import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import styled, { css, createGlobalStyle } from 'styled-components';
export { ServerStyleSheet as ArchieServerStyleSheet } from 'styled-components';
import * as React from 'react';
import React__default, { forwardRef, useEffect, useState, useRef, isValidElement, createContext, useContext, useCallback, useImperativeHandle, useLayoutEffect as useLayoutEffect$1, useMemo, createElement, Children, cloneElement, Fragment as Fragment$1, useReducer, useId, Component, createRef, version } from 'react';
import { useFormContext, get, Controller } from 'react-hook-form';
import * as require$$1 from 'react-dom';
import require$$1__default, { flushSync, findDOMNode } from 'react-dom';
import { toast as toast$1, ToastContainer as ToastContainer$1 } from 'react-toastify';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

/* eslint-disable prettier/prettier */
// Auto-generated
var colorAction = {
    'colorActionActionDark': 'var(--color-action-action-dark)',
    'colorActionActionGrey': 'var(--color-action-action-grey)',
    'colorActionActionWashed': 'var(--color-action-action-washed)',
    'colorActionActionWhite': 'var(--color-action-action-white)'
};

/* eslint-disable prettier/prettier */
// Auto-generated
var colorActionIcon = {
    'colorActionIconSurface': 'var(--color-action-icon-surface)',
    'colorActionIconText': 'var(--color-action-icon-text)'
};

/* eslint-disable prettier/prettier */
// Auto-generated
var colorActionPrimary = {
    'colorActionPrimarySurface': 'var(--color-action-primary-surface)',
    'colorActionPrimaryText': 'var(--color-action-primary-text)'
};

/* eslint-disable prettier/prettier */
// Auto-generated
var colorActionSecondary = {
    'colorActionSecondaryBorder': 'var(--color-action-secondary-border)',
    'colorActionSecondarySurface': 'var(--color-action-secondary-surface)',
    'colorActionSecondaryText': 'var(--color-action-secondary-text)'
};

/* eslint-disable prettier/prettier */
// Auto-generated
var colorActionTertiary = {
    'colorActionTertiaryBorder': 'var(--color-action-tertiary-border)',
    'colorActionTertiarySurface': 'var(--color-action-tertiary-surface)',
    'colorActionTertiaryText': 'var(--color-action-tertiary-text)'
};

/* eslint-disable prettier/prettier */
// Auto-generated
var colorBorder$1 = {
    'colorBorderBorderAlert': 'var(--color-border-border-alert)',
    'colorBorderBorderBrand': 'var(--color-border-border-brand)',
    'colorBorderBorderFocus': 'var(--color-border-border-focus)',
    'colorBorderBorderPrimary': 'var(--color-border-border-primary)',
    'colorBorderBorderSecondary': 'var(--color-border-border-secondary)',
    'colorBorderBorderSuccess': 'var(--color-border-border-success)',
    'colorBorderBorderWarning': 'var(--color-border-border-warning)'
};

/* eslint-disable prettier/prettier */
// Auto-generated
var colorFormBorder = {
    'colorFormBorderActive': 'var(--color-form-border-active)',
    'colorFormBorderDefault': 'var(--color-form-border-default)',
    'colorFormBorderError': 'var(--color-form-border-error)'
};

/* eslint-disable prettier/prettier */
// Auto-generated
var colorFormSurface = {
    'colorFormSurfaceChecked': 'var(--color-form-surface-checked)',
    'colorFormSurfaceDefault': 'var(--color-form-surface-default)',
    'colorFormSurfaceDisabled': 'var(--color-form-surface-disabled)',
    'colorFormSurfacePrefix': 'var(--color-form-surface-prefix)',
    'colorFormSurfaceWashed': 'var(--color-form-surface-washed)'
};

/* eslint-disable prettier/prettier */
// Auto-generated
var colorIcon = {
    'colorIconIconAlert': 'var(--color-icon-icon-alert)',
    'colorIconIconBrand': 'var(--color-icon-icon-brand)',
    'colorIconIconInvert': 'var(--color-icon-icon-invert)',
    'colorIconIconPrimary': 'var(--color-icon-icon-primary)',
    'colorIconIconSecondary': 'var(--color-icon-icon-secondary)',
    'colorIconIconSuccess': 'var(--color-icon-icon-success)',
    'colorIconIconWarning': 'var(--color-icon-icon-warning)'
};

/* eslint-disable prettier/prettier */
// Auto-generated
var colorSurfaceOverlay = {
    'colorSurfaceOverlayDark-10': 'var(--color-surface-overlay-dark-10)',
    'colorSurfaceOverlayDark-20': 'var(--color-surface-overlay-dark-20)',
    'colorSurfaceOverlayDark-40': 'var(--color-surface-overlay-dark-40)',
    'colorSurfaceOverlayLight-10': 'var(--color-surface-overlay-light-10)',
    'colorSurfaceOverlayLight-70': 'var(--color-surface-overlay-light-70)'
};

/* eslint-disable prettier/prettier */
// Auto-generated
var colorSurface = {
    'alert': 'var(--color-surface-surface-alert)',
    'alertFilled': 'var(--color-surface-surface-alert-filled)',
    'brand': 'var(--color-surface-surface-brand)',
    'brandSecondary': 'var(--color-surface-surface-brand-secondary)',
    'invert': 'var(--color-surface-surface-invert)',
    'primary': 'var(--color-surface-surface-primary)',
    'secondary': 'var(--color-surface-surface-secondary)',
    'success': 'var(--color-surface-surface-success)',
    'tertiary': 'var(--color-surface-surface-tertiary)',
    'warning': 'var(--color-surface-surface-warning)'
};

/* eslint-disable prettier/prettier */
// Auto-generated
var colorText = {
    'colorTextTextAlert': 'var(--color-text-text-alert)',
    'colorTextTextDisabled': 'var(--color-text-text-disabled)',
    'colorTextTextInvert': 'var(--color-text-text-invert)',
    'colorTextTextPrimary': 'var(--color-text-text-primary)',
    'colorTextTextSecondary': 'var(--color-text-text-secondary)',
    'colorTextTextSuccess': 'var(--color-text-text-success)'
};

/* eslint-disable prettier/prettier */
// Auto-generated
var colorTextLink = {
    'colorTextLinkLinkPrimary': 'var(--color-text-link-link-primary)',
    'colorTextLinkLinkVisited': 'var(--color-text-link-link-visited)'
};

/* eslint-disable prettier/prettier */
// Auto-generated
var fontContent = {
    'fontContentHelper': 'var(--font-content-helper)',
    'fontContentSmall': 'var(--font-content-small)',
    'fontContentDefault': 'var(--font-content-default)'
};

/* eslint-disable prettier/prettier */
// Auto-generated
var radius = {
    'xxs': 'var(--radius-radius-xxs)',
    'xs': 'var(--radius-radius-xs)',
    'sm': 'var(--radius-radius-sm)',
    'md': 'var(--radius-radius-md)',
    'lg': 'var(--radius-radius-lg)',
    'xl': 'var(--radius-radius-xl)'
};

/* eslint-disable prettier/prettier */
// Auto-generated
var radiusAction = {
    'radiusActionSm': 'var(--radius-action-sm)',
    'radiusActionMd': 'var(--radius-action-md)',
    'radiusActionLg': 'var(--radius-action-lg)'
};

/* eslint-disable prettier/prettier */
// Auto-generated
var spacingActionGap = {
    'spacingActionGapSm': 'var(--spacing-action-gap-sm)',
    'spacingActionGapMd': 'var(--spacing-action-gap-md)',
    'spacingActionGapLg': 'var(--spacing-action-gap-lg)'
};

/* eslint-disable prettier/prettier */
// Auto-generated
var spacingActionPadding = {
    'spacingActionPaddingXs': 'var(--spacing-action-padding-xs)',
    'spacingActionPaddingSm': 'var(--spacing-action-padding-sm)',
    'spacingActionPaddingMd': 'var(--spacing-action-padding-md)',
    'spacingActionPaddingLg': 'var(--spacing-action-padding-lg)'
};

/* eslint-disable prettier/prettier */
// Auto-generated
var colorBase = {
    'colorBrand-100': 'var(--color-brand-100)',
    'colorBrand-200': 'var(--color-brand-200)',
    'colorBrand-300': 'var(--color-brand-300)',
    'colorBrand-400': 'var(--color-brand-400)',
    'colorBrand-500': 'var(--color-brand-500)',
    'colorBrand-600': 'var(--color-brand-600)',
    'colorBrandOpacity-300-10': 'var(--color-brand-opacity-300-10)',
    'colorNeutral-0': 'var(--color-neutral-0)',
    'colorNeutral-100': 'var(--color-neutral-100)',
    'colorNeutral-200': 'var(--color-neutral-200)',
    'colorNeutral-300': 'var(--color-neutral-300)',
    'colorNeutral-400': 'var(--color-neutral-400)',
    'colorNeutral-500': 'var(--color-neutral-500)',
    'colorNeutral-600': 'var(--color-neutral-600)',
    'colorNeutralDarkmode-0': 'var(--color-neutral-darkmode-0)',
    'colorNeutralDarkmode-100': 'var(--color-neutral-darkmode-100)',
    'colorNeutralDarkmode-200': 'var(--color-neutral-darkmode-200)',
    'colorNeutralDarkmode-300': 'var(--color-neutral-darkmode-300)',
    'colorNeutralDarkmode-400': 'var(--color-neutral-darkmode-400)',
    'colorNeutralDarkmode-50': 'var(--color-neutral-darkmode-50)',
    'colorNeutralDarkmode-500': 'var(--color-neutral-darkmode-500)',
    'colorNeutralDarkmode-600': 'var(--color-neutral-darkmode-600)',
    'colorNeutralOpacity-0-10': 'var(--color-neutral-opacity-0-10)',
    'colorNeutralOpacity-0-70': 'var(--color-neutral-opacity-0-70)',
    'colorNeutralOpacity-600-10': 'var(--color-neutral-opacity-600-10)',
    'colorNeutralOpacity-600-20': 'var(--color-neutral-opacity-600-20)',
    'colorNeutralOpacity-600-40': 'var(--color-neutral-opacity-600-40)'
};

/* eslint-disable prettier/prettier */
// Auto-generated
var colorInteractionBase = {
    'colorInteractionAlert-100': 'var(--color-interaction-alert-100)',
    'colorInteractionAlert-200': 'var(--color-interaction-alert-200)',
    'colorInteractionDarkmodeAlert-100': 'var(--color-interaction-darkmode-alert-100)',
    'colorInteractionDarkmodeAlert-200': 'var(--color-interaction-darkmode-alert-200)',
    'colorInteractionDarkmodeSuccess-100': 'var(--color-interaction-darkmode-success-100)',
    'colorInteractionDarkmodeSuccess-200': 'var(--color-interaction-darkmode-success-200)',
    'colorInteractionDarkmodeSuccess-300': 'var(--color-interaction-darkmode-success-300)',
    'colorInteractionDarkmodeWarning-100': 'var(--color-interaction-darkmode-warning-100)',
    'colorInteractionDarkmodeWarning-200': 'var(--color-interaction-darkmode-warning-200)',
    'colorInteractionSuccess-100': 'var(--color-interaction-success-100)',
    'colorInteractionSuccess-200': 'var(--color-interaction-success-200)',
    'colorInteractionWarning-100': 'var(--color-interaction-warning-100)',
    'colorInteractionWarning-200': 'var(--color-interaction-warning-200)'
};

var customComponentsColors = {
    eliteSellerBadge: 'var(--elite-seller-badge-color)',
    offLeaseExclusiveBadge: 'var(--off-lease-exclusive-badge-color)',
    carouselArrowBackgroundActive: 'var(--carousel-arrow-background-active)',
    carouselArrowBackgroundHover: 'var(--carousel-arrow-background-hover)',
    blcTabSelectedBorder: 'var(--blc-tab-selected-border-color)'
};
var colorPallete = {
    corePrimaryBlue: 'var(--corePrimaryBlue)',
    coreSecondaryBlue: 'var(--coreSecondaryBlue)',
    coreDarkest: 'var(--coreDarkest)',
    coreBlack: 'var(--coreBlack)',
    coreWhite: 'var(--coreWhite)',
    neutralGray70: 'var(--neutralGray70)',
    neutralGray50: 'var(--neutralGray50)',
    neutralGray20: 'var(--neutralGray20)',
    neutralGray5: 'var(--neutralGray5)',
    neutralBlue5: 'var(--neutralBlue5)',
    neutralCloudBlue: 'var(--neutralCloudBlue)',
    arcLightBlue: 'var(--arcLightBlue)',
    interactionRed: 'var(--interactionRed)',
    interactionRed5: 'var(--interactionRed5)',
    interactionYellow: 'var(--interactionYellow)',
    interactionYellow5: 'var(--interactionYellow5)',
    interactionGreen: 'var(--interactionGreen)',
    interactionGreen5: 'var(--interactionGreen5)'
};
/**
 * @deprecated The object is deprecated. Use objects from designSystemTokens
 */
var colors = __assign(__assign(__assign({}, colorPallete), { backgroundPrimary: 'var(--backgroundPrimary)', backgroundSecondary: 'var(--backgroundSecondary)', backgroundTertiary: 'var(--backgroundTertiary)', primary: 'var(--primary)', primaryText: 'var(--primaryText)', secondary: 'var(--secondary)', secondaryText: 'var(--secondaryText)', tertiary: 'var(--tertiary)', tertiaryText: 'var(--tertiaryText)', link: 'var(--hyperlink-link-default)', 
    /**
     * Interaction colors
     */
    alert: 'var(--alert)', alertLightest: 'var(--alertLightest)', alertLightestOverlay: 'var(--alertLightestOverlay)', warningDark: 'var(--warningDark)', warning: 'var(--warning)', warningLightest: 'var(--warningLightest)', success: 'var(--success)', successLightest: 'var(--successLightest)', info: 'var(--info)', infoLightest: 'var(--infoLightest)', navBarBackground: 'var(--navBarBackground)', navBarFont: 'var(--navBarFont)', dropDownActive: 'var(--dropDownActive)', dropDownHover: 'var(--dropDownHover)', fontColor: 'var(--fontColor)', 
    // this colors are deprecated we should not use it anymore, the idea is to replace it with new theming colors
    // and the remove it from here
    asphalt: 'var(--asphalt)', 
    // gray scale (it should not change so match between themes)
    black: 'var(--black)', white: 'var(--white)', transparent: 'var(--transparent)', grayDark: 'var(--grayDark)', grayLight: 'var(--grayLight)', smokeLight: 'var(--smokeLight)', 
    // neutral
    neutral1: 'var(--neutral1)', shadow: 'var(--shadow)', shadowDark: 'var(--shadowDark)', overlay: 'var(--overlay)', focus: 'var(--focus)', 
    // vendor
    carbravoGreen: 'var(--carbravo-green)', carbravoBlue: 'var(--carbravo-blue)', groupRed: 'var(--group-red)', afcGreen: 'var(--afc-green)' }), customComponentsColors);

var getSurfaceColor = function (colorName) { return colorSurface[colorName]; };
/** @deprecated */
var getLegacyColor = function (colorName) { return colors[colorName]; };
var getFormSurfaceColor = function (colorName) { return colorFormSurface[colorName] || colors[colorName]; };
var getFormBorderColor = function (colorName) { return colorFormBorder[colorName] || colors[colorName]; };
var getBorderColor = function (colorName) { return colorBorder$1[colorName] || colors[colorName]; };
var getTextColor = function (colorName) { return colorText[colorName] || colors[colorName]; };
var getTextLinkColor = function (colorName) { return colorTextLink[colorName] || colors[colorName]; };
var getIconColor = function (colorName) { return colorIcon[colorName] || colors[colorName]; };
var getRadius = function (radiusName) { return radius[radiusName]; };
var customColors = {
    black: colors.black,
    primary: colorBase['colorBrand-300'],
    transparent: colors.transparent,
    carouselArrowBackgroundActive: colors.carouselArrowBackgroundActive,
    carouselArrowBackgroundHover: colors.carouselArrowBackgroundHover,
    shadow: colors.shadow,
    focus: colors.focus,
    blcTabSelectedBorder: colors.blcTabSelectedBorder
};

var weightMap$1 = {
    bold: 'var(--fontWeightSemiBold)',
    regular: 'var(--fontWeightRegular)'
};
var getTruncableProps = function () { return "\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  width: 100%;\n"; };
var fontFamilyFallback = 'sans-serif';
var fontFamily = "var(--fontFamily, ".concat(fontFamilyFallback, ")");

var Banner = styled.div(function (props) {
    return ({
        background: getLegacyColor(props.backgroundColor),
        color: getTextColor(props.color),
        margin: props.margin,
        padding: props.padding,
        textAlign: props.textAlign,
        fontSize: '13px',
        fontFamily: fontFamily
    });
});
var BlcBanner = function (_a) {
    var className = _a.className, _b = _a.margin, margin = _b === void 0 ? '0' : _b, _c = _a.padding, padding = _c === void 0 ? '10px' : _c, _d = _a.textAlign, textAlign = _d === void 0 ? 'center' : _d, backgroundColor = _a.backgroundColor, color = _a.color, children = _a.children;
    return (jsx(Banner, __assign({ className: className, margin: margin, padding: padding, textAlign: textAlign, backgroundColor: backgroundColor, color: color }, { children: children })));
};

var PrivateMarketplaceBanner = function (_a) {
    var className = _a.className;
    return (jsx(BlcBanner, __assign({ className: className, backgroundColor: "secondary", color: "secondaryText", padding: "5px", margin: "0 0 10px 0" }, { children: "Private Marketplace" })));
};

var baseUnit = 8;
var px = function (n) {
    return n + 'px';
};
var unit = function (n) {
    return px(n * baseUnit);
};
var sizeMap = {
    /**
     * Global Units
     */
    zero: 0,
    unit: unit(1),
    line: {
        mxl: unit(0.5),
        ml: unit(0.375),
        ms: unit(0.25),
        mxs: unit(0.125)
    },
    border: {
        mxl: unit(0.25),
        ml: unit(0.25),
        ms: unit(0.125),
        mxs: unit(0.125)
    },
    inherit: 'inherit',
    full: '100%',
    radius: {
        largest: unit(4),
        larger: unit(3.5),
        normal: unit(3),
        smaller: unit(2),
        smallest: unit(1.5)
    },
    /**
     * Grid
     */
    gap: {
        largest: {
            mxl: 40,
            ml: 36,
            ms: 34,
            mxs: 32
        },
        larger: {
            mxl: 32,
            ml: 28,
            ms: 26,
            mxs: 24
        },
        normal: {
            mxl: 24,
            ml: 20,
            ms: 18,
            mxs: 16
        },
        smaller: {
            mxl: 16,
            ml: 12,
            ms: 10,
            mxs: 8
        },
        smallest: {
            mxl: 8,
            ml: 6,
            ms: 4,
            mxs: 0
        },
        none: {
            mxl: 0,
            ml: 0,
            ms: 0,
            mxs: 0
        }
    },
    columns: {
        mxl: 12,
        ml: 8,
        ms: 6,
        mxs: 4
    },
    container: {
        largest: unit(320),
        larger: unit(240),
        normal: unit(160),
        smaller: unit(120),
        smallest: unit(80)
    },
    sectionSpacing: {
        largest: {
            mxl: unit(20),
            ml: unit(18),
            ms: unit(16),
            mxs: unit(14)
        },
        larger: {
            mxl: unit(14),
            ml: unit(13),
            ms: unit(11),
            mxs: unit(10)
        },
        normal: {
            mxl: unit(10),
            ml: unit(9),
            ms: unit(8),
            mxs: unit(7)
        },
        smaller: {
            mxl: unit(7),
            ml: unit(6),
            ms: unit(5),
            mxs: unit(4)
        },
        smallest: {
            mxl: unit(4),
            ml: unit(3),
            ms: unit(2),
            mxs: unit(1)
        },
        none: {
            mxl: 0,
            ml: 0,
            ms: 0,
            mxs: 0
        }
    },
    /**
     * Modals
     */
    modal: {
        largest: unit(140),
        larger: unit(120),
        normal: unit(100),
        smaller: unit(80),
        smallest: unit(60)
    },
    videoModal: {
        normal: unit(92)
    },
    /**
     * Distance
     */
    spacing: {
        largest: {
            mxl: unit(5),
            ml: unit(4.5),
            ms: unit(4),
            mxs: unit(3.5)
        },
        larger: {
            mxl: unit(4),
            ml: unit(3.5),
            ms: unit(3),
            mxs: unit(2.5)
        },
        normal: {
            mxl: unit(3),
            ml: unit(2.5),
            ms: unit(2),
            mxs: unit(1.5)
        },
        smaller: {
            mxl: unit(2),
            ml: unit(1.666),
            ms: unit(1.333),
            mxs: unit(1)
        },
        smallest: {
            mxl: unit(1),
            ml: unit(0.75),
            ms: unit(0.5),
            mxs: unit(0.25)
        },
        none: {
            mxl: 0,
            ml: 0,
            ms: 0,
            mxs: 0
        }
    },
    /**
     * Font Sizes
     */
    /* Headlines: */
    h1: {
        text: {
            mxl: unit(7),
            ml: unit(6),
            ms: unit(5),
            mxs: unit(4)
        },
        lineHeight: 1.14 // unit(8)
    },
    h2: {
        text: {
            mxl: unit(6),
            ml: unit(5),
            ms: unit(4),
            mxs: unit(3)
        },
        lineHeight: 1.17 // unit(7)
    },
    h3: {
        text: {
            mxl: unit(5),
            ml: unit(4),
            ms: unit(3),
            mxs: unit(2.5)
        },
        lineHeight: 1.2 // unit(6)
    },
    h4: {
        text: {
            mxl: unit(4),
            ml: unit(3),
            ms: unit(2.5),
            mxs: unit(2)
        },
        lineHeight: 1.25 // unit(5)
    },
    h5: {
        text: {
            mxl: unit(3),
            ml: unit(2.5),
            ms: unit(2),
            mxs: unit(1.75)
        },
        lineHeight: 1.33 // unit(4)
    },
    h6: {
        text: {
            mxl: unit(2),
            ml: unit(1.75),
            ms: unit(1.5),
            mxs: unit(1.5)
        },
        lineHeight: 1.5 // unit(3)
    },
    /* Paragraph: */
    p: {
        largest: {
            text: {
                mxl: unit(2.5),
                ml: unit(2.25),
                ms: unit(2),
                mxs: unit(1.75)
            },
            lineHeight: 1.5
        },
        larger: {
            text: {
                mxl: unit(2.25),
                ml: unit(2),
                ms: unit(1.75),
                mxs: unit(1.625)
            },
            lineHeight: 1.56
        },
        normal: {
            text: {
                mxl: unit(2),
                ml: unit(1.75),
                ms: unit(1.625),
                mxs: unit(1.5)
            },
            lineHeight: 1.5
        },
        smaller: {
            text: {
                mxl: unit(1.75),
                ml: unit(1.625),
                ms: unit(1.5),
                mxs: unit(1.375)
            },
            lineHeight: 1.43
        },
        smallest: {
            text: {
                mxl: unit(1.625),
                ml: unit(1.5),
                ms: unit(1.375),
                mxs: unit(1.25)
            },
            lineHeight: 1.5
        }
    },
    /* Labels */
    label: {
        mxl: unit(1.75),
        ml: unit(1.625),
        ms: unit(1.5),
        mxs: unit(1.375)
    },
    /**
     * Buttons:
     */
    buttonPaddings: {
        largest: {
            mxl: px(16) + ' ' + px(38),
            ml: px(14) + ' ' + px(34),
            ms: px(13) + ' ' + px(31),
            mxs: px(12) + ' ' + px(27)
        },
        larger: {
            mxl: px(13) + ' ' + px(30),
            ml: px(11) + ' ' + px(26),
            ms: px(10) + ' ' + px(23),
            mxs: px(8.5) + ' ' + px(21)
        },
        normal: {
            mxl: px(10) + ' ' + px(22),
            ml: px(8) + ' ' + px(18),
            ms: px(7.5) + ' ' + px(17),
            mxs: px(7) + ' ' + px(15)
        },
        smaller: {
            mxl: px(7) + ' ' + px(14),
            ml: px(4.5) + ' ' + px(12),
            ms: px(5) + ' ' + px(11),
            mxs: px(3.5) + ' ' + px(9)
        },
        smallest: {
            mxl: px(3.5) + ' ' + px(6),
            ml: px(2) + ' ' + px(6),
            ms: px(2.5) + ' ' + px(5),
            mxs: px(2) + ' ' + px(5)
        }
    },
    /**
     * Icons:
     */
    icon: {
        largest: {
            mxl: px(39),
            ml: px(35),
            ms: px(33),
            mxs: px(31)
        },
        larger: {
            mxl: px(31),
            ml: px(27),
            ms: px(25),
            mxs: px(23)
        },
        normal: {
            mxl: px(23),
            ml: px(19),
            ms: px(17),
            mxs: px(15)
        },
        smaller: {
            mxl: px(15),
            ml: px(14),
            ms: px(11),
            mxs: px(9)
        },
        smallest: {
            mxl: px(10),
            ml: px(8),
            ms: px(6),
            mxs: px(4)
        }
    },
    avatar: {
        largest: {
            size: {
                mxl: unit(10),
                ml: unit(8.666),
                ms: unit(8.333),
                mxs: unit(8)
            },
            text: {
                mxl: unit(4),
                ml: unit(3.75),
                ms: unit(3.5),
                mxs: unit(3.25)
            }
        },
        larger: {
            size: {
                mxl: unit(8),
                ml: unit(6.666),
                ms: unit(6.333),
                mxs: unit(6)
            },
            text: {
                mxl: unit(3.5),
                ml: unit(3.25),
                ms: unit(3),
                mxs: unit(2.75)
            }
        },
        normal: {
            size: {
                mxl: unit(6),
                ml: unit(4.666),
                ms: unit(4.333),
                mxs: unit(4)
            },
            text: {
                mxl: unit(3),
                ml: unit(2.75),
                ms: unit(2.5),
                mxs: unit(2.25)
            }
        },
        smaller: {
            size: {
                mxl: unit(4),
                ml: unit(2.666),
                ms: unit(2.333),
                mxs: unit(2)
            },
            text: {
                mxl: unit(2.5),
                ml: unit(2.25),
                ms: unit(2),
                mxs: unit(1.75)
            }
        },
        smallest: {
            size: {
                mxl: unit(2),
                ml: unit(1.666),
                ms: unit(1.333),
                mxs: unit(1)
            },
            text: {
                mxl: unit(2),
                ml: unit(1.75),
                ms: unit(1.5),
                mxs: unit(1.25)
            }
        }
    },
    /**
     * Components
     */
    header: {
        mxl: unit(9),
        ml: unit(8),
        ms: unit(7),
        mxs: unit(6)
    }
};
var weightMap = {
    /**
     * Font Weights
     */
    bold: 600,
    regular: 400
};
var mediaMaxWidthBreakpoints = {
    largest: 150 * baseUnit,
    larger: 124 * baseUnit,
    smaller: 96 * baseUnit,
    smallest: 60 * baseUnit
};
var getMaxMediaQuery = function (value) { return "(max-width: ".concat(value, ")"); };
var getMinMediaQuery = function (value) { return "(min-width: ".concat(value, ")"); };
var getMinMaxMediaQuery = function (min, max) { return "".concat(getMinMediaQuery(min), " and ").concat(getMaxMediaQuery(max)); };
var mediaSizeMap = {
    /**
     * Breakpoint naming comes from the grid system we use.
     * Default max-columns gets verbouse in each display mode.
     *
     * Breakpoint 	Purpose
     * default: 	laptops
     */
    /* max-width for Tablet-landscape (and smaller) max-width 1200px */
    largest: getMaxMediaQuery(px(mediaMaxWidthBreakpoints.largest)),
    /* max-width for Tablet-portrait (and smaller) max-width 992px */
    larger: getMaxMediaQuery(px(mediaMaxWidthBreakpoints.larger)),
    /* max-width for Mobile-landscape (and smaller) max-width 768px */
    smaller: getMaxMediaQuery(px(mediaMaxWidthBreakpoints.smaller)),
    /* max-width for Mobile-portrait (and smaller) max-width 480px */
    smallest: getMaxMediaQuery(px(mediaMaxWidthBreakpoints.smallest))
};
var minMaxForDevices = {
    desktop: { min: mediaMaxWidthBreakpoints.larger + 1 },
    smallDesktop: { min: mediaMaxWidthBreakpoints.smaller + 1, max: mediaMaxWidthBreakpoints.larger },
    tablet: { min: mediaMaxWidthBreakpoints.smallest + 1, max: mediaMaxWidthBreakpoints.smaller },
    mobile: { max: mediaMaxWidthBreakpoints.smallest + 1 }
};
var getMediaForDevices = function (_a) {
    var desktop = _a.desktop, smallDesktop = _a.smallDesktop, tablet = _a.tablet, mobile = _a.mobile;
    var values = [];
    if (desktop)
        values.push(minMaxForDevices.desktop);
    if (smallDesktop)
        values.push(minMaxForDevices.smallDesktop);
    if (tablet)
        values.push(minMaxForDevices.tablet);
    if (mobile)
        values.push(minMaxForDevices.mobile);
    return values;
};
var mediaDevicesSizeMap = {
    desktop: getMinMediaQuery(px(mediaMaxWidthBreakpoints.larger + 1)),
    smallDesktop: getMinMaxMediaQuery(px(mediaMaxWidthBreakpoints.smaller + 1), px(mediaMaxWidthBreakpoints.larger)),
    tablet: getMinMaxMediaQuery(px(mediaMaxWidthBreakpoints.smallest + 1), px(mediaMaxWidthBreakpoints.smaller)),
    mobile: getMaxMediaQuery(px(mediaMaxWidthBreakpoints.smallest + 1))
};

var getSize$2 = function (_a) {
    var tag = _a.tag, _b = _a.defaultValue, defaultValue = _b === void 0 ? 'inherit' : _b, name = _a.name, media = _a.media, type = _a.type;
    if (!name || name === 'inherit' || !tag) {
        return sizeMap[defaultValue];
    }
    var tagSize = type ? sizeMap[tag][name][type] : sizeMap[tag][name];
    return media ? tagSize[media] : tagSize;
};

/**
 * Grid
 */
var getContainerSize = function (size) {
    return getSize$2({ tag: 'container', defaultValue: 'zero', name: size }).toString();
};
var getGap = function (mediaSize, size) {
    return getSize$2({
        tag: 'gap',
        defaultValue: 'zero',
        name: size,
        media: mediaSize
    });
};
var getGapMXL = function (size) {
    return getGap('mxl', size);
};
var getGapML = function (size) {
    return getGap('ml', size);
};
var getGapMS = function (size) {
    return getGap('ms', size);
};
var getGapMXS = function (size) {
    return getGap('mxs', size);
};

var SizeEnum;
(function (SizeEnum) {
    SizeEnum["largest"] = "largest";
    SizeEnum["larger"] = "larger";
    SizeEnum["normal"] = "normal";
    SizeEnum["smaller"] = "smaller";
    SizeEnum["smallest"] = "smallest";
    SizeEnum["inherit"] = "inherit";
    SizeEnum["none"] = "none";
})(SizeEnum || (SizeEnum = {}));

var getSpacing = function (mediaSize, size, tag) {
    if (tag === void 0) { tag = 'spacing'; }
    return getSize$2({
        tag: tag,
        defaultValue: 'zero',
        name: size,
        media: mediaSize
    });
};
/**
 * Spacing
 */
var getSpaceMXL = function (size) {
    return getSpacing('mxl', size);
};
var getSpaceML = function (size) {
    return getSpacing('ml', size);
};
var getSpaceMS = function (size) {
    return getSpacing('ms', size);
};
var getSpaceMXS = function (size) {
    return getSpacing('mxs', size);
};
var getSpaceFromArrayValues = function (prop, values, spaceGetter) {
    if (prop === 'sectionPadding') {
        return "padding: ".concat(values
            .map(function (val, index) { return (index % 2 !== 0 ? "".concat(spaceGetter(val, true), " ") : "".concat(spaceGetter(val), " ")); })
            .join(''));
    }
    else {
        return "".concat(prop, ": ").concat(values.map(function (val) { return "".concat(spaceGetter(val), " "); }).join(''));
    }
};
/**
 * Builds the margin or padding style based on the size provided:
 * @prop spaceGetter - Function that provides the space value
 * @prop prop - The property to be used for the style
 * @prop space - The size to use for the margin or padding, could have a Size value or an array of Size values
 */
var getSpace = function (spaceGetter, prop, space) {
    if (!space || !spaceGetter || !prop)
        return '';
    if (typeof space === 'string') {
        return "".concat(prop, ": ").concat(space in SizeEnum ? spaceGetter(space) : space);
    }
    return space.length ? getSpaceFromArrayValues(prop, space, spaceGetter) : '';
};

var BlcGridBase = forwardRef(function (_a, ref) {
    var id = _a.id, children = _a.children, className = _a.className;
    return (jsx("div", __assign({ className: className, ref: ref, id: id }, { children: children })));
});
BlcGridBase.displayName = 'BlcGridBase';
var styles = function (_a) {
    var _b;
    var _c = _a.background, background = _c === void 0 ? 'transparent' : _c, _d = _a.fullHeight, fullHeight = _d === void 0 ? false : _d, _e = _a.margin, margin = _e === void 0 ? 'none' : _e, _f = _a.size, size = _f === void 0 ? '100%' : _f, _g = _a.position, position = _g === void 0 ? 'relative' : _g, _h = _a.zIndex, zIndex = _h === void 0 ? 1 : _h, _j = _a.noOverflow, noOverflow = _j === void 0 ? false : _j, top = _a.top;
    return (_b = {
            backgroundColor: getLegacyColor(background),
            boxSizing: 'border-box',
            height: fullHeight ? '100vh' : '100%',
            margin: "".concat(getSpaceMXL(margin), " auto"),
            maxWidth: size,
            padding: 0,
            position: position,
            top: top && "".concat(top, "px"),
            width: '100%',
            zIndex: zIndex,
            fontSize: '13px',
            fontFamily: fontFamily
        },
        _b["@media ".concat(mediaSizeMap.larger)] = {
            margin: "".concat(getSpaceML(margin), " auto")
        },
        _b["@media ".concat(mediaSizeMap.smaller)] = {
            margin: "".concat(getSpaceMS(margin), " auto")
        },
        _b["@media ".concat(mediaSizeMap.smallest)] = {
            margin: "".concat(getSpaceMXS(margin), " auto"),
            overflowX: 'hidden',
            overflowY: noOverflow ? 'hidden' : 'visible'
        },
        _b);
};
var StyledBase$1 = styled(BlcGridBase)(function (props) { return styles(props); });

var calcPadding = function (value, getPadding) {
    return value === 'none' ? '0' : getPadding('smaller');
};
var Container$f = styled.div(templateObject_1$1_ || (templateObject_1$1_ = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var padding = _a.padding, position = _a.position, height = _a.height;
    return "\n        height: ".concat(height, ";\n        padding: ").concat(getSpaceMXL(padding), " ").concat(calcPadding(padding, getSpaceMXL), ";\n        position: ").concat(position, ";\n        width: 100%;\n        @media ").concat(mediaSizeMap.larger, " {\n            padding: ").concat(getSpaceML(padding), " ").concat(calcPadding(padding, getSpaceML), ";\n        }\n        @media ").concat(mediaSizeMap.smaller, " {\n            padding: ").concat(getSpaceMS(padding), " ").concat(calcPadding(padding, getSpaceMS), ";\n        }\n        @media ").concat(mediaSizeMap.smallest, " {\n            padding: ").concat(getSpaceMXS(padding), " ").concat(calcPadding(padding, getSpaceMXS), ";\n        }\n\n    ");
});
var BlcContainer = function (_a) {
    var className = _a.className, children = _a.children, background = _a.background, _b = _a.padding, padding = _b === void 0 ? 'none' : _b, _c = _a.position, position = _c === void 0 ? 'relative' : _c, _d = _a.size, size = _d === void 0 ? 'largest' : _d, _e = _a.height, height = _e === void 0 ? '100%' : _e;
    return (jsx(StyledBase$1, __assign({ size: getContainerSize(size), position: position, background: background }, { children: jsx(Container$f, __assign({ padding: padding, position: position, className: className, height: height }, { children: children })) })));
};
var templateObject_1$1_;

/**
 * Section Spacing
 */
var getSpacingForXAxis = function (space, percentage) {
    return typeof space === 'string' ? "".concat(parseFloat(space) * percentage, "px") : space;
};
var getSectionSpacingMXL = function (size) {
    return getSpacing('mxl', size, 'sectionSpacing');
};
var getSectionSpacingML = function (size, isXAxis) {
    var spacing = getSpacing('ml', size, 'sectionSpacing');
    return isXAxis ? getSpacingForXAxis(spacing, 0.8) : spacing;
};
var getSectionSpacingMS = function (size, isXAxis) {
    var spacing = getSpacing('ms', size, 'sectionSpacing');
    return isXAxis ? getSpacingForXAxis(spacing, 0.6) : spacing;
};
var getSectionSpacingMXS = function (size, isXAxis) {
    var spacing = getSpacing('mxs', size, 'sectionSpacing');
    return isXAxis ? getSpacingForXAxis(spacing, 0.3) : spacing;
};

var getBannerPaddingTop = function (banner, bannerHeight) {
    return banner ? "padding-top: ".concat(bannerHeight, "vh") : '';
};
var getID = function (id) { return (id ? "section-".concat(id) : undefined); };
var Section = styled.section(templateObject_1$1Z || (templateObject_1$1Z = __makeTemplateObject(["\n  height: 100%;\n  ", "\n"], ["\n  height: 100%;\n  ", "\n"])), function (_a) {
    var banner = _a.banner, _b = _a.bannerHeight, bannerHeight = _b === void 0 ? 52 : _b, padding = _a.padding, position = _a.position;
    return "\n  ".concat(getSpace(getSectionSpacingMXL, 'sectionPadding', padding), ";\n  ").concat(getBannerPaddingTop(banner, bannerHeight), ";\n  position: ").concat(position || 'relative', ";\n  @media ").concat(mediaSizeMap.larger, " {\n    ").concat(getSpace(getSectionSpacingML, 'sectionPadding', padding), ";\n  }\n  @media ").concat(mediaSizeMap.smaller, " {\n    ").concat(getSpace(getSectionSpacingMS, 'sectionPadding', padding), ";\n  }\n  @media ").concat(mediaSizeMap.smallest, " {\n    ").concat(getSpace(getSectionSpacingMXS, 'sectionPadding', padding), ";\n  }\n  ");
});
var getDefaultSectionPadding = function (padding) {
    return typeof padding === 'string' ? [padding, 'none'] : padding;
};
var BlcSection = forwardRef(function (_a, ref) {
    var background = _a.background, _b = _a.banner, banner = _b === void 0 ? false : _b, bannerHeight = _a.bannerHeight, children = _a.children, className = _a.className, fullHeight = _a.fullHeight, id = _a.id, margin = _a.margin, noOverflow = _a.noOverflow, _c = _a.padding, padding = _c === void 0 ? 'normal' : _c, position = _a.position;
    // Section padding only applies to top and bottom unless SizeArray is passed in.
    var sectionPadding = getDefaultSectionPadding(padding);
    return (jsx(StyledBase$1, __assign({ ref: ref, background: background, className: className, fullHeight: fullHeight, id: getID(id), margin: margin, noOverflow: noOverflow, size: "100%" }, { children: jsx(Section, __assign({ id: id, padding: sectionPadding, position: position, banner: banner, bannerHeight: bannerHeight }, { children: children })) })));
});
BlcSection.displayName = 'BlcSection';
var templateObject_1$1Z;

var AlignEnum;
(function (AlignEnum) {
    AlignEnum["inherit"] = "inherit";
    AlignEnum["left"] = "left";
    AlignEnum["center"] = "center";
    AlignEnum["right"] = "right";
})(AlignEnum || (AlignEnum = {}));
var CursorEnum;
(function (CursorEnum) {
    CursorEnum["default"] = "default";
    CursorEnum["pointer"] = "pointer";
    CursorEnum["notAllowed"] = "not-allowed";
})(CursorEnum || (CursorEnum = {}));
var FontWeightEnum;
(function (FontWeightEnum) {
    FontWeightEnum["bold"] = "bold";
    FontWeightEnum["inherit"] = "inherit";
    FontWeightEnum["regular"] = "regular";
    FontWeightEnum["normal"] = "normal";
})(FontWeightEnum || (FontWeightEnum = {}));

var getTextSize = function (sizeName, mediaSize, type) {
    return getSize$2({
        tag: 'p',
        name: sizeName,
        defaultValue: 'inherit',
        media: mediaSize,
        type: type || 'text'
    });
};
/**
 * Texts and paragraphs
 */
var getTextSizeMXL = function (sizeName) {
    return getTextSize(sizeName, 'mxl');
};
var getTextLineHeight = function (sizeName) {
    return getTextSize(sizeName, undefined, 'lineHeight');
};
var getTextSizeML = function (sizeName) {
    return getTextSize(sizeName, 'ml');
};
var getTextSizeMS = function (sizeName) {
    return getTextSize(sizeName, 'ms');
};
var getTextSizeMXS = function (sizeName) {
    return getTextSize(sizeName, 'mxs');
};
/**
 * Font Weights
 */
var getFontWeight = function (fontWeight) {
    switch (fontWeight) {
        case FontWeightEnum.regular:
            return weightMap.regular;
        case FontWeightEnum.bold:
            return weightMap.bold;
        default:
            return weightMap.regular;
    }
};

var EMPTY_STRING = '';
css(templateObject_1$1Y || (templateObject_1$1Y = __makeTemplateObject(["\n  color: ", ";\n  line-height: ", ";\n  text-align: inherit;\n  margin: 0 0;\n"], ["\n  color: ", ";\n  line-height: ", ";\n  text-align: inherit;\n  margin: 0 0;\n"])), function (props) { return getTextColor(props.color || 'fontColor'); }, getTextLineHeight(SizeEnum.normal));
var hideScrollBarStyle = "\n  ::-webkit-scrollbar {\n    display: none;\n  }\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n";
var isEmpty = function (value) {
    return value === undefined || value === null || value === EMPTY_STRING;
};
/**
 * @param value - A number or string representing size
 * @returns A string representing size: if value is a number, it will be converted to a string with 'px'.
 * If there is no value, empty string will be returned.
 */
var getSizeValue = function (value) {
    if (isEmpty(value)) {
        return EMPTY_STRING;
    }
    return typeof value === 'number' ? "".concat(value, "px") : value || EMPTY_STRING;
};
/**
 * @param value - A number or string
 * @returns If there is no value, empty string will be returned.
 */
var getValue$1 = function (value) { return value || EMPTY_STRING; };
/**
 * @returns A string representing css border: if one parameter is omitted, empty string will be returned.
 */
var getBorder = function (_a) {
    var type = _a.type, borderColor = _a.borderColor, borderStyle = _a.borderStyle, width = _a.width;
    if (borderColor && borderStyle && width) {
        return "border".concat(type ? "-".concat(type) : EMPTY_STRING, ": ").concat(width, "px ").concat(borderStyle, " ").concat(getBorderColor(borderColor));
    }
    return EMPTY_STRING;
};
/**
 * @returns A string representing css border bottom: if one parameter is omitted, empty string will be returned.
 */
var getBorderBottom = function (_a) {
    var borderColor = _a.borderColor, borderStyle = _a.borderStyle, borderBottomWidth = _a.borderBottomWidth;
    return getBorder({ type: 'bottom', borderColor: borderColor, borderStyle: borderStyle, width: borderBottomWidth });
};
/**
 * @returns A string representing css border top: if one parameter is omitted, empty string will be returned.
 */
var getBorderTop = function (_a) {
    var borderColor = _a.borderColor, borderStyle = _a.borderStyle, borderTopWidth = _a.borderTopWidth;
    return getBorder({ type: 'top', borderColor: borderColor, borderStyle: borderStyle, width: borderTopWidth });
};
/**
 * @returns A string representing css border left: if one parameter is omitted, empty string will be returned.
 */
var getBorderLeft = function (_a) {
    var borderColor = _a.borderColor, borderStyle = _a.borderStyle, borderLeftWidth = _a.borderLeftWidth;
    return getBorder({ type: 'left', borderColor: borderColor, borderStyle: borderStyle, width: borderLeftWidth });
};
/**
 * @returns A string representing css border right: if one parameter is omitted, empty string will be returned.
 */
var getBorderRight = function (_a) {
    var borderColor = _a.borderColor, borderStyle = _a.borderStyle, borderRightWidth = _a.borderRightWidth;
    return getBorder({ type: 'right', borderColor: borderColor, borderStyle: borderStyle, width: borderRightWidth });
};
var templateObject_1$1Y;

var getMargin = function (spaceGetter, margin) {
    if (typeof margin === 'number')
        return "margin: ".concat(getSizeValue(margin), ";");
    return typeof margin === 'string'
        ? "".concat(getSpace(spaceGetter, 'margin', margin), " auto")
        : getSpace(spaceGetter, 'margin', margin);
};
/**
 * @deprecated The object is deprecated. Use FlexBox component
 */
var BlcBox = styled.div(templateObject_1$1X || (templateObject_1$1X = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var alignItems = _a.alignItems, background = _a.background, borderColor = _a.borderColor, borderStyle = _a.borderStyle, borderWidth = _a.borderWidth, borderBottomWidth = _a.borderBottomWidth, borderTopWidth = _a.borderTopWidth, borderLeftWidth = _a.borderLeftWidth, borderRightWidth = _a.borderRightWidth, boxSizing = _a.boxSizing, display = _a.display, flexDirection = _a.flexDirection, flexGrow = _a.flexGrow, flexWrap = _a.flexWrap, gap = _a.gap, rowGap = _a.rowGap, columnGap = _a.columnGap, height = _a.height, justifyContent = _a.justifyContent, margin = _a.margin, minHeight = _a.minHeight, minWidth = _a.minWidth, overflow = _a.overflow, overflowX = _a.overflowX, overflowY = _a.overflowY, padding = _a.padding, position = _a.position, textAlign = _a.textAlign, left = _a.left, right = _a.right, bottom = _a.bottom, top = _a.top, centerY = _a.centerY, width = _a.width, zIndex = _a.zIndex;
    return "\n    box-sizing: ".concat(boxSizing, ";\n    background-color: ").concat(getLegacyColor(background), ";\n    ").concat(getBorder({ borderColor: borderColor, borderStyle: borderStyle, width: borderWidth }), ";\n    ").concat(getBorderBottom({ borderColor: borderColor, borderStyle: borderStyle, borderBottomWidth: borderBottomWidth }), ";\n    ").concat(getBorderTop({ borderColor: borderColor, borderStyle: borderStyle, borderTopWidth: borderTopWidth }), ";\n    ").concat(getBorderLeft({ borderColor: borderColor, borderStyle: borderStyle, borderLeftWidth: borderLeftWidth }), ";\n    ").concat(getBorderRight({ borderColor: borderColor, borderStyle: borderStyle, borderRightWidth: borderRightWidth }), ";\n    display: ").concat(getValue$1(display), ";\n    flex-direction: ").concat(flexDirection, ";\n    flex-grow: ").concat(getValue$1(flexGrow), ";\n    flex-wrap: ").concat(getValue$1(flexWrap), ";\n    justify-content: ").concat(justifyContent, ";\n    align-items: ").concat(alignItems, ";\n    gap: ").concat(getSizeValue(gap), ";\n    row-gap: ").concat(getSizeValue(rowGap), ";\n    column-gap: ").concat(getSizeValue(columnGap), ";\n    position: ").concat(centerY ? 'absolute' : position, ";\n    ").concat(centerY ? 'bottom: unset' : "bottom: ".concat(getSizeValue(bottom)), ";\n    ").concat(centerY ? 'top: 50%' : "top: ".concat(getSizeValue(top)), ";\n    left: ").concat(getSizeValue(left), ";\n    right: ").concat(getSizeValue(right), ";\n    ").concat(getMargin(getSpaceMXL, margin), ";\n    ").concat(getSpace(getSpaceMXL, 'padding', padding), ";\n    transform: ").concat(centerY ? 'translateY(-50%)' : '', ";\n    min-height: ").concat(getSizeValue(minHeight), ";\n    min-width: ").concat(getSizeValue(minWidth), ";\n    height: ").concat(getSizeValue(height), ";\n    width: ").concat(getSizeValue(width), ";\n    overflow: ").concat(getValue$1(overflow), ";\n    overflow-x: ").concat(getValue$1(overflowX), ";\n    overflow-y: ").concat(getValue$1(overflowY), ";\n    text-align: ").concat(getValue$1(textAlign), ";\n    z-index: ").concat(getValue$1(zIndex), ";\n    font-family: ").concat(fontFamily, ";\n    @media ").concat(mediaSizeMap.larger, " {\n      ").concat(getMargin(getSpaceML, margin), ";\n      ").concat(getSpace(getSpaceML, 'padding', padding), ";\n    }\n    @media ").concat(mediaSizeMap.smaller, " {\n      ").concat(getMargin(getSpaceMS, margin), ";\n      ").concat(getSpace(getSpaceMS, 'padding', padding), ";\n    }\n    @media ").concat(mediaSizeMap.smallest, " {\n      ").concat(getMargin(getSpaceMXS, margin), ";\n      ").concat(getSpace(getSpaceMXS, 'padding', padding), ";\n    }\n");
});
BlcBox.defaultProps = {
    alignItems: 'flex-start',
    boxSizing: 'border-box',
    borderColor: 'grayLight',
    borderStyle: 'solid',
    borderWidth: 0,
    flexDirection: 'row',
    height: 'fit-content',
    justifyContent: 'flex-start',
    margin: 'none',
    padding: 'smaller',
    position: 'relative',
    centerY: false,
    width: 'auto'
};
var templateObject_1$1X;

var getColumns = function (columns, columnsOpt) {
    return typeof columns === 'string' || typeof columnsOpt === 'string'
        ? "grid-template-columns: ".concat(columnsOpt || columns)
        : "grid-template-columns: repeat(".concat(columns, ", 1fr)");
};
var getAreas = function (areas) { return "grid-template-areas: ".concat(areas.map(function (area) { return "'".concat(area, "'"); }).join('')); };
var getTemplate = function (areas, columns, columnsOpt) {
    return areas.length > 0 ? getAreas(areas) : getColumns(columns, columnsOpt);
};
var getGapByMedia = function (getGap, gap, columnGap, rowGap) { return "\n  ".concat(gap ? "gap: ".concat(getGap(gap), "px") : '', ";\n  ").concat(columnGap ? "column-gap: ".concat(getGap(columnGap), "px") : '', ";\n  ").concat(rowGap ? "row-gap: ".concat(getGap(rowGap), "px") : '', ";\n"); };
var BlcRow = styled.div(templateObject_1$1W || (templateObject_1$1W = __makeTemplateObject(["\n  display: grid;\n  font-family: ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  @media ", " {\n    ", ";\n    ", ";\n  }\n\n  @media ", " {\n    ", ";\n    ", ";\n  }\n\n  @media ", " {\n    ", ";\n    ", ";\n  }\n"], ["\n  display: grid;\n  font-family: ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  @media ", " {\n    ", ";\n    ", ";\n  }\n\n  @media ", " {\n    ", ";\n    ", ";\n  }\n\n  @media ", " {\n    ", ";\n    ", ";\n  }\n"])), fontFamily, function (_a) {
    var height = _a.height;
    return "height: ".concat(getSizeValue(height));
}, function (_a) {
    var _b = _a.areas, areas = _b === void 0 ? [] : _b, _c = _a.columns, columns = _c === void 0 ? sizeMap.columns.mxl : _c, columnsOpt = _a.columnsOpt;
    return getTemplate(areas, columns, columnsOpt === null || columnsOpt === void 0 ? void 0 : columnsOpt.mxl);
}, function (_a) {
    var gap = _a.gap, columnGap = _a.columnGap, rowGap = _a.rowGap;
    return getGapByMedia(getGapMXL, gap, columnGap, rowGap);
}, mediaSizeMap.larger, function (_a) {
    var _b = _a.areas, areas = _b === void 0 ? [] : _b, _c = _a.columns, columns = _c === void 0 ? sizeMap.columns.ml : _c, columnsOpt = _a.columnsOpt;
    return getTemplate(areas, columns, columnsOpt === null || columnsOpt === void 0 ? void 0 : columnsOpt.ml);
}, function (_a) {
    var gap = _a.gap, columnGap = _a.columnGap, rowGap = _a.rowGap;
    return getGapByMedia(getGapML, gap, columnGap, rowGap);
}, mediaSizeMap.smaller, function (_a) {
    var _b = _a.areas, areas = _b === void 0 ? [] : _b, _c = _a.columns, columns = _c === void 0 ? sizeMap.columns.ms : _c, columnsOpt = _a.columnsOpt;
    return getTemplate(areas, columns, columnsOpt === null || columnsOpt === void 0 ? void 0 : columnsOpt.ms);
}, function (_a) {
    var gap = _a.gap, columnGap = _a.columnGap, rowGap = _a.rowGap;
    return getGapByMedia(getGapMS, gap, columnGap, rowGap);
}, mediaSizeMap.smallest, function (_a) {
    var _b = _a.areas, areas = _b === void 0 ? [] : _b, _c = _a.columns, columns = _c === void 0 ? sizeMap.columns.mxs : _c, columnsOpt = _a.columnsOpt;
    return getTemplate(areas, columns, columnsOpt === null || columnsOpt === void 0 ? void 0 : columnsOpt.mxs);
}, function (_a) {
    var gap = _a.gap, columnGap = _a.columnGap, rowGap = _a.rowGap;
    return getGapByMedia(getGapMXS, gap, columnGap, rowGap);
});
var templateObject_1$1W;

var columnValueMap = {
    12: { ml: 8, ms: 6, mxs: 4 },
    11: { ml: 7, ms: 5, mxs: 4 },
    10: { ml: 7, ms: 5, mxs: 4 },
    9: { ml: 6, ms: 4, mxs: 4 },
    8: { ml: 6, ms: 4, mxs: 4 },
    7: { ml: 5, ms: 3, mxs: 2 },
    6: { ml: 4, ms: 3, mxs: 2 },
    5: { ml: 3, ms: 3, mxs: 2 },
    4: { ml: 2, ms: 2, mxs: 4 },
    3: { ml: 2, ms: 2, mxs: 4 },
    2: { ml: 1, ms: 1, mxs: 4 },
    1: { ml: 1, ms: 1, mxs: 4 }
};
var getColumnValue = function (column, media) {
    return columnValueMap[column] ? columnValueMap[column][media] : columnValueMap[12][media];
};
var columnLarger = function (cols) {
    return getColumnValue(cols, 'ml');
};
var columnSmaller = function (cols) {
    return getColumnValue(cols, 'ms');
};
var columnSmallest = function (cols) {
    return getColumnValue(cols, 'mxs');
};

var getAlignment$1 = function (align, alignItems, justify) { return "\n".concat(justify ? "justify-self: ".concat(justify) : '', ";\n").concat(align ? "align-self: ".concat(align) : '', ";\n").concat(alignItems ? "align-items: ".concat(alignItems) : '', ";\n"); };
var getOrder = function (orderOpt) { return "order: ".concat(typeof orderOpt === 'number' ? orderOpt : ''); };
/**
 * Builds the grid-column style.
 * @returns If col or colOpt equals 0, it will return display: none.
 */
var getColumnWidth = function (display, col, colOpt) {
    return col === 0 || colOpt === 0
        ? "display: none"
        : "\n      grid-column: span ".concat(colOpt || col, ";\n      display: ").concat(display, ";\n    ");
};
var BlcColumn = styled.div(templateObject_1$1V || (templateObject_1$1V = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  font-family: ", ";\n  ", "\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  font-family: ", ";\n  ", "\n"])), function (_a) {
    var height = _a.height;
    return "height: ".concat(getSizeValue(height));
}, function (_a) {
    var minHeight = _a.minHeight;
    return "min-height: ".concat(getSizeValue(minHeight));
}, function (_a) {
    var gridArea = _a.gridArea;
    return (gridArea ? "grid-area: ".concat(gridArea) : '');
}, function (_a) {
    var alignSelf = _a.alignSelf, alignItems = _a.alignItems, justifySelf = _a.justifySelf;
    return getAlignment$1(alignSelf, alignItems, justifySelf);
}, fontFamily, function (_a) {
    var _b = _a.display, display = _b === void 0 ? 'block' : _b, margin = _a.margin, padding = _a.padding, colsOpt = _a.colsOpt, _c = _a.col, col = _c === void 0 ? 12 : _c, orderOpt = _a.orderOpt;
    return "\n    ".concat(getColumnWidth(display, col, colsOpt === null || colsOpt === void 0 ? void 0 : colsOpt.mxl), ";\n    ").concat(getSpace(getSpaceMXL, 'margin', margin), ";\n    ").concat(getSpace(getSpaceMXL, 'padding', padding), ";\n    ").concat(getOrder(orderOpt === null || orderOpt === void 0 ? void 0 : orderOpt.mxl), ";\n    @media ").concat(mediaSizeMap.larger, " {\n      ").concat(getColumnWidth(display, columnLarger(col), colsOpt === null || colsOpt === void 0 ? void 0 : colsOpt.ml), ";\n      ").concat(getSpace(getSpaceML, 'margin', margin), ";\n      ").concat(getSpace(getSpaceML, 'padding', padding), ";\n      ").concat(getOrder(orderOpt === null || orderOpt === void 0 ? void 0 : orderOpt.ml), ";\n    }\n    @media ").concat(mediaSizeMap.smaller, " {\n      ").concat(getColumnWidth(display, columnSmaller(col), colsOpt === null || colsOpt === void 0 ? void 0 : colsOpt.ms), ";\n      ").concat(getSpace(getSpaceMS, 'margin', margin), ";\n      ").concat(getSpace(getSpaceMS, 'padding', padding), ";\n      ").concat(getOrder(orderOpt === null || orderOpt === void 0 ? void 0 : orderOpt.ms), ";\n    }\n    @media ").concat(mediaSizeMap.smallest, " {\n      ").concat(getColumnWidth(display, columnSmallest(col), colsOpt === null || colsOpt === void 0 ? void 0 : colsOpt.mxs), ";\n      ").concat(getSpace(getSpaceMXS, 'margin', margin), ";\n      ").concat(getSpace(getSpaceMXS, 'padding', padding), ";\n      ").concat(getOrder(orderOpt === null || orderOpt === void 0 ? void 0 : orderOpt.mxs), ";\n    }\n  ");
});
var templateObject_1$1V;

var getCssProp = function (prop, value) { return (value || value === 0 ? "".concat(prop, ": ").concat(value, ";") : ''); };

var FlexBox = styled.div(templateObject_1$1U || (templateObject_1$1U = __makeTemplateObject(["\n  display: flex;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  display: flex;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), function (_a) {
    var flex = _a.flex;
    return getCssProp('flex', flex);
}, function (_a) {
    var flexDirection = _a.flexDirection;
    return getCssProp('flex-direction', flexDirection);
}, function (_a) {
    var gap = _a.gap;
    return getCssProp('gap', getSizeValue(gap));
}, function (_a) {
    var minWidth = _a.minWidth;
    return getCssProp('min-width', getSizeValue(minWidth));
}, function (_a) {
    var maxWidth = _a.maxWidth;
    return getCssProp('max-width', getSizeValue(maxWidth));
}, function (_a) {
    var width = _a.width;
    return getCssProp('width', getSizeValue(width));
}, function (_a) {
    var minHeight = _a.minHeight;
    return getCssProp('min-height', getSizeValue(minHeight));
}, function (_a) {
    var maxHeight = _a.maxHeight;
    return getCssProp('max-height', getSizeValue(maxHeight));
}, function (_a) {
    var height = _a.height;
    return getCssProp('height', getSizeValue(height));
}, function (_a) {
    var justifyContent = _a.justifyContent;
    return getCssProp('justify-content', justifyContent);
}, function (_a) {
    var alignSelf = _a.alignSelf;
    return getCssProp('align-self', alignSelf);
}, function (_a) {
    var alignItems = _a.alignItems;
    return getCssProp('align-items', alignItems);
}, function (_a) {
    var alignContent = _a.alignContent;
    return getCssProp('align-content', alignContent);
}, function (_a) {
    var flexWrap = _a.flexWrap;
    return getCssProp('flex-wrap', flexWrap);
}, function (_a) {
    var order = _a.order;
    return getCssProp('order', order);
}, function (_a) {
    var flexGrow = _a.flexGrow;
    return getCssProp('flex-grow', flexGrow);
}, function (_a) {
    var flexShrink = _a.flexShrink;
    return getCssProp('flex-shrink', flexShrink);
}, function (_a) {
    var flexFlow = _a.flexFlow;
    return getCssProp('flex-flow', flexFlow);
}, function (_a) {
    var flexBasis = _a.flexBasis;
    return getCssProp('flex-basis', flexBasis);
}, function (_a) {
    var padding = _a.padding;
    return getCssProp('padding', getSizeValue(padding));
}, function (_a) {
    var margin = _a.margin;
    return getCssProp('margin', getSizeValue(margin));
}, function (_a) {
    var border = _a.border;
    return getCssProp('border', border);
}, function (_a) {
    var borderColor = _a.borderColor;
    return getCssProp('border-color', borderColor);
}, function (_a) {
    var borderStyle = _a.borderStyle;
    return getCssProp('border-style', borderStyle);
}, function (_a) {
    var borderWidth = _a.borderWidth;
    return getCssProp('border-width', getSizeValue(borderWidth));
}, function (_a) {
    var borderRadius = _a.borderRadius;
    return getCssProp('border-radius', getSizeValue(borderRadius));
}, function (_a) {
    var background = _a.background;
    return getCssProp('background', background);
}, function (_a) {
    var position = _a.position;
    return getCssProp('position', position);
}, function (_a) {
    var textAlign = _a.textAlign;
    return getCssProp('text-align', textAlign);
}, function (_a) {
    var zIndex = _a.zIndex;
    return getCssProp('z-index', zIndex);
}, function (_a) {
    var boxSizing = _a.boxSizing;
    return getCssProp('box-sizing', boxSizing);
}, function (_a) {
    var margin = _a.margin;
    return getCssProp('margin', margin);
});
var templateObject_1$1U;

var headlineMap = {
    H1: {
        fontSize: px(32),
        fontWeight: weightMap$1.regular,
        lineHeight: px(40)
    },
    H2: {
        fontSize: px(28),
        fontWeight: weightMap$1.bold,
        lineHeight: px(36)
    },
    H3: {
        fontSize: px(24),
        fontWeight: weightMap$1.bold,
        lineHeight: px(32)
    },
    H4: {
        fontSize: px(18),
        fontWeight: weightMap$1.bold,
        lineHeight: px(24)
    },
    H5: {
        fontSize: px(16),
        fontWeight: weightMap$1.bold,
        lineHeight: px(22)
    },
    H6: {
        fontSize: px(14),
        fontWeight: weightMap$1.bold,
        lineHeight: px(18)
    }
};

var HeadlineSizeEnum;
(function (HeadlineSizeEnum) {
    HeadlineSizeEnum["H1"] = "h1";
    HeadlineSizeEnum["H2"] = "h2";
    HeadlineSizeEnum["H3"] = "h3";
    HeadlineSizeEnum["H4"] = "h4";
    HeadlineSizeEnum["H5"] = "h5";
    HeadlineSizeEnum["H6"] = "h6";
})(HeadlineSizeEnum || (HeadlineSizeEnum = {}));
var fontSize$1 = function (size) { return headlineMap[size].fontSize; };
var fontWeight$1 = function (size) { return headlineMap[size].fontWeight; };
var lineHeight$1 = function (size) { return headlineMap[size].lineHeight; };

var baseStyle$1 = css(templateObject_1$1T || (templateObject_1$1T = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var _b = _a.margin, margin = _b === void 0 ? 0 : _b, _c = _a.padding, padding = _c === void 0 ? 0 : _c, _d = _a.color, color = _d === void 0 ? 'black' : _d, textAlign = _a.textAlign, _e = _a.truncable, truncable = _e === void 0 ? false : _e, width = _a.width, whiteSpace = _a.whiteSpace;
    return "\n    margin: ".concat(getSizeValue(margin), ";\n    padding: ").concat(getSizeValue(padding), ";\n    font-family: ").concat(fontFamily, ";\n    color: ").concat(getTextColor(color), ";\n    text-align: ").concat(getValue$1(textAlign), ";\n    ").concat(truncable ? getTruncableProps() : '', "\n    width: ").concat(getValue$1(width), ";\n    white-space: ").concat(getValue$1(whiteSpace), ";\n  ");
});
var templateObject_1$1T;

var StyledHeadline$1 = styled('h6')(templateObject_1$1S || (templateObject_1$1S = __makeTemplateObject(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n"])), baseStyle$1, function (_a) {
    var size = _a.size, bold = _a.bold, textDecoration = _a.textDecoration;
    return "\n    font-size: ".concat(fontSize$1(size), ";\n    font-weight: ").concat(bold ? weightMap$1.bold : bold === false ? weightMap$1.regular : fontWeight$1(size), ";\n    line-height: ").concat(lineHeight$1(size), ";\n    text-decoration: ").concat(getValue$1(textDecoration), ";\n\n    ");
});
var Headline = React__default.forwardRef(function (_a, ref) {
    var bold = _a.bold, children = _a.children, className = _a.className, _b = _a.color, color = _b === void 0 ? 'fontColor' : _b, id = _a.id, margin = _a.margin, padding = _a.padding, _c = _a.size, size = _c === void 0 ? 'H5' : _c, textAlign = _a.textAlign, truncable = _a.truncable, width = _a.width, whiteSpace = _a.whiteSpace, href = _a.href, target = _a.target, textDecoration = _a.textDecoration;
    var tag = href ? 'a' : HeadlineSizeEnum[size];
    return (jsx(StyledHeadline$1, __assign({ as: tag, href: href, target: target, bold: bold, className: className, color: color, id: id, margin: margin, padding: padding, ref: ref, size: size, textAlign: textAlign, truncable: truncable, width: width, whiteSpace: whiteSpace, textDecoration: textDecoration }, { children: children })));
});
Headline.displayName = 'Headline';
var templateObject_1$1S;

var fontMap = {
    largest: {
        fontSize: px(18),
        lineHeight: px(21)
    },
    larger: {
        fontSize: px(16),
        lineHeight: px(20)
    },
    normal: {
        fontSize: px(14),
        lineHeight: px(18)
    },
    smaller: {
        fontSize: px(12),
        lineHeight: px(16)
    }
};
var bodyMap = {
    paragraph: {
        size: {
            // H4
            largest: fontMap.largest,
            // H5
            larger: fontMap.larger,
            normal: fontMap.normal,
            smaller: fontMap.smaller
        },
        fontWeight: weightMap$1.regular
    },
    label: __assign({ fontWeight: weightMap$1.bold }, fontMap.normal),
    caption: __assign({ fontWeight: weightMap$1.bold }, fontMap.smaller),
    link: __assign({ fontWeight: weightMap$1.bold }, fontMap.normal)
};

/* eslint-disable @typescript-eslint/no-non-null-assertion */
var BodyTagsEnum;
(function (BodyTagsEnum) {
    BodyTagsEnum["paragraph"] = "p";
    BodyTagsEnum["caption"] = "small";
    BodyTagsEnum["link"] = "a";
    BodyTagsEnum["label"] = "label";
})(BodyTagsEnum || (BodyTagsEnum = {}));
var fontSize = function (type, size) {
    var sizeVariable = fontContent[size];
    if (sizeVariable) {
        return sizeVariable;
    }
    return type === 'paragraph' ? bodyMap[type].size[size || 'normal'].fontSize : bodyMap[type].fontSize;
};
var fontWeight = function (type) { return bodyMap[type].fontWeight; };
var lineHeight = function (type, size) {
    var _a;
    if (type === 'paragraph') {
        return (_a = bodyMap[type].size[size || 'normal']) === null || _a === void 0 ? void 0 : _a.lineHeight;
    }
    else {
        return bodyMap[type].lineHeight;
    }
};

var StyledBody$1 = styled.span(templateObject_1$1R || (templateObject_1$1R = __makeTemplateObject(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n"])), baseStyle$1, function (_a) {
    var size = _a.size, type = _a.type, textDecoration = _a.textDecoration, textTransform = _a.textTransform, bold = _a.bold, italic = _a.italic;
    return "\n    font-size: ".concat(fontSize(type, size), ";\n    font-weight: ").concat(bold ? weightMap$1.bold : fontWeight(type), ";\n    font-style: ").concat(italic ? 'italic' : '', ";\n    line-height: ").concat(lineHeight(type, size), ";\n    text-decoration: ").concat(getValue$1(textDecoration), ";\n    text-transform: ").concat(getValue$1(textTransform), "\n  ");
});
var Body = React__default.forwardRef(function (_a, ref) {
    var bold = _a.bold, children = _a.children, className = _a.className, _b = _a.color, color = _b === void 0 ? 'fontColor' : _b, id = _a.id, margin = _a.margin, padding = _a.padding, _c = _a.size, size = _c === void 0 ? 'normal' : _c, textAlign = _a.textAlign, textDecoration = _a.textDecoration, textTransform = _a.textTransform, _d = _a.truncable, truncable = _d === void 0 ? false : _d, _e = _a.type, type = _e === void 0 ? 'paragraph' : _e, width = _a.width, htmlFor = _a.htmlFor, whiteSpace = _a.whiteSpace, rest = __rest(_a, ["bold", "children", "className", "color", "id", "margin", "padding", "size", "textAlign", "textDecoration", "textTransform", "truncable", "type", "width", "htmlFor", "whiteSpace"]);
    var tag = BodyTagsEnum[type];
    return (jsx(StyledBody$1, __assign({ as: tag, bold: bold, className: className, color: color, id: id, margin: margin, padding: padding, ref: ref, size: size, textAlign: textAlign, textDecoration: textDecoration, textTransform: textTransform, truncable: truncable, type: type, width: width, htmlFor: htmlFor, whiteSpace: whiteSpace }, rest, { children: children })));
});
Body.displayName = 'Body';
var templateObject_1$1R;

var BackgroundLayout = function (props) { return (jsxs("svg", __assign({ viewBox: "0 0 208 36", preserveAspectRatio: "none", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%" }, props, { children: [jsx("path", { d: "M4 0H0v4h4V0Z", fill: "#CF2027" }), jsx("path", { d: "M4 0H0v4h4V0Z", fill: "#313335", fillOpacity: 0.08 }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M56 0h152v36H88v-4h-8v4h-8v-8h8v-4h-8v4h-8v-8h8v-4h-8v4h-8v-8h8V8h-8v4h-8V4h8V0Zm36 32h4v-4h-4v4Zm-8-12h4v4h-4v-4Zm-8-8h4v4h-4v-4Zm-8-8h4v4h-4V4Z", fill: "#CF2027" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M56 0h152v36H88v-4h-8v4h-8v-8h8v-4h-8v4h-8v-8h8v-4h-8v4h-8v-8h8V8h-8v4h-8V4h8V0Zm36 32h4v-4h-4v4Zm-8-12h4v4h-4v-4Zm-8-8h4v4h-4v-4Zm-8-8h4v4h-4V4Z", fill: "#313335", fillOpacity: 0.08 }), jsx("path", { d: "M40 4V0h8v4h-8Z", fill: "#CF2027" }), jsx("path", { d: "M40 4V0h8v4h-8Z", fill: "#313335", fillOpacity: 0.08 }), jsx("path", { d: "M40 12V4h-8V0h-8v4h-8v4h8V4h8v8h-8v4h8v-4h8Z", fill: "#CF2027" }), jsx("path", { d: "M40 12V4h-8V0h-8v4h-8v4h8V4h8v8h-8v4h8v-4h8Z", fill: "#313335", fillOpacity: 0.08 }), jsx("path", { d: "M40 20v-8h8v8h-8Z", fill: "#CF2027" }), jsx("path", { d: "M40 20v-8h8v8h-8Z", fill: "#313335", fillOpacity: 0.08 }), jsx("path", { d: "M40 20v4h-8v-4h8Z", fill: "#CF2027" }), jsx("path", { d: "M40 20v4h-8v-4h8Z", fill: "#313335", fillOpacity: 0.08 }), jsx("path", { d: "M48 28v-8h8v8h-8Z", fill: "#CF2027" }), jsx("path", { d: "M48 28v-8h8v8h-8Z", fill: "#313335", fillOpacity: 0.08 }), jsx("path", { d: "M48 28v4h-8v-4h8Z", fill: "#CF2027" }), jsx("path", { d: "M48 28v4h-8v-4h8Z", fill: "#313335", fillOpacity: 0.08 }), jsx("path", { d: "M56 28h8v8h-8v-8Z", fill: "#CF2027" }), jsx("path", { d: "M56 28h8v8h-8v-8Z", fill: "#313335", fillOpacity: 0.08 }), jsx("path", { d: "M28 24v4h-4v-4h4Z", fill: "#CF2027" }), jsx("path", { d: "M28 24v4h-4v-4h4Z", fill: "#313335", fillOpacity: 0.08 }), jsx("path", { d: "M16 16h4v4h-4v-4Z", fill: "#CF2027" }), jsx("path", { d: "M16 16h4v4h-4v-4Z", fill: "#313335", fillOpacity: 0.08 }), jsx("path", { d: "M8 8h4v4H8V8Z", fill: "#CF2027" }), jsx("path", { d: "M8 8h4v4H8V8Z", fill: "#313335", fillOpacity: 0.08 }), jsx("path", { d: "M32 32h4v4h-4v-4Z", fill: "#CF2027" }), jsx("path", { d: "M32 32h4v4h-4v-4Z", fill: "#313335", fillOpacity: 0.08 })] }))); };

var Link$1 = styled.a(templateObject_1$1Q || (templateObject_1$1Q = __makeTemplateObject(["\n  text-decoration: none;\n  padding: 8px;\n  position: absolute;\n  color: ", ";\n"], ["\n  text-decoration: none;\n  padding: 8px;\n  position: absolute;\n  color: ", ";\n"])), colorText.colorTextTextInvert);
var Svg$4 = styled(BackgroundLayout)(templateObject_2$U || (templateObject_2$U = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var color = _a.color;
    return "\n    path {\n      fill: ".concat(color, ";\n    }\n  ");
});
var ClosedMarketplaceBanner = function (_a) {
    var primaryColor = _a.primaryColor, href = _a.href;
    return (jsx(BlcBanner, __assign({ backgroundColor: "black", padding: "0px", color: "white", margin: "0 0 10px 0" }, { children: jsxs(BlcRow, { children: [jsx(BlcColumn, __assign({ padding: "smallest", col: 6 }, { children: jsx(FlexBox, __assign({ height: "100%", alignItems: "center", justifyContent: "flex-start" }, { children: jsx(Headline, __assign({ size: "H6", color: "white", textAlign: "left" }, { children: "Group exclusive" })) })) })), jsx(BlcColumn, __assign({ col: 6, padding: "none" }, { children: jsxs(FlexBox, __assign({ height: "100%", alignItems: "center", justifyContent: "flex-end" }, { children: [jsx(Svg$4, { color: primaryColor }), href && jsx(Link$1, __assign({ href: href }, { children: "See all listings" }))] })) }))] }) })));
};
var templateObject_1$1Q, templateObject_2$U;

var CarBravoBanner = styled.div(templateObject_1$1P || (templateObject_1$1P = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 5px;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 5px;\n"])));
var templateObject_1$1P;

var CarbravoBanner = function (_a) {
    var className = _a.className;
    return (jsx(BlcBanner, __assign({ className: className, backgroundColor: "carbravoBlue", color: "white", padding: "5px", margin: "0 0 10px 0" }, { children: jsxs(CarBravoBanner, { children: [jsx(Body, __assign({ bold: true, color: "white" }, { children: "CarBravo" })), "eligible"] }) })));
};

/* eslint-disable no-undefined,no-param-reassign,no-shadow */

/**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param  {number}    delay -          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {boolean}   [noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
 *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
 *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
 *                                    the internal counter is reset).
 * @param  {Function}  callback -       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                    to `callback` when the throttled-function is executed.
 * @param  {boolean}   [debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
 *                                    schedule `callback` to execute after `delay` ms.
 *
 * @returns {Function}  A new, throttled, function.
 */
function throttle (delay, noTrailing, callback, debounceMode) {
  /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */
  var timeoutID;
  var cancelled = false; // Keep track of the last time `callback` was executed.

  var lastExec = 0; // Function to clear existing timeout

  function clearExistingTimeout() {
    if (timeoutID) {
      clearTimeout(timeoutID);
    }
  } // Function to cancel next exec


  function cancel() {
    clearExistingTimeout();
    cancelled = true;
  } // `noTrailing` defaults to falsy.


  if (typeof noTrailing !== 'boolean') {
    debounceMode = callback;
    callback = noTrailing;
    noTrailing = undefined;
  }
  /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */


  function wrapper() {
    for (var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++) {
      arguments_[_key] = arguments[_key];
    }

    var self = this;
    var elapsed = Date.now() - lastExec;

    if (cancelled) {
      return;
    } // Execute `callback` and update the `lastExec` timestamp.


    function exec() {
      lastExec = Date.now();
      callback.apply(self, arguments_);
    }
    /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */


    function clear() {
      timeoutID = undefined;
    }

    if (debounceMode && !timeoutID) {
      /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`.
       */
      exec();
    }

    clearExistingTimeout();

    if (debounceMode === undefined && elapsed > delay) {
      /*
       * In throttle mode, if `delay` time has been exceeded, execute
       * `callback`.
       */
      exec();
    } else if (noTrailing !== true) {
      /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */
      timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
  }

  wrapper.cancel = cancel; // Return the wrapper function.

  return wrapper;
}

/* eslint-disable no-undefined */
/**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param  {number}   delay -         A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {boolean}  [atBegin] -     Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                  after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                  (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 * @param  {Function} callback -      A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                  to `callback` when the debounced-function is executed.
 *
 * @returns {Function} A new, debounced function.
 */

function debounce$1 (delay, atBegin, callback) {
  return callback === undefined ? throttle(delay, atBegin, false) : throttle(delay, callback, atBegin !== false);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var useWindowEvent = function (callback, event, delay) {
    if (delay === void 0) { delay = 5; }
    useEffect(function () {
        var throttledCallback = throttle(delay, callback);
        window.addEventListener(event, throttledCallback);
        return function () {
            window.removeEventListener(event, throttledCallback);
        };
    }, [callback, delay, event]);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var useResize = function (callback) {
    useWindowEvent(callback, 'resize');
};

var useDimension = function (ref) {
    var _a = useState(0), width = _a[0], setWidth = _a[1];
    var _b = useState(0), height = _b[0], setHeight = _b[1];
    var setDimensions = function () {
        if (ref.current) {
            setWidth(ref.current.offsetWidth);
            setHeight(ref.current.offsetHeight);
        }
    };
    useEffect(setDimensions, [ref]);
    useResize(setDimensions);
    return [height, width];
};

var spin = css(templateObject_1$1O || (templateObject_1$1O = __makeTemplateObject(["\n  animation: spin 1.8s linear infinite;\n\n  @keyframes spin {\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n"], ["\n  animation: spin 1.8s linear infinite;\n\n  @keyframes spin {\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n"])));
var templateObject_1$1O;

var animations = { spin: spin };
var getAnimationCss = function (animation) { return animations[animation]; };

var iconSizeMap = {
    largest: '40px',
    larger: '32px',
    normal: '24px',
    smaller: '20px',
    smallest: '16px',
    inherit: '100%'
};
var SvgContainer$1 = styled.span(templateObject_1$1N || (templateObject_1$1N = __makeTemplateObject(["\n  height: auto;\n  width: auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  & svg {\n    ", "\n\n    ", "\n  }\n"], ["\n  height: auto;\n  width: auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  & svg {\n    ", "\n\n    ", "\n  }\n"])), function (_a) {
    var size = _a.size, cursor = _a.cursor, noFix = _a.noFix;
    return "\n        height: ".concat(iconSizeMap[size], ";\n        width: ").concat(iconSizeMap[size], ";\n        ").concat(!noFix && 'margin: -2px;', "\n        cursor: ").concat(getValue$1(cursor), ";\n    ");
}, function (_a) {
    var animation = _a.animation;
    return (animation ? getAnimationCss(animation) : "");
});
styled.div(templateObject_2$T || (templateObject_2$T = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: repeat(8, 1fr);\n  row-gap: 15px;\n\n  > div {\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n  }\n"], ["\n  display: grid;\n  grid-template-columns: repeat(8, 1fr);\n  row-gap: 15px;\n\n  > div {\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n  }\n"])));
var templateObject_1$1N, templateObject_2$T;

var Icon = function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'black' : _b, className = _a.className, _c = _a.size, size = _c === void 0 ? 'normal' : _c, _d = _a.name, name = _d === void 0 ? 'caret-right' : _d, cursor = _a.cursor, _e = _a.noFix, noFix = _e === void 0 ? false : _e, animation = _a.animation, rest = __rest(_a, ["color", "className", "size", "name", "cursor", "noFix", "animation"]);
    return (jsx(SvgContainer$1, __assign({ className: className, size: size, cursor: cursor, noFix: noFix, animation: animation }, rest, { children: jsx("svg", __assign({ width: "100%", height: "100%", fill: getIconColor(color), role: "img", "aria-labelledby": name }, { children: jsx("use", { href: "#dsicon-".concat(name) }) })) })));
};

var Arrow = styled.span(templateObject_1$1M || (templateObject_1$1M = __makeTemplateObject(["\n  align-items: center;\n  cursor: pointer;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  opacity: 0.5;\n  position: absolute;\n  pointer-events: all;\n\n  &:hover {\n    opacity: 1;\n  }\n  &:focus {\n    outline: 0;\n  }\n  &.prev {\n    left: 0;\n  }\n  &.next {\n    right: 0;\n  }\n"], ["\n  align-items: center;\n  cursor: pointer;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  opacity: 0.5;\n  position: absolute;\n  pointer-events: all;\n\n  &:hover {\n    opacity: 1;\n  }\n  &:focus {\n    outline: 0;\n  }\n  &.prev {\n    left: 0;\n  }\n  &.next {\n    right: 0;\n  }\n"])));
var BlcCarouselArrow = function (_a) {
    var action = _a.action, nav = _a.nav, navColor = _a.navColor, navSize = _a.navSize;
    var direction = nav === 'prev' ? 'caret-left' : 'caret-right';
    return (jsx(Arrow, __assign({ className: nav, onClick: function () { return action(); }, role: "button", "aria-label": "Carousel arrow ".concat(direction) }, { children: jsx(Icon, { color: navColor, name: direction, size: navSize }) })));
};
var templateObject_1$1M;

var orientLandscape = function (ratio) {
    switch (ratio) {
        case '4:3':
            return { height: 3, width: 4 };
        case '16:9':
            return { height: 9, width: 16 };
        default:
            return { height: 1, width: 1 };
    }
};
var orientPortrait = function (ratio) {
    var swiped = orientLandscape(ratio);
    return { height: swiped.width, width: swiped.height };
};
var imageHeight = function (ratio, size, portrait) {
    var orientFunction = portrait ? orientPortrait : orientLandscape;
    return (orientFunction(ratio).height * size) / orientFunction(ratio).width + 'px';
};

var transitionStyles = function (transitionStyle) {
    switch (transitionStyle) {
        case 'smooth':
            return 'ease';
        case 'elastic':
            return 'cubic-bezier(0.68, -0.55, 0.265, 1.55)';
        default:
            return 'linear';
    }
};

var getValue = function (value) { return (typeof value === 'number' ? "".concat(value, "px") : value); };
var getHeight = function (_a) {
    var _b = _a.aspectRatio, aspectRatio = _b === void 0 ? '16:9' : _b, direction = _a.direction, height = _a.height, _c = _a.portrait, portrait = _c === void 0 ? false : _c, _d = _a.size, size = _d === void 0 ? 0 : _d;
    if (height) {
        return getValue(height);
    }
    if (size === 0) {
        return direction === 'horizontal' ? '100%' : '100vh';
    }
    return "".concat(imageHeight(aspectRatio, size, portrait), ";");
};
var getWidth = function (size, width) {
    if (width) {
        return getValue(width);
    }
    return size === 0 ? '100%' : "".concat(size, "px");
};
// Carousel accepts size, but if width or height is set, it will be ignored
var Carousel$1 = styled.div(templateObject_1$1L || (templateObject_1$1L = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var aspectRatio = _a.aspectRatio, _b = _a.background, background = _b === void 0 ? 'smokeLight' : _b, direction = _a.direction, height = _a.height, portrait = _a.portrait, _c = _a.size, size = _c === void 0 ? 0 : _c, width = _a.width;
    return "\n    overflow: hidden;\n    position: relative;\n    background-color: ".concat(getLegacyColor(background), ";\n    height: ").concat(getHeight({ aspectRatio: aspectRatio, direction: direction, height: height, portrait: portrait, size: size }), ";\n    width: ").concat(getWidth(size, width), ";\n    &:focus-visible {\n      outline: none;\n    }\n  ");
});
var Wrapper$2 = styled.div(templateObject_2$S || (templateObject_2$S = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var currentIndex = _a.currentIndex, direction = _a.direction, itemCount = _a.itemCount, height = _a.height, width = _a.width, transitionStyle = _a.transitionStyle, transitionTime = _a.transitionTime;
    return "\n    display: flex;\n    flex-wrap: nowrap;\n    z-index: 0;\n    font-family: ".concat(fontFamily, ";\n    flex-direction: ").concat(direction === 'horizontal' ? 'row' : 'column', ";\n    height: ").concat(direction === 'horizontal' ? '100%' : height * itemCount + 'px', ";\n    transform: ").concat(direction === 'horizontal' ? "translateX(".concat(currentIndex * -width, "px)") : "translateY(".concat(currentIndex * -height, "px)"), ";\n    transition: transform ").concat(transitionStyles(transitionStyle), " ").concat(transitionTime, "ms;\n    width: ").concat(direction === 'horizontal' ? width * itemCount + 'px' : '100%', ";\n  ");
});
var Navigation$1 = styled.div(templateObject_3$r || (templateObject_3$r = __makeTemplateObject(["\n  bottom: 0;\n  height: 100%;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 100%;\n  z-index: 1;\n  pointer-events: none;\n"], ["\n  bottom: 0;\n  height: 100%;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 100%;\n  z-index: 1;\n  pointer-events: none;\n"])));
var Indicator = styled.span(templateObject_4$e || (templateObject_4$e = __makeTemplateObject(["\n  cursor: pointer;\n  margin: 4px 6px;\n  line-height: 1;\n  opacity: 0.5;\n  &:hover,\n  &.active {\n    opacity: 1;\n  }\n  &:focus {\n    outline: 0;\n  }\n"], ["\n  cursor: pointer;\n  margin: 4px 6px;\n  line-height: 1;\n  opacity: 0.5;\n  &:hover,\n  &.active {\n    opacity: 1;\n  }\n  &:focus {\n    outline: 0;\n  }\n"])));
var templateObject_1$1L, templateObject_2$S, templateObject_3$r, templateObject_4$e;

var Dot$1 = styled.span(templateObject_1$1K || (templateObject_1$1K = __makeTemplateObject(["\n  ", "\n  border-radius: 50%;\n  box-sizing: border-box;\n  display: flex;\n  flex-shrink: 0;\n"], ["\n  ", "\n  border-radius: 50%;\n  box-sizing: border-box;\n  display: flex;\n  flex-shrink: 0;\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? 8 : _b, _c = _a.color, color = _c === void 0 ? 'primary' : _c, _d = _a.active, active = _d === void 0 ? true : _d;
    return "\n    height: ".concat(getSizeValue(size), ";\n    width: ").concat(getSizeValue(size), ";\n    ").concat(active ? "background-color: ".concat(getIconColor(color)) : "border: 1px solid ".concat(getIconColor(color)), ";\n  ");
});
var templateObject_1$1K;

var BlcCarouselDots = function (_a) {
    var dotsMargin = _a.dotsMargin, count = _a.count, activeItem = _a.activeItem, navColor = _a.navColor, action = _a.action, direction = _a.direction;
    var dots = Array.from({ length: count }).map(function (_, index) {
        var isActive = activeItem === index;
        return (jsx(Indicator, __assign({ className: isActive ? "dot dot-".concat(index, " active") : "dot dot-".concat(index), onClick: function () { return action(index); }, role: "button", tabIndex: 0, "aria-label": "Go to carousel slide ".concat(index + 1) }, { children: jsx(Dot$1, { className: "carousel-dot", color: navColor, active: isActive, size: 10 }) }), index));
    });
    return direction === 'horizontal' ? (jsx(HorizontalDots, __assign({ dotsMargin: dotsMargin }, { children: dots }))) : (jsx(VerticalDots, { children: dots }));
};
var base = styled.div(templateObject_1$1J || (templateObject_1$1J = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  pointer-events: all;\n"], ["\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  pointer-events: all;\n"])));
var HorizontalDots = styled(base)(templateObject_2$R || (templateObject_2$R = __makeTemplateObject(["\n  ", "\n  bottom: 0;\n  flex-direction: row;\n  height: fit-content;\n  left: 0;\n  right: unset;\n  top: unset;\n  width: 100%;\n"], ["\n  ", "\n  bottom: 0;\n  flex-direction: row;\n  height: fit-content;\n  left: 0;\n  right: unset;\n  top: unset;\n  width: 100%;\n"])), function (_a) {
    var dotsMargin = _a.dotsMargin;
    return (dotsMargin ? "margin-bottom: ".concat(dotsMargin, "px;") : '');
});
var VerticalDots = styled(base)(templateObject_3$q || (templateObject_3$q = __makeTemplateObject(["\n  bottom: unset;\n  flex-direction: column;\n  height: 100%;\n  left: unset;\n  right: 0;\n  top: 0;\n  width: fit-content;\n"], ["\n  bottom: unset;\n  flex-direction: column;\n  height: 100%;\n  left: unset;\n  right: 0;\n  top: 0;\n  width: fit-content;\n"])));
var templateObject_1$1J, templateObject_2$R, templateObject_3$q;

var NavButton = function (_a) {
    var nav = _a.nav, action = _a.action, direction = _a.direction, hide = _a.hide, navColor = _a.navColor, navSize = _a.navSize;
    if (direction === 'horizontal' && !hide) {
        return jsx(BlcCarouselArrow, { action: action, navColor: navColor, navSize: navSize, nav: nav });
    }
    return null;
};
var BlcCarouselNav = function (_a) {
    var infinite = _a.infinite, direction = _a.direction, goToPrevSlide = _a.goToPrevSlide, goToSlide = _a.goToSlide, goToNextSlide = _a.goToNextSlide, dots = _a.dots, dotsMargin = _a.dotsMargin, navColor = _a.navColor, navSize = _a.navSize, count = _a.count, activeItem = _a.activeItem, hideArrows = _a.hideArrows;
    var hidePrev = hideArrows || (!infinite && activeItem <= 0);
    var hideNext = hideArrows || (!infinite && activeItem === count - 1);
    return (jsxs(Navigation$1, { children: [jsx(NavButton, { nav: "prev", action: goToPrevSlide, direction: direction, hide: hidePrev, navColor: navColor, navSize: navSize }), dots && (jsx(BlcCarouselDots, { dotsMargin: dotsMargin, action: goToSlide, count: count, navColor: navColor, navSize: navSize, activeItem: activeItem, direction: direction })), jsx(NavButton, { nav: "next", action: goToNextSlide, direction: direction, hide: hideNext, navColor: navColor, navSize: navSize })] }));
};

var useKeys = function (elementRef, callbacks) {
    var callbackRef = useRef(elementRef);
    callbackRef.current = callbacks;
    useEffect(function () {
        var handleKeyDown = function (e) {
            var event = e;
            callbackRef.current[event.key] && callbackRef.current[event.key](event);
        };
        var element = elementRef.current;
        if (element) {
            element.addEventListener('keydown', handleKeyDown);
        }
        return function () {
            if (element) {
                element.removeEventListener('keydown', handleKeyDown);
            }
        };
    }, [elementRef, callbackRef]);
};

var checkIfIsFirstItem = function (index) { return index === 0; };
var checkIfIsLastItem = function (index, numberOfItems) { return index === numberOfItems - 1; };
var shouldInfiniteNav = function (isFirstOrLastItem, infinite) { return isFirstOrLastItem && infinite; };
var useCarouselNav = function (activeItem, numberOfItems, infinite) {
    var _a = useState(activeItem), currentItem = _a[0], setCurrentItem = _a[1];
    var goToSlide = function (i) {
        setCurrentItem(i);
    };
    var goPrev = function () {
        var isFirstItem = checkIfIsFirstItem(currentItem);
        if (shouldInfiniteNav(isFirstItem, infinite)) {
            setCurrentItem(numberOfItems - 1);
        }
        else if (!isFirstItem) {
            setCurrentItem(function (prevState) { return prevState - 1; });
        }
    };
    var goNext = function () {
        var isLastItem = checkIfIsLastItem(currentItem, numberOfItems);
        if (shouldInfiniteNav(isLastItem, infinite)) {
            setCurrentItem(0);
        }
        else if (!isLastItem) {
            setCurrentItem(function (prevState) { return prevState + 1; });
        }
    };
    return { goToSlide: goToSlide, goPrev: goPrev, goNext: goNext, currentItem: currentItem };
};

var getNavCallbacks = function (prev, next) { return ({
    horizontal: {
        ArrowLeft: prev,
        ArrowRight: next
    },
    vertical: {
        ArrowUp: prev,
        ArrowDown: next
    }
}); };
var BlcCarousel = React__default.forwardRef(function (_a, ref) {
    var _b = _a.activeItem, activeItem = _b === void 0 ? 0 : _b, _c = _a.aspectRatio, aspectRatio = _c === void 0 ? '16:9' : _c, _d = _a.autoSlide, autoSlide = _d === void 0 ? false : _d, _e = _a.autoSlideTime, autoSlideTime = _e === void 0 ? 5 : _e, _f = _a.background, background = _f === void 0 ? 'smokeLight' : _f, _g = _a.children, children = _g === void 0 ? null : _g, _h = _a.direction, direction = _h === void 0 ? 'horizontal' : _h, _j = _a.dots, dots = _j === void 0 ? true : _j, dotsMargin = _a.dotsMargin, _k = _a.infinite, infinite = _k === void 0 ? false : _k, _l = _a.navigation, navigation = _l === void 0 ? true : _l, _m = _a.navColor, navColor = _m === void 0 ? 'white' : _m, _o = _a.navSize, navSize = _o === void 0 ? 'normal' : _o, _p = _a.portrait, portrait = _p === void 0 ? false : _p, _q = _a.size, size = _q === void 0 ? 0 : _q, width = _a.width, height = _a.height, _r = _a.transitionStyle, transitionStyle = _r === void 0 ? 'linear' : _r, _s = _a.transitionTime, transitionTime = _s === void 0 ? 320 : _s, _t = _a.hideArrows, hideArrows = _t === void 0 ? false : _t;
    var carouselRef = ref || useRef(null);
    var itemCount = React__default.Children.count(children);
    var _u = useDimension(carouselRef), carouselHeight = _u[0], carouselWidth = _u[1];
    var _v = useCarouselNav(activeItem, itemCount, infinite), goToSlide = _v.goToSlide, goPrev = _v.goPrev, goNext = _v.goNext, currentItem = _v.currentItem;
    useEffect(function () {
        if (autoSlide && infinite) {
            var id_1 = setTimeout(goNext, autoSlideTime * 1000);
            return function () { return clearTimeout(id_1); };
        }
    });
    var callbacks = getNavCallbacks(goPrev, goNext)[direction];
    useKeys(carouselRef, callbacks);
    return (jsxs(Carousel$1, __assign({ ref: carouselRef, aspectRatio: aspectRatio, background: background, direction: direction, size: size, portrait: portrait, width: width, height: height, tabIndex: 0 }, { children: [navigation && itemCount !== 1 && (jsx(BlcCarouselNav, { direction: direction, dots: dots, dotsMargin: dotsMargin, navColor: navColor, navSize: navSize, activeItem: currentItem, count: itemCount, goToSlide: goToSlide, goToPrevSlide: goPrev, goToNextSlide: goNext, infinite: infinite, hideArrows: hideArrows })), jsx(Wrapper$2, __assign({ currentIndex: currentItem, direction: direction, itemCount: itemCount, height: carouselHeight, width: carouselWidth, transitionStyle: transitionStyle, transitionTime: transitionTime, className: "wrapper" }, { children: React__default.Children.map(children, function (child) {
                    return React__default.cloneElement(child, {
                        height: carouselHeight,
                        direction: direction
                    });
                }) }))] })));
});
BlcCarousel.displayName = 'BlcCarousel';

var Item$2 = styled.div(templateObject_1$1I || (templateObject_1$1I = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var _b = _a.display, display = _b === void 0 ? 'flex' : _b, _c = _a.direction, direction = _c === void 0 ? 'horizontal' : _c, height = _a.height, _d = _a.padding, padding = _d === void 0 ? SizeEnum.none : _d;
    return "\n    align-items: center;\n    display: ".concat(display, ";\n    flex-wrap: nowrap;\n    height: ").concat(direction === 'horizontal' ? 'unset' : height + 'px', ";\n    justify-content: center;\n    padding: 0 ").concat(getSpaceMXL(padding), ";\n    position: relative;\n    width: 100%;\n    @media ").concat(mediaSizeMap.larger, " {\n      padding: 0 ").concat(getSpaceML(padding), ";\n    }\n    @media ").concat(mediaSizeMap.smaller, " {\n      padding: 0 ").concat(getSpaceMS(padding), ";\n    }\n    @media ").concat(mediaSizeMap.smallest, " {\n      padding: 0 ").concat(getSpaceMXS(padding), ";\n    }\n  ");
});
var BlcCarouselItem = function (_a) {
    var _b = _a.children, children = _b === void 0 ? null : _b, direction = _a.direction, display = _a.display, height = _a.height, padding = _a.padding, _c = _a.placeholder, placeholder = _c === void 0 ? 'Not found.' : _c;
    return (jsx(Item$2, __assign({ direction: direction, display: display, height: height, padding: padding }, { children: children || (jsx("div", __assign({ className: "placeholder" }, { children: jsx(Body, __assign({ color: "grayDark", textAlign: "center" }, { children: placeholder })) }))) })));
};
var templateObject_1$1I;

var CircleBadge = styled.div(function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'white' : _b, _c = _a.background, background = _c === void 0 ? 'grayDark' : _c;
    return css(templateObject_1$1H || (templateObject_1$1H = __makeTemplateObject(["\n    border-radius: 100%;\n    display: flex;\n    width: 20px;\n    height: 20px;\n    background: ", ";\n    color: ", ";\n    justify-content: center;\n    align-items: center;\n    font-size: ", ";\n    line-height: ", ";\n    font-family: ", ";\n  "], ["\n    border-radius: 100%;\n    display: flex;\n    width: 20px;\n    height: 20px;\n    background: ", ";\n    color: ", ";\n    justify-content: center;\n    align-items: center;\n    font-size: ", ";\n    line-height: ", ";\n    font-family: ", ";\n  "])), getLegacyColor(background), getTextColor(color), fontMap.normal.fontSize, fontMap.normal.lineHeight, fontFamily);
});
var templateObject_1$1H;

var types = {
    info: 'i',
    exclamation: '!',
    question: '?'
};
var BlcCircleBadge = function (_a) {
    var background = _a.background, color = _a.color, _b = _a.type, type = _b === void 0 ? 'info' : _b;
    return (jsx(CircleBadge, __assign({ background: background, color: color }, { children: types[type] })));
};

var s=function(s){var t=s.as,a=s.errors,m=s.name,o=s.message,i=s.render,l=function(e,r){if(null==e)return {};var n,s,t={},a=Object.keys(e);for(s=0;s<a.length;s++)r.indexOf(n=a[s])>=0||(t[n]=e[n]);return t}(s,["as","errors","name","message","render"]),f=useFormContext(),c=get(a||f.formState.errors,m);if(!c)return null;var g=c.message,u=c.types,d=Object.assign({},l,{children:g||o});return React.isValidElement(t)?React.cloneElement(t,d):i?i({message:g||o,messages:u}):React.createElement(t||React.Fragment,d)};

var FormErrorContainer = styled.div(templateObject_1$1G || (templateObject_1$1G = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: 8px;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 8px;\n"])));
var templateObject_1$1G;

var FormError = function (_a) {
    var text = _a.text, children = _a.children, _b = _a["data-testid"], dataTestid = _b === void 0 ? 'error-text' : _b;
    return children || text ? (jsxs(FormErrorContainer, { children: [jsx(Icon, { name: "exclamation", color: "alert", size: "smaller" }), jsx(Body, __assign({ bold: true, color: "alert", "data-testid": dataTestid }, { children: children || text }))] })) : null;
};

var BlcErrorMessage = function (_a) {
    var errors = _a.errors, name = _a.name;
    return (jsx(s, { errors: errors, name: name, render: function (data) { return jsx(FormError, { children: data.message }); } }));
};

var inputPosition = function (position) {
    switch (position) {
        case 'top':
            return 2;
        case 'left':
            return 2;
        case 'bottom':
            return 1;
        case 'right':
            return 1;
        default:
            return 0;
    }
};

var INPUT_SIZE = {
    default: 'var(--inputHeight)',
    smallest: 'var(--inputHeightSmallest)'
};

var Container$e = styled.div.attrs({ className: 'input-prefix-container' })(templateObject_1$1F || (templateObject_1$1F = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var _b = _a.background, background = _b === void 0 ? 'transparent' : _b, _c = _a.labelPosition, labelPosition = _c === void 0 ? 'top' : _c, _d = _a.borderColor, borderColor = _d === void 0 ? 'grayLight' : _d, _e = _a.borderWidth, borderWidth = _e === void 0 ? 1 : _e, _f = _a.borderStyle, borderStyle = _f === void 0 ? 'solid' : _f, _g = _a.disabled, disabled = _g === void 0 ? false : _g, _h = _a.size, size = _h === void 0 ? 'default' : _h;
    return "\n    height: ".concat(INPUT_SIZE[size], ";\n    overflow: hidden;\n    background-color: ").concat(disabled ? colorFormSurface.colorFormSurfaceDisabled : getLegacyColor(background), ";\n    border-radius: var(--inputBorderRadius);\n    ").concat(getBorder({ borderColor: borderColor, borderStyle: borderStyle, width: borderWidth }), ";\n    box-sizing: border-box;\n    color: ").concat(colorText.colorTextTextPrimary, ";\n    font-family: ").concat(fontFamily, ";\n    font-stretch: normal;\n    font-style: normal;\n    font-weight: ").concat(weightMap.regular, ";\n    letter-spacing: normal;\n    margin: 0;\n    transition: border-color .15s;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    order: ").concat(inputPosition(labelPosition || ''), ";\n\n    &:focus-within,\n    &:focus {\n      box-shadow: 0px 0px 2px 2px var(--focus);\n    }\n\n    &:focus-within,\n    &:focus,\n    &:hover {\n      border-color: ").concat(colorFormBorder.colorFormBorderActive, ";\n    }\n\n    input {\n      box-shadow: none !important;\n      border: none !important;\n    }\n\t");
});
var Prefix = styled.div(templateObject_2$Q || (templateObject_2$Q = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var background = _a.background, _b = _a.prefixMargin, prefixMargin = _b === void 0 ? '0px 0px 0px 4px' : _b;
    return "\n    width: fit-content;\n    margin: ".concat(prefixMargin, ";\n    background: ").concat(getLegacyColor(background) || colorFormSurface.colorFormSurfacePrefix, ";\n    align-items: center;\n    justify-content: center;\n    font-size: ").concat(fontContent.fontContentDefault, ";\n    font-weight: ").concat(weightMap.bold, ";\n    color: ").concat(colorText.colorTextTextSecondary, ";\n    display: flex;\n    height: 40px;\n    border-radius: 5px 2px 2px 5px;\n    padding: 0 8px;\n    min-width: 28px;\n    box-sizing: border-box;\n\t");
});
var ChildrenContainer$1 = styled.div(templateObject_3$p || (templateObject_3$p = __makeTemplateObject(["\n  flex: 1;\n  display: flex;\n"], ["\n  flex: 1;\n  display: flex;\n"])));
var templateObject_1$1F, templateObject_2$Q, templateObject_3$p;

var BlcInputPrefix = function (_a) {
    var background = _a.background, labelPosition = _a.labelPosition, prefixMargin = _a.prefixMargin, prefix = _a.prefix, children = _a.children, borderColor = _a.borderColor, borderWidth = _a.borderWidth, borderStyle = _a.borderStyle, disabled = _a.disabled, size = _a.size;
    return (jsxs(Container$e, __assign({ labelPosition: labelPosition, borderColor: borderColor, borderWidth: borderWidth, borderStyle: borderStyle, disabled: disabled, size: size }, { children: [jsx(Prefix, __assign({ background: background, prefixMargin: prefixMargin }, { children: prefix })), jsx(ChildrenContainer$1, { children: children })] })));
};

var disabled = "\n  &:disabled, &:disabled:hover, &:disabled:focus {\n    background-color: ".concat(colorFormSurface.colorFormSurfaceDisabled, ";\n    color: ").concat(colorText.colorTextTextDisabled, ";\n    cursor: not-allowed;\n  }\n");
var placeholder = "\n    &::placeholder {\n        color: ".concat(colorText.colorTextTextDisabled, ";\n        font-size: ").concat(fontContent.fontContentDefault, ";\n    }\n");
var getInputBorderColor = function (borderColor, defaultColor) { return getFormBorderColor(borderColor) || defaultColor; };
var getInputBorder = function (props) { return "\n    border-radius: ".concat(props.borderRadius || 0, ";\n    &:focus,\n    :hover {\n      outline: none;\n    }\n\n    ").concat(props.$prefix
    ? "\n        border-width: 0px;\n        "
    : "\n        border-color: ".concat(getInputBorderColor(props.borderColor, colorFormBorder.colorFormBorderDefault), ";\n        border-style: solid;\n        border-width: 1px;\n        &:focus-visible,\n        &:focus,\n        &:hover {\n          border-color: ").concat(getInputBorderColor(props.borderColor, colorBase['colorBrand-500']), ";\n        }\n    "), "\n\n\n\n"); };
var font = "\n    color: ".concat(colorText.colorTextTextPrimary, ";\n    font-family: ").concat(fontFamily, ";\n    font-stretch: normal;\n    font-style: normal;\n    font-size: ").concat(fontContent.fontContentDefault, ";\n    font-weight: ").concat(weightMap$1.regular, ";\n    letter-spacing: normal;\n");
var inputStyles = css(templateObject_1$1E || (templateObject_1$1E = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var borderWidth = _a.borderWidth, borderColor = _a.borderColor, borderRadius = _a.borderRadius, _b = _a.padding, padding = _b === void 0 ? '10px' : _b, paddingLeft = _a.paddingLeft, paddingRight = _a.paddingRight, $prefix = _a.$prefix, width = _a.width, height = _a.height, _c = _a.$size, $size = _c === void 0 ? 'default' : _c;
    return "\n    appearance: none;\n    box-sizing: border-box;\n    box-shadow: none;\n    margin: 0;\n    padding: ".concat(getValue$1(padding), ";\n    padding-left: ").concat(getValue$1(paddingLeft), ";\n    padding-right: ").concat(getValue$1(paddingRight), ";\n    transition: border-color 0.15s;\n    line-height: 1.5;\n    height: ").concat(height ? getSizeValue(height) : INPUT_SIZE[$size], ";\n    width: ").concat(width ? getSizeValue(width) : '100%', ";\n    ").concat(getInputBorder({ borderWidth: borderWidth, $prefix: $prefix, borderRadius: borderRadius, borderColor: borderColor }), "\n    ").concat(font, "\n    ").concat(disabled, "\n    ").concat(placeholder, "\n    &:focus-visible, &.focus {\n      box-shadow: 0px 0px 2px 2px var(--focus);\n    }\n    ");
});
var Input$2 = styled.input(templateObject_2$P || (templateObject_2$P = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), inputStyles);
var templateObject_1$1E, templateObject_2$P;

var InputBase = forwardRef(function (props, ref) { return (jsx(Input$2, __assign({ ref: ref }, props, { "data-form-error": true }))); });
InputBase.displayName = 'Input';
InputBase.defaultProps = {
    borderRadius: 'var(--inputBorderRadius)'
};

/**
 * react-number-format - 4.9.4
 * Author : Sudhanshu Yadav
 * Copyright (c) 2016, 2022 to Sudhanshu Yadav, released under the MIT license.
 * https://github.com/s-yadav/react-number-format
 */

//     

                                                               

// basic noop function
function noop$1() {}
function returnTrue() {
  return true;
}

function charIsNumber(char         ) {
  return !!(char || '').match(/\d/);
}

function isNil(val     ) {
  return val === null || val === undefined;
}

function escapeRegExp(str        ) {
  return str.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');
}

function getThousandsGroupRegex(thousandsGroupStyle        ) {
  switch (thousandsGroupStyle) {
    case 'lakh':
      return /(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g;
    case 'wan':
      return /(\d)(?=(\d{4})+(?!\d))/g;
    case 'thousand':
    default:
      return /(\d)(?=(\d{3})+(?!\d))/g;
  }
}

function applyThousandSeparator(
  str        ,
  thousandSeparator        ,
  thousandsGroupStyle        
) {
  var thousandsGroupRegex = getThousandsGroupRegex(thousandsGroupStyle);
  var index = str.search(/[1-9]/);
  index = index === -1 ? str.length : index;
  return (
    str.substring(0, index) +
    str.substring(index, str.length).replace(thousandsGroupRegex, '$1' + thousandSeparator)
  );
}

//spilt a float number into different parts beforeDecimal, afterDecimal, and negation
function splitDecimal(numStr        , allowNegative) {
  if ( allowNegative === void 0 ) allowNegative          = true;

  var hasNagation = numStr[0] === '-';
  var addNegation = hasNagation && allowNegative;
  numStr = numStr.replace('-', '');

  var parts = numStr.split('.');
  var beforeDecimal = parts[0];
  var afterDecimal = parts[1] || '';

  return {
    beforeDecimal: beforeDecimal,
    afterDecimal: afterDecimal,
    hasNagation: hasNagation,
    addNegation: addNegation,
  };
}

function fixLeadingZero(numStr         ) {
  if (!numStr) { return numStr; }
  var isNegative = numStr[0] === '-';
  if (isNegative) { numStr = numStr.substring(1, numStr.length); }
  var parts = numStr.split('.');
  var beforeDecimal = parts[0].replace(/^0+/, '') || '0';
  var afterDecimal = parts[1] || '';

  return ("" + (isNegative ? '-' : '') + beforeDecimal + (afterDecimal ? ("." + afterDecimal) : ''));
}

/**
 * limit decimal numbers to given scale
 * Not used .fixedTo because that will break with big numbers
 */
function limitToScale(numStr        , scale        , fixedDecimalScale         ) {
  var str = '';
  var filler = fixedDecimalScale ? '0' : '';
  for (var i = 0; i <= scale - 1; i++) {
    str += numStr[i] || filler;
  }
  return str;
}

function repeat(str, count) {
  return Array(count + 1).join(str);
}

function toNumericString(num) {
  num += ''; // typecast number to string

  // store the sign and remove it from the number.
  var sign = num[0] === '-' ? '-' : '';
  if (sign) { num = num.substring(1); }

  // split the number into cofficient and exponent
  var ref = num.split(/[eE]/g);
  var coefficient = ref[0];
  var exponent = ref[1];

  // covert exponent to number;
  exponent = Number(exponent);

  // if there is no exponent part or its 0, return the coffiecient with sign
  if (!exponent) { return sign + coefficient; }

  coefficient = coefficient.replace('.', '');

  /**
   * for scientific notation the current decimal index will be after first number (index 0)
   * So effective decimal index will always be 1 + exponent value
   */
  var decimalIndex = 1 + exponent;

  var coffiecientLn = coefficient.length;

  if (decimalIndex < 0) {
    // if decimal index is less then 0 add preceding 0s
    // add 1 as join will have
    coefficient = '0.' + repeat('0', Math.abs(decimalIndex)) + coefficient;
  } else if (decimalIndex >= coffiecientLn) {
    // if decimal index is less then 0 add leading 0s
    coefficient = coefficient + repeat('0', decimalIndex - coffiecientLn);
  } else {
    // else add decimal point at proper index
    coefficient =
      (coefficient.substring(0, decimalIndex) || '0') + '.' + coefficient.substring(decimalIndex);
  }

  return sign + coefficient;
}

/**
 * This method is required to round prop value to given scale.
 * Not used .round or .fixedTo because that will break with big numbers
 */
function roundToPrecision(numStr        , scale        , fixedDecimalScale         ) {
  //if number is empty don't do anything return empty string
  if (['', '-'].indexOf(numStr) !== -1) { return numStr; }

  var shoudHaveDecimalSeparator = numStr.indexOf('.') !== -1 && scale;
  var ref = splitDecimal(numStr);
  var beforeDecimal = ref.beforeDecimal;
  var afterDecimal = ref.afterDecimal;
  var hasNagation = ref.hasNagation;
  var floatValue = parseFloat(("0." + (afterDecimal || '0')));
  var floatValueStr =
    afterDecimal.length <= scale ? ("0." + afterDecimal) : floatValue.toFixed(scale);
  var roundedDecimalParts = floatValueStr.split('.');
  var intPart = beforeDecimal
    .split('')
    .reverse()
    .reduce(function (roundedStr, current, idx) {
      if (roundedStr.length > idx) {
        return (
          (Number(roundedStr[0]) + Number(current)).toString() +
          roundedStr.substring(1, roundedStr.length)
        );
      }
      return current + roundedStr;
    }, roundedDecimalParts[0]);

  var decimalPart = limitToScale(
    roundedDecimalParts[1] || '',
    Math.min(scale, afterDecimal.length),
    fixedDecimalScale
  );
  var negation = hasNagation ? '-' : '';
  var decimalSeparator = shoudHaveDecimalSeparator ? '.' : '';
  return ("" + negation + intPart + decimalSeparator + decimalPart);
}

/** set the caret positon in an input field **/
function setCaretPosition(el                  , caretPos        ) {
  el.value = el.value;
  // ^ this is used to not only get 'focus', but
  // to make sure we don't have it everything -selected-
  // (it causes an issue in chrome, and having it doesn't hurt any other browser)
  if (el !== null) {
    if (el.createTextRange) {
      var range = el.createTextRange();
      range.move('character', caretPos);
      range.select();
      return true;
    }
    // (el.selectionStart === 0 added for Firefox bug)
    if (el.selectionStart || el.selectionStart === 0) {
      el.focus();
      el.setSelectionRange(caretPos, caretPos);
      return true;
    }

    // fail city, fortunately this never happens (as far as I've tested) :)
    el.focus();
    return false;
  }
}

/**
  Given previous value and newValue it returns the index
  start - end to which values have changed.
  This function makes assumption about only consecutive
  characters are changed which is correct assumption for caret input.
*/
function findChangedIndex(prevValue        , newValue        ) {
  var i = 0,
    j = 0;
  var prevLength = prevValue.length;
  var newLength = newValue.length;
  while (prevValue[i] === newValue[i] && i < prevLength) { i++; }

  //check what has been changed from last
  while (
    prevValue[prevLength - 1 - j] === newValue[newLength - 1 - j] &&
    newLength - j > i &&
    prevLength - j > i
  ) {
    j++;
  }

  return { start: i, end: prevLength - j };
}

/*
  Returns a number whose value is limited to the given range
*/
function clamp$1(num        , min        , max        ) {
  return Math.min(Math.max(num, min), max);
}

function getCurrentCaretPosition(el                  ) {
  /*Max of selectionStart and selectionEnd is taken for the patch of pixel and other mobile device caret bug*/
  return Math.max(el.selectionStart, el.selectionEnd);
}

function addInputMode(format                                   ) {
  return (
    format ||
    (typeof navigator !== 'undefined' &&
      !(navigator.platform && /iPhone|iPod/.test(navigator.platform)))
  );
}

//     
function objectWithoutProperties (obj, exclude) { var target = {}; for (var k in obj) if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k]; return target; }

var defaultProps$6 = {
  displayType: 'input',
  decimalSeparator: '.',
  thousandsGroupStyle: 'thousand',
  fixedDecimalScale: false,
  prefix: '',
  suffix: '',
  allowNegative: true,
  allowEmptyFormatting: false,
  allowLeadingZeros: false,
  isNumericString: false,
  type: 'text',
  onValueChange: noop$1,
  onChange: noop$1,
  onKeyDown: noop$1,
  onMouseUp: noop$1,
  onFocus: noop$1,
  onBlur: noop$1,
  isAllowed: returnTrue,
};
var NumberFormat = /*@__PURE__*/(function (superclass) {
  function NumberFormat(props        ) {
    superclass.call(this, props);
    var defaultValue = props.defaultValue;

    //validate props
    this.validateProps();

    var formattedValue = this.formatValueProp(defaultValue);

    this.state = {
      value: formattedValue,
      numAsString: this.removeFormatting(formattedValue),
      mounted: false,
    };

    this.selectionBeforeInput = {
      selectionStart: 0,
      selectionEnd: 0,
    };

    this.onChange = this.onChange.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onMouseUp = this.onMouseUp.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }

  if ( superclass ) NumberFormat.__proto__ = superclass;
  NumberFormat.prototype = Object.create( superclass && superclass.prototype );
  NumberFormat.prototype.constructor = NumberFormat;

  NumberFormat.prototype.componentDidMount = function componentDidMount () {
    // set mounted state
    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({
      mounted: true,
    });
  };

  NumberFormat.prototype.componentDidUpdate = function componentDidUpdate (prevProps        ) {
    this.updateValueIfRequired(prevProps);
  };

  NumberFormat.prototype.componentWillUnmount = function componentWillUnmount () {
    clearTimeout(this.focusTimeout);
    clearTimeout(this.caretPositionTimeout);
  };

  NumberFormat.prototype.updateValueIfRequired = function updateValueIfRequired (prevProps        ) {
    var ref = this;
    var props = ref.props;
    var state = ref.state;
    var focusedElm = ref.focusedElm;
    var stateValue = state.value;
    var lastNumStr = state.numAsString; if ( lastNumStr === void 0 ) lastNumStr = '';

    // If only state changed no need to do any thing
    if (prevProps !== props) {
      //validate props
      this.validateProps();

      var lastValueWithNewFormat = this.formatNumString(lastNumStr);

      var formattedValue = isNil(props.value) ? lastValueWithNewFormat : this.formatValueProp();
      var numAsString = this.removeFormatting(formattedValue);

      var floatValue = parseFloat(numAsString);
      var lastFloatValue = parseFloat(lastNumStr);

      if (
        //while typing set state only when float value changes
        ((!isNaN(floatValue) || !isNaN(lastFloatValue)) && floatValue !== lastFloatValue) ||
        //can also set state when float value is same and the format props changes
        lastValueWithNewFormat !== stateValue ||
        //set state always when not in focus and formatted value is changed
        (focusedElm === null && formattedValue !== stateValue)
      ) {
        this.updateValue({
          formattedValue: formattedValue,
          numAsString: numAsString,
          input: focusedElm,
          source: 'prop',
          event: null,
        });
      }
    }
  };

  /** Misc methods **/
  NumberFormat.prototype.getFloatString = function getFloatString (num) {
    if ( num === void 0 ) num         = '';

    var ref = this.props;
    var decimalScale = ref.decimalScale;
    var ref$1 = this.getSeparators();
    var decimalSeparator = ref$1.decimalSeparator;
    var numRegex = this.getNumberRegex(true);

    //remove negation for regex check
    var hasNegation = num[0] === '-';
    if (hasNegation) { num = num.replace('-', ''); }

    //if decimal scale is zero remove decimal and number after decimalSeparator
    if (decimalSeparator && decimalScale === 0) {
      num = num.split(decimalSeparator)[0];
    }

    num = (num.match(numRegex) || []).join('').replace(decimalSeparator, '.');

    //remove extra decimals
    var firstDecimalIndex = num.indexOf('.');

    if (firstDecimalIndex !== -1) {
      num = (num.substring(0, firstDecimalIndex)) + "." + (num
        .substring(firstDecimalIndex + 1, num.length)
        .replace(new RegExp(escapeRegExp(decimalSeparator), 'g'), ''));
    }

    //add negation back
    if (hasNegation) { num = '-' + num; }

    return num;
  };

  //returned regex assumes decimalSeparator is as per prop
  NumberFormat.prototype.getNumberRegex = function getNumberRegex (g         , ignoreDecimalSeparator          ) {
    var ref = this.props;
    var format = ref.format;
    var decimalScale = ref.decimalScale;
    var customNumerals = ref.customNumerals;
    var ref$1 = this.getSeparators();
    var decimalSeparator = ref$1.decimalSeparator;
    return new RegExp(
      '[0-9' +
        (customNumerals ? customNumerals.join('') : '') +
        ']' +
        (decimalSeparator && decimalScale !== 0 && !ignoreDecimalSeparator && !format
          ? '|' + escapeRegExp(decimalSeparator)
          : ''),
      g ? 'g' : undefined
    );
  };

  NumberFormat.prototype.getSeparators = function getSeparators () {
    var ref = this.props;
    var decimalSeparator = ref.decimalSeparator;
    var ref$1 = this.props;
    var thousandSeparator = ref$1.thousandSeparator;
    var allowedDecimalSeparators = ref$1.allowedDecimalSeparators;

    if (thousandSeparator === true) {
      thousandSeparator = ',';
    }
    if (!allowedDecimalSeparators) {
      allowedDecimalSeparators = [decimalSeparator, '.'];
    }

    return {
      decimalSeparator: decimalSeparator,
      thousandSeparator: thousandSeparator,
      allowedDecimalSeparators: allowedDecimalSeparators,
    };
  };

  NumberFormat.prototype.getMaskAtIndex = function getMaskAtIndex (index        ) {
    var ref = this.props;
    var mask = ref.mask; if ( mask === void 0 ) mask = ' ';
    if (typeof mask === 'string') {
      return mask;
    }

    return mask[index] || ' ';
  };

  NumberFormat.prototype.getValueObject = function getValueObject (formattedValue        , numAsString        ) {
    var floatValue = parseFloat(numAsString);

    return {
      formattedValue: formattedValue,
      value: numAsString,
      floatValue: isNaN(floatValue) ? undefined : floatValue,
    };
  };

  NumberFormat.prototype.validateProps = function validateProps () {
    var ref = this.props;
    var mask = ref.mask;

    //validate decimalSeparator and thousandSeparator
    var ref$1 = this.getSeparators();
    var decimalSeparator = ref$1.decimalSeparator;
    var thousandSeparator = ref$1.thousandSeparator;

    if (decimalSeparator === thousandSeparator) {
      throw new Error(("\n          Decimal separator can't be same as thousand separator.\n          thousandSeparator: " + thousandSeparator + " (thousandSeparator = {true} is same as thousandSeparator = \",\")\n          decimalSeparator: " + decimalSeparator + " (default value for decimalSeparator is .)\n       "));
    }

    //validate mask
    if (mask) {
      var maskAsStr = mask === 'string' ? mask : mask.toString();
      if (maskAsStr.match(/\d/g)) {
        throw new Error(("\n          Mask " + mask + " should not contain numeric character;\n        "));
      }
    }
  };
  /** Misc methods end **/

  /** caret specific methods **/
  NumberFormat.prototype.setPatchedCaretPosition = function setPatchedCaretPosition (el                  , caretPos        , currentValue        ) {
    /* setting caret position within timeout of 0ms is required for mobile chrome,
    otherwise browser resets the caret position after we set it
    We are also setting it without timeout so that in normal browser we don't see the flickering */
    setCaretPosition(el, caretPos);
    this.caretPositionTimeout = setTimeout(function () {
      if (el.value === currentValue) { setCaretPosition(el, caretPos); }
    }, 0);
  };

  /* This keeps the caret within typing area so people can't type in between prefix or suffix */
  NumberFormat.prototype.correctCaretPosition = function correctCaretPosition (value        , caretPos        , direction         ) {
    var ref = this.props;
    var prefix = ref.prefix;
    var suffix = ref.suffix;
    var format = ref.format;

    //if value is empty return 0
    if (value === '') { return 0; }

    //caret position should be between 0 and value length
    caretPos = clamp$1(caretPos, 0, value.length);

    //in case of format as number limit between prefix and suffix
    if (!format) {
      var hasNegation = value[0] === '-';
      return clamp$1(caretPos, prefix.length + (hasNegation ? 1 : 0), value.length - suffix.length);
    }

    //in case if custom format method don't do anything
    if (typeof format === 'function') { return caretPos; }

    /* in case format is string find the closest # position from the caret position */

    //in case the caretPos have input value on it don't do anything
    if (format[caretPos] === '#' && charIsNumber(value[caretPos])) {
      return caretPos;
    }

    //if caretPos is just after input value don't do anything
    if (format[caretPos - 1] === '#' && charIsNumber(value[caretPos - 1])) {
      return caretPos;
    }

    //find the nearest caret position
    var firstHashPosition = format.indexOf('#');
    var lastHashPosition = format.lastIndexOf('#');

    //limit the cursor between the first # position and the last # position
    caretPos = clamp$1(caretPos, firstHashPosition, lastHashPosition + 1);

    var nextPos = format.substring(caretPos, format.length).indexOf('#');
    var caretLeftBound = caretPos;
    var caretRightBound = caretPos + (nextPos === -1 ? 0 : nextPos);

    //get the position where the last number is present
    while (
      caretLeftBound > firstHashPosition &&
      (format[caretLeftBound] !== '#' || !charIsNumber(value[caretLeftBound]))
    ) {
      caretLeftBound -= 1;
    }

    var goToLeft =
      !charIsNumber(value[caretRightBound]) ||
      (direction === 'left' && caretPos !== firstHashPosition) ||
      caretPos - caretLeftBound < caretRightBound - caretPos;

    if (goToLeft) {
      //check if number should be taken after the bound or after it
      //if number preceding a valid number keep it after
      return charIsNumber(value[caretLeftBound]) ? caretLeftBound + 1 : caretLeftBound;
    }

    return caretRightBound;
  };

  NumberFormat.prototype.getCaretPosition = function getCaretPosition (inputValue        , formattedValue        , caretPos        ) {
    var ref = this.props;
    var format = ref.format;
    var stateValue = this.state.value;
    var numRegex = this.getNumberRegex(true);
    var inputNumber = (inputValue.match(numRegex) || []).join('');
    var formattedNumber = (formattedValue.match(numRegex) || []).join('');
    var j, i;

    j = 0;

    for (i = 0; i < caretPos; i++) {
      var currentInputChar = inputValue[i] || '';
      var currentFormatChar = formattedValue[j] || '';
      //no need to increase new cursor position if formatted value does not have those characters
      //case inputValue = 1a23 and formattedValue =  123
      if (!currentInputChar.match(numRegex) && currentInputChar !== currentFormatChar) {
        continue;
      }

      //When we are striping out leading zeros maintain the new cursor position
      //Case inputValue = 00023 and formattedValue = 23;
      if (
        currentInputChar === '0' &&
        currentFormatChar.match(numRegex) &&
        currentFormatChar !== '0' &&
        inputNumber.length !== formattedNumber.length
      ) {
        continue;
      }

      //we are not using currentFormatChar because j can change here
      while (currentInputChar !== formattedValue[j] && j < formattedValue.length) {
        j++;
      }
      j++;
    }

    if (typeof format === 'string' && !stateValue) {
      //set it to the maximum value so it goes after the last number
      j = formattedValue.length;
    }

    //correct caret position if its outside of editable area
    j = this.correctCaretPosition(formattedValue, j);

    return j;
  };
  /** caret specific methods ends **/

  /** methods to remove formattting **/
  NumberFormat.prototype.removePrefixAndSuffix = function removePrefixAndSuffix (val        ) {
    var ref = this.props;
    var format = ref.format;
    var prefix = ref.prefix;
    var suffix = ref.suffix;

    //remove prefix and suffix
    if (!format && val) {
      var isNegative = val[0] === '-';

      //remove negation sign
      if (isNegative) { val = val.substring(1, val.length); }

      //remove prefix
      val = prefix && val.indexOf(prefix) === 0 ? val.substring(prefix.length, val.length) : val;

      //remove suffix
      var suffixLastIndex = val.lastIndexOf(suffix);
      val =
        suffix && suffixLastIndex !== -1 && suffixLastIndex === val.length - suffix.length
          ? val.substring(0, suffixLastIndex)
          : val;

      //add negation sign back
      if (isNegative) { val = '-' + val; }
    }

    return val;
  };

  NumberFormat.prototype.removePatternFormatting = function removePatternFormatting (val        ) {
    var ref = this.props;
    var format = ref.format;
    var formatArray = format.split('#').filter(function (str) { return str !== ''; });
    var start = 0;
    var numStr = '';

    for (var i = 0, ln = formatArray.length; i <= ln; i++) {
      var part = formatArray[i] || '';

      //if i is the last fragment take the index of end of the value
      //For case like +1 (911) 911 91 91 having pattern +1 (###) ### ## ##
      var index = i === ln ? val.length : val.indexOf(part, start);

      /* in any case if we don't find the pattern part in the value assume the val as numeric string
      This will be also in case if user has started typing, in any other case it will not be -1
      unless wrong prop value is provided */
      if (index === -1) {
        numStr = val;
        break;
      } else {
        numStr += val.substring(start, index);
        start = index + part.length;
      }
    }

    return (numStr.match(this.getNumberRegex(true)) || []).join('');
  };

  NumberFormat.prototype.removeFormatting = function removeFormatting (val        ) {
    var ref = this.props;
    var format = ref.format;
    var removeFormatting = ref.removeFormatting;
    if (!val) { return val; }

    if (!format) {
      val = this.removePrefixAndSuffix(val);
      val = this.getFloatString(val);
    } else if (typeof format === 'string') {
      val = this.removePatternFormatting(val);
    } else if (typeof removeFormatting === 'function') {
      //condition need to be handled if format method is provide,
      val = removeFormatting(val);
    } else {
      val = (val.match(this.getNumberRegex(true)) || []).join('');
    }
    return val;
  };
  /** methods to remove formattting end **/

  /*** format specific methods start ***/
  /**
   * Format when # based string is provided
   * @param  {string} numStr Numeric String
   * @return {string}        formatted Value
   */
  NumberFormat.prototype.formatWithPattern = function formatWithPattern (numStr        ) {
    var ref = this.props;
    var format = ref.format;
    var hashCount = 0;
    var formattedNumberAry = format.split('');
    for (var i = 0, ln = format.length; i < ln; i++) {
      if (format[i] === '#') {
        formattedNumberAry[i] = numStr[hashCount] || this.getMaskAtIndex(hashCount);
        hashCount += 1;
      }
    }
    return formattedNumberAry.join('');
  };
  /**
   * @param  {string} numStr Numeric string/floatString] It always have decimalSeparator as .
   * @return {string} formatted Value
   */
  NumberFormat.prototype.formatAsNumber = function formatAsNumber (numStr        ) {
    var ref = this.props;
    var decimalScale = ref.decimalScale;
    var fixedDecimalScale = ref.fixedDecimalScale;
    var prefix = ref.prefix;
    var suffix = ref.suffix;
    var allowNegative = ref.allowNegative;
    var thousandsGroupStyle = ref.thousandsGroupStyle;
    var ref$1 = this.getSeparators();
    var thousandSeparator = ref$1.thousandSeparator;
    var decimalSeparator = ref$1.decimalSeparator;

    var hasDecimalSeparator = numStr.indexOf('.') !== -1 || (decimalScale && fixedDecimalScale);
    var ref$2 = splitDecimal(numStr, allowNegative);
    var beforeDecimal = ref$2.beforeDecimal;
    var afterDecimal = ref$2.afterDecimal;
    var addNegation = ref$2.addNegation; // eslint-disable-line prefer-const

    //apply decimal precision if its defined
    if (decimalScale !== undefined) {
      afterDecimal = limitToScale(afterDecimal, decimalScale, fixedDecimalScale);
    }

    if (thousandSeparator) {
      beforeDecimal = applyThousandSeparator(beforeDecimal, thousandSeparator, thousandsGroupStyle);
    }

    //add prefix and suffix
    if (prefix) { beforeDecimal = prefix + beforeDecimal; }
    if (suffix) { afterDecimal = afterDecimal + suffix; }

    //restore negation sign
    if (addNegation) { beforeDecimal = '-' + beforeDecimal; }

    numStr = beforeDecimal + ((hasDecimalSeparator && decimalSeparator) || '') + afterDecimal;

    return numStr;
  };

  NumberFormat.prototype.formatNumString = function formatNumString (numStr) {
    if ( numStr === void 0 ) numStr         = '';

    var ref = this.props;
    var format = ref.format;
    var allowEmptyFormatting = ref.allowEmptyFormatting;
    var customNumerals = ref.customNumerals;
    var formattedValue = numStr;

    if (customNumerals && customNumerals.length === 10) {
      var customNumeralRegex = new RegExp('[' + customNumerals.join('') + ']', 'g');
      formattedValue = numStr.replace(customNumeralRegex, function (digit) { return customNumerals.indexOf(digit).toString(); }
      );
    }

    if (numStr === '' && !allowEmptyFormatting) {
      formattedValue = '';
    } else if (numStr === '-' && !format) {
      formattedValue = '-';
    } else if (typeof format === 'string') {
      formattedValue = this.formatWithPattern(formattedValue);
    } else if (typeof format === 'function') {
      formattedValue = format(formattedValue);
    } else {
      formattedValue = this.formatAsNumber(formattedValue);
    }

    return formattedValue;
  };

  NumberFormat.prototype.formatValueProp = function formatValueProp (defaultValue                 ) {
    var ref = this.props;
    var format = ref.format;
    var decimalScale = ref.decimalScale;
    var fixedDecimalScale = ref.fixedDecimalScale;
    var allowEmptyFormatting = ref.allowEmptyFormatting;
    var ref$1 = this.props;
    var value = ref$1.value;
    var isNumericString = ref$1.isNumericString;

    // if value is undefined or null, use defaultValue instead
    value = isNil(value) ? defaultValue : value;

    var isNonNumericFalsy = !value && value !== 0;

    if (isNonNumericFalsy && allowEmptyFormatting) {
      value = '';
    }

    // if value is not defined return empty string
    if (isNonNumericFalsy && !allowEmptyFormatting) { return ''; }

    if (typeof value === 'number') {
      value = toNumericString(value);
      isNumericString = true;
    }

    //change infinity value to empty string
    if (value === 'Infinity' && isNumericString) {
      value = '';
    }

    //round the number based on decimalScale
    //format only if non formatted value is provided
    if (isNumericString && !format && typeof decimalScale === 'number') {
      value = roundToPrecision(value, decimalScale, fixedDecimalScale);
    }

    var formattedValue = isNumericString ? this.formatNumString(value) : this.formatInput(value);

    return formattedValue;
  };

  NumberFormat.prototype.formatNegation = function formatNegation (value) {
    if ( value === void 0 ) value         = '';

    var ref = this.props;
    var allowNegative = ref.allowNegative;
    var negationRegex = new RegExp('(-)');
    var doubleNegationRegex = new RegExp('(-)(.)*(-)');

    // Check number has '-' value
    var hasNegation = negationRegex.test(value);

    // Check number has 2 or more '-' values
    var removeNegation = doubleNegationRegex.test(value);

    //remove negation
    value = value.replace(/-/g, '');

    if (hasNegation && !removeNegation && allowNegative) {
      value = '-' + value;
    }

    return value;
  };

  NumberFormat.prototype.formatInput = function formatInput (value) {
    if ( value === void 0 ) value         = '';

    var ref = this.props;
    var format = ref.format;

    //format negation only if we are formatting as number
    if (!format) {
      value = this.removePrefixAndSuffix(value);
      value = this.formatNegation(value);
    }

    //remove formatting from number
    value = this.removeFormatting(value);

    return this.formatNumString(value);
  };

  /*** format specific methods end ***/
  NumberFormat.prototype.isCharacterAFormat = function isCharacterAFormat (caretPos        , value        ) {
    var ref = this.props;
    var format = ref.format;
    var prefix = ref.prefix;
    var suffix = ref.suffix;
    var decimalScale = ref.decimalScale;
    var fixedDecimalScale = ref.fixedDecimalScale;
    var ref$1 = this.getSeparators();
    var decimalSeparator = ref$1.decimalSeparator;

    //check within format pattern
    if (typeof format === 'string' && format[caretPos] !== '#') { return true; }

    //check in number format
    if (
      !format &&
      (caretPos < prefix.length ||
        caretPos >= value.length - suffix.length ||
        (decimalScale && fixedDecimalScale && value[caretPos] === decimalSeparator))
    ) {
      return true;
    }

    return false;
  };

  /**
   * This will check if any formatting got removed by the delete or backspace and reset the value
   * It will also work as fallback if android chome keyDown handler does not work
   **/
  NumberFormat.prototype.correctInputValue = function correctInputValue (caretPos        , lastValue        , value        ) {
    var this$1$1 = this;

    var ref = this.props;
    var format = ref.format;
    var allowNegative = ref.allowNegative;
    var prefix = ref.prefix;
    var suffix = ref.suffix;
    var decimalScale = ref.decimalScale;
    var ref$1 = this.getSeparators();
    var allowedDecimalSeparators = ref$1.allowedDecimalSeparators;
    var decimalSeparator = ref$1.decimalSeparator;
    var lastNumStr = this.state.numAsString || '';
    var ref$2 = this.selectionBeforeInput;
    var selectionStart = ref$2.selectionStart;
    var selectionEnd = ref$2.selectionEnd;
    var ref$3 = findChangedIndex(lastValue, value);
    var start = ref$3.start;
    var end = ref$3.end;

    /** Check for any allowed decimal separator is added in the numeric format and replace it with decimal separator */
    if (
      !format &&
      start === end &&
      allowedDecimalSeparators.indexOf(value[selectionStart]) !== -1
    ) {
      var separator = decimalScale === 0 ? '' : decimalSeparator;
      return (
        value.substr(0, selectionStart) + separator + value.substr(selectionStart + 1, value.length)
      );
    }

    var leftBound = !!format ? 0 : prefix.length;
    var rightBound = lastValue.length - (!!format ? 0 : suffix.length);

    if (
      // don't do anything if something got added
      value.length > lastValue.length ||
      // or if the new value is an empty string
      !value.length ||
      // or if nothing has changed, in which case start will be same as end
      start === end ||
      // or in case if whole input is selected and new value is typed
      (selectionStart === 0 && selectionEnd === lastValue.length) ||
      // or in case if the whole content is replaced by browser, example (autocomplete)
      (start === 0 && end === lastValue.length) ||
      // or if charcters between prefix and suffix is selected.
      // For numeric inputs we apply the format so, prefix and suffix can be ignored
      (selectionStart === leftBound && selectionEnd === rightBound)
    ) {
      return value;
    }

    // check whether the deleted portion has a character that is part of a format
    var deletedValues = lastValue.substr(start, end - start);
    var formatGotDeleted = !![].concat( deletedValues ).find(function (deletedVal, idx) { return this$1$1.isCharacterAFormat(idx + start, lastValue); }
    );

    // if it has, only remove characters that are not part of the format
    if (formatGotDeleted) {
      var deletedValuePortion = lastValue.substr(start);
      var recordIndexOfFormatCharacters = {};
      var resolvedPortion = [];
      [].concat( deletedValuePortion ).forEach(function (currentPortion, idx) {
        if (this$1$1.isCharacterAFormat(idx + start, lastValue)) {
          recordIndexOfFormatCharacters[idx] = currentPortion;
        } else if (idx > deletedValues.length - 1) {
          resolvedPortion.push(currentPortion);
        }
      });

      Object.keys(recordIndexOfFormatCharacters).forEach(function (idx) {
        if (resolvedPortion.length > idx) {
          resolvedPortion.splice(idx, 0, recordIndexOfFormatCharacters[idx]);
        } else {
          resolvedPortion.push(recordIndexOfFormatCharacters[idx]);
        }
      });

      value = lastValue.substr(0, start) + resolvedPortion.join('');
    }

    //for numbers check if beforeDecimal got deleted and there is nothing after decimal,
    //clear all numbers in such case while keeping the - sign
    if (!format) {
      var numericString = this.removeFormatting(value);
      var ref$4 = splitDecimal(
        numericString,
        allowNegative
      );
      var beforeDecimal = ref$4.beforeDecimal;
      var afterDecimal = ref$4.afterDecimal;
      var addNegation = ref$4.addNegation; // eslint-disable-line prefer-const

      //clear only if something got deleted
      var isBeforeDecimalPoint = caretPos < value.indexOf(decimalSeparator) + 1;
      if (
        numericString.length < lastNumStr.length &&
        isBeforeDecimalPoint &&
        beforeDecimal === '' &&
        !parseFloat(afterDecimal)
      ) {
        return addNegation ? '-' : '';
      }
    }

    return value;
  };

  /** Update value and caret position */
  NumberFormat.prototype.updateValue = function updateValue (params   
                           
                        
                       
                            
                               
                   
                     
                              
   ) {
    var formattedValue = params.formattedValue;
    var input = params.input;
    var setCaretPosition = params.setCaretPosition; if ( setCaretPosition === void 0 ) setCaretPosition = true;
    var source = params.source;
    var event = params.event;
    var numAsString = params.numAsString;
    var caretPos = params.caretPos;
    var ref = this.props;
    var onValueChange = ref.onValueChange;
    var ref$1 = this.state;
    var lastValue = ref$1.value;

    if (input) {
      //calculate caret position if not defined
      if (caretPos === undefined && setCaretPosition) {
        var inputValue = params.inputValue || input.value;

        var currentCaretPosition = getCurrentCaretPosition(input);

        /**
         * set the value imperatively, this is required for IE fix
         * This is also required as if new caret position is beyond the previous value.
         * Caret position will not be set correctly
         */
        input.value = formattedValue;

        //get the caret position
        caretPos = this.getCaretPosition(inputValue, formattedValue, currentCaretPosition);
      }

      /**
       * set the value imperatively, as we set the caret position as well imperatively.
       * This is to keep value and caret position in sync
       */
      input.value = formattedValue;

      //set caret position, and value imperatively when element is provided
      if (setCaretPosition) {
        //set caret position
        this.setPatchedCaretPosition(input, caretPos, formattedValue);
      }
    }

    //calculate numeric string if not passed
    if (numAsString === undefined) {
      numAsString = this.removeFormatting(formattedValue);
    }

    //update state if value is changed
    if (formattedValue !== lastValue) {
      this.setState({ value: formattedValue, numAsString: numAsString });

      // trigger onValueChange synchronously, so parent is updated along with the number format. Fix for #277, #287
      onValueChange(this.getValueObject(formattedValue, numAsString), { event: event, source: source });
    }
  };

  NumberFormat.prototype.onChange = function onChange (e                     ) {
    var el = e.target;
    var inputValue = el.value;
    var ref = this;
    var state = ref.state;
    var props = ref.props;
    var isAllowed = props.isAllowed;
    var lastValue = state.value || '';

    var currentCaretPosition = getCurrentCaretPosition(el);

    inputValue = this.correctInputValue(currentCaretPosition, lastValue, inputValue);

    var formattedValue = this.formatInput(inputValue) || '';
    var numAsString = this.removeFormatting(formattedValue);

    var valueObj = this.getValueObject(formattedValue, numAsString);
    var isChangeAllowed = isAllowed(valueObj);

    if (!isChangeAllowed) {
      formattedValue = lastValue;
    }

    this.updateValue({
      formattedValue: formattedValue,
      numAsString: numAsString,
      inputValue: inputValue,
      input: el,
      event: e,
      source: 'event',
    });

    if (isChangeAllowed) {
      props.onChange(e);
    }
  };

  NumberFormat.prototype.onBlur = function onBlur (e                     ) {
    var ref = this;
    var props = ref.props;
    var state = ref.state;
    var format = props.format;
    var onBlur = props.onBlur;
    var allowLeadingZeros = props.allowLeadingZeros;
    var numAsString = state.numAsString;
    var lastValue = state.value;
    this.focusedElm = null;

    clearTimeout(this.focusTimeout);
    clearTimeout(this.caretPositionTimeout);

    if (!format) {
      // if the numAsString is not a valid number reset it to empty
      if (isNaN(parseFloat(numAsString))) {
        numAsString = '';
      }

      if (!allowLeadingZeros) {
        numAsString = fixLeadingZero(numAsString);
      }

      var formattedValue = this.formatNumString(numAsString);

      //change the state
      if (formattedValue !== lastValue) {
        // the event needs to be persisted because its properties can be accessed in an asynchronous way
        this.updateValue({
          formattedValue: formattedValue,
          numAsString: numAsString,
          input: e.target,
          setCaretPosition: false,
          event: e,
          source: 'event',
        });
        onBlur(e);
        return;
      }
    }
    onBlur(e);
  };

  NumberFormat.prototype.onKeyDown = function onKeyDown (e                             ) {
    var el = e.target;
    var key = e.key;
    var selectionStart = el.selectionStart;
    var selectionEnd = el.selectionEnd;
    var value = el.value; if ( value === void 0 ) value = '';
    var expectedCaretPosition;
    var ref = this.props;
    var decimalScale = ref.decimalScale;
    var fixedDecimalScale = ref.fixedDecimalScale;
    var prefix = ref.prefix;
    var suffix = ref.suffix;
    var format = ref.format;
    var onKeyDown = ref.onKeyDown;
    var ignoreDecimalSeparator = decimalScale !== undefined && fixedDecimalScale;
    var numRegex = this.getNumberRegex(false, ignoreDecimalSeparator);
    var negativeRegex = new RegExp('-');
    var isPatternFormat = typeof format === 'string';

    this.selectionBeforeInput = {
      selectionStart: selectionStart,
      selectionEnd: selectionEnd,
    };

    //Handle backspace and delete against non numerical/decimal characters or arrow keys
    if (key === 'ArrowLeft' || key === 'Backspace') {
      expectedCaretPosition = selectionStart - 1;
    } else if (key === 'ArrowRight') {
      expectedCaretPosition = selectionStart + 1;
    } else if (key === 'Delete') {
      expectedCaretPosition = selectionStart;
    }

    //if expectedCaretPosition is not set it means we don't want to Handle keyDown
    //also if multiple characters are selected don't handle
    if (expectedCaretPosition === undefined || selectionStart !== selectionEnd) {
      onKeyDown(e);
      return;
    }

    var newCaretPosition = expectedCaretPosition;
    var leftBound = isPatternFormat ? format.indexOf('#') : prefix.length;
    var rightBound = isPatternFormat ? format.lastIndexOf('#') + 1 : value.length - suffix.length;

    if (key === 'ArrowLeft' || key === 'ArrowRight') {
      var direction = key === 'ArrowLeft' ? 'left' : 'right';
      newCaretPosition = this.correctCaretPosition(value, expectedCaretPosition, direction);
    } else if (
      key === 'Delete' &&
      !numRegex.test(value[expectedCaretPosition]) &&
      !negativeRegex.test(value[expectedCaretPosition])
    ) {
      while (!numRegex.test(value[newCaretPosition]) && newCaretPosition < rightBound) {
        newCaretPosition++;
      }
    } else if (key === 'Backspace' && !numRegex.test(value[expectedCaretPosition])) {
      /* NOTE: This is special case when backspace is pressed on a
      negative value while the cursor position is after prefix. We can't handle it on onChange because
      we will not have any information of keyPress
      */
      if (selectionStart <= leftBound + 1 && value[0] === '-' && typeof format === 'undefined') {
        var newValue = value.substring(1);
        this.updateValue({
          formattedValue: newValue,
          caretPos: newCaretPosition,
          input: el,
          event: e,
          source: 'event',
        });
      } else if (!negativeRegex.test(value[expectedCaretPosition])) {
        while (!numRegex.test(value[newCaretPosition - 1]) && newCaretPosition > leftBound) {
          newCaretPosition--;
        }
        newCaretPosition = this.correctCaretPosition(value, newCaretPosition, 'left');
      }
    }

    if (
      newCaretPosition !== expectedCaretPosition ||
      expectedCaretPosition < leftBound ||
      expectedCaretPosition > rightBound
    ) {
      e.preventDefault();
      this.setPatchedCaretPosition(el, newCaretPosition, value);
    }

    /* NOTE: this is just required for unit test as we need to get the newCaretPosition,
            Remove this when you find different solution */
    if (e.isUnitTestRun) {
      this.setPatchedCaretPosition(el, newCaretPosition, value);
    }

    onKeyDown(e);
  };

  /** required to handle the caret position when click anywhere within the input **/
  NumberFormat.prototype.onMouseUp = function onMouseUp (e                          ) {
    var el = e.target;

    /**
     * NOTE: we have to give default value for value as in case when custom input is provided
     * value can come as undefined when nothing is provided on value prop.
     */
    var selectionStart = el.selectionStart;
    var selectionEnd = el.selectionEnd;
    var value = el.value; if ( value === void 0 ) value = '';

    if (selectionStart === selectionEnd) {
      var caretPosition = this.correctCaretPosition(value, selectionStart);
      if (caretPosition !== selectionStart) {
        this.setPatchedCaretPosition(el, caretPosition, value);
      }
    }

    this.props.onMouseUp(e);
  };

  NumberFormat.prototype.onFocus = function onFocus (e                     ) {
    var this$1$1 = this;

    // Workaround Chrome and Safari bug https://bugs.chromium.org/p/chromium/issues/detail?id=779328
    // (onFocus event target selectionStart is always 0 before setTimeout)
    e.persist();

    this.focusedElm = e.target;
    this.focusTimeout = setTimeout(function () {
      var el = e.target;
      var selectionStart = el.selectionStart;
      var selectionEnd = el.selectionEnd;
      var value = el.value; if ( value === void 0 ) value = '';

      var caretPosition = this$1$1.correctCaretPosition(value, selectionStart);

      //setPatchedCaretPosition only when everything is not selected on focus (while tabbing into the field)
      if (
        caretPosition !== selectionStart &&
        !(selectionStart === 0 && selectionEnd === value.length)
      ) {
        this$1$1.setPatchedCaretPosition(el, caretPosition, value);
      }

      this$1$1.props.onFocus(e);
    }, 0);
  };

  NumberFormat.prototype.render = function render () {
    var ref = this.props;
    var type = ref.type;
    var displayType = ref.displayType;
    var customInput = ref.customInput;
    var renderText = ref.renderText;
    var getInputRef = ref.getInputRef;
    var format = ref.format;
    ref.thousandSeparator;
    ref.decimalSeparator;
    ref.allowedDecimalSeparators;
    ref.thousandsGroupStyle;
    ref.decimalScale;
    ref.fixedDecimalScale;
    ref.prefix;
    ref.suffix;
    ref.removeFormatting;
    ref.mask;
    ref.defaultValue;
    ref.isNumericString;
    ref.allowNegative;
    ref.allowEmptyFormatting;
    ref.allowLeadingZeros;
    ref.onValueChange;
    ref.isAllowed;
    ref.customNumerals;
    ref.onChange;
    ref.onKeyDown;
    ref.onMouseUp;
    ref.onFocus;
    ref.onBlur;
    ref.value;
    var rest = objectWithoutProperties( ref, ["type", "displayType", "customInput", "renderText", "getInputRef", "format", "thousandSeparator", "decimalSeparator", "allowedDecimalSeparators", "thousandsGroupStyle", "decimalScale", "fixedDecimalScale", "prefix", "suffix", "removeFormatting", "mask", "defaultValue", "isNumericString", "allowNegative", "allowEmptyFormatting", "allowLeadingZeros", "onValueChange", "isAllowed", "customNumerals", "onChange", "onKeyDown", "onMouseUp", "onFocus", "onBlur", "value"] );
    var otherProps = rest;
    var ref$1 = this.state;
    var value = ref$1.value;
    var mounted = ref$1.mounted;

    // add input mode on element based on format prop and device once the component is mounted
    var inputMode = mounted && addInputMode(format) ? 'numeric' : undefined;

    var inputProps = Object.assign({ inputMode: inputMode }, otherProps, {
      type: type,
      value: value,
      onChange: this.onChange,
      onKeyDown: this.onKeyDown,
      onMouseUp: this.onMouseUp,
      onFocus: this.onFocus,
      onBlur: this.onBlur,
    });

    if (displayType === 'text') {
      return renderText ? (
        renderText(value, otherProps) || null
      ) : (
        React__default.createElement( 'span', Object.assign({}, otherProps, { ref: getInputRef }),
          value
        )
      );
    } else if (customInput) {
      var CustomInput = customInput;
      return React__default.createElement( CustomInput, Object.assign({}, inputProps, { ref: getInputRef }));
    }

    return React__default.createElement( 'input', Object.assign({}, inputProps, { ref: getInputRef }));
  };

  return NumberFormat;
}(React__default.Component));

NumberFormat.defaultProps = defaultProps$6;

var multipleOf50 = function (value) { return !value || value >= 3000 || value % 50 === 0; };
var multipleOf100 = function (value) { return !value || value < 3000 || value % 100 === 0; };

var formatAmount = function (value) {
    return parseFloat(value.toString().replace(/,/g, ''));
};

var InputAmountWrapper = styled.div(templateObject_1$1D || (templateObject_1$1D = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n"])));
var templateObject_1$1D;

var InputAmount = function (props) { return (jsx(InputBase, __assign({}, props, { borderWidth: "0", padding: "10px", borderRadius: "0" }))); };
var BlcInputAmount = function (_a) {
    var name = _a.name, _b = _a.prefix, prefix = _b === void 0 ? '$' : _b, _c = _a.prefixBackground, prefixBackground = _c === void 0 ? 'grayLight' : _c, control = _a.control, errors = _a.errors, _d = _a.isRequired, isRequired = _d === void 0 ? false : _d, _e = _a.validateMultiples, validateMultiples = _e === void 0 ? false : _e, placeholder = _a.placeholder, maxLength = _a.maxLength, disabled = _a.disabled;
    return (jsxs(InputAmountWrapper, { children: [jsx(BlcInputPrefix, __assign({ prefix: prefix, background: prefixBackground, labelPosition: null }, { children: jsx(Controller, { control: control, name: name, render: function (_a) {
                        var _b = _a.field, onChange = _b.onChange, name = _b.name, value = _b.value;
                        return (jsx(NumberFormat, { name: name, value: value, onChange: onChange, customInput: InputAmount, placeholder: placeholder, maxLength: maxLength, disabled: disabled, thousandSeparator: true }));
                    }, rules: {
                        validate: __assign({ required: function (value) { return (isRequired && !value ? 'Required' : true); } }, (validateMultiples
                            ? {
                                multipleOf100: function (value) { return multipleOf100(formatAmount(value)) || 'Please enter a multiple of 100'; },
                                multipleOf50: function (value) { return multipleOf50(formatAmount(value)) || 'Please enter a multiple of 50'; }
                            }
                            : {}))
                    } }) })), jsx(BlcErrorMessage, { errors: errors, name: name })] }));
};

var getAvatarSize = function (size, mediaSize, type) {
    return getSize$2({
        tag: 'avatar',
        defaultValue: 'full',
        name: size,
        media: mediaSize,
        type: type || 'size'
    });
};
var getAvatarSizeMXL = function (size) {
    return getAvatarSize(size, 'mxl');
};
var getAvatarSizeML = function (size) {
    return getAvatarSize(size, 'ml');
};
var getAvatarSizeMS = function (size) {
    return getAvatarSize(size, 'ms');
};
var getAvatarSizeMXS = function (size) {
    return getAvatarSize(size, 'mxs');
};

var getIconSize = function (size, mediaSize) {
    return getSize$2({
        tag: 'icon',
        defaultValue: 'full',
        name: size,
        media: mediaSize
    });
};
/**
 * Icons
 */
var getIconSizeMXL = function (size) {
    return getIconSize(size, 'mxl');
};
/* Media queries: */
var getIconSizeML = function (size) {
    return getIconSize(size, 'ml');
};
var getIconSizeMS = function (size) {
    return getIconSize(size, 'ms');
};
var getIconSizeMXS = function (size) {
    return getIconSize(size, 'mxs');
};

var iconState = {
    state: {
        default: '400',
        active: '700'
    }
};

({
    BlcIconInactive: __assign({ icon: '23F8' }, iconState),
    BlcIconBuy: __assign({ icon: '0024' }, iconState),
    BlcIconListing: __assign({ icon: '1F697' }, iconState),
    BlcIconTrade: __assign({ icon: '1F501' }, iconState),
    BlcIconSell: __assign({ icon: '1F511' }, iconState),
    BlcIconMore: __assign({ icon: '2026' }, iconState),
    BlcIconHelp: __assign({ icon: '2139' }, iconState),
    BlcIconSearch: __assign({ icon: '1F50D' }, iconState),
    BlcIconBell: __assign({ icon: '1F514' }, iconState),
    BlcIconDashboard: __assign({ icon: '229E' }, iconState),
    BlcIconTransport: __assign({ icon: '1F69A' }, iconState),
    BlcIconSettings: __assign({ icon: '2699' }, iconState),
    BlcIconTitle: __assign({ icon: '1F4C4' }, iconState),
    BlcIconHeart: __assign({ icon: '2665' }, iconState),
    BlcIconAlert: __assign({ icon: '26A0' }, iconState),
    BlcIconElite: __assign({ icon: '1F3C5' }, iconState)
});

({
    BlcIconMenu: {
        icon: '2630'
    },
    BlcIconPlus: {
        style: {
            default: {
                icon: '002B'
            },
            circle: {
                icon: '2295'
            }
        }
    },
    BlcIconClose: {
        style: {
            default: {
                icon: '00D7'
            },
            circle: {
                icon: '2297'
            }
        }
    },
    BlcIconCheck: {
        style: {
            default: {
                icon: '2713'
            },
            circle: {
                icon: '2705'
            }
        }
    },
    BlcIconInfo: {
        style: {
            default: {
                icon: '003F'
            },
            circle: {
                icon: '2370'
            }
        }
    },
    BlcIconNA: {
        style: {
            default: {
                icon: '2215'
            },
            circle: {
                icon: '2298'
            }
        }
    },
    BlcIconVisible: {
        style: {
            default: {
                icon: '29BF'
            },
            disabled: {
                icon: '2349'
            }
        }
    },
    BlcIconInternet: {
        style: {
            default: {
                icon: '1F4F3'
            },
            disabled: {
                icon: '1F4F4'
            }
        }
    },
    BlcIconAutoPilot: {
        style: {
            default: {
                icon: '2389'
            },
            disabled: {
                icon: '29B7'
            }
        }
    },
    BlcIconNotification: {
        style: {
            email: {
                icon: '2709'
            },
            sms: {
                icon: '260E'
            },
            push: {
                icon: '1F4F1'
            }
        }
    },
    BlcIconChart: {
        direction: {
            right: {
                icon: '2933'
            },
            top: {
                icon: '293B'
            },
            bottom: {
                icon: '20D5'
            }
        }
    },
    BlcIconPlay: __assign({ icon: '25B7' }, iconState),
    BlcIconEdit: __assign({ icon: '270F' }, iconState),
    BlcIconImage: __assign({ icon: '1F5BC' }, iconState),
    BlcIconUser: __assign({ icon: '1F464' }, iconState),
    BlcIconTrash: __assign({ icon: '1F6AE' }, iconState)
});

({
    BlcIconReport: {
        style: {
            guarantee: {
                icon: '2714'
            },
            autocheck: {
                icon: '2611'
            }
        }
    },
    BlcIconLog: {
        style: {
            login: {
                icon: '2347'
            },
            logout: {
                icon: '2348'
            }
        }
    },
    BlcIconNew: __assign({ icon: '2460' }, iconState),
    BlcIconFire: __assign({ icon: '1F525' }, iconState),
    BlcIconEnter: __assign({ icon: '23CE' }, iconState),
    BlcIconLocation: __assign({ icon: '1F4CD' }, iconState),
    BlcIconCard: __assign({ icon: '1F4EE' }, iconState),
    BlcIconCalendar: __assign({ icon: '1F5D3' }, iconState),
    BlcIconCircle: __assign({ icon: '20DD' }, iconState),
    BlcIconGift: __assign({ icon: '1F381' }, iconState),
    BlcIconRadio: __assign({ icon: '25CB' }, iconState),
    BlcIconBug: __assign({ icon: '1F41E' }, iconState),
    BlcIconSupport: __assign({ icon: '26D1' }, iconState)
});

({
    Placeholder: {
        BlcUserPlaceholder: {
            style: {
                buyer: {
                    icon: '24B7'
                },
                seller: {
                    icon: '24C8'
                }
            }
        }
    },
    Badge: {
        BlcSealedBidSale: __assign({ icon: '1F162' }, iconState)
    }
});

({
    BlcIconUS: {
        icon: '13D4',
        style: {
            alabama: __assign({ icon: '1360' }, iconState),
            alaska: __assign({ icon: '13A1' }, iconState),
            arizona: __assign({ icon: '13A2' }, iconState),
            arkansas: __assign({ icon: '13A3' }, iconState),
            california: __assign({ icon: '13A4' }, iconState),
            colorado: __assign({ icon: '13A5' }, iconState),
            connecticut: __assign({ icon: '13A6' }, iconState),
            delaware: __assign({ icon: '13A7' }, iconState),
            dc: __assign({ icon: '13A8' }, iconState),
            florida: __assign({ icon: '13A9' }, iconState),
            georgia: __assign({ icon: '13AA' }, iconState),
            hawaii: __assign({ icon: '13AB' }, iconState),
            idaho: __assign({ icon: '13AC' }, iconState),
            illinois: __assign({ icon: '13AD' }, iconState),
            indiana: __assign({ icon: '13AE' }, iconState),
            iowa: __assign({ icon: '13AF' }, iconState),
            kansas: __assign({ icon: '13B0' }, iconState),
            kentucky: __assign({ icon: '13B1' }, iconState),
            louisiana: __assign({ icon: '13B2' }, iconState),
            maine: __assign({ icon: '13B3' }, iconState),
            maryland: __assign({ icon: '13B4' }, iconState),
            massachusetts: __assign({ icon: '13B5' }, iconState),
            michigan: __assign({ icon: '13B6' }, iconState),
            minnesota: __assign({ icon: '13B7' }, iconState),
            mississippi: __assign({ icon: '13B8' }, iconState),
            missouri: __assign({ icon: '13B9' }, iconState),
            montana: __assign({ icon: '13BA' }, iconState),
            nebraska: __assign({ icon: '13BB' }, iconState),
            nevada: __assign({ icon: '13BC' }, iconState),
            newhampshire: __assign({ icon: '13BD' }, iconState),
            newjersey: __assign({ icon: '13BE' }, iconState),
            newmexico: __assign({ icon: '13BF' }, iconState),
            newyork: __assign({ icon: '13C0' }, iconState),
            northcarolina: __assign({ icon: '13C1' }, iconState),
            northdakota: __assign({ icon: '13C2' }, iconState),
            ohio: __assign({ icon: '13C3' }, iconState),
            oklahoma: __assign({ icon: '13C4' }, iconState),
            oregon: __assign({ icon: '13C5' }, iconState),
            pennsylvania: __assign({ icon: '13C6' }, iconState),
            rhodeisland: __assign({ icon: '13C7' }, iconState),
            southcarolina: __assign({ icon: '13C8' }, iconState),
            southdakota: __assign({ icon: '13C9' }, iconState),
            tennessee: __assign({ icon: '13CA' }, iconState),
            texas: __assign({ icon: '13CB' }, iconState),
            utah: __assign({ icon: '13CC' }, iconState),
            vermont: __assign({ icon: '13CD' }, iconState),
            virginia: __assign({ icon: '13CE' }, iconState),
            washington: __assign({ icon: '13CF' }, iconState),
            westvirginia: __assign({ icon: '13D0' }, iconState),
            wisconsin: __assign({ icon: '13D1' }, iconState),
            wyoming: __assign({ icon: '13D2' }, iconState)
        }
    }
});

var getIconMediaSizes = function (size, giant) {
    return {
        normalSize: giant ? getAvatarSizeMXL(size) : getIconSizeMXL(size),
        largerSize: giant ? getAvatarSizeML(size) : getIconSizeML(size),
        smallerSize: giant ? getAvatarSizeMS(size) : getIconSizeMS(size),
        smallestSize: giant ? getAvatarSizeMXS(size) : getIconSizeMXS(size)
    };
};

var Loader = styled.div(templateObject_1$1C || (templateObject_1$1C = __makeTemplateObject([""], [""])));
var AnimatedBox = styled.div(templateObject_2$O || (templateObject_2$O = __makeTemplateObject([""], [""])));
var LdsRing = styled.div(templateObject_3$o || (templateObject_3$o = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var normalSize = _a.normalSize, largerSize = _a.largerSize, smallerSize = _a.smallerSize, smallestSize = _a.smallestSize;
    return "\n        height: ".concat(normalSize, ";\n        width: ").concat(normalSize, ";\n        display: flex;\n        justify-content: center;\n        position: relative;\n\n        div {\n            width: ").concat(normalSize, ";\n\t\t\theight: ").concat(normalSize, ";\n            box-sizing: border-box;\n            display: block;\n            position: absolute;\n            border: 4px solid #969696;\n            border-radius: 50%;\n            animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n            border-color: #969696 transparent transparent transparent;\n        }\n\n        div:nth-child(1) {\n            animation-delay: -0.45s;\n        }\n\n        div:nth-child(2) {\n            animation-delay: -0.3s;\n        }\n\n        div:nth-child(3) {\n            animation-delay: -0.15s;\n        }\n\n        @keyframes lds-ring {\n            0% {\n              transform: rotate(0deg);\n            }\n            100% {\n              transform: rotate(360deg);\n            }\n        }\n\n        @media ").concat(mediaSizeMap.larger, " {\n            height: ").concat(largerSize, ";\n            div {\n                width: ").concat(largerSize, ";\n                height: ").concat(largerSize, ";\n            }\n        }\n\n        @media ").concat(mediaSizeMap.smaller, " {\n            height: ").concat(smallerSize, ";\n\n            div {\n                width: ").concat(smallerSize, ";\n                height: ").concat(smallerSize, ";\n            }\n        }\n\n        @media ").concat(mediaSizeMap.smallest, " {\n            height: ").concat(smallestSize, ";\n\n            div {\n                width: ").concat(smallestSize, ";\n                height: ").concat(smallestSize, ";\n            }\n        }\n    ");
});
var templateObject_1$1C, templateObject_2$O, templateObject_3$o;

var BlcLoader = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'normal' : _b;
    return (jsx(Loader, __assign({ "data-testid": "blc-loader" }, { children: jsxs(LdsRing, __assign({}, getIconMediaSizes(size, false), { children: [jsx(AnimatedBox, {}), jsx(AnimatedBox, {}), jsx(AnimatedBox, {}), jsx(AnimatedBox, {})] })) })));
};

var Content$4 = styled.div.attrs({
    className: 'blc-modal-content'
})(templateObject_1$1B || (templateObject_1$1B = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var _b = _a.hideScrollBar, hideScrollBar = _b === void 0 ? false : _b, _c = _a.padding, padding = _c === void 0 ? 16 : _c;
    return "\n  flex-grow: 1;\n  height: 100%;\n  overflow: auto;\n  padding: ".concat(getSizeValue(padding), ";\n  ").concat(hideScrollBar && hideScrollBarStyle, "\n  ");
});
var templateObject_1$1B;

var ModalContent = function (_a) {
    var padding = _a.padding, children = _a.children, fullpageModal = _a.fullpageModal, hideScrollBar = _a.hideScrollBar;
    return (jsx(Content$4, __assign({ padding: padding, fullpageModal: fullpageModal, hideScrollBar: hideScrollBar }, { children: children })));
};

var Highlighted = function (props) {
    var _a = props.showHighlight, showHighlight = _a === void 0 ? true : _a, defaultHighlight = props.defaultHighlight, children = props.children, className = props.className;
    return (jsxs(StyledLabelContainer, __assign({ className: className }, { children: [children, showHighlight && jsx(StyledHighlight, __assign({ id: "highlighted" }, defaultHighlight))] })));
};
var StyledHighlight = styled.span(templateObject_1$1A || (templateObject_1$1A = __makeTemplateObject(["\n  position: absolute;\n  aspect-ratio: 1;\n  border-radius: 50%;\n  ", "\n"], ["\n  position: absolute;\n  aspect-ratio: 1;\n  border-radius: 50%;\n  ", "\n"])), function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'primary' : _b, _c = _a.size, size = _c === void 0 ? 8 : _c;
    return "\n    right: -".concat(px(size / 3), ";\n    top: -").concat(px(size / 3), ";\n    width: ").concat(px(size), ";\n    background-color: ").concat(getIconColor(color), ";\n   ");
});
var StyledLabelContainer = styled.div(templateObject_2$N || (templateObject_2$N = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  font-size: ", ";\n  font-family: ", ";\n"], ["\n  position: relative;\n  display: flex;\n  font-size: ", ";\n  font-family: ", ";\n"])), fontMap.smaller.fontSize, fontFamily);
var templateObject_1$1A, templateObject_2$N;

/* eslint-disable @typescript-eslint/no-explicit-any */
var baseStyle = function (_a) {
    var borderRadius = _a.borderRadius, _b = _a.position, position = _b === void 0 ? '-1px' : _b;
    return "\n  border-radius: ".concat(borderRadius, ";\n\n  &:before {\n    content: '';\n    position: absolute;\n    opacity: 1;\n    z-index: 2;\n    top: ").concat(position, ";\n    left: ").concat(position, ";\n    right: ").concat(position, ";\n    bottom: ").concat(position, ";\n    pointer-events: none;\n    border-radius: ").concat(borderRadius, ";\n  }\n");
};
var hoverOverlay = "\n  background: ".concat(colorSurfaceOverlay['colorSurfaceOverlayDark-10'], ";\n");
var hoverStyle = "\n  &:hover {\n    &:before {\n      ".concat(hoverOverlay, "\n    }\n  }\n");
var activeOverlay = "\n  background: ".concat(colorSurfaceOverlay['colorSurfaceOverlayDark-20'], ";\n");
var activeStyle = "\n  &:active {\n    &:before {\n      ".concat(activeOverlay, "\n    }\n  }\n");
var disabledStyle = function (_a) {
    var disabled = _a.disabled;
    return "\n  ".concat(disabled
        ? "\n    pointer-events: none;\n\n    &:before {\n      background: ".concat(colorSurfaceOverlay['colorSurfaceOverlayLight-70'], ";\n    }\n    ")
        : '', "\n");
};
var focusStyle = "\n  &.focus,\n  &:focus-visible {\n    outline: 2px solid ".concat(colorBase['colorNeutral-0'], ";\n    box-shadow: 0px 0px 2px 4px var(--focus);\n    z-index: 2;\n  }\n");
var focusWithinStyle = "\n   :focus-within {\n    outline: 2px solid ".concat(colorBase['colorNeutral-0'], ";\n    box-shadow: 0px 0px 2px 4px var(--focus);\n    z-index: 2;\n  }\n");

var theming = {
    borderRadiusSmaller: 'var(--borderRadiusSmaller)',
    borderRadius: 'var(--borderRadius, 0px)',
    inputHeight: 'var(--inputHeight)',
    inputMinHeight: 'var(--inputHeightSmallest)'
};

var StyledButtonBase = styled.button.attrs(function (props) { return ({
    'aria-label': props.ariaLabel
}); })(templateObject_1$1z || (templateObject_1$1z = __makeTemplateObject(["\n  ", "\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  display: inline-flex;\n  gap: ", ";\n  position: relative;\n  justify-content: center;\n  align-items: center;\n  appearance: none;\n  background: none;\n  box-sizing: border-box;\n  cursor: pointer;\n  border: none;\n  text-decoration: none;\n  text-align: center;\n  text-wrap: ", ";\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  display: inline-flex;\n  gap: ", ";\n  position: relative;\n  justify-content: center;\n  align-items: center;\n  appearance: none;\n  background: none;\n  box-sizing: border-box;\n  cursor: pointer;\n  border: none;\n  text-decoration: none;\n  text-align: center;\n  text-wrap: ", ";\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), baseStyle$1, fontMap.normal.fontSize, fontMap.normal.lineHeight, weightMap$1.bold, function (_a) {
    var _b = _a.gap, gap = _b === void 0 ? 8 : _b;
    return "".concat(getSizeValue(gap));
}, function (_a) {
    var textWrap = _a.textWrap;
    return "".concat(getValue$1(textWrap));
}, baseStyle({ borderRadius: theming.borderRadius }), hoverStyle, focusStyle, activeStyle, disabledStyle);
var templateObject_1$1z;

var HighlightedIcon = function (_a) {
    var highlightedIcon = _a.highlightedIcon, iconName = _a.iconName, _b = _a.size, size = _b === void 0 ? 'larger' : _b, className = _a.className, iconColor = _a.iconColor;
    return (jsx(Highlighted, __assign({ className: className, showHighlight: highlightedIcon }, { children: jsx(Icon, { name: iconName, size: size, color: iconColor }) })));
};
var LeftIcon = styled(HighlightedIcon)(templateObject_1$1y || (templateObject_1$1y = __makeTemplateObject(["\n  margin-left: -4px;\n"], ["\n  margin-left: -4px;\n"])));
var RightIcon = styled(HighlightedIcon)(templateObject_2$M || (templateObject_2$M = __makeTemplateObject(["\n  margin-right: -4px;\n"], ["\n  margin-right: -4px;\n"])));
var WithLabel = function (_a) {
    var label = _a.label, icon = _a.icon, iconPosition = _a.iconPosition, highlightedIcon = _a.highlightedIcon, iconColor = _a.iconColor, _b = _a.iconSize, iconSize = _b === void 0 ? 'smaller' : _b;
    var leftIcon = icon && iconPosition === 'left' && (jsx(LeftIcon, { highlightedIcon: highlightedIcon, iconName: icon, size: iconSize, iconColor: iconColor }));
    var rightIcon = icon && iconPosition === 'right' && (jsx(RightIcon, { highlightedIcon: highlightedIcon, iconName: icon, size: iconSize, iconColor: iconColor }));
    return (jsxs(Fragment, { children: [leftIcon, label, rightIcon] }));
};
var getLinkProps = function (hReference, mailTo, openIn, variant, disabled) {
    var href = mailTo ? "mailto:".concat(mailTo) : hReference;
    var as = disabled && variant === 'link' ? 'span' : variant === 'link' || href ? 'a' : 'button';
    var open = href || mailTo ? '_blank' : undefined;
    return { link: href, as: as, openIn: openIn || open };
};
var ButtonBase = React__default.forwardRef(function (_a, forwardedRef) {
    var children = _a.children, className = _a.className, disabled = _a.disabled, gap = _a.gap, hoverDarkerStyle = _a.hoverDarkerStyle, _b = _a.highlightedIcon, highlightedIcon = _b === void 0 ? false : _b, icon = _a.icon, iconColor = _a.iconColor, _c = _a.iconPosition, iconPosition = _c === void 0 ? 'right' : _c, iconSize = _a.iconSize, id = _a.id, href = _a.href, mailTo = _a.mailTo, name = _a.name, ariaLabel = _a.ariaLabel, target = _a.target, type = _a.type, width = _a.width, textWrap = _a.textWrap, onClick = _a.onClick, variant = _a.variant, props = __rest(_a, ["children", "className", "disabled", "gap", "hoverDarkerStyle", "highlightedIcon", "icon", "iconColor", "iconPosition", "iconSize", "id", "href", "mailTo", "name", "ariaLabel", "target", "type", "width", "textWrap", "onClick", "variant"]);
    var hasLabel = children && Object.keys(children).length > 0;
    // this is just for storybook purposes
    var _d = getLinkProps(href, mailTo, target, variant, disabled), link = _d.link, as = _d.as, openIn = _d.openIn;
    return (jsx(StyledButtonBase, __assign({ as: as, className: className, gap: gap, hoverDarkerStyle: hoverDarkerStyle, disabled: disabled, id: id, href: link, name: name, onClick: onClick, target: openIn, type: type, width: width, textWrap: textWrap, ariaLabel: ariaLabel || name, ref: forwardedRef, variant: variant }, props, { children: icon && !hasLabel ? (jsx(HighlightedIcon, { highlightedIcon: highlightedIcon, iconName: icon, size: iconSize, iconColor: iconColor })) : (jsx(Fragment, { children: jsx(WithLabel, { label: children, icon: icon, iconPosition: iconPosition, highlightedIcon: highlightedIcon, iconColor: iconColor, iconSize: iconSize }) })) })));
});
ButtonBase.displayName = 'ButtonBase';
var templateObject_1$1y, templateObject_2$M;

var getPadding$1 = function (size) {
    switch (size) {
        case 'smaller':
            return "".concat(spacingActionPadding.spacingActionPaddingSm, " ").concat(spacingActionPadding.spacingActionPaddingSm);
        case 'normal':
        default:
            return "calc(".concat(spacingActionPadding.spacingActionPaddingMd, " + 2px) ").concat(spacingActionPadding.spacingActionPaddingLg);
    }
};
var getIconProps = function (color, defaultColor) { return "\n  svg {\n    fill: ".concat(color ? getBorderColor(color) : defaultColor, ";\n  }\n"); };
var primary$1 = styled(ButtonBase)(templateObject_1$1x || (templateObject_1$1x = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'normal' : _b, iconColor = _a.iconColor, padding = _a.padding;
    return "\n        padding: ".concat(padding || getPadding$1(size), ";\n        background-color: ").concat(colorActionPrimary.colorActionPrimarySurface, ";\n        color: ").concat(colorActionPrimary.colorActionPrimaryText, ";\n        border: 1px solid ").concat(colorActionPrimary.colorActionPrimarySurface, ";\n        ").concat(getIconProps(iconColor, colorActionPrimary.colorActionPrimaryText), "\n    ");
});
var secondary = styled(ButtonBase)(templateObject_2$L || (templateObject_2$L = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'normal' : _b, iconColor = _a.iconColor, padding = _a.padding;
    return "\n        padding: ".concat(padding || getPadding$1(size), ";\n        background-color: ").concat(colorActionSecondary.colorActionSecondarySurface, ";\n        color: ").concat(colorActionSecondary.colorActionSecondaryText, ";\n        border: 1px solid ").concat(colorActionSecondary.colorActionSecondaryBorder, ";\n        ").concat(getIconProps(iconColor, colorActionSecondary.colorActionSecondaryText), "\n    ");
});
var tertiary = styled(ButtonBase).attrs({
    hoverDarkerStyle: true
})(templateObject_3$n || (templateObject_3$n = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'normal' : _b, iconColor = _a.iconColor, padding = _a.padding;
    return "\n      padding: ".concat(padding || getPadding$1(size), ";\n      background-color: ").concat(colorActionTertiary.colorActionTertiarySurface, ";\n      color: ").concat(colorActionTertiary.colorActionTertiaryText, ";\n      border: 1px solid ").concat(colorActionTertiary.colorActionTertiaryBorder, ";\n      ").concat(getIconProps(iconColor, colorActionTertiary.colorActionTertiaryText), "\n  ");
});
var text = styled(ButtonBase)(templateObject_4$d || (templateObject_4$d = __makeTemplateObject(["\n  color: ", ";\n  cursor: pointer;\n  border-radius: var(--borderRadiusSmaller);\n  box-shadow: none;\n  &:before {\n    display: none;\n  }\n"], ["\n  color: ", ";\n  cursor: pointer;\n  border-radius: var(--borderRadiusSmaller);\n  box-shadow: none;\n  &:before {\n    display: none;\n  }\n"])), function (_a) {
    var _b = _a.labelColor, labelColor = _b === void 0 ? 'fontColor' : _b;
    return getTextColor(labelColor);
});
var icon = styled(ButtonBase)(templateObject_5$6 || (templateObject_5$6 = __makeTemplateObject(["\n  box-shadow: none;\n  &:before {\n    border-radius: var(--borderRadius);\n  }\n"], ["\n  box-shadow: none;\n  &:before {\n    border-radius: var(--borderRadius);\n  }\n"])));
var floatingIcon = styled(ButtonBase)(templateObject_6$5 || (templateObject_6$5 = __makeTemplateObject(["\n  box-shadow: 0px 0px 8px 0px #00000029;\n  border-radius: 24px;\n  width: 32px;\n  height: 32px;\n  flex-shrink: 0;\n  background-color: ", ";\n  &:before {\n    border-radius: 24px;\n  }\n  &:focus-visible,\n  &.focus {\n    outline-color: ", ";\n  }\n"], ["\n  box-shadow: 0px 0px 8px 0px #00000029;\n  border-radius: 24px;\n  width: 32px;\n  height: 32px;\n  flex-shrink: 0;\n  background-color: ", ";\n  &:before {\n    border-radius: 24px;\n  }\n  &:focus-visible,\n  &.focus {\n    outline-color: ", ";\n  }\n"])), colorActionIcon.colorActionIconSurface, colorBorder$1.colorBorderBorderSecondary);
var link = styled(ButtonBase)(templateObject_7$3 || (templateObject_7$3 = __makeTemplateObject(["\n  font-weight: 400;\n  font-size: ", ";\n  line-height: 18px;\n  letter-spacing: 0px;\n  color: ", ";\n  border-radius: var(--borderRadiusSmaller);\n  box-shadow: none;\n  ", ";\n\n  :before {\n    display: none;\n  }\n\n  :hover {\n    text-decoration: underline;\n  }\n\n  :active,\n  :visited {\n    color: ", ";\n    text-decoration: none;\n  }\n"], ["\n  font-weight: 400;\n  font-size: ", ";\n  line-height: 18px;\n  letter-spacing: 0px;\n  color: ", ";\n  border-radius: var(--borderRadiusSmaller);\n  box-shadow: none;\n  ", ";\n\n  :before {\n    display: none;\n  }\n\n  :hover {\n    text-decoration: underline;\n  }\n\n  :active,\n  :visited {\n    color: ", ";\n    text-decoration: none;\n  }\n"])), fontContent.fontContentDefault, function (_a) {
    var labelColor = _a.labelColor;
    return getTextLinkColor(labelColor) || colorTextLink.colorTextLinkLinkPrimary;
}, function (_a) {
    var disabled = _a.disabled;
    return "\n    ".concat(disabled
        ? "\n        color: ".concat(colorText.colorTextTextSecondary, ";\n        opacity: 0.5;\n        text-decoration: underline;\n      ")
        : '', "\n  ");
}, colorTextLink.colorTextLinkLinkVisited);
var buttonVariants = {
    primary: primary$1,
    secondary: secondary,
    tertiary: tertiary,
    text: text,
    icon: icon,
    'floating-icon': floatingIcon,
    link: link
};
var templateObject_1$1x, templateObject_2$L, templateObject_3$n, templateObject_4$d, templateObject_5$6, templateObject_6$5, templateObject_7$3;

var Button = React__default.forwardRef(function (_a, forwardedRef) {
    var children = _a.children, className = _a.className, disabled = _a.disabled, gap = _a.gap, highlightedIcon = _a.highlightedIcon, href = _a.href, icon = _a.icon, iconColor = _a.iconColor, iconPosition = _a.iconPosition, iconSize = _a.iconSize, id = _a.id, labelColor = _a.labelColor, mailTo = _a.mailTo, name = _a.name, ariaLabel = _a.ariaLabel, padding = _a.padding, _b = _a.size, size = _b === void 0 ? 'normal' : _b, target = _a.target, type = _a.type, _c = _a.variant, variant = _c === void 0 ? 'primary' : _c, width = _a.width, textWrap = _a.textWrap, onClick = _a.onClick, props = __rest(_a, ["children", "className", "disabled", "gap", "highlightedIcon", "href", "icon", "iconColor", "iconPosition", "iconSize", "id", "labelColor", "mailTo", "name", "ariaLabel", "padding", "size", "target", "type", "variant", "width", "textWrap", "onClick"]);
    var isFloatingIcon = variant === 'floating-icon';
    variant = children || isFloatingIcon ? variant : 'icon';
    iconSize = isFloatingIcon ? SizeEnum.smaller : iconSize;
    var ButtonVariant = buttonVariants[variant];
    return (jsx(ButtonVariant, __assign({ className: className, disabled: disabled, gap: gap, highlightedIcon: highlightedIcon, href: href, icon: icon, iconColor: iconColor, iconPosition: iconPosition, iconSize: iconSize, id: id, labelColor: labelColor, mailTo: mailTo, name: name, ariaLabel: ariaLabel, onClick: onClick, padding: padding, size: size, target: target, type: type, width: width, textWrap: textWrap, variant: variant, ref: forwardedRef }, props, { children: children })));
});
Button.displayName = 'Button';

var Footer = styled.footer(templateObject_1$1w || (templateObject_1$1w = __makeTemplateObject(["\n  border-top: 1px solid ", ";\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  flex-grow: 1;\n  padding: 16px;\n"], ["\n  border-top: 1px solid ", ";\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  flex-grow: 1;\n  padding: 16px;\n"])), colorBorder$1.colorBorderBorderPrimary);
var ConfirmButtonText = styled.span(templateObject_2$K || (templateObject_2$K = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var loadingConfirm = _a.loadingConfirm;
    return "\n\t\tmargin-right: ".concat(loadingConfirm ? '15px' : 0, ";\n\t");
});
var templateObject_1$1w, templateObject_2$K;

var ModalFooter = function (_a) {
    var showCancel = _a.showCancel, showAction = _a.showAction, showConfirm = _a.showConfirm, disableAction = _a.disableAction, disableConfirm = _a.disableConfirm, actionCopy = _a.actionCopy, cancelCopy = _a.cancelCopy, confirmCopy = _a.confirmCopy, loadingConfirm = _a.loadingConfirm, actionFunction = _a.actionFunction, confirmFunction = _a.confirmFunction, closeFunction = _a.closeFunction, closeModal = _a.closeModal, confirmClassName = _a.confirmClassName, actionClassName = _a.actionClassName, cancelClassName = _a.cancelClassName;
    return (jsxs(Footer, { children: [showCancel && (jsx(FlexBox, __assign({ flex: 1 }, { children: jsx(Button, __assign({ className: cancelClassName, variant: "tertiary", name: cancelCopy, onClick: closeFunction || closeModal, width: showAction ? 'auto' : '100%' }, { children: cancelCopy })) }))), (showAction || showConfirm) && (jsxs(FlexBox, __assign({ flex: 1, gap: 8 }, { children: [showAction && (jsx(Button, __assign({ className: actionClassName, variant: "secondary", disabled: disableAction, name: actionCopy, onClick: actionFunction, width: "100%" }, { children: actionCopy }))), showConfirm && (jsxs(Button, __assign({ className: confirmClassName, name: confirmCopy, onClick: confirmFunction, disabled: disableConfirm || loadingConfirm, width: "100%" }, { children: [jsx(ConfirmButtonText, __assign({ loadingConfirm: loadingConfirm }, { children: confirmCopy })), loadingConfirm && jsx(BlcLoader, { size: "smaller" })] })))] })))] }));
};

var Header = styled.header(templateObject_1$1v || (templateObject_1$1v = __makeTemplateObject(["\n  display: flex;\n  flex-grow: 0;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px;\n  border-bottom: 1px solid ", ";\n"], ["\n  display: flex;\n  flex-grow: 0;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px;\n  border-bottom: 1px solid ", ";\n"])), colorBorder$1.colorBorderBorderPrimary);
var HeaderIcon = styled.span(templateObject_2$J || (templateObject_2$J = __makeTemplateObject(["\n  cursor: pointer;\n\n  &:focus {\n    outline: none;\n  }\n"], ["\n  cursor: pointer;\n\n  &:focus {\n    outline: none;\n  }\n"])));
var templateObject_1$1v, templateObject_2$J;

var ModalHeader = function (_a) {
    var modalTitleContent = _a.modalTitleContent, modalTitle = _a.modalTitle, closeModal = _a.closeModal, type = _a.type, iconClose = _a.iconClose;
    return (jsxs(Header, __assign({ type: type }, { children: [modalTitleContent || jsx(Headline, __assign({ size: "H3" }, { children: modalTitle })), jsx(HeaderIcon, __assign({ onClick: closeModal, tabIndex: 0 }, { children: iconClose || jsx(Icon, { name: "close" }) }))] })));
};

var TypeEnum;
(function (TypeEnum) {
    TypeEnum["window"] = "window";
    TypeEnum["dialog"] = "dialog";
    TypeEnum["confirm"] = "confirm";
})(TypeEnum || (TypeEnum = {}));

var zIndexMap = {
    dropdown: 8000,
    overlay: 9000,
    navigationBar: 10000,
    navigationBarMobile: 11000,
    intercom: 11050,
    modal: 12000,
    tooltip: 12500,
    toast: 13000
};

var widthByType = {
    window: '100%',
    confirm: '480px',
    dialog: '768px'
};
var ModalStyle = styled.div(templateObject_1$1u || (templateObject_1$1u = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'dialog' : _b, fullHeight = _a.fullHeight, height = _a.height, _c = _a.width, width = _c === void 0 ? widthByType[type] : _c;
    return "\n    background-color: ".concat(colorSurface.primary, ";\n    border-radius: 0;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    font-family: ").concat(fontFamily, ";\n    max-width: 100%;\n    outline: none;\n    height: ").concat(type === 'window' ? '100%' : fullHeight ? '100%' : getSizeValue(height), ";\n    max-height: 100%;\n    width: ").concat(getSizeValue(width), ";\n    border-radius: ").concat(theming.borderRadius, ";\n    @media ").concat(mediaSizeMap.smaller, " {\n      border-radius: 0;\n    }\n  ");
});
var OverlayStyle = styled.div(templateObject_2$I || (templateObject_2$I = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var type = _a.type, fullpageModal = _a.fullpageModal;
    return "\n    align-items: ".concat(type === 'confirm' ? 'flex-end' : 'center', ";\n    justify-content: ").concat(type === 'confirm' ? 'flex-end' : 'center', ";\n    padding: ").concat(fullpageModal ? '0px' : '16px;', ";\n    align-items: center;\n    background: ").concat(colorSurfaceOverlay['colorSurfaceOverlayDark-40'], " !important;\n    bottom: 0;\n    display: flex;\n    justify-content: center;\n    left: 0;\n    position: fixed;\n    right: 0;\n    top: 0;\n    z-index: ").concat(zIndexMap.modal, ";\n\n    @media ").concat(mediaSizeMap.smaller, " {\n      padding: 0;\n    }\n");
});
var templateObject_1$1u, templateObject_2$I;

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var f = n.default;
	if (typeof f == "function") {
		var a = function a () {
			if (this instanceof a) {
				var args = [null];
				args.push.apply(args, arguments);
				var Ctor = Function.bind.apply(f, args);
				return new Ctor();
			}
			return f.apply(this, arguments);
		};
		a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

var libExports = {};
var lib = {
  get exports(){ return libExports; },
  set exports(v){ libExports = v; },
};

var Modal$2 = {};

var propTypesExports = {};
var propTypes$5 = {
  get exports(){ return propTypesExports; },
  set exports(v){ propTypesExports = v; },
};

var reactIsExports$1 = {};
var reactIs$1 = {
  get exports(){ return reactIsExports$1; },
  set exports(v){ reactIsExports$1 = v; },
};

var reactIs_production_min$1 = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min$1;

function requireReactIs_production_min$1 () {
	if (hasRequiredReactIs_production_min$1) return reactIs_production_min$1;
	hasRequiredReactIs_production_min$1 = 1;
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min$1.AsyncMode=l;reactIs_production_min$1.ConcurrentMode=m;reactIs_production_min$1.ContextConsumer=k;reactIs_production_min$1.ContextProvider=h;reactIs_production_min$1.Element=c;reactIs_production_min$1.ForwardRef=n;reactIs_production_min$1.Fragment=e;reactIs_production_min$1.Lazy=t;reactIs_production_min$1.Memo=r;reactIs_production_min$1.Portal=d;
	reactIs_production_min$1.Profiler=g;reactIs_production_min$1.StrictMode=f;reactIs_production_min$1.Suspense=p;reactIs_production_min$1.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min$1.isConcurrentMode=A;reactIs_production_min$1.isContextConsumer=function(a){return z(a)===k};reactIs_production_min$1.isContextProvider=function(a){return z(a)===h};reactIs_production_min$1.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min$1.isForwardRef=function(a){return z(a)===n};reactIs_production_min$1.isFragment=function(a){return z(a)===e};reactIs_production_min$1.isLazy=function(a){return z(a)===t};
	reactIs_production_min$1.isMemo=function(a){return z(a)===r};reactIs_production_min$1.isPortal=function(a){return z(a)===d};reactIs_production_min$1.isProfiler=function(a){return z(a)===g};reactIs_production_min$1.isStrictMode=function(a){return z(a)===f};reactIs_production_min$1.isSuspense=function(a){return z(a)===p};
	reactIs_production_min$1.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min$1.typeOf=z;
	return reactIs_production_min$1;
}

var reactIs_development$1 = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development$1;

function requireReactIs_development$1 () {
	if (hasRequiredReactIs_development$1) return reactIs_development$1;
	hasRequiredReactIs_development$1 = 1;



	if (process.env.NODE_ENV !== "production") {
	  (function() {

	// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
	var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
	var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
	var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
	var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
	var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
	var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
	// (unstable) APIs that have been removed. Can we remove the symbols?

	var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
	var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
	var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
	var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
	var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
	var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
	var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
	var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
	var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
	var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
	var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

	function isValidElementType(type) {
	  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
	  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
	}

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;

	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_ASYNC_MODE_TYPE:
	          case REACT_CONCURRENT_MODE_TYPE:
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	            return type;

	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;

	              default:
	                return $$typeof;
	            }

	        }

	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	} // AsyncMode is deprecated along with isAsyncMode

	var AsyncMode = REACT_ASYNC_MODE_TYPE;
	var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
	    }
	  }

	  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
	}
	function isConcurrentMode(object) {
	  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}

	reactIs_development$1.AsyncMode = AsyncMode;
	reactIs_development$1.ConcurrentMode = ConcurrentMode;
	reactIs_development$1.ContextConsumer = ContextConsumer;
	reactIs_development$1.ContextProvider = ContextProvider;
	reactIs_development$1.Element = Element;
	reactIs_development$1.ForwardRef = ForwardRef;
	reactIs_development$1.Fragment = Fragment;
	reactIs_development$1.Lazy = Lazy;
	reactIs_development$1.Memo = Memo;
	reactIs_development$1.Portal = Portal;
	reactIs_development$1.Profiler = Profiler;
	reactIs_development$1.StrictMode = StrictMode;
	reactIs_development$1.Suspense = Suspense;
	reactIs_development$1.isAsyncMode = isAsyncMode;
	reactIs_development$1.isConcurrentMode = isConcurrentMode;
	reactIs_development$1.isContextConsumer = isContextConsumer;
	reactIs_development$1.isContextProvider = isContextProvider;
	reactIs_development$1.isElement = isElement;
	reactIs_development$1.isForwardRef = isForwardRef;
	reactIs_development$1.isFragment = isFragment;
	reactIs_development$1.isLazy = isLazy;
	reactIs_development$1.isMemo = isMemo;
	reactIs_development$1.isPortal = isPortal;
	reactIs_development$1.isProfiler = isProfiler;
	reactIs_development$1.isStrictMode = isStrictMode;
	reactIs_development$1.isSuspense = isSuspense;
	reactIs_development$1.isValidElementType = isValidElementType;
	reactIs_development$1.typeOf = typeOf;
	  })();
	}
	return reactIs_development$1;
}

var hasRequiredReactIs;

function requireReactIs () {
	if (hasRequiredReactIs) return reactIsExports$1;
	hasRequiredReactIs = 1;
	(function (module) {

		if (process.env.NODE_ENV === 'production') {
		  module.exports = requireReactIs_production_min$1();
		} else {
		  module.exports = requireReactIs_development$1();
		}
} (reactIs$1));
	return reactIsExports$1;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

var objectAssign;
var hasRequiredObjectAssign;

function requireObjectAssign () {
	if (hasRequiredObjectAssign) return objectAssign;
	hasRequiredObjectAssign = 1;
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}

		return Object(val);
	}

	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}

			// Detect buggy property enumeration order in older V8 versions.

			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}

			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}

	objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;

		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);

			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}

			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}

		return to;
	};
	return objectAssign;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;

function requireReactPropTypesSecret () {
	if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
	hasRequiredReactPropTypesSecret = 1;

	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

	ReactPropTypesSecret_1 = ReactPropTypesSecret;
	return ReactPropTypesSecret_1;
}

var has;
var hasRequiredHas;

function requireHas () {
	if (hasRequiredHas) return has;
	hasRequiredHas = 1;
	has = Function.call.bind(Object.prototype.hasOwnProperty);
	return has;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var checkPropTypes_1;
var hasRequiredCheckPropTypes;

function requireCheckPropTypes () {
	if (hasRequiredCheckPropTypes) return checkPropTypes_1;
	hasRequiredCheckPropTypes = 1;

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  var ReactPropTypesSecret = requireReactPropTypesSecret();
	  var loggedTypeFailures = {};
	  var has = requireHas();

	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) { /**/ }
	  };
	}

	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
	              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;

	          var stack = getStack ? getStack() : '';

	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}

	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (process.env.NODE_ENV !== 'production') {
	    loggedTypeFailures = {};
	  }
	};

	checkPropTypes_1 = checkPropTypes;
	return checkPropTypes_1;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;

function requireFactoryWithTypeCheckers () {
	if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
	hasRequiredFactoryWithTypeCheckers = 1;

	var ReactIs = requireReactIs();
	var assign = requireObjectAssign();

	var ReactPropTypesSecret = requireReactPropTypesSecret();
	var has = requireHas();
	var checkPropTypes = requireCheckPropTypes();

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}

	function emptyFunctionThatReturnsNull() {
	  return null;
	}

	factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }

	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */

	  var ANONYMOUS = '<<anonymous>>';

	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bigint: createPrimitiveTypeChecker('bigint'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),

	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };

	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/

	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message, data) {
	    this.message = message;
	    this.data = data && typeof data === 'object' ? data: {};
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;

	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;

	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }

	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);

	    return chainedCheckType;
	  }

	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);

	        return new PropTypeError(
	          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
	          {expectedType: expectedType}
	        );
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }

	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (process.env.NODE_ENV !== 'production') {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }

	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }

	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var expectedTypes = [];
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
	        if (checkerResult == null) {
	          return null;
	        }
	        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
	          expectedTypes.push(checkerResult.data.expectedType);
	        }
	      }
	      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function invalidValidatorError(componentName, location, propFullName, key, type) {
	    return new PropTypeError(
	      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
	      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
	    );
	  }

	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (has(shapeTypes, key) && typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }

	    return createChainableTypeChecker(validate);
	  }

	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }

	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }

	        return true;
	      default:
	        return false;
	    }
	  }

	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }

	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }

	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }

	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }

	    return false;
	  }

	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }

	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }

	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }

	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }

	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithTypeCheckers;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;

function requireFactoryWithThrowingShims () {
	if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
	hasRequiredFactoryWithThrowingShims = 1;

	var ReactPropTypesSecret = requireReactPropTypesSecret();

	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;

	factoryWithThrowingShims = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  }	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  }	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,

	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,

	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };

	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithThrowingShims;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = requireReactIs();

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes$5.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes$5.exports = requireFactoryWithThrowingShims()();
}

var ModalPortalExports = {};
var ModalPortal = {
  get exports(){ return ModalPortalExports; },
  set exports(v){ ModalPortalExports = v; },
};

var focusManager = {};

var tabbableExports = {};
var tabbable = {
  get exports(){ return tabbableExports; },
  set exports(v){ tabbableExports = v; },
};

(function (module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = findTabbableDescendants;
	/*!
	 * Adapted from jQuery UI core
	 *
	 * http://jqueryui.com
	 *
	 * Copyright 2014 jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/category/ui-core/
	 */

	var DISPLAY_NONE = "none";
	var DISPLAY_CONTENTS = "contents";

	var tabbableNode = /input|select|textarea|button|object|iframe/;

	function isNotOverflowing(element, style) {
	  return style.getPropertyValue("overflow") !== "visible" ||
	  // if 'overflow: visible' set, check if there is actually any overflow
	  element.scrollWidth <= 0 && element.scrollHeight <= 0;
	}

	function hidesContents(element) {
	  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

	  // If the node is empty, this is good enough
	  if (zeroSize && !element.innerHTML) return true;

	  try {
	    // Otherwise we need to check some styles
	    var style = window.getComputedStyle(element);
	    var displayValue = style.getPropertyValue("display");
	    return zeroSize ? displayValue !== DISPLAY_CONTENTS && isNotOverflowing(element, style) : displayValue === DISPLAY_NONE;
	  } catch (exception) {
	    // eslint-disable-next-line no-console
	    console.warn("Failed to inspect element style");
	    return false;
	  }
	}

	function visible(element) {
	  var parentElement = element;
	  var rootNode = element.getRootNode && element.getRootNode();
	  while (parentElement) {
	    if (parentElement === document.body) break;

	    // if we are not hidden yet, skip to checking outside the Web Component
	    if (rootNode && parentElement === rootNode) parentElement = rootNode.host.parentNode;

	    if (hidesContents(parentElement)) return false;
	    parentElement = parentElement.parentNode;
	  }
	  return true;
	}

	function focusable(element, isTabIndexNotNaN) {
	  var nodeName = element.nodeName.toLowerCase();
	  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
	  return res && visible(element);
	}

	function tabbable(element) {
	  var tabIndex = element.getAttribute("tabindex");
	  if (tabIndex === null) tabIndex = undefined;
	  var isTabIndexNaN = isNaN(tabIndex);
	  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
	}

	function findTabbableDescendants(element) {
	  var descendants = [].slice.call(element.querySelectorAll("*"), 0).reduce(function (finished, el) {
	    return finished.concat(!el.shadowRoot ? [el] : findTabbableDescendants(el.shadowRoot));
	  }, []);
	  return descendants.filter(tabbable);
	}
	module.exports = exports["default"];
} (tabbable, tabbableExports));

Object.defineProperty(focusManager, "__esModule", {
  value: true
});
focusManager.resetState = resetState$4;
focusManager.log = log$4;
focusManager.handleBlur = handleBlur;
focusManager.handleFocus = handleFocus;
focusManager.markForFocusLater = markForFocusLater;
focusManager.returnFocus = returnFocus;
focusManager.popWithoutFocus = popWithoutFocus;
focusManager.setupScopedFocus = setupScopedFocus;
focusManager.teardownScopedFocus = teardownScopedFocus;

var _tabbable = tabbableExports;

var _tabbable2 = _interopRequireDefault$b(_tabbable);

function _interopRequireDefault$b(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState$4() {
  focusLaterElements = [];
}

/* istanbul ignore next */
function log$4() {
  if (process.env.NODE_ENV !== "production") {
    console.log("focusManager ----------");
    focusLaterElements.forEach(function (f) {
      var check = f || {};
      console.log(check.nodeName, check.className, check.id);
    });
    console.log("end focusManager ----------");
  }
}
/* eslint-enable no-console */

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus({ preventScroll: preventScroll });
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}

var scopeTabExports = {};
var scopeTab = {
  get exports(){ return scopeTabExports; },
  set exports(v){ scopeTabExports = v; },
};

(function (module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = scopeTab;

	var _tabbable = tabbableExports;

	var _tabbable2 = _interopRequireDefault(_tabbable);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function getActiveElement() {
	  var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

	  return el.activeElement.shadowRoot ? getActiveElement(el.activeElement.shadowRoot) : el.activeElement;
	}

	function scopeTab(node, event) {
	  var tabbable = (0, _tabbable2.default)(node);

	  if (!tabbable.length) {
	    // Do nothing, since there are no elements that can receive focus.
	    event.preventDefault();
	    return;
	  }

	  var target = void 0;

	  var shiftKey = event.shiftKey;
	  var head = tabbable[0];
	  var tail = tabbable[tabbable.length - 1];
	  var activeElement = getActiveElement();

	  // proceed with default browser behavior on tab.
	  // Focus on last element on shift + tab.
	  if (node === activeElement) {
	    if (!shiftKey) return;
	    target = tail;
	  }

	  if (tail === activeElement && !shiftKey) {
	    target = head;
	  }

	  if (head === activeElement && shiftKey) {
	    target = tail;
	  }

	  if (target) {
	    event.preventDefault();
	    target.focus();
	    return;
	  }

	  // Safari radio issue.
	  //
	  // Safari does not move the focus to the radio button,
	  // so we need to force it to really walk through all elements.
	  //
	  // This is very error prone, since we are trying to guess
	  // if it is a safari browser from the first occurence between
	  // chrome or safari.
	  //
	  // The chrome user agent contains the first ocurrence
	  // as the 'chrome/version' and later the 'safari/version'.
	  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
	  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

	  // If we are not in safari desktop, let the browser control
	  // the focus
	  if (!isSafariDesktop) return;

	  var x = tabbable.indexOf(activeElement);

	  if (x > -1) {
	    x += shiftKey ? -1 : 1;
	  }

	  target = tabbable[x];

	  // If the tabbable element does not exist,
	  // focus head/tail based on shiftKey
	  if (typeof target === "undefined") {
	    event.preventDefault();
	    target = shiftKey ? tail : head;
	    target.focus();
	    return;
	  }

	  event.preventDefault();

	  target.focus();
	}
	module.exports = exports["default"];
} (scopeTab, scopeTabExports));

var ariaAppHider$1 = {};

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = process.env.NODE_ENV !== 'production';

var warning$2 = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning$2 = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

var warning_1 = warning$2;

var safeHTMLElement = {};

var exenvExports = {};
var exenv = {
  get exports(){ return exenvExports; },
  set exports(v){ exenvExports = v; },
};

/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/

(function (module) {
	/* global define */

	(function () {

		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);

		var ExecutionEnvironment = {

			canUseDOM: canUseDOM,

			canUseWorkers: typeof Worker !== 'undefined',

			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),

			canUseViewport: canUseDOM && !!window.screen

		};

		if (module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}

	}());
} (exenv));

Object.defineProperty(safeHTMLElement, "__esModule", {
  value: true
});
safeHTMLElement.canUseDOM = safeHTMLElement.SafeNodeList = safeHTMLElement.SafeHTMLCollection = undefined;

var _exenv = exenvExports;

var _exenv2 = _interopRequireDefault$a(_exenv);

function _interopRequireDefault$a(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

safeHTMLElement.SafeHTMLCollection = EE.canUseDOM ? window.HTMLCollection : {};

safeHTMLElement.SafeNodeList = EE.canUseDOM ? window.NodeList : {};

safeHTMLElement.canUseDOM = EE.canUseDOM;

safeHTMLElement.default = SafeHTMLElement;

Object.defineProperty(ariaAppHider$1, "__esModule", {
  value: true
});
ariaAppHider$1.resetState = resetState$3;
ariaAppHider$1.log = log$3;
ariaAppHider$1.assertNodeList = assertNodeList;
ariaAppHider$1.setElement = setElement;
ariaAppHider$1.validateElement = validateElement;
ariaAppHider$1.hide = hide$4;
ariaAppHider$1.show = show;
ariaAppHider$1.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;

var _warning = warning_1;

var _warning2 = _interopRequireDefault$9(_warning);

var _safeHTMLElement$1 = safeHTMLElement;

function _interopRequireDefault$9(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalElement = null;

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState$3() {
  if (globalElement) {
    if (globalElement.removeAttribute) {
      globalElement.removeAttribute("aria-hidden");
    } else if (globalElement.length != null) {
      globalElement.forEach(function (element) {
        return element.removeAttribute("aria-hidden");
      });
    } else {
      document.querySelectorAll(globalElement).forEach(function (element) {
        return element.removeAttribute("aria-hidden");
      });
    }
  }
  globalElement = null;
}

/* istanbul ignore next */
function log$3() {
  if (process.env.NODE_ENV !== "production") {
    var check = globalElement || {};
    console.log("ariaAppHider ----------");
    console.log(check.nodeName, check.className, check.id);
    console.log("end ariaAppHider ----------");
  }
}
/* eslint-enable no-console */

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string" && _safeHTMLElement$1.canUseDOM) {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function validateElement(appElement) {
  var el = appElement || globalElement;
  if (el) {
    return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [el];
  } else {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));

    return [];
  }
}

function hide$4(appElement) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var el = _step.value;

      el.setAttribute("aria-hidden", "true");
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

function show(appElement) {
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var el = _step2.value;

      el.removeAttribute("aria-hidden");
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

var classList = {};

Object.defineProperty(classList, "__esModule", {
  value: true
});
classList.resetState = resetState$2;
classList.log = log$2;
var htmlClassList = {};
var docBodyClassList = {};

/* eslint-disable no-console */
/* istanbul ignore next */
function removeClass(at, cls) {
  at.classList.remove(cls);
}

/* istanbul ignore next */
function resetState$2() {
  var htmlElement = document.getElementsByTagName("html")[0];
  for (var cls in htmlClassList) {
    removeClass(htmlElement, htmlClassList[cls]);
  }

  var body = document.body;
  for (var _cls in docBodyClassList) {
    removeClass(body, docBodyClassList[_cls]);
  }

  htmlClassList = {};
  docBodyClassList = {};
}

/* istanbul ignore next */
function log$2() {
  if (process.env.NODE_ENV !== "production") {
    var classes = document.getElementsByTagName("html")[0].className;
    var buffer = "Show tracked classes:\n\n";

    buffer += "<html /> (" + classes + "):\n  ";
    for (var x in htmlClassList) {
      buffer += "  " + x + " " + htmlClassList[x] + "\n  ";
    }

    classes = document.body.className;

    buffer += "\n\ndoc.body (" + classes + "):\n  ";
    for (var _x in docBodyClassList) {
      buffer += "  " + _x + " " + docBodyClassList[_x] + "\n  ";
    }

    buffer += "\n";

    console.log(buffer);
  }
}
/* eslint-enable no-console */

/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var incrementReference = function incrementReference(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};

/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var decrementReference = function decrementReference(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};

/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */
var trackClass = function trackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};

/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */
var untrackClass = function untrackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};

/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
classList.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
classList.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

var portalOpenInstances$1 = {};

Object.defineProperty(portalOpenInstances$1, "__esModule", {
  value: true
});
portalOpenInstances$1.log = log$1;
portalOpenInstances$1.resetState = resetState$1;

function _classCallCheck$5(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Tracks portals that are open and emits events to subscribers

var PortalOpenInstances = function PortalOpenInstances() {
  var _this = this;

  _classCallCheck$5(this, PortalOpenInstances);

  this.register = function (openInstance) {
    if (_this.openInstances.indexOf(openInstance) !== -1) {
      if (process.env.NODE_ENV !== "production") {
        // eslint-disable-next-line no-console
        console.warn("React-Modal: Cannot register modal instance that's already open");
      }
      return;
    }
    _this.openInstances.push(openInstance);
    _this.emit("register");
  };

  this.deregister = function (openInstance) {
    var index = _this.openInstances.indexOf(openInstance);
    if (index === -1) {
      if (process.env.NODE_ENV !== "production") {
        // eslint-disable-next-line no-console
        console.warn("React-Modal: Unable to deregister " + openInstance + " as " + "it was never registered");
      }
      return;
    }
    _this.openInstances.splice(index, 1);
    _this.emit("deregister");
  };

  this.subscribe = function (callback) {
    _this.subscribers.push(callback);
  };

  this.emit = function (eventType) {
    _this.subscribers.forEach(function (subscriber) {
      return subscriber(eventType,
      // shallow copy to avoid accidental mutation
      _this.openInstances.slice());
    });
  };

  this.openInstances = [];
  this.subscribers = [];
};

var portalOpenInstances = new PortalOpenInstances();

/* eslint-disable no-console */
/* istanbul ignore next */
function log$1() {
  console.log("portalOpenInstances ----------");
  console.log(portalOpenInstances.openInstances.length);
  portalOpenInstances.openInstances.forEach(function (p) {
    return console.log(p);
  });
  console.log("end portalOpenInstances ----------");
}

/* istanbul ignore next */
function resetState$1() {
  portalOpenInstances = new PortalOpenInstances();
}
/* eslint-enable no-console */

portalOpenInstances$1.default = portalOpenInstances;

var bodyTrap$1 = {};

Object.defineProperty(bodyTrap$1, "__esModule", {
  value: true
});
bodyTrap$1.resetState = resetState;
bodyTrap$1.log = log;

var _portalOpenInstances = portalOpenInstances$1;

var _portalOpenInstances2 = _interopRequireDefault$8(_portalOpenInstances);

function _interopRequireDefault$8(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Body focus trap see Issue #742

var before = void 0,
    after = void 0,
    instances = [];

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState() {
  var _arr = [before, after];

  for (var _i = 0; _i < _arr.length; _i++) {
    var item = _arr[_i];
    if (!item) continue;
    item.parentNode && item.parentNode.removeChild(item);
  }
  before = after = null;
  instances = [];
}

/* istanbul ignore next */
function log() {
  console.log("bodyTrap ----------");
  console.log(instances.length);
  var _arr2 = [before, after];
  for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
    var item = _arr2[_i2];
    var check = item || {};
    console.log(check.nodeName, check.className, check.id);
  }
  console.log("edn bodyTrap ----------");
}
/* eslint-enable no-console */

function focusContent() {
  if (instances.length === 0) {
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.warn("React-Modal: Open instances > 0 expected");
    }
    return;
  }
  instances[instances.length - 1].focusContent();
}

function bodyTrap(eventType, openInstances) {
  if (!before && !after) {
    before = document.createElement("div");
    before.setAttribute("data-react-modal-body-trap", "");
    before.style.position = "absolute";
    before.style.opacity = "0";
    before.setAttribute("tabindex", "0");
    before.addEventListener("focus", focusContent);
    after = before.cloneNode();
    after.addEventListener("focus", focusContent);
  }

  instances = openInstances;

  if (instances.length > 0) {
    // Add focus trap
    if (document.body.firstChild !== before) {
      document.body.insertBefore(before, document.body.firstChild);
    }
    if (document.body.lastChild !== after) {
      document.body.appendChild(after);
    }
  } else {
    // Remove focus trap
    if (before.parentElement) {
      before.parentElement.removeChild(before);
    }
    if (after.parentElement) {
      after.parentElement.removeChild(after);
    }
  }
}

_portalOpenInstances2.default.subscribe(bodyTrap);

(function (module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = React__default;

	var _propTypes = propTypesExports;

	var _propTypes2 = _interopRequireDefault(_propTypes);

	var _focusManager = focusManager;

	var focusManager$1 = _interopRequireWildcard(_focusManager);

	var _scopeTab = scopeTabExports;

	var _scopeTab2 = _interopRequireDefault(_scopeTab);

	var _ariaAppHider = ariaAppHider$1;

	var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

	var _classList = classList;

	var classList$1 = _interopRequireWildcard(_classList);

	var _safeHTMLElement = safeHTMLElement;

	var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

	var _portalOpenInstances = portalOpenInstances$1;

	var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);



	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	// so that our CSS is statically analyzable
	var CLASS_NAMES = {
	  overlay: "ReactModal__Overlay",
	  content: "ReactModal__Content"
	};

	/**
	 * We need to support the deprecated `KeyboardEvent.keyCode` in addition to
	 * `KeyboardEvent.code` for apps that still support IE11. Can be removed when
	 * `react-modal` only supports React >18 (which dropped IE support).
	 */
	var isTabKey = function isTabKey(event) {
	  return event.code === "Tab" || event.keyCode === 9;
	};
	var isEscKey = function isEscKey(event) {
	  return event.code === "Escape" || event.keyCode === 27;
	};

	var ariaHiddenInstances = 0;

	var ModalPortal = function (_Component) {
	  _inherits(ModalPortal, _Component);

	  function ModalPortal(props) {
	    _classCallCheck(this, ModalPortal);

	    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

	    _this.setOverlayRef = function (overlay) {
	      _this.overlay = overlay;
	      _this.props.overlayRef && _this.props.overlayRef(overlay);
	    };

	    _this.setContentRef = function (content) {
	      _this.content = content;
	      _this.props.contentRef && _this.props.contentRef(content);
	    };

	    _this.afterClose = function () {
	      var _this$props = _this.props,
	          appElement = _this$props.appElement,
	          ariaHideApp = _this$props.ariaHideApp,
	          htmlOpenClassName = _this$props.htmlOpenClassName,
	          bodyOpenClassName = _this$props.bodyOpenClassName,
	          parentSelector = _this$props.parentSelector;


	      var parentDocument = parentSelector && parentSelector().ownerDocument || document;

	      // Remove classes.
	      bodyOpenClassName && classList$1.remove(parentDocument.body, bodyOpenClassName);

	      htmlOpenClassName && classList$1.remove(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);

	      // Reset aria-hidden attribute if all modals have been removed
	      if (ariaHideApp && ariaHiddenInstances > 0) {
	        ariaHiddenInstances -= 1;

	        if (ariaHiddenInstances === 0) {
	          ariaAppHider.show(appElement);
	        }
	      }

	      if (_this.props.shouldFocusAfterRender) {
	        if (_this.props.shouldReturnFocusAfterClose) {
	          focusManager$1.returnFocus(_this.props.preventScroll);
	          focusManager$1.teardownScopedFocus();
	        } else {
	          focusManager$1.popWithoutFocus();
	        }
	      }

	      if (_this.props.onAfterClose) {
	        _this.props.onAfterClose();
	      }

	      _portalOpenInstances2.default.deregister(_this);
	    };

	    _this.open = function () {
	      _this.beforeOpen();
	      if (_this.state.afterOpen && _this.state.beforeClose) {
	        clearTimeout(_this.closeTimer);
	        _this.setState({ beforeClose: false });
	      } else {
	        if (_this.props.shouldFocusAfterRender) {
	          focusManager$1.setupScopedFocus(_this.node);
	          focusManager$1.markForFocusLater();
	        }

	        _this.setState({ isOpen: true }, function () {
	          _this.openAnimationFrame = requestAnimationFrame(function () {
	            _this.setState({ afterOpen: true });

	            if (_this.props.isOpen && _this.props.onAfterOpen) {
	              _this.props.onAfterOpen({
	                overlayEl: _this.overlay,
	                contentEl: _this.content
	              });
	            }
	          });
	        });
	      }
	    };

	    _this.close = function () {
	      if (_this.props.closeTimeoutMS > 0) {
	        _this.closeWithTimeout();
	      } else {
	        _this.closeWithoutTimeout();
	      }
	    };

	    _this.focusContent = function () {
	      return _this.content && !_this.contentHasFocus() && _this.content.focus({ preventScroll: true });
	    };

	    _this.closeWithTimeout = function () {
	      var closesAt = Date.now() + _this.props.closeTimeoutMS;
	      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
	        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
	      });
	    };

	    _this.closeWithoutTimeout = function () {
	      _this.setState({
	        beforeClose: false,
	        isOpen: false,
	        afterOpen: false,
	        closesAt: null
	      }, _this.afterClose);
	    };

	    _this.handleKeyDown = function (event) {
	      if (isTabKey(event)) {
	        (0, _scopeTab2.default)(_this.content, event);
	      }

	      if (_this.props.shouldCloseOnEsc && isEscKey(event)) {
	        event.stopPropagation();
	        _this.requestClose(event);
	      }
	    };

	    _this.handleOverlayOnClick = function (event) {
	      if (_this.shouldClose === null) {
	        _this.shouldClose = true;
	      }

	      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
	        if (_this.ownerHandlesClose()) {
	          _this.requestClose(event);
	        } else {
	          _this.focusContent();
	        }
	      }
	      _this.shouldClose = null;
	    };

	    _this.handleContentOnMouseUp = function () {
	      _this.shouldClose = false;
	    };

	    _this.handleOverlayOnMouseDown = function (event) {
	      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
	        event.preventDefault();
	      }
	    };

	    _this.handleContentOnClick = function () {
	      _this.shouldClose = false;
	    };

	    _this.handleContentOnMouseDown = function () {
	      _this.shouldClose = false;
	    };

	    _this.requestClose = function (event) {
	      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
	    };

	    _this.ownerHandlesClose = function () {
	      return _this.props.onRequestClose;
	    };

	    _this.shouldBeClosed = function () {
	      return !_this.state.isOpen && !_this.state.beforeClose;
	    };

	    _this.contentHasFocus = function () {
	      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
	    };

	    _this.buildClassName = function (which, additional) {
	      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
	        base: CLASS_NAMES[which],
	        afterOpen: CLASS_NAMES[which] + "--after-open",
	        beforeClose: CLASS_NAMES[which] + "--before-close"
	      };
	      var className = classNames.base;
	      if (_this.state.afterOpen) {
	        className = className + " " + classNames.afterOpen;
	      }
	      if (_this.state.beforeClose) {
	        className = className + " " + classNames.beforeClose;
	      }
	      return typeof additional === "string" && additional ? className + " " + additional : className;
	    };

	    _this.attributesFromObject = function (prefix, items) {
	      return Object.keys(items).reduce(function (acc, name) {
	        acc[prefix + "-" + name] = items[name];
	        return acc;
	      }, {});
	    };

	    _this.state = {
	      afterOpen: false,
	      beforeClose: false
	    };

	    _this.shouldClose = null;
	    _this.moveFromContentToOverlay = null;
	    return _this;
	  }

	  _createClass(ModalPortal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.props.isOpen) {
	        this.open();
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (process.env.NODE_ENV !== "production") {
	        if (prevProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
	          // eslint-disable-next-line no-console
	          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
	        }
	        if (prevProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
	          // eslint-disable-next-line no-console
	          console.warn('React-Modal: "htmlOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
	        }
	      }

	      if (this.props.isOpen && !prevProps.isOpen) {
	        this.open();
	      } else if (!this.props.isOpen && prevProps.isOpen) {
	        this.close();
	      }

	      // Focus only needs to be set once when the modal is being opened
	      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
	        this.focusContent();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.state.isOpen) {
	        this.afterClose();
	      }
	      clearTimeout(this.closeTimer);
	      cancelAnimationFrame(this.openAnimationFrame);
	    }
	  }, {
	    key: "beforeOpen",
	    value: function beforeOpen() {
	      var _props = this.props,
	          appElement = _props.appElement,
	          ariaHideApp = _props.ariaHideApp,
	          htmlOpenClassName = _props.htmlOpenClassName,
	          bodyOpenClassName = _props.bodyOpenClassName,
	          parentSelector = _props.parentSelector;


	      var parentDocument = parentSelector && parentSelector().ownerDocument || document;

	      // Add classes.
	      bodyOpenClassName && classList$1.add(parentDocument.body, bodyOpenClassName);

	      htmlOpenClassName && classList$1.add(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);

	      if (ariaHideApp) {
	        ariaHiddenInstances += 1;
	        ariaAppHider.hide(appElement);
	      }

	      _portalOpenInstances2.default.register(this);
	    }

	    // Don't steal focus from inner elements

	  }, {
	    key: "render",
	    value: function render() {
	      var _props2 = this.props,
	          id = _props2.id,
	          className = _props2.className,
	          overlayClassName = _props2.overlayClassName,
	          defaultStyles = _props2.defaultStyles,
	          children = _props2.children;

	      var contentStyles = className ? {} : defaultStyles.content;
	      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

	      if (this.shouldBeClosed()) {
	        return null;
	      }

	      var overlayProps = {
	        ref: this.setOverlayRef,
	        className: this.buildClassName("overlay", overlayClassName),
	        style: _extends({}, overlayStyles, this.props.style.overlay),
	        onClick: this.handleOverlayOnClick,
	        onMouseDown: this.handleOverlayOnMouseDown
	      };

	      var contentProps = _extends({
	        id: id,
	        ref: this.setContentRef,
	        style: _extends({}, contentStyles, this.props.style.content),
	        className: this.buildClassName("content", className),
	        tabIndex: "-1",
	        onKeyDown: this.handleKeyDown,
	        onMouseDown: this.handleContentOnMouseDown,
	        onMouseUp: this.handleContentOnMouseUp,
	        onClick: this.handleContentOnClick,
	        role: this.props.role,
	        "aria-label": this.props.contentLabel
	      }, this.attributesFromObject("aria", _extends({ modal: true }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
	        "data-testid": this.props.testId
	      });

	      var contentElement = this.props.contentElement(contentProps, children);
	      return this.props.overlayElement(overlayProps, contentElement);
	    }
	  }]);

	  return ModalPortal;
	}(_react.Component);

	ModalPortal.defaultProps = {
	  style: {
	    overlay: {},
	    content: {}
	  },
	  defaultStyles: {}
	};
	ModalPortal.propTypes = {
	  isOpen: _propTypes2.default.bool.isRequired,
	  defaultStyles: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  style: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  parentSelector: _propTypes2.default.func,
	  bodyOpenClassName: _propTypes2.default.string,
	  htmlOpenClassName: _propTypes2.default.string,
	  ariaHideApp: _propTypes2.default.bool,
	  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
	  onAfterOpen: _propTypes2.default.func,
	  onAfterClose: _propTypes2.default.func,
	  onRequestClose: _propTypes2.default.func,
	  closeTimeoutMS: _propTypes2.default.number,
	  shouldFocusAfterRender: _propTypes2.default.bool,
	  shouldCloseOnOverlayClick: _propTypes2.default.bool,
	  shouldReturnFocusAfterClose: _propTypes2.default.bool,
	  preventScroll: _propTypes2.default.bool,
	  role: _propTypes2.default.string,
	  contentLabel: _propTypes2.default.string,
	  aria: _propTypes2.default.object,
	  data: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  shouldCloseOnEsc: _propTypes2.default.bool,
	  overlayRef: _propTypes2.default.func,
	  contentRef: _propTypes2.default.func,
	  id: _propTypes2.default.string,
	  overlayElement: _propTypes2.default.func,
	  contentElement: _propTypes2.default.func,
	  testId: _propTypes2.default.string
	};
	exports.default = ModalPortal;
	module.exports = exports["default"];
} (ModalPortal, ModalPortalExports));

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}

var reactLifecyclesCompat_es = /*#__PURE__*/Object.freeze({
    __proto__: null,
    polyfill: polyfill
});

var require$$6 = /*@__PURE__*/getAugmentedNamespace(reactLifecyclesCompat_es);

Object.defineProperty(Modal$2, "__esModule", {
  value: true
});
Modal$2.bodyOpenClassName = Modal$2.portalClassName = undefined;

var _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$3 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react$9 = React__default;

var _react2 = _interopRequireDefault$7(_react$9);

var _reactDom = require$$1__default;

var _reactDom2 = _interopRequireDefault$7(_reactDom);

var _propTypes$3 = propTypesExports;

var _propTypes2 = _interopRequireDefault$7(_propTypes$3);

var _ModalPortal = ModalPortalExports;

var _ModalPortal2 = _interopRequireDefault$7(_ModalPortal);

var _ariaAppHider = ariaAppHider$1;

var ariaAppHider = _interopRequireWildcard$1(_ariaAppHider);

var _safeHTMLElement = safeHTMLElement;

var _safeHTMLElement2 = _interopRequireDefault$7(_safeHTMLElement);

var _reactLifecyclesCompat = require$$6;

function _interopRequireWildcard$1(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault$7(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$4(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$1(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$1(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = Modal$2.portalClassName = "ReactModalPortal";
var bodyOpenClassName = Modal$2.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = _safeHTMLElement.canUseDOM && _reactDom2.default.createPortal !== undefined;

var createHTMLElement = function createHTMLElement(name) {
  return document.createElement(name);
};

var getCreatePortal = function getCreatePortal() {
  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
};

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal$1 = function (_Component) {
  _inherits$1(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck$4(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$1(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      if (parent && parent.contains(_this.node)) {
        parent.removeChild(_this.node);
      } else {
        // eslint-disable-next-line no-console
        console.warn('React-Modal: "parentSelector" prop did not returned any DOM ' + "element. Make sure that the parent element is unmounted to " + "avoid any memory leaks.");
      }
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var createPortal = getCreatePortal();
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends$2({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn$1(_this, _ret);
  }

  _createClass$3(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = createHTMLElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return { prevParent: prevParent, nextParent: nextParent };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _, snapshot) {
      if (!_safeHTMLElement.canUseDOM) return;
      var _props = this.props,
          isOpen = _props.isOpen,
          portalClassName = _props.portalClassName;


      if (prevProps.portalClassName !== portalClassName) {
        this.node.className = portalClassName;
      }

      var prevParent = snapshot.prevParent,
          nextParent = snapshot.nextParent;

      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      }

      // Stop unnecessary renders if modal is remaining closed
      if (!prevProps.isOpen && !isOpen) return;

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = createHTMLElement("div");
      }

      var createPortal = getCreatePortal();
      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends$2({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react$9.Component);

Modal$1.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func
};
Modal$1.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  role: "dialog",
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  preventScroll: false,
  parentSelector: function parentSelector() {
    return document.body;
  },
  overlayElement: function overlayElement(props, contentEl) {
    return _react2.default.createElement(
      "div",
      props,
      contentEl
    );
  },
  contentElement: function contentElement(props, children) {
    return _react2.default.createElement(
      "div",
      props,
      children
    );
  }
};
Modal$1.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};


(0, _reactLifecyclesCompat.polyfill)(Modal$1);

if (process.env.NODE_ENV !== "production") {
  Modal$1.setCreateHTMLElement = function (fn) {
    return createHTMLElement = fn;
  };
}

Modal$2.default = Modal$1;

(function (module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _Modal = Modal$2;

	var _Modal2 = _interopRequireDefault(_Modal);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _Modal2.default;
	module.exports = exports["default"];
} (lib, libExports));

var Modal = /*@__PURE__*/getDefaultExportFromCjs(libExports);

var BlcModal = function (_a) {
    var _b = _a.isOpen, isOpen = _b === void 0 ? false : _b, closeModal = _a.closeModal, className = _a.className, modalId = _a.modalId, _c = _a.noHeader, noHeader = _c === void 0 ? false : _c, _d = _a.noFooter, noFooter = _d === void 0 ? false : _d, customFooter = _a.customFooter, _e = _a.modalTitleContent, modalTitleContent = _e === void 0 ? null : _e, _f = _a.modalTitle, modalTitle = _f === void 0 ? 'Title' : _f, _g = _a.type, type = _g === void 0 ? TypeEnum.dialog : _g, _h = _a.fullHeight, fullHeight = _h === void 0 ? false : _h, _j = _a.height, height = _j === void 0 ? 'auto' : _j, width = _a.width, padding = _a.padding, _k = _a.fullpageModal, fullpageModal = _k === void 0 ? false : _k, hideScrollBar = _a.hideScrollBar, _l = _a.iconClose, iconClose = _l === void 0 ? null : _l, _m = _a.showCancel, showCancel = _m === void 0 ? true : _m, _o = _a.cancelCopy, cancelCopy = _o === void 0 ? 'Cancel' : _o, _p = _a.showAction, showAction = _p === void 0 ? false : _p, _q = _a.actionCopy, actionCopy = _q === void 0 ? 'Action' : _q, _r = _a.showConfirm, showConfirm = _r === void 0 ? true : _r, _s = _a.confirmCopy, confirmCopy = _s === void 0 ? 'Confirm' : _s, _t = _a.loadingConfirm, loadingConfirm = _t === void 0 ? false : _t, _u = _a.disableAction, disableAction = _u === void 0 ? false : _u, _v = _a.disableConfirm, disableConfirm = _v === void 0 ? false : _v, actionFunction = _a.actionFunction, confirmFunction = _a.confirmFunction, closeFunction = _a.closeFunction, confirmClassName = _a.confirmClassName, actionClassName = _a.actionClassName, cancelClassName = _a.cancelClassName, props = __rest(_a, ["isOpen", "closeModal", "className", "modalId", "noHeader", "noFooter", "customFooter", "modalTitleContent", "modalTitle", "type", "fullHeight", "height", "width", "padding", "fullpageModal", "hideScrollBar", "iconClose", "showCancel", "cancelCopy", "showAction", "actionCopy", "showConfirm", "confirmCopy", "loadingConfirm", "disableAction", "disableConfirm", "actionFunction", "confirmFunction", "closeFunction", "confirmClassName", "actionClassName", "cancelClassName"]);
    return (jsxs(Modal, __assign({ ariaHideApp: false, isOpen: isOpen, onRequestClose: closeModal, className: className ? "BlcModal ".concat(className) : 'BlcModal', overlayClassName: "BlcModalOverlay", bodyOpenClassName: "BlcModalOpenBody", id: modalId, contentElement: function (elmProps, children) { return (jsx(ModalStyle, __assign({}, elmProps, { type: type, fullHeight: fullHeight, height: height, width: width }, props, { children: children }))); }, overlayElement: function (elmProps, contentElement) { return (jsx(OverlayStyle, __assign({}, elmProps, { type: type }, props, { fullpageModal: fullpageModal }, { children: contentElement }))); } }, { children: [!noHeader && jsx(ModalHeader, __assign({}, { modalTitleContent: modalTitleContent, modalTitle: modalTitle, closeModal: closeModal, type: type, iconClose: iconClose })), jsx(ModalContent, __assign({ padding: padding }, { children: props.children, fullpageModal: fullpageModal, hideScrollBar: hideScrollBar })), !noFooter && !customFooter && (jsx(ModalFooter, __assign({}, {
                showCancel: showCancel,
                showAction: showAction,
                showConfirm: showConfirm,
                disableAction: disableAction,
                disableConfirm: disableConfirm,
                actionCopy: actionCopy,
                cancelCopy: cancelCopy,
                confirmCopy: confirmCopy,
                loadingConfirm: loadingConfirm,
                actionFunction: actionFunction,
                confirmFunction: confirmFunction,
                closeFunction: closeFunction,
                closeModal: closeModal,
                confirmClassName: confirmClassName,
                actionClassName: actionClassName,
                cancelClassName: cancelClassName
            }))), isValidElement(customFooter) && customFooter] })));
};

var getPadding = function (name, media) {
    return getSize$2({ tag: 'buttonPaddings', name: name, media: media, defaultValue: 'zero' });
};
/**
 * Paddings
* /

* Media queries: */
var buttonPadding = function (name) {
    return getPadding(name, 'mxl');
};
var buttonPaddingML = function (name) {
    return getPadding(name, 'ml');
};
var buttonPaddingMS = function (name) {
    return getPadding(name, 'ms');
};
var buttonPaddingMXS = function (name) {
    return getPadding(name, 'mxs');
};

var reactPaginateExports = {};
var reactPaginate = {
  get exports(){ return reactPaginateExports; },
  set exports(v){ reactPaginateExports = v; },
};

(function (module, exports) {
	!function(e,t){module.exports=t(React__default);}(commonjsGlobal,(e=>(()=>{var t={703:(e,t,a)=>{var r=a(414);function n(){}function i(){}i.resetWarningCache=n,e.exports=function(){function e(e,t,a,n,i,o){if(o!==r){var s=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw s.name="Invariant Violation",s}}function t(){return e}e.isRequired=e;var a={array:e,bigint:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,elementType:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t,checkPropTypes:i,resetWarningCache:n};return a.PropTypes=a,a};},697:(e,t,a)=>{e.exports=a(703)();},414:e=>{e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";},98:t=>{t.exports=e;}},a={};function r(e){var n=a[e];if(void 0!==n)return n.exports;var i=a[e]={exports:{}};return t[e](i,i.exports,r),i.exports}r.n=e=>{var t=e&&e.__esModule?()=>e.default:()=>e;return r.d(t,{a:t}),t},r.d=(e,t)=>{for(var a in t)r.o(t,a)&&!r.o(e,a)&&Object.defineProperty(e,a,{enumerable:!0,get:t[a]});},r.o=(e,t)=>Object.prototype.hasOwnProperty.call(e,t),r.r=e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0});};var n={};return (()=>{r.r(n),r.d(n,{default:()=>k});var e=r(98),t=r.n(e),a=r(697),i=r.n(a);function o(){return o=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var a=arguments[t];for(var r in a)Object.prototype.hasOwnProperty.call(a,r)&&(e[r]=a[r]);}return e},o.apply(this,arguments)}var s=function(e){var a=e.pageClassName,r=e.pageLinkClassName,n=e.page,i=e.selected,s=e.activeClassName,l=e.activeLinkClassName,c=e.getEventListener,p=e.pageSelectedHandler,u=e.href,g=e.extraAriaContext,d=e.pageLabelBuilder,f=e.rel,v=e.ariaLabel||"Page "+n+(g?" "+g:""),b=null;return i&&(b="page",v=e.ariaLabel||"Page "+n+" is your current page",a=void 0!==a?a+" "+s:s,void 0!==r?void 0!==l&&(r=r+" "+l):r=l),t().createElement("li",{className:a},t().createElement("a",o({rel:f,role:u?void 0:"button",className:r,href:u,tabIndex:i?"-1":"0","aria-label":v,"aria-current":b,onKeyPress:p},c(p)),d(n)))};s.propTypes={pageSelectedHandler:i().func.isRequired,selected:i().bool.isRequired,pageClassName:i().string,pageLinkClassName:i().string,activeClassName:i().string,activeLinkClassName:i().string,extraAriaContext:i().string,href:i().string,ariaLabel:i().string,page:i().number.isRequired,getEventListener:i().func.isRequired,pageLabelBuilder:i().func.isRequired,rel:i().string};const l=s;function c(){return c=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var a=arguments[t];for(var r in a)Object.prototype.hasOwnProperty.call(a,r)&&(e[r]=a[r]);}return e},c.apply(this,arguments)}var p=function(e){var a=e.breakLabel,r=e.breakClassName,n=e.breakLinkClassName,i=e.breakHandler,o=e.getEventListener,s=r||"break";return t().createElement("li",{className:s},t().createElement("a",c({className:n,role:"button",tabIndex:"0",onKeyPress:i},o(i)),a))};p.propTypes={breakLabel:i().oneOfType([i().string,i().node]),breakClassName:i().string,breakLinkClassName:i().string,breakHandler:i().func.isRequired,getEventListener:i().func.isRequired};const u=p;function g(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"";return null!=e?e:t}function d(e){return d="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},d(e)}function f(){return f=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var a=arguments[t];for(var r in a)Object.prototype.hasOwnProperty.call(a,r)&&(e[r]=a[r]);}return e},f.apply(this,arguments)}function v(e,t){for(var a=0;a<t.length;a++){var r=t[a];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r);}}function b(e,t){return b=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(e,t){return e.__proto__=t,e},b(e,t)}function h(e,t){if(t&&("object"===d(t)||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return m(e)}function m(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function y(e){return y=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(e){return e.__proto__||Object.getPrototypeOf(e)},y(e)}function C(e,t,a){return t in e?Object.defineProperty(e,t,{value:a,enumerable:!0,configurable:!0,writable:!0}):e[t]=a,e}var P=function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),Object.defineProperty(e,"prototype",{writable:!1}),t&&b(e,t);}(s,e);var a,r,n,i,o=(n=s,i=function(){if("undefined"==typeof Reflect||!Reflect.construct)return !1;if(Reflect.construct.sham)return !1;if("function"==typeof Proxy)return !0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return !1}}(),function(){var e,t=y(n);if(i){var a=y(this).constructor;e=Reflect.construct(t,arguments,a);}else e=t.apply(this,arguments);return h(this,e)});function s(e){var a,r;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,s),C(m(a=o.call(this,e)),"handlePreviousPage",(function(e){var t=a.state.selected;a.handleClick(e,null,t>0?t-1:void 0,{isPrevious:!0});})),C(m(a),"handleNextPage",(function(e){var t=a.state.selected,r=a.props.pageCount;a.handleClick(e,null,t<r-1?t+1:void 0,{isNext:!0});})),C(m(a),"handlePageSelected",(function(e,t){if(a.state.selected===e)return a.callActiveCallback(e),void a.handleClick(t,null,void 0,{isActive:!0});a.handleClick(t,null,e);})),C(m(a),"handlePageChange",(function(e){a.state.selected!==e&&(a.setState({selected:e}),a.callCallback(e));})),C(m(a),"getEventListener",(function(e){return C({},a.props.eventListener,e)})),C(m(a),"handleClick",(function(e,t,r){var n=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{},i=n.isPrevious,o=void 0!==i&&i,s=n.isNext,l=void 0!==s&&s,c=n.isBreak,p=void 0!==c&&c,u=n.isActive,g=void 0!==u&&u;e.preventDefault?e.preventDefault():e.returnValue=!1;var d=a.state.selected,f=a.props.onClick,v=r;if(f){var b=f({index:t,selected:d,nextSelectedPage:r,event:e,isPrevious:o,isNext:l,isBreak:p,isActive:g});if(!1===b)return;Number.isInteger(b)&&(v=b);}void 0!==v&&a.handlePageChange(v);})),C(m(a),"handleBreakClick",(function(e,t){var r=a.state.selected;a.handleClick(t,e,r<e?a.getForwardJump():a.getBackwardJump(),{isBreak:!0});})),C(m(a),"callCallback",(function(e){void 0!==a.props.onPageChange&&"function"==typeof a.props.onPageChange&&a.props.onPageChange({selected:e});})),C(m(a),"callActiveCallback",(function(e){void 0!==a.props.onPageActive&&"function"==typeof a.props.onPageActive&&a.props.onPageActive({selected:e});})),C(m(a),"getElementPageRel",(function(e){var t=a.state.selected,r=a.props,n=r.nextPageRel,i=r.prevPageRel,o=r.selectedPageRel;return t-1===e?i:t===e?o:t+1===e?n:void 0})),C(m(a),"pagination",(function(){var e=[],r=a.props,n=r.pageRangeDisplayed,i=r.pageCount,o=r.marginPagesDisplayed,s=r.breakLabel,l=r.breakClassName,c=r.breakLinkClassName,p=a.state.selected;if(i<=n)for(var g=0;g<i;g++)e.push(a.getPageElement(g));else {var d=n/2,f=n-d;p>i-n/2?d=n-(f=i-p):p<n/2&&(f=n-(d=p));var v,b,h=function(e){return a.getPageElement(e)},m=[];for(v=0;v<i;v++){var y=v+1;y<=o||y>i-o||v>=p-d&&v<=p+(0===p&&n>1?f-1:f)?m.push({type:"page",index:v,display:h(v)}):s&&m.length>0&&m[m.length-1].display!==b&&(n>0||o>0)&&(b=t().createElement(u,{key:v,breakLabel:s,breakClassName:l,breakLinkClassName:c,breakHandler:a.handleBreakClick.bind(null,v),getEventListener:a.getEventListener}),m.push({type:"break",index:v,display:b}));}m.forEach((function(t,a){var r=t;"break"===t.type&&m[a-1]&&"page"===m[a-1].type&&m[a+1]&&"page"===m[a+1].type&&m[a+1].index-m[a-1].index<=2&&(r={type:"page",index:t.index,display:h(t.index)}),e.push(r.display);}));}return e})),void 0!==e.initialPage&&void 0!==e.forcePage&&console.warn("(react-paginate): Both initialPage (".concat(e.initialPage,") and forcePage (").concat(e.forcePage,") props are provided, which is discouraged.")+" Use exclusively forcePage prop for a controlled component.\nSee https://reactjs.org/docs/forms.html#controlled-components"),r=e.initialPage?e.initialPage:e.forcePage?e.forcePage:0,a.state={selected:r},a}return a=s,(r=[{key:"componentDidMount",value:function(){var e=this.props,t=e.initialPage,a=e.disableInitialCallback,r=e.extraAriaContext,n=e.pageCount,i=e.forcePage;void 0===t||a||this.callCallback(t),r&&console.warn("DEPRECATED (react-paginate): The extraAriaContext prop is deprecated. You should now use the ariaLabelBuilder instead."),Number.isInteger(n)||console.warn("(react-paginate): The pageCount prop value provided is not an integer (".concat(n,"). Did you forget a Math.ceil()?")),void 0!==t&&t>n-1&&console.warn("(react-paginate): The initialPage prop provided is greater than the maximum page index from pageCount prop (".concat(t," > ").concat(n-1,").")),void 0!==i&&i>n-1&&console.warn("(react-paginate): The forcePage prop provided is greater than the maximum page index from pageCount prop (".concat(i," > ").concat(n-1,")."));}},{key:"componentDidUpdate",value:function(e){void 0!==this.props.forcePage&&this.props.forcePage!==e.forcePage&&(this.props.forcePage>this.props.pageCount-1&&console.warn("(react-paginate): The forcePage prop provided is greater than the maximum page index from pageCount prop (".concat(this.props.forcePage," > ").concat(this.props.pageCount-1,").")),this.setState({selected:this.props.forcePage})),Number.isInteger(e.pageCount)&&!Number.isInteger(this.props.pageCount)&&console.warn("(react-paginate): The pageCount prop value provided is not an integer (".concat(this.props.pageCount,"). Did you forget a Math.ceil()?"));}},{key:"getForwardJump",value:function(){var e=this.state.selected,t=this.props,a=t.pageCount,r=e+t.pageRangeDisplayed;return r>=a?a-1:r}},{key:"getBackwardJump",value:function(){var e=this.state.selected-this.props.pageRangeDisplayed;return e<0?0:e}},{key:"getElementHref",value:function(e){var t=this.props,a=t.hrefBuilder,r=t.pageCount,n=t.hrefAllControls;if(a)return n||e>=0&&e<r?a(e+1,r,this.state.selected):void 0}},{key:"ariaLabelBuilder",value:function(e){var t=e===this.state.selected;if(this.props.ariaLabelBuilder&&e>=0&&e<this.props.pageCount){var a=this.props.ariaLabelBuilder(e+1,t);return this.props.extraAriaContext&&!t&&(a=a+" "+this.props.extraAriaContext),a}}},{key:"getPageElement",value:function(e){var a=this.state.selected,r=this.props,n=r.pageClassName,i=r.pageLinkClassName,o=r.activeClassName,s=r.activeLinkClassName,c=r.extraAriaContext,p=r.pageLabelBuilder;return t().createElement(l,{key:e,pageSelectedHandler:this.handlePageSelected.bind(null,e),selected:a===e,rel:this.getElementPageRel(e),pageClassName:n,pageLinkClassName:i,activeClassName:o,activeLinkClassName:s,extraAriaContext:c,href:this.getElementHref(e),ariaLabel:this.ariaLabelBuilder(e),page:e+1,pageLabelBuilder:p,getEventListener:this.getEventListener})}},{key:"render",value:function(){var e=this.props.renderOnZeroPageCount;if(0===this.props.pageCount&&void 0!==e)return e?e(this.props):e;var a=this.props,r=a.disabledClassName,n=a.disabledLinkClassName,i=a.pageCount,o=a.className,s=a.containerClassName,l=a.previousLabel,c=a.previousClassName,p=a.previousLinkClassName,u=a.previousAriaLabel,d=a.prevRel,v=a.nextLabel,b=a.nextClassName,h=a.nextLinkClassName,m=a.nextAriaLabel,y=a.nextRel,C=this.state.selected,P=0===C,k=C===i-1,x="".concat(g(c)).concat(P?" ".concat(g(r)):""),N="".concat(g(b)).concat(k?" ".concat(g(r)):""),L="".concat(g(p)).concat(P?" ".concat(g(n)):""),O="".concat(g(h)).concat(k?" ".concat(g(n)):""),R=P?"true":"false",E=k?"true":"false";return t().createElement("ul",{className:o||s,role:"navigation","aria-label":"Pagination"},t().createElement("li",{className:x},t().createElement("a",f({className:L,href:this.getElementHref(C-1),tabIndex:P?"-1":"0",role:"button",onKeyPress:this.handlePreviousPage,"aria-disabled":R,"aria-label":u,rel:d},this.getEventListener(this.handlePreviousPage)),l)),this.pagination(),t().createElement("li",{className:N},t().createElement("a",f({className:O,href:this.getElementHref(C+1),tabIndex:k?"-1":"0",role:"button",onKeyPress:this.handleNextPage,"aria-disabled":E,"aria-label":m,rel:y},this.getEventListener(this.handleNextPage)),v)))}}])&&v(a.prototype,r),Object.defineProperty(a,"prototype",{writable:!1}),s}(e.Component);C(P,"propTypes",{pageCount:i().number.isRequired,pageRangeDisplayed:i().number,marginPagesDisplayed:i().number,previousLabel:i().node,previousAriaLabel:i().string,prevPageRel:i().string,prevRel:i().string,nextLabel:i().node,nextAriaLabel:i().string,nextPageRel:i().string,nextRel:i().string,breakLabel:i().oneOfType([i().string,i().node]),hrefBuilder:i().func,hrefAllControls:i().bool,onPageChange:i().func,onPageActive:i().func,onClick:i().func,initialPage:i().number,forcePage:i().number,disableInitialCallback:i().bool,containerClassName:i().string,className:i().string,pageClassName:i().string,pageLinkClassName:i().string,pageLabelBuilder:i().func,activeClassName:i().string,activeLinkClassName:i().string,previousClassName:i().string,nextClassName:i().string,previousLinkClassName:i().string,nextLinkClassName:i().string,disabledClassName:i().string,disabledLinkClassName:i().string,breakClassName:i().string,breakLinkClassName:i().string,extraAriaContext:i().string,ariaLabelBuilder:i().func,eventListener:i().string,renderOnZeroPageCount:i().func,selectedPageRel:i().string}),C(P,"defaultProps",{pageRangeDisplayed:2,marginPagesDisplayed:3,activeClassName:"selected",previousLabel:"Previous",previousClassName:"previous",previousAriaLabel:"Previous page",prevPageRel:"prev",prevRel:"prev",nextLabel:"Next",nextClassName:"next",nextAriaLabel:"Next page",nextPageRel:"next",nextRel:"next",breakLabel:"...",disabledClassName:"disabled",disableInitialCallback:!1,pageLabelBuilder:function(e){return e},eventListener:"onClick",renderOnZeroPageCount:void 0,selectedPageRel:"canonical",hrefAllControls:!1});const k=P;})(),n})()));
	
} (reactPaginate));

var ReactPaginate = /*@__PURE__*/getDefaultExportFromCjs(reactPaginateExports);

/* eslint-disable max-len */
var StyledReactPaginate = styled(ReactPaginate)(function (props) {
    var _a;
    return (_a = {
            display: 'flex',
            justifyContent: 'center',
            padding: 0,
            margin: getSpaceMXL(props.margin),
            fontFamily: fontFamily,
            '.BlcPaginationBreak, .BlcPaginationNext, .BlcPaginationPrevious, .BlcPaginationLink': {
                color: getTextColor(props.color) || colorText.colorTextTextPrimary,
                fontSize: getTextSizeMXL(props.size || 'normal'),
                padding: buttonPadding(props.size || 'normal'),
                display: 'inline-block',
                margin: '0 8px',
                fontWeight: 'normal'
            },
            '.BlcPaginationPage:hover .BlcPaginationLink, .BlcPaginationPage:hover .BlcPaginationBreak, .BlcPaginationPage:hover .BlcPaginationNext, .BlcPaginationPage:hover .BlcPaginationPrevious': {
                backgroundColor: getLegacyColor(props.background)
            },
            '.BlcPaginationNext, .BlcPaginationPrevious, .BlcPaginationPage': {
                cursor: 'pointer',
                fontWeight: getFontWeight('bold'),
                listStyleType: 'none',
                display: 'flex',
                alignItems: 'center'
            },
            '.BlcPaginationDisabled button': {
                cursor: 'not-allowed',
                pointerEvents: 'none'
            },
            '.BlcPaginationDisabled:hover': {
                cursor: 'not-allowed'
            },
            '.BlcPaginationBreak': {
                fontWeight: getFontWeight('bold'),
                pointerEvents: 'none'
            },
            '.BlcPaginationActive .BlcPaginationLink, .BlcPaginationPage:hover .BlcPaginationActive': {
                color: getTextColor(props.colorActive) || colorText.colorTextTextPrimary,
                borderBottomStyle: 'solid',
                borderBottomWidth: sizeMap.line.mxl,
                borderBottomColor: getBorderColor(props.borderColorActive) || colorBorder.colorBorderBorderSecondary,
                cursor: 'default',
                fontWeight: 'bold'
            },
            '.BlcPaginationLink:focus, .BlcPaginationBreak a:focus, .BlcPaginationNext a:focus, .BlcPaginationPrevious a:focus': {
                outline: 'none'
            }
        },
        _a["@media ".concat(mediaSizeMap.larger)] = {
            margin: "".concat(getSpaceML(props.margin), " auto"),
            '.BlcPaginationActive .BlcPaginationLink, .BlcPaginationPage:hover .BlcPaginationActive': {
                borderBottomWidth: sizeMap.line.ml
            },
            '.BlcPaginationBreak, .BlcPaginationNext, .BlcPaginationPrevious, .BlcPaginationLink': {
                fontSize: getTextSizeML(props.size || 'inherit'),
                padding: buttonPaddingML(props.size || 'inherit')
            }
        },
        _a["@media ".concat(mediaSizeMap.smaller)] = {
            margin: "".concat(getSpaceMS(props.margin), " auto"),
            '.BlcPaginationActive .BlcPaginationLink, .BlcPaginationPage:hover .BlcPaginationActive': {
                borderBottomWidth: sizeMap.line.ms
            },
            '.BlcPaginationBreak, .BlcPaginationNext, .BlcPaginationPrevious, .BlcPaginationLink': {
                fontSize: getTextSizeMS(props.size || 'inherit'),
                padding: buttonPaddingMS(props.size || 'inherit')
            }
        },
        _a["@media ".concat(mediaSizeMap.smallest)] = {
            margin: "".concat(getSpaceMXS(props.margin), " auto"),
            '.BlcPaginationActive .BlcPaginationLink, .BlcPaginationPage:hover .BlcPaginationActive': {
                borderBottomWidth: sizeMap.line.mxs
            },
            '.BlcPaginationBreak, .BlcPaginationNext, .BlcPaginationPrevious, .BlcPaginationLink': {
                fontSize: getTextSizeMXS(props.size || 'inherit'),
                padding: buttonPaddingMXS(props.size || 'inherit')
            }
        },
        _a);
});

var BlcPagination = function (_a) {
    var initialPage = _a.initialPage, page = _a.page, marginPagesDisplayed = _a.marginPagesDisplayed, pageRangeDisplayed = _a.pageRangeDisplayed, pageCount = _a.pageCount, color = _a.color, borderColorActive = _a.borderColorActive, colorActive = _a.colorActive, size = _a.size, margin = _a.margin, background = _a.background, disableInitialCallback = _a.disableInitialCallback, handlePageChange = _a.handlePageChange, pageLabelBuilder = _a.pageLabelBuilder;
    var _b = useState(page), pageIndex = _b[0], setPageIndex = _b[1];
    var onHandlePageChange = function (selectedItem) {
        setPageIndex(selectedItem.selected);
        if (handlePageChange) {
            handlePageChange(selectedItem);
        }
    };
    useEffect(function () {
        setPageIndex(page);
    }, [page]);
    return (jsx(StyledReactPaginate, { initialPage: initialPage, forcePage: pageIndex, pageClassName: "BlcPaginationPage", pageLinkClassName: "BlcPaginationLink", breakLabel: "\u2026", breakClassName: "BlcPaginationBreak", activeClassName: "BlcPaginationActive", disabledClassName: "BlcPaginationDisabled", marginPagesDisplayed: marginPagesDisplayed, pageRangeDisplayed: pageRangeDisplayed, pageCount: pageCount, nextClassName: "BlcPaginationNext", nextLabel: jsx(Button, { iconColor: color, iconSize: size, variant: "floating-icon", icon: "caret-right", "aria-label": "Next", "data-testid": "next" }), previousClassName: "BlcPaginationPrevious", previousLabel: jsx(Button, { iconColor: color, iconSize: size, variant: "floating-icon", icon: "caret-left", "aria-label": "Previous", "data-testid": "previous" }), onPageChange: onHandlePageChange, borderColorActive: borderColorActive, color: color, colorActive: colorActive, margin: margin, background: background, size: size, pageLabelBuilder: pageLabelBuilder, disableInitialCallback: disableInitialCallback }));
};
BlcPagination.defaultProps = {
    marginPagesDisplayed: 3,
    pageRangeDisplayed: 2,
    pageCount: 1,
    background: 'grayLight',
    color: 'grayDark',
    borderColorActive: 'primary',
    colorActive: 'fontColor',
    margin: 'normal',
    size: 'smaller',
    disableInitialCallback: false
};

var pricify = function (price, addCurrencySymbol) {
    if (addCurrencySymbol === void 0) { addCurrencySymbol = true; }
    var formattedPrice = Number(price || 0).toLocaleString('en-US');
    return addCurrencySymbol ? "$".concat(formattedPrice) : formattedPrice;
};

var _path, _g, _path2, _defs;
function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
var SvgNoImage = function SvgNoImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    width: 63,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h63v48H0V0Z",
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#no_image_svg__a)",
    fill: "#CDCFD1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.375 22.125a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.75 12.75h22.5v22.5h-22.5v-22.5ZM23 15v14.159l4.5-4.5 2.063 2.063L35 21.284l6 6V15H23Zm0 18v-.659l4.5-4.5L32.659 33H23Zm18 0h-5.159l-4.688-4.688L35 24.466l6 6V33Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-1h-1v1h1Zm63 0h1v-1h-1v1Zm0 48v1h1v-1h-1ZM0 48h-1v1h1v-1ZM0 1h63v-2H0v2Zm62-1v48h2V0h-2Zm1 47H0v2h63v-2ZM1 48V0h-2v48h2Z",
    fill: "#CDCFD1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "no_image_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(20 12)",
    d: "M0 0h24v24H0z"
  })))));
};

var Link = styled.a(templateObject_1$1t || (templateObject_1$1t = __makeTemplateObject(["\n  text-decoration: none;\n"], ["\n  text-decoration: none;\n"])));
var Container$d = styled.div(templateObject_2$H || (templateObject_2$H = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  justify-content: ", ";\n  border-color: ", ";\n  border-width: ", ";\n  border-style: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  justify-content: ", ";\n  border-color: ", ";\n  border-width: ", ";\n  border-style: ", ";\n"])), function (props) { return (props.gap ? props.gap : 'auto'); }, function (props) { return (props.flexStart ? 'flex-start' : 'space-between'); }, colorBorder$1.colorBorderBorderPrimary, function (props) { return (props.border ? sizeMap.line.mxs : '0px'); }, function (props) { return (props.border ? 'solid' : 'none'); });
var Image$1 = styled.img(templateObject_3$m || (templateObject_3$m = __makeTemplateObject(["\n  max-width: 100%;\n  height: 64px;\n  margin: ", ";\n"], ["\n  max-width: 100%;\n  height: 64px;\n  margin: ", ";\n"])), getSpaceMXS('smaller'));
var templateObject_1$1t, templateObject_2$H, templateObject_3$m;

var BlcSalesCard = function (_a) {
    var title = _a.title, price = _a.price, date = _a.date, imageSrc = _a.imageSrc, height = _a.height, href = _a.href;
    return (jsx(Link, __assign({ href: href }, { children: jsxs(Container$d, __assign({ border: true }, { children: [jsxs(Container$d, __assign({ flexStart: true, gap: "8px" }, { children: [jsx(FlexBox, __assign({ width: 90 }, { children: jsx(Image$1, { src: imageSrc || SvgNoImage, alt: title }) })), jsx(FlexBox, __assign({ height: height }, { children: jsx(Body, __assign({ id: "title", bold: true }, { children: title })) }))] })), jsxs(FlexBox, __assign({ height: height, alignItems: "space-between", justifyContent: "space-between", flexDirection: "column", margin: getSpaceMXS('smaller') }, { children: [jsx(Headline, __assign({ size: "H6", textAlign: "right" }, { children: pricify(price) })), jsx(Body, __assign({ id: "date", color: "grayDark", textAlign: "right" }, { children: date }))] }))] })) })));
};

var PricingTierContainer = styled.div(templateObject_1$1s || (templateObject_1$1s = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
var TitleContainer = styled.div(templateObject_2$G || (templateObject_2$G = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var IconContainer$2 = styled.div(templateObject_3$l || (templateObject_3$l = __makeTemplateObject(["\n  margin: 0 10px;\n  display: flex;\n  align-items: center;\n"], ["\n  margin: 0 10px;\n  display: flex;\n  align-items: center;\n"])));
var InfoContainer = styled.div(templateObject_4$c || (templateObject_4$c = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var BadgeContainer = styled.div(templateObject_5$5 || (templateObject_5$5 = __makeTemplateObject(["\n  margin-right: 5px;\n"], ["\n  margin-right: 5px;\n"])));
var TextContainer$1 = styled.div(templateObject_6$4 || (templateObject_6$4 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  max-width: 230px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  max-width: 230px;\n"])));
var Container$c = styled.div(templateObject_7$2 || (templateObject_7$2 = __makeTemplateObject([""], [""])));
var templateObject_1$1s, templateObject_2$G, templateObject_3$l, templateObject_4$c, templateObject_5$5, templateObject_6$4, templateObject_7$2;

const sides = ['top', 'right', 'bottom', 'left'];
const alignments = ['start', 'end'];
const placements$1 = /*#__PURE__*/sides.reduce((acc, side) => acc.concat(side, side + "-" + alignments[0], side + "-" + alignments[1]), []);
const min$3 = Math.min;
const max$3 = Math.max;
const oppositeSideMap = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
const oppositeAlignmentMap = {
  start: 'end',
  end: 'start'
};
function clamp(start, value, end) {
  return max$3(start, min$3(value, end));
}
function evaluate(value, param) {
  return typeof value === 'function' ? value(param) : value;
}
function getSide(placement) {
  return placement.split('-')[0];
}
function getAlignment(placement) {
  return placement.split('-')[1];
}
function getOppositeAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
function getAxisLength(axis) {
  return axis === 'y' ? 'height' : 'width';
}
function getSideAxis(placement) {
  return ['top', 'bottom'].includes(getSide(placement)) ? 'y' : 'x';
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement$1(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement$1(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement$1(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, alignment => oppositeAlignmentMap[alignment]);
}
function getSideList(side, isStart, rtl) {
  const lr = ['left', 'right'];
  const rl = ['right', 'left'];
  const tb = ['top', 'bottom'];
  const bt = ['bottom', 'top'];
  switch (side) {
    case 'top':
    case 'bottom':
      if (rtl) return isStart ? rl : lr;
      return isStart ? lr : rl;
    case 'left':
    case 'right':
      return isStart ? tb : bt;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list = getSideList(getSide(placement), direction === 'start', rtl);
  if (alignment) {
    list = list.map(side => side + "-" + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
  }
  return list;
}
function getOppositePlacement$1(placement) {
  return placement.replace(/left|right|bottom|top/g, side => oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}
function getPaddingObject(padding) {
  return typeof padding !== 'number' ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect$1(rect) {
  return {
    ...rect,
    top: rect.y,
    left: rect.x,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  };
}

function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference,
    floating
  } = _ref;
  const sideAxis = getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = getSide(placement);
  const isVertical = sideAxis === 'y';
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case 'top':
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case 'bottom':
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case 'right':
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case 'left':
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (getAlignment(placement)) {
    case 'start':
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case 'end':
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain positioning strategy.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */
const computePosition$1 = async (reference, floating, config) => {
  const {
    placement = 'bottom',
    strategy = 'absolute',
    middleware = [],
    platform
  } = config;
  const validMiddleware = middleware.filter(Boolean);
  const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
  let rects = await platform.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x,
    y
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i = 0; i < validMiddleware.length; i++) {
    const {
      name,
      fn
    } = validMiddleware[i];
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = await fn({
      x,
      y,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform,
      elements: {
        reference,
        floating
      }
    });
    x = nextX != null ? nextX : x;
    y = nextY != null ? nextY : y;
    middlewareData = {
      ...middlewareData,
      [name]: {
        ...middlewareData[name],
        ...data
      }
    };
    if (reset && resetCount <= 50) {
      resetCount++;
      if (typeof reset === 'object') {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x,
          y
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i = -1;
      continue;
    }
  }
  return {
    x,
    y,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};

/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */
async function detectOverflow$1(state, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const {
    x,
    y,
    platform,
    rects,
    elements,
    strategy
  } = state;
  const {
    boundary = 'clippingAncestors',
    rootBoundary = 'viewport',
    elementContext = 'floating',
    altBoundary = false,
    padding = 0
  } = evaluate(options, state);
  const paddingObject = getPaddingObject(padding);
  const altContext = elementContext === 'floating' ? 'reference' : 'floating';
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect$1(await platform.getClippingRect({
    element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || (await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating))),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === 'floating' ? {
    ...rects.floating,
    x,
    y
  } : rects.reference;
  const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
  const offsetScale = (await (platform.isElement == null ? void 0 : platform.isElement(offsetParent))) ? (await (platform.getScale == null ? void 0 : platform.getScale(offsetParent))) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = rectToClientRect$1(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow$4 = options => ({
  name: 'arrow',
  options,
  async fn(state) {
    const {
      x,
      y,
      placement,
      rects,
      platform,
      elements
    } = state;
    // Since `element` is required, we don't Partial<> the type.
    const {
      element,
      padding = 0
    } = evaluate(options, state) || {};
    if (element == null) {
      return {};
    }
    const paddingObject = getPaddingObject(padding);
    const coords = {
      x,
      y
    };
    const axis = getAlignmentAxis(placement);
    const length = getAxisLength(axis);
    const arrowDimensions = await platform.getDimensions(element);
    const isYAxis = axis === 'y';
    const minProp = isYAxis ? 'top' : 'left';
    const maxProp = isYAxis ? 'bottom' : 'right';
    const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
    const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
    const startDiff = coords[axis] - rects.reference[axis];
    const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
    let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;

    // DOM platform can return `window` as the `offsetParent`.
    if (!clientSize || !(await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent)))) {
      clientSize = elements.floating[clientProp] || rects.floating[length];
    }
    const centerToReference = endDiff / 2 - startDiff / 2;

    // If the padding is large enough that it causes the arrow to no longer be
    // centered, modify the padding so that it is centered.
    const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
    const minPadding = min$3(paddingObject[minProp], largestPossiblePadding);
    const maxPadding = min$3(paddingObject[maxProp], largestPossiblePadding);

    // Make sure the arrow doesn't overflow the floating element if the center
    // point is outside the floating element's bounds.
    const min$1 = minPadding;
    const max = clientSize - arrowDimensions[length] - maxPadding;
    const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
    const offset = clamp(min$1, center, max);

    // If the reference is small enough that the arrow's padding causes it to
    // to point to nothing for an aligned placement, adjust the offset of the
    // floating element itself. This stops `shift()` from taking action, but can
    // be worked around by calling it again after the `arrow()` if desired.
    const shouldAddOffset = getAlignment(placement) != null && center != offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
    const alignmentOffset = shouldAddOffset ? center < min$1 ? min$1 - center : max - center : 0;
    return {
      [axis]: coords[axis] - alignmentOffset,
      data: {
        [axis]: offset,
        centerOffset: center - offset + alignmentOffset
      }
    };
  }
});

function getPlacementList(alignment, autoAlignment, allowedPlacements) {
  const allowedPlacementsSortedByAlignment = alignment ? [...allowedPlacements.filter(placement => getAlignment(placement) === alignment), ...allowedPlacements.filter(placement => getAlignment(placement) !== alignment)] : allowedPlacements.filter(placement => getSide(placement) === placement);
  return allowedPlacementsSortedByAlignment.filter(placement => {
    if (alignment) {
      return getAlignment(placement) === alignment || (autoAlignment ? getOppositeAlignmentPlacement(placement) !== placement : false);
    }
    return true;
  });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */
const autoPlacement = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'autoPlacement',
    options,
    async fn(state) {
      var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
      const {
        rects,
        middlewareData,
        placement,
        platform,
        elements
      } = state;
      const {
        crossAxis = false,
        alignment,
        allowedPlacements = placements$1,
        autoAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state);
      const placements$1$1 = alignment !== undefined || allowedPlacements === placements$1 ? getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
      const overflow = await detectOverflow$1(state, detectOverflowOptions);
      const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
      const currentPlacement = placements$1$1[currentIndex];
      if (currentPlacement == null) {
        return {};
      }
      const alignmentSides = getAlignmentSides(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));

      // Make `computeCoords` start from the right place.
      if (placement !== currentPlacement) {
        return {
          reset: {
            placement: placements$1$1[0]
          }
        };
      }
      const currentOverflows = [overflow[getSide(currentPlacement)], overflow[alignmentSides[0]], overflow[alignmentSides[1]]];
      const allOverflows = [...(((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || []), {
        placement: currentPlacement,
        overflows: currentOverflows
      }];
      const nextPlacement = placements$1$1[currentIndex + 1];

      // There are more placements to check.
      if (nextPlacement) {
        return {
          data: {
            index: currentIndex + 1,
            overflows: allOverflows
          },
          reset: {
            placement: nextPlacement
          }
        };
      }
      const placementsSortedByMostSpace = allOverflows.map(d => {
        const alignment = getAlignment(d.placement);
        return [d.placement, alignment && crossAxis ?
        // Check along the mainAxis and main crossAxis side.
        d.overflows.slice(0, 2).reduce((acc, v) => acc + v, 0) :
        // Check only the mainAxis.
        d.overflows[0], d.overflows];
      }).sort((a, b) => a[1] - b[1]);
      const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter(d => d[2].slice(0,
      // Aligned placements should not check their opposite crossAxis
      // side.
      getAlignment(d[0]) ? 2 : 3).every(v => v <= 0));
      const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
      if (resetPlacement !== placement) {
        return {
          data: {
            index: currentIndex + 1,
            overflows: allOverflows
          },
          reset: {
            placement: resetPlacement
          }
        };
      }
      return {};
    }
  };
};

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const flip$3 = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'flip',
    options,
    async fn(state) {
      var _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform,
        elements
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = 'bestFit',
        fallbackAxisSideDirection = 'none',
        flipAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state);
      const side = getSide(placement);
      const isBasePlacement = getSide(initialPlacement) === initialPlacement;
      const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement$1(initialPlacement)] : getExpandedPlacements(initialPlacement));
      if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== 'none') {
        fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements = [initialPlacement, ...fallbackPlacements];
      const overflow = await detectOverflow$1(state, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const sides = getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[sides[0]], overflow[sides[1]]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];

      // One or more sides is overflowing.
      if (!overflows.every(side => side <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements[nextIndex];
        if (nextPlacement) {
          // Try next placement and re-run the lifecycle.
          return {
            data: {
              index: nextIndex,
              overflows: overflowsData
            },
            reset: {
              placement: nextPlacement
            }
          };
        }

        // First, find the candidates that fit on the mainAxis side of overflow,
        // then find the placement that fits the best on the main crossAxis side.
        let resetPlacement = (_overflowsData$filter = overflowsData.filter(d => d.overflows[0] <= 0).sort((a, b) => a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;

        // Otherwise fallback.
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case 'bestFit':
              {
                var _overflowsData$map$so;
                const placement = (_overflowsData$map$so = overflowsData.map(d => [d.placement, d.overflows.filter(overflow => overflow > 0).reduce((acc, overflow) => acc + overflow, 0)]).sort((a, b) => a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                if (placement) {
                  resetPlacement = placement;
                }
                break;
              }
            case 'initialPlacement':
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};

function getSideOffsets$1(overflow, rect) {
  return {
    top: overflow.top - rect.height,
    right: overflow.right - rect.width,
    bottom: overflow.bottom - rect.height,
    left: overflow.left - rect.width
  };
}
function isAnySideFullyClipped$1(overflow) {
  return sides.some(side => overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */
const hide$3 = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'hide',
    options,
    async fn(state) {
      const {
        rects
      } = state;
      const {
        strategy = 'referenceHidden',
        ...detectOverflowOptions
      } = evaluate(options, state);
      switch (strategy) {
        case 'referenceHidden':
          {
            const overflow = await detectOverflow$1(state, {
              ...detectOverflowOptions,
              elementContext: 'reference'
            });
            const offsets = getSideOffsets$1(overflow, rects.reference);
            return {
              data: {
                referenceHiddenOffsets: offsets,
                referenceHidden: isAnySideFullyClipped$1(offsets)
              }
            };
          }
        case 'escaped':
          {
            const overflow = await detectOverflow$1(state, {
              ...detectOverflowOptions,
              altBoundary: true
            });
            const offsets = getSideOffsets$1(overflow, rects.floating);
            return {
              data: {
                escapedOffsets: offsets,
                escaped: isAnySideFullyClipped$1(offsets)
              }
            };
          }
        default:
          {
            return {};
          }
      }
    }
  };
};

function getBoundingRect(rects) {
  const minX = min$3(...rects.map(rect => rect.left));
  const minY = min$3(...rects.map(rect => rect.top));
  const maxX = max$3(...rects.map(rect => rect.right));
  const maxY = max$3(...rects.map(rect => rect.bottom));
  return {
    x: minX,
    y: minY,
    width: maxX - minX,
    height: maxY - minY
  };
}
function getRectsByLine(rects) {
  const sortedRects = rects.slice().sort((a, b) => a.y - b.y);
  const groups = [];
  let prevRect = null;
  for (let i = 0; i < sortedRects.length; i++) {
    const rect = sortedRects[i];
    if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) {
      groups.push([rect]);
    } else {
      groups[groups.length - 1].push(rect);
    }
    prevRect = rect;
  }
  return groups.map(rect => rectToClientRect$1(getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */
const inline = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'inline',
    options,
    async fn(state) {
      const {
        placement,
        elements,
        rects,
        platform,
        strategy
      } = state;
      // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
      // ClientRect's bounds, despite the event listener being triggered. A
      // padding of 2 seems to handle this issue.
      const {
        padding = 2,
        x,
        y
      } = evaluate(options, state);
      const nativeClientRects = Array.from((await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference))) || []);
      const clientRects = getRectsByLine(nativeClientRects);
      const fallback = rectToClientRect$1(getBoundingRect(nativeClientRects));
      const paddingObject = getPaddingObject(padding);
      function getBoundingClientRect() {
        // There are two rects and they are disjoined.
        if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) {
          // Find the first rect in which the point is fully inside.
          return clientRects.find(rect => x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
        }

        // There are 2 or more connected rects.
        if (clientRects.length >= 2) {
          if (getSideAxis(placement) === 'y') {
            const firstRect = clientRects[0];
            const lastRect = clientRects[clientRects.length - 1];
            const isTop = getSide(placement) === 'top';
            const top = firstRect.top;
            const bottom = lastRect.bottom;
            const left = isTop ? firstRect.left : lastRect.left;
            const right = isTop ? firstRect.right : lastRect.right;
            const width = right - left;
            const height = bottom - top;
            return {
              top,
              bottom,
              left,
              right,
              width,
              height,
              x: left,
              y: top
            };
          }
          const isLeftSide = getSide(placement) === 'left';
          const maxRight = max$3(...clientRects.map(rect => rect.right));
          const minLeft = min$3(...clientRects.map(rect => rect.left));
          const measureRects = clientRects.filter(rect => isLeftSide ? rect.left === minLeft : rect.right === maxRight);
          const top = measureRects[0].top;
          const bottom = measureRects[measureRects.length - 1].bottom;
          const left = minLeft;
          const right = maxRight;
          const width = right - left;
          const height = bottom - top;
          return {
            top,
            bottom,
            left,
            right,
            width,
            height,
            x: left,
            y: top
          };
        }
        return fallback;
      }
      const resetRects = await platform.getElementRects({
        reference: {
          getBoundingClientRect
        },
        floating: elements.floating,
        strategy
      });
      if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) {
        return {
          reset: {
            rects: resetRects
          }
        };
      }
      return {};
    }
  };
};

// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function convertValueToCoords(state, options) {
  const {
    placement,
    platform,
    elements
  } = state;
  const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
  const side = getSide(placement);
  const alignment = getAlignment(placement);
  const isVertical = getSideAxis(placement) === 'y';
  const mainAxisMulti = ['left', 'top'].includes(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = evaluate(options, state);

  // eslint-disable-next-line prefer-const
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === 'number' ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...rawValue
  };
  if (alignment && typeof alignmentAxis === 'number') {
    crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}

/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */
const offset$2 = function (options) {
  if (options === void 0) {
    options = 0;
  }
  return {
    name: 'offset',
    options,
    async fn(state) {
      const {
        x,
        y
      } = state;
      const diffCoords = await convertValueToCoords(state, options);
      return {
        x: x + diffCoords.x,
        y: y + diffCoords.y,
        data: diffCoords
      };
    }
  };
};

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const shift$1 = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'shift',
    options,
    async fn(state) {
      const {
        x,
        y,
        placement
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: _ref => {
            let {
              x,
              y
            } = _ref;
            return {
              x,
              y
            };
          }
        },
        ...detectOverflowOptions
      } = evaluate(options, state);
      const coords = {
        x,
        y
      };
      const overflow = await detectOverflow$1(state, detectOverflowOptions);
      const crossAxis = getSideAxis(getSide(placement));
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      if (checkMainAxis) {
        const minSide = mainAxis === 'y' ? 'top' : 'left';
        const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
        const min = mainAxisCoord + overflow[minSide];
        const max = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = clamp(min, mainAxisCoord, max);
      }
      if (checkCrossAxis) {
        const minSide = crossAxis === 'y' ? 'top' : 'left';
        const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
        const min = crossAxisCoord + overflow[minSide];
        const max = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = clamp(min, crossAxisCoord, max);
      }
      const limitedCoords = limiter.fn({
        ...state,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x,
          y: limitedCoords.y - y
        }
      };
    }
  };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */
const limitShift$1 = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    options,
    fn(state) {
      const {
        x,
        y,
        placement,
        rects,
        middlewareData
      } = state;
      const {
        offset = 0,
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true
      } = evaluate(options, state);
      const coords = {
        x,
        y
      };
      const crossAxis = getSideAxis(placement);
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      const rawOffset = evaluate(offset, state);
      const computedOffset = typeof rawOffset === 'number' ? {
        mainAxis: rawOffset,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...rawOffset
      };
      if (checkMainAxis) {
        const len = mainAxis === 'y' ? 'height' : 'width';
        const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
        const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
        if (mainAxisCoord < limitMin) {
          mainAxisCoord = limitMin;
        } else if (mainAxisCoord > limitMax) {
          mainAxisCoord = limitMax;
        }
      }
      if (checkCrossAxis) {
        var _middlewareData$offse, _middlewareData$offse2;
        const len = mainAxis === 'y' ? 'width' : 'height';
        const isOriginSide = ['top', 'left'].includes(getSide(placement));
        const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
        const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
        if (crossAxisCoord < limitMin) {
          crossAxisCoord = limitMin;
        } else if (crossAxisCoord > limitMax) {
          crossAxisCoord = limitMax;
        }
      }
      return {
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      };
    }
  };
};

/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */
const size$1 = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'size',
    options,
    async fn(state) {
      const {
        placement,
        rects,
        platform,
        elements
      } = state;
      const {
        apply = () => {},
        ...detectOverflowOptions
      } = evaluate(options, state);
      const overflow = await detectOverflow$1(state, detectOverflowOptions);
      const side = getSide(placement);
      const alignment = getAlignment(placement);
      const isYAxis = getSideAxis(placement) === 'y';
      const {
        width,
        height
      } = rects.floating;
      let heightSide;
      let widthSide;
      if (side === 'top' || side === 'bottom') {
        heightSide = side;
        widthSide = alignment === ((await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating))) ? 'start' : 'end') ? 'left' : 'right';
      } else {
        widthSide = side;
        heightSide = alignment === 'end' ? 'top' : 'bottom';
      }
      const overflowAvailableHeight = height - overflow[heightSide];
      const overflowAvailableWidth = width - overflow[widthSide];
      const noShift = !state.middlewareData.shift;
      let availableHeight = overflowAvailableHeight;
      let availableWidth = overflowAvailableWidth;
      if (isYAxis) {
        const maximumClippingWidth = width - overflow.left - overflow.right;
        availableWidth = alignment || noShift ? min$3(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
      } else {
        const maximumClippingHeight = height - overflow.top - overflow.bottom;
        availableHeight = alignment || noShift ? min$3(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
      }
      if (noShift && !alignment) {
        const xMin = max$3(overflow.left, 0);
        const xMax = max$3(overflow.right, 0);
        const yMin = max$3(overflow.top, 0);
        const yMax = max$3(overflow.bottom, 0);
        if (isYAxis) {
          availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : max$3(overflow.left, overflow.right));
        } else {
          availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : max$3(overflow.top, overflow.bottom));
        }
      }
      await apply({
        ...state,
        availableWidth,
        availableHeight
      });
      const nextDimensions = await platform.getDimensions(elements.floating);
      if (width !== nextDimensions.width || height !== nextDimensions.height) {
        return {
          reset: {
            rects: true
          }
        };
      }
      return {};
    }
  };
};

/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */
const min$2 = Math.min;
const max$2 = Math.max;
const round$1 = Math.round;
const floor = Math.floor;
const createCoords = v => ({
  x: v,
  y: v
});

function getNodeName$1(node) {
  if (isNode$1(node)) {
    return (node.nodeName || '').toLowerCase();
  }
  // Mocked nodes in testing environments may not be instances of Node. By
  // returning `#document` an infinite loop won't occur.
  // https://github.com/floating-ui/floating-ui/issues/2317
  return '#document';
}
function getWindow$1(node) {
  var _node$ownerDocument;
  return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement$1(node) {
  var _ref;
  return (_ref = (isNode$1(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode$1(value) {
  return value instanceof Node || value instanceof getWindow$1(value).Node;
}
function isElement$1(value) {
  return value instanceof Element || value instanceof getWindow$1(value).Element;
}
function isHTMLElement$1(value) {
  return value instanceof HTMLElement || value instanceof getWindow$1(value).HTMLElement;
}
function isShadowRoot$1(value) {
  // Browsers without `ShadowRoot` support.
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow$1(value).ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle$2(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !['inline', 'contents'].includes(display);
}
function isTableElement$1(element) {
  return ['table', 'td', 'th'].includes(getNodeName$1(element));
}
function isContainingBlock(element) {
  const webkit = isWebKit();
  const css = getComputedStyle$2(element);

  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || ['transform', 'perspective', 'filter'].some(value => (css.willChange || '').includes(value)) || ['paint', 'layout', 'strict', 'content'].some(value => (css.contain || '').includes(value));
}
function getContainingBlock$1(element) {
  let currentNode = getParentNode$1(element);
  while (isHTMLElement$1(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else {
      currentNode = getParentNode$1(currentNode);
    }
  }
  return null;
}
function isWebKit() {
  if (typeof CSS === 'undefined' || !CSS.supports) return false;
  return CSS.supports('-webkit-backdrop-filter', 'none');
}
function isLastTraversableNode(node) {
  return ['html', 'body', '#document'].includes(getNodeName$1(node));
}
function getComputedStyle$2(element) {
  return getWindow$1(element).getComputedStyle(element);
}
function getNodeScroll$1(element) {
  if (isElement$1(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.pageXOffset,
    scrollTop: element.pageYOffset
  };
}
function getParentNode$1(node) {
  if (getNodeName$1(node) === 'html') {
    return node;
  }
  const result =
  // Step into the shadow DOM of the parent of a slotted node.
  node.assignedSlot ||
  // DOM Element detected.
  node.parentNode ||
  // ShadowRoot detected.
  isShadowRoot$1(node) && node.host ||
  // Fallback.
  getDocumentElement$1(node);
  return isShadowRoot$1(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode$1(node);
  if (isLastTraversableNode(parentNode)) {
    return node.ownerDocument ? node.ownerDocument.body : node.body;
  }
  if (isHTMLElement$1(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
  var _node$ownerDocument2;
  if (list === void 0) {
    list = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow$1(scrollableAncestor);
  if (isBody) {
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? getOverflowAncestors(win.frameElement) : []);
  }
  return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}

function getCssDimensions(element) {
  const css = getComputedStyle$2(element);
  // In testing environments, the `width` and `height` properties are empty
  // strings for SVG elements, returning NaN. Fallback to `0` in this case.
  let width = parseFloat(css.width) || 0;
  let height = parseFloat(css.height) || 0;
  const hasOffset = isHTMLElement$1(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round$1(width) !== offsetWidth || round$1(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}

function unwrapElement(element) {
  return !isElement$1(element) ? element.contextElement : element;
}

function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement$1(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $
  } = getCssDimensions(domElement);
  let x = ($ ? round$1(rect.width) : rect.width) / width;
  let y = ($ ? round$1(rect.height) : rect.height) / height;

  // 0, NaN, or Infinity should always fallback to 1.

  if (!x || !Number.isFinite(x)) {
    x = 1;
  }
  if (!y || !Number.isFinite(y)) {
    y = 1;
  }
  return {
    x,
    y
  };
}

const noOffsets = /*#__PURE__*/createCoords(0);
function getVisualOffsets(element) {
  const win = getWindow$1(element);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow$1(element)) {
    return false;
  }
  return isFixed;
}

function getBoundingClientRect$1(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement$1(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x = (clientRect.left + visualOffsets.x) / scale.x;
  let y = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow$1(domElement);
    const offsetWin = offsetParent && isElement$1(offsetParent) ? getWindow$1(offsetParent) : offsetParent;
    let currentWin = win;
    let currentIFrame = currentWin.frameElement;
    while (currentIFrame && offsetParent && offsetWin !== currentWin) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = getComputedStyle$2(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x *= iframeScale.x;
      y *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x += left;
      y += top;
      currentWin = getWindow$1(currentIFrame);
      currentIFrame = currentWin.frameElement;
    }
  }
  return rectToClientRect$1({
    width,
    height,
    x,
    y
  });
}

const topLayerSelectors = [':popover-open', ':modal'];
function isTopLayer(floating) {
  return topLayerSelectors.some(selector => {
    try {
      return floating.matches(selector);
    } catch (e) {
      return false;
    }
  });
}

function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    elements,
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isFixed = strategy === 'fixed';
  const documentElement = getDocumentElement$1(offsetParent);
  const topLayer = elements ? isTopLayer(elements.floating) : false;
  if (offsetParent === documentElement || topLayer && isFixed) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  const isOffsetParentAnElement = isHTMLElement$1(offsetParent);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName$1(offsetParent) !== 'body' || isOverflowElement(documentElement)) {
      scroll = getNodeScroll$1(offsetParent);
    }
    if (isHTMLElement$1(offsetParent)) {
      const offsetRect = getBoundingClientRect$1(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
  };
}

function getClientRects(element) {
  return Array.from(element.getClientRects());
}

function getWindowScrollBarX$1(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  return getBoundingClientRect$1(getDocumentElement$1(element)).left + getNodeScroll$1(element).scrollLeft;
}

// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function getDocumentRect$1(element) {
  const html = getDocumentElement$1(element);
  const scroll = getNodeScroll$1(element);
  const body = element.ownerDocument.body;
  const width = max$2(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height = max$2(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x = -scroll.scrollLeft + getWindowScrollBarX$1(element);
  const y = -scroll.scrollTop;
  if (getComputedStyle$2(body).direction === 'rtl') {
    x += max$2(html.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x,
    y
  };
}

function getViewportRect$1(element, strategy) {
  const win = getWindow$1(element);
  const html = getDocumentElement$1(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x = 0;
  let y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const visualViewportBased = isWebKit();
    if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x,
    y
  };
}

// Returns the inner client rect, subtracting scrollbars if present.
function getInnerBoundingClientRect$1(element, strategy) {
  const clientRect = getBoundingClientRect$1(element, true, strategy === 'fixed');
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  const scale = isHTMLElement$1(element) ? getScale(element) : createCoords(1);
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x = left * scale.x;
  const y = top * scale.y;
  return {
    width,
    height,
    x,
    y
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === 'viewport') {
    rect = getViewportRect$1(element, strategy);
  } else if (clippingAncestor === 'document') {
    rect = getDocumentRect$1(getDocumentElement$1(element));
  } else if (isElement$1(clippingAncestor)) {
    rect = getInnerBoundingClientRect$1(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = {
      ...clippingAncestor,
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y
    };
  }
  return rectToClientRect$1(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
  const parentNode = getParentNode$1(element);
  if (parentNode === stopNode || !isElement$1(parentNode) || isLastTraversableNode(parentNode)) {
    return false;
  }
  return getComputedStyle$2(parentNode).position === 'fixed' || hasFixedPositionAncestor(parentNode, stopNode);
}

// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = getOverflowAncestors(element, [], false).filter(el => isElement$1(el) && getNodeName$1(el) !== 'body');
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = getComputedStyle$2(element).position === 'fixed';
  let currentNode = elementIsFixed ? getParentNode$1(element) : element;

  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  while (isElement$1(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = getComputedStyle$2(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === 'fixed') {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && ['absolute', 'fixed'].includes(currentContainingBlockComputedStyle.position) || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
    if (shouldDropCurrentNode) {
      // Drop non-containing blocks.
      result = result.filter(ancestor => ancestor !== currentNode);
    } else {
      // Record last containing block for next iteration.
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode$1(currentNode);
  }
  cache.set(element, result);
  return result;
}

// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function getClippingRect$1(_ref) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === 'clippingAncestors' ? getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
    accRect.top = max$2(rect.top, accRect.top);
    accRect.right = min$2(rect.right, accRect.right);
    accRect.bottom = min$2(rect.bottom, accRect.bottom);
    accRect.left = max$2(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}

function getDimensions(element) {
  const {
    width,
    height
  } = getCssDimensions(element);
  return {
    width,
    height
  };
}

function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement$1(offsetParent);
  const documentElement = getDocumentElement$1(offsetParent);
  const isFixed = strategy === 'fixed';
  const rect = getBoundingClientRect$1(element, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName$1(offsetParent) !== 'body' || isOverflowElement(documentElement)) {
      scroll = getNodeScroll$1(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect$1(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX$1(documentElement);
    }
  }
  const x = rect.left + scroll.scrollLeft - offsets.x;
  const y = rect.top + scroll.scrollTop - offsets.y;
  return {
    x,
    y,
    width: rect.width,
    height: rect.height
  };
}

function getTrueOffsetParent$1(element, polyfill) {
  if (!isHTMLElement$1(element) || getComputedStyle$2(element).position === 'fixed') {
    return null;
  }
  if (polyfill) {
    return polyfill(element);
  }
  return element.offsetParent;
}

// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function getOffsetParent$1(element, polyfill) {
  const window = getWindow$1(element);
  if (!isHTMLElement$1(element) || isTopLayer(element)) {
    return window;
  }
  let offsetParent = getTrueOffsetParent$1(element, polyfill);
  while (offsetParent && isTableElement$1(offsetParent) && getComputedStyle$2(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent$1(offsetParent, polyfill);
  }
  if (offsetParent && (getNodeName$1(offsetParent) === 'html' || getNodeName$1(offsetParent) === 'body' && getComputedStyle$2(offsetParent).position === 'static' && !isContainingBlock(offsetParent))) {
    return window;
  }
  return offsetParent || getContainingBlock$1(element) || window;
}

const getElementRects = async function (data) {
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent$1;
  const getDimensionsFn = this.getDimensions;
  return {
    reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
    floating: {
      x: 0,
      y: 0,
      ...(await getDimensionsFn(data.floating))
    }
  };
};

function isRTL(element) {
  return getComputedStyle$2(element).direction === 'rtl';
}

const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement: getDocumentElement$1,
  getClippingRect: getClippingRect$1,
  getOffsetParent: getOffsetParent$1,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement: isElement$1,
  isRTL
};

// https://samthor.au/2021/observing-dom/
function observeMove(element, onMove) {
  let io = null;
  let timeoutId;
  const root = getDocumentElement$1(element);
  function cleanup() {
    var _io;
    clearTimeout(timeoutId);
    (_io = io) == null || _io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const {
      left,
      top,
      width,
      height
    } = element.getBoundingClientRect();
    if (!skip) {
      onMove();
    }
    if (!width || !height) {
      return;
    }
    const insetTop = floor(top);
    const insetRight = floor(root.clientWidth - (left + width));
    const insetBottom = floor(root.clientHeight - (top + height));
    const insetLeft = floor(left);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options = {
      rootMargin,
      threshold: max$2(0, min$2(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 100);
        } else {
          refresh(false, ratio);
        }
      }
      isFirstUpdate = false;
    }

    // Older browsers don't support a `document` as the root and will throw an
    // error.
    try {
      io = new IntersectionObserver(handleObserve, {
        ...options,
        // Handle <iframe>s
        root: root.ownerDocument
      });
    } catch (e) {
      io = new IntersectionObserver(handleObserve, options);
    }
    io.observe(element);
  }
  refresh(true);
  return cleanup;
}

/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */
function autoUpdate(reference, floating, update, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === 'function',
    layoutShift = typeof IntersectionObserver === 'function',
    animationFrame = false
  } = options;
  const referenceEl = unwrapElement(reference);
  const ancestors = ancestorScroll || ancestorResize ? [...(referenceEl ? getOverflowAncestors(referenceEl) : []), ...getOverflowAncestors(floating)] : [];
  ancestors.forEach(ancestor => {
    ancestorScroll && ancestor.addEventListener('scroll', update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener('resize', update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver(_ref => {
      let [firstEntry] = _ref;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
        // Prevent update loops when using the `size` middleware.
        // https://github.com/floating-ui/floating-ui/issues/1740
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    resizeObserver.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect$1(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect$1(reference);
    if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    var _resizeObserver2;
    ancestors.forEach(ancestor => {
      ancestorScroll && ancestor.removeEventListener('scroll', update);
      ancestorResize && ancestor.removeEventListener('resize', update);
    });
    cleanupIo == null || cleanupIo();
    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}

/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */
autoPlacement;

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const shift = shift$1;

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const flip$2 = flip$3;

/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */
const size = size$1;

/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */
const hide$2 = hide$3;

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow$3 = arrow$4;

/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */
inline;

/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */
const limitShift = limitShift$1;

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */
const computePosition = (reference, floating, options) => {
  // This caches the expensive `getClippingElementAncestors` function so that
  // multiple lifecycle resets re-use the same result. It only lives for a
  // single call. If other functions become expensive, we can add them as well.
  const cache = new Map();
  const mergedOptions = {
    platform,
    ...options
  };
  const platformWithCache = {
    ...mergedOptions.platform,
    _c: cache
  };
  return computePosition$1(reference, floating, {
    ...mergedOptions,
    platform: platformWithCache
  });
};

var classnamesExports = {};
var classnames = {
  get exports(){ return classnamesExports; },
  set exports(v){ classnamesExports = v; },
};

/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/

(function (module) {
	/* global define */

	(function () {

		var hasOwn = {}.hasOwnProperty;

		function classNames() {
			var classes = [];

			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;

				var argType = typeof arg;

				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					if (arg.length) {
						var inner = classNames.apply(null, arg);
						if (inner) {
							classes.push(inner);
						}
					}
				} else if (argType === 'object') {
					if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
						classes.push(arg.toString());
						continue;
					}

					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}

			return classes.join(' ');
		}

		if (module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else {
			window.classNames = classNames;
		}
	}());
} (classnames));

var cls = classnamesExports;

/*
* React Tooltip
* {@link https://github.com/ReactTooltip/react-tooltip}
* @copyright ReactTooltip Team
* @license MIT
*/
const h="react-tooltip-core-styles",w="react-tooltip-base-styles",b={core:!1,base:!1};function S({css:e,id:t=w,type:o="base",ref:l}){var r,n;if(!e||"undefined"==typeof document||b[o])return;if("core"===o&&"undefined"!=typeof process&&(null===(r=null===process||void 0===process?void 0:process.env)||void 0===r?void 0:r.REACT_TOOLTIP_DISABLE_CORE_STYLES))return;if("base"!==o&&"undefined"!=typeof process&&(null===(n=null===process||void 0===process?void 0:process.env)||void 0===n?void 0:n.REACT_TOOLTIP_DISABLE_BASE_STYLES))return;"core"===o&&(t=h),l||(l={});const{insertAt:i}=l;if(document.getElementById(t))return;const c=document.head||document.getElementsByTagName("head")[0],s=document.createElement("style");s.id=t,s.type="text/css","top"===i&&c.firstChild?c.insertBefore(s,c.firstChild):c.appendChild(s),s.styleSheet?s.styleSheet.cssText=e:s.appendChild(document.createTextNode(e)),b[o]=!0;}const E=async({elementReference:e=null,tooltipReference:t=null,tooltipArrowReference:o=null,place:l="top",offset:r=10,strategy:n="absolute",middlewares:i=[offset$2(Number(r)),flip$2({fallbackAxisSideDirection:"start"}),shift({padding:5})],border:c})=>{if(!e)return {tooltipStyles:{},tooltipArrowStyles:{},place:l};if(null===t)return {tooltipStyles:{},tooltipArrowStyles:{},place:l};const s=i;return o?(s.push(arrow$3({element:o,padding:5})),computePosition(e,t,{placement:l,strategy:n,middleware:s}).then((({x:e,y:t,placement:o,middlewareData:l})=>{var r,n;const i={left:`${e}px`,top:`${t}px`,border:c},{x:s,y:a}=null!==(r=l.arrow)&&void 0!==r?r:{x:0,y:0},u=null!==(n={top:"bottom",right:"left",bottom:"top",left:"right"}[o.split("-")[0]])&&void 0!==n?n:"bottom",d=c&&{borderBottom:c,borderRight:c};let p=0;if(c){const e=`${c}`.match(/(\d+)px/);p=(null==e?void 0:e[1])?Number(e[1]):1;}return {tooltipStyles:i,tooltipArrowStyles:{left:null!=s?`${s}px`:"",top:null!=a?`${a}px`:"",right:"",bottom:"",...d,[u]:`-${4+p}px`},place:o}}))):computePosition(e,t,{placement:"bottom",strategy:n,middleware:s}).then((({x:e,y:t,placement:o})=>({tooltipStyles:{left:`${e}px`,top:`${t}px`},tooltipArrowStyles:{},place:o})))},A=(e,t)=>!("CSS"in window&&"supports"in window.CSS)||window.CSS.supports(e,t),_=(e,t,o)=>{let l=null;const r=function(...r){const n=()=>{l=null,o||e.apply(this,r);};o&&!l&&(e.apply(this,r),l=setTimeout(n,t)),o||(l&&clearTimeout(l),l=setTimeout(n,t));};return r.cancel=()=>{l&&(clearTimeout(l),l=null);},r},O=e=>null!==e&&!Array.isArray(e)&&"object"==typeof e,k=(e,t)=>{if(e===t)return !0;if(Array.isArray(e)&&Array.isArray(t))return e.length===t.length&&e.every(((e,o)=>k(e,t[o])));if(Array.isArray(e)!==Array.isArray(t))return !1;if(!O(e)||!O(t))return e===t;const o=Object.keys(e),l=Object.keys(t);return o.length===l.length&&o.every((o=>k(e[o],t[o])))},T=e=>{if(!(e instanceof HTMLElement||e instanceof SVGElement))return !1;const t=getComputedStyle(e);return ["overflow","overflow-x","overflow-y"].some((e=>{const o=t.getPropertyValue(e);return "auto"===o||"scroll"===o}))},L=e=>{if(!e)return null;let t=e.parentElement;for(;t;){if(T(t))return t;t=t.parentElement;}return document.scrollingElement||document.documentElement},C="undefined"!=typeof window?useLayoutEffect$1:useEffect,R=e=>{e.current&&(clearTimeout(e.current),e.current=null);},x="DEFAULT_TOOLTIP_ID",N={anchorRefs:new Set,activeAnchor:{current:null},attach:()=>{},detach:()=>{},setActiveAnchor:()=>{}},$=createContext({getTooltipData:()=>N});function j(e=x){return useContext($).getTooltipData(e)}var z={tooltip:"core-styles-module_tooltip__3vRRp",fixed:"core-styles-module_fixed__pcSol",arrow:"core-styles-module_arrow__cvMwQ",noArrow:"core-styles-module_noArrow__xock6",clickable:"core-styles-module_clickable__ZuTTB",show:"core-styles-module_show__Nt9eE",closing:"core-styles-module_closing__sGnxF"},D={tooltip:"styles-module_tooltip__mnnfp",arrow:"styles-module_arrow__K0L3T",dark:"styles-module_dark__xNqje",light:"styles-module_light__Z6W-X",success:"styles-module_success__A2AKt",warning:"styles-module_warning__SCK0X",error:"styles-module_error__JvumD",info:"styles-module_info__BWdHW"};const q=({forwardRef:t,id:l,className:i,classNameArrow:c,variant:u="dark",anchorId:d,anchorSelect:p,place:v="top",offset:m=10,events:h=["hover"],openOnClick:w=!1,positionStrategy:b="absolute",middlewares:S,wrapper:g,delayShow:A=0,delayHide:O=0,float:T=!1,hidden:x=!1,noArrow:N=!1,clickable:$=!1,closeOnEsc:I=!1,closeOnScroll:B=!1,closeOnResize:q=!1,openEvents:H,closeEvents:M,globalCloseEvents:W,imperativeModeOnly:P,style:V,position:F,afterShow:K,afterHide:U,disableTooltip:X,content:Y,contentWrapperRef:G,isOpen:Z,defaultIsOpen:J=!1,setIsOpen:Q,activeAnchor:ee,setActiveAnchor:te,border:oe,opacity:le,arrowColor:re,role:ne="tooltip"})=>{var ie;const ce=useRef(null),se=useRef(null),ae=useRef(null),ue=useRef(null),de=useRef(null),[pe,ve]=useState({tooltipStyles:{},tooltipArrowStyles:{},place:v}),[me,fe]=useState(!1),[ye,he]=useState(!1),[we,be]=useState(null),Se=useRef(!1),ge=useRef(null),{anchorRefs:Ee,setActiveAnchor:Ae}=j(l),_e=useRef(!1),[Oe,ke]=useState([]),Te=useRef(!1),Le=w||h.includes("click"),Ce=Le||(null==H?void 0:H.click)||(null==H?void 0:H.dblclick)||(null==H?void 0:H.mousedown),Re=H?{...H}:{mouseover:!0,focus:!0,mouseenter:!1,click:!1,dblclick:!1,mousedown:!1};!H&&Le&&Object.assign(Re,{mouseenter:!1,focus:!1,mouseover:!1,click:!0});const xe=M?{...M}:{mouseout:!0,blur:!0,mouseleave:!1,click:!1,dblclick:!1,mouseup:!1};!M&&Le&&Object.assign(xe,{mouseleave:!1,blur:!1,mouseout:!1});const Ne=W?{...W}:{escape:I||!1,scroll:B||!1,resize:q||!1,clickOutsideAnchor:Ce||!1};P&&(Object.assign(Re,{mouseenter:!1,focus:!1,click:!1,dblclick:!1,mousedown:!1}),Object.assign(xe,{mouseleave:!1,blur:!1,click:!1,dblclick:!1,mouseup:!1}),Object.assign(Ne,{escape:!1,scroll:!1,resize:!1,clickOutsideAnchor:!1})),C((()=>(Te.current=!0,()=>{Te.current=!1;})),[]);const $e=e=>{Te.current&&(e&&he(!0),setTimeout((()=>{Te.current&&(null==Q||Q(e),void 0===Z&&fe(e));}),10));};useEffect((()=>{if(void 0===Z)return ()=>null;Z&&he(!0);const e=setTimeout((()=>{fe(Z);}),10);return ()=>{clearTimeout(e);}}),[Z]),useEffect((()=>{if(me!==Se.current)if(R(de),Se.current=me,me)null==K||K();else {const e=(e=>{const t=e.match(/^([\d.]+)(ms|s)$/);if(!t)return 0;const[,o,l]=t;return Number(o)*("ms"===l?1:1e3)})(getComputedStyle(document.body).getPropertyValue("--rt-transition-show-delay"));de.current=setTimeout((()=>{he(!1),be(null),null==U||U();}),e+25);}}),[me]);const Ie=e=>{ve((t=>k(t,e)?t:e));},je=(e=A)=>{R(ae),ye?$e(!0):ae.current=setTimeout((()=>{$e(!0);}),e);},Be=(e=O)=>{R(ue),ue.current=setTimeout((()=>{_e.current||$e(!1);}),e);},ze=e=>{var t;if(!e)return;const o=null!==(t=e.currentTarget)&&void 0!==t?t:e.target;if(!(null==o?void 0:o.isConnected))return te(null),void Ae({current:null});A?je():$e(!0),te(o),Ae({current:o}),R(ue);},De=()=>{$?Be(O||100):O?Be():$e(!1),R(ae);},qe=({x:e,y:t})=>{var o;const l={getBoundingClientRect:()=>({x:e,y:t,width:0,height:0,top:t,left:e,right:e,bottom:t})};E({place:null!==(o=null==we?void 0:we.place)&&void 0!==o?o:v,offset:m,elementReference:l,tooltipReference:ce.current,tooltipArrowReference:se.current,strategy:b,middlewares:S,border:oe}).then((e=>{Ie(e);}));},He=e=>{if(!e)return;const t=e,o={x:t.clientX,y:t.clientY};qe(o),ge.current=o;},Me=e=>{var t;if(!me)return;const o=e.target;if(!o.isConnected)return;if(null===(t=ce.current)||void 0===t?void 0:t.contains(o))return;[document.querySelector(`[id='${d}']`),...Oe].some((e=>null==e?void 0:e.contains(o)))||($e(!1),R(ae));},We=_(ze,50,!0),Pe=_(De,50,!0),Ve=e=>{Pe.cancel(),We(e);},Fe=()=>{We.cancel(),Pe();},Ke=useCallback((()=>{var e,t;const o=null!==(e=null==we?void 0:we.position)&&void 0!==e?e:F;o?qe(o):T?ge.current&&qe(ge.current):(null==ee?void 0:ee.isConnected)&&E({place:null!==(t=null==we?void 0:we.place)&&void 0!==t?t:v,offset:m,elementReference:ee,tooltipReference:ce.current,tooltipArrowReference:se.current,strategy:b,middlewares:S,border:oe}).then((e=>{Te.current&&Ie(e);}));}),[me,ee,Y,V,v,null==we?void 0:we.place,m,b,F,null==we?void 0:we.position,T]);useEffect((()=>{var e,t;const o=new Set(Ee);Oe.forEach((e=>{(null==X?void 0:X(e))||o.add({current:e});}));const l=document.querySelector(`[id='${d}']`);l&&!(null==X?void 0:X(l))&&o.add({current:l});const r=()=>{$e(!1);},n=L(ee),i=L(ce.current);Ne.scroll&&(window.addEventListener("scroll",r),null==n||n.addEventListener("scroll",r),null==i||i.addEventListener("scroll",r));let c=null;Ne.resize?window.addEventListener("resize",r):ee&&ce.current&&(c=autoUpdate(ee,ce.current,Ke,{ancestorResize:!0,elementResize:!0,layoutShift:!0}));const s=e=>{"Escape"===e.key&&$e(!1);};Ne.escape&&window.addEventListener("keydown",s),Ne.clickOutsideAnchor&&window.addEventListener("click",Me);const a=[],u=e=>{me&&(null==e?void 0:e.target)===ee||ze(e);},p=e=>{me&&(null==e?void 0:e.target)===ee&&De();},v=["mouseover","mouseout","mouseenter","mouseleave","focus","blur"],m=["click","dblclick","mousedown","mouseup"];Object.entries(Re).forEach((([e,t])=>{t&&(v.includes(e)?a.push({event:e,listener:Ve}):m.includes(e)&&a.push({event:e,listener:u}));})),Object.entries(xe).forEach((([e,t])=>{t&&(v.includes(e)?a.push({event:e,listener:Fe}):m.includes(e)&&a.push({event:e,listener:p}));})),T&&a.push({event:"pointermove",listener:He});const y=()=>{_e.current=!0;},h=()=>{_e.current=!1,De();};return $&&!Ce&&(null===(e=ce.current)||void 0===e||e.addEventListener("mouseenter",y),null===(t=ce.current)||void 0===t||t.addEventListener("mouseleave",h)),a.forEach((({event:e,listener:t})=>{o.forEach((o=>{var l;null===(l=o.current)||void 0===l||l.addEventListener(e,t);}));})),()=>{var e,t;Ne.scroll&&(window.removeEventListener("scroll",r),null==n||n.removeEventListener("scroll",r),null==i||i.removeEventListener("scroll",r)),Ne.resize?window.removeEventListener("resize",r):null==c||c(),Ne.clickOutsideAnchor&&window.removeEventListener("click",Me),Ne.escape&&window.removeEventListener("keydown",s),$&&!Ce&&(null===(e=ce.current)||void 0===e||e.removeEventListener("mouseenter",y),null===(t=ce.current)||void 0===t||t.removeEventListener("mouseleave",h)),a.forEach((({event:e,listener:t})=>{o.forEach((o=>{var l;null===(l=o.current)||void 0===l||l.removeEventListener(e,t);}));}));}}),[ee,Ke,ye,Ee,Oe,H,M,W,Le,A,O]),useEffect((()=>{var e,t;let o=null!==(t=null!==(e=null==we?void 0:we.anchorSelect)&&void 0!==e?e:p)&&void 0!==t?t:"";!o&&l&&(o=`[data-tooltip-id='${l.replace(/'/g,"\\'")}']`);const r=new MutationObserver((e=>{const t=[],r=[];e.forEach((e=>{if("attributes"===e.type&&"data-tooltip-id"===e.attributeName){e.target.getAttribute("data-tooltip-id")===l?t.push(e.target):e.oldValue===l&&r.push(e.target);}if("childList"===e.type){if(ee){const t=[...e.removedNodes].filter((e=>1===e.nodeType));if(o)try{r.push(...t.filter((e=>e.matches(o)))),r.push(...t.flatMap((e=>[...e.querySelectorAll(o)])));}catch(e){}t.some((e=>{var t;return !!(null===(t=null==e?void 0:e.contains)||void 0===t?void 0:t.call(e,ee))&&(he(!1),$e(!1),te(null),R(ae),R(ue),!0)}));}if(o)try{const l=[...e.addedNodes].filter((e=>1===e.nodeType));t.push(...l.filter((e=>e.matches(o)))),t.push(...l.flatMap((e=>[...e.querySelectorAll(o)])));}catch(e){}}})),(t.length||r.length)&&ke((e=>[...e.filter((e=>!r.includes(e))),...t]));}));return r.observe(document.body,{childList:!0,subtree:!0,attributes:!0,attributeFilter:["data-tooltip-id"],attributeOldValue:!0}),()=>{r.disconnect();}}),[l,p,null==we?void 0:we.anchorSelect,ee]),useEffect((()=>{Ke();}),[Ke]),useEffect((()=>{if(!(null==G?void 0:G.current))return ()=>null;const e=new ResizeObserver((()=>{setTimeout((()=>Ke()));}));return e.observe(G.current),()=>{e.disconnect();}}),[Y,null==G?void 0:G.current]),useEffect((()=>{var e;const t=document.querySelector(`[id='${d}']`),o=[...Oe,t];ee&&o.includes(ee)||te(null!==(e=Oe[0])&&void 0!==e?e:t);}),[d,Oe,ee]),useEffect((()=>(J&&$e(!0),()=>{R(ae),R(ue);})),[]),useEffect((()=>{var e;let t=null!==(e=null==we?void 0:we.anchorSelect)&&void 0!==e?e:p;if(!t&&l&&(t=`[data-tooltip-id='${l.replace(/'/g,"\\'")}']`),t)try{const e=Array.from(document.querySelectorAll(t));ke(e);}catch(e){ke([]);}}),[l,p,null==we?void 0:we.anchorSelect]),useEffect((()=>{ae.current&&(R(ae),je(A));}),[A]);const Ue=null!==(ie=null==we?void 0:we.content)&&void 0!==ie?ie:Y,Xe=me&&Object.keys(pe.tooltipStyles).length>0;return useImperativeHandle(t,(()=>({open:e=>{if(null==e?void 0:e.anchorSelect)try{document.querySelector(e.anchorSelect);}catch(t){return void console.warn(`[react-tooltip] "${e.anchorSelect}" is not a valid CSS selector`)}be(null!=e?e:null),(null==e?void 0:e.delay)?je(e.delay):$e(!0);},close:e=>{(null==e?void 0:e.delay)?Be(e.delay):$e(!1);},activeAnchor:ee,place:pe.place,isOpen:Boolean(ye&&!x&&Ue&&Xe)}))),ye&&!x&&Ue?React__default.createElement(g,{id:l,role:ne,className:cls("react-tooltip",z.tooltip,D.tooltip,D[u],i,`react-tooltip__place-${pe.place}`,z[Xe?"show":"closing"],Xe?"react-tooltip__show":"react-tooltip__closing","fixed"===b&&z.fixed,$&&z.clickable),onTransitionEnd:e=>{R(de),me||"opacity"!==e.propertyName||(he(!1),be(null),null==U||U());},style:{...V,...pe.tooltipStyles,opacity:void 0!==le&&Xe?le:void 0},ref:ce},Ue,React__default.createElement(g,{className:cls("react-tooltip-arrow",z.arrow,D.arrow,c,N&&z.noArrow),style:{...pe.tooltipArrowStyles,background:re?`linear-gradient(to right bottom, transparent 50%, ${re} 50%)`:void 0},ref:se})):null},H=({content:t})=>React__default.createElement("span",{dangerouslySetInnerHTML:{__html:t}}),M=React__default.forwardRef((({id:t,anchorId:l,anchorSelect:n,content:i,html:c,render:a,className:u,classNameArrow:d,variant:p="dark",place:v="top",offset:m=10,wrapper:f="div",children:h=null,events:w=["hover"],openOnClick:b=!1,positionStrategy:S="absolute",middlewares:g,delayShow:E=0,delayHide:_=0,float:O=!1,hidden:k=!1,noArrow:T=!1,clickable:L=!1,closeOnEsc:C=!1,closeOnScroll:R=!1,closeOnResize:x=!1,openEvents:N,closeEvents:$,globalCloseEvents:I,imperativeModeOnly:B=!1,style:z,position:D,isOpen:M,defaultIsOpen:W=!1,disableStyleInjection:P=!1,border:V,opacity:F,arrowColor:K,setIsOpen:U,afterShow:X,afterHide:Y,disableTooltip:G,role:Z="tooltip"},J)=>{const[Q,ee]=useState(i),[te,oe]=useState(c),[le,re]=useState(v),[ne,ie]=useState(p),[ce,se]=useState(m),[ae,ue]=useState(E),[de,pe]=useState(_),[ve,me]=useState(O),[fe,ye]=useState(k),[he,we]=useState(f),[be,Se]=useState(w),[ge,Ee]=useState(S),[Ae,_e]=useState(null),[Oe,ke]=useState(null),Te=useRef(P),{anchorRefs:Le,activeAnchor:Ce}=j(t),Re=e=>null==e?void 0:e.getAttributeNames().reduce(((t,o)=>{var l;if(o.startsWith("data-tooltip-")){t[o.replace(/^data-tooltip-/,"")]=null!==(l=null==e?void 0:e.getAttribute(o))&&void 0!==l?l:null;}return t}),{}),xe=e=>{const t={place:e=>{var t;re(null!==(t=e)&&void 0!==t?t:v);},content:e=>{ee(null!=e?e:i);},html:e=>{oe(null!=e?e:c);},variant:e=>{var t;ie(null!==(t=e)&&void 0!==t?t:p);},offset:e=>{se(null===e?m:Number(e));},wrapper:e=>{var t;we(null!==(t=e)&&void 0!==t?t:f);},events:e=>{const t=null==e?void 0:e.split(" ");Se(null!=t?t:w);},"position-strategy":e=>{var t;Ee(null!==(t=e)&&void 0!==t?t:S);},"delay-show":e=>{ue(null===e?E:Number(e));},"delay-hide":e=>{pe(null===e?_:Number(e));},float:e=>{me(null===e?O:"true"===e);},hidden:e=>{ye(null===e?k:"true"===e);},"class-name":e=>{_e(e);}};Object.values(t).forEach((e=>e(null))),Object.entries(e).forEach((([e,o])=>{var l;null===(l=t[e])||void 0===l||l.call(t,o);}));};useEffect((()=>{ee(i);}),[i]),useEffect((()=>{oe(c);}),[c]),useEffect((()=>{re(v);}),[v]),useEffect((()=>{ie(p);}),[p]),useEffect((()=>{se(m);}),[m]),useEffect((()=>{ue(E);}),[E]),useEffect((()=>{pe(_);}),[_]),useEffect((()=>{me(O);}),[O]),useEffect((()=>{ye(k);}),[k]),useEffect((()=>{Ee(S);}),[S]),useEffect((()=>{Te.current!==P&&console.warn("[react-tooltip] Do not change `disableStyleInjection` dynamically.");}),[P]),useEffect((()=>{"undefined"!=typeof window&&window.dispatchEvent(new CustomEvent("react-tooltip-inject-styles",{detail:{disableCore:"core"===P,disableBase:P}}));}),[]),useEffect((()=>{var e;const o=new Set(Le);let r=n;if(!r&&t&&(r=`[data-tooltip-id='${t.replace(/'/g,"\\'")}']`),r)try{document.querySelectorAll(r).forEach((e=>{o.add({current:e});}));}catch(e){console.warn(`[react-tooltip] "${r}" is not a valid CSS selector`);}const i=document.querySelector(`[id='${l}']`);if(i&&o.add({current:i}),!o.size)return ()=>null;const c=null!==(e=null!=Oe?Oe:i)&&void 0!==e?e:Ce.current,s=new MutationObserver((e=>{e.forEach((e=>{var t;if(!c||"attributes"!==e.type||!(null===(t=e.attributeName)||void 0===t?void 0:t.startsWith("data-tooltip-")))return;const o=Re(c);xe(o);}));})),a={attributes:!0,childList:!1,subtree:!1};if(c){const e=Re(c);xe(e),s.observe(c,a);}return ()=>{s.disconnect();}}),[Le,Ce,Oe,l,n]),useEffect((()=>{(null==z?void 0:z.border)&&console.warn("[react-tooltip] Do not set `style.border`. Use `border` prop instead."),V&&!A("border",`${V}`)&&console.warn(`[react-tooltip] "${V}" is not a valid \`border\`.`),(null==z?void 0:z.opacity)&&console.warn("[react-tooltip] Do not set `style.opacity`. Use `opacity` prop instead."),F&&!A("opacity",`${F}`)&&console.warn(`[react-tooltip] "${F}" is not a valid \`opacity\`.`);}),[]);let Ne=h;const $e=useRef(null);if(a){const t=a({content:(null==Oe?void 0:Oe.getAttribute("data-tooltip-content"))||Q||null,activeAnchor:Oe});Ne=t?React__default.createElement("div",{ref:$e,className:"react-tooltip-content-wrapper"},t):null;}else Q&&(Ne=Q);te&&(Ne=React__default.createElement(H,{content:te}));const Ie={forwardRef:J,id:t,anchorId:l,anchorSelect:n,className:cls(u,Ae),classNameArrow:d,content:Ne,contentWrapperRef:$e,place:le,variant:ne,offset:ce,wrapper:he,events:be,openOnClick:b,positionStrategy:ge,middlewares:g,delayShow:ae,delayHide:de,float:ve,hidden:fe,noArrow:T,clickable:L,closeOnEsc:C,closeOnScroll:R,closeOnResize:x,openEvents:N,closeEvents:$,globalCloseEvents:I,imperativeModeOnly:B,style:z,position:D,isOpen:M,defaultIsOpen:W,border:V,opacity:F,arrowColor:K,setIsOpen:U,afterShow:X,afterHide:Y,disableTooltip:G,activeAnchor:Oe,setActiveAnchor:e=>ke(e),role:Z};return React__default.createElement(q,{...Ie})}));"undefined"!=typeof window&&window.addEventListener("react-tooltip-inject-styles",(e=>{e.detail.disableCore||S({css:`:root{--rt-color-white:#fff;--rt-color-dark:#222;--rt-color-success:#8dc572;--rt-color-error:#be6464;--rt-color-warning:#f0ad4e;--rt-color-info:#337ab7;--rt-opacity:0.9;--rt-transition-show-delay:0.15s;--rt-transition-closing-delay:0.15s}.core-styles-module_tooltip__3vRRp{position:absolute;top:0;left:0;pointer-events:none;opacity:0;will-change:opacity}.core-styles-module_fixed__pcSol{position:fixed}.core-styles-module_arrow__cvMwQ{position:absolute;background:inherit}.core-styles-module_noArrow__xock6{display:none}.core-styles-module_clickable__ZuTTB{pointer-events:auto}.core-styles-module_show__Nt9eE{opacity:var(--rt-opacity);transition:opacity var(--rt-transition-show-delay)ease-out}.core-styles-module_closing__sGnxF{opacity:0;transition:opacity var(--rt-transition-closing-delay)ease-in}`,type:"core"}),e.detail.disableBase||S({css:`
.styles-module_tooltip__mnnfp{padding:8px 16px;border-radius:3px;font-size:90%;width:max-content}.styles-module_arrow__K0L3T{width:8px;height:8px}[class*='react-tooltip__place-top']>.styles-module_arrow__K0L3T{transform:rotate(45deg)}[class*='react-tooltip__place-right']>.styles-module_arrow__K0L3T{transform:rotate(135deg)}[class*='react-tooltip__place-bottom']>.styles-module_arrow__K0L3T{transform:rotate(225deg)}[class*='react-tooltip__place-left']>.styles-module_arrow__K0L3T{transform:rotate(315deg)}.styles-module_dark__xNqje{background:var(--rt-color-dark);color:var(--rt-color-white)}.styles-module_light__Z6W-X{background-color:var(--rt-color-white);color:var(--rt-color-dark)}.styles-module_success__A2AKt{background-color:var(--rt-color-success);color:var(--rt-color-white)}.styles-module_warning__SCK0X{background-color:var(--rt-color-warning);color:var(--rt-color-white)}.styles-module_error__JvumD{background-color:var(--rt-color-error);color:var(--rt-color-white)}.styles-module_info__BWdHW{background-color:var(--rt-color-info);color:var(--rt-color-white)}`,type:"base"});}));

var shadow = {
    larger: "0px 4px 24px 0px ".concat(customColors.shadow),
    normal: "0px 4px 16px 0px ".concat(customColors.shadow),
    smaller: "0px 0px 8px 0px ".concat(customColors.shadow),
    focus: " 0px 0px 2px 4px ".concat(customColors.focus)
};
styled.div(templateObject_1$1r || (templateObject_1$1r = __makeTemplateObject(["\n  width: 152px;\n  height: 152px;\n  border: 1px solid ", ";\n  border-radius: var(--borderRadius);\n  box-shadow: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  width: 152px;\n  height: 152px;\n  border: 1px solid ", ";\n  border-radius: var(--borderRadius);\n  box-shadow: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])), colorBorder$1.colorBorderBorderPrimary, function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'normal' : _b;
    return shadow[size];
});
var templateObject_1$1r;

var StyledReactTooltip = styled(M)(templateObject_1$1q || (templateObject_1$1q = __makeTemplateObject(["\n  --rt-color-white: var(--white);\n  --rt-color-dark: var(--asphalt);\n  --rt-color-success: var(--successLightest);\n  --rt-color-error: var(--alertLightest);\n  --rt-color-warning: var(--warningLightest);\n  --rt-color-info: var(--smokeLight);\n  --rt-opacity: 1;\n\n  max-width: ", ";\n  overflow-wrap: break-word;\n\n  &.react-tooltip {\n    border-radius: 6px;\n    ", "\n    z-index: ", ";\n  }\n\n  &.__react_component_tooltip.show {\n    ", "\n    box-shadow: ", "\n  }\n"], ["\n  --rt-color-white: var(--white);\n  --rt-color-dark: var(--asphalt);\n  --rt-color-success: var(--successLightest);\n  --rt-color-error: var(--alertLightest);\n  --rt-color-warning: var(--warningLightest);\n  --rt-color-info: var(--smokeLight);\n  --rt-opacity: 1;\n\n  max-width: ", ";\n  overflow-wrap: break-word;\n\n  &.react-tooltip {\n    border-radius: 6px;\n    ", "\n    z-index: ", ";\n  }\n\n  &.__react_component_tooltip.show {\n    ", "\n    box-shadow: ", "\n  }\n"])), function (_a) {
    var maxWidth = _a.maxWidth;
    return getSizeValue(maxWidth);
}, function (_a) {
    var padding = _a.padding;
    return padding && "padding: ".concat(padding, ";");
}, zIndexMap.tooltip, function (_a) {
    var opacity = _a.opacity;
    return opacity && "opacity: ".concat(opacity, ";");
}, shadow.larger);
var BlcTooltip = function (_a) {
    var text = _a.text, id = _a.id, scrollHide = _a.scrollHide, resizeHide = _a.resizeHide, children = _a.children, maxWidth = _a.maxWidth, _b = _a.border, border = _b === void 0 ? true : _b, padding = _a.padding, _c = _a.variant, variant = _c === void 0 ? 'info' : _c, clickable = _a.clickable, props = __rest(_a, ["text", "id", "scrollHide", "resizeHide", "children", "maxWidth", "border", "padding", "variant", "clickable"]);
    var globalCloseEvents = {
        scroll: scrollHide,
        resize: resizeHide,
        clickOutsideAnchor: true
    };
    return (jsx(StyledReactTooltip, __assign({ id: id, maxWidth: maxWidth, variant: variant, border: border ? "1px solid ".concat(colorBorder$1.colorBorderBorderFocus) : '', padding: padding, clickable: clickable, globalCloseEvents: globalCloseEvents }, props, { children: !children ? jsx("span", { children: text }) : jsx(Body, __assign({ size: "smaller" }, { children: children })) })));
};
var templateObject_1$1q;

var Container$b = styled.div(templateObject_1$1p || (templateObject_1$1p = __makeTemplateObject(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  flex-direction: column;\n"], ["\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  flex-direction: column;\n"])));
var ListContainer = styled.div(templateObject_2$F || (templateObject_2$F = __makeTemplateObject(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  flex-direction: column;\n  margin-left: 18px;\n"], ["\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  flex-direction: column;\n  margin-left: 18px;\n"])));
var templateObject_1$1p, templateObject_2$F;

var BlcConditionalIfWrapper = function (_a) {
    var condition = _a.condition, wrapperIf = _a.wrapperIf, wrapperElse = _a.wrapperElse, children = _a.children;
    return condition ? wrapperIf(children) : wrapperElse(children);
};

var listStyleType = function (type) { return (type === 'ordered' ? 'decimal' : 'disc'); };
var UnorderedList = styled.ul(function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'colorTextTextPrimary' : _b, _c = _a.size, size = _c === void 0 ? 'inherit' : _c, styleType = _a.styleType, type = _a.type, fontWeight = _a.fontWeight, textAlign = _a.textAlign;
    return css(templateObject_1$1o || (templateObject_1$1o = __makeTemplateObject(["\n    color: ", ";\n    display: block;\n    list-style-type: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    margin: 0;\n    padding: 0;\n    text-align: ", ";\n    @media ", " {\n      font-size: ", ";\n    }\n    @media ", " {\n      font-size: ", ";\n    }\n    @media ", " {\n      font-size: ", ";\n    }\n  "], ["\n    color: ", ";\n    display: block;\n    list-style-type: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    margin: 0;\n    padding: 0;\n    text-align: ", ";\n    @media ", " {\n      font-size: ", ";\n    }\n    @media ", " {\n      font-size: ", ";\n    }\n    @media ", " {\n      font-size: ", ";\n    }\n  "])), getTextColor(color), styleType ? listStyleType(type) : 'none', getTextSizeMXL(size), getFontWeight(fontWeight), getTextLineHeight(size), textAlign, mediaSizeMap.larger, getTextSizeML(size), mediaSizeMap.smaller, getTextSizeMS(size), mediaSizeMap.smallest, getTextSizeMXS(size));
});
var OrderedList = styled(UnorderedList).attrs({
    as: 'ol'
})(templateObject_2$E || (templateObject_2$E = __makeTemplateObject([""], [""])));
var Container$a = styled.div(templateObject_3$k || (templateObject_3$k = __makeTemplateObject(["\n  font-size: 13px;\n  font-family: ", ";\n"], ["\n  font-size: 13px;\n  font-family: ", ";\n"])), fontFamily);
var templateObject_1$1o, templateObject_2$E, templateObject_3$k;

var BlcList = function (props) {
    var count = 0;
    return (jsx(BlcConditionalIfWrapper, __assign({ condition: props.type === 'ordered', wrapperIf: function (children) { return jsx(OrderedList, __assign({}, props, { children: children })); }, wrapperElse: function (children) { return jsx(UnorderedList, __assign({}, props, { children: children })); } }, { children: jsx(Container$a, { children: React__default.Children.map(props.children, function (child) {
                return React__default.cloneElement(child, { id: count++, color: props.color });
            }) }) })));
};

var ListItem = styled.li(function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'colorTextTextPrimary' : _b, _c = _a.size, size = _c === void 0 ? 'inherit' : _c, display = _a.display, fontWeight = _a.fontWeight, margin = _a.margin, textAlign = _a.textAlign;
    return css(templateObject_1$1n || (templateObject_1$1n = __makeTemplateObject(["\n    color: ", ";\n    ", "\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    margin: ", ";\n    text-align: ", ";\n    @media ", " {\n      font-size: ", ";\n      margin: ", ";\n    }\n    @media ", " {\n      font-size: ", ";\n      margin: ", ";\n    }\n    @media ", " {\n      font-size: ", ";\n      margin: ", ";\n    }\n  "], ["\n    color: ", ";\n    ", "\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    margin: ", ";\n    text-align: ", ";\n    @media ", " {\n      font-size: ", ";\n      margin: ", ";\n    }\n    @media ", " {\n      font-size: ", ";\n      margin: ", ";\n    }\n    @media ", " {\n      font-size: ", ";\n      margin: ", ";\n    }\n  "])), getTextColor(color), display ? "display: ".concat(display, ";") : '', getTextSizeMXL(size), getFontWeight(fontWeight), getTextLineHeight(size), getSpaceMXL(margin), textAlign, mediaSizeMap.larger, getTextSizeML(size), getSpaceML(margin), mediaSizeMap.smaller, getTextSizeMS(size), getSpaceMS(margin), mediaSizeMap.smallest, getTextSizeMXS(size), getSpaceMXS(margin));
});
var templateObject_1$1n;

var BlcListItem = function (_a) {
    var children = _a.children, id = _a.id, _b = _a.color, color = _b === void 0 ? 'fontColor' : _b, display = _a.display, _c = _a.fontWeight, fontWeight = _c === void 0 ? 'regular' : _c, _d = _a.margin, margin = _d === void 0 ? 'none' : _d, _e = _a.size, size = _e === void 0 ? 'inherit' : _e, _f = _a.textAlign, textAlign = _f === void 0 ? 'inherit' : _f;
    return (jsx(ListItem, __assign({ color: color, display: display, fontWeight: fontWeight, margin: margin, size: size, textAlign: textAlign }, { children: children }), id));
};

var signifierTooltipId = 'BlcSignifierTooltip-info';

var BlcSignifierTooltip = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, tiers = _a.tiers, tiersTitle = _a.tiersTitle, additionalInfo = _a.additionalInfo;
    return (jsx(BlcTooltip, __assign({ id: signifierTooltipId, maxWidth: 350 }, { children: jsxs(Container$b, { children: [jsx(Headline, __assign({ size: "H5" }, { children: title })), jsx(Body, { children: subtitle }), tiersTitle && jsx(Body, { children: tiersTitle }), jsx(ListContainer, { children: jsx(BlcList, __assign({ styleType: true, color: "black", size: "normal" }, { children: tiers &&
                            tiers.map(function (_a, i) {
                                var name = _a.name, description = _a.description;
                                return (jsxs(BlcListItem, { children: [name && "".concat(name, ":"), " ", description] }, i));
                            }) })) }), additionalInfo && jsx(Body, { children: additionalInfo })] }) })));
};

var BlcSignifier = function (_a) {
    var title = _a.title, signifierTitle = _a.signifierTitle, signifierSubtitle = _a.signifierSubtitle, tooltipTitle = _a.tooltipTitle, tooltipSubtitle = _a.tooltipSubtitle, tooltipTiers = _a.tooltipTiers, tiersTitle = _a.tiersTitle, additionalInfo = _a.additionalInfo;
    return (jsxs(PricingTierContainer, { children: [jsxs(TitleContainer, { children: [jsx(Headline, __assign({ size: "H4" }, { children: title })), jsx(IconContainer$2, __assign({ "data-tooltip-id": signifierTooltipId }, { children: jsx(Icon, { name: "info", color: "colorIconIconSecondary" }) })), jsx(BlcSignifierTooltip, { title: tooltipTitle, subtitle: tooltipSubtitle, tiers: tooltipTiers, tiersTitle: tiersTitle, additionalInfo: additionalInfo })] }), jsxs(InfoContainer, { children: [jsx(BadgeContainer, { children: jsx(Icon, { name: "elite-inverted", color: "colorIconIconBrand", size: "largest" }) }), jsxs(TextContainer$1, { children: [jsx(Container$c, { children: jsx(Body, __assign({ size: "larger" }, { children: signifierTitle })) }), jsx(Container$c, { children: jsx(Body, __assign({ size: "smaller", bold: true, color: "grayDark" }, { children: signifierSubtitle })) })] })] })] }));
};

var dayjs_minExports = {};
var dayjs_min = {
  get exports(){ return dayjs_minExports; },
  set exports(v){ dayjs_minExports = v; },
};

(function (module, exports) {
	!function(t,e){module.exports=e();}(commonjsGlobal,(function(){var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",f="month",h="quarter",c="year",d="date",l="Invalid Date",$=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),ordinal:function(t){var e=["th","st","nd","rd"],n=t%100;return "["+t+(e[(n-20)%10]||e[n]||e[0])+"]"}},m=function(t,e,n){var r=String(t);return !r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},v={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return (e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return -t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,f),s=n-i<0,u=e.clone().add(r+(s?-1:1),f);return +(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return {M:f,y:c,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:h}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},g="en",D={};D[g]=M;var p=function(t){return t instanceof _},S=function t(e,n,r){var i;if(!e)return g;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else {var a=e.name;D[a]=e,i=a;}return !r&&i&&(g=i),i||!r&&g},w=function(t,e){if(p(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},O=v;O.l=S,O.i=p,O.w=function(t,e){return w(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=S(t.locale,null,!0),this.parse(t);}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(O.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match($);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.$x=t.x||{},this.init();},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds();},m.$utils=function(){return O},m.isValid=function(){return !(this.$d.toString()===l)},m.isSame=function(t,e){var n=w(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return w(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<w(t)},m.$g=function(t,e,n){return O.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!O.u(e)||e,h=O.p(t),l=function(t,e){var i=O.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},$=function(t,e){return O.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,v="set"+(this.$u?"UTC":"");switch(h){case c:return r?l(1,0):l(31,11);case f:return r?l(1,M):l(0,M+1);case o:var g=this.$locale().weekStart||0,D=(y<g?y+7:y)-g;return l(r?m-D:m+(6-D),M);case a:case d:return $(v+"Hours",0);case u:return $(v+"Minutes",1);case s:return $(v+"Seconds",2);case i:return $(v+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=O.p(t),h="set"+(this.$u?"UTC":""),l=(n={},n[a]=h+"Date",n[d]=h+"Date",n[f]=h+"Month",n[c]=h+"FullYear",n[u]=h+"Hours",n[s]=h+"Minutes",n[i]=h+"Seconds",n[r]=h+"Milliseconds",n)[o],$=o===a?this.$D+(e-this.$W):e;if(o===f||o===c){var y=this.clone().set(d,1);y.$d[l]($),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d;}else l&&this.$d[l]($);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[O.p(t)]()},m.add=function(r,h){var d,l=this;r=Number(r);var $=O.p(h),y=function(t){var e=w(l);return O.w(e.date(e.date()+Math.round(t*r)),l)};if($===f)return this.set(f,this.$M+r);if($===c)return this.set(c,this.$y+r);if($===a)return y(1);if($===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[$]||1,m=this.$d.getTime()+r*M;return O.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||l;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=O.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,f=n.months,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},c=function(t){return O.s(s%12||12,t,"0")},d=n.meridiem||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r},$={YY:String(this.$y).slice(-2),YYYY:this.$y,M:a+1,MM:O.s(a+1,2,"0"),MMM:h(n.monthsShort,a,f,3),MMMM:h(f,a),D:this.$D,DD:O.s(this.$D,2,"0"),d:String(this.$W),dd:h(n.weekdaysMin,this.$W,o,2),ddd:h(n.weekdaysShort,this.$W,o,3),dddd:o[this.$W],H:String(s),HH:O.s(s,2,"0"),h:c(1),hh:c(2),a:d(s,u,!0),A:d(s,u,!1),m:String(u),mm:O.s(u,2,"0"),s:String(this.$s),ss:O.s(this.$s,2,"0"),SSS:O.s(this.$ms,3,"0"),Z:i};return r.replace(y,(function(t,e){return e||$[t]||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,l){var $,y=O.p(d),M=w(r),m=(M.utcOffset()-this.utcOffset())*e,v=this-M,g=O.m(this,M);return g=($={},$[c]=g/12,$[f]=g,$[h]=g/3,$[o]=(v-m)/6048e5,$[a]=(v-m)/864e5,$[u]=v/n,$[s]=v/e,$[i]=v/t,$)[y]||v,l?g:O.a(g)},m.daysInMonth=function(){return this.endOf(f).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=S(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return O.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),T=_.prototype;return w.prototype=T,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",f],["$y",c],["$D",d]].forEach((function(t){T[t[1]]=function(e){return this.$g(e,t[0],t[1])};})),w.extend=function(t,e){return t.$i||(t(e,_,w),t.$i=!0),w},w.locale=S,w.isDayjs=p,w.unix=function(t){return w(1e3*t)},w.en=D[g],w.Ls=D,w.p={},w}));
} (dayjs_min));

var dayjs = dayjs_minExports;

var reactTimeSync = {};

var timeSync$1 = {};

var timers = {};

var constants = {};

Object.defineProperty(constants, "__esModule", {
  value: true
});
constants.IntervalMap = constants.Interval = void 0;

var _IntervalMap;

function _defineProperty$8(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Intervals
var Interval;
constants.Interval = Interval;

(function (Interval) {
  Interval["SECONDS"] = "s";
  Interval["MINUTES"] = "m";
  Interval["HOURS"] = "h";
  Interval["DAYS"] = "d";
})(Interval || (constants.Interval = Interval = {}));

var IntervalMap = (_IntervalMap = {}, _defineProperty$8(_IntervalMap, Interval.SECONDS, 1), _defineProperty$8(_IntervalMap, Interval.MINUTES, 2), _defineProperty$8(_IntervalMap, Interval.HOURS, 3), _defineProperty$8(_IntervalMap, Interval.DAYS, 4), _IntervalMap);
constants.IntervalMap = IntervalMap;

var id = {};

Object.defineProperty(id, "__esModule", {
  value: true
});
id.generateId = generateId;
var lastId = 0;

function generateId() {
  return lastId++;
}

var validation = {};

Object.defineProperty(validation, "__esModule", {
  value: true
});
validation.validateInterval = validateInterval;

var _constants$4 = constants;

function validateInterval(interval) {
  if (typeof interval !== "undefined" && !Object.keys(_constants$4.IntervalMap).some(function (innerInterval) {
    return innerInterval === interval;
  })) {
    throw new Error("interval must be one of TimeSync.SECONDS, TimeSync.MINUTES, TimeSync.HOURS or TimeSync.DAYS");
  }
}

var getMs$1 = {};

Object.defineProperty(getMs$1, "__esModule", {
  value: true
});
getMs$1.getMs = getMs;

var _constants$3 = constants;

function getMs(interval) {
  var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var intervalValue = _constants$3.IntervalMap[interval];
  var ms = 1000;

  if (intervalValue >= _constants$3.IntervalMap[_constants$3.Interval.MINUTES]) {
    ms *= 60;
  }

  if (intervalValue >= _constants$3.IntervalMap[_constants$3.Interval.HOURS]) {
    ms *= 60;
  }

  if (intervalValue >= _constants$3.IntervalMap[_constants$3.Interval.DAYS]) {
    ms *= 24;
  }

  ms *= unit;
  return ms;
}

Object.defineProperty(timers, "__esModule", {
  value: true
});
timers.Timers = void 0;
timers.getCurrentTime = getCurrentTime;

var _constants$2 = constants;

var _id$1 = id;

var _validation$1 = validation;

var _getMs$1 = getMs$1;

function _classCallCheck$3(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$2(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$2(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$2(Constructor.prototype, protoProps); if (staticProps) _defineProperties$2(Constructor, staticProps); return Constructor; }

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$6(Object(source), true).forEach(function (key) { _defineProperty$7(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$7(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DEFAULT_TIMER_CONFIG = {
  interval: _constants$2.Interval.SECONDS,
  unit: 1
};

function validateTimerConfig(timerConfig) {
  (0, _validation$1.validateInterval)(timerConfig.interval);

  if (typeof timerConfig.unit !== "undefined" && (!Number.isInteger(timerConfig.unit) || timerConfig.unit <= 0)) {
    throw new Error("unit must be a positive integer");
  }
}

function validateAddTimerArgs(callback, timerConfig) {
  if (!callback) {
    throw new Error("You need to provide a callback as the first argument to addTimer");
  }

  validateTimerConfig(timerConfig);
}

function getTimezoneOffset() {
  return new Date().getTimezoneOffset() * 60 * 1000;
}

function roundTick(ms, tick, interval) {
  var delta = tick % ms;

  if (interval === _constants$2.Interval.DAYS) {
    var timezoneDelta = delta - getTimezoneOffset();

    if (timezoneDelta > ms) {
      return tick + timezoneDelta;
    }

    delta = Math.abs(timezoneDelta);
  }

  return tick - delta;
}

function getCurrentTick(ms, interval) {
  return roundTick(ms, Date.now(), interval);
}

function getNextTick(interval, ms, time) {
  var newTime = time + ms;
  return roundTick(ms, newTime, interval);
}

function getUnixTimeStamp(tick) {
  return Math.floor(tick / 1000);
}

function getCurrentTime() {
  var timerConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  validateTimerConfig(timerConfig);

  var config = _objectSpread$5(_objectSpread$5({}, DEFAULT_TIMER_CONFIG), timerConfig);

  return getUnixTimeStamp(getCurrentTick((0, _getMs$1.getMs)(config.interval, config.unit), config.interval));
}

var Timers = /*#__PURE__*/function () {
  function Timers() {
    _classCallCheck$3(this, Timers);

    _defineProperty$7(this, "timers", {});

    _defineProperty$7(this, "currentTimeout", void 0);

    _defineProperty$7(this, "nextTick", 0);

    this.addTimer = this.addTimer.bind(this);
    this.removeAllTimers = this.removeAllTimers.bind(this);
    this.removeTimer = this.removeTimer.bind(this);
    this.revalidateAllTimers = this.revalidateAllTimers.bind(this);
  }

  _createClass$2(Timers, [{
    key: "removeAllTimers",
    value: function removeAllTimers() {
      this.timers = {};
      this.revalidateAllTimers();
    }
  }, {
    key: "addTimer",
    value: function addTimer(callback) {
      var _this = this;

      var timerConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      validateAddTimerArgs(callback, timerConfig);
      var id = (0, _id$1.generateId)();

      var newTimerBase = _objectSpread$5(_objectSpread$5({}, DEFAULT_TIMER_CONFIG), timerConfig);

      var ms = (0, _getMs$1.getMs)(newTimerBase.interval, newTimerBase.unit);

      var newTimer = _objectSpread$5(_objectSpread$5({}, newTimerBase), {}, {
        callback: callback,
        id: id,
        ms: ms,
        nextTick: getNextTick(newTimerBase.interval, ms, Date.now())
      });

      this.timers[id] = newTimer;

      if (!this.nextTick || newTimer.nextTick < this.nextTick) {
        this.revalidateAllTimers();
      }

      return function () {
        return _this.removeTimer(id);
      };
    }
  }, {
    key: "revalidateAllTimers",
    value: function revalidateAllTimers() {
      var _this2 = this;

      clearTimeout(this.currentTimeout);
      var now = Date.now();
      this.nextTick = Object.keys(this.timers).reduce(function (prev, timerId) {
        var timer = _this2.timers[timerId];

        if (!timer) {
          // Timer was already removed within callback of another timer
          return prev;
        }

        if (timer.nextTick <= now) {
          var usedTime = roundTick(timer.ms, now, timer.interval);
          timer.callback(getUnixTimeStamp(usedTime));
          timer.nextTick = getNextTick(timer.interval, timer.ms, now);
        }

        if (!prev || prev > timer.nextTick) {
          return timer.nextTick;
        }

        return prev;
      }, 0);

      if (this.nextTick) {
        var nextTickDelta = this.nextTick - Date.now();
        this.currentTimeout = setTimeout(this.revalidateAllTimers, nextTickDelta);
      }
    }
  }, {
    key: "removeTimer",
    value: function removeTimer(id) {
      var timer = this.timers[id];

      if (!timer) {
        return;
      }

      delete this.timers[id];

      if (timer.nextTick === this.nextTick) {
        this.revalidateAllTimers();
      }
    }
  }]);

  return Timers;
}();

timers.Timers = Timers;

var countdowns = {};

Object.defineProperty(countdowns, "__esModule", {
  value: true
});
countdowns.Countdowns = void 0;
countdowns.getTimeLeft = getTimeLeft;

var _constants$1 = constants;

var _validation = validation;

var _id = id;

var _getMs = getMs$1;

function _classCallCheck$2(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$1(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$1(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$1(Constructor.prototype, protoProps); if (staticProps) _defineProperties$1(Constructor, staticProps); return Constructor; }

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$5(Object(source), true).forEach(function (key) { _defineProperty$6(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$6(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DEFAULT_COUNTDOWN_CONFIG = {
  interval: _constants$1.Interval.SECONDS
};

function validateCountdownConfig(countdownConfig) {
  if (!countdownConfig) {
    throw new Error("You must pass a valid countdown configuration object");
  }

  (0, _validation.validateInterval)(countdownConfig.interval);

  if (!Number.isInteger(countdownConfig.until)) {
    throw new Error("until must be an integer");
  }
}

function convert(difference, interval) {
  var intervalValue = _constants$1.IntervalMap[interval];
  var result = difference / 1000;

  if (intervalValue >= _constants$1.IntervalMap[_constants$1.Interval.MINUTES]) {
    result /= 60;
  }

  if (intervalValue >= _constants$1.IntervalMap[_constants$1.Interval.HOURS]) {
    result /= 60;
  }

  if (intervalValue >= _constants$1.IntervalMap[_constants$1.Interval.DAYS]) {
    result /= 24;
  }

  return result;
}

function calculateTimeLeft(config) {
  // until is timestamp in milliseconds that should be reached
  var difference = config.until - Date.now(); // Convert the difference to the specified interval

  var timeLeft = Math.ceil(convert(difference, config.interval));
  return timeLeft > 0 ? timeLeft : 0;
}

function getTimeLeft(countdownConfig) {
  validateCountdownConfig(countdownConfig);

  var config = _objectSpread$4(_objectSpread$4({}, DEFAULT_COUNTDOWN_CONFIG), countdownConfig);

  return calculateTimeLeft(config);
}

function getNextTickDelta(_ref, time) {
  var ms = _ref.ms,
      until = _ref.until;
  var timeMod = time % ms;
  var untilMod = until % ms;

  if (timeMod === untilMod) {
    return ms;
  }

  if (timeMod < untilMod) {
    return untilMod - timeMod;
  }

  return untilMod + ms - timeMod;
}

function validateCreateCountdownArgs(callback, countdownConfig) {
  if (!callback) {
    throw new Error("You need to provide a callback as the first argument to createCountdown");
  }

  validateCountdownConfig(countdownConfig);
}

var Countdowns = /*#__PURE__*/function () {
  function Countdowns() {
    _classCallCheck$2(this, Countdowns);

    _defineProperty$6(this, "countdowns", {});

    this.createCountdown = this.createCountdown.bind(this);
    this.removeCountdown = this.removeCountdown.bind(this);
    this.revalidate = this.revalidate.bind(this);
    this.revalidateAllCountdowns = this.revalidateAllCountdowns.bind(this);
    this.stopAllCountdowns = this.stopAllCountdowns.bind(this);
  }

  _createClass$1(Countdowns, [{
    key: "createCountdown",
    value: function createCountdown(callback, countdownConfig) {
      var _this = this;

      validateCreateCountdownArgs(callback, countdownConfig);
      var id = (0, _id.generateId)();

      var countdownBase = _objectSpread$4(_objectSpread$4({}, DEFAULT_COUNTDOWN_CONFIG), countdownConfig);

      var newCountdown = _objectSpread$4(_objectSpread$4({}, countdownBase), {}, {
        callback: callback,
        id: id,
        ms: (0, _getMs.getMs)(countdownBase.interval)
      });

      var now = Date.now();
      var nextTickDelta = getNextTickDelta(newCountdown, now);

      if (newCountdown.until <= now) {
        throw new Error("until property needs to be in the future. Please ensure you are using a millisecond timestamp!");
      }

      newCountdown.timeout = setTimeout(this.revalidate, nextTickDelta, newCountdown);
      this.countdowns[id] = newCountdown;
      return function () {
        return _this.removeCountdown(id);
      };
    }
  }, {
    key: "stopAllCountdowns",
    value: function stopAllCountdowns() {
      var _this2 = this;

      Object.keys(this.countdowns).forEach(function (id) {
        clearTimeout(_this2.countdowns[id].timeout);
      });
      this.countdowns = {};
    }
  }, {
    key: "revalidateAllCountdowns",
    value: function revalidateAllCountdowns() {
      var _this3 = this;

      Object.keys(this.countdowns).forEach(function (id) {
        _this3.revalidate(_this3.countdowns[id]);
      });
    }
  }, {
    key: "revalidate",
    value: function revalidate(countdown) {
      clearTimeout(countdown.timeout);
      var timeLeft = calculateTimeLeft(countdown);
      countdown.callback(timeLeft);

      if (timeLeft > 0) {
        var nextTickDelta = getNextTickDelta(countdown, Date.now());
        countdown.timeout = setTimeout(this.revalidate, nextTickDelta, countdown);
      } else {
        this.removeCountdown(countdown.id);
      }
    }
  }, {
    key: "removeCountdown",
    value: function removeCountdown(id) {
      var countdown = this.countdowns[id];

      if (!countdown) {
        return;
      }

      clearTimeout(countdown.timeout);
      delete this.countdowns[id];
    }
  }]);

  return Countdowns;
}();

countdowns.Countdowns = Countdowns;

Object.defineProperty(timeSync$1, "__esModule", {
  value: true
});
timeSync$1.default = void 0;

var _timers = timers;

var _constants = constants;

var _countdowns = countdowns;

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty$5(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TimeSync = function TimeSync() {
  _classCallCheck$1(this, TimeSync);

  _defineProperty$5(this, "addTimer", void 0);

  _defineProperty$5(this, "removeAllTimers", void 0);

  _defineProperty$5(this, "createCountdown", void 0);

  _defineProperty$5(this, "stopAllCountdowns", void 0);

  _defineProperty$5(this, "revalidate", void 0);

  _defineProperty$5(this, "getCurrentTime", void 0);

  _defineProperty$5(this, "getTimeLeft", void 0);

  var timers = new _timers.Timers();
  var countdowns = new _countdowns.Countdowns();
  this.addTimer = timers.addTimer;
  this.removeAllTimers = timers.removeAllTimers;
  this.createCountdown = countdowns.createCountdown;
  this.stopAllCountdowns = countdowns.stopAllCountdowns;

  this.revalidate = function () {
    timers.revalidateAllTimers();
    countdowns.revalidateAllCountdowns();
  };

  this.getCurrentTime = _timers.getCurrentTime;
  this.getTimeLeft = _countdowns.getTimeLeft;
};

timeSync$1.default = TimeSync;

_defineProperty$5(TimeSync, "SECONDS", _constants.Interval.SECONDS);

_defineProperty$5(TimeSync, "MINUTES", _constants.Interval.MINUTES);

_defineProperty$5(TimeSync, "HOURS", _constants.Interval.HOURS);

_defineProperty$5(TimeSync, "DAYS", _constants.Interval.DAYS);

_defineProperty$5(TimeSync, "getCurrentTime", _timers.getCurrentTime);

_defineProperty$5(TimeSync, "getTimeLeft", _countdowns.getTimeLeft);

var connectTime$1 = {};

var useTime$1 = {};

var context = {};

Object.defineProperty(context, "__esModule", {
  value: true
});
context.default = context.TIMESYNC_PROP = void 0;

var _react$8 = _interopRequireDefault$6(React__default);

var _timeSync$1 = _interopRequireDefault$6(timeSync$1);

function _interopRequireDefault$6(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TIMESYNC_PROP = "$$_TIME_SYNC_HIDDEN_$$";
context.TIMESYNC_PROP = TIMESYNC_PROP;
var timeSync = new _timeSync$1.default();

var _default$4 = /*#__PURE__*/_react$8.default.createContext({
  getCurrentTime: _timeSync$1.default.getCurrentTime,
  getTimeLeft: _timeSync$1.default.getTimeLeft,
  addTimer: timeSync.addTimer,
  createCountdown: timeSync.createCountdown
});

context.default = _default$4;

var useStateWithDeps$1 = {};

var useForceUpdate$1 = {};

Object.defineProperty(useForceUpdate$1, "__esModule", {
  value: true
});
useForceUpdate$1.useForceUpdate = useForceUpdate;

var _react$7 = React__default;

function _slicedToArray$5(arr, i) { return _arrayWithHoles$5(arr) || _iterableToArrayLimit$5(arr, i) || _unsupportedIterableToArray$5(arr, i) || _nonIterableRest$5(); }

function _nonIterableRest$5() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$5(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$5(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$5(o, minLen); }

function _arrayLikeToArray$5(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$5(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$5(arr) { if (Array.isArray(arr)) return arr; }

function useForceUpdate() {
  var _useReducer = (0, _react$7.useReducer)(function (x) {
    return !x;
  }, false),
      _useReducer2 = _slicedToArray$5(_useReducer, 2),
      forceUpdate = _useReducer2[1];

  return function () {
    return forceUpdate();
  };
}

var depsAreEqual$1 = {};

Object.defineProperty(depsAreEqual$1, "__esModule", {
  value: true
});
depsAreEqual$1.depsAreEqual = depsAreEqual;

function depsAreEqual(prevDeps, deps) {
  return prevDeps.length === deps.length && deps.every(function (dep, index) {
    return Object.is(dep, prevDeps[index]);
  });
}

var isFunction$1 = {};

Object.defineProperty(isFunction$1, "__esModule", {
  value: true
});
isFunction$1.isFunction = isFunction;

// eslint-disable-next-line @typescript-eslint/ban-types
function isFunction(input) {
  return typeof input === "function";
}

Object.defineProperty(useStateWithDeps$1, "__esModule", {
  value: true
});
useStateWithDeps$1.useStateWithDeps = useStateWithDeps;

var _react$6 = React__default;

var _useForceUpdate = useForceUpdate$1;

var _depsAreEqual = depsAreEqual$1;

var _isFunction = isFunction$1;

/**
 * `useState` hook with an additional dependency array that resets
 * the state to the `initialState` param when the dependencies passed
 * in the `deps` array change.
 *
 * @param initialState
 * The state that will be set when the component mounts or the
 * dependencies change.
 *
 * It can also be a function which resolves to the state. If the state
 * is reset due to a change of dependencies, this function will be called with the previous
 * state (`undefined` for the first call upon mount).
 * @param deps Dependencies for this hook that resets the state to `initialState`
 */
function useStateWithDeps(initialState, deps) {
  var isMounted = (0, _react$6.useRef)(false); // Determine initial state

  var usableInitialState = null;

  if (!isMounted.current) {
    isMounted.current = true;

    if ((0, _isFunction.isFunction)(initialState)) {
      usableInitialState = initialState();
    } else {
      usableInitialState = initialState;
    }
  } // It would be possible to use useState instead of
  // useRef to store the state, however this would
  // trigger re-renders whenever the state is reset due
  // to a change in dependencies. In order to avoid these
  // re-renders, the state is stored in a ref and an
  // update is triggered via forceUpdate below when necessary


  var state = (0, _react$6.useRef)(usableInitialState); // Check if dependencies have changed

  var prevDeps = (0, _react$6.useRef)(deps);

  if (!(0, _depsAreEqual.depsAreEqual)(prevDeps.current, deps)) {
    // Update state and deps
    var nextState;

    if ((0, _isFunction.isFunction)(initialState)) {
      nextState = initialState(state.current);
    } else {
      nextState = initialState;
    }

    state.current = nextState;
    prevDeps.current = deps;
  }

  var forceUpdate = (0, _useForceUpdate.useForceUpdate)();
  var updateState = (0, _react$6.useCallback)(function updateState(newState) {
    var nextState;

    if ((0, _isFunction.isFunction)(newState)) {
      nextState = newState(state.current);
    } else {
      nextState = newState;
    }

    if (!Object.is(state.current, nextState)) {
      state.current = nextState;
      forceUpdate();
    }
  }, []);
  return [state.current, updateState];
}

Object.defineProperty(useTime$1, "__esModule", {
  value: true
});
useTime$1.useTime = useTime;

var _react$5 = React__default;

var _context$2 = _interopRequireDefault$5(context);

var _useStateWithDeps3$1 = useStateWithDeps$1;

function _interopRequireDefault$5(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray$4(arr, i) { return _arrayWithHoles$4(arr) || _iterableToArrayLimit$4(arr, i) || _unsupportedIterableToArray$4(arr, i) || _nonIterableRest$4(); }

function _nonIterableRest$4() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$4(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$4(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$4(o, minLen); }

function _arrayLikeToArray$4(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$4(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$4(arr) { if (Array.isArray(arr)) return arr; }

function useTime() {
  var timerConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var timeSync = (0, _react$5.useContext)(_context$2.default);

  var _useStateWithDeps = (0, _useStateWithDeps3$1.useStateWithDeps)(function () {
    return timeSync.getCurrentTime({
      interval: timerConfig.interval,
      unit: timerConfig.unit
    });
  }, [timerConfig.interval, timerConfig.unit]),
      _useStateWithDeps2 = _slicedToArray$4(_useStateWithDeps, 2),
      time = _useStateWithDeps2[0],
      setTime = _useStateWithDeps2[1];

  (0, _react$5.useEffect)(function () {
    return timeSync.addTimer(function (currentTime) {
      setTime(currentTime);
    }, timerConfig);
  }, [timerConfig.unit, timerConfig.interval]);
  (0, _react$5.useDebugValue)(time);
  return time;
}

Object.defineProperty(connectTime$1, "__esModule", {
  value: true
});
connectTime$1.connectTime = connectTime;

var _react$4 = _interopRequireDefault$4(React__default);

var _useTime$1 = useTime$1;

function _interopRequireDefault$4(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$4(Object(source), !0).forEach(function (key) { _defineProperty$4(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$4(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DEFAULT_COMPONENT_CONFIG = {
  timeProp: "currentTime"
};

function validateComponentConfig(componentConfig) {
  if (typeof componentConfig.timeProp !== "undefined" && (typeof componentConfig.timeProp !== "string" || componentConfig.timeProp === "")) {
    throw new Error("timeProp must be a non-empty string value");
  }
}

function connectTime(timerConfig) {
  var componentConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  validateComponentConfig(componentConfig);
  var usedTimerConfig = timerConfig || {};

  var usedComponentConfig = _objectSpread$3(_objectSpread$3({}, DEFAULT_COMPONENT_CONFIG), componentConfig);

  return function (WrappedComponent) {
    return function TimeComponent(props) {
      var timeProps = _objectSpread$3(_objectSpread$3({}, props), {}, _defineProperty$4({}, usedComponentConfig.timeProp, (0, _useTime$1.useTime)(usedTimerConfig)));

      return /*#__PURE__*/_react$4.default.createElement(WrappedComponent, timeProps);
    };
  };
}

var timeProvider = {};

function _typeof$1(obj) { "@babel/helpers - typeof"; return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$1(obj); }

Object.defineProperty(timeProvider, "__esModule", {
  value: true
});
timeProvider.default = void 0;

var _react$3 = _interopRequireWildcard(React__default);

var _propTypes$2 = _interopRequireDefault$3(propTypesExports);

var _context$1 = _interopRequireDefault$3(context);

var _timeSync = _interopRequireDefault$3(timeSync$1);

function _interopRequireDefault$3(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof$1(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var TimeProvider = function TimeProvider(props) {
  var timeSyncFallback = (0, _react$3.useRef)(null);

  if (!props.timeSync && !timeSyncFallback.current) {
    timeSyncFallback.current = new _timeSync.default();
  }

  var timeSync = props.timeSync || timeSyncFallback.current;
  var timeContext = (0, _react$3.useMemo)(function () {
    return {
      getCurrentTime: _timeSync.default.getCurrentTime,
      getTimeLeft: _timeSync.default.getTimeLeft,
      addTimer: timeSync.addTimer,
      createCountdown: timeSync.createCountdown
    };
  }, [timeSync]);
  (0, _react$3.useEffect)(function () {
    return function () {
      if (!props.timeSync) {
        timeSync.removeAllTimers();
        timeSync.stopAllCountdowns();
      }
    };
  }, [props.timeSync, timeSync]);
  (0, _react$3.useEffect)(function () {
    function handleVisibilityChange() {
      if (document.visibilityState === "visible") {
        timeSync.revalidate();
      }
    }

    var listenerSet = false;

    if (typeof document !== "undefined" && typeof document.visibilityState !== "undefined") {
      document.addEventListener("visibilitychange", handleVisibilityChange);
      listenerSet = true;
    }

    return function () {
      if (listenerSet) {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
      }
    };
  }, [timeSync]);
  return /*#__PURE__*/_react$3.default.createElement(_context$1.default.Provider, {
    value: timeContext
  }, props.children);
};

TimeProvider.propTypes = {
  children: _propTypes$2.default.node,
  timeSync: _propTypes$2.default.object
};
var _default$3 = TimeProvider;
timeProvider.default = _default$3;

var timed = {};

Object.defineProperty(timed, "__esModule", {
  value: true
});
timed.default = void 0;

var _react$2 = _interopRequireDefault$2(React__default);

var _propTypes$1 = _interopRequireDefault$2(propTypesExports);

var _useTime = useTime$1;

function _interopRequireDefault$2(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Timed = function Timed(props) {
  var currentTime = (0, _useTime.useTime)(props);

  if (!props.children) {
    return null;
  }

  return /*#__PURE__*/_react$2.default.createElement(_react$2.default.Fragment, null, props.children({
    currentTime: currentTime
  }));
};

Timed.propTypes = {
  children: _propTypes$1.default.func
};
var _default$2 = Timed;
timed.default = _default$2;

var countdown = {};

var useCountdown$1 = {};

Object.defineProperty(useCountdown$1, "__esModule", {
  value: true
});
useCountdown$1.useCountdown = useCountdown;

var _react$1 = React__default;

var _context = _interopRequireDefault$1(context);

var _useStateWithDeps3 = useStateWithDeps$1;

function _interopRequireDefault$1(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray$3(arr, i) { return _arrayWithHoles$3(arr) || _iterableToArrayLimit$3(arr, i) || _unsupportedIterableToArray$3(arr, i) || _nonIterableRest$3(); }

function _nonIterableRest$3() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$3(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$3(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$3(o, minLen); }

function _arrayLikeToArray$3(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$3(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$3(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$3(Object(source), !0).forEach(function (key) { _defineProperty$3(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$3(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getUsableConfig(countdownConfig) {
  return _objectSpread$2(_objectSpread$2({}, countdownConfig), {}, {
    until: countdownConfig.until || 0
  });
}

function useCountdown() {
  var countdownConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var timeSync = (0, _react$1.useContext)(_context.default);
  var usableConfig = getUsableConfig(countdownConfig);

  var _useStateWithDeps = (0, _useStateWithDeps3.useStateWithDeps)(function () {
    return timeSync.getTimeLeft({
      interval: usableConfig.interval,
      until: usableConfig.until
    });
  }, [usableConfig.interval, usableConfig.until]),
      _useStateWithDeps2 = _slicedToArray$3(_useStateWithDeps, 2),
      timeLeft = _useStateWithDeps2[0],
      setTimeLeft = _useStateWithDeps2[1];

  (0, _react$1.useEffect)(function () {
    if (Date.now() < usableConfig.until) {
      return timeSync.createCountdown(function (newTimeLeft) {
        setTimeLeft(newTimeLeft);
      }, usableConfig);
    }
  }, [usableConfig.until, usableConfig.interval]);
  (0, _react$1.useDebugValue)(timeLeft);
  return timeLeft;
}

Object.defineProperty(countdown, "__esModule", {
  value: true
});
countdown.default = void 0;

var _react = _interopRequireDefault(React__default);

var _propTypes = _interopRequireDefault(propTypesExports);

var _useCountdown = useCountdown$1;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Countdown = function Countdown(props) {
  var timeLeft = (0, _useCountdown.useCountdown)(props);

  if (!props.children) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, props.children({
    timeLeft: timeLeft
  }));
};

Countdown.propTypes = {
  children: _propTypes.default.func
};
var _default$1 = Countdown;
countdown.default = _default$1;

(function (exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Countdown", {
	  enumerable: true,
	  get: function get() {
	    return _countdown.default;
	  }
	});
	exports.SECONDS = exports.MINUTES = exports.HOURS = exports.DAYS = void 0;
	Object.defineProperty(exports, "TimeProvider", {
	  enumerable: true,
	  get: function get() {
	    return _timeProvider.default;
	  }
	});
	Object.defineProperty(exports, "Timed", {
	  enumerable: true,
	  get: function get() {
	    return _timed.default;
	  }
	});
	Object.defineProperty(exports, "connectTime", {
	  enumerable: true,
	  get: function get() {
	    return _connectTime.connectTime;
	  }
	});
	Object.defineProperty(exports, "useCountdown", {
	  enumerable: true,
	  get: function get() {
	    return _useCountdown.useCountdown;
	  }
	});
	Object.defineProperty(exports, "useTime", {
	  enumerable: true,
	  get: function get() {
	    return _useTime.useTime;
	  }
	});

	var _timeSync = _interopRequireDefault(timeSync$1);

	var _connectTime = connectTime$1;

	var _timeProvider = _interopRequireDefault(timeProvider);

	var _timed = _interopRequireDefault(timed);

	var _countdown = _interopRequireDefault(countdown);

	var _useTime = useTime$1;

	var _useCountdown = useCountdown$1;

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var SECONDS = _timeSync.default.SECONDS,
	    MINUTES = _timeSync.default.MINUTES,
	    HOURS = _timeSync.default.HOURS,
	    DAYS = _timeSync.default.DAYS;
	exports.DAYS = DAYS;
	exports.HOURS = HOURS;
	exports.MINUTES = MINUTES;
	exports.SECONDS = SECONDS;
} (reactTimeSync));

var format$1 = function (value, noPads) {
    return noPads ? value.toString() : value.toString().padStart(2, '0');
};
var initialValue = function (noPads) { return (noPads ? '0' : '00'); };
var timeLeftToTimeObject = function (timeLeft, showFull, noPads) {
    timeLeft = timeLeft < 0 ? 0 : timeLeft;
    var SECONDS_IN_1_MINUTE = 60;
    var SECONDS_IN_1_HOUR = SECONDS_IN_1_MINUTE * SECONDS_IN_1_MINUTE;
    var SECONDS_IN_1_DAY = SECONDS_IN_1_HOUR * 24;
    var INITIAL_VALUE = initialValue(noPads);
    var days = INITIAL_VALUE;
    var hours = INITIAL_VALUE;
    var minutes = INITIAL_VALUE;
    var seconds = INITIAL_VALUE;
    if (showFull) {
        // Calculate remaining time based on days
        days = format$1(Math.floor(timeLeft / SECONDS_IN_1_DAY), noPads);
        var secondsLeft = timeLeft - Math.floor(timeLeft / SECONDS_IN_1_DAY) * SECONDS_IN_1_DAY;
        hours = format$1(Math.floor(secondsLeft / SECONDS_IN_1_HOUR), noPads);
        secondsLeft -= Math.floor(secondsLeft / SECONDS_IN_1_HOUR) * SECONDS_IN_1_HOUR;
        minutes = format$1(Math.floor((secondsLeft % SECONDS_IN_1_HOUR) / SECONDS_IN_1_MINUTE), noPads);
        secondsLeft -= Math.floor((secondsLeft % SECONDS_IN_1_HOUR) / SECONDS_IN_1_MINUTE) * SECONDS_IN_1_MINUTE;
        seconds = format$1(Math.floor((secondsLeft % SECONDS_IN_1_HOUR) % SECONDS_IN_1_MINUTE), noPads);
    }
    else {
        // Calculate remaining time based on hours
        hours = format$1(Math.floor(timeLeft / SECONDS_IN_1_HOUR), noPads);
        minutes = format$1(Math.floor((timeLeft % SECONDS_IN_1_HOUR) / SECONDS_IN_1_MINUTE), noPads);
        seconds = format$1(Math.floor((timeLeft % SECONDS_IN_1_HOUR) % SECONDS_IN_1_MINUTE), noPads);
    }
    return { days: days, hours: hours, minutes: minutes, seconds: seconds, completed: timeLeft === 0 };
};

var StyledBody = styled(Body)(templateObject_1$1m || (templateObject_1$1m = __makeTemplateObject(["\n  min-width: ", ";\n  text-align: center;\n"], ["\n  min-width: ", ";\n  text-align: center;\n"])), function (_a) {
    var minWidth = _a.minWidth;
    return minWidth;
});
var CountdownContainer = styled.span(templateObject_2$D || (templateObject_2$D = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n"], ["\n  display: flex;\n  flex-direction: row;\n"])));
var templateObject_1$1m, templateObject_2$D;

var BasicCountdown = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, color = _a.color, _c = _a.size, size = _c === void 0 ? 'normal' : _c, _d = _a.bold, bold = _d === void 0 ? false : _d, _e = _a.showHours, showHours = _e === void 0 ? false : _e, _f = _a.showHoursIfThereAre, showHoursIfThereAre = _f === void 0 ? false : _f, date = _a.date, onComplete = _a.onComplete;
    return (jsx(CountdownContainer, __assign({ className: "chromatic-ignore ".concat(className) }, { children: jsx(reactTimeSync.Countdown, __assign({ until: dayjs(date).valueOf() }, { children: function (_a) {
                var timeLeft = _a.timeLeft;
                var _b = timeLeftToTimeObject(timeLeft), hours = _b.hours, minutes = _b.minutes, seconds = _b.seconds, completed = _b.completed;
                if (completed && onComplete)
                    onComplete();
                var shouldShowHours = Boolean(showHours || (showHoursIfThereAre && Number(hours)));
                return (jsxs(Fragment, { children: [shouldShowHours && (jsxs(Fragment, { children: [jsx(StyledBody, __assign({ minWidth: "2ch", color: color, size: size, bold: bold }, { children: hours })), jsx(Body, __assign({ color: color, size: size, bold: bold }, { children: ":" }))] })), jsx(StyledBody, __assign({ minWidth: "2ch", color: color, size: size, bold: bold }, { children: minutes })), jsx(Body, __assign({ color: color, size: size, bold: bold }, { children: ":" })), jsx(StyledBody, __assign({ minWidth: "2ch", color: color, size: size, bold: bold }, { children: seconds }))] }));
            } })) })));
};

var Colon = function (_a) {
    var completed = _a.completed;
    return (jsx(BlcColumn, __assign({ alignSelf: "center", padding: "smallest", colsOpt: { mxl: 1, ml: 1, ms: 1, mxs: 1 } }, { children: jsx(Headline, __assign({ size: "H6", color: completed ? 'grayLight' : 'black' }, { children: ":" })) })));
};
var Time = function (_a) {
    var value = _a.value, children = _a.children, completed = _a.completed;
    var textColor = completed ? 'grayLight' : 'black';
    return (jsxs(BlcColumn, __assign({ colsOpt: { mxl: 1, ml: 1, ms: 1, mxs: 1 }, padding: ['none', 'smallest'] }, { children: [jsx(Headline, __assign({ size: "H5", className: "chromatic-ignore", color: textColor }, { children: value })), jsx(Body, __assign({ color: textColor }, { children: children }))] })));
};
var Render = function (_a) {
    var showFull = _a.showFull, days = _a.days, hours = _a.hours, minutes = _a.minutes, seconds = _a.seconds, className = _a.className, noPads = _a.noPads, noBorders = _a.noBorders;
    var INITIAL_VALUE = initialValue(noPads);
    var showHours = hours !== INITIAL_VALUE;
    var rowColumns = showFull ? 7 : showHours ? 5 : 3;
    var completedDays = days === INITIAL_VALUE;
    var completedHours = completedDays && hours === INITIAL_VALUE;
    var completedMinutes = completedHours && minutes === INITIAL_VALUE;
    var completedSeconds = completedMinutes && seconds === INITIAL_VALUE;
    return (jsx(FlexBox, __assign({ border: "solid ".concat(colorBorder$1.colorBorderBorderPrimary), borderWidth: noBorders ? 0 : 1, className: className, textAlign: "center", width: "min-content" }, { children: jsxs(BlcRow, __assign({ columns: rowColumns }, { children: [showFull && (jsxs(Fragment, { children: [jsx(Time, __assign({ completed: completedDays, value: days }, { children: "Days" })), jsx(Colon, { completed: completedDays })] })), (showFull || showHours) && (jsxs(Fragment, { children: [jsx(Time, __assign({ completed: completedHours, value: hours }, { children: "Hours" })), jsx(Colon, { completed: completedHours })] })), jsx(Time, __assign({ completed: completedMinutes, value: minutes }, { children: "Minutes" })), jsx(Colon, { completed: completedSeconds }), jsx(Time, __assign({ completed: completedSeconds, value: seconds }, { children: "Seconds" }))] })) })));
};
var ExtendedCountdown = function (_a) {
    var className = _a.className, date = _a.date, onComplete = _a.onComplete, _b = _a.showFull, showFull = _b === void 0 ? false : _b, _c = _a.noPads, noPads = _c === void 0 ? false : _c, _d = _a.noBorders, noBorders = _d === void 0 ? false : _d;
    return (jsx(reactTimeSync.Countdown, __assign({ until: dayjs(date).valueOf() }, { children: function (_a) {
            var timeLeft = _a.timeLeft;
            var _b = timeLeftToTimeObject(timeLeft, showFull, noPads), days = _b.days, hours = _b.hours, minutes = _b.minutes, seconds = _b.seconds;
            if (onComplete)
                onComplete();
            return (jsx(Render, { days: days, hours: hours, minutes: minutes, seconds: seconds, className: className, showFull: showFull, noPads: noPads, noBorders: noBorders }));
        } })));
};

var IconWrapper = styled.div(templateObject_1$1l || (templateObject_1$1l = __makeTemplateObject(["\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  margin-left: 14px;\n\n  i {\n    position: relative;\n    cursor: pointer;\n    bottom: 2px;\n  }\n"], ["\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  margin-left: 14px;\n\n  i {\n    position: relative;\n    cursor: pointer;\n    bottom: 2px;\n  }\n"])));
var Container$9 = styled.div(templateObject_2$C || (templateObject_2$C = __makeTemplateObject(["\n  position: relative;\n  ", ";\n"], ["\n  position: relative;\n  ", ";\n"])), function (_a) {
    var _b = _a.minWidth, minWidth = _b === void 0 ? 240 : _b, width = _a.width;
    return "\n    min-width: ".concat(getSizeValue(minWidth), ";\n    width: ").concat(getSizeValue(width), ";\n  ");
});
var CloseContainer = styled.div(templateObject_3$j || (templateObject_3$j = __makeTemplateObject(["\n  position: absolute;\n  right: 14px;\n  top: 35%;\n  cursor: pointer;\n"], ["\n  position: absolute;\n  right: 14px;\n  top: 35%;\n  cursor: pointer;\n"])));
var ReturnContainer = styled.div(templateObject_4$b || (templateObject_4$b = __makeTemplateObject(["\n  position: absolute;\n  right: 14px;\n  top: 38%;\n"], ["\n  position: absolute;\n  right: 14px;\n  top: 38%;\n"])));
var templateObject_1$1l, templateObject_2$C, templateObject_3$j, templateObject_4$b;

var InputSearch = forwardRef(function (props, ref) {
    var autocomplete = props.autocomplete, className = props.className, minWidth = props.minWidth, _a = props.value, value = _a === void 0 ? '' : _a, _b = props.placeholder, placeholder = _b === void 0 ? 'Search' : _b, width = props.width, _c = props.showClear, showClear = _c === void 0 ? false : _c, _d = props.showSearchIcon, showSearchIcon = _d === void 0 ? true : _d, _e = props.showEnterIcon, showEnterIcon = _e === void 0 ? true : _e, _f = props.$size, $size = _f === void 0 ? 'default' : _f, inputTestid = props.inputTestid, onSubmit = props.onSubmit, onChange = props.onChange, onBlur = props.onBlur, onClear = props.onClear, onKeyDown = props.onKeyDown;
    var _g = useState(value), inputValue = _g[0], setInputValue = _g[1];
    var handleOnKeyDown = function (e) {
        return e.key === 'Enter' && onSubmit && onSubmit(inputValue);
    };
    var handleOnBlur = function () { return onBlur && onBlur(inputValue); };
    var handleOnChange = function (e) {
        setInputValue(e.target.value);
        onChange && onChange(e);
    };
    var onClickSubmit = function () { return onSubmit && onSubmit(inputValue); };
    var onClickClear = function () {
        setInputValue('');
        onClear && onClear();
    };
    useEffect(function () {
        setInputValue(value);
    }, [value]);
    return (jsxs(Container$9, __assign({ className: className, minWidth: minWidth, width: width }, { children: [jsx(Input$2, { autoComplete: autocomplete, value: inputValue, placeholder: placeholder, onBlur: handleOnBlur, onKeyDown: onKeyDown || handleOnKeyDown, onChange: handleOnChange, type: "text", paddingLeft: showSearchIcon ? '48px' : '16px', paddingRight: showEnterIcon || showClear ? '32px' : '16px', borderRadius: $size === 'smallest' ? 'var(--inputBorderRadiusSmallest)' : 'var(--inputBorderRadius)', "$size": $size, ref: ref, "data-form-error": true, "data-testid": inputTestid }), showSearchIcon && (jsx(IconWrapper, __assign({ onClick: onClickSubmit }, { children: jsx(Icon, { name: "search", color: "grayLight" }) }))), showClear && inputValue ? (jsx(CloseContainer, __assign({ onClick: onClickClear }, { children: jsx(Icon, { name: "close", color: "grayLight", size: "smaller" }) }))) : (jsx(Fragment, { children: showEnterIcon && (jsx(ReturnContainer, { children: jsx(Icon, { name: "return-left", color: "grayLight", size: "smaller" }) })) }))] })));
});
InputSearch.displayName = 'InputSearch';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

function $e42e1063c40fb3ef$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true  } = {}) {
    return function handleEvent(event) {
        originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
    };
}

/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function $6ed0406888f73fc4$var$setRef(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function $6ed0406888f73fc4$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$6ed0406888f73fc4$var$setRef(ref, node)
        )
    ;
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function $6ed0406888f73fc4$export$c7b2cbe3552a0d05(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return useCallback($6ed0406888f73fc4$export$43e446d32b3d21af(...refs), refs);
}

/* -------------------------------------------------------------------------------------------------
 * createContextScope
 * -----------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    /* -----------------------------------------------------------------------------------------------
   * createContext
   * ---------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
        const BaseContext = /*#__PURE__*/ createContext(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope , children: children , ...context } = props;
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext; // Only re-memoize when prop values change
            // eslint-disable-next-line react-hooks/exhaustive-deps
            const value = useMemo(()=>context
            , Object.values(context));
            return /*#__PURE__*/ createElement(Context.Provider, {
                value: value
            }, children);
        }
        function useContext$1(consumerName, scope) {
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
            const context = useContext(Context);
            if (context) return context;
            if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + 'Provider';
        return [
            Provider,
            useContext$1
        ];
    }
    /* -----------------------------------------------------------------------------------------------
   * createScope
   * ---------------------------------------------------------------------------------------------*/ const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return /*#__PURE__*/ createContext(defaultContext);
        });
        return function useScope(scope) {
            const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
            return useMemo(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                })
            , [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        $c512c27ab02ef895$export$fd42f52fd3ae1109,
        $c512c27ab02ef895$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
/* -------------------------------------------------------------------------------------------------
 * composeContextScopes
 * -----------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope1 = ()=>{
        const scopeHooks = scopes.map((createScope)=>({
                useScope: createScope(),
                scopeName: createScope.scopeName
            })
        );
        return function useComposedScopes(overrideScopes) {
            const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope: useScope , scopeName: scopeName  })=>{
                // We are calling a hook inside a callback which React warns against to avoid inconsistent
                // renders, however, scoping doesn't have render side effects so we ignore the rule.
                // eslint-disable-next-line react-hooks/rules-of-hooks
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes,
                    ...currentScope
                };
            }, {});
            return useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes1
                })
            , [
                nextScopes1
            ]);
        };
    };
    createScope1.scopeName = baseScope.scopeName;
    return createScope1;
}

/**
 * A custom hook that converts a callback to a ref to avoid triggering re-renders when passed as a
 * prop or avoid re-executing effects when passed as a dependency
 */ function $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(callback) {
    const callbackRef = useRef(callback);
    useEffect(()=>{
        callbackRef.current = callback;
    }); // https://github.com/facebook/react/issues/19240
    return useMemo(()=>(...args)=>{
            var _callbackRef$current;
            return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
        }
    , []);
}

function $71cd76cc60e0454e$export$6f32135080cb4c3({ prop: prop , defaultProp: defaultProp , onChange: onChange = ()=>{}  }) {
    const [uncontrolledProp, setUncontrolledProp] = $71cd76cc60e0454e$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== undefined;
    const value1 = isControlled ? prop : uncontrolledProp;
    const handleChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onChange);
    const setValue = useCallback((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value = typeof nextValue === 'function' ? setter(prop) : nextValue;
            if (value !== prop) handleChange(value);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value1,
        setValue
    ];
}
function $71cd76cc60e0454e$var$useUncontrolledState({ defaultProp: defaultProp , onChange: onChange  }) {
    const uncontrolledState = useState(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = useRef(value);
    const handleChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onChange);
    useEffect(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}

/* -------------------------------------------------------------------------------------------------
 * Slot
 * -----------------------------------------------------------------------------------------------*/ const $5e63c961fc1ce211$export$8c6ed5c666ac1360 = /*#__PURE__*/ forwardRef((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    const childrenArray = Children.toArray(children);
    const slottable = childrenArray.find($5e63c961fc1ce211$var$isSlottable);
    if (slottable) {
        // the new element to render is the one passed as a child of `Slottable`
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                // because the new element will be the one rendered, we are only interested
                // in grabbing its children (`newElement.props.children`)
                if (Children.count(newElement) > 1) return Children.only(null);
                return /*#__PURE__*/ isValidElement(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /*#__PURE__*/ createElement($5e63c961fc1ce211$var$SlotClone, _extends({}, slotProps, {
            ref: forwardedRef
        }), /*#__PURE__*/ isValidElement(newElement) ? /*#__PURE__*/ cloneElement(newElement, undefined, newChildren) : null);
    }
    return /*#__PURE__*/ createElement($5e63c961fc1ce211$var$SlotClone, _extends({}, slotProps, {
        ref: forwardedRef
    }), children);
});
$5e63c961fc1ce211$export$8c6ed5c666ac1360.displayName = 'Slot';
/* -------------------------------------------------------------------------------------------------
 * SlotClone
 * -----------------------------------------------------------------------------------------------*/ const $5e63c961fc1ce211$var$SlotClone = /*#__PURE__*/ forwardRef((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    if (/*#__PURE__*/ isValidElement(children)) return /*#__PURE__*/ cloneElement(children, {
        ...$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
        ref: forwardedRef ? $6ed0406888f73fc4$export$43e446d32b3d21af(forwardedRef, children.ref) : children.ref
    });
    return Children.count(children) > 1 ? Children.only(null) : null;
});
$5e63c961fc1ce211$var$SlotClone.displayName = 'SlotClone';
/* -------------------------------------------------------------------------------------------------
 * Slottable
 * -----------------------------------------------------------------------------------------------*/ const $5e63c961fc1ce211$export$d9f1ccf0bdb05d45 = ({ children: children  })=>{
    return /*#__PURE__*/ createElement(Fragment$1, null, children);
};
/* ---------------------------------------------------------------------------------------------- */ function $5e63c961fc1ce211$var$isSlottable(child) {
    return /*#__PURE__*/ isValidElement(child) && child.type === $5e63c961fc1ce211$export$d9f1ccf0bdb05d45;
}
function $5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
    // all child props should override
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            // if the handler exists on both, we compose them
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === 'style') overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === 'className') overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(' ');
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}

const $8927f6f2acc4f386$var$NODES = [
    'a',
    'button',
    'div',
    'form',
    'h2',
    'h3',
    'img',
    'input',
    'label',
    'li',
    'nav',
    'ol',
    'p',
    'span',
    'svg',
    'ul'
]; // Temporary while we await merge of this fix:
// https://github.com/DefinitelyTyped/DefinitelyTyped/pull/55396
// prettier-ignore
/* -------------------------------------------------------------------------------------------------
 * Primitive
 * -----------------------------------------------------------------------------------------------*/ const $8927f6f2acc4f386$export$250ffa63cdc0d034 = $8927f6f2acc4f386$var$NODES.reduce((primitive, node)=>{
    const Node = /*#__PURE__*/ forwardRef((props, forwardedRef)=>{
        const { asChild: asChild , ...primitiveProps } = props;
        const Comp = asChild ? $5e63c961fc1ce211$export$8c6ed5c666ac1360 : node;
        useEffect(()=>{
            window[Symbol.for('radix-ui')] = true;
        }, []);
        return /*#__PURE__*/ createElement(Comp, _extends({}, primitiveProps, {
            ref: forwardedRef
        }));
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Flush custom event dispatch
 * https://github.com/radix-ui/primitives/pull/1378
 *
 * React batches *all* event handlers since version 18, this introduces certain considerations when using custom event types.
 *
 * Internally, React prioritises events in the following order:
 *  - discrete
 *  - continuous
 *  - default
 *
 * https://github.com/facebook/react/blob/a8a4742f1c54493df00da648a3f9d26e3db9c8b5/packages/react-dom/src/events/ReactDOMEventListener.js#L294-L350
 *
 * `discrete` is an  important distinction as updates within these events are applied immediately.
 * React however, is not able to infer the priority of custom event types due to how they are detected internally.
 * Because of this, it's possible for updates from custom events to be unexpectedly batched when
 * dispatched by another `discrete` event.
 *
 * In order to ensure that updates from custom events are applied predictably, we need to manually flush the batch.
 * This utility should be used when dispatching a custom event from within another `discrete` event, this utility
 * is not nessesary when dispatching known event types, or if dispatching a custom type inside a non-discrete event.
 * For example:
 *
 * dispatching a known click 👎
 * target.dispatchEvent(new Event(‘click’))
 *
 * dispatching a custom type within a non-discrete event 👎
 * onScroll={(event) => event.target.dispatchEvent(new CustomEvent(‘customType’))}
 *
 * dispatching a custom type within a `discrete` event 👍
 * onPointerDown={(event) => dispatchDiscreteCustomEvent(event.target, new CustomEvent(‘customType’))}
 *
 * Note: though React classifies `focus`, `focusin` and `focusout` events as `discrete`, it's  not recommended to use
 * this utility with them. This is because it's possible for those handlers to be called implicitly during render
 * e.g. when focus is within a component as it is unmounted, or when managing focus on mount.
 */ function $8927f6f2acc4f386$export$6d1a0317bde7de7f(target, event) {
    if (target) flushSync(()=>target.dispatchEvent(event)
    );
}

// We have resorted to returning slots directly rather than exposing primitives that can then
// be slotted like `<CollectionItem as={Slot}>…</CollectionItem>`.
// This is because we encountered issues with generic types that cannot be statically analysed
// due to creating them dynamically via createCollection.
function $e02a7d9cb1dc128c$export$c74125a8e3af6bb2(name) {
    /* -----------------------------------------------------------------------------------------------
   * CollectionProvider
   * ---------------------------------------------------------------------------------------------*/ const PROVIDER_NAME = name + 'CollectionProvider';
    const [createCollectionContext, createCollectionScope] = $c512c27ab02ef895$export$50c7b4e9d9f19c1(PROVIDER_NAME);
    const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionRef: {
            current: null
        },
        itemMap: new Map()
    });
    const CollectionProvider = (props)=>{
        const { scope: scope , children: children  } = props;
        const ref = React__default.useRef(null);
        const itemMap = React__default.useRef(new Map()).current;
        return /*#__PURE__*/ React__default.createElement(CollectionProviderImpl, {
            scope: scope,
            itemMap: itemMap,
            collectionRef: ref
        }, children);
    };
    /* -----------------------------------------------------------------------------------------------
   * CollectionSlot
   * ---------------------------------------------------------------------------------------------*/ const COLLECTION_SLOT_NAME = name + 'CollectionSlot';
    const CollectionSlot = /*#__PURE__*/ React__default.forwardRef((props, forwardedRef)=>{
        const { scope: scope , children: children  } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, context.collectionRef);
        return /*#__PURE__*/ React__default.createElement($5e63c961fc1ce211$export$8c6ed5c666ac1360, {
            ref: composedRefs
        }, children);
    });
    /* -----------------------------------------------------------------------------------------------
   * CollectionItem
   * ---------------------------------------------------------------------------------------------*/ const ITEM_SLOT_NAME = name + 'CollectionItemSlot';
    const ITEM_DATA_ATTR = 'data-radix-collection-item';
    const CollectionItemSlot = /*#__PURE__*/ React__default.forwardRef((props, forwardedRef)=>{
        const { scope: scope , children: children , ...itemData } = props;
        const ref = React__default.useRef(null);
        const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        React__default.useEffect(()=>{
            context.itemMap.set(ref, {
                ref: ref,
                ...itemData
            });
            return ()=>void context.itemMap.delete(ref)
            ;
        });
        return /*#__PURE__*/ React__default.createElement($5e63c961fc1ce211$export$8c6ed5c666ac1360, {
            [ITEM_DATA_ATTR]: '',
            ref: composedRefs
        }, children);
    });
    /* -----------------------------------------------------------------------------------------------
   * useCollection
   * ---------------------------------------------------------------------------------------------*/ function useCollection(scope) {
        const context = useCollectionContext(name + 'CollectionConsumer', scope);
        const getItems = React__default.useCallback(()=>{
            const collectionNode = context.collectionRef.current;
            if (!collectionNode) return [];
            const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
            const items = Array.from(context.itemMap.values());
            const orderedItems = items.sort((a, b)=>orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current)
            );
            return orderedItems;
        }, [
            context.collectionRef,
            context.itemMap
        ]);
        return getItems;
    }
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        useCollection,
        createCollectionScope
    ];
}

const $f631663db3294ace$var$DirectionContext = /*#__PURE__*/ createContext(undefined);
/* -----------------------------------------------------------------------------------------------*/ function $f631663db3294ace$export$b39126d51d94e6f3(localDir) {
    const globalDir = useContext($f631663db3294ace$var$DirectionContext);
    return localDir || globalDir || 'ltr';
}

/**
 * Listens for when the escape key is down
 */ function $addc16e1bbe58fd0$export$3a72a57244d6e765(onEscapeKeyDownProp, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const onEscapeKeyDown = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onEscapeKeyDownProp);
    useEffect(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === 'Escape') onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener('keydown', handleKeyDown);
        return ()=>ownerDocument.removeEventListener('keydown', handleKeyDown)
        ;
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}

const $5cb92bef7577960e$var$CONTEXT_UPDATE = 'dismissableLayer.update';
const $5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE = 'dismissableLayer.pointerDownOutside';
const $5cb92bef7577960e$var$FOCUS_OUTSIDE = 'dismissableLayer.focusOutside';
let $5cb92bef7577960e$var$originalBodyPointerEvents;
const $5cb92bef7577960e$var$DismissableLayerContext = /*#__PURE__*/ createContext({
    layers: new Set(),
    layersWithOutsidePointerEventsDisabled: new Set(),
    branches: new Set()
});
const $5cb92bef7577960e$export$177fb62ff3ec1f22 = /*#__PURE__*/ forwardRef((props, forwardedRef)=>{
    var _node$ownerDocument;
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false , onEscapeKeyDown: onEscapeKeyDown , onPointerDownOutside: onPointerDownOutside , onFocusOutside: onFocusOutside , onInteractOutside: onInteractOutside , onDismiss: onDismiss , ...layerProps } = props;
    const context = useContext($5cb92bef7577960e$var$DismissableLayerContext);
    const [node1, setNode] = useState(null);
    const ownerDocument = (_node$ownerDocument = node1 === null || node1 === void 0 ? void 0 : node1.ownerDocument) !== null && _node$ownerDocument !== void 0 ? _node$ownerDocument : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
    const [, force] = useState({});
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, (node)=>setNode(node)
    );
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1); // prettier-ignore
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled); // prettier-ignore
    const index = node1 ? layers.indexOf(node1) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = $5cb92bef7577960e$var$usePointerDownOutside((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target)
        );
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside === null || onPointerDownOutside === void 0 || onPointerDownOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    const focusOutside = $5cb92bef7577960e$var$useFocusOutside((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target)
        );
        if (isFocusInBranch) return;
        onFocusOutside === null || onFocusOutside === void 0 || onFocusOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    $addc16e1bbe58fd0$export$3a72a57244d6e765((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    useEffect(()=>{
        if (!node1) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $5cb92bef7577960e$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = 'none';
            }
            context.layersWithOutsidePointerEventsDisabled.add(node1);
        }
        context.layers.add(node1);
        $5cb92bef7577960e$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $5cb92bef7577960e$var$originalBodyPointerEvents;
        };
    }, [
        node1,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    /**
   * We purposefully prevent combining this effect with the `disableOutsidePointerEvents` effect
   * because a change to `disableOutsidePointerEvents` would remove this layer from the stack
   * and add it to the end again so the layering order wouldn't be _creation order_.
   * We only want them to be removed from context stacks when unmounted.
   */ useEffect(()=>{
        return ()=>{
            if (!node1) return;
            context.layers.delete(node1);
            context.layersWithOutsidePointerEventsDisabled.delete(node1);
            $5cb92bef7577960e$var$dispatchUpdate();
        };
    }, [
        node1,
        context
    ]);
    useEffect(()=>{
        const handleUpdate = ()=>force({})
        ;
        document.addEventListener($5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate)
        ;
    }, []);
    return /*#__PURE__*/ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends({}, layerProps, {
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? 'auto' : 'none' : undefined,
            ...props.style
        },
        onFocusCapture: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    }));
});
/* -----------------------------------------------------------------------------------------------*/ /**
 * Listens for `pointerdown` outside a react subtree. We use `pointerdown` rather than `pointerup`
 * to mimic layer dismissing behaviour present in OS.
 * Returns props to pass to the node we want to check for outside events.
 */ function $5cb92bef7577960e$var$usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const handlePointerDownOutside = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onPointerDownOutside);
    const isPointerInsideReactTreeRef = useRef(false);
    const handleClickRef = useRef(()=>{});
    useEffect(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                function handleAndDispatchPointerDownOutsideEvent() {
                    $5cb92bef7577960e$var$handleAndDispatchCustomEvent($5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                }
                /**
         * On touch devices, we need to wait for a click event because browsers implement
         * a ~350ms delay between the time the user stops touching the display and when the
         * browser executres events. We need to ensure we don't reactivate pointer-events within
         * this timeframe otherwise the browser may execute events that should have been prevented.
         *
         * Additionally, this also lets us deal automatically with cancellations when a click event
         * isn't raised because the page was considered scrolled/drag-scrolled, long-pressed, etc.
         *
         * This is why we also continuously remove the previous listener, because we cannot be
         * certain that it was raised, and therefore cleaned-up.
         */ if (event.pointerType === 'touch') {
                    ownerDocument.removeEventListener('click', handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent;
                    ownerDocument.addEventListener('click', handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent();
            } else // We need to remove the event listener in case the outside click has been canceled.
            // See: https://github.com/radix-ui/primitives/issues/2171
            ownerDocument.removeEventListener('click', handleClickRef.current);
            isPointerInsideReactTreeRef.current = false;
        };
        /**
     * if this hook executes in a component that mounts via a `pointerdown` event, the event
     * would bubble up to the document and trigger a `pointerDownOutside` event. We avoid
     * this by delaying the event listener registration on the document.
     * This is not React specific, but rather how the DOM works, ie:
     * ```
     * button.addEventListener('pointerdown', () => {
     *   console.log('I will log');
     *   document.addEventListener('pointerdown', () => {
     *     console.log('I will also log');
     *   })
     * });
     */ const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener('pointerdown', handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener('pointerdown', handlePointerDown);
            ownerDocument.removeEventListener('click', handleClickRef.current);
        };
    }, [
        ownerDocument,
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
/**
 * Listens for when focus happens outside a react subtree.
 * Returns props to pass to the root (node) of the subtree we want to check.
 */ function $5cb92bef7577960e$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const handleFocusOutside = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onFocusOutside);
    const isFocusInsideReactTreeRef = useRef(false);
    useEffect(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $5cb92bef7577960e$var$handleAndDispatchCustomEvent($5cb92bef7577960e$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener('focusin', handleFocus);
        return ()=>ownerDocument.removeEventListener('focusin', handleFocus)
        ;
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true
        ,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $5cb92bef7577960e$var$dispatchUpdate() {
    const event = new CustomEvent($5cb92bef7577960e$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $5cb92bef7577960e$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete  }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) $8927f6f2acc4f386$export$6d1a0317bde7de7f(target, event);
    else target.dispatchEvent(event);
}

/** Number of components which have requested interest to have focus guards */ let $3db38b7d1fb3fe6a$var$count = 0;
/**
 * Injects a pair of focus guards at the edges of the whole DOM tree
 * to ensure `focusin` & `focusout` events can be caught consistently.
 */ function $3db38b7d1fb3fe6a$export$b7ece24a22aeda8c() {
    useEffect(()=>{
        var _edgeGuards$, _edgeGuards$2;
        const edgeGuards = document.querySelectorAll('[data-radix-focus-guard]');
        document.body.insertAdjacentElement('afterbegin', (_edgeGuards$ = edgeGuards[0]) !== null && _edgeGuards$ !== void 0 ? _edgeGuards$ : $3db38b7d1fb3fe6a$var$createFocusGuard());
        document.body.insertAdjacentElement('beforeend', (_edgeGuards$2 = edgeGuards[1]) !== null && _edgeGuards$2 !== void 0 ? _edgeGuards$2 : $3db38b7d1fb3fe6a$var$createFocusGuard());
        $3db38b7d1fb3fe6a$var$count++;
        return ()=>{
            if ($3db38b7d1fb3fe6a$var$count === 1) document.querySelectorAll('[data-radix-focus-guard]').forEach((node)=>node.remove()
            );
            $3db38b7d1fb3fe6a$var$count--;
        };
    }, []);
}
function $3db38b7d1fb3fe6a$var$createFocusGuard() {
    const element = document.createElement('span');
    element.setAttribute('data-radix-focus-guard', '');
    element.tabIndex = 0;
    element.style.cssText = 'outline: none; opacity: 0; position: fixed; pointer-events: none';
    return element;
}

const $d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT = 'focusScope.autoFocusOnMount';
const $d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT = 'focusScope.autoFocusOnUnmount';
const $d3863c46a17e8a28$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
const $d3863c46a17e8a28$export$20e40289641fbbb6 = /*#__PURE__*/ forwardRef((props, forwardedRef)=>{
    const { loop: loop = false , trapped: trapped = false , onMountAutoFocus: onMountAutoFocusProp , onUnmountAutoFocus: onUnmountAutoFocusProp , ...scopeProps } = props;
    const [container1, setContainer] = useState(null);
    const onMountAutoFocus = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onMountAutoFocusProp);
    const onUnmountAutoFocus = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onUnmountAutoFocusProp);
    const lastFocusedElementRef = useRef(null);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, (node)=>setContainer(node)
    );
    const focusScope = useRef({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current; // Takes care of trapping focus if focus is moved outside programmatically for example
    useEffect(()=>{
        if (trapped) {
            function handleFocusIn(event) {
                if (focusScope.paused || !container1) return;
                const target = event.target;
                if (container1.contains(target)) lastFocusedElementRef.current = target;
                else $d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }
            function handleFocusOut(event) {
                if (focusScope.paused || !container1) return;
                const relatedTarget = event.relatedTarget; // A `focusout` event with a `null` `relatedTarget` will happen in at least two cases:
                //
                // 1. When the user switches app/tabs/windows/the browser itself loses focus.
                // 2. In Google Chrome, when the focused element is removed from the DOM.
                //
                // We let the browser do its thing here because:
                //
                // 1. The browser already keeps a memory of what's focused for when the page gets refocused.
                // 2. In Google Chrome, if we try to focus the deleted focused element (as per below), it
                //    throws the CPU to 100%, so we avoid doing anything for this reason here too.
                if (relatedTarget === null) return; // If the focus has moved to an actual legitimate element (`relatedTarget !== null`)
                // that is outside the container, we move focus to the last valid focused element inside.
                if (!container1.contains(relatedTarget)) $d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            } // When the focused element gets removed from the DOM, browsers move focus
            // back to the document.body. In this case, we move focus to the container
            // to keep focus trapped correctly.
            function handleMutations(mutations) {
                const focusedElement = document.activeElement;
                if (focusedElement !== document.body) return;
                for (const mutation of mutations)if (mutation.removedNodes.length > 0) $d3863c46a17e8a28$var$focus(container1);
            }
            document.addEventListener('focusin', handleFocusIn);
            document.addEventListener('focusout', handleFocusOut);
            const mutationObserver = new MutationObserver(handleMutations);
            if (container1) mutationObserver.observe(container1, {
                childList: true,
                subtree: true
            });
            return ()=>{
                document.removeEventListener('focusin', handleFocusIn);
                document.removeEventListener('focusout', handleFocusOut);
                mutationObserver.disconnect();
            };
        }
    }, [
        trapped,
        container1,
        focusScope.paused
    ]);
    useEffect(()=>{
        if (container1) {
            $d3863c46a17e8a28$var$focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container1.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent($d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, $d3863c46a17e8a28$var$EVENT_OPTIONS);
                container1.addEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container1.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $d3863c46a17e8a28$var$focusFirst($d3863c46a17e8a28$var$removeLinks($d3863c46a17e8a28$var$getTabbableCandidates(container1)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $d3863c46a17e8a28$var$focus(container1);
                }
            }
            return ()=>{
                container1.removeEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus); // We hit a react bug (fixed in v17) with focusing in unmount.
                // We need to delay the focus a little to get around it for now.
                // See: https://github.com/facebook/react/issues/17894
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent($d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, $d3863c46a17e8a28$var$EVENT_OPTIONS);
                    container1.addEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container1.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $d3863c46a17e8a28$var$focus(previouslyFocusedElement !== null && previouslyFocusedElement !== void 0 ? previouslyFocusedElement : document.body, {
                        select: true
                    });
                     // we need to remove the listener after we `dispatchEvent`
                    container1.removeEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $d3863c46a17e8a28$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container1,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]); // Takes care of looping focus (when tabbing whilst at the edges)
    const handleKeyDown = useCallback((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === 'Tab' && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container = event.currentTarget;
            const [first, last] = $d3863c46a17e8a28$var$getTabbableEdges(container);
            const hasTabbableElementsInside = first && last; // we can only wrap focus if we have tabbable edges
            if (!hasTabbableElementsInside) {
                if (focusedElement === container) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $d3863c46a17e8a28$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $d3863c46a17e8a28$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /*#__PURE__*/ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends({
        tabIndex: -1
    }, scopeProps, {
        ref: composedRefs,
        onKeyDown: handleKeyDown
    }));
});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Attempts focusing the first element in a list of candidates.
 * Stops when focus has actually moved.
 */ function $d3863c46a17e8a28$var$focusFirst(candidates, { select: select = false  } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        $d3863c46a17e8a28$var$focus(candidate, {
            select: select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
/**
 * Returns the first and last tabbable elements inside a container.
 */ function $d3863c46a17e8a28$var$getTabbableEdges(container) {
    const candidates = $d3863c46a17e8a28$var$getTabbableCandidates(container);
    const first = $d3863c46a17e8a28$var$findVisible(candidates, container);
    const last = $d3863c46a17e8a28$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
/**
 * Returns a list of potential tabbable candidates.
 *
 * NOTE: This is only a close approximation. For example it doesn't take into account cases like when
 * elements are not visible. This cannot be worked out easily by just reading a property, but rather
 * necessitate runtime knowledge (computed styles, etc). We deal with these cases separately.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/TreeWalker
 * Credit: https://github.com/discord/focus-layers/blob/master/src/util/wrapFocus.tsx#L1
 */ function $d3863c46a17e8a28$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === 'INPUT' && node.type === 'hidden';
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP; // `.tabIndex` is not the same as the `tabindex` attribute. It works on the
            // runtime's understanding of tabbability, so this automatically accounts
            // for any kind of element that could be tabbed to.
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode); // we do not take into account the order of nodes with positive `tabIndex` as it
    // hinders accessibility to have tab order different from visual order.
    return nodes;
}
/**
 * Returns the first visible element in a list.
 * NOTE: Only checks visibility up to the `container`.
 */ function $d3863c46a17e8a28$var$findVisible(elements, container) {
    for (const element of elements){
        // we stop checking if it's hidden at the `container` level (excluding)
        if (!$d3863c46a17e8a28$var$isHidden(element, {
            upTo: container
        })) return element;
    }
}
function $d3863c46a17e8a28$var$isHidden(node, { upTo: upTo  }) {
    if (getComputedStyle(node).visibility === 'hidden') return true;
    while(node){
        // we stop at `upTo` (excluding it)
        if (upTo !== undefined && node === upTo) return false;
        if (getComputedStyle(node).display === 'none') return true;
        node = node.parentElement;
    }
    return false;
}
function $d3863c46a17e8a28$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && 'select' in element;
}
function $d3863c46a17e8a28$var$focus(element, { select: select = false  } = {}) {
    // only focus if that element is focusable
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement; // NOTE: we prevent scrolling on focus, to minimize jarring transitions for users
        element.focus({
            preventScroll: true
        }); // only select if its not the same element, it supports selection and we need to select
        if (element !== previouslyFocusedElement && $d3863c46a17e8a28$var$isSelectableInput(element) && select) element.select();
    }
}
/* -------------------------------------------------------------------------------------------------
 * FocusScope stack
 * -----------------------------------------------------------------------------------------------*/ const $d3863c46a17e8a28$var$focusScopesStack = $d3863c46a17e8a28$var$createFocusScopesStack();
function $d3863c46a17e8a28$var$createFocusScopesStack() {
    /** A stack of focus scopes, with the active one at the top */ let stack = [];
    return {
        add (focusScope) {
            // pause the currently active focus scope (at the top of the stack)
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope === null || activeFocusScope === void 0 || activeFocusScope.pause();
             // remove in case it already exists (because we'll re-add it at the top of the stack)
            stack = $d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            var _stack$;
            stack = $d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
            (_stack$ = stack[0]) === null || _stack$ === void 0 || _stack$.resume();
        }
    };
}
function $d3863c46a17e8a28$var$arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
function $d3863c46a17e8a28$var$removeLinks(items) {
    return items.filter((item)=>item.tagName !== 'A'
    );
}

/**
 * On the server, React emits a warning when calling `useLayoutEffect`.
 * This is because neither `useLayoutEffect` nor `useEffect` run on the server.
 * We use this safe version which suppresses the warning by replacing it with a noop on the server.
 *
 * See: https://reactjs.org/docs/hooks-reference.html#uselayouteffect
 */ const $9f79659886946c16$export$e5c5a5f917a5871c = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? useLayoutEffect$1 : ()=>{};

const $1746a345f3d73bb7$var$useReactId = React['useId'.toString()] || (()=>undefined
);
let $1746a345f3d73bb7$var$count = 0;
function $1746a345f3d73bb7$export$f680877a34711e37(deterministicId) {
    const [id, setId] = React.useState($1746a345f3d73bb7$var$useReactId()); // React versions older than 18 will have client-side ids only.
    $9f79659886946c16$export$e5c5a5f917a5871c(()=>{
        if (!deterministicId) setId((reactId)=>reactId !== null && reactId !== void 0 ? reactId : String($1746a345f3d73bb7$var$count++)
        );
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : '');
}

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow$2 = options => {
  function isRef(value) {
    return {}.hasOwnProperty.call(value, 'current');
  }
  return {
    name: 'arrow',
    options,
    fn(state) {
      const {
        element,
        padding
      } = typeof options === 'function' ? options(state) : options;
      if (element && isRef(element)) {
        if (element.current != null) {
          return arrow$3({
            element: element.current,
            padding
          }).fn(state);
        }
        return {};
      }
      if (element) {
        return arrow$3({
          element,
          padding
        }).fn(state);
      }
      return {};
    }
  };
};

var index = typeof document !== 'undefined' ? useLayoutEffect$1 : useEffect;

// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function deepEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (typeof a !== typeof b) {
    return false;
  }
  if (typeof a === 'function' && a.toString() === b.toString()) {
    return true;
  }
  let length;
  let i;
  let keys;
  if (a && b && typeof a === 'object') {
    if (Array.isArray(a)) {
      length = a.length;
      if (length !== b.length) return false;
      for (i = length; i-- !== 0;) {
        if (!deepEqual(a[i], b[i])) {
          return false;
        }
      }
      return true;
    }
    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) {
      return false;
    }
    for (i = length; i-- !== 0;) {
      if (!{}.hasOwnProperty.call(b, keys[i])) {
        return false;
      }
    }
    for (i = length; i-- !== 0;) {
      const key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        continue;
      }
      if (!deepEqual(a[key], b[key])) {
        return false;
      }
    }
    return true;
  }

  // biome-ignore lint/suspicious/noSelfCompare: in source
  return a !== a && b !== b;
}

function getDPR(element) {
  if (typeof window === 'undefined') {
    return 1;
  }
  const win = element.ownerDocument.defaultView || window;
  return win.devicePixelRatio || 1;
}

function roundByDPR(element, value) {
  const dpr = getDPR(element);
  return Math.round(value * dpr) / dpr;
}

function useLatestRef(value) {
  const ref = React.useRef(value);
  index(() => {
    ref.current = value;
  });
  return ref;
}

/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */
function useFloating(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    placement = 'bottom',
    strategy = 'absolute',
    middleware = [],
    platform,
    elements: {
      reference: externalReference,
      floating: externalFloating
    } = {},
    transform = true,
    whileElementsMounted,
    open
  } = options;
  const [data, setData] = React.useState({
    x: 0,
    y: 0,
    strategy,
    placement,
    middlewareData: {},
    isPositioned: false
  });
  const [latestMiddleware, setLatestMiddleware] = React.useState(middleware);
  if (!deepEqual(latestMiddleware, middleware)) {
    setLatestMiddleware(middleware);
  }
  const [_reference, _setReference] = React.useState(null);
  const [_floating, _setFloating] = React.useState(null);
  const setReference = React.useCallback(node => {
    if (node !== referenceRef.current) {
      referenceRef.current = node;
      _setReference(node);
    }
  }, []);
  const setFloating = React.useCallback(node => {
    if (node !== floatingRef.current) {
      floatingRef.current = node;
      _setFloating(node);
    }
  }, []);
  const referenceEl = externalReference || _reference;
  const floatingEl = externalFloating || _floating;
  const referenceRef = React.useRef(null);
  const floatingRef = React.useRef(null);
  const dataRef = React.useRef(data);
  const hasWhileElementsMounted = whileElementsMounted != null;
  const whileElementsMountedRef = useLatestRef(whileElementsMounted);
  const platformRef = useLatestRef(platform);
  const update = React.useCallback(() => {
    if (!referenceRef.current || !floatingRef.current) {
      return;
    }
    const config = {
      placement,
      strategy,
      middleware: latestMiddleware
    };
    if (platformRef.current) {
      config.platform = platformRef.current;
    }
    computePosition(referenceRef.current, floatingRef.current, config).then(data => {
      const fullData = {
        ...data,
        isPositioned: true
      };
      if (isMountedRef.current && !deepEqual(dataRef.current, fullData)) {
        dataRef.current = fullData;
        require$$1.flushSync(() => {
          setData(fullData);
        });
      }
    });
  }, [latestMiddleware, placement, strategy, platformRef]);
  index(() => {
    if (open === false && dataRef.current.isPositioned) {
      dataRef.current.isPositioned = false;
      setData(data => ({
        ...data,
        isPositioned: false
      }));
    }
  }, [open]);
  const isMountedRef = React.useRef(false);
  index(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  // biome-ignore lint/correctness/useExhaustiveDependencies: `hasWhileElementsMounted` is intentionally included.
  index(() => {
    if (referenceEl) referenceRef.current = referenceEl;
    if (floatingEl) floatingRef.current = floatingEl;
    if (referenceEl && floatingEl) {
      if (whileElementsMountedRef.current) {
        return whileElementsMountedRef.current(referenceEl, floatingEl, update);
      }
      update();
    }
  }, [referenceEl, floatingEl, update, whileElementsMountedRef, hasWhileElementsMounted]);
  const refs = React.useMemo(() => ({
    reference: referenceRef,
    floating: floatingRef,
    setReference,
    setFloating
  }), [setReference, setFloating]);
  const elements = React.useMemo(() => ({
    reference: referenceEl,
    floating: floatingEl
  }), [referenceEl, floatingEl]);
  const floatingStyles = React.useMemo(() => {
    const initialStyles = {
      position: strategy,
      left: 0,
      top: 0
    };
    if (!elements.floating) {
      return initialStyles;
    }
    const x = roundByDPR(elements.floating, data.x);
    const y = roundByDPR(elements.floating, data.y);
    if (transform) {
      return {
        ...initialStyles,
        transform: "translate(" + x + "px, " + y + "px)",
        ...(getDPR(elements.floating) >= 1.5 && {
          willChange: 'transform'
        })
      };
    }
    return {
      position: strategy,
      left: x,
      top: y
    };
  }, [strategy, transform, elements.floating, data.x, data.y]);
  return React.useMemo(() => ({
    ...data,
    update,
    refs,
    elements,
    floatingStyles
  }), [data, update, refs, elements, floatingStyles]);
}

function $db6c3485150b8e66$export$1ab7ae714698c4b8(element) {
    const [size, setSize] = useState(undefined);
    $9f79659886946c16$export$e5c5a5f917a5871c(()=>{
        if (element) {
            // provide size as early as possible
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            const resizeObserver = new ResizeObserver((entries)=>{
                if (!Array.isArray(entries)) return;
                 // Since we only observe the one element, we don't need to loop over the
                // array
                if (!entries.length) return;
                const entry = entries[0];
                let width;
                let height;
                if ('borderBoxSize' in entry) {
                    const borderSizeEntry = entry['borderBoxSize']; // iron out differences between browsers
                    const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                    width = borderSize['inlineSize'];
                    height = borderSize['blockSize'];
                } else {
                    // for browsers that don't support `borderBoxSize`
                    // we calculate it ourselves to get the correct border box.
                    width = element.offsetWidth;
                    height = element.offsetHeight;
                }
                setSize({
                    width: width,
                    height: height
                });
            });
            resizeObserver.observe(element, {
                box: 'border-box'
            });
            return ()=>resizeObserver.unobserve(element)
            ;
        } else // We only want to reset to `undefined` when the element becomes `null`,
        // not if it changes to another element.
        setSize(undefined);
    }, [
        element
    ]);
    return size;
}

/* -------------------------------------------------------------------------------------------------
 * Popper
 * -----------------------------------------------------------------------------------------------*/ const $cf1ac5d9fe0e8206$var$POPPER_NAME = 'Popper';
const [$cf1ac5d9fe0e8206$var$createPopperContext, $cf1ac5d9fe0e8206$export$722aac194ae923] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($cf1ac5d9fe0e8206$var$POPPER_NAME);
const [$cf1ac5d9fe0e8206$var$PopperProvider, $cf1ac5d9fe0e8206$var$usePopperContext] = $cf1ac5d9fe0e8206$var$createPopperContext($cf1ac5d9fe0e8206$var$POPPER_NAME);
const $cf1ac5d9fe0e8206$export$badac9ada3a0bdf9 = (props)=>{
    const { __scopePopper: __scopePopper , children: children  } = props;
    const [anchor, setAnchor] = useState(null);
    return /*#__PURE__*/ createElement($cf1ac5d9fe0e8206$var$PopperProvider, {
        scope: __scopePopper,
        anchor: anchor,
        onAnchorChange: setAnchor
    }, children);
};
/* -------------------------------------------------------------------------------------------------
 * PopperAnchor
 * -----------------------------------------------------------------------------------------------*/ const $cf1ac5d9fe0e8206$var$ANCHOR_NAME = 'PopperAnchor';
const $cf1ac5d9fe0e8206$export$ecd4e1ccab6ed6d = /*#__PURE__*/ forwardRef((props, forwardedRef)=>{
    const { __scopePopper: __scopePopper , virtualRef: virtualRef , ...anchorProps } = props;
    const context = $cf1ac5d9fe0e8206$var$usePopperContext($cf1ac5d9fe0e8206$var$ANCHOR_NAME, __scopePopper);
    const ref = useRef(null);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
    useEffect(()=>{
        // Consumer can anchor the popper to something that isn't
        // a DOM node e.g. pointer position, so we override the
        // `anchorRef` with their virtual ref in this case.
        context.onAnchorChange((virtualRef === null || virtualRef === void 0 ? void 0 : virtualRef.current) || ref.current);
    });
    return virtualRef ? null : /*#__PURE__*/ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends({}, anchorProps, {
        ref: composedRefs
    }));
});
/* -------------------------------------------------------------------------------------------------
 * PopperContent
 * -----------------------------------------------------------------------------------------------*/ const $cf1ac5d9fe0e8206$var$CONTENT_NAME = 'PopperContent';
const [$cf1ac5d9fe0e8206$var$PopperContentProvider, $cf1ac5d9fe0e8206$var$useContentContext] = $cf1ac5d9fe0e8206$var$createPopperContext($cf1ac5d9fe0e8206$var$CONTENT_NAME);
const $cf1ac5d9fe0e8206$export$bc4ae5855d3c4fc = /*#__PURE__*/ forwardRef((props, forwardedRef)=>{
    var _arrowSize$width, _arrowSize$height, _middlewareData$arrow, _middlewareData$arrow2, _middlewareData$arrow3, _middlewareData$trans, _middlewareData$trans2, _middlewareData$hide;
    const { __scopePopper: __scopePopper , side: side = 'bottom' , sideOffset: sideOffset = 0 , align: align = 'center' , alignOffset: alignOffset = 0 , arrowPadding: arrowPadding = 0 , avoidCollisions: avoidCollisions = true , collisionBoundary: collisionBoundary = [] , collisionPadding: collisionPaddingProp = 0 , sticky: sticky = 'partial' , hideWhenDetached: hideWhenDetached = false , updatePositionStrategy: updatePositionStrategy = 'optimized' , onPlaced: onPlaced , ...contentProps } = props;
    const context = $cf1ac5d9fe0e8206$var$usePopperContext($cf1ac5d9fe0e8206$var$CONTENT_NAME, __scopePopper);
    const [content, setContent] = useState(null);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, (node)=>setContent(node)
    );
    const [arrow, setArrow] = useState(null);
    const arrowSize = $db6c3485150b8e66$export$1ab7ae714698c4b8(arrow);
    const arrowWidth = (_arrowSize$width = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.width) !== null && _arrowSize$width !== void 0 ? _arrowSize$width : 0;
    const arrowHeight = (_arrowSize$height = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.height) !== null && _arrowSize$height !== void 0 ? _arrowSize$height : 0;
    const desiredPlacement = side + (align !== 'center' ? '-' + align : '');
    const collisionPadding = typeof collisionPaddingProp === 'number' ? collisionPaddingProp : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...collisionPaddingProp
    };
    const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [
        collisionBoundary
    ];
    const hasExplicitBoundaries = boundary.length > 0;
    const detectOverflowOptions = {
        padding: collisionPadding,
        boundary: boundary.filter($cf1ac5d9fe0e8206$var$isNotNull),
        // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
        altBoundary: hasExplicitBoundaries
    };
    const { refs: refs , floatingStyles: floatingStyles , placement: placement , isPositioned: isPositioned , middlewareData: middlewareData  } = useFloating({
        // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
        strategy: 'fixed',
        placement: desiredPlacement,
        whileElementsMounted: (...args)=>{
            const cleanup = autoUpdate(...args, {
                animationFrame: updatePositionStrategy === 'always'
            });
            return cleanup;
        },
        elements: {
            reference: context.anchor
        },
        middleware: [
            offset$2({
                mainAxis: sideOffset + arrowHeight,
                alignmentAxis: alignOffset
            }),
            avoidCollisions && shift({
                mainAxis: true,
                crossAxis: false,
                limiter: sticky === 'partial' ? limitShift() : undefined,
                ...detectOverflowOptions
            }),
            avoidCollisions && flip$2({
                ...detectOverflowOptions
            }),
            size({
                ...detectOverflowOptions,
                apply: ({ elements: elements , rects: rects , availableWidth: availableWidth , availableHeight: availableHeight  })=>{
                    const { width: anchorWidth , height: anchorHeight  } = rects.reference;
                    const contentStyle = elements.floating.style;
                    contentStyle.setProperty('--radix-popper-available-width', `${availableWidth}px`);
                    contentStyle.setProperty('--radix-popper-available-height', `${availableHeight}px`);
                    contentStyle.setProperty('--radix-popper-anchor-width', `${anchorWidth}px`);
                    contentStyle.setProperty('--radix-popper-anchor-height', `${anchorHeight}px`);
                }
            }),
            arrow && arrow$2({
                element: arrow,
                padding: arrowPadding
            }),
            $cf1ac5d9fe0e8206$var$transformOrigin({
                arrowWidth: arrowWidth,
                arrowHeight: arrowHeight
            }),
            hideWhenDetached && hide$2({
                strategy: 'referenceHidden',
                ...detectOverflowOptions
            })
        ]
    });
    const [placedSide, placedAlign] = $cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
    const handlePlaced = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onPlaced);
    $9f79659886946c16$export$e5c5a5f917a5871c(()=>{
        if (isPositioned) handlePlaced === null || handlePlaced === void 0 || handlePlaced();
    }, [
        isPositioned,
        handlePlaced
    ]);
    const arrowX = (_middlewareData$arrow = middlewareData.arrow) === null || _middlewareData$arrow === void 0 ? void 0 : _middlewareData$arrow.x;
    const arrowY = (_middlewareData$arrow2 = middlewareData.arrow) === null || _middlewareData$arrow2 === void 0 ? void 0 : _middlewareData$arrow2.y;
    const cannotCenterArrow = ((_middlewareData$arrow3 = middlewareData.arrow) === null || _middlewareData$arrow3 === void 0 ? void 0 : _middlewareData$arrow3.centerOffset) !== 0;
    const [contentZIndex, setContentZIndex] = useState();
    $9f79659886946c16$export$e5c5a5f917a5871c(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    return /*#__PURE__*/ createElement("div", {
        ref: refs.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
            ...floatingStyles,
            transform: isPositioned ? floatingStyles.transform : 'translate(0, -200%)',
            // keep off the page when measuring
            minWidth: 'max-content',
            zIndex: contentZIndex,
            ['--radix-popper-transform-origin']: [
                (_middlewareData$trans = middlewareData.transformOrigin) === null || _middlewareData$trans === void 0 ? void 0 : _middlewareData$trans.x,
                (_middlewareData$trans2 = middlewareData.transformOrigin) === null || _middlewareData$trans2 === void 0 ? void 0 : _middlewareData$trans2.y
            ].join(' ')
        } // Floating UI interally calculates logical alignment based the `dir` attribute on
        ,
        dir: props.dir
    }, /*#__PURE__*/ createElement($cf1ac5d9fe0e8206$var$PopperContentProvider, {
        scope: __scopePopper,
        placedSide: placedSide,
        onArrowChange: setArrow,
        arrowX: arrowX,
        arrowY: arrowY,
        shouldHideArrow: cannotCenterArrow
    }, /*#__PURE__*/ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends({
        "data-side": placedSide,
        "data-align": placedAlign
    }, contentProps, {
        ref: composedRefs,
        style: {
            ...contentProps.style,
            // if the PopperContent hasn't been placed yet (not all measurements done)
            // we prevent animations so that users's animation don't kick in too early referring wrong sides
            animation: !isPositioned ? 'none' : undefined,
            // hide the content if using the hide middleware and should be hidden
            opacity: (_middlewareData$hide = middlewareData.hide) !== null && _middlewareData$hide !== void 0 && _middlewareData$hide.referenceHidden ? 0 : undefined
        }
    }))));
});
/* -----------------------------------------------------------------------------------------------*/ function $cf1ac5d9fe0e8206$var$isNotNull(value) {
    return value !== null;
}
const $cf1ac5d9fe0e8206$var$transformOrigin = (options)=>({
        name: 'transformOrigin',
        options: options,
        fn (data) {
            var _middlewareData$arrow4, _middlewareData$arrow5, _middlewareData$arrow6, _middlewareData$arrow7, _middlewareData$arrow8;
            const { placement: placement , rects: rects , middlewareData: middlewareData  } = data;
            const cannotCenterArrow = ((_middlewareData$arrow4 = middlewareData.arrow) === null || _middlewareData$arrow4 === void 0 ? void 0 : _middlewareData$arrow4.centerOffset) !== 0;
            const isArrowHidden = cannotCenterArrow;
            const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
            const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
            const [placedSide, placedAlign] = $cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
            const noArrowAlign = {
                start: '0%',
                center: '50%',
                end: '100%'
            }[placedAlign];
            const arrowXCenter = ((_middlewareData$arrow5 = (_middlewareData$arrow6 = middlewareData.arrow) === null || _middlewareData$arrow6 === void 0 ? void 0 : _middlewareData$arrow6.x) !== null && _middlewareData$arrow5 !== void 0 ? _middlewareData$arrow5 : 0) + arrowWidth / 2;
            const arrowYCenter = ((_middlewareData$arrow7 = (_middlewareData$arrow8 = middlewareData.arrow) === null || _middlewareData$arrow8 === void 0 ? void 0 : _middlewareData$arrow8.y) !== null && _middlewareData$arrow7 !== void 0 ? _middlewareData$arrow7 : 0) + arrowHeight / 2;
            let x = '';
            let y = '';
            if (placedSide === 'bottom') {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${-arrowHeight}px`;
            } else if (placedSide === 'top') {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${rects.floating.height + arrowHeight}px`;
            } else if (placedSide === 'right') {
                x = `${-arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            } else if (placedSide === 'left') {
                x = `${rects.floating.width + arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            }
            return {
                data: {
                    x: x,
                    y: y
                }
            };
        }
    })
;
function $cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement) {
    const [side, align = 'center'] = placement.split('-');
    return [
        side,
        align
    ];
}
const $cf1ac5d9fe0e8206$export$be92b6f5f03c0fe9 = $cf1ac5d9fe0e8206$export$badac9ada3a0bdf9;
const $cf1ac5d9fe0e8206$export$b688253958b8dfe7 = $cf1ac5d9fe0e8206$export$ecd4e1ccab6ed6d;
const $cf1ac5d9fe0e8206$export$7c6e2c02157bb7d2 = $cf1ac5d9fe0e8206$export$bc4ae5855d3c4fc;

function $fe963b355347cc68$export$3e6543de14f8614f(initialState, machine) {
    return useReducer((state, event)=>{
        const nextState = machine[state][event];
        return nextState !== null && nextState !== void 0 ? nextState : state;
    }, initialState);
}


const $921a889cee6df7e8$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present , children: children  } = props;
    const presence = $921a889cee6df7e8$var$usePresence(present);
    const child = typeof children === 'function' ? children({
        present: presence.isPresent
    }) : Children.only(children);
    const ref = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(presence.ref, child.ref);
    const forceMount = typeof children === 'function';
    return forceMount || presence.isPresent ? /*#__PURE__*/ cloneElement(child, {
        ref: ref
    }) : null;
};
$921a889cee6df7e8$export$99c2b779aa4e8b8b.displayName = 'Presence';
/* -------------------------------------------------------------------------------------------------
 * usePresence
 * -----------------------------------------------------------------------------------------------*/ function $921a889cee6df7e8$var$usePresence(present) {
    const [node1, setNode] = useState();
    const stylesRef = useRef({});
    const prevPresentRef = useRef(present);
    const prevAnimationNameRef = useRef('none');
    const initialState = present ? 'mounted' : 'unmounted';
    const [state, send] = $fe963b355347cc68$export$3e6543de14f8614f(initialState, {
        mounted: {
            UNMOUNT: 'unmounted',
            ANIMATION_OUT: 'unmountSuspended'
        },
        unmountSuspended: {
            MOUNT: 'mounted',
            ANIMATION_END: 'unmounted'
        },
        unmounted: {
            MOUNT: 'mounted'
        }
    });
    useEffect(()=>{
        const currentAnimationName = $921a889cee6df7e8$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === 'mounted' ? currentAnimationName : 'none';
    }, [
        state
    ]);
    $9f79659886946c16$export$e5c5a5f917a5871c(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $921a889cee6df7e8$var$getAnimationName(styles);
            if (present) send('MOUNT');
            else if (currentAnimationName === 'none' || (styles === null || styles === void 0 ? void 0 : styles.display) === 'none') // If there is no exit animation or the element is hidden, animations won't run
            // so we unmount instantly
            send('UNMOUNT');
            else {
                /**
         * When `present` changes to `false`, we check changes to animation-name to
         * determine whether an animation has started. We chose this approach (reading
         * computed styles) because there is no `animationrun` event and `animationstart`
         * fires after `animation-delay` has expired which would be too late.
         */ const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send('ANIMATION_OUT');
                else send('UNMOUNT');
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    $9f79659886946c16$export$e5c5a5f917a5871c(()=>{
        if (node1) {
            /**
       * Triggering an ANIMATION_OUT during an ANIMATION_IN will fire an `animationcancel`
       * event for ANIMATION_IN after we have entered `unmountSuspended` state. So, we
       * make sure we only trigger ANIMATION_END for the currently active animation.
       */ const handleAnimationEnd = (event)=>{
                const currentAnimationName = $921a889cee6df7e8$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node1 && isCurrentAnimation) // With React 18 concurrency this update is applied
                // a frame after the animation ends, creating a flash of visible content.
                // By manually flushing we ensure they sync within a frame, removing the flash.
                flushSync(()=>send('ANIMATION_END')
                );
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node1) // if animation occurred, store its name as the previous animation.
                prevAnimationNameRef.current = $921a889cee6df7e8$var$getAnimationName(stylesRef.current);
            };
            node1.addEventListener('animationstart', handleAnimationStart);
            node1.addEventListener('animationcancel', handleAnimationEnd);
            node1.addEventListener('animationend', handleAnimationEnd);
            return ()=>{
                node1.removeEventListener('animationstart', handleAnimationStart);
                node1.removeEventListener('animationcancel', handleAnimationEnd);
                node1.removeEventListener('animationend', handleAnimationEnd);
            };
        } else // Transition to the unmounted state if the node is removed prematurely.
        // We avoid doing so during cleanup as the node may change but still exist.
        send('ANIMATION_END');
    }, [
        node1,
        send
    ]);
    return {
        isPresent: [
            'mounted',
            'unmountSuspended'
        ].includes(state),
        ref: useCallback((node)=>{
            if (node) stylesRef.current = getComputedStyle(node);
            setNode(node);
        }, [])
    };
}
/* -----------------------------------------------------------------------------------------------*/ function $921a889cee6df7e8$var$getAnimationName(styles) {
    return (styles === null || styles === void 0 ? void 0 : styles.animationName) || 'none';
}

const $d7bdfb9eb0fdf311$var$ENTRY_FOCUS = 'rovingFocusGroup.onEntryFocus';
const $d7bdfb9eb0fdf311$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
/* -------------------------------------------------------------------------------------------------
 * RovingFocusGroup
 * -----------------------------------------------------------------------------------------------*/ const $d7bdfb9eb0fdf311$var$GROUP_NAME = 'RovingFocusGroup';
const [$d7bdfb9eb0fdf311$var$Collection, $d7bdfb9eb0fdf311$var$useCollection, $d7bdfb9eb0fdf311$var$createCollectionScope] = $e02a7d9cb1dc128c$export$c74125a8e3af6bb2($d7bdfb9eb0fdf311$var$GROUP_NAME);
const [$d7bdfb9eb0fdf311$var$createRovingFocusGroupContext, $d7bdfb9eb0fdf311$export$c7109489551a4f4] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($d7bdfb9eb0fdf311$var$GROUP_NAME, [
    $d7bdfb9eb0fdf311$var$createCollectionScope
]);
const [$d7bdfb9eb0fdf311$var$RovingFocusProvider, $d7bdfb9eb0fdf311$var$useRovingFocusContext] = $d7bdfb9eb0fdf311$var$createRovingFocusGroupContext($d7bdfb9eb0fdf311$var$GROUP_NAME);
const $d7bdfb9eb0fdf311$export$8699f7c8af148338 = /*#__PURE__*/ forwardRef((props, forwardedRef)=>{
    return /*#__PURE__*/ createElement($d7bdfb9eb0fdf311$var$Collection.Provider, {
        scope: props.__scopeRovingFocusGroup
    }, /*#__PURE__*/ createElement($d7bdfb9eb0fdf311$var$Collection.Slot, {
        scope: props.__scopeRovingFocusGroup
    }, /*#__PURE__*/ createElement($d7bdfb9eb0fdf311$var$RovingFocusGroupImpl, _extends({}, props, {
        ref: forwardedRef
    }))));
});
/* -----------------------------------------------------------------------------------------------*/ const $d7bdfb9eb0fdf311$var$RovingFocusGroupImpl = /*#__PURE__*/ forwardRef((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup , orientation: orientation , loop: loop = false , dir: dir , currentTabStopId: currentTabStopIdProp , defaultCurrentTabStopId: defaultCurrentTabStopId , onCurrentTabStopIdChange: onCurrentTabStopIdChange , onEntryFocus: onEntryFocus , ...groupProps } = props;
    const ref = useRef(null);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
    const direction = $f631663db3294ace$export$b39126d51d94e6f3(dir);
    const [currentTabStopId = null, setCurrentTabStopId] = $71cd76cc60e0454e$export$6f32135080cb4c3({
        prop: currentTabStopIdProp,
        defaultProp: defaultCurrentTabStopId,
        onChange: onCurrentTabStopIdChange
    });
    const [isTabbingBackOut, setIsTabbingBackOut] = useState(false);
    const handleEntryFocus = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onEntryFocus);
    const getItems = $d7bdfb9eb0fdf311$var$useCollection(__scopeRovingFocusGroup);
    const isClickFocusRef = useRef(false);
    const [focusableItemsCount, setFocusableItemsCount] = useState(0);
    useEffect(()=>{
        const node = ref.current;
        if (node) {
            node.addEventListener($d7bdfb9eb0fdf311$var$ENTRY_FOCUS, handleEntryFocus);
            return ()=>node.removeEventListener($d7bdfb9eb0fdf311$var$ENTRY_FOCUS, handleEntryFocus)
            ;
        }
    }, [
        handleEntryFocus
    ]);
    return /*#__PURE__*/ createElement($d7bdfb9eb0fdf311$var$RovingFocusProvider, {
        scope: __scopeRovingFocusGroup,
        orientation: orientation,
        dir: direction,
        loop: loop,
        currentTabStopId: currentTabStopId,
        onItemFocus: useCallback((tabStopId)=>setCurrentTabStopId(tabStopId)
        , [
            setCurrentTabStopId
        ]),
        onItemShiftTab: useCallback(()=>setIsTabbingBackOut(true)
        , []),
        onFocusableItemAdd: useCallback(()=>setFocusableItemsCount((prevCount)=>prevCount + 1
            )
        , []),
        onFocusableItemRemove: useCallback(()=>setFocusableItemsCount((prevCount)=>prevCount - 1
            )
        , [])
    }, /*#__PURE__*/ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends({
        tabIndex: isTabbingBackOut || focusableItemsCount === 0 ? -1 : 0,
        "data-orientation": orientation
    }, groupProps, {
        ref: composedRefs,
        style: {
            outline: 'none',
            ...props.style
        },
        onMouseDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onMouseDown, ()=>{
            isClickFocusRef.current = true;
        }),
        onFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onFocus, (event)=>{
            // We normally wouldn't need this check, because we already check
            // that the focus is on the current target and not bubbling to it.
            // We do this because Safari doesn't focus buttons when clicked, and
            // instead, the wrapper will get focused and not through a bubbling event.
            const isKeyboardFocus = !isClickFocusRef.current;
            if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
                const entryFocusEvent = new CustomEvent($d7bdfb9eb0fdf311$var$ENTRY_FOCUS, $d7bdfb9eb0fdf311$var$EVENT_OPTIONS);
                event.currentTarget.dispatchEvent(entryFocusEvent);
                if (!entryFocusEvent.defaultPrevented) {
                    const items = getItems().filter((item)=>item.focusable
                    );
                    const activeItem = items.find((item)=>item.active
                    );
                    const currentItem = items.find((item)=>item.id === currentTabStopId
                    );
                    const candidateItems = [
                        activeItem,
                        currentItem,
                        ...items
                    ].filter(Boolean);
                    const candidateNodes = candidateItems.map((item)=>item.ref.current
                    );
                    $d7bdfb9eb0fdf311$var$focusFirst(candidateNodes);
                }
            }
            isClickFocusRef.current = false;
        }),
        onBlur: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onBlur, ()=>setIsTabbingBackOut(false)
        )
    })));
});
/* -------------------------------------------------------------------------------------------------
 * RovingFocusGroupItem
 * -----------------------------------------------------------------------------------------------*/ const $d7bdfb9eb0fdf311$var$ITEM_NAME = 'RovingFocusGroupItem';
const $d7bdfb9eb0fdf311$export$ab9df7c53fe8454 = /*#__PURE__*/ forwardRef((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup , focusable: focusable = true , active: active = false , tabStopId: tabStopId , ...itemProps } = props;
    const autoId = $1746a345f3d73bb7$export$f680877a34711e37();
    const id = tabStopId || autoId;
    const context = $d7bdfb9eb0fdf311$var$useRovingFocusContext($d7bdfb9eb0fdf311$var$ITEM_NAME, __scopeRovingFocusGroup);
    const isCurrentTabStop = context.currentTabStopId === id;
    const getItems = $d7bdfb9eb0fdf311$var$useCollection(__scopeRovingFocusGroup);
    const { onFocusableItemAdd: onFocusableItemAdd , onFocusableItemRemove: onFocusableItemRemove  } = context;
    useEffect(()=>{
        if (focusable) {
            onFocusableItemAdd();
            return ()=>onFocusableItemRemove()
            ;
        }
    }, [
        focusable,
        onFocusableItemAdd,
        onFocusableItemRemove
    ]);
    return /*#__PURE__*/ createElement($d7bdfb9eb0fdf311$var$Collection.ItemSlot, {
        scope: __scopeRovingFocusGroup,
        id: id,
        focusable: focusable,
        active: active
    }, /*#__PURE__*/ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.span, _extends({
        tabIndex: isCurrentTabStop ? 0 : -1,
        "data-orientation": context.orientation
    }, itemProps, {
        ref: forwardedRef,
        onMouseDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onMouseDown, (event)=>{
            // We prevent focusing non-focusable items on `mousedown`.
            // Even though the item has tabIndex={-1}, that only means take it out of the tab order.
            if (!focusable) event.preventDefault(); // Safari doesn't focus a button when clicked so we run our logic on mousedown also
            else context.onItemFocus(id);
        }),
        onFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onFocus, ()=>context.onItemFocus(id)
        ),
        onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onKeyDown, (event)=>{
            if (event.key === 'Tab' && event.shiftKey) {
                context.onItemShiftTab();
                return;
            }
            if (event.target !== event.currentTarget) return;
            const focusIntent = $d7bdfb9eb0fdf311$var$getFocusIntent(event, context.orientation, context.dir);
            if (focusIntent !== undefined) {
                event.preventDefault();
                const items = getItems().filter((item)=>item.focusable
                );
                let candidateNodes = items.map((item)=>item.ref.current
                );
                if (focusIntent === 'last') candidateNodes.reverse();
                else if (focusIntent === 'prev' || focusIntent === 'next') {
                    if (focusIntent === 'prev') candidateNodes.reverse();
                    const currentIndex = candidateNodes.indexOf(event.currentTarget);
                    candidateNodes = context.loop ? $d7bdfb9eb0fdf311$var$wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
                }
                /**
         * Imperative focus during keydown is risky so we prevent React's batching updates
         * to avoid potential bugs. See: https://github.com/facebook/react/issues/20332
         */ setTimeout(()=>$d7bdfb9eb0fdf311$var$focusFirst(candidateNodes)
                );
            }
        })
    })));
});
/* -----------------------------------------------------------------------------------------------*/ // prettier-ignore
const $d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT = {
    ArrowLeft: 'prev',
    ArrowUp: 'prev',
    ArrowRight: 'next',
    ArrowDown: 'next',
    PageUp: 'first',
    Home: 'first',
    PageDown: 'last',
    End: 'last'
};
function $d7bdfb9eb0fdf311$var$getDirectionAwareKey(key, dir) {
    if (dir !== 'rtl') return key;
    return key === 'ArrowLeft' ? 'ArrowRight' : key === 'ArrowRight' ? 'ArrowLeft' : key;
}
function $d7bdfb9eb0fdf311$var$getFocusIntent(event, orientation, dir) {
    const key = $d7bdfb9eb0fdf311$var$getDirectionAwareKey(event.key, dir);
    if (orientation === 'vertical' && [
        'ArrowLeft',
        'ArrowRight'
    ].includes(key)) return undefined;
    if (orientation === 'horizontal' && [
        'ArrowUp',
        'ArrowDown'
    ].includes(key)) return undefined;
    return $d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT[key];
}
function $d7bdfb9eb0fdf311$var$focusFirst(candidates) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        // if focus is already where we want to go, we don't want to keep going through the candidates
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus();
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
/**
 * Wraps an array around itself at a given start index
 * Example: `wrapArray(['a', 'b', 'c', 'd'], 2) === ['c', 'd', 'a', 'b']`
 */ function $d7bdfb9eb0fdf311$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]
    );
}
const $d7bdfb9eb0fdf311$export$be92b6f5f03c0fe9 = $d7bdfb9eb0fdf311$export$8699f7c8af148338;
const $d7bdfb9eb0fdf311$export$6d08773d2e66f8f2 = $d7bdfb9eb0fdf311$export$ab9df7c53fe8454;

var getDefaultParent = function (originalTarget) {
    if (typeof document === 'undefined') {
        return null;
    }
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var counterMap = new WeakMap();
var uncontrolledNodes = new WeakMap();
var markerMap = {};
var lockCount = 0;
var unwrapHost = function (node) {
    return node && (node.host || unwrapHost(node.parentNode));
};
var correctTargets = function (parent, targets) {
    return targets
        .map(function (target) {
        if (parent.contains(target)) {
            return target;
        }
        var correctedTarget = unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) {
            return correctedTarget;
        }
        console.error('aria-hidden', target, 'in not contained inside', parent, '. Doing nothing');
        return null;
    })
        .filter(function (x) { return Boolean(x); });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */
var applyAttributeToOthers = function (originalTarget, parentNode, markerName, controlAttribute) {
    var targets = correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
    if (!markerMap[markerName]) {
        markerMap[markerName] = new WeakMap();
    }
    var markerCounter = markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function (el) {
        if (!el || elementsToKeep.has(el)) {
            return;
        }
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function (parent) {
        if (!parent || elementsToStop.has(parent)) {
            return;
        }
        Array.prototype.forEach.call(parent.children, function (node) {
            if (elementsToKeep.has(node)) {
                deep(node);
            }
            else {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== 'false';
                var counterValue = (counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) {
                    uncontrolledNodes.set(node, true);
                }
                if (markerValue === 1) {
                    node.setAttribute(markerName, 'true');
                }
                if (!alreadyHidden) {
                    node.setAttribute(controlAttribute, 'true');
                }
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    lockCount++;
    return function () {
        hiddenNodes.forEach(function (node) {
            var counterValue = counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!uncontrolledNodes.has(node)) {
                    node.removeAttribute(controlAttribute);
                }
                uncontrolledNodes.delete(node);
            }
            if (!markerValue) {
                node.removeAttribute(markerName);
            }
        });
        lockCount--;
        if (!lockCount) {
            // clear
            counterMap = new WeakMap();
            counterMap = new WeakMap();
            uncontrolledNodes = new WeakMap();
            markerMap = {};
        }
    };
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @return {Undo} undo command
 */
var hideOthers = function (originalTarget, parentNode, markerName) {
    if (markerName === void 0) { markerName = 'data-aria-hidden'; }
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
    var activeParentNode = parentNode || getDefaultParent(originalTarget);
    if (!activeParentNode) {
        return function () { return null; };
    }
    // we should not hide ariaLive elements - https://github.com/theKashey/aria-hidden/issues/10
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll('[aria-live]')));
    return applyAttributeToOthers(targets, activeParentNode, markerName, 'aria-hidden');
};

var zeroRightClassName = 'right-scroll-bar-position';
var fullWidthClassName = 'width-before-scroll-bar';
var noScrollbarsClassName = 'with-scroll-bars-hidden';
/**
 * Name of a CSS variable containing the amount of "hidden" scrollbar
 * ! might be undefined ! use will fallback!
 */
var removedBarSizeVariable = '--removed-body-scroll-bar-size';

/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */
function assignRef(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
    }
    else if (ref) {
        ref.current = value;
    }
    return ref;
}

/**
 * creates a MutableRef with ref change callback
 * @param initialValue - initial ref value
 * @param {Function} callback - a callback to run when value changes
 *
 * @example
 * const ref = useCallbackRef(0, (newValue, oldValue) => console.log(oldValue, '->', newValue);
 * ref.current = 1;
 * // prints 0 -> 1
 *
 * @see https://reactjs.org/docs/hooks-reference.html#useref
 * @see https://github.com/theKashey/use-callback-ref#usecallbackref---to-replace-reactuseref
 * @returns {MutableRefObject}
 */
function useCallbackRef(initialValue, callback) {
    var ref = useState(function () { return ({
        // value
        value: initialValue,
        // last callback
        callback: callback,
        // "memoized" public interface
        facade: {
            get current() {
                return ref.value;
            },
            set current(value) {
                var last = ref.value;
                if (last !== value) {
                    ref.value = value;
                    ref.callback(value, last);
                }
            },
        },
    }); })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

/**
 * Merges two or more refs together providing a single interface to set their value
 * @param {RefObject|Ref} refs
 * @returns {MutableRefObject} - a new ref, which translates all changes to {refs}
 *
 * @see {@link mergeRefs} a version without buit-in memoization
 * @see https://github.com/theKashey/use-callback-ref#usemergerefs
 * @example
 * const Component = React.forwardRef((props, ref) => {
 *   const ownRef = useRef();
 *   const domRef = useMergeRefs([ref, ownRef]); // 👈 merge together
 *   return <div ref={domRef}>...</div>
 * }
 */
function useMergeRefs(refs, defaultValue) {
    return useCallbackRef(defaultValue || null, function (newValue) { return refs.forEach(function (ref) { return assignRef(ref, newValue); }); });
}

function ItoI(a) {
    return a;
}
function innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) { middleware = ItoI; }
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function () {
            if (assigned) {
                throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            }
            if (buffer.length) {
                return buffer[buffer.length - 1];
            }
            return defaults;
        },
        useMedium: function (data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function () {
                buffer = buffer.filter(function (x) { return x !== item; });
            };
        },
        assignSyncMedium: function (cb) {
            assigned = true;
            while (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function (x) { return cb(x); },
                filter: function () { return buffer; },
            };
        },
        assignMedium: function (cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function () {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function () { return Promise.resolve().then(executeQueue); };
            cycle();
            buffer = {
                push: function (x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function (filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                },
            };
        },
    };
    return medium;
}
// eslint-disable-next-line @typescript-eslint/ban-types
function createSidecarMedium(options) {
    if (options === void 0) { options = {}; }
    var medium = innerCreateMedium(null);
    medium.options = __assign({ async: true, ssr: false }, options);
    return medium;
}

var SideCar$1 = function (_a) {
    var sideCar = _a.sideCar, rest = __rest(_a, ["sideCar"]);
    if (!sideCar) {
        throw new Error('Sidecar: please provide `sideCar` property to import the right car');
    }
    var Target = sideCar.read();
    if (!Target) {
        throw new Error('Sidecar medium not found');
    }
    return React.createElement(Target, __assign({}, rest));
};
SideCar$1.isSideCarExport = true;
function exportSidecar(medium, exported) {
    medium.useMedium(exported);
    return SideCar$1;
}

var effectCar = createSidecarMedium();

var nothing = function () {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */
var RemoveScroll = React.forwardRef(function (props, parentRef) {
    var ref = React.useRef(null);
    var _a = React.useState({
        onScrollCapture: nothing,
        onWheelCapture: nothing,
        onTouchMoveCapture: nothing,
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? 'div' : _b, rest = __rest(props, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]);
    var SideCar = sideCar;
    var containerRef = useMergeRefs([ref, parentRef]);
    var containerProps = __assign(__assign({}, rest), callbacks);
    return (React.createElement(React.Fragment, null,
        enabled && (React.createElement(SideCar, { sideCar: effectCar, removeScrollBar: removeScrollBar, shards: shards, noIsolation: noIsolation, inert: inert, setCallbacks: setCallbacks, allowPinchZoom: !!allowPinchZoom, lockRef: ref })),
        forwardProps ? (React.cloneElement(React.Children.only(children), __assign(__assign({}, containerProps), { ref: containerRef }))) : (React.createElement(Container, __assign({}, containerProps, { className: className, ref: containerRef }), children))));
});
RemoveScroll.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false,
};
RemoveScroll.classNames = {
    fullWidth: fullWidthClassName,
    zeroRight: zeroRightClassName,
};

var getNonce = function () {
    if (typeof __webpack_nonce__ !== 'undefined') {
        return __webpack_nonce__;
    }
    return undefined;
};

function makeStyleTag() {
    if (!document)
        return null;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    var nonce = getNonce();
    if (nonce) {
        tag.setAttribute('nonce', nonce);
    }
    return tag;
}
function injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) {
        // @ts-ignore
        tag.styleSheet.cssText = css;
    }
    else {
        tag.appendChild(document.createTextNode(css));
    }
}
function insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}
var stylesheetSingleton = function () {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function (style) {
            if (counter == 0) {
                if ((stylesheet = makeStyleTag())) {
                    injectStyles(stylesheet, style);
                    insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function () {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        },
    };
};

/**
 * creates a hook to control style singleton
 * @see {@link styleSingleton} for a safer component version
 * @example
 * ```tsx
 * const useStyle = styleHookSingleton();
 * ///
 * useStyle('body { overflow: hidden}');
 */
var styleHookSingleton = function () {
    var sheet = stylesheetSingleton();
    return function (styles, isDynamic) {
        React.useEffect(function () {
            sheet.add(styles);
            return function () {
                sheet.remove();
            };
        }, [styles && isDynamic]);
    };
};

/**
 * create a Component to add styles on demand
 * - styles are added when first instance is mounted
 * - styles are removed when the last instance is unmounted
 * - changing styles in runtime does nothing unless dynamic is set. But with multiple components that can lead to the undefined behavior
 */
var styleSingleton = function () {
    var useStyle = styleHookSingleton();
    var Sheet = function (_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};

var zeroGap = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0,
};
var parse$1 = function (x) { return parseInt(x || '', 10) || 0; };
var getOffset$1 = function (gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === 'padding' ? 'paddingLeft' : 'marginLeft'];
    var top = cs[gapMode === 'padding' ? 'paddingTop' : 'marginTop'];
    var right = cs[gapMode === 'padding' ? 'paddingRight' : 'marginRight'];
    return [parse$1(left), parse$1(top), parse$1(right)];
};
var getGapWidth = function (gapMode) {
    if (gapMode === void 0) { gapMode = 'margin'; }
    if (typeof window === 'undefined') {
        return zeroGap;
    }
    var offsets = getOffset$1(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0]),
    };
};

var Style = styleSingleton();
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var getStyles = function (_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) { gapMode = 'margin'; }
    return "\n  .".concat(noScrollbarsClassName, " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === 'margin' &&
            "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === 'padding' && "padding-right: ".concat(gap, "px ").concat(important, ";"),
    ]
        .filter(Boolean)
        .join(''), "\n  }\n  \n  .").concat(zeroRightClassName, " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(zeroRightClassName, " .").concat(zeroRightClassName, " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " .").concat(fullWidthClassName, " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body {\n    ").concat(removedBarSizeVariable, ": ").concat(gap, "px;\n  }\n");
};
/**
 * Removes page scrollbar and blocks page scroll when mounted
 */
var RemoveScrollBar = function (props) {
    var noRelative = props.noRelative, noImportant = props.noImportant, _a = props.gapMode, gapMode = _a === void 0 ? 'margin' : _a;
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */
    var gap = React.useMemo(function () { return getGapWidth(gapMode); }, [gapMode]);
    return React.createElement(Style, { styles: getStyles(gap, !noRelative, gapMode, !noImportant ? '!important' : '') });
};

var passiveSupported = false;
if (typeof window !== 'undefined') {
    try {
        var options$1 = Object.defineProperty({}, 'passive', {
            get: function () {
                passiveSupported = true;
                return true;
            },
        });
        // @ts-ignore
        window.addEventListener('test', options$1, options$1);
        // @ts-ignore
        window.removeEventListener('test', options$1, options$1);
    }
    catch (err) {
        passiveSupported = false;
    }
}
var nonPassive = passiveSupported ? { passive: false } : false;

var alwaysContainsScroll = function (node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === 'TEXTAREA';
};
var elementCanBeScrolled = function (node, overflow) {
    var styles = window.getComputedStyle(node);
    return (
    // not-not-scrollable
    styles[overflow] !== 'hidden' &&
        // contains scroll inside self
        !(styles.overflowY === styles.overflowX && !alwaysContainsScroll(node) && styles[overflow] === 'visible'));
};
var elementCouldBeVScrolled = function (node) { return elementCanBeScrolled(node, 'overflowY'); };
var elementCouldBeHScrolled = function (node) { return elementCanBeScrolled(node, 'overflowX'); };
var locationCouldBeScrolled = function (axis, node) {
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== 'undefined' && current instanceof ShadowRoot) {
            current = current.host;
        }
        var isScrollable = elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = getScrollVariables(axis, current), s = _a[1], d = _a[2];
            if (s > d) {
                return true;
            }
        }
        current = current.parentNode;
    } while (current && current !== document.body);
    return false;
};
var getVScrollVariables = function (_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight,
    ];
};
var getHScrollVariables = function (_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth,
    ];
};
var elementCouldBeScrolled = function (axis, node) {
    return axis === 'v' ? elementCouldBeVScrolled(node) : elementCouldBeHScrolled(node);
};
var getScrollVariables = function (axis, node) {
    return axis === 'v' ? getVScrollVariables(node) : getHScrollVariables(node);
};
var getDirectionFactor = function (axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */
    return axis === 'h' && direction === 'rtl' ? -1 : 1;
};
var handleScroll = function (axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if (elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        target = target.parentNode;
    } while (
    // portaled content
    (!targetInLock && target !== document.body) ||
        // self content
        (targetInLock && (endTarget.contains(target) || endTarget === target)));
    if (isDeltaPositive && ((noOverscroll && availableScroll === 0) || (!noOverscroll && delta > availableScroll))) {
        shouldCancelScroll = true;
    }
    else if (!isDeltaPositive &&
        ((noOverscroll && availableScrollTop === 0) || (!noOverscroll && -delta > availableScrollTop))) {
        shouldCancelScroll = true;
    }
    return shouldCancelScroll;
};

var getTouchXY = function (event) {
    return 'changedTouches' in event ? [event.changedTouches[0].clientX, event.changedTouches[0].clientY] : [0, 0];
};
var getDeltaXY = function (event) { return [event.deltaX, event.deltaY]; };
var extractRef = function (ref) {
    return ref && 'current' in ref ? ref.current : ref;
};
var deltaCompare = function (x, y) { return x[0] === y[0] && x[1] === y[1]; };
var generateStyle = function (id) { return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n"); };
var idCounter = 0;
var lockStack = [];
function RemoveScrollSideCar(props) {
    var shouldPreventQueue = React.useRef([]);
    var touchStartRef = React.useRef([0, 0]);
    var activeAxis = React.useRef();
    var id = React.useState(idCounter++)[0];
    var Style = React.useState(function () { return styleSingleton(); })[0];
    var lastProps = React.useRef(props);
    React.useEffect(function () {
        lastProps.current = props;
    }, [props]);
    React.useEffect(function () {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = __spreadArray([props.lockRef.current], (props.shards || []).map(extractRef), true).filter(Boolean);
            allow_1.forEach(function (el) { return el.classList.add("allow-interactivity-".concat(id)); });
            return function () {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function (el) { return el.classList.remove("allow-interactivity-".concat(id)); });
            };
        }
        return;
    }, [props.inert, props.lockRef.current, props.shards]);
    var shouldCancelEvent = React.useCallback(function (event, parent) {
        if ('touches' in event && event.touches.length === 2) {
            return !lastProps.current.allowPinchZoom;
        }
        var touch = getTouchXY(event);
        var touchStart = touchStartRef.current;
        var deltaX = 'deltaX' in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = 'deltaY' in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? 'h' : 'v';
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ('touches' in event && moveDirection === 'h' && target.type === 'range') {
            return false;
        }
        var canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
        if (!canBeScrolledInMainDirection) {
            return true;
        }
        if (canBeScrolledInMainDirection) {
            currentAxis = moveDirection;
        }
        else {
            currentAxis = moveDirection === 'v' ? 'h' : 'v';
            canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
            // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) {
            return false;
        }
        if (!activeAxis.current && 'changedTouches' in event && (deltaX || deltaY)) {
            activeAxis.current = currentAxis;
        }
        if (!currentAxis) {
            return true;
        }
        var cancelingAxis = activeAxis.current || currentAxis;
        return handleScroll(cancelingAxis, parent, event, cancelingAxis === 'h' ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = React.useCallback(function (_event) {
        var event = _event;
        if (!lockStack.length || lockStack[lockStack.length - 1] !== Style) {
            // not the last active
            return;
        }
        var delta = 'deltaY' in event ? getDeltaXY(event) : getTouchXY(event);
        var sourceEvent = shouldPreventQueue.current.filter(function (e) { return e.name === event.type && e.target === event.target && deltaCompare(e.delta, delta); })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) {
                event.preventDefault();
            }
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || [])
                .map(extractRef)
                .filter(Boolean)
                .filter(function (node) { return node.contains(event.target); });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) {
                    event.preventDefault();
                }
            }
        }
    }, []);
    var shouldCancel = React.useCallback(function (name, delta, target, should) {
        var event = { name: name, delta: delta, target: target, should: should };
        shouldPreventQueue.current.push(event);
        setTimeout(function () {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function (e) { return e !== event; });
        }, 1);
    }, []);
    var scrollTouchStart = React.useCallback(function (event) {
        touchStartRef.current = getTouchXY(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = React.useCallback(function (event) {
        shouldCancel(event.type, getDeltaXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = React.useCallback(function (event) {
        shouldCancel(event.type, getTouchXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    React.useEffect(function () {
        lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove,
        });
        document.addEventListener('wheel', shouldPrevent, nonPassive);
        document.addEventListener('touchmove', shouldPrevent, nonPassive);
        document.addEventListener('touchstart', scrollTouchStart, nonPassive);
        return function () {
            lockStack = lockStack.filter(function (inst) { return inst !== Style; });
            document.removeEventListener('wheel', shouldPrevent, nonPassive);
            document.removeEventListener('touchmove', shouldPrevent, nonPassive);
            document.removeEventListener('touchstart', scrollTouchStart, nonPassive);
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return (React.createElement(React.Fragment, null,
        inert ? React.createElement(Style, { styles: generateStyle(id) }) : null,
        removeScrollBar ? React.createElement(RemoveScrollBar, { gapMode: "margin" }) : null));
}

var SideCar = exportSidecar(effectCar, RemoveScrollSideCar);

var ReactRemoveScroll = React.forwardRef(function (props, ref) { return (React.createElement(RemoveScroll, __assign({}, props, { ref: ref, sideCar: SideCar }))); });
ReactRemoveScroll.classNames = RemoveScroll.classNames;
var $am6gm$RemoveScroll = ReactRemoveScroll;

const $6cc32821e9371a1c$var$SELECTION_KEYS = [
    'Enter',
    ' '
];
const $6cc32821e9371a1c$var$FIRST_KEYS = [
    'ArrowDown',
    'PageUp',
    'Home'
];
const $6cc32821e9371a1c$var$LAST_KEYS = [
    'ArrowUp',
    'PageDown',
    'End'
];
const $6cc32821e9371a1c$var$FIRST_LAST_KEYS = [
    ...$6cc32821e9371a1c$var$FIRST_KEYS,
    ...$6cc32821e9371a1c$var$LAST_KEYS
];
/* -------------------------------------------------------------------------------------------------
 * Menu
 * -----------------------------------------------------------------------------------------------*/ const $6cc32821e9371a1c$var$MENU_NAME = 'Menu';
const [$6cc32821e9371a1c$var$Collection, $6cc32821e9371a1c$var$useCollection, $6cc32821e9371a1c$var$createCollectionScope] = $e02a7d9cb1dc128c$export$c74125a8e3af6bb2($6cc32821e9371a1c$var$MENU_NAME);
const [$6cc32821e9371a1c$var$createMenuContext, $6cc32821e9371a1c$export$4027731b685e72eb] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($6cc32821e9371a1c$var$MENU_NAME, [
    $6cc32821e9371a1c$var$createCollectionScope,
    $cf1ac5d9fe0e8206$export$722aac194ae923,
    $d7bdfb9eb0fdf311$export$c7109489551a4f4
]);
const $6cc32821e9371a1c$var$usePopperScope = $cf1ac5d9fe0e8206$export$722aac194ae923();
const $6cc32821e9371a1c$var$useRovingFocusGroupScope = $d7bdfb9eb0fdf311$export$c7109489551a4f4();
const [$6cc32821e9371a1c$var$MenuProvider, $6cc32821e9371a1c$var$useMenuContext] = $6cc32821e9371a1c$var$createMenuContext($6cc32821e9371a1c$var$MENU_NAME);
const [$6cc32821e9371a1c$var$MenuRootProvider, $6cc32821e9371a1c$var$useMenuRootContext] = $6cc32821e9371a1c$var$createMenuContext($6cc32821e9371a1c$var$MENU_NAME);
const $6cc32821e9371a1c$export$d9b273488cd8ce6f = (props)=>{
    const { __scopeMenu: __scopeMenu , open: open = false , children: children , dir: dir , onOpenChange: onOpenChange , modal: modal = true  } = props;
    const popperScope = $6cc32821e9371a1c$var$usePopperScope(__scopeMenu);
    const [content, setContent] = useState(null);
    const isUsingKeyboardRef = useRef(false);
    const handleOpenChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onOpenChange);
    const direction = $f631663db3294ace$export$b39126d51d94e6f3(dir);
    useEffect(()=>{
        // Capture phase ensures we set the boolean before any side effects execute
        // in response to the key or pointer event as they might depend on this value.
        const handleKeyDown = ()=>{
            isUsingKeyboardRef.current = true;
            document.addEventListener('pointerdown', handlePointer, {
                capture: true,
                once: true
            });
            document.addEventListener('pointermove', handlePointer, {
                capture: true,
                once: true
            });
        };
        const handlePointer = ()=>isUsingKeyboardRef.current = false
        ;
        document.addEventListener('keydown', handleKeyDown, {
            capture: true
        });
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown, {
                capture: true
            });
            document.removeEventListener('pointerdown', handlePointer, {
                capture: true
            });
            document.removeEventListener('pointermove', handlePointer, {
                capture: true
            });
        };
    }, []);
    return /*#__PURE__*/ createElement($cf1ac5d9fe0e8206$export$be92b6f5f03c0fe9, popperScope, /*#__PURE__*/ createElement($6cc32821e9371a1c$var$MenuProvider, {
        scope: __scopeMenu,
        open: open,
        onOpenChange: handleOpenChange,
        content: content,
        onContentChange: setContent
    }, /*#__PURE__*/ createElement($6cc32821e9371a1c$var$MenuRootProvider, {
        scope: __scopeMenu,
        onClose: useCallback(()=>handleOpenChange(false)
        , [
            handleOpenChange
        ]),
        isUsingKeyboardRef: isUsingKeyboardRef,
        dir: direction,
        modal: modal
    }, children)));
};
const $6cc32821e9371a1c$export$9fa5ebd18bee4d43 = /*#__PURE__*/ forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu , ...anchorProps } = props;
    const popperScope = $6cc32821e9371a1c$var$usePopperScope(__scopeMenu);
    return /*#__PURE__*/ createElement($cf1ac5d9fe0e8206$export$b688253958b8dfe7, _extends({}, popperScope, anchorProps, {
        ref: forwardedRef
    }));
});
/* -------------------------------------------------------------------------------------------------
 * MenuPortal
 * -----------------------------------------------------------------------------------------------*/ const $6cc32821e9371a1c$var$PORTAL_NAME = 'MenuPortal';
const [$6cc32821e9371a1c$var$PortalProvider, $6cc32821e9371a1c$var$usePortalContext] = $6cc32821e9371a1c$var$createMenuContext($6cc32821e9371a1c$var$PORTAL_NAME, {
    forceMount: undefined
});
/* -------------------------------------------------------------------------------------------------
 * MenuContent
 * -----------------------------------------------------------------------------------------------*/ const $6cc32821e9371a1c$var$CONTENT_NAME = 'MenuContent';
const [$6cc32821e9371a1c$var$MenuContentProvider, $6cc32821e9371a1c$var$useMenuContentContext] = $6cc32821e9371a1c$var$createMenuContext($6cc32821e9371a1c$var$CONTENT_NAME);
const $6cc32821e9371a1c$export$479f0f2f71193efe = /*#__PURE__*/ forwardRef((props, forwardedRef)=>{
    const portalContext = $6cc32821e9371a1c$var$usePortalContext($6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    const { forceMount: forceMount = portalContext.forceMount , ...contentProps } = props;
    const context = $6cc32821e9371a1c$var$useMenuContext($6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    const rootContext = $6cc32821e9371a1c$var$useMenuRootContext($6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    return /*#__PURE__*/ createElement($6cc32821e9371a1c$var$Collection.Provider, {
        scope: props.__scopeMenu
    }, /*#__PURE__*/ createElement($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
        present: forceMount || context.open
    }, /*#__PURE__*/ createElement($6cc32821e9371a1c$var$Collection.Slot, {
        scope: props.__scopeMenu
    }, rootContext.modal ? /*#__PURE__*/ createElement($6cc32821e9371a1c$var$MenuRootContentModal, _extends({}, contentProps, {
        ref: forwardedRef
    })) : /*#__PURE__*/ createElement($6cc32821e9371a1c$var$MenuRootContentNonModal, _extends({}, contentProps, {
        ref: forwardedRef
    })))));
});
/* ---------------------------------------------------------------------------------------------- */ const $6cc32821e9371a1c$var$MenuRootContentModal = /*#__PURE__*/ forwardRef((props, forwardedRef)=>{
    const context = $6cc32821e9371a1c$var$useMenuContext($6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    const ref = useRef(null);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref); // Hide everything from ARIA except the `MenuContent`
    useEffect(()=>{
        const content = ref.current;
        if (content) return hideOthers(content);
    }, []);
    return /*#__PURE__*/ createElement($6cc32821e9371a1c$var$MenuContentImpl, _extends({}, props, {
        ref: composedRefs // we make sure we're not trapping once it's been closed
        ,
        trapFocus: context.open // make sure to only disable pointer events when open
        ,
        disableOutsidePointerEvents: context.open,
        disableOutsideScroll: true // When focus is trapped, a `focusout` event may still happen.
        ,
        onFocusOutside: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onFocusOutside, (event)=>event.preventDefault()
        , {
            checkForDefaultPrevented: false
        }),
        onDismiss: ()=>context.onOpenChange(false)
    }));
});
const $6cc32821e9371a1c$var$MenuRootContentNonModal = /*#__PURE__*/ forwardRef((props, forwardedRef)=>{
    const context = $6cc32821e9371a1c$var$useMenuContext($6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    return /*#__PURE__*/ createElement($6cc32821e9371a1c$var$MenuContentImpl, _extends({}, props, {
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        disableOutsideScroll: false,
        onDismiss: ()=>context.onOpenChange(false)
    }));
});
/* ---------------------------------------------------------------------------------------------- */ const $6cc32821e9371a1c$var$MenuContentImpl = /*#__PURE__*/ forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu , loop: loop = false , trapFocus: trapFocus , onOpenAutoFocus: onOpenAutoFocus , onCloseAutoFocus: onCloseAutoFocus , disableOutsidePointerEvents: disableOutsidePointerEvents , onEntryFocus: onEntryFocus , onEscapeKeyDown: onEscapeKeyDown , onPointerDownOutside: onPointerDownOutside , onFocusOutside: onFocusOutside , onInteractOutside: onInteractOutside , onDismiss: onDismiss , disableOutsideScroll: disableOutsideScroll , ...contentProps } = props;
    const context = $6cc32821e9371a1c$var$useMenuContext($6cc32821e9371a1c$var$CONTENT_NAME, __scopeMenu);
    const rootContext = $6cc32821e9371a1c$var$useMenuRootContext($6cc32821e9371a1c$var$CONTENT_NAME, __scopeMenu);
    const popperScope = $6cc32821e9371a1c$var$usePopperScope(__scopeMenu);
    const rovingFocusGroupScope = $6cc32821e9371a1c$var$useRovingFocusGroupScope(__scopeMenu);
    const getItems = $6cc32821e9371a1c$var$useCollection(__scopeMenu);
    const [currentItemId, setCurrentItemId] = useState(null);
    const contentRef = useRef(null);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, contentRef, context.onContentChange);
    const timerRef = useRef(0);
    const searchRef = useRef('');
    const pointerGraceTimerRef = useRef(0);
    const pointerGraceIntentRef = useRef(null);
    const pointerDirRef = useRef('right');
    const lastPointerXRef = useRef(0);
    const ScrollLockWrapper = disableOutsideScroll ? $am6gm$RemoveScroll : Fragment$1;
    const scrollLockWrapperProps = disableOutsideScroll ? {
        as: $5e63c961fc1ce211$export$8c6ed5c666ac1360,
        allowPinchZoom: true
    } : undefined;
    const handleTypeaheadSearch = (key)=>{
        var _items$find, _items$find2;
        const search = searchRef.current + key;
        const items = getItems().filter((item)=>!item.disabled
        );
        const currentItem = document.activeElement;
        const currentMatch = (_items$find = items.find((item)=>item.ref.current === currentItem
        )) === null || _items$find === void 0 ? void 0 : _items$find.textValue;
        const values = items.map((item)=>item.textValue
        );
        const nextMatch = $6cc32821e9371a1c$var$getNextMatch(values, search, currentMatch);
        const newItem = (_items$find2 = items.find((item)=>item.textValue === nextMatch
        )) === null || _items$find2 === void 0 ? void 0 : _items$find2.ref.current; // Reset `searchRef` 1 second after it was last updated
        (function updateSearch(value) {
            searchRef.current = value;
            window.clearTimeout(timerRef.current);
            if (value !== '') timerRef.current = window.setTimeout(()=>updateSearch('')
            , 1000);
        })(search);
        if (newItem) /**
       * Imperative focus during keydown is risky so we prevent React's batching updates
       * to avoid potential bugs. See: https://github.com/facebook/react/issues/20332
       */ setTimeout(()=>newItem.focus()
        );
    };
    useEffect(()=>{
        return ()=>window.clearTimeout(timerRef.current)
        ;
    }, []); // Make sure the whole tree has focus guards as our `MenuContent` may be
    // the last element in the DOM (beacuse of the `Portal`)
    $3db38b7d1fb3fe6a$export$b7ece24a22aeda8c();
    const isPointerMovingToSubmenu = useCallback((event)=>{
        var _pointerGraceIntentRe, _pointerGraceIntentRe2;
        const isMovingTowards = pointerDirRef.current === ((_pointerGraceIntentRe = pointerGraceIntentRef.current) === null || _pointerGraceIntentRe === void 0 ? void 0 : _pointerGraceIntentRe.side);
        return isMovingTowards && $6cc32821e9371a1c$var$isPointerInGraceArea(event, (_pointerGraceIntentRe2 = pointerGraceIntentRef.current) === null || _pointerGraceIntentRe2 === void 0 ? void 0 : _pointerGraceIntentRe2.area);
    }, []);
    return /*#__PURE__*/ createElement($6cc32821e9371a1c$var$MenuContentProvider, {
        scope: __scopeMenu,
        searchRef: searchRef,
        onItemEnter: useCallback((event)=>{
            if (isPointerMovingToSubmenu(event)) event.preventDefault();
        }, [
            isPointerMovingToSubmenu
        ]),
        onItemLeave: useCallback((event)=>{
            var _contentRef$current;
            if (isPointerMovingToSubmenu(event)) return;
            (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 || _contentRef$current.focus();
            setCurrentItemId(null);
        }, [
            isPointerMovingToSubmenu
        ]),
        onTriggerLeave: useCallback((event)=>{
            if (isPointerMovingToSubmenu(event)) event.preventDefault();
        }, [
            isPointerMovingToSubmenu
        ]),
        pointerGraceTimerRef: pointerGraceTimerRef,
        onPointerGraceIntentChange: useCallback((intent)=>{
            pointerGraceIntentRef.current = intent;
        }, [])
    }, /*#__PURE__*/ createElement(ScrollLockWrapper, scrollLockWrapperProps, /*#__PURE__*/ createElement($d3863c46a17e8a28$export$20e40289641fbbb6, {
        asChild: true,
        trapped: trapFocus,
        onMountAutoFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(onOpenAutoFocus, (event)=>{
            var _contentRef$current2;
            // when opening, explicitly focus the content area only and leave
            // `onEntryFocus` in  control of focusing first item
            event.preventDefault();
            (_contentRef$current2 = contentRef.current) === null || _contentRef$current2 === void 0 || _contentRef$current2.focus();
        }),
        onUnmountAutoFocus: onCloseAutoFocus
    }, /*#__PURE__*/ createElement($5cb92bef7577960e$export$177fb62ff3ec1f22, {
        asChild: true,
        disableOutsidePointerEvents: disableOutsidePointerEvents,
        onEscapeKeyDown: onEscapeKeyDown,
        onPointerDownOutside: onPointerDownOutside,
        onFocusOutside: onFocusOutside,
        onInteractOutside: onInteractOutside,
        onDismiss: onDismiss
    }, /*#__PURE__*/ createElement($d7bdfb9eb0fdf311$export$be92b6f5f03c0fe9, _extends({
        asChild: true
    }, rovingFocusGroupScope, {
        dir: rootContext.dir,
        orientation: "vertical",
        loop: loop,
        currentTabStopId: currentItemId,
        onCurrentTabStopIdChange: setCurrentItemId,
        onEntryFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(onEntryFocus, (event)=>{
            // only focus first item when using keyboard
            if (!rootContext.isUsingKeyboardRef.current) event.preventDefault();
        })
    }), /*#__PURE__*/ createElement($cf1ac5d9fe0e8206$export$7c6e2c02157bb7d2, _extends({
        role: "menu",
        "aria-orientation": "vertical",
        "data-state": $6cc32821e9371a1c$var$getOpenState(context.open),
        "data-radix-menu-content": "",
        dir: rootContext.dir
    }, popperScope, contentProps, {
        ref: composedRefs,
        style: {
            outline: 'none',
            ...contentProps.style
        },
        onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(contentProps.onKeyDown, (event)=>{
            // submenu key events bubble through portals. We only care about keys in this menu.
            const target = event.target;
            const isKeyDownInside = target.closest('[data-radix-menu-content]') === event.currentTarget;
            const isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
            const isCharacterKey = event.key.length === 1;
            if (isKeyDownInside) {
                // menus should not be navigated using tab key so we prevent it
                if (event.key === 'Tab') event.preventDefault();
                if (!isModifierKey && isCharacterKey) handleTypeaheadSearch(event.key);
            } // focus first/last item based on key pressed
            const content = contentRef.current;
            if (event.target !== content) return;
            if (!$6cc32821e9371a1c$var$FIRST_LAST_KEYS.includes(event.key)) return;
            event.preventDefault();
            const items = getItems().filter((item)=>!item.disabled
            );
            const candidateNodes = items.map((item)=>item.ref.current
            );
            if ($6cc32821e9371a1c$var$LAST_KEYS.includes(event.key)) candidateNodes.reverse();
            $6cc32821e9371a1c$var$focusFirst(candidateNodes);
        }),
        onBlur: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onBlur, (event)=>{
            // clear search buffer when leaving the menu
            if (!event.currentTarget.contains(event.target)) {
                window.clearTimeout(timerRef.current);
                searchRef.current = '';
            }
        }),
        onPointerMove: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerMove, $6cc32821e9371a1c$var$whenMouse((event)=>{
            const target = event.target;
            const pointerXHasChanged = lastPointerXRef.current !== event.clientX; // We don't use `event.movementX` for this check because Safari will
            // always return `0` on a pointer event.
            if (event.currentTarget.contains(target) && pointerXHasChanged) {
                const newDir = event.clientX > lastPointerXRef.current ? 'right' : 'left';
                pointerDirRef.current = newDir;
                lastPointerXRef.current = event.clientX;
            }
        }))
    })))))));
});
/* -------------------------------------------------------------------------------------------------
 * MenuItem
 * -----------------------------------------------------------------------------------------------*/ const $6cc32821e9371a1c$var$ITEM_NAME = 'MenuItem';
const $6cc32821e9371a1c$var$ITEM_SELECT = 'menu.itemSelect';
const $6cc32821e9371a1c$export$2ce376c2cc3355c8 = /*#__PURE__*/ forwardRef((props, forwardedRef)=>{
    const { disabled: disabled = false , onSelect: onSelect , ...itemProps } = props;
    const ref = useRef(null);
    const rootContext = $6cc32821e9371a1c$var$useMenuRootContext($6cc32821e9371a1c$var$ITEM_NAME, props.__scopeMenu);
    const contentContext = $6cc32821e9371a1c$var$useMenuContentContext($6cc32821e9371a1c$var$ITEM_NAME, props.__scopeMenu);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
    const isPointerDownRef = useRef(false);
    const handleSelect = ()=>{
        const menuItem = ref.current;
        if (!disabled && menuItem) {
            const itemSelectEvent = new CustomEvent($6cc32821e9371a1c$var$ITEM_SELECT, {
                bubbles: true,
                cancelable: true
            });
            menuItem.addEventListener($6cc32821e9371a1c$var$ITEM_SELECT, (event)=>onSelect === null || onSelect === void 0 ? void 0 : onSelect(event)
            , {
                once: true
            });
            $8927f6f2acc4f386$export$6d1a0317bde7de7f(menuItem, itemSelectEvent);
            if (itemSelectEvent.defaultPrevented) isPointerDownRef.current = false;
            else rootContext.onClose();
        }
    };
    return /*#__PURE__*/ createElement($6cc32821e9371a1c$var$MenuItemImpl, _extends({}, itemProps, {
        ref: composedRefs,
        disabled: disabled,
        onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onClick, handleSelect),
        onPointerDown: (event)=>{
            var _props$onPointerDown;
            (_props$onPointerDown = props.onPointerDown) === null || _props$onPointerDown === void 0 || _props$onPointerDown.call(props, event);
            isPointerDownRef.current = true;
        },
        onPointerUp: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerUp, (event)=>{
            var _event$currentTarget;
            // Pointer down can move to a different menu item which should activate it on pointer up.
            // We dispatch a click for selection to allow composition with click based triggers and to
            // prevent Firefox from getting stuck in text selection mode when the menu closes.
            if (!isPointerDownRef.current) (_event$currentTarget = event.currentTarget) === null || _event$currentTarget === void 0 || _event$currentTarget.click();
        }),
        onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onKeyDown, (event)=>{
            const isTypingAhead = contentContext.searchRef.current !== '';
            if (disabled || isTypingAhead && event.key === ' ') return;
            if ($6cc32821e9371a1c$var$SELECTION_KEYS.includes(event.key)) {
                event.currentTarget.click();
                /**
         * We prevent default browser behaviour for selection keys as they should trigger
         * a selection only:
         * - prevents space from scrolling the page.
         * - if keydown causes focus to move, prevents keydown from firing on the new target.
         */ event.preventDefault();
            }
        })
    }));
});
/* ---------------------------------------------------------------------------------------------- */ const $6cc32821e9371a1c$var$MenuItemImpl = /*#__PURE__*/ forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu , disabled: disabled = false , textValue: textValue , ...itemProps } = props;
    const contentContext = $6cc32821e9371a1c$var$useMenuContentContext($6cc32821e9371a1c$var$ITEM_NAME, __scopeMenu);
    const rovingFocusGroupScope = $6cc32821e9371a1c$var$useRovingFocusGroupScope(__scopeMenu);
    const ref = useRef(null);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
    const [isFocused, setIsFocused] = useState(false); // get the item's `.textContent` as default strategy for typeahead `textValue`
    const [textContent, setTextContent] = useState('');
    useEffect(()=>{
        const menuItem = ref.current;
        if (menuItem) {
            var _menuItem$textContent;
            setTextContent(((_menuItem$textContent = menuItem.textContent) !== null && _menuItem$textContent !== void 0 ? _menuItem$textContent : '').trim());
        }
    }, [
        itemProps.children
    ]);
    return /*#__PURE__*/ createElement($6cc32821e9371a1c$var$Collection.ItemSlot, {
        scope: __scopeMenu,
        disabled: disabled,
        textValue: textValue !== null && textValue !== void 0 ? textValue : textContent
    }, /*#__PURE__*/ createElement($d7bdfb9eb0fdf311$export$6d08773d2e66f8f2, _extends({
        asChild: true
    }, rovingFocusGroupScope, {
        focusable: !disabled
    }), /*#__PURE__*/ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends({
        role: "menuitem",
        "data-highlighted": isFocused ? '' : undefined,
        "aria-disabled": disabled || undefined,
        "data-disabled": disabled ? '' : undefined
    }, itemProps, {
        ref: composedRefs,
        onPointerMove: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerMove, $6cc32821e9371a1c$var$whenMouse((event)=>{
            if (disabled) contentContext.onItemLeave(event);
            else {
                contentContext.onItemEnter(event);
                if (!event.defaultPrevented) {
                    const item = event.currentTarget;
                    item.focus();
                }
            }
        })),
        onPointerLeave: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerLeave, $6cc32821e9371a1c$var$whenMouse((event)=>contentContext.onItemLeave(event)
        )),
        onFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onFocus, ()=>setIsFocused(true)
        ),
        onBlur: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onBlur, ()=>setIsFocused(false)
        )
    }))));
});
/* -------------------------------------------------------------------------------------------------
 * MenuRadioGroup
 * -----------------------------------------------------------------------------------------------*/ const $6cc32821e9371a1c$var$RADIO_GROUP_NAME = 'MenuRadioGroup';
$6cc32821e9371a1c$var$createMenuContext($6cc32821e9371a1c$var$RADIO_GROUP_NAME, {
    value: undefined,
    onValueChange: ()=>{}
});
/* -------------------------------------------------------------------------------------------------
 * MenuItemIndicator
 * -----------------------------------------------------------------------------------------------*/ const $6cc32821e9371a1c$var$ITEM_INDICATOR_NAME = 'MenuItemIndicator';
$6cc32821e9371a1c$var$createMenuContext($6cc32821e9371a1c$var$ITEM_INDICATOR_NAME, {
    checked: false
});
/* -------------------------------------------------------------------------------------------------
 * MenuSub
 * -----------------------------------------------------------------------------------------------*/ const $6cc32821e9371a1c$var$SUB_NAME = 'MenuSub';
$6cc32821e9371a1c$var$createMenuContext($6cc32821e9371a1c$var$SUB_NAME);
/* -----------------------------------------------------------------------------------------------*/ function $6cc32821e9371a1c$var$getOpenState(open) {
    return open ? 'open' : 'closed';
}
function $6cc32821e9371a1c$var$focusFirst(candidates) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        // if focus is already where we want to go, we don't want to keep going through the candidates
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus();
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
/**
 * Wraps an array around itself at a given start index
 * Example: `wrapArray(['a', 'b', 'c', 'd'], 2) === ['c', 'd', 'a', 'b']`
 */ function $6cc32821e9371a1c$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]
    );
}
/**
 * This is the "meat" of the typeahead matching logic. It takes in all the values,
 * the search and the current match, and returns the next match (or `undefined`).
 *
 * We normalize the search because if a user has repeatedly pressed a character,
 * we want the exact same behavior as if we only had that one character
 * (ie. cycle through options starting with that character)
 *
 * We also reorder the values by wrapping the array around the current match.
 * This is so we always look forward from the current match, and picking the first
 * match will always be the correct one.
 *
 * Finally, if the normalized search is exactly one character, we exclude the
 * current match from the values because otherwise it would be the first to match always
 * and focus would never move. This is as opposed to the regular case, where we
 * don't want focus to move if the current match still matches.
 */ function $6cc32821e9371a1c$var$getNextMatch(values, search, currentMatch) {
    const isRepeated = search.length > 1 && Array.from(search).every((char)=>char === search[0]
    );
    const normalizedSearch = isRepeated ? search[0] : search;
    const currentMatchIndex = currentMatch ? values.indexOf(currentMatch) : -1;
    let wrappedValues = $6cc32821e9371a1c$var$wrapArray(values, Math.max(currentMatchIndex, 0));
    const excludeCurrentMatch = normalizedSearch.length === 1;
    if (excludeCurrentMatch) wrappedValues = wrappedValues.filter((v)=>v !== currentMatch
    );
    const nextMatch = wrappedValues.find((value)=>value.toLowerCase().startsWith(normalizedSearch.toLowerCase())
    );
    return nextMatch !== currentMatch ? nextMatch : undefined;
}
// Determine if a point is inside of a polygon.
// Based on https://github.com/substack/point-in-polygon
function $6cc32821e9371a1c$var$isPointInPolygon(point, polygon) {
    const { x: x , y: y  } = point;
    let inside = false;
    for(let i = 0, j = polygon.length - 1; i < polygon.length; j = i++){
        const xi = polygon[i].x;
        const yi = polygon[i].y;
        const xj = polygon[j].x;
        const yj = polygon[j].y; // prettier-ignore
        const intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) inside = !inside;
    }
    return inside;
}
function $6cc32821e9371a1c$var$isPointerInGraceArea(event, area) {
    if (!area) return false;
    const cursorPos = {
        x: event.clientX,
        y: event.clientY
    };
    return $6cc32821e9371a1c$var$isPointInPolygon(cursorPos, area);
}
function $6cc32821e9371a1c$var$whenMouse(handler) {
    return (event)=>event.pointerType === 'mouse' ? handler(event) : undefined
    ;
}
const $6cc32821e9371a1c$export$be92b6f5f03c0fe9 = $6cc32821e9371a1c$export$d9b273488cd8ce6f;
const $6cc32821e9371a1c$export$b688253958b8dfe7 = $6cc32821e9371a1c$export$9fa5ebd18bee4d43;
const $6cc32821e9371a1c$export$7c6e2c02157bb7d2 = $6cc32821e9371a1c$export$479f0f2f71193efe;
const $6cc32821e9371a1c$export$6d08773d2e66f8f2 = $6cc32821e9371a1c$export$2ce376c2cc3355c8;

/* -------------------------------------------------------------------------------------------------
 * DropdownMenu
 * -----------------------------------------------------------------------------------------------*/ const $d08ef79370b62062$var$DROPDOWN_MENU_NAME = 'DropdownMenu';
const [$d08ef79370b62062$var$createDropdownMenuContext, $d08ef79370b62062$export$c0623cd925aeb687] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($d08ef79370b62062$var$DROPDOWN_MENU_NAME, [
    $6cc32821e9371a1c$export$4027731b685e72eb
]);
const $d08ef79370b62062$var$useMenuScope = $6cc32821e9371a1c$export$4027731b685e72eb();
const [$d08ef79370b62062$var$DropdownMenuProvider, $d08ef79370b62062$var$useDropdownMenuContext] = $d08ef79370b62062$var$createDropdownMenuContext($d08ef79370b62062$var$DROPDOWN_MENU_NAME);
const $d08ef79370b62062$export$e44a253a59704894 = (props)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu , children: children , dir: dir , open: openProp , defaultOpen: defaultOpen , onOpenChange: onOpenChange , modal: modal = true  } = props;
    const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    const triggerRef = useRef(null);
    const [open = false, setOpen] = $71cd76cc60e0454e$export$6f32135080cb4c3({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ createElement($d08ef79370b62062$var$DropdownMenuProvider, {
        scope: __scopeDropdownMenu,
        triggerId: $1746a345f3d73bb7$export$f680877a34711e37(),
        triggerRef: triggerRef,
        contentId: $1746a345f3d73bb7$export$f680877a34711e37(),
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: useCallback(()=>setOpen((prevOpen)=>!prevOpen
            )
        , [
            setOpen
        ]),
        modal: modal
    }, /*#__PURE__*/ createElement($6cc32821e9371a1c$export$be92b6f5f03c0fe9, _extends({}, menuScope, {
        open: open,
        onOpenChange: setOpen,
        dir: dir,
        modal: modal
    }), children));
};
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuTrigger
 * -----------------------------------------------------------------------------------------------*/ const $d08ef79370b62062$var$TRIGGER_NAME = 'DropdownMenuTrigger';
const $d08ef79370b62062$export$d2469213b3befba9 = /*#__PURE__*/ forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu , disabled: disabled = false , ...triggerProps } = props;
    const context = $d08ef79370b62062$var$useDropdownMenuContext($d08ef79370b62062$var$TRIGGER_NAME, __scopeDropdownMenu);
    const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ createElement($6cc32821e9371a1c$export$b688253958b8dfe7, _extends({
        asChild: true
    }, menuScope), /*#__PURE__*/ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.button, _extends({
        type: "button",
        id: context.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": context.open,
        "aria-controls": context.open ? context.contentId : undefined,
        "data-state": context.open ? 'open' : 'closed',
        "data-disabled": disabled ? '' : undefined,
        disabled: disabled
    }, triggerProps, {
        ref: $6ed0406888f73fc4$export$43e446d32b3d21af(forwardedRef, context.triggerRef),
        onPointerDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerDown, (event)=>{
            // only call handler if it's the left button (mousedown gets triggered by all mouse buttons)
            // but not when the control key is pressed (avoiding MacOS right click)
            if (!disabled && event.button === 0 && event.ctrlKey === false) {
                context.onOpenToggle(); // prevent trigger focusing when opening
                // this allows the content to be given focus without competition
                if (!context.open) event.preventDefault();
            }
        }),
        onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onKeyDown, (event)=>{
            if (disabled) return;
            if ([
                'Enter',
                ' '
            ].includes(event.key)) context.onOpenToggle();
            if (event.key === 'ArrowDown') context.onOpenChange(true); // prevent keydown from scrolling window / first focused item to execute
            // that keydown (inadvertently closing the menu)
            if ([
                'Enter',
                ' ',
                'ArrowDown'
            ].includes(event.key)) event.preventDefault();
        })
    })));
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuContent
 * -----------------------------------------------------------------------------------------------*/ const $d08ef79370b62062$var$CONTENT_NAME = 'DropdownMenuContent';
const $d08ef79370b62062$export$6e76d93a37c01248 = /*#__PURE__*/ forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu , ...contentProps } = props;
    const context = $d08ef79370b62062$var$useDropdownMenuContext($d08ef79370b62062$var$CONTENT_NAME, __scopeDropdownMenu);
    const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    const hasInteractedOutsideRef = useRef(false);
    return /*#__PURE__*/ createElement($6cc32821e9371a1c$export$7c6e2c02157bb7d2, _extends({
        id: context.contentId,
        "aria-labelledby": context.triggerId
    }, menuScope, contentProps, {
        ref: forwardedRef,
        onCloseAutoFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onCloseAutoFocus, (event)=>{
            var _context$triggerRef$c;
            if (!hasInteractedOutsideRef.current) (_context$triggerRef$c = context.triggerRef.current) === null || _context$triggerRef$c === void 0 || _context$triggerRef$c.focus();
            hasInteractedOutsideRef.current = false; // Always prevent auto focus because we either focus manually or want user agent focus
            event.preventDefault();
        }),
        onInteractOutside: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onInteractOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            if (!context.modal || isRightClick) hasInteractedOutsideRef.current = true;
        }),
        style: {
            ...props.style,
            '--radix-dropdown-menu-content-transform-origin': 'var(--radix-popper-transform-origin)',
            '--radix-dropdown-menu-content-available-width': 'var(--radix-popper-available-width)',
            '--radix-dropdown-menu-content-available-height': 'var(--radix-popper-available-height)',
            '--radix-dropdown-menu-trigger-width': 'var(--radix-popper-anchor-width)',
            '--radix-dropdown-menu-trigger-height': 'var(--radix-popper-anchor-height)'
        }
    }));
});
const $d08ef79370b62062$export$ed97964d1871885d = /*#__PURE__*/ forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu , ...itemProps } = props;
    const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ createElement($6cc32821e9371a1c$export$6d08773d2e66f8f2, _extends({}, menuScope, itemProps, {
        ref: forwardedRef
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const $d08ef79370b62062$export$be92b6f5f03c0fe9 = $d08ef79370b62062$export$e44a253a59704894;
const $d08ef79370b62062$export$41fb9f06171c75f4 = $d08ef79370b62062$export$d2469213b3befba9;
const $d08ef79370b62062$export$7c6e2c02157bb7d2 = $d08ef79370b62062$export$6e76d93a37c01248;
const $d08ef79370b62062$export$6d08773d2e66f8f2 = $d08ef79370b62062$export$ed97964d1871885d;

function $ae6933e535247d3d$export$7d15b64cf5a3a4c4(value, [min, max]) {
    return Math.min(max, Math.max(min, value));
}

function $6c2e24571c90391f$export$3e6543de14f8614f(initialState, machine) {
    return useReducer((state, event)=>{
        const nextState = machine[state][event];
        return nextState !== null && nextState !== void 0 ? nextState : state;
    }, initialState);
}


/* -------------------------------------------------------------------------------------------------
 * ScrollArea
 * -----------------------------------------------------------------------------------------------*/ const $57acba87d6e25586$var$SCROLL_AREA_NAME = 'ScrollArea';
const [$57acba87d6e25586$var$createScrollAreaContext, $57acba87d6e25586$export$488468afe3a6f2b1] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($57acba87d6e25586$var$SCROLL_AREA_NAME);
const [$57acba87d6e25586$var$ScrollAreaProvider, $57acba87d6e25586$var$useScrollAreaContext] = $57acba87d6e25586$var$createScrollAreaContext($57acba87d6e25586$var$SCROLL_AREA_NAME);
const $57acba87d6e25586$export$ccf8d8d7bbf3c2cc = /*#__PURE__*/ forwardRef((props, forwardedRef)=>{
    const { __scopeScrollArea: __scopeScrollArea , type: type = 'hover' , dir: dir , scrollHideDelay: scrollHideDelay = 600 , ...scrollAreaProps } = props;
    const [scrollArea, setScrollArea] = useState(null);
    const [viewport, setViewport] = useState(null);
    const [content, setContent] = useState(null);
    const [scrollbarX, setScrollbarX] = useState(null);
    const [scrollbarY, setScrollbarY] = useState(null);
    const [cornerWidth, setCornerWidth] = useState(0);
    const [cornerHeight, setCornerHeight] = useState(0);
    const [scrollbarXEnabled, setScrollbarXEnabled] = useState(false);
    const [scrollbarYEnabled, setScrollbarYEnabled] = useState(false);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, (node)=>setScrollArea(node)
    );
    const direction = $f631663db3294ace$export$b39126d51d94e6f3(dir);
    return /*#__PURE__*/ createElement($57acba87d6e25586$var$ScrollAreaProvider, {
        scope: __scopeScrollArea,
        type: type,
        dir: direction,
        scrollHideDelay: scrollHideDelay,
        scrollArea: scrollArea,
        viewport: viewport,
        onViewportChange: setViewport,
        content: content,
        onContentChange: setContent,
        scrollbarX: scrollbarX,
        onScrollbarXChange: setScrollbarX,
        scrollbarXEnabled: scrollbarXEnabled,
        onScrollbarXEnabledChange: setScrollbarXEnabled,
        scrollbarY: scrollbarY,
        onScrollbarYChange: setScrollbarY,
        scrollbarYEnabled: scrollbarYEnabled,
        onScrollbarYEnabledChange: setScrollbarYEnabled,
        onCornerWidthChange: setCornerWidth,
        onCornerHeightChange: setCornerHeight
    }, /*#__PURE__*/ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends({
        dir: direction
    }, scrollAreaProps, {
        ref: composedRefs,
        style: {
            position: 'relative',
            // Pass corner sizes as CSS vars to reduce re-renders of context consumers
            ['--radix-scroll-area-corner-width']: cornerWidth + 'px',
            ['--radix-scroll-area-corner-height']: cornerHeight + 'px',
            ...props.style
        }
    })));
});
/* -------------------------------------------------------------------------------------------------
 * ScrollAreaViewport
 * -----------------------------------------------------------------------------------------------*/ const $57acba87d6e25586$var$VIEWPORT_NAME = 'ScrollAreaViewport';
const $57acba87d6e25586$export$a21cbf9f11fca853 = /*#__PURE__*/ forwardRef((props, forwardedRef)=>{
    const { __scopeScrollArea: __scopeScrollArea , children: children , ...viewportProps } = props;
    const context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$VIEWPORT_NAME, __scopeScrollArea);
    const ref = useRef(null);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref, context.onViewportChange);
    return /*#__PURE__*/ createElement(Fragment$1, null, /*#__PURE__*/ createElement("style", {
        dangerouslySetInnerHTML: {
            __html: `[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}`
        }
    }), /*#__PURE__*/ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends({
        "data-radix-scroll-area-viewport": ""
    }, viewportProps, {
        ref: composedRefs,
        style: {
            /**
       * We don't support `visible` because the intention is to have at least one scrollbar
       * if this component is used and `visible` will behave like `auto` in that case
       * https://developer.mozilla.org/en-US/docs/Web/CSS/overflowed#description
       *
       * We don't handle `auto` because the intention is for the native implementation
       * to be hidden if using this component. We just want to ensure the node is scrollable
       * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
       * the browser from having to work out whether to render native scrollbars or not,
       * we tell it to with the intention of hiding them in CSS.
       */ overflowX: context.scrollbarXEnabled ? 'scroll' : 'hidden',
            overflowY: context.scrollbarYEnabled ? 'scroll' : 'hidden',
            ...props.style
        }
    }), /*#__PURE__*/ createElement("div", {
        ref: context.onContentChange,
        style: {
            minWidth: '100%',
            display: 'table'
        }
    }, children)));
});
/* -------------------------------------------------------------------------------------------------
 * ScrollAreaScrollbar
 * -----------------------------------------------------------------------------------------------*/ const $57acba87d6e25586$var$SCROLLBAR_NAME = 'ScrollAreaScrollbar';
const $57acba87d6e25586$export$2fabd85d0eba3c57 = /*#__PURE__*/ forwardRef((props, forwardedRef)=>{
    const { forceMount: forceMount , ...scrollbarProps } = props;
    const context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const { onScrollbarXEnabledChange: onScrollbarXEnabledChange , onScrollbarYEnabledChange: onScrollbarYEnabledChange  } = context;
    const isHorizontal = props.orientation === 'horizontal';
    useEffect(()=>{
        isHorizontal ? onScrollbarXEnabledChange(true) : onScrollbarYEnabledChange(true);
        return ()=>{
            isHorizontal ? onScrollbarXEnabledChange(false) : onScrollbarYEnabledChange(false);
        };
    }, [
        isHorizontal,
        onScrollbarXEnabledChange,
        onScrollbarYEnabledChange
    ]);
    return context.type === 'hover' ? /*#__PURE__*/ createElement($57acba87d6e25586$var$ScrollAreaScrollbarHover, _extends({}, scrollbarProps, {
        ref: forwardedRef,
        forceMount: forceMount
    })) : context.type === 'scroll' ? /*#__PURE__*/ createElement($57acba87d6e25586$var$ScrollAreaScrollbarScroll, _extends({}, scrollbarProps, {
        ref: forwardedRef,
        forceMount: forceMount
    })) : context.type === 'auto' ? /*#__PURE__*/ createElement($57acba87d6e25586$var$ScrollAreaScrollbarAuto, _extends({}, scrollbarProps, {
        ref: forwardedRef,
        forceMount: forceMount
    })) : context.type === 'always' ? /*#__PURE__*/ createElement($57acba87d6e25586$var$ScrollAreaScrollbarVisible, _extends({}, scrollbarProps, {
        ref: forwardedRef
    })) : null;
});
/* -----------------------------------------------------------------------------------------------*/ const $57acba87d6e25586$var$ScrollAreaScrollbarHover = /*#__PURE__*/ forwardRef((props, forwardedRef)=>{
    const { forceMount: forceMount , ...scrollbarProps } = props;
    const context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const [visible, setVisible] = useState(false);
    useEffect(()=>{
        const scrollArea = context.scrollArea;
        let hideTimer = 0;
        if (scrollArea) {
            const handlePointerEnter = ()=>{
                window.clearTimeout(hideTimer);
                setVisible(true);
            };
            const handlePointerLeave = ()=>{
                hideTimer = window.setTimeout(()=>setVisible(false)
                , context.scrollHideDelay);
            };
            scrollArea.addEventListener('pointerenter', handlePointerEnter);
            scrollArea.addEventListener('pointerleave', handlePointerLeave);
            return ()=>{
                window.clearTimeout(hideTimer);
                scrollArea.removeEventListener('pointerenter', handlePointerEnter);
                scrollArea.removeEventListener('pointerleave', handlePointerLeave);
            };
        }
    }, [
        context.scrollArea,
        context.scrollHideDelay
    ]);
    return /*#__PURE__*/ createElement($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
        present: forceMount || visible
    }, /*#__PURE__*/ createElement($57acba87d6e25586$var$ScrollAreaScrollbarAuto, _extends({
        "data-state": visible ? 'visible' : 'hidden'
    }, scrollbarProps, {
        ref: forwardedRef
    })));
});
const $57acba87d6e25586$var$ScrollAreaScrollbarScroll = /*#__PURE__*/ forwardRef((props, forwardedRef)=>{
    const { forceMount: forceMount , ...scrollbarProps } = props;
    const context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const isHorizontal = props.orientation === 'horizontal';
    const debounceScrollEnd = $57acba87d6e25586$var$useDebounceCallback(()=>send('SCROLL_END')
    , 100);
    const [state, send] = $6c2e24571c90391f$export$3e6543de14f8614f('hidden', {
        hidden: {
            SCROLL: 'scrolling'
        },
        scrolling: {
            SCROLL_END: 'idle',
            POINTER_ENTER: 'interacting'
        },
        interacting: {
            SCROLL: 'interacting',
            POINTER_LEAVE: 'idle'
        },
        idle: {
            HIDE: 'hidden',
            SCROLL: 'scrolling',
            POINTER_ENTER: 'interacting'
        }
    });
    useEffect(()=>{
        if (state === 'idle') {
            const hideTimer = window.setTimeout(()=>send('HIDE')
            , context.scrollHideDelay);
            return ()=>window.clearTimeout(hideTimer)
            ;
        }
    }, [
        state,
        context.scrollHideDelay,
        send
    ]);
    useEffect(()=>{
        const viewport = context.viewport;
        const scrollDirection = isHorizontal ? 'scrollLeft' : 'scrollTop';
        if (viewport) {
            let prevScrollPos = viewport[scrollDirection];
            const handleScroll = ()=>{
                const scrollPos = viewport[scrollDirection];
                const hasScrollInDirectionChanged = prevScrollPos !== scrollPos;
                if (hasScrollInDirectionChanged) {
                    send('SCROLL');
                    debounceScrollEnd();
                }
                prevScrollPos = scrollPos;
            };
            viewport.addEventListener('scroll', handleScroll);
            return ()=>viewport.removeEventListener('scroll', handleScroll)
            ;
        }
    }, [
        context.viewport,
        isHorizontal,
        send,
        debounceScrollEnd
    ]);
    return /*#__PURE__*/ createElement($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
        present: forceMount || state !== 'hidden'
    }, /*#__PURE__*/ createElement($57acba87d6e25586$var$ScrollAreaScrollbarVisible, _extends({
        "data-state": state === 'hidden' ? 'hidden' : 'visible'
    }, scrollbarProps, {
        ref: forwardedRef,
        onPointerEnter: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerEnter, ()=>send('POINTER_ENTER')
        ),
        onPointerLeave: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerLeave, ()=>send('POINTER_LEAVE')
        )
    })));
});
const $57acba87d6e25586$var$ScrollAreaScrollbarAuto = /*#__PURE__*/ forwardRef((props, forwardedRef)=>{
    const context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const { forceMount: forceMount , ...scrollbarProps } = props;
    const [visible, setVisible] = useState(false);
    const isHorizontal = props.orientation === 'horizontal';
    const handleResize = $57acba87d6e25586$var$useDebounceCallback(()=>{
        if (context.viewport) {
            const isOverflowX = context.viewport.offsetWidth < context.viewport.scrollWidth;
            const isOverflowY = context.viewport.offsetHeight < context.viewport.scrollHeight;
            setVisible(isHorizontal ? isOverflowX : isOverflowY);
        }
    }, 10);
    $57acba87d6e25586$var$useResizeObserver(context.viewport, handleResize);
    $57acba87d6e25586$var$useResizeObserver(context.content, handleResize);
    return /*#__PURE__*/ createElement($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
        present: forceMount || visible
    }, /*#__PURE__*/ createElement($57acba87d6e25586$var$ScrollAreaScrollbarVisible, _extends({
        "data-state": visible ? 'visible' : 'hidden'
    }, scrollbarProps, {
        ref: forwardedRef
    })));
});
/* -----------------------------------------------------------------------------------------------*/ const $57acba87d6e25586$var$ScrollAreaScrollbarVisible = /*#__PURE__*/ forwardRef((props, forwardedRef)=>{
    const { orientation: orientation = 'vertical' , ...scrollbarProps } = props;
    const context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const thumbRef = useRef(null);
    const pointerOffsetRef = useRef(0);
    const [sizes, setSizes] = useState({
        content: 0,
        viewport: 0,
        scrollbar: {
            size: 0,
            paddingStart: 0,
            paddingEnd: 0
        }
    });
    const thumbRatio = $57acba87d6e25586$var$getThumbRatio(sizes.viewport, sizes.content);
    const commonProps = {
        ...scrollbarProps,
        sizes: sizes,
        onSizesChange: setSizes,
        hasThumb: Boolean(thumbRatio > 0 && thumbRatio < 1),
        onThumbChange: (thumb)=>thumbRef.current = thumb
        ,
        onThumbPointerUp: ()=>pointerOffsetRef.current = 0
        ,
        onThumbPointerDown: (pointerPos)=>pointerOffsetRef.current = pointerPos
    };
    function getScrollPosition(pointerPos, dir) {
        return $57acba87d6e25586$var$getScrollPositionFromPointer(pointerPos, pointerOffsetRef.current, sizes, dir);
    }
    if (orientation === 'horizontal') return /*#__PURE__*/ createElement($57acba87d6e25586$var$ScrollAreaScrollbarX, _extends({}, commonProps, {
        ref: forwardedRef,
        onThumbPositionChange: ()=>{
            if (context.viewport && thumbRef.current) {
                const scrollPos = context.viewport.scrollLeft;
                const offset = $57acba87d6e25586$var$getThumbOffsetFromScroll(scrollPos, sizes, context.dir);
                thumbRef.current.style.transform = `translate3d(${offset}px, 0, 0)`;
            }
        },
        onWheelScroll: (scrollPos)=>{
            if (context.viewport) context.viewport.scrollLeft = scrollPos;
        },
        onDragScroll: (pointerPos)=>{
            if (context.viewport) context.viewport.scrollLeft = getScrollPosition(pointerPos, context.dir);
        }
    }));
    if (orientation === 'vertical') return /*#__PURE__*/ createElement($57acba87d6e25586$var$ScrollAreaScrollbarY, _extends({}, commonProps, {
        ref: forwardedRef,
        onThumbPositionChange: ()=>{
            if (context.viewport && thumbRef.current) {
                const scrollPos = context.viewport.scrollTop;
                const offset = $57acba87d6e25586$var$getThumbOffsetFromScroll(scrollPos, sizes);
                thumbRef.current.style.transform = `translate3d(0, ${offset}px, 0)`;
            }
        },
        onWheelScroll: (scrollPos)=>{
            if (context.viewport) context.viewport.scrollTop = scrollPos;
        },
        onDragScroll: (pointerPos)=>{
            if (context.viewport) context.viewport.scrollTop = getScrollPosition(pointerPos);
        }
    }));
    return null;
});
/* -----------------------------------------------------------------------------------------------*/ const $57acba87d6e25586$var$ScrollAreaScrollbarX = /*#__PURE__*/ forwardRef((props, forwardedRef)=>{
    const { sizes: sizes , onSizesChange: onSizesChange , ...scrollbarProps } = props;
    const context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const [computedStyle, setComputedStyle] = useState();
    const ref = useRef(null);
    const composeRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref, context.onScrollbarXChange);
    useEffect(()=>{
        if (ref.current) setComputedStyle(getComputedStyle(ref.current));
    }, [
        ref
    ]);
    return /*#__PURE__*/ createElement($57acba87d6e25586$var$ScrollAreaScrollbarImpl, _extends({
        "data-orientation": "horizontal"
    }, scrollbarProps, {
        ref: composeRefs,
        sizes: sizes,
        style: {
            bottom: 0,
            left: context.dir === 'rtl' ? 'var(--radix-scroll-area-corner-width)' : 0,
            right: context.dir === 'ltr' ? 'var(--radix-scroll-area-corner-width)' : 0,
            ['--radix-scroll-area-thumb-width']: $57acba87d6e25586$var$getThumbSize(sizes) + 'px',
            ...props.style
        },
        onThumbPointerDown: (pointerPos)=>props.onThumbPointerDown(pointerPos.x)
        ,
        onDragScroll: (pointerPos)=>props.onDragScroll(pointerPos.x)
        ,
        onWheelScroll: (event, maxScrollPos)=>{
            if (context.viewport) {
                const scrollPos = context.viewport.scrollLeft + event.deltaX;
                props.onWheelScroll(scrollPos); // prevent window scroll when wheeling on scrollbar
                if ($57acba87d6e25586$var$isScrollingWithinScrollbarBounds(scrollPos, maxScrollPos)) event.preventDefault();
            }
        },
        onResize: ()=>{
            if (ref.current && context.viewport && computedStyle) onSizesChange({
                content: context.viewport.scrollWidth,
                viewport: context.viewport.offsetWidth,
                scrollbar: {
                    size: ref.current.clientWidth,
                    paddingStart: $57acba87d6e25586$var$toInt(computedStyle.paddingLeft),
                    paddingEnd: $57acba87d6e25586$var$toInt(computedStyle.paddingRight)
                }
            });
        }
    }));
});
const $57acba87d6e25586$var$ScrollAreaScrollbarY = /*#__PURE__*/ forwardRef((props, forwardedRef)=>{
    const { sizes: sizes , onSizesChange: onSizesChange , ...scrollbarProps } = props;
    const context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const [computedStyle, setComputedStyle] = useState();
    const ref = useRef(null);
    const composeRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref, context.onScrollbarYChange);
    useEffect(()=>{
        if (ref.current) setComputedStyle(getComputedStyle(ref.current));
    }, [
        ref
    ]);
    return /*#__PURE__*/ createElement($57acba87d6e25586$var$ScrollAreaScrollbarImpl, _extends({
        "data-orientation": "vertical"
    }, scrollbarProps, {
        ref: composeRefs,
        sizes: sizes,
        style: {
            top: 0,
            right: context.dir === 'ltr' ? 0 : undefined,
            left: context.dir === 'rtl' ? 0 : undefined,
            bottom: 'var(--radix-scroll-area-corner-height)',
            ['--radix-scroll-area-thumb-height']: $57acba87d6e25586$var$getThumbSize(sizes) + 'px',
            ...props.style
        },
        onThumbPointerDown: (pointerPos)=>props.onThumbPointerDown(pointerPos.y)
        ,
        onDragScroll: (pointerPos)=>props.onDragScroll(pointerPos.y)
        ,
        onWheelScroll: (event, maxScrollPos)=>{
            if (context.viewport) {
                const scrollPos = context.viewport.scrollTop + event.deltaY;
                props.onWheelScroll(scrollPos); // prevent window scroll when wheeling on scrollbar
                if ($57acba87d6e25586$var$isScrollingWithinScrollbarBounds(scrollPos, maxScrollPos)) event.preventDefault();
            }
        },
        onResize: ()=>{
            if (ref.current && context.viewport && computedStyle) onSizesChange({
                content: context.viewport.scrollHeight,
                viewport: context.viewport.offsetHeight,
                scrollbar: {
                    size: ref.current.clientHeight,
                    paddingStart: $57acba87d6e25586$var$toInt(computedStyle.paddingTop),
                    paddingEnd: $57acba87d6e25586$var$toInt(computedStyle.paddingBottom)
                }
            });
        }
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const [$57acba87d6e25586$var$ScrollbarProvider, $57acba87d6e25586$var$useScrollbarContext] = $57acba87d6e25586$var$createScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME);
const $57acba87d6e25586$var$ScrollAreaScrollbarImpl = /*#__PURE__*/ forwardRef((props, forwardedRef)=>{
    const { __scopeScrollArea: __scopeScrollArea , sizes: sizes , hasThumb: hasThumb , onThumbChange: onThumbChange , onThumbPointerUp: onThumbPointerUp , onThumbPointerDown: onThumbPointerDown , onThumbPositionChange: onThumbPositionChange , onDragScroll: onDragScroll , onWheelScroll: onWheelScroll , onResize: onResize , ...scrollbarProps } = props;
    const context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, __scopeScrollArea);
    const [scrollbar, setScrollbar] = useState(null);
    const composeRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, (node)=>setScrollbar(node)
    );
    const rectRef = useRef(null);
    const prevWebkitUserSelectRef = useRef('');
    const viewport = context.viewport;
    const maxScrollPos = sizes.content - sizes.viewport;
    const handleWheelScroll = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onWheelScroll);
    const handleThumbPositionChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onThumbPositionChange);
    const handleResize = $57acba87d6e25586$var$useDebounceCallback(onResize, 10);
    function handleDragScroll(event) {
        if (rectRef.current) {
            const x = event.clientX - rectRef.current.left;
            const y = event.clientY - rectRef.current.top;
            onDragScroll({
                x: x,
                y: y
            });
        }
    }
    /**
   * We bind wheel event imperatively so we can switch off passive
   * mode for document wheel event to allow it to be prevented
   */ useEffect(()=>{
        const handleWheel = (event)=>{
            const element = event.target;
            const isScrollbarWheel = scrollbar === null || scrollbar === void 0 ? void 0 : scrollbar.contains(element);
            if (isScrollbarWheel) handleWheelScroll(event, maxScrollPos);
        };
        document.addEventListener('wheel', handleWheel, {
            passive: false
        });
        return ()=>document.removeEventListener('wheel', handleWheel, {
                passive: false
            })
        ;
    }, [
        viewport,
        scrollbar,
        maxScrollPos,
        handleWheelScroll
    ]);
    /**
   * Update thumb position on sizes change
   */ useEffect(handleThumbPositionChange, [
        sizes,
        handleThumbPositionChange
    ]);
    $57acba87d6e25586$var$useResizeObserver(scrollbar, handleResize);
    $57acba87d6e25586$var$useResizeObserver(context.content, handleResize);
    return /*#__PURE__*/ createElement($57acba87d6e25586$var$ScrollbarProvider, {
        scope: __scopeScrollArea,
        scrollbar: scrollbar,
        hasThumb: hasThumb,
        onThumbChange: $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onThumbChange),
        onThumbPointerUp: $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onThumbPointerUp),
        onThumbPositionChange: handleThumbPositionChange,
        onThumbPointerDown: $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onThumbPointerDown)
    }, /*#__PURE__*/ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends({}, scrollbarProps, {
        ref: composeRefs,
        style: {
            position: 'absolute',
            ...scrollbarProps.style
        },
        onPointerDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerDown, (event)=>{
            const mainPointer = 0;
            if (event.button === mainPointer) {
                const element = event.target;
                element.setPointerCapture(event.pointerId);
                rectRef.current = scrollbar.getBoundingClientRect(); // pointer capture doesn't prevent text selection in Safari
                // so we remove text selection manually when scrolling
                prevWebkitUserSelectRef.current = document.body.style.webkitUserSelect;
                document.body.style.webkitUserSelect = 'none';
                if (context.viewport) context.viewport.style.scrollBehavior = 'auto';
                handleDragScroll(event);
            }
        }),
        onPointerMove: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerMove, handleDragScroll),
        onPointerUp: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerUp, (event)=>{
            const element = event.target;
            if (element.hasPointerCapture(event.pointerId)) element.releasePointerCapture(event.pointerId);
            document.body.style.webkitUserSelect = prevWebkitUserSelectRef.current;
            if (context.viewport) context.viewport.style.scrollBehavior = '';
            rectRef.current = null;
        })
    })));
});
/* -------------------------------------------------------------------------------------------------
 * ScrollAreaThumb
 * -----------------------------------------------------------------------------------------------*/ const $57acba87d6e25586$var$THUMB_NAME = 'ScrollAreaThumb';
const $57acba87d6e25586$export$9fba1154677d7cd2 = /*#__PURE__*/ forwardRef((props, forwardedRef)=>{
    const { forceMount: forceMount , ...thumbProps } = props;
    const scrollbarContext = $57acba87d6e25586$var$useScrollbarContext($57acba87d6e25586$var$THUMB_NAME, props.__scopeScrollArea);
    return /*#__PURE__*/ createElement($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
        present: forceMount || scrollbarContext.hasThumb
    }, /*#__PURE__*/ createElement($57acba87d6e25586$var$ScrollAreaThumbImpl, _extends({
        ref: forwardedRef
    }, thumbProps)));
});
const $57acba87d6e25586$var$ScrollAreaThumbImpl = /*#__PURE__*/ forwardRef((props, forwardedRef)=>{
    const { __scopeScrollArea: __scopeScrollArea , style: style , ...thumbProps } = props;
    const scrollAreaContext = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$THUMB_NAME, __scopeScrollArea);
    const scrollbarContext = $57acba87d6e25586$var$useScrollbarContext($57acba87d6e25586$var$THUMB_NAME, __scopeScrollArea);
    const { onThumbPositionChange: onThumbPositionChange  } = scrollbarContext;
    const composedRef = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, (node)=>scrollbarContext.onThumbChange(node)
    );
    const removeUnlinkedScrollListenerRef = useRef();
    const debounceScrollEnd = $57acba87d6e25586$var$useDebounceCallback(()=>{
        if (removeUnlinkedScrollListenerRef.current) {
            removeUnlinkedScrollListenerRef.current();
            removeUnlinkedScrollListenerRef.current = undefined;
        }
    }, 100);
    useEffect(()=>{
        const viewport = scrollAreaContext.viewport;
        if (viewport) {
            /**
       * We only bind to native scroll event so we know when scroll starts and ends.
       * When scroll starts we start a requestAnimationFrame loop that checks for
       * changes to scroll position. That rAF loop triggers our thumb position change
       * when relevant to avoid scroll-linked effects. We cancel the loop when scroll ends.
       * https://developer.mozilla.org/en-US/docs/Mozilla/Performance/Scroll-linked_effects
       */ const handleScroll = ()=>{
                debounceScrollEnd();
                if (!removeUnlinkedScrollListenerRef.current) {
                    const listener = $57acba87d6e25586$var$addUnlinkedScrollListener(viewport, onThumbPositionChange);
                    removeUnlinkedScrollListenerRef.current = listener;
                    onThumbPositionChange();
                }
            };
            onThumbPositionChange();
            viewport.addEventListener('scroll', handleScroll);
            return ()=>viewport.removeEventListener('scroll', handleScroll)
            ;
        }
    }, [
        scrollAreaContext.viewport,
        debounceScrollEnd,
        onThumbPositionChange
    ]);
    return /*#__PURE__*/ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends({
        "data-state": scrollbarContext.hasThumb ? 'visible' : 'hidden'
    }, thumbProps, {
        ref: composedRef,
        style: {
            width: 'var(--radix-scroll-area-thumb-width)',
            height: 'var(--radix-scroll-area-thumb-height)',
            ...style
        },
        onPointerDownCapture: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerDownCapture, (event)=>{
            const thumb = event.target;
            const thumbRect = thumb.getBoundingClientRect();
            const x = event.clientX - thumbRect.left;
            const y = event.clientY - thumbRect.top;
            scrollbarContext.onThumbPointerDown({
                x: x,
                y: y
            });
        }),
        onPointerUp: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerUp, scrollbarContext.onThumbPointerUp)
    }));
});
/* -----------------------------------------------------------------------------------------------*/ function $57acba87d6e25586$var$toInt(value) {
    return value ? parseInt(value, 10) : 0;
}
function $57acba87d6e25586$var$getThumbRatio(viewportSize, contentSize) {
    const ratio = viewportSize / contentSize;
    return isNaN(ratio) ? 0 : ratio;
}
function $57acba87d6e25586$var$getThumbSize(sizes) {
    const ratio = $57acba87d6e25586$var$getThumbRatio(sizes.viewport, sizes.content);
    const scrollbarPadding = sizes.scrollbar.paddingStart + sizes.scrollbar.paddingEnd;
    const thumbSize = (sizes.scrollbar.size - scrollbarPadding) * ratio; // minimum of 18 matches macOS minimum
    return Math.max(thumbSize, 18);
}
function $57acba87d6e25586$var$getScrollPositionFromPointer(pointerPos, pointerOffset, sizes, dir = 'ltr') {
    const thumbSizePx = $57acba87d6e25586$var$getThumbSize(sizes);
    const thumbCenter = thumbSizePx / 2;
    const offset = pointerOffset || thumbCenter;
    const thumbOffsetFromEnd = thumbSizePx - offset;
    const minPointerPos = sizes.scrollbar.paddingStart + offset;
    const maxPointerPos = sizes.scrollbar.size - sizes.scrollbar.paddingEnd - thumbOffsetFromEnd;
    const maxScrollPos = sizes.content - sizes.viewport;
    const scrollRange = dir === 'ltr' ? [
        0,
        maxScrollPos
    ] : [
        maxScrollPos * -1,
        0
    ];
    const interpolate = $57acba87d6e25586$var$linearScale([
        minPointerPos,
        maxPointerPos
    ], scrollRange);
    return interpolate(pointerPos);
}
function $57acba87d6e25586$var$getThumbOffsetFromScroll(scrollPos, sizes, dir = 'ltr') {
    const thumbSizePx = $57acba87d6e25586$var$getThumbSize(sizes);
    const scrollbarPadding = sizes.scrollbar.paddingStart + sizes.scrollbar.paddingEnd;
    const scrollbar = sizes.scrollbar.size - scrollbarPadding;
    const maxScrollPos = sizes.content - sizes.viewport;
    const maxThumbPos = scrollbar - thumbSizePx;
    const scrollClampRange = dir === 'ltr' ? [
        0,
        maxScrollPos
    ] : [
        maxScrollPos * -1,
        0
    ];
    const scrollWithoutMomentum = $ae6933e535247d3d$export$7d15b64cf5a3a4c4(scrollPos, scrollClampRange);
    const interpolate = $57acba87d6e25586$var$linearScale([
        0,
        maxScrollPos
    ], [
        0,
        maxThumbPos
    ]);
    return interpolate(scrollWithoutMomentum);
} // https://github.com/tmcw-up-for-adoption/simple-linear-scale/blob/master/index.js
function $57acba87d6e25586$var$linearScale(input, output) {
    return (value)=>{
        if (input[0] === input[1] || output[0] === output[1]) return output[0];
        const ratio = (output[1] - output[0]) / (input[1] - input[0]);
        return output[0] + ratio * (value - input[0]);
    };
}
function $57acba87d6e25586$var$isScrollingWithinScrollbarBounds(scrollPos, maxScrollPos) {
    return scrollPos > 0 && scrollPos < maxScrollPos;
} // Custom scroll handler to avoid scroll-linked effects
// https://developer.mozilla.org/en-US/docs/Mozilla/Performance/Scroll-linked_effects
const $57acba87d6e25586$var$addUnlinkedScrollListener = (node, handler = ()=>{})=>{
    let prevPosition = {
        left: node.scrollLeft,
        top: node.scrollTop
    };
    let rAF = 0;
    (function loop() {
        const position = {
            left: node.scrollLeft,
            top: node.scrollTop
        };
        const isHorizontalScroll = prevPosition.left !== position.left;
        const isVerticalScroll = prevPosition.top !== position.top;
        if (isHorizontalScroll || isVerticalScroll) handler();
        prevPosition = position;
        rAF = window.requestAnimationFrame(loop);
    })();
    return ()=>window.cancelAnimationFrame(rAF)
    ;
};
function $57acba87d6e25586$var$useDebounceCallback(callback, delay) {
    const handleCallback = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(callback);
    const debounceTimerRef = useRef(0);
    useEffect(()=>()=>window.clearTimeout(debounceTimerRef.current)
    , []);
    return useCallback(()=>{
        window.clearTimeout(debounceTimerRef.current);
        debounceTimerRef.current = window.setTimeout(handleCallback, delay);
    }, [
        handleCallback,
        delay
    ]);
}
function $57acba87d6e25586$var$useResizeObserver(element, onResize) {
    const handleResize = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onResize);
    $9f79659886946c16$export$e5c5a5f917a5871c(()=>{
        let rAF = 0;
        if (element) {
            /**
       * Resize Observer will throw an often benign error that says `ResizeObserver loop
       * completed with undelivered notifications`. This means that ResizeObserver was not
       * able to deliver all observations within a single animation frame, so we use
       * `requestAnimationFrame` to ensure we don't deliver unnecessary observations.
       * Further reading: https://github.com/WICG/resize-observer/issues/38
       */ const resizeObserver = new ResizeObserver(()=>{
                cancelAnimationFrame(rAF);
                rAF = window.requestAnimationFrame(handleResize);
            });
            resizeObserver.observe(element);
            return ()=>{
                window.cancelAnimationFrame(rAF);
                resizeObserver.unobserve(element);
            };
        }
    }, [
        element,
        handleResize
    ]);
}
/* -----------------------------------------------------------------------------------------------*/ const $57acba87d6e25586$export$be92b6f5f03c0fe9 = $57acba87d6e25586$export$ccf8d8d7bbf3c2cc;
const $57acba87d6e25586$export$d5c6c08dc2d3ca7 = $57acba87d6e25586$export$a21cbf9f11fca853;
const $57acba87d6e25586$export$9a4e88b92edfce6b = $57acba87d6e25586$export$2fabd85d0eba3c57;
const $57acba87d6e25586$export$6521433ed15a34db = $57acba87d6e25586$export$9fba1154677d7cd2;

var SelectItem = function (_a) {
    var textvalue = _a.textValue, value = _a.value, disabled = _a.disabled, children = _a.children;
    if (textvalue && value) {
        return React__default.cloneElement(children, { textvalue: textvalue, value: value, disabled: disabled });
    }
    else {
        if (!textvalue)
            console.error('Item must have a textValue prop');
        if (!value)
            console.error('Item must have a value prop');
        return null;
    }
};
SelectItem.displayName = 'SelectItem';
var IsSelectItemChild = function (child) {
    var elementType = child.type;
    return (elementType === null || elementType === void 0 ? void 0 : elementType.displayName) === SelectItem.displayName;
};
/**
 * Get the text only if the child is a SelectItem
 */
var getSelectItemText = function (children, selectedValue) {
    var selectedChild = React__default.Children.toArray(children).find(function (child) { return React__default.isValidElement(child) && IsSelectItemChild(child) && child.props.value === selectedValue; });
    return selectedChild ? selectedChild.props.textValue : undefined;
};

var SPACE = 8;
var BORDER_WIDTH = 2;
// Item height depends of the Body component and the padding of the Item component
var ITEM_HEIGHT = parseInt(fontMap.normal.lineHeight) + SPACE * 2;
var SelectTrigger = styled($d08ef79370b62062$export$41fb9f06171c75f4)(templateObject_1$1k || (templateObject_1$1k = __makeTemplateObject(["\n  ", "\n  display: flex;\n  align-items: center;\n  border-radius: ", ";\n  position: relative;\n  text-align: left;\n  cursor: pointer;\n  background-color: ", ";\n  gap: 4px;\n  min-height: ", ";\n  min-width: 120px;\n  &[data-state='open'] {\n    border-color: ", ";\n  }\n"], ["\n  ", "\n  display: flex;\n  align-items: center;\n  border-radius: ", ";\n  position: relative;\n  text-align: left;\n  cursor: pointer;\n  background-color: ", ";\n  gap: 4px;\n  min-height: ", ";\n  min-width: 120px;\n  &[data-state='open'] {\n    border-color: ", ";\n  }\n"])), inputStyles, theming.borderRadius, colorFormSurface.colorFormSurfaceDefault, theming.inputMinHeight, colorFormBorder.colorFormBorderActive);
var StyledItem = styled($d08ef79370b62062$export$6d08773d2e66f8f2)(templateObject_2$B || (templateObject_2$B = __makeTemplateObject(["\n  cursor: pointer;\n  padding: ", "px;\n  position: relative;\n  &[data-state='checked'] {\n    &:before {\n      ", "\n      border-radius: var(--borderRadiusSmaller);\n    }\n\n    ", "\n  }\n  &[data-highlighted] {\n    &:before {\n      ", "\n      border-radius: var(--borderRadiusSmaller);\n    }\n  }\n  &[data-disabled] {\n    cursor: default;\n    pointer-events: none;\n    p {\n      color: ", ";\n    }\n  }\n\n  &:focus-visible {\n    outline: none;\n  }\n  ", "\n  margin-bottom: 1px;\n"], ["\n  cursor: pointer;\n  padding: ", "px;\n  position: relative;\n  &[data-state='checked'] {\n    &:before {\n      ", "\n      border-radius: var(--borderRadiusSmaller);\n    }\n\n    ", "\n  }\n  &[data-highlighted] {\n    &:before {\n      ", "\n      border-radius: var(--borderRadiusSmaller);\n    }\n  }\n  &[data-disabled] {\n    cursor: default;\n    pointer-events: none;\n    p {\n      color: ", ";\n    }\n  }\n\n  &:focus-visible {\n    outline: none;\n  }\n  ", "\n  margin-bottom: 1px;\n"])), SPACE, activeOverlay, activeStyle, hoverOverlay, colorText.colorTextTextDisabled, baseStyle({ position: '0' }));
var SelectContent = styled($d08ef79370b62062$export$7c6e2c02157bb7d2).attrs({ className: 'select-content' })(templateObject_3$i || (templateObject_3$i = __makeTemplateObject(["\n  width: var(--radix-dropdown-menu-trigger-width);\n  position: relative;\n  margin: ", "px 0;\n  z-index: ", ";\n\n  [data-radix-scroll-area-viewport] > div {\n    display: block !important;\n  }\n\n  ", "\n"], ["\n  width: var(--radix-dropdown-menu-trigger-width);\n  position: relative;\n  margin: ", "px 0;\n  z-index: ", ";\n\n  [data-radix-scroll-area-viewport] > div {\n    display: block !important;\n  }\n\n  ", "\n"])), SPACE, zIndexMap.dropdown, function (_a) {
    var $dropdownWidth = _a.$dropdownWidth;
    return $dropdownWidth
        ? "\n      > div {\n        width: ".concat($dropdownWidth, ";\n      }\n    ")
        : '';
});
var calcMaxHeight = function (maxItems, placeholder) {
    var itemsHeight = maxItems * ITEM_HEIGHT + (placeholder ? ITEM_HEIGHT : 0);
    return "".concat(itemsHeight + BORDER_WIDTH + SPACE * 2, "px");
};
var getSelectContentMaxHeight = function (_a) {
    var $maxItems = _a.$maxItems, placeholder = _a.placeholder;
    return $maxItems ? calcMaxHeight($maxItems, placeholder) : 'var(--radix-dropdown-menu-content-available-height)';
};
var ScrollViewport = styled($57acba87d6e25586$export$d5c6c08dc2d3ca7)(templateObject_4$a || (templateObject_4$a = __makeTemplateObject(["\n  max-height: ", ";\n  background-color: ", ";\n  border: ", "px solid ", ";\n  border-radius: var(--borderRadiusSmaller);\n  box-shadow: ", ";\n  padding: ", "px;\n  display: flex;\n  flex-direction: column;\n  z-index: 1;\n  box-sizing: border-box;\n  width: 100%;\n"], ["\n  max-height: ", ";\n  background-color: ", ";\n  border: ", "px solid ", ";\n  border-radius: var(--borderRadiusSmaller);\n  box-shadow: ", ";\n  padding: ", "px;\n  display: flex;\n  flex-direction: column;\n  z-index: 1;\n  box-sizing: border-box;\n  width: 100%;\n"])), getSelectContentMaxHeight, colorSurface.primary, BORDER_WIDTH, colorBorder$1.colorBorderBorderPrimary, shadow.larger, SPACE);
var ScrollAreaScrollBar = styled($57acba87d6e25586$export$9a4e88b92edfce6b)(templateObject_5$4 || (templateObject_5$4 = __makeTemplateObject(["\n  top: 12px !important;\n  right: 4px !important;\n  height: calc(100% - ", "px - ", "px);\n  padding: 1px 0px;\n  background-color: ", ";\n  border-radius: 4px;\n  width: 6px;\n  z-index: 2;\n"], ["\n  top: 12px !important;\n  right: 4px !important;\n  height: calc(100% - ", "px - ", "px);\n  padding: 1px 0px;\n  background-color: ", ";\n  border-radius: 4px;\n  width: 6px;\n  z-index: 2;\n"])), SPACE * 2, BORDER_WIDTH, colorSurface.secondary);
var ScrollThumb = styled($57acba87d6e25586$export$6521433ed15a34db)(templateObject_6$3 || (templateObject_6$3 = __makeTemplateObject(["\n  background-color: ", ";\n  border-radius: var(--inputBorderRadius);\n"], ["\n  background-color: ", ";\n  border-radius: var(--inputBorderRadius);\n"])), colorSurface.tertiary);
var templateObject_1$1k, templateObject_2$B, templateObject_3$i, templateObject_4$a, templateObject_5$4, templateObject_6$3;

var WithOptions = function (_a) {
    var options = _a.options, onSelect = _a.onSelect, selectedValue = _a.selectedValue, dataTestid = _a.dataTestid;
    return (jsx(Fragment, { children: options.map(function (_a, index) {
            var text = _a.text, value = _a.value, disabled = _a.disabled;
            return (jsx(StyledItem, __assign({ "data-state": selectedValue === value ? 'checked' : undefined, "data-value": value, "data-testid": dataTestid ? "".concat(dataTestid, "-").concat(value) : undefined, onSelect: function () { return onSelect(value); }, disabled: disabled }, { children: jsx(Body, { children: text }) }), index));
        }) }));
};
var WithSelectItems = function (_a) {
    var handleSelect = _a.handleSelect, children = _a.children, selectedValue = _a.selectedValue, dataTestid = _a.dataTestid;
    return (jsx(Fragment, { children: React__default.Children.map(children, function (child, index) {
            if (React__default.isValidElement(child) && IsSelectItemChild(child)) {
                var _a = child.props, value_1 = _a.value, disabled = _a.disabled;
                return (jsx(StyledItem, __assign({ "data-state": selectedValue === value_1 ? 'checked' : undefined, "data-value": value_1, "data-testid": dataTestid ? "".concat(dataTestid, "-").concat(value_1) : undefined, onSelect: function () { return handleSelect(value_1); }, disabled: disabled }, { children: child }), index));
            }
            return null;
        }) }));
};
var Select = forwardRef(function (_a, forwardedRef) {
    var bold = _a.bold, defaultValue = _a.defaultValue, children = _a.children, placeholder = _a.placeholder, onChange = _a.onChange, options = _a.options, name = _a.name, maxItems = _a.maxItems, _b = _a["data-testid"], dataTestid = _b === void 0 ? 'select' : _b, controlledValue = _a.value, icon = _a.icon, width = _a.width, dropdownWidth = _a.dropdownWidth, _c = _a.size, size = _c === void 0 ? 'default' : _c, rest = __rest(_a, ["bold", "defaultValue", "children", "placeholder", "onChange", "options", "name", "maxItems", 'data-testid', "value", "icon", "width", "dropdownWidth", "size"]);
    var _d = useState(false), isOpen = _d[0], setIsOpen = _d[1];
    var _e = useState(controlledValue || defaultValue), selectedValue = _e[0], setSelectedValue = _e[1];
    useEffect(function () {
        if (controlledValue !== undefined) {
            setSelectedValue(controlledValue);
        }
    }, [controlledValue]);
    var selectedText = useMemo(function () {
        var _a;
        if (options) {
            return (_a = options.find(function (option) { return option.value === selectedValue; })) === null || _a === void 0 ? void 0 : _a.text;
        }
        return getSelectItemText(children, selectedValue);
    }, [options, selectedValue, children]);
    var handleSelect = function (value) {
        if (onChange) {
            onChange({ target: { value: value, name: name } });
        }
        if (!controlledValue) {
            setSelectedValue(value);
        }
    };
    return (jsxs($d08ef79370b62062$export$be92b6f5f03c0fe9, __assign({ open: isOpen, onOpenChange: setIsOpen, modal: false }, { children: [jsxs(SelectTrigger, __assign({ role: "combobox", ref: forwardedRef, placeholder: placeholder, "data-form-error": true, "data-testid": dataTestid, width: width, "$size": size }, rest, { children: [icon && jsx(Icon, { color: "grayDark", size: "smaller", name: icon }), jsx(Body, __assign({ truncable: true, bold: bold }, { children: selectedText || placeholder })), jsx(Icon, { noFix: true, color: "grayDark", size: "smaller", name: isOpen ? 'caret-up' : 'caret-down' })] })), jsx(SelectContent, __assign({ "$dropdownWidth": dropdownWidth }, { children: jsxs($57acba87d6e25586$export$be92b6f5f03c0fe9, __assign({ type: "auto" }, { children: [jsxs(ScrollViewport, __assign({ "$maxItems": maxItems, placeholder: placeholder }, { children: [placeholder && (jsx(StyledItem, __assign({ "data-testid": "".concat(dataTestid, "-placeholder"), disabled: true }, { children: jsx(Body, { children: placeholder }) }))), options ? (jsx(WithOptions, { selectedValue: selectedValue, options: options, onSelect: handleSelect, dataTestid: dataTestid })) : (jsx(WithSelectItems, __assign({ selectedValue: selectedValue, dataTestid: dataTestid, handleSelect: handleSelect }, { children: children })))] })), jsx(ScrollAreaScrollBar, __assign({ orientation: "vertical" }, { children: jsx(ScrollThumb, {}) }))] })) }))] })));
});
Select.displayName = 'Select';

var StyledTextArea = styled.textarea(templateObject_1$1j || (templateObject_1$1j = __makeTemplateObject(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n"])), inputStyles, function (_a) {
    var resize = _a.resize, _b = _a.height, height = _b === void 0 ? '4rem' : _b;
    return "\n        resize: ".concat(resize, ";\n        height: ").concat(getSizeValue(height), ";\n    ");
});
var templateObject_1$1j;

var TextArea = forwardRef(function (_a, ref) {
    var className = _a.className, name = _a.name, disabled = _a.disabled, onChange = _a.onChange, value = _a.value, _b = _a.resize, resize = _b === void 0 ? 'none' : _b, placeholder = _a.placeholder, rest = __rest(_a, ["className", "name", "disabled", "onChange", "value", "resize", "placeholder"]);
    var _c = useState(value), currentValue = _c[0], setCurrentValue = _c[1];
    var handleChange = useCallback(function (e) {
        var value = typeof e === 'string' ? e : e.target.value;
        setCurrentValue(value);
        onChange && onChange(value);
    }, []);
    return (jsx(StyledTextArea, __assign({ ref: ref, className: className, name: name, onChange: handleChange, disabled: disabled, value: currentValue, resize: resize, placeholder: placeholder, borderRadius: "var(--inputBorderRadius)" }, rest)));
});
TextArea.displayName = 'TextArea';

var ShowHideContainer = styled.div(function (_a) {
    var show = _a.show;
    return ({
        visibility: show ? 'visible' : 'hidden'
    });
});

var ColorBar = styled.div(function (_a) {
    var color = _a.color, widthPercentage = _a.widthPercentage;
    return ({
        background: color,
        height: '10px',
        width: "".concat(widthPercentage * 100, "%")
    });
});
var BarContainer$1 = styled.div(templateObject_1$1i || (templateObject_1$1i = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var ProgressLabel = styled.div(function (_a) {
    var _b;
    var position = _a.position;
    return (_b = {
            position: 'absolute',
            width: '110px',
            fontSize: fontMap.smaller.fontSize,
            fontFamily: fontFamily,
            textAlign: 'center'
        },
        _b[position] = '-27px',
        _b);
});
function getKinkColor(progress, goal, goalColor, progressColor) {
    var goalColorEnd = 0;
    var progressColorStart = 0;
    if (progress === goal) {
        goalColorEnd = 100;
    }
    else if (progress > goal && progress <= goal + 0.01) {
        goalColorEnd = 50;
        progressColorStart = 60;
    }
    else if (progress > goal && progress <= goal + 0.02) {
        goalColorEnd = 15;
        progressColorStart = 20;
    }
    return "linear-gradient(to right, ".concat(goalColor, " ").concat(goalColorEnd, "%, ").concat(progressColor, " ").concat(progressColorStart, "%)");
}
var BarKink = styled.div(function (_a) {
    var _b;
    var goalColor = _a.goalColor, progressColor = _a.progressColor, progress = _a.progress, goal = _a.goal, position = _a.position;
    return (_b = {
            display: 'flex',
            flexFlow: 'column',
            alignItems: 'center',
            position: 'absolute',
            border: "2.5px solid ".concat(colorSurface.secondary)
        },
        _b[position === 'top' ? 'borderBottom' : 'borderTop'] = 'transparent',
        _b.backgroundImage = getKinkColor(progress, goal, goalColor, progressColor),
        _b.minWidth = '15px',
        _b.minHeight = '13px',
        _b.boxSizing = 'border-box',
        _b.width = '10px',
        _b.height = '24px',
        _b[position] = '-22px',
        _b.left = "calc(".concat(progress * 100, "% - 13px)"),
        _b);
});
var GoalProgressBar = function (_a) {
    var progress = _a.progress, goal = _a.goal, _b = _a.progressColorId, progressColorId = _b === void 0 ? 'progressGreen' : _b, _c = _a.goalColorId, goalColorId = _c === void 0 ? progressColorId : _c, position = _a.position, labelText = _a.labelText, count = _a.count;
    var progressColor = "var(--".concat(progressColorId, ")");
    var goalColor = "var(--".concat(goalColorId, ")");
    var goalMet = progress >= goal;
    var progressWidth = goalMet ? progress - goal : progress;
    var progressLabel = "".concat(Math.round(progress * 100), "% ").concat(labelText);
    var countLabel = count !== undefined && "".concat(count, " ").concat(labelText);
    var progressLabelText = countLabel || progressLabel;
    var hasSpaceForKink = progress > 0.03;
    return (jsxs(BarContainer$1, { children: [goalMet && jsx(ColorBar, { widthPercentage: goal, color: goalColor }), jsx(ColorBar, { widthPercentage: progressWidth, color: progressColor }), hasSpaceForKink && (jsx(BarKink, __assign({ progress: progress, goal: goal, position: position, progressColor: progressColor, goalColor: goalColor }, { children: jsx(ProgressLabel, __assign({ progress: progress, position: position, "data-testid": "progress-label" }, { children: jsx("strong", { children: progressLabelText }) })) })))] }));
};
var templateObject_1$1i;

var GoalMarker = styled.div(function (_a) {
    var location = _a.location;
    return ({
        position: 'absolute',
        background: colorBase['colorNeutral-500'],
        height: '38px',
        width: '5px',
        left: "calc(".concat(location * 100, "% - 2.5px)"),
        bottom: '-5px',
        zIndex: 1
    });
});
var StartMarker = styled.div({
    height: '38px',
    width: '5px',
    bottom: '-5px'
});
var EndMarker = styled.div({
    height: '28px',
    width: '2px',
    left: '100%'
});
var GoalIconContainer = styled.div(templateObject_1$1h || (templateObject_1$1h = __makeTemplateObject(["\n  position: absolute;\n  top: -21px;\n  left: -5px;\n"], ["\n  position: absolute;\n  top: -21px;\n  left: -5px;\n"])));
var BarContainer = styled.div(templateObject_2$A || (templateObject_2$A = __makeTemplateObject(["\n  position: relative;\n  width: 600px;\n  background: ", ";\n  display: flex;\n  flex-flow: column;\n  justify-content: space-around;\n  height: 28px;\n"], ["\n  position: relative;\n  width: 600px;\n  background: ", ";\n  display: flex;\n  flex-flow: column;\n  justify-content: space-around;\n  height: 28px;\n"])), colorSurface.secondary);
var Column = styled.div(templateObject_3$h || (templateObject_3$h = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n"])));
var OuterContainer = styled.div(templateObject_4$9 || (templateObject_4$9 = __makeTemplateObject(["\n  display: flex;\n  width: 705px;\n  height: 95px;\n  font-family: ", ";\n  font-size: ", ";\n\n  #elite-seller-copy,\n  #elite-seller-label {\n    font-family: inherit;\n  }\n\n  #elite-seller-label {\n    padding-top: 5px;\n    padding-right: 20px;\n    font-size: ", ";\n  }\n\n  #elite-seller-copy {\n    color: ", ";\n    font-size: ", ";\n  }\n\n  ", ", ", " {\n    position: absolute;\n    background: ", ";\n  }\n"], ["\n  display: flex;\n  width: 705px;\n  height: 95px;\n  font-family: ", ";\n  font-size: ", ";\n\n  #elite-seller-copy,\n  #elite-seller-label {\n    font-family: inherit;\n  }\n\n  #elite-seller-label {\n    padding-top: 5px;\n    padding-right: 20px;\n    font-size: ", ";\n  }\n\n  #elite-seller-copy {\n    color: ", ";\n    font-size: ", ";\n  }\n\n  ", ", ", " {\n    position: absolute;\n    background: ", ";\n  }\n"
    /**
     * Calculate a progress percentage that will equal to progress goal when vehicles sold goal is met
     * Since we can always sell more vehicles, this value should never reach 100% so it is capped at 95%
     * @param {number} vehiclesSold - The number of vehicles sold
     * @param {number} vehiclesSoldGoal - The number of vehicles sold required to be considered "elite"
     * @param {number} goalPercentage - The location of the goal marker (this number should be between 0.0 and 1.0)
     * @returns {number}
     */
])), fontFamily, fontMap.smaller.fontSize, headlineMap.H6.fontSize, colorText.colorTextTextSecondary, fontMap.smaller.fontSize, StartMarker, EndMarker, colorSurface.secondary);
/**
 * Calculate a progress percentage that will equal to progress goal when vehicles sold goal is met
 * Since we can always sell more vehicles, this value should never reach 100% so it is capped at 95%
 * @param {number} vehiclesSold - The number of vehicles sold
 * @param {number} vehiclesSoldGoal - The number of vehicles sold required to be considered "elite"
 * @param {number} goalPercentage - The location of the goal marker (this number should be between 0.0 and 1.0)
 * @returns {number}
 */
var calculateVehiclesSoldProgress = function (vehiclesSold, vehiclesSoldGoal, goalPercentage) {
    var maxPercentage = 0.95;
    var exactPercentage = vehiclesSold / (vehiclesSoldGoal / goalPercentage);
    var roundedPercentage = Number(exactPercentage.toFixed(2));
    return roundedPercentage > maxPercentage ? maxPercentage : roundedPercentage;
};
var EliteSellerProgressBar = function (_a) {
    var vehiclesSoldGoal = _a.vehiclesSoldGoal, goalPercentage = _a.goalPercentage, salesPercentage = _a.salesPercentage, vehiclesSold = _a.vehiclesSold, effectiveMonthName = _a.effectiveMonthName;
    var vehiclesSoldProgress = calculateVehiclesSoldProgress(vehiclesSold, vehiclesSoldGoal, goalPercentage);
    var bothGoalsMet = vehiclesSoldProgress >= goalPercentage && salesPercentage >= goalPercentage;
    var goalColorId = bothGoalsMet ? 'elite-progress-bar-goal-color' : undefined;
    return (jsxs(OuterContainer, { children: [jsx(ShowHideContainer, __assign({ show: bothGoalsMet, id: "elite-seller-label", "data-testid": "elite-seller-label" }, { children: jsx("strong", { children: "Elite dealer" }) })), jsxs(Column, { children: [jsxs(BarContainer, { children: [jsx(StartMarker, {}), jsx(GoalMarker, __assign({ location: goalPercentage }, { children: jsx(GoalIconContainer, { children: jsx(Icon, { name: "elite-inverted", size: "smaller" }) }) })), jsx(GoalProgressBar, { position: "top", labelText: "sold", count: vehiclesSold, progress: vehiclesSoldProgress, goal: goalPercentage, goalColorId: goalColorId, progressColorId: "elite-progress-bar-top-color" }), jsx(GoalProgressBar, { position: "bottom", labelText: "conversion", progress: salesPercentage, goal: goalPercentage, goalColorId: goalColorId, progressColorId: "elite-progress-bar-bottom-color" }), jsx(EndMarker, {})] }), jsx(ShowHideContainer, __assign({ show: bothGoalsMet, "data-testid": "elite-seller-copy" }, { children: jsxs("strong", __assign({ id: "elite-seller-copy" }, { children: ["You've qualified as an Elite dealer for ", effectiveMonthName] })) }))] })] }));
};
var templateObject_1$1h, templateObject_2$A, templateObject_3$h, templateObject_4$9;

var vehicleTypes = [
    { id: 1, name: 'Car', slug: 'vehicle-type-car' },
    { id: 2, name: 'SUV', slug: 'vehicle-type-suvV' },
    { id: 3, name: 'Truck', slug: 'vehicle-type-truck' },
    { id: 4, name: 'Van', slug: 'vehicle-type-van' },
    { id: 5, name: 'Minivan', slug: 'vehicle-type-minivan' },
    { id: 6, name: 'Motorcycle', slug: 'vehicle-type-motorcycle' },
    { id: 7, name: 'Trailer', slug: 'vehicle-type-trailer' },
    { id: 8, name: 'RV', slug: 'vehicle-type-rv' },
    { id: 9, name: 'Semi', slug: 'vehicle-type-semi' },
    { id: 10, name: 'Tractor', slug: 'vehicle-type-tractor' },
    { id: 11, name: 'Semi Tractor', slug: 'vehicle-type-semi-tractor' },
    { id: 12, name: 'Other', slug: 'vehicle-type-other' }
];

var allowedTagParameters = [
    { name: 'buy_it_now_only', type: 'boolean', label: 'Buy it now' },
    { name: 'deals_about_to_close', type: 'boolean', label: 'Deals about to close' },
    { name: 'present_title', type: 'boolean', label: 'Seller has Title' },
    { name: 'dealer_id', type: 'dealer', label: 'Dealership' },
    { name: 'drivetrain', type: 'list', label: 'Drivetrain' },
    { name: 'engine_issue', type: 'boolean', label: 'Engine noise' },
    { name: 'makes', type: 'list', label: 'Make' },
    { name: 'max_adjusted_average', type: 'integer', label: 'Maximum Black Book value' },
    { name: 'max_mileage', type: 'integer', label: 'Maximum mileage' },
    { name: 'max_year', type: 'integer', label: 'Maximum year' },
    { name: 'min_adjusted_average', type: 'integer', label: 'Minimum Black Book value' },
    { name: 'min_mileage', type: 'integer', label: 'Minimum mileage' },
    { name: 'min_year', type: 'integer', label: 'Minimum year' },
    { name: 'radius', type: 'integer', label: 'Radius' },
    { name: 'min_radius', type: 'integer', label: 'Minimum radius' },
    { name: 'max_radius', type: 'integer', label: 'Maximum radius' },
    { name: 'sealed_bid_only', type: 'boolean', label: 'Sealed bid sales' },
    { name: 'sellers_i_follow', type: 'boolean', label: 'Sellers I follow' },
    { name: 'transmission', type: 'list', label: 'Transmission' },
    { name: 'transmission_issue', type: 'boolean', label: 'Transmission issue' },
    { name: 'vehicle_type', type: 'list', label: 'Body style' },
    { name: 'seller_type_franchise', type: 'boolean', label: 'Franchise' },
    { name: 'seller_type_independent', type: 'boolean', label: 'Independent' },
    { name: 'autotec_title', type: 'boolean', label: 'Title events' },
    { name: 'autotec_accidents_count', type: 'integer', label: 'Max accident count' },
    { name: 'autotec_owners_count', type: 'integer', label: 'Max owner count' }
];

var drivetrains = [
    { id: 1, name: '2WD', slug: 'drive-train-2wd' },
    { id: 2, name: '4WD', slug: 'drive-train-4wd' },
    { id: 3, name: 'AWD', slug: 'drive-train-awd' },
    { id: 4, name: 'RWD', slug: 'drive-train-rwd' },
    { id: 5, name: 'FWD', slug: 'drive-train-fwd' }
];

var transmissions = [
    { id: 1, name: 'Manual', slug: 'transmission-manual' },
    { id: 2, name: 'Automatic', slug: 'transmission-automatic' },
    { id: 3, name: 'Other', slug: 'transmission-other' }
];

var mainMakesList = [
    'Chevrolet',
    'Ford',
    'Toyota',
    'Dodge',
    'Nissan',
    'Honda',
    'GMC',
    'Jeep',
    'Buick',
    'Kia',
    'Hyundai',
    'Chrysler',
    'Volkswagen'
];

var sortByList = [
    { id: 1, label: 'Newest', direction: 'desc', orderBy: 'created_at' },
    { id: 2, label: 'Expiring Soon', direction: 'asc', orderBy: 'created_at' },
    { id: 3, label: 'Year - Newest First', direction: 'desc', orderBy: 'year' },
    { id: 4, label: 'Year - Oldest First', direction: 'asc', orderBy: 'year' },
    { id: 5, label: 'Mileage - Lowest First', direction: 'asc', orderBy: 'mileage' },
    { id: 6, label: 'Mileage - Highest First', direction: 'desc', orderBy: 'mileage' },
    { id: 7, label: 'Price - Lowest First', direction: 'asc', orderBy: 'price' },
    { id: 8, label: 'Price - Highest First', direction: 'desc', orderBy: 'price' },
    { id: 9, label: 'Distance - Closest', direction: 'asc', orderBy: 'distance' }
];

var Bubble = styled.div(templateObject_1$1g || (templateObject_1$1g = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var _b = _a.background, background = _b === void 0 ? 'grayDark' : _b, _c = _a.borderWidth, borderWidth = _c === void 0 ? 2 : _c, outlined = _a.outlined, _d = _a.borderRadius, borderRadius = _d === void 0 ? 16 : _d, _e = _a.padding, padding = _e === void 0 ? '4px 8px' : _e, borderColor = _a.borderColor, _f = _a.minWidth, minWidth = _f === void 0 ? 24 : _f, _g = _a.minHeight, minHeight = _g === void 0 ? 24 : _g;
    return "\n    border-radius: ".concat(borderRadius, "px;\n    background-color: ").concat(outlined ? customColors.transparent : getLegacyColor(background), ";\n    border-color: ").concat(getBorderColor(borderColor || background), ";\n    border-style: solid;\n    border-width: ").concat(px(borderWidth), ";\n    padding: ").concat(padding, ";\n    min-width: ").concat(getSizeValue(minWidth), ";\n    min-height: ").concat(getSizeValue(minHeight), ";\n    box-sizing: border-box;\n    width: fit-content;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: ").concat(fontMap.smaller.fontSize, ";\n    font-family: ").concat(fontFamily, ";\n  ");
});
var templateObject_1$1g;

var Container$8 = styled.div(templateObject_1$1f || (templateObject_1$1f = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var RangeLine = styled.div(templateObject_2$z || (templateObject_2$z = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  width: 100%;\n"], ["\n  display: flex;\n  align-items: center;\n  width: 100%;\n"])));
var RangeSquareLimiter = styled.div(templateObject_3$g || (templateObject_3$g = __makeTemplateObject(["\n  height: 8px;\n  width: 4px;\n  background-color: ", ";\n"], ["\n  height: 8px;\n  width: 4px;\n  background-color: ", ";\n"])), colorBase['colorNeutral-600']);
var Line$2 = styled.div(templateObject_4$8 || (templateObject_4$8 = __makeTemplateObject(["\n  border-top: 4px solid ", ";\n  height: 0px;\n  flex: 2;\n"], ["\n  border-top: 4px solid ", ";\n  height: 0px;\n  flex: 2;\n"])), colorBase['colorNeutral-200']);
var InnerLine = styled(Line$2)(templateObject_5$3 || (templateObject_5$3 = __makeTemplateObject(["\n  border-color: ", ";\n  flex: 6;\n"], ["\n  border-color: ", ";\n  flex: 6;\n"])), colorBase['colorNeutral-600']);
var RangeValues = styled.div(templateObject_6$2 || (templateObject_6$2 = __makeTemplateObject(["\n  display: flex;\n  margin-top: 8px;\n  justify-content: space-between;\n  width: 100%;\n  gap: 5px;\n"], ["\n  display: flex;\n  margin-top: 8px;\n  justify-content: space-between;\n  width: 100%;\n  gap: 5px;\n"])));
var templateObject_1$1f, templateObject_2$z, templateObject_3$g, templateObject_4$8, templateObject_5$3, templateObject_6$2;

var Range = function (_a) {
    var min = _a.min, max = _a.max;
    return (jsxs(Container$8, { children: [jsxs(RangeLine, { children: [jsx(Line$2, {}), jsx(RangeSquareLimiter, {}), jsx(InnerLine, {}), jsx(RangeSquareLimiter, {}), jsx(Line$2, {})] }), jsxs(RangeValues, { children: [jsx(Body, { children: min }), jsx(Body, { children: max })] })] }));
};

var _a$1 = toast$1.TYPE, SUCCESS = _a$1.SUCCESS, INFO = _a$1.INFO, WARNING = _a$1.WARNING, ERROR = _a$1.ERROR;
var LOADING = 'loading';
var CustomToast = function (_a) {
    var title = _a.title, text = _a.text, type = _a.type, _b = _a.closeIcon, closeIcon = _b === void 0 ? 'close' : _b, children = _a.children, handleClose = _a.handleClose;
    var variant = useMemo(function () {
        var _a;
        var variants = (_a = {},
            _a[SUCCESS] = { icon: 'success', color: 'colorIconIconSuccess' },
            _a[INFO] = { icon: 'info', color: 'colorIconIconBrand' },
            _a[WARNING] = { icon: 'warning', color: 'colorIconIconWarning' },
            _a[ERROR] = { icon: 'alert', color: 'colorIconIconAlert' },
            _a);
        return variants[type];
    }, [type]);
    var isLoading = type === LOADING;
    return (jsxs("div", __assign({ className: "custom-toast" }, { children: [jsxs(FlexBox, __assign({ justifyContent: "space-between", padding: spacingActionPadding.spacingActionPaddingSm, alignItems: "flex-start" }, { children: [jsxs(FlexBox, __assign({ gap: spacingActionGap.spacingActionGapLg, alignItems: title ? 'flex-start' : 'center' }, { children: [variant && jsx(Icon, { name: variant.icon, color: variant.color }), isLoading && jsx(BlcLoader, { size: "normal" }), jsxs(FlexBox, __assign({ flexDirection: "column", gap: spacingActionGap.spacingActionGapMd }, { children: [title && jsx(Headline, { children: title }), text && jsx(Body, { children: text })] }))] })), !isLoading && (jsx(FlexBox, __assign({ onClick: handleClose }, { children: jsx(Icon, { name: closeIcon, color: "colorIconIconPrimary", cursor: "pointer" }) })))] })), children] })));
};

var toastifyVariant = function (_a) {
    var selector = _a.selector, backgroundColor = _a.backgroundColor, borderColor = _a.borderColor;
    return "\n  ".concat(selector, " {\n    background-color: ").concat(backgroundColor, ";\n    border: 1px solid;\n    border-color: ").concat(borderColor, "\n  }");
};
var ToastContainerStyles = createGlobalStyle(templateObject_1$1e || (templateObject_1$1e = __makeTemplateObject(["\n.Toastify {\n  z-index: ", " !important;\n}\n\n.Toastify__toast-container {\n  width: ", ";\n}\n\n.Toastify__toast-body {\n  padding: 0;\n}\n\n.Toastify__toast-body > div:not(:has(.custom-toast)) {\n  font-size: ", ";\n  font-weight: ", ";\n  color: black;\n  margin-left: 24px;\n}\n\n.Toastify__toast {\n  padding: 0;\n  border-radius: 0;\n  ", "\n}\n\n", "\n\n", "\n\n", "\n\n", "\n"], ["\n.Toastify {\n  z-index: ", " !important;\n}\n\n.Toastify__toast-container {\n  width: ", ";\n}\n\n.Toastify__toast-body {\n  padding: 0;\n}\n\n.Toastify__toast-body > div:not(:has(.custom-toast)) {\n  font-size: ", ";\n  font-weight: ", ";\n  color: black;\n  margin-left: 24px;\n}\n\n.Toastify__toast {\n  padding: 0;\n  border-radius: 0;\n  ", "\n}\n\n", "\n\n", "\n\n", "\n\n", "\n"])), zIndexMap.toast, function (_a) {
    var width = _a.width;
    return width;
}, fontMap.normal.fontSize, weightMap$1.bold, function (_a) {
    var top = _a.top;
    return " top: ".concat(getSizeValue(top), ";");
}, toastifyVariant({
    selector: '.Toastify__toast--default, .Toastify__toast--info',
    backgroundColor: colorSurface.brand,
    borderColor: colorBorder$1.colorBorderBorderBrand
}), toastifyVariant({
    selector: '.Toastify__toast--warning',
    backgroundColor: colorSurface.warning,
    borderColor: colorBorder$1.colorBorderBorderWarning
}), toastifyVariant({
    selector: '.Toastify__toast--success',
    backgroundColor: colorSurface.success,
    borderColor: colorBorder$1.colorBorderBorderSuccess
}), toastifyVariant({
    selector: '.Toastify__toast--error',
    backgroundColor: colorSurface.alert,
    borderColor: colorBorder$1.colorBorderBorderAlert
}));
var templateObject_1$1e;

var ToastContainer = function (_a) {
    var top = _a.top, _b = _a.width, width = _b === void 0 ? '320px' : _b;
    return (jsxs(Fragment, { children: [jsx(ToastContainerStyles, { top: top || 0, width: width }), jsx(ToastContainer$1, { closeOnClick: false })] }));
};

var options = {
    hideProgressBar: true,
    closeButton: false,
    icon: false
};
var toast = function (text, title, config) {
    return toast$1(function (_a) {
        var closeToast = _a.closeToast;
        return (jsx(CustomToast, __assign({ title: title, text: text, type: toast$1.TYPE.DEFAULT, handleClose: closeToast }, config)));
    }, options);
};
toast.info = function (text, title, config) {
    return toast$1.info(function (_a) {
        var closeToast = _a.closeToast;
        return (jsx(CustomToast, __assign({ title: title, text: text, type: toast$1.TYPE.INFO, handleClose: closeToast }, config)));
    }, options);
};
toast.warning = function (text, title, config) {
    return toast$1.warning(function (_a) {
        var closeToast = _a.closeToast;
        return (jsx(CustomToast, __assign({ title: title, text: text, type: toast$1.TYPE.WARNING, handleClose: closeToast }, config)));
    }, options);
};
toast.success = function (text, title, config) {
    return toast$1.success(function (_a) {
        var closeToast = _a.closeToast;
        return (jsx(CustomToast, __assign({ title: title, text: text, type: toast$1.TYPE.SUCCESS, handleClose: closeToast }, config)));
    }, options);
};
toast.error = function (text, title, config) {
    return toast$1.error(function (_a) {
        var closeToast = _a.closeToast;
        return (jsx(CustomToast, __assign({ title: title, text: text, type: toast$1.TYPE.ERROR, handleClose: closeToast }, config)));
    }, options);
};
toast.loading = function (text, title, config) {
    return toast$1.loading(function (_a) {
        var closeToast = _a.closeToast;
        return jsx(CustomToast, __assign({ title: title, text: text, type: LOADING, handleClose: closeToast }, config));
    }, options);
};
toast.update = toast$1.update;
toast.dismiss = function (id) { return toast$1.dismiss(id); };

var Label = styled.label(templateObject_1$1d || (templateObject_1$1d = __makeTemplateObject(["\n  box-sizing: content-box;\n  position: relative;\n  display: inline-block;\n  width: 56px;\n  height: 32px;\n  transition: 0.4s;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  box-sizing: content-box;\n  position: relative;\n  display: inline-block;\n  width: 56px;\n  height: 32px;\n  transition: 0.4s;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), function (_a) {
    var active = _a.active;
    return "background-color: ".concat(active ? colorFormSurface.colorFormSurfaceChecked : colorSurface.tertiary, ";");
}, baseStyle({ borderRadius: '48px' }), hoverStyle, focusWithinStyle, activeStyle, disabledStyle);
var Slider$2 = styled.span(templateObject_2$y || (templateObject_2$y = __makeTemplateObject(["\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n\n  border-radius: 48px;\n  transition: 0.4s;\n\n  &:before {\n    position: absolute;\n    content: '';\n    height: 24px;\n    width: 24px;\n    left: 4px;\n    bottom: 4px;\n    background-color: ", ";\n    border-radius: 50%;\n    transition: 0.4s;\n  }\n"], ["\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n\n  border-radius: 48px;\n  transition: 0.4s;\n\n  &:before {\n    position: absolute;\n    content: '';\n    height: 24px;\n    width: 24px;\n    left: 4px;\n    bottom: 4px;\n    background-color: ", ";\n    border-radius: 50%;\n    transition: 0.4s;\n  }\n"])), colorSurface.primary);
var Input$1 = styled.input(templateObject_3$f || (templateObject_3$f = __makeTemplateObject(["\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  appearance: none;\n  outline: none;\n\n  &:checked + ", " {\n    &:before {\n      transform: translateX(26px);\n    }\n  }\n"], ["\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  appearance: none;\n  outline: none;\n\n  &:checked + ", " {\n    &:before {\n      transform: translateX(26px);\n    }\n  }\n"])), Slider$2);
var templateObject_1$1d, templateObject_2$y, templateObject_3$f;

var Toggle = function (_a) {
    var _b = _a.active, active = _b === void 0 ? false : _b, className = _a.className, _c = _a.disabled, disabled = _c === void 0 ? false : _c, id = _a.id, _d = _a.name, name = _d === void 0 ? 'switch' : _d, onChange = _a.onChange;
    var _e = useState(active), isActive = _e[0], setIsActive = _e[1];
    var handleOnChange = function (currentStatus) { return onChange && onChange(currentStatus); };
    var handleChange = function (event) {
        var checked = event.target.checked;
        setIsActive(checked);
        handleOnChange(checked);
    };
    useEffect(function () {
        setIsActive(active);
    }, [active]);
    return (jsxs(Label, __assign({ className: className, disabled: disabled, active: isActive }, { children: [jsx(Input$1, { type: "checkbox", "aria-label": name, name: name, id: id, checked: isActive, disabled: disabled, onChange: function (event) { return handleChange(event); } }), jsx(Slider$2, {})] })));
};

var getTooltipPositionProperties = function (_a) {
    var position = _a.position, margin = _a.margin;
    switch (position) {
        case 'right':
            return "\n      top: -5px;\n      left: 130%;\n      flex-direction: row;\n      align-items: flex-start;\n    ";
        case 'left':
            return "\n      top: -15px;\n      right: 140%;\n      flex-direction: row-reverse;\n      align-items: flex-start;\n    ";
        case 'top':
            return "\n      bottom: 140%;\n      left: 50%;\n      margin-left: calc(".concat(margin, " / -2);\n      flex-direction: column-reverse;\n      align-items: center;\n    ");
        case 'bottom':
            return "\n      top: 120%;\n      left: 50%;\n      margin-left: calc(".concat(margin, " / -2);\n      flex-direction: column;\n      align-items: center;\n    ");
    }
};
var StyledTooltip = styled.div(templateObject_1$1c || (templateObject_1$1c = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var scrollable = _a.scrollable, position = _a.position, width = _a.width, maxWidth = _a.maxWidth, margin = _a.margin, wordBreak = _a.wordBreak, alwaysVisible = _a.alwaysVisible;
    return "\n    width: ".concat(width, ";\n    max-width: ").concat(maxWidth, ";\n    visibility: ").concat(alwaysVisible ? 'visible' : 'hidden', ";\n    position: absolute;\n    word-break: ").concat(wordBreak ? 'break-word' : '', ";\n    z-index: 2;\n    display: flex;\n    ").concat(scrollable ? 'overflow-y: scroll;' : '', "\n    ").concat(scrollable ? 'max-height: 300px;' : '', "\n    ").concat(getTooltipPositionProperties({ position: position, margin: margin }), "\n  ");
});
var StyledText = styled.div(templateObject_2$x || (templateObject_2$x = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var textAlign = _a.textAlign, textWidth = _a.textWidth;
    return "\n    color: ".concat(colorText.colorTextTextPrimary, ";\n    text-align: ").concat(textAlign, ";\n    border-radius: 0px;\n    padding: 8px;\n    background-color: ").concat(colorSurface.tertiary, ";\n    border: 1px solid ").concat(colorBorder$1.colorBorderBorderFocus, ";\n    width: ").concat(textWidth, ";\n    box-shadow: ").concat(shadow.larger, ";\n    border-radius: 6px;\n  ");
});
var getArrowProperties = function (_a) {
    var position = _a.position;
    switch (position) {
        case 'right':
            return "\n      left: -5.6px;\n      top: calc(50% - 11.31px/2);\n      border-width: 0px 0px 1px 1px;\n      transform: rotate(45deg);\n\t\t";
        case 'left':
            return "\n      right: -5.48px;\n      top: calc(50% - 11.31px/2);\n      border-width: 1px 1px 0px 0px;\n      transform: rotate(45deg);\n    ";
        case 'top':
            return "\n      bottom: -5.8px;\n      border-width: 0px 0px 1px 1px;\n      transform: rotate(-45deg);\n    ";
        case 'bottom':
            return "\n      top: -5.3px;\n      border-width: 1px 1px 0px 0px;\n      transform: rotate(-45deg);\n\t\t";
    }
};
var StyledArrow = styled.div(templateObject_3$e || (templateObject_3$e = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var position = _a.position;
    return "\n    box-sizing: border-box;\n    position: absolute;\n    width: 11.32px;\n    height: 11.31px;\n    background: ".concat(colorSurface.tertiary, ";\n    border-style: solid;\n    border-color: ").concat(colorBorder$1.colorBorderBorderFocus, ";\n    z-index: 1;\n    ").concat(getArrowProperties({ position: position }), "\n  ");
});
var Container$7 = styled.div(templateObject_4$7 || (templateObject_4$7 = __makeTemplateObject(["\n  position: relative;\n  font-size: ", ";\n  font-family: ", ";\n  display: flex;\n  &:hover ", " {\n    visibility: visible;\n  }\n"], ["\n  position: relative;\n  font-size: ", ";\n  font-family: ", ";\n  display: flex;\n  &:hover ", " {\n    visibility: visible;\n  }\n"])), fontMap.smaller.fontSize, fontFamily, StyledTooltip);
var templateObject_1$1c, templateObject_2$x, templateObject_3$e, templateObject_4$7;

var truncatedText = function (text, maxLength) {
    if (maxLength && text && text.length > maxLength) {
        return text.substring(0, maxLength) + '...';
    }
    return text;
};
var Tooltip = function (_a) {
    var content = _a.content, children = _a.children, maxLength = _a.maxLength, _b = _a.position, position = _b === void 0 ? 'bottom' : _b, _c = _a.scrollable, scrollable = _c === void 0 ? false : _c, _d = _a.textAlign, textAlign = _d === void 0 ? 'center' : _d, _e = _a.textWidth, textWidth = _e === void 0 ? '100%' : _e, _f = _a.width, width = _f === void 0 ? 'max-content' : _f, _g = _a.maxWidth, maxWidth = _g === void 0 ? '280px' : _g, _h = _a.alwaysVisible, alwaysVisible = _h === void 0 ? false : _h, _j = _a.className, className = _j === void 0 ? 'container' : _j, _k = _a.tooltipClassName, tooltipClassName = _k === void 0 ? 'tooltip' : _k;
    var _l = React__default.useState(''), contentWidth = _l[0], setContentWidth = _l[1];
    var tootlipRef = useRef(null);
    useEffect(function () {
        var _a;
        if (width === 'max-content' && (tootlipRef === null || tootlipRef === void 0 ? void 0 : tootlipRef.current)) {
            setContentWidth("".concat((_a = tootlipRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth, "px"));
        }
        else {
            setContentWidth(width);
        }
    }, []);
    var getTootlipContent = function () {
        if (typeof content === 'string') {
            return (jsx(StyledText, __assign({ textAlign: textAlign, textWidth: textWidth, ref: tootlipRef }, { children: jsx(Body, { children: truncatedText(content, maxLength) }) })));
        }
        return jsx(StyledText, __assign({ ref: tootlipRef }, { children: content }));
    };
    return (jsx(Fragment, { children: jsxs(Container$7, __assign({ className: className }, { children: [children, jsxs(StyledTooltip, __assign({ className: tooltipClassName, "data-testid": tooltipClassName, scrollable: scrollable, position: position, width: width, maxWidth: maxWidth, margin: contentWidth, wordBreak: width === 'max-content', alwaysVisible: alwaysVisible }, { children: [jsx(StyledArrow, { position: position }), getTootlipContent()] }))] })) }));
};

var FoldLeft = styled.div(templateObject_1$1b || (templateObject_1$1b = __makeTemplateObject(["\n  left: -13px;\n  top: 25px;\n  position: absolute;\n  border-left: 13px solid transparent;\n  border-bottom: 7px solid transparent;\n  filter: brightness(0.9);\n"], ["\n  left: -13px;\n  top: 25px;\n  position: absolute;\n  border-left: 13px solid transparent;\n  border-bottom: 7px solid transparent;\n  filter: brightness(0.9);\n"])));
var FoldRight = styled.div(templateObject_2$w || (templateObject_2$w = __makeTemplateObject(["\n  right: -13px;\n  top: -7px;\n  transform: rotate(-180deg);\n  position: absolute;\n  border-left: 13px solid transparent;\n  border-bottom: 7px solid transparent;\n  filter: brightness(0.9);\n"], ["\n  right: -13px;\n  top: -7px;\n  transform: rotate(-180deg);\n  position: absolute;\n  border-left: 13px solid transparent;\n  border-bottom: 7px solid transparent;\n  filter: brightness(0.9);\n"])));
var templateObject_1$1b, templateObject_2$w;

var BlcBadgeBase = function (_a) {
    var text = _a.text, className = _a.className, children = _a.children;
    return (jsxs("div", __assign({ className: className }, { children: [jsx(FoldLeft, { className: "badge-fold" }), jsxs("div", __assign({ className: "badge-body" }, { children: [jsx("div", __assign({ "data-testid": "badge-icon", className: "badge-icon" }, { children: children })), jsxs("strong", { children: ["\u00A0", text] })] })), jsx(FoldRight, { className: "badge-fold" })] })));
};
var StyledBase = styled(BlcBadgeBase)(function (props) {
    return ({
        background: props.background,
        color: props.color,
        position: 'relative',
        '.badge-icon i': {
            color: props.color
        },
        '.badge-icon': {
            display: 'inherit'
        },
        '.badge-fold': {
            borderRight: "13px solid ".concat(props.background)
        },
        '.badge-body': {
            width: '106px',
            height: '25px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: '13px',
            fontFamily: fontFamily
        }
    });
});

var EliteSellerBadge = function () { return (jsx(StyledBase, __assign({ background: colorIcon.colorIconIconBrand, color: colorText.colorTextTextInvert, text: "Elite Dealer" }, { children: jsx(Icon, { size: "smaller", name: "elite", color: "colorIconIconInvert" }) }))); };

var TabTitle = function (props) { return jsx(Body, __assign({ bold: true }, { children: props.children })); };
var TabContent = function (props) { return jsx(Fragment, { children: props.children }); };
var TabSection = function (props) { return jsx(Fragment, { children: props.children }); };
var TabDropdown = function (props) { return jsx(Fragment, { children: props.children }); };

function makeTypeChecker(tabsRole){return element=>!!element.type&&element.type.tabsRole===tabsRole}const isTab=makeTypeChecker("Tab");const isTabList=makeTypeChecker("TabList");const isTabPanel=makeTypeChecker("TabPanel");

function isTabChild(child){return isTab(child)||isTabList(child)||isTabPanel(child)}function deepMap(children,callback){return Children.map(children,child=>{if(child===null)return null;if(isTabChild(child)){return callback(child)}if(child.props&&child.props.children&&typeof child.props.children==="object"){return cloneElement(child,{...child.props,children:deepMap(child.props.children,callback)})}return child})}function deepForEach(children,callback){return Children.forEach(children,child=>{if(child===null)return;if(isTab(child)||isTabPanel(child)){callback(child);}else if(child.props&&child.props.children&&typeof child.props.children==="object"){if(isTabList(child))callback(child);deepForEach(child.props.children,callback);}})}

function childrenPropType(props,propName,componentName){let error;let tabsCount=0;let panelsCount=0;let tabListFound=false;const listTabs=[];const children=props[propName];deepForEach(children,child=>{if(isTabList(child)){if(child.props&&child.props.children&&typeof child.props.children==="object"){deepForEach(child.props.children,listChild=>listTabs.push(listChild));}if(tabListFound){error=new Error("Found multiple 'TabList' components inside 'Tabs'. Only one is allowed.");}tabListFound=true;}if(isTab(child)){if(!tabListFound||listTabs.indexOf(child)===-1){error=new Error("Found a 'Tab' component outside of the 'TabList' component. 'Tab' components "+"have to be inside the 'TabList' component.");}tabsCount++;}else if(isTabPanel(child)){panelsCount++;}});if(!error&&tabsCount!==panelsCount){error=new Error(`There should be an equal number of 'Tab' and 'TabPanel' in \`${componentName}\`. `+`Received ${tabsCount} 'Tab' and ${panelsCount} 'TabPanel'.`);}return error}function onSelectPropType(props,propName,componentName,location,propFullName){const prop=props[propName];const name=propFullName||propName;let error=null;if(prop&&typeof prop!=="function"){error=new Error(`Invalid ${location} \`${name}\` of type \`${typeof prop}\` supplied `+`to \`${componentName}\`, expected \`function\`.`);}else if(props.selectedIndex!=null&&prop==null){error=new Error(`The ${location} \`${name}\` is marked as required in \`${componentName}\`, but `+`its value is \`undefined\` or \`null\`.\n`+`\`onSelect\` is required when \`selectedIndex\` is also set. Not doing so will `+`make the tabs not do anything, as \`selectedIndex\` indicates that you want to `+`handle the selected tab yourself.\n`+`If you only want to set the inital tab replace \`selectedIndex\` with \`defaultIndex\`.`);}return error}function selectedIndexPropType(props,propName,componentName,location,propFullName){const prop=props[propName];const name=propFullName||propName;let error=null;if(prop!=null&&typeof prop!=="number"){error=new Error(`Invalid ${location} \`${name}\` of type \`${typeof prop}\` supplied to `+`\`${componentName}\`, expected \`number\`.`);}else if(props.defaultIndex!=null&&prop!=null){return new Error(`The ${location} \`${name}\` cannot be used together with \`defaultIndex\` `+`in \`${componentName}\`.\n`+`Either remove \`${name}\` to let \`${componentName}\` handle the selected `+`tab internally or remove \`defaultIndex\` to handle it yourself.`)}return error}

function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}

function getTabsCount(children){let tabCount=0;deepForEach(children,child=>{if(isTab(child))tabCount++;});return tabCount}

function isNode(node){return node&&"getAttribute"in node}function isTabNode(node){return isNode(node)&&node.getAttribute("data-rttab")}function isTabDisabled(node){return isNode(node)&&node.getAttribute("aria-disabled")==="true"}let canUseActiveElement;function determineCanUseActiveElement(environment){const env=environment||(typeof window!=="undefined"?window:undefined);try{canUseActiveElement=!!(typeof env!=="undefined"&&env.document&&env.document.activeElement);}catch(e){canUseActiveElement=false;}}const defaultProps$5={className:"react-tabs",focus:false};const propTypes$4=process.env.NODE_ENV!=="production"?{children:childrenPropType,direction:propTypesExports.oneOf(["rtl","ltr"]),className:propTypesExports.oneOfType([propTypesExports.string,propTypesExports.array,propTypesExports.object]),disabledTabClassName:propTypesExports.string,disableUpDownKeys:propTypesExports.bool,disableLeftRightKeys:propTypesExports.bool,domRef:propTypesExports.func,focus:propTypesExports.bool,forceRenderTabPanel:propTypesExports.bool,onSelect:propTypesExports.func.isRequired,selectedIndex:propTypesExports.number.isRequired,selectedTabClassName:propTypesExports.string,selectedTabPanelClassName:propTypesExports.string,environment:propTypesExports.object}:{};const UncontrolledTabs=props=>{let tabNodes=useRef([]);let tabIds=useRef([]);const ref=useRef();function setSelected(index,event){if(index<0||index>=getTabsCount$1())return;const{onSelect,selectedIndex}=props;onSelect(index,selectedIndex,event);}function getNextTab(index){const count=getTabsCount$1();for(let i=index+1;i<count;i++){if(!isTabDisabled(getTab(i))){return i}}for(let i=0;i<index;i++){if(!isTabDisabled(getTab(i))){return i}}return index}function getPrevTab(index){let i=index;while(i--){if(!isTabDisabled(getTab(i))){return i}}i=getTabsCount$1();while(i-->index){if(!isTabDisabled(getTab(i))){return i}}return index}function getFirstTab(){const count=getTabsCount$1();for(let i=0;i<count;i++){if(!isTabDisabled(getTab(i))){return i}}return null}function getLastTab(){let i=getTabsCount$1();while(i--){if(!isTabDisabled(getTab(i))){return i}}return null}function getTabsCount$1(){const{children}=props;return getTabsCount(children)}function getTab(index){return tabNodes.current[`tabs-${index}`]}function getChildren(){let index=0;const{children,disabledTabClassName,focus,forceRenderTabPanel,selectedIndex,selectedTabClassName,selectedTabPanelClassName,environment}=props;tabIds.current=tabIds.current||[];let diff=tabIds.current.length-getTabsCount$1();const id=useId();while(diff++<0){tabIds.current.push(`${id}${tabIds.current.length}`);}return deepMap(children,child=>{let result=child;if(isTabList(child)){let listIndex=0;let wasTabFocused=false;if(canUseActiveElement==null){determineCanUseActiveElement(environment);}const env=environment||(typeof window!=="undefined"?window:undefined);if(canUseActiveElement&&env){wasTabFocused=React__default.Children.toArray(child.props.children).filter(isTab).some((tab,i)=>env.document.activeElement===getTab(i));}result=cloneElement(child,{children:deepMap(child.props.children,tab=>{const key=`tabs-${listIndex}`;const selected=selectedIndex===listIndex;const props={tabRef:node=>{tabNodes.current[key]=node;},id:tabIds.current[listIndex],selected,focus:selected&&(focus||wasTabFocused)};if(selectedTabClassName)props.selectedClassName=selectedTabClassName;if(disabledTabClassName)props.disabledClassName=disabledTabClassName;listIndex++;return cloneElement(tab,props)})});}else if(isTabPanel(child)){const props={id:tabIds.current[index],selected:selectedIndex===index};if(forceRenderTabPanel)props.forceRender=forceRenderTabPanel;if(selectedTabPanelClassName)props.selectedClassName=selectedTabPanelClassName;index++;result=cloneElement(child,props);}return result})}function handleKeyDown(e){const{direction,disableUpDownKeys,disableLeftRightKeys}=props;if(isTabFromContainer(e.target)){let{selectedIndex:index}=props;let preventDefault=false;let useSelectedIndex=false;if(e.code==="Space"||e.keyCode===32||e.code==="Enter"||e.keyCode===13){preventDefault=true;useSelectedIndex=false;handleClick(e);}if(!disableLeftRightKeys&&(e.keyCode===37||e.code==="ArrowLeft")||!disableUpDownKeys&&(e.keyCode===38||e.code==="ArrowUp")){if(direction==="rtl"){index=getNextTab(index);}else {index=getPrevTab(index);}preventDefault=true;useSelectedIndex=true;}else if(!disableLeftRightKeys&&(e.keyCode===39||e.code==="ArrowRight")||!disableUpDownKeys&&(e.keyCode===40||e.code==="ArrowDown")){if(direction==="rtl"){index=getPrevTab(index);}else {index=getNextTab(index);}preventDefault=true;useSelectedIndex=true;}else if(e.keyCode===35||e.code==="End"){index=getLastTab();preventDefault=true;useSelectedIndex=true;}else if(e.keyCode===36||e.code==="Home"){index=getFirstTab();preventDefault=true;useSelectedIndex=true;}if(preventDefault){e.preventDefault();}if(useSelectedIndex){setSelected(index,e);}}}function handleClick(e){let node=e.target;do{if(isTabFromContainer(node)){if(isTabDisabled(node)){return}const index=[].slice.call(node.parentNode.children).filter(isTabNode).indexOf(node);setSelected(index,e);return}}while((node=node.parentNode)!=null)}function isTabFromContainer(node){if(!isTabNode(node)){return false}let nodeAncestor=node.parentElement;do{if(nodeAncestor===ref.current)return true;if(nodeAncestor.getAttribute("data-rttabs"))break;nodeAncestor=nodeAncestor.parentElement;}while(nodeAncestor);return false}const{children,className,disabledTabClassName,domRef,focus,forceRenderTabPanel,onSelect,selectedIndex,selectedTabClassName,selectedTabPanelClassName,environment,disableUpDownKeys,disableLeftRightKeys,...attributes}=props;return React__default.createElement("div",Object.assign({},attributes,{className:clsx(className),onClick:handleClick,onKeyDown:handleKeyDown,ref:node=>{ref.current=node;if(domRef)domRef(node);},"data-rttabs":true}),getChildren())};UncontrolledTabs.defaultProps=defaultProps$5;UncontrolledTabs.propTypes=process.env.NODE_ENV!=="production"?propTypes$4:{};

const MODE_CONTROLLED=0;const MODE_UNCONTROLLED=1;const propTypes$3=process.env.NODE_ENV!=="production"?{children:childrenPropType,className:propTypesExports.oneOfType([propTypesExports.string,propTypesExports.array,propTypesExports.object]),defaultFocus:propTypesExports.bool,defaultIndex:propTypesExports.number,direction:propTypesExports.oneOf(["rtl","ltr"]),disabledTabClassName:propTypesExports.string,disableUpDownKeys:propTypesExports.bool,disableLeftRightKeys:propTypesExports.bool,domRef:propTypesExports.func,environment:propTypesExports.object,focusTabOnClick:propTypesExports.bool,forceRenderTabPanel:propTypesExports.bool,onSelect:onSelectPropType,selectedIndex:selectedIndexPropType,selectedTabClassName:propTypesExports.string,selectedTabPanelClassName:propTypesExports.string}:{};const defaultProps$4={defaultFocus:false,focusTabOnClick:true,forceRenderTabPanel:false,selectedIndex:null,defaultIndex:null,environment:null,disableUpDownKeys:false,disableLeftRightKeys:false};const getModeFromProps=props=>{return props.selectedIndex===null?MODE_UNCONTROLLED:MODE_CONTROLLED};const checkForIllegalModeChange=(props,mode)=>{if(process.env.NODE_ENV!=="production"&&mode!=undefined&&mode!==getModeFromProps(props)){throw new Error(`Switching between controlled mode (by using \`selectedIndex\`) and uncontrolled mode is not supported in \`Tabs\`.
For more information about controlled and uncontrolled mode of react-tabs see https://github.com/reactjs/react-tabs#controlled-vs-uncontrolled-mode.`)}};const Tabs=props=>{const{children,defaultFocus,defaultIndex,focusTabOnClick,onSelect}=props;const[focus,setFocus]=useState(defaultFocus);const[mode]=useState(getModeFromProps(props));const[selectedIndex,setSelectedIndex]=useState(mode===MODE_UNCONTROLLED?defaultIndex||0:null);useEffect(()=>{setFocus(false);},[]);if(mode===MODE_UNCONTROLLED){const tabsCount=getTabsCount(children);useEffect(()=>{if(selectedIndex!=null){const maxTabIndex=Math.max(0,tabsCount-1);setSelectedIndex(Math.min(selectedIndex,maxTabIndex));}},[tabsCount]);}checkForIllegalModeChange(props,mode);const handleSelected=(index,last,event)=>{if(typeof onSelect==="function"){if(onSelect(index,last,event)===false)return}if(focusTabOnClick){setFocus(true);}if(mode===MODE_UNCONTROLLED){setSelectedIndex(index);}};let subProps={...props};subProps.focus=focus;subProps.onSelect=handleSelected;if(selectedIndex!=null){subProps.selectedIndex=selectedIndex;}delete subProps.defaultFocus;delete subProps.defaultIndex;delete subProps.focusTabOnClick;return React__default.createElement(UncontrolledTabs,subProps,children)};Tabs.propTypes=process.env.NODE_ENV!=="production"?propTypes$3:{};Tabs.defaultProps=defaultProps$4;Tabs.tabsRole="Tabs";

const defaultProps$3={className:"react-tabs__tab-list"};const propTypes$2=process.env.NODE_ENV!=="production"?{children:propTypesExports.oneOfType([propTypesExports.object,propTypesExports.array]),className:propTypesExports.oneOfType([propTypesExports.string,propTypesExports.array,propTypesExports.object])}:{};const TabList=props=>{const{children,className,...attributes}=props;return React__default.createElement("ul",Object.assign({},attributes,{className:clsx(className),role:"tablist"}),children)};TabList.tabsRole="TabList";TabList.propTypes=process.env.NODE_ENV!=="production"?propTypes$2:{};TabList.defaultProps=defaultProps$3;

const DEFAULT_CLASS$1="react-tabs__tab";const defaultProps$2={className:DEFAULT_CLASS$1,disabledClassName:`${DEFAULT_CLASS$1}--disabled`,focus:false,id:null,selected:false,selectedClassName:`${DEFAULT_CLASS$1}--selected`};const propTypes$1=process.env.NODE_ENV!=="production"?{children:propTypesExports.oneOfType([propTypesExports.array,propTypesExports.object,propTypesExports.string]),className:propTypesExports.oneOfType([propTypesExports.string,propTypesExports.array,propTypesExports.object]),disabled:propTypesExports.bool,disabledClassName:propTypesExports.string,focus:propTypesExports.bool,id:propTypesExports.string,selected:propTypesExports.bool,selectedClassName:propTypesExports.string,tabIndex:propTypesExports.string,tabRef:propTypesExports.func}:{};const Tab=props=>{let nodeRef=useRef();const{children,className,disabled,disabledClassName,focus,id,selected,selectedClassName,tabIndex,tabRef,...attributes}=props;useEffect(()=>{if(selected&&focus){nodeRef.current.focus();}},[selected,focus]);return React__default.createElement("li",Object.assign({},attributes,{className:clsx(className,{[selectedClassName]:selected,[disabledClassName]:disabled}),ref:node=>{nodeRef.current=node;if(tabRef)tabRef(node);},role:"tab",id:`tab${id}`,"aria-selected":selected?"true":"false","aria-disabled":disabled?"true":"false","aria-controls":`panel${id}`,tabIndex:tabIndex||(selected?"0":null),"data-rttab":true}),children)};Tab.propTypes=process.env.NODE_ENV!=="production"?propTypes$1:{};Tab.tabsRole="Tab";Tab.defaultProps=defaultProps$2;

const DEFAULT_CLASS="react-tabs__tab-panel";const defaultProps$1={className:DEFAULT_CLASS,forceRender:false,selectedClassName:`${DEFAULT_CLASS}--selected`};const propTypes=process.env.NODE_ENV!=="production"?{children:propTypesExports.node,className:propTypesExports.oneOfType([propTypesExports.string,propTypesExports.array,propTypesExports.object]),forceRender:propTypesExports.bool,id:propTypesExports.string,selected:propTypesExports.bool,selectedClassName:propTypesExports.string}:{};const TabPanel=props=>{const{children,className,forceRender,id,selected,selectedClassName,...attributes}=props;return React__default.createElement("div",Object.assign({},attributes,{className:clsx(className,{[selectedClassName]:selected}),role:"tabpanel",id:`panel${id}`,"aria-labelledby":`tab${id}`}),forceRender||selected?children:null)};TabPanel.tabsRole="TabPanel";TabPanel.propTypes=process.env.NODE_ENV!=="production"?propTypes:{};TabPanel.defaultProps=defaultProps$1;

/* eslint-disable @typescript-eslint/no-explicit-any */
var filterReact = function (array) {
    return array.filter(function (e) { return React__default.isValidElement(e); });
};
var reactChildren = function (children) {
    return filterReact(React__default.Children.toArray(children));
};
var filterType = function (children, types) {
    return reactChildren(children).filter(function (e) {
        return types.includes(e.type);
    });
};
var filterNotType = function (children, type) {
    return reactChildren(children).filter(function (e) {
        return e.type !== type;
    });
};
var reactChildrenByType = function (wrapper, types) {
    return wrapper.flatMap(function (e) {
        return filterType(e.props.children, types);
    });
};
var reactChildrenByNotType = function (wrapper, type) {
    return wrapper.flatMap(function (e) {
        return filterNotType(e.props.children, type);
    });
};

var StyledCustomSelect = styled(Select).attrs(function (props) { return ({
    defaultValue: props.defaultValue
}); })(templateObject_1$1a || (templateObject_1$1a = __makeTemplateObject(["\n  border: none;\n"], ["\n  border: none;\n"])));
var createDropdownTab = function (tabDropdownComponent, index) {
    var _a = tabDropdownComponent.props, customKey = _a.customKey, disabled = _a.disabled, children = _a.children, dropdownProps = __rest(_a, ["customKey", "disabled", "children"]);
    var items = filterType(children, [SelectItem]);
    return (jsx(Tab, __assign({ className: "blc-dropdown-tab", disabledClassName: "blc-dropdown-tab-disabled", selectedClassName: "blc-dropdown-tab-selected", disabled: disabled, "data-testid": "tab-dropdown-".concat(index) }, { children: jsx(StyledCustomSelect, __assign({ bold: true, size: "smallest", dropdownWidth: "354px", disabled: disabled, "data-testid": "tab-dropdown-trigger-".concat(index), "data-tab-title": "true" }, dropdownProps, { children: items })) }), customKey || "blc-dropdown-tab-key-".concat(index)));
};
var createTab = function (tabTitleContent, index) {
    var _a;
    return (jsx(Tab, __assign({ disabled: tabTitleContent.props.disabled, className: "blc-tab", disabledClassName: "blc-tab-disabled", selectedClassName: "blc-tab-selected", "data-tab-title": "true" }, { children: tabTitleContent }), ((_a = tabTitleContent === null || tabTitleContent === void 0 ? void 0 : tabTitleContent.props) === null || _a === void 0 ? void 0 : _a.customKey) || "blc-tab-key-".concat(index)));
};
var createTabs = function (sections) {
    return reactChildrenByType(sections, [TabTitle, TabDropdown]).map(function (e, index) {
        return e.type === TabDropdown ? createDropdownTab(e, index) : createTab(e, index);
    });
};
var createUnsafeTabs = function (sections) {
    return reactChildrenByNotType(sections, TabContent).map(function (e, index) {
        return e.type === TabDropdown ? createDropdownTab(e, index) : createTab(e, index);
    });
};
var createPanel = function (panelContent, forceRender, index) {
    var _a;
    return (jsx(TabPanel, __assign({ className: "blc-tab-panel", selectedClassName: "blc-tab-panel-selected", forceRender: forceRender }, { children: panelContent }), ((_a = panelContent === null || panelContent === void 0 ? void 0 : panelContent.props) === null || _a === void 0 ? void 0 : _a.customKey) || "blc-panel-key-".concat(index)));
};
var createPanels = function (sections, forceRender) {
    return reactChildrenByType(sections, [TabContent]).map(function (e, index) { return createPanel(e, forceRender, index); });
};
var templateObject_1$1a;

var BaseTabs = function (_a) {
    var children = _a.children, className = _a.className, onSelect = _a.onSelect, _b = _a.defaultFocus, defaultFocus = _b === void 0 ? false : _b, defaultIndex = _a.defaultIndex, _c = _a.forceRenderTabPanel, forceRenderTabPanel = _c === void 0 ? false : _c, selectedIndex = _a.selectedIndex, _d = _a.safeMode, safeMode = _d === void 0 ? true : _d;
    var sections = reactChildren(children);
    var tabs = safeMode ? createTabs(sections) : createUnsafeTabs(sections);
    var panels = createPanels(sections, forceRenderTabPanel);
    return (jsxs(Tabs, __assign({ className: className, defaultFocus: defaultFocus, defaultIndex: defaultIndex, forceRenderTabPanel: forceRenderTabPanel, onSelect: onSelect, selectedIndex: selectedIndex }, { children: [jsx(TabList, __assign({ className: "blc-tab-list" }, { children: tabs })), panels] })));
};

var StyledBlcTabs = styled(BaseTabs)(function (_a) {
    var _b;
    var _c = _a.size, size = _c === void 0 ? 'normal' : _c, margin = _a.margin;
    return (_b = {
            '.blc-tab-panel': {
                display: 'none',
                fontSize: getTextSizeML(size)
            },
            '.blc-tab-panel-selected': {
                display: 'block'
            },
            '.blc-tab-list': {
                borderBottom: "solid ".concat(colorBorder$1.colorBorderBorderPrimary),
                borderWidth: sizeMap.border.mxl,
                display: 'flex',
                flexWrap: 'wrap',
                margin: getSpaceMXL(margin),
                padding: '0'
            },
            '.blc-tab': {
                display: 'flex',
                alignItems: 'center',
                appearance: 'none',
                borderStyle: 'solid',
                borderWidth: '0',
                borderBottomWidth: sizeMap.line.mxl,
                borderColor: customColors.transparent,
                cursor: 'pointer',
                listStyle: 'none',
                textAlign: 'center',
                transaction: 'border 0.15s linear',
                padding: '16px 16px 12px',
                '&[data-tab-title="true"]': {
                    p: {
                        color: colorText.colorTextTextSecondary
                    }
                }
            },
            '.blc-dropdown-tab': {
                display: 'flex',
                alignItems: 'center',
                appearance: 'none',
                borderStyle: 'solid',
                borderWidth: '0',
                borderBottomWidth: sizeMap.line.mxl,
                borderColor: customColors.transparent,
                cursor: 'pointer',
                listStyle: 'none',
                textAlign: 'center',
                transaction: 'border 0.15s linear',
                button: {
                    minHeight: 'auto',
                    height: 'auto',
                    minWidth: 'auto',
                    padding: '16px 16px 12px',
                    zIndex: '-1',
                    '&[data-tab-title="true"]': {
                        p: {
                            color: colorText.colorTextTextSecondary
                        }
                    }
                }
            },
            '.blc-dropdown-tab-disabled': {
                cursor: 'not-allowed',
                button: {
                    backgroundColor: colorSurface.primary,
                    '&[data-tab-title="true"]': {
                        p: {
                            color: colorText.colorTextTextDisabled
                        }
                    }
                },
                svg: {
                    color: colorText.colorTextTextDisabled
                }
            },
            '.blc-dropdown-tab-selected': {
                borderColor: customColors.blcTabSelectedBorder,
                button: {
                    zIndex: '1',
                    '&[data-tab-title="true"]': {
                        p: {
                            color: colorText.colorTextTextPrimary
                        }
                    }
                },
                'button:focus-visible': {
                    outline: 'none',
                    boxShadow: 'none'
                }
            },
            '.blc-tab-selected': {
                borderColor: customColors.blcTabSelectedBorder,
                '&[data-tab-title="true"]': {
                    p: {
                        color: colorText.colorTextTextPrimary
                    }
                }
            },
            '.blc-tab-disabled': {
                '&[data-tab-title="true"]': {
                    p: {
                        color: colorText.colorTextTextDisabled
                    }
                },
                cursor: 'not-allowed'
            },
            '.blc-tab:focus': {
                outline: 'none'
            },
            '.blc-dropdown-tab:focus-visible': {
                outline: 'none'
            }
        },
        _b["@media ".concat(mediaSizeMap.largest)] = {
            '.blc-tab-list': {
                borderWidth: sizeMap.border.mxl,
                margin: getSpaceMXL(margin)
            },
            '.blc-tab': {
                borderBottomWidth: sizeMap.line.mxl
            }
        },
        _b["@media ".concat(mediaSizeMap.larger)] = {
            '.blc-tab-list': {
                borderWidth: sizeMap.border.ml,
                margin: getSpaceML(margin),
                borderBottomWidth: sizeMap.line.ml
            }
        },
        _b["@media ".concat(mediaSizeMap.smaller)] = {
            '.blc-tab-list': {
                borderWidth: sizeMap.border.ms,
                margin: getSpaceMS(margin),
                borderBottomWidth: sizeMap.line.ms
            }
        },
        _b["@media ".concat(mediaSizeMap.smallest)] = {
            '.blc-tab-list': {
                borderWidth: sizeMap.border.mxs,
                flexWrap: 'nowrap',
                margin: getSpaceMXS(margin),
                overflowX: 'auto',
                borderBottomWidth: sizeMap.line.mxs
            }
        },
        _b);
});

/* -------------------------------------------------------------------------------------------------
 * Collapsible
 * -----------------------------------------------------------------------------------------------*/ const $409067139f391064$var$COLLAPSIBLE_NAME = 'Collapsible';
const [$409067139f391064$var$createCollapsibleContext, $409067139f391064$export$952b32dcbe73087a] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($409067139f391064$var$COLLAPSIBLE_NAME);
const [$409067139f391064$var$CollapsibleProvider, $409067139f391064$var$useCollapsibleContext] = $409067139f391064$var$createCollapsibleContext($409067139f391064$var$COLLAPSIBLE_NAME);
const $409067139f391064$export$6eb0f7ddcda6131f = /*#__PURE__*/ forwardRef((props, forwardedRef)=>{
    const { __scopeCollapsible: __scopeCollapsible , open: openProp , defaultOpen: defaultOpen , disabled: disabled , onOpenChange: onOpenChange , ...collapsibleProps } = props;
    const [open = false, setOpen] = $71cd76cc60e0454e$export$6f32135080cb4c3({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ createElement($409067139f391064$var$CollapsibleProvider, {
        scope: __scopeCollapsible,
        disabled: disabled,
        contentId: $1746a345f3d73bb7$export$f680877a34711e37(),
        open: open,
        onOpenToggle: useCallback(()=>setOpen((prevOpen)=>!prevOpen
            )
        , [
            setOpen
        ])
    }, /*#__PURE__*/ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends({
        "data-state": $409067139f391064$var$getState(open),
        "data-disabled": disabled ? '' : undefined
    }, collapsibleProps, {
        ref: forwardedRef
    })));
});
/* -------------------------------------------------------------------------------------------------
 * CollapsibleTrigger
 * -----------------------------------------------------------------------------------------------*/ const $409067139f391064$var$TRIGGER_NAME = 'CollapsibleTrigger';
const $409067139f391064$export$c135dce7b15bbbdc = /*#__PURE__*/ forwardRef((props, forwardedRef)=>{
    const { __scopeCollapsible: __scopeCollapsible , ...triggerProps } = props;
    const context = $409067139f391064$var$useCollapsibleContext($409067139f391064$var$TRIGGER_NAME, __scopeCollapsible);
    return /*#__PURE__*/ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.button, _extends({
        type: "button",
        "aria-controls": context.contentId,
        "aria-expanded": context.open || false,
        "data-state": $409067139f391064$var$getState(context.open),
        "data-disabled": context.disabled ? '' : undefined,
        disabled: context.disabled
    }, triggerProps, {
        ref: forwardedRef,
        onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onClick, context.onOpenToggle)
    }));
});
/* -------------------------------------------------------------------------------------------------
 * CollapsibleContent
 * -----------------------------------------------------------------------------------------------*/ const $409067139f391064$var$CONTENT_NAME = 'CollapsibleContent';
const $409067139f391064$export$aadde00976f34151 = /*#__PURE__*/ forwardRef((props, forwardedRef)=>{
    const { forceMount: forceMount , ...contentProps } = props;
    const context = $409067139f391064$var$useCollapsibleContext($409067139f391064$var$CONTENT_NAME, props.__scopeCollapsible);
    return /*#__PURE__*/ createElement($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
        present: forceMount || context.open
    }, ({ present: present  })=>/*#__PURE__*/ createElement($409067139f391064$var$CollapsibleContentImpl, _extends({}, contentProps, {
            ref: forwardedRef,
            present: present
        }))
    );
});
/* -----------------------------------------------------------------------------------------------*/ const $409067139f391064$var$CollapsibleContentImpl = /*#__PURE__*/ forwardRef((props, forwardedRef)=>{
    const { __scopeCollapsible: __scopeCollapsible , present: present , children: children , ...contentProps } = props;
    const context = $409067139f391064$var$useCollapsibleContext($409067139f391064$var$CONTENT_NAME, __scopeCollapsible);
    const [isPresent, setIsPresent] = useState(present);
    const ref = useRef(null);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
    const heightRef = useRef(0);
    const height = heightRef.current;
    const widthRef = useRef(0);
    const width = widthRef.current; // when opening we want it to immediately open to retrieve dimensions
    // when closing we delay `present` to retrieve dimensions before closing
    const isOpen = context.open || isPresent;
    const isMountAnimationPreventedRef = useRef(isOpen);
    const originalStylesRef = useRef();
    useEffect(()=>{
        const rAF = requestAnimationFrame(()=>isMountAnimationPreventedRef.current = false
        );
        return ()=>cancelAnimationFrame(rAF)
        ;
    }, []);
    $9f79659886946c16$export$e5c5a5f917a5871c(()=>{
        const node = ref.current;
        if (node) {
            originalStylesRef.current = originalStylesRef.current || {
                transitionDuration: node.style.transitionDuration,
                animationName: node.style.animationName
            }; // block any animations/transitions so the element renders at its full dimensions
            node.style.transitionDuration = '0s';
            node.style.animationName = 'none'; // get width and height from full dimensions
            const rect = node.getBoundingClientRect();
            heightRef.current = rect.height;
            widthRef.current = rect.width; // kick off any animations/transitions that were originally set up if it isn't the initial mount
            if (!isMountAnimationPreventedRef.current) {
                node.style.transitionDuration = originalStylesRef.current.transitionDuration;
                node.style.animationName = originalStylesRef.current.animationName;
            }
            setIsPresent(present);
        }
    /**
     * depends on `context.open` because it will change to `false`
     * when a close is triggered but `present` will be `false` on
     * animation end (so when close finishes). This allows us to
     * retrieve the dimensions *before* closing.
     */ }, [
        context.open,
        present
    ]);
    return /*#__PURE__*/ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends({
        "data-state": $409067139f391064$var$getState(context.open),
        "data-disabled": context.disabled ? '' : undefined,
        id: context.contentId,
        hidden: !isOpen
    }, contentProps, {
        ref: composedRefs,
        style: {
            [`--radix-collapsible-content-height`]: height ? `${height}px` : undefined,
            [`--radix-collapsible-content-width`]: width ? `${width}px` : undefined,
            ...props.style
        }
    }), isOpen && children);
});
/* -----------------------------------------------------------------------------------------------*/ function $409067139f391064$var$getState(open) {
    return open ? 'open' : 'closed';
}
const $409067139f391064$export$be92b6f5f03c0fe9 = $409067139f391064$export$6eb0f7ddcda6131f;
const $409067139f391064$export$41fb9f06171c75f4 = $409067139f391064$export$c135dce7b15bbbdc;
const $409067139f391064$export$7c6e2c02157bb7d2 = $409067139f391064$export$aadde00976f34151;

/* -------------------------------------------------------------------------------------------------
 * Accordion
 * -----------------------------------------------------------------------------------------------*/ const $1bf158f521e1b1b4$var$ACCORDION_NAME = 'Accordion';
const $1bf158f521e1b1b4$var$ACCORDION_KEYS = [
    'Home',
    'End',
    'ArrowDown',
    'ArrowUp',
    'ArrowLeft',
    'ArrowRight'
];
const [$1bf158f521e1b1b4$var$Collection, $1bf158f521e1b1b4$var$useCollection, $1bf158f521e1b1b4$var$createCollectionScope] = $e02a7d9cb1dc128c$export$c74125a8e3af6bb2($1bf158f521e1b1b4$var$ACCORDION_NAME);
const [$1bf158f521e1b1b4$var$createAccordionContext, $1bf158f521e1b1b4$export$9748edc328a73be1] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($1bf158f521e1b1b4$var$ACCORDION_NAME, [
    $1bf158f521e1b1b4$var$createCollectionScope,
    $409067139f391064$export$952b32dcbe73087a
]);
const $1bf158f521e1b1b4$var$useCollapsibleScope = $409067139f391064$export$952b32dcbe73087a();
const $1bf158f521e1b1b4$export$a766cd26d0d69044 = /*#__PURE__*/ React__default.forwardRef((props, forwardedRef)=>{
    const { type: type , ...accordionProps } = props;
    const singleProps = accordionProps;
    const multipleProps = accordionProps;
    return /*#__PURE__*/ React__default.createElement($1bf158f521e1b1b4$var$Collection.Provider, {
        scope: props.__scopeAccordion
    }, type === 'multiple' ? /*#__PURE__*/ React__default.createElement($1bf158f521e1b1b4$var$AccordionImplMultiple, _extends({}, multipleProps, {
        ref: forwardedRef
    })) : /*#__PURE__*/ React__default.createElement($1bf158f521e1b1b4$var$AccordionImplSingle, _extends({}, singleProps, {
        ref: forwardedRef
    })));
});
$1bf158f521e1b1b4$export$a766cd26d0d69044.propTypes = {
    type (props) {
        const value = props.value || props.defaultValue;
        if (props.type && ![
            'single',
            'multiple'
        ].includes(props.type)) return new Error('Invalid prop `type` supplied to `Accordion`. Expected one of `single | multiple`.');
        if (props.type === 'multiple' && typeof value === 'string') return new Error('Invalid prop `type` supplied to `Accordion`. Expected `single` when `defaultValue` or `value` is type `string`.');
        if (props.type === 'single' && Array.isArray(value)) return new Error('Invalid prop `type` supplied to `Accordion`. Expected `multiple` when `defaultValue` or `value` is type `string[]`.');
        return null;
    }
};
/* -----------------------------------------------------------------------------------------------*/ const [$1bf158f521e1b1b4$var$AccordionValueProvider, $1bf158f521e1b1b4$var$useAccordionValueContext] = $1bf158f521e1b1b4$var$createAccordionContext($1bf158f521e1b1b4$var$ACCORDION_NAME);
const [$1bf158f521e1b1b4$var$AccordionCollapsibleProvider, $1bf158f521e1b1b4$var$useAccordionCollapsibleContext] = $1bf158f521e1b1b4$var$createAccordionContext($1bf158f521e1b1b4$var$ACCORDION_NAME, {
    collapsible: false
});
const $1bf158f521e1b1b4$var$AccordionImplSingle = /*#__PURE__*/ React__default.forwardRef((props, forwardedRef)=>{
    const { value: valueProp , defaultValue: defaultValue , onValueChange: onValueChange = ()=>{} , collapsible: collapsible = false , ...accordionSingleProps } = props;
    const [value, setValue] = $71cd76cc60e0454e$export$6f32135080cb4c3({
        prop: valueProp,
        defaultProp: defaultValue,
        onChange: onValueChange
    });
    return /*#__PURE__*/ React__default.createElement($1bf158f521e1b1b4$var$AccordionValueProvider, {
        scope: props.__scopeAccordion,
        value: value ? [
            value
        ] : [],
        onItemOpen: setValue,
        onItemClose: React__default.useCallback(()=>collapsible && setValue('')
        , [
            collapsible,
            setValue
        ])
    }, /*#__PURE__*/ React__default.createElement($1bf158f521e1b1b4$var$AccordionCollapsibleProvider, {
        scope: props.__scopeAccordion,
        collapsible: collapsible
    }, /*#__PURE__*/ React__default.createElement($1bf158f521e1b1b4$var$AccordionImpl, _extends({}, accordionSingleProps, {
        ref: forwardedRef
    }))));
});
/* -----------------------------------------------------------------------------------------------*/ const $1bf158f521e1b1b4$var$AccordionImplMultiple = /*#__PURE__*/ React__default.forwardRef((props, forwardedRef)=>{
    const { value: valueProp , defaultValue: defaultValue , onValueChange: onValueChange = ()=>{} , ...accordionMultipleProps } = props;
    const [value1 = [], setValue] = $71cd76cc60e0454e$export$6f32135080cb4c3({
        prop: valueProp,
        defaultProp: defaultValue,
        onChange: onValueChange
    });
    const handleItemOpen = React__default.useCallback((itemValue)=>setValue((prevValue = [])=>[
                ...prevValue,
                itemValue
            ]
        )
    , [
        setValue
    ]);
    const handleItemClose = React__default.useCallback((itemValue)=>setValue((prevValue = [])=>prevValue.filter((value)=>value !== itemValue
            )
        )
    , [
        setValue
    ]);
    return /*#__PURE__*/ React__default.createElement($1bf158f521e1b1b4$var$AccordionValueProvider, {
        scope: props.__scopeAccordion,
        value: value1,
        onItemOpen: handleItemOpen,
        onItemClose: handleItemClose
    }, /*#__PURE__*/ React__default.createElement($1bf158f521e1b1b4$var$AccordionCollapsibleProvider, {
        scope: props.__scopeAccordion,
        collapsible: true
    }, /*#__PURE__*/ React__default.createElement($1bf158f521e1b1b4$var$AccordionImpl, _extends({}, accordionMultipleProps, {
        ref: forwardedRef
    }))));
});
/* -----------------------------------------------------------------------------------------------*/ const [$1bf158f521e1b1b4$var$AccordionImplProvider, $1bf158f521e1b1b4$var$useAccordionContext] = $1bf158f521e1b1b4$var$createAccordionContext($1bf158f521e1b1b4$var$ACCORDION_NAME);
const $1bf158f521e1b1b4$var$AccordionImpl = /*#__PURE__*/ React__default.forwardRef((props, forwardedRef)=>{
    const { __scopeAccordion: __scopeAccordion , disabled: disabled , dir: dir , orientation: orientation = 'vertical' , ...accordionProps } = props;
    const accordionRef = React__default.useRef(null);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(accordionRef, forwardedRef);
    const getItems = $1bf158f521e1b1b4$var$useCollection(__scopeAccordion);
    const direction = $f631663db3294ace$export$b39126d51d94e6f3(dir);
    const isDirectionLTR = direction === 'ltr';
    const handleKeyDown = $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onKeyDown, (event)=>{
        var _triggerCollection$cl;
        if (!$1bf158f521e1b1b4$var$ACCORDION_KEYS.includes(event.key)) return;
        const target = event.target;
        const triggerCollection = getItems().filter((item)=>{
            var _item$ref$current;
            return !((_item$ref$current = item.ref.current) !== null && _item$ref$current !== void 0 && _item$ref$current.disabled);
        });
        const triggerIndex = triggerCollection.findIndex((item)=>item.ref.current === target
        );
        const triggerCount = triggerCollection.length;
        if (triggerIndex === -1) return; // Prevents page scroll while user is navigating
        event.preventDefault();
        let nextIndex = triggerIndex;
        const homeIndex = 0;
        const endIndex = triggerCount - 1;
        const moveNext = ()=>{
            nextIndex = triggerIndex + 1;
            if (nextIndex > endIndex) nextIndex = homeIndex;
        };
        const movePrev = ()=>{
            nextIndex = triggerIndex - 1;
            if (nextIndex < homeIndex) nextIndex = endIndex;
        };
        switch(event.key){
            case 'Home':
                nextIndex = homeIndex;
                break;
            case 'End':
                nextIndex = endIndex;
                break;
            case 'ArrowRight':
                if (orientation === 'horizontal') {
                    if (isDirectionLTR) moveNext();
                    else movePrev();
                }
                break;
            case 'ArrowDown':
                if (orientation === 'vertical') moveNext();
                break;
            case 'ArrowLeft':
                if (orientation === 'horizontal') {
                    if (isDirectionLTR) movePrev();
                    else moveNext();
                }
                break;
            case 'ArrowUp':
                if (orientation === 'vertical') movePrev();
                break;
        }
        const clampedIndex = nextIndex % triggerCount;
        (_triggerCollection$cl = triggerCollection[clampedIndex].ref.current) === null || _triggerCollection$cl === void 0 || _triggerCollection$cl.focus();
    });
    return /*#__PURE__*/ React__default.createElement($1bf158f521e1b1b4$var$AccordionImplProvider, {
        scope: __scopeAccordion,
        disabled: disabled,
        direction: dir,
        orientation: orientation
    }, /*#__PURE__*/ React__default.createElement($1bf158f521e1b1b4$var$Collection.Slot, {
        scope: __scopeAccordion
    }, /*#__PURE__*/ React__default.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends({}, accordionProps, {
        "data-orientation": orientation,
        ref: composedRefs,
        onKeyDown: disabled ? undefined : handleKeyDown
    }))));
});
/* -------------------------------------------------------------------------------------------------
 * AccordionItem
 * -----------------------------------------------------------------------------------------------*/ const $1bf158f521e1b1b4$var$ITEM_NAME = 'AccordionItem';
const [$1bf158f521e1b1b4$var$AccordionItemProvider, $1bf158f521e1b1b4$var$useAccordionItemContext] = $1bf158f521e1b1b4$var$createAccordionContext($1bf158f521e1b1b4$var$ITEM_NAME);
/**
 * `AccordionItem` contains all of the parts of a collapsible section inside of an `Accordion`.
 */ const $1bf158f521e1b1b4$export$d99097c13d4dac9f = /*#__PURE__*/ React__default.forwardRef((props, forwardedRef)=>{
    const { __scopeAccordion: __scopeAccordion , value: value , ...accordionItemProps } = props;
    const accordionContext = $1bf158f521e1b1b4$var$useAccordionContext($1bf158f521e1b1b4$var$ITEM_NAME, __scopeAccordion);
    const valueContext = $1bf158f521e1b1b4$var$useAccordionValueContext($1bf158f521e1b1b4$var$ITEM_NAME, __scopeAccordion);
    const collapsibleScope = $1bf158f521e1b1b4$var$useCollapsibleScope(__scopeAccordion);
    const triggerId = $1746a345f3d73bb7$export$f680877a34711e37();
    const open1 = value && valueContext.value.includes(value) || false;
    const disabled = accordionContext.disabled || props.disabled;
    return /*#__PURE__*/ React__default.createElement($1bf158f521e1b1b4$var$AccordionItemProvider, {
        scope: __scopeAccordion,
        open: open1,
        disabled: disabled,
        triggerId: triggerId
    }, /*#__PURE__*/ React__default.createElement($409067139f391064$export$be92b6f5f03c0fe9, _extends({
        "data-orientation": accordionContext.orientation,
        "data-state": $1bf158f521e1b1b4$var$getState(open1)
    }, collapsibleScope, accordionItemProps, {
        ref: forwardedRef,
        disabled: disabled,
        open: open1,
        onOpenChange: (open)=>{
            if (open) valueContext.onItemOpen(value);
            else valueContext.onItemClose(value);
        }
    })));
});
/* -------------------------------------------------------------------------------------------------
 * AccordionHeader
 * -----------------------------------------------------------------------------------------------*/ const $1bf158f521e1b1b4$var$HEADER_NAME = 'AccordionHeader';
/**
 * `AccordionHeader` contains the content for the parts of an `AccordionItem` that will be visible
 * whether or not its content is collapsed.
 */ const $1bf158f521e1b1b4$export$5e3e5deaaf81ee41 = /*#__PURE__*/ React__default.forwardRef((props, forwardedRef)=>{
    const { __scopeAccordion: __scopeAccordion , ...headerProps } = props;
    const accordionContext = $1bf158f521e1b1b4$var$useAccordionContext($1bf158f521e1b1b4$var$ACCORDION_NAME, __scopeAccordion);
    const itemContext = $1bf158f521e1b1b4$var$useAccordionItemContext($1bf158f521e1b1b4$var$HEADER_NAME, __scopeAccordion);
    return /*#__PURE__*/ React__default.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.h3, _extends({
        "data-orientation": accordionContext.orientation,
        "data-state": $1bf158f521e1b1b4$var$getState(itemContext.open),
        "data-disabled": itemContext.disabled ? '' : undefined
    }, headerProps, {
        ref: forwardedRef
    }));
});
/* -------------------------------------------------------------------------------------------------
 * AccordionTrigger
 * -----------------------------------------------------------------------------------------------*/ const $1bf158f521e1b1b4$var$TRIGGER_NAME = 'AccordionTrigger';
/**
 * `AccordionTrigger` is the trigger that toggles the collapsed state of an `AccordionItem`. It
 * should always be nested inside of an `AccordionHeader`.
 */ const $1bf158f521e1b1b4$export$94e939b1f85bdd73 = /*#__PURE__*/ React__default.forwardRef((props, forwardedRef)=>{
    const { __scopeAccordion: __scopeAccordion , ...triggerProps } = props;
    const accordionContext = $1bf158f521e1b1b4$var$useAccordionContext($1bf158f521e1b1b4$var$ACCORDION_NAME, __scopeAccordion);
    const itemContext = $1bf158f521e1b1b4$var$useAccordionItemContext($1bf158f521e1b1b4$var$TRIGGER_NAME, __scopeAccordion);
    const collapsibleContext = $1bf158f521e1b1b4$var$useAccordionCollapsibleContext($1bf158f521e1b1b4$var$TRIGGER_NAME, __scopeAccordion);
    const collapsibleScope = $1bf158f521e1b1b4$var$useCollapsibleScope(__scopeAccordion);
    return /*#__PURE__*/ React__default.createElement($1bf158f521e1b1b4$var$Collection.ItemSlot, {
        scope: __scopeAccordion
    }, /*#__PURE__*/ React__default.createElement($409067139f391064$export$41fb9f06171c75f4, _extends({
        "aria-disabled": itemContext.open && !collapsibleContext.collapsible || undefined,
        "data-orientation": accordionContext.orientation,
        id: itemContext.triggerId
    }, collapsibleScope, triggerProps, {
        ref: forwardedRef
    })));
});
/* -------------------------------------------------------------------------------------------------
 * AccordionContent
 * -----------------------------------------------------------------------------------------------*/ const $1bf158f521e1b1b4$var$CONTENT_NAME = 'AccordionContent';
/**
 * `AccordionContent` contains the collapsible content for an `AccordionItem`.
 */ const $1bf158f521e1b1b4$export$985b9a77379b54a0 = /*#__PURE__*/ React__default.forwardRef((props, forwardedRef)=>{
    const { __scopeAccordion: __scopeAccordion , ...contentProps } = props;
    const accordionContext = $1bf158f521e1b1b4$var$useAccordionContext($1bf158f521e1b1b4$var$ACCORDION_NAME, __scopeAccordion);
    const itemContext = $1bf158f521e1b1b4$var$useAccordionItemContext($1bf158f521e1b1b4$var$CONTENT_NAME, __scopeAccordion);
    const collapsibleScope = $1bf158f521e1b1b4$var$useCollapsibleScope(__scopeAccordion);
    return /*#__PURE__*/ React__default.createElement($409067139f391064$export$7c6e2c02157bb7d2, _extends({
        role: "region",
        "aria-labelledby": itemContext.triggerId,
        "data-orientation": accordionContext.orientation
    }, collapsibleScope, contentProps, {
        ref: forwardedRef,
        style: {
            ['--radix-accordion-content-height']: 'var(--radix-collapsible-content-height)',
            ['--radix-accordion-content-width']: 'var(--radix-collapsible-content-width)',
            ...props.style
        }
    }));
});
/* -----------------------------------------------------------------------------------------------*/ function $1bf158f521e1b1b4$var$getState(open) {
    return open ? 'open' : 'closed';
}
const $1bf158f521e1b1b4$export$be92b6f5f03c0fe9 = $1bf158f521e1b1b4$export$a766cd26d0d69044;
const $1bf158f521e1b1b4$export$6d08773d2e66f8f2 = $1bf158f521e1b1b4$export$d99097c13d4dac9f;
const $1bf158f521e1b1b4$export$8b251419efc915eb = $1bf158f521e1b1b4$export$5e3e5deaaf81ee41;
const $1bf158f521e1b1b4$export$41fb9f06171c75f4 = $1bf158f521e1b1b4$export$94e939b1f85bdd73;
const $1bf158f521e1b1b4$export$7c6e2c02157bb7d2 = $1bf158f521e1b1b4$export$985b9a77379b54a0;

var AccordionRootContainer = styled.div(templateObject_1$19 || (templateObject_1$19 = __makeTemplateObject(["\n  width: 100%;\n  ", "\n  display: flex;\n  flex-direction: column;\n\n  h3 {\n    margin: 0;\n    display: flex;\n  }\n"], ["\n  width: 100%;\n  ", "\n  display: flex;\n  flex-direction: column;\n\n  h3 {\n    margin: 0;\n    display: flex;\n  }\n"])), function (_a) {
    var gap = _a.gap;
    return getCssProp('gap', gap);
});
var AccordionSecondaryContainer = styled(FlexBox).attrs({
    className: 'accordion-secondary-container',
    flexDirection: 'column',
    padding: '12px 0',
    gap: '12px'
})(templateObject_2$v || (templateObject_2$v = __makeTemplateObject(["\n  background: ", ";\n  margin: 0px;\n  padding: 12px 24px;\n  margin-top: 12px;\n"], ["\n  background: ", ";\n  margin: 0px;\n  padding: 12px 24px;\n  margin-top: 12px;\n"])), colorSurface.secondary);
var templateObject_1$19, templateObject_2$v;

var AccordionRoot = forwardRef(function (_a, ref) {
    var children = _a.children, name = _a.name, className = _a.className, _b = _a.gap, gap = _b === void 0 ? '16px' : _b, rest = __rest(_a, ["children", "name", "className", "gap"]);
    return (jsx(AccordionRootContainer, __assign({ className: "accordion-root-container ".concat(className), gap: gap, ref: ref, "data-testid": "".concat(name, "-accordion-root-container") }, rest, { children: children })));
});
AccordionRoot.displayName = 'AccordionRoot';

function AccordionContainer(_a) {
    var children = _a.children, type = _a.type, value = _a.value, defaultValue = _a.defaultValue, onValueChange = _a.onValueChange, disabled = _a.disabled, gap = _a.gap;
    return (jsx($1bf158f521e1b1b4$export$be92b6f5f03c0fe9, __assign({ type: type, value: value, defaultValue: defaultValue, onValueChange: onValueChange, disabled: disabled, asChild: true }, { children: jsx(AccordionRoot, __assign({ gap: gap }, { children: children })) })));
}

var AccordionButtonTrigger = styled.button(templateObject_1$18 || (templateObject_1$18 = __makeTemplateObject(["\n  width: 100%;\n  justify-content: space-between;\n  font-family: ", ";\n  color: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  padding: 0;\n  border: none;\n  display: inline-flex;\n  align-items: center;\n  cursor: pointer;\n  background: transparent;\n  &:active {\n    border-color: ", ";\n  }\n  &.focus,\n  &:focus-visible {\n    outline: 2px solid ", ";\n    box-shadow: ", ";\n  }\n"], ["\n  width: 100%;\n  justify-content: space-between;\n  font-family: ", ";\n  color: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  padding: 0;\n  border: none;\n  display: inline-flex;\n  align-items: center;\n  cursor: pointer;\n  background: transparent;\n  &:active {\n    border-color: ", ";\n  }\n  &.focus,\n  &:focus-visible {\n    outline: 2px solid ", ";\n    box-shadow: ", ";\n  }\n"])), fontFamily, colorText.colorTextTextPrimary, fontMap.normal.fontSize, fontMap.normal.lineHeight, weightMap$1.bold, colorBorder$1.colorBorderBorderPrimary, colorBase['colorNeutral-0'], shadow.focus);
styled.div(templateObject_2$u || (templateObject_2$u = __makeTemplateObject([""], [""])));
var templateObject_1$18, templateObject_2$u;

var AccordionTrigger = forwardRef(function (_a, ref) {
    var children = _a.children, name = _a.name, className = _a.className, _b = _a.expandedIcon, expandedIcon = _b === void 0 ? 'caret-up' : _b, _c = _a.collapsedIcon, collapsedIcon = _c === void 0 ? 'caret-down' : _c, rest = __rest(_a, ["children", "name", "className", "expandedIcon", "collapsedIcon"]);
    var isOpen = (rest === null || rest === void 0 ? void 0 : rest['data-state']) === 'open';
    return (jsx(AccordionButtonTrigger, __assign({ className: className, ref: ref, isOpen: isOpen, "data-testid": "".concat(name, "-button"), name: name }, rest, { children: jsxs(Fragment, { children: [children, jsx(Icon, { name: isOpen ? expandedIcon : collapsedIcon, size: "normal" })] }) })));
});
AccordionTrigger.displayName = 'AccordionTrigger';

var Accordion = function (_a) {
    var value = _a.value, title = _a.title, children = _a.children, expandedIcon = _a.expandedIcon, collapsedIcon = _a.collapsedIcon, className = _a.className;
    return (jsxs($1bf158f521e1b1b4$export$6d08773d2e66f8f2, __assign({ value: value }, { children: [jsx($1bf158f521e1b1b4$export$8b251419efc915eb, { children: jsx($1bf158f521e1b1b4$export$41fb9f06171c75f4, __assign({ asChild: true }, { children: jsx(AccordionTrigger, __assign({ className: className, expandedIcon: expandedIcon, collapsedIcon: collapsedIcon }, { children: title })) })) }), jsx($1bf158f521e1b1b4$export$7c6e2c02157bb7d2, { children: children })] })));
};

const TermsContainer = styled(FlexBox).attrs({ flexDirection: 'column' })`
  ol,
  ul {
    display: grid;
    gap: 10px;
  }
`;

var PrivateSaleNewTermsContent = function () {
    return (jsxs(TermsContainer, { children: [jsxs(Body, __assign({ size: "smaller" }, { children: ["BacklotCars, Inc.\u2019s d/b/a OPENLANE (\u201COPENLANE\u201D) Private Buying is an invitation only program that allows certain Customers (as defined in the Terms and Conditions) to return Eligible Vehicles to OPENLANE within a specified timeframe without the need to have a valid Arbitration Claim (as defined in the Terms and Conditions) for a fee as set forth herein (\u201CPrivate Buying\u201D). These Private Buying Terms and Conditions (\u201C", jsx("b", { children: "Private Buying Terms and Conditions" }), "\u201D), which may be amended from time to time, together with the Terms and Conditions that Customer has entered into with OPENLANE, govern any and all transactions undertaken by Customer and its Authorized Representatives (as defined in the Terms and Conditions), using Private Buying. Please read these Private Buying Terms and Conditions carefully before accessing Private Buying. By clicking acceptance of these Private Buying Terms and Conditions, or by otherwise using Private Buying, you as the Customer acknowledge and agree to these Private Buying Terms and Conditions and that you have full authority to bind to these Private Buying Terms and Conditions any dealership, business, or other entity for whom you may be acting as a representative or agent."] })), jsxs("ol", __assign({ "data-testid": "new_pm_terms" }, { children: [jsx("li", { children: jsx(Body, __assign({ size: "smaller", textDecoration: "underline", type: "caption" }, { children: "Access to Private Buying." })) }), jsx("ol", __assign({ type: "a" }, { children: jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "OPENLANE, in its sole discretion, will determine eligibility for Private Buying. OPENLANE reserves the right, in its sole discretion, to refuse to make the Private Buying available or to revoke access to any Customer. If Customer is selected by OPENLANE to participate in Private Buying, OPENLANE will notify Customer and provide access to Private Buying." })) }) })), jsx("li", { children: jsx(Body, __assign({ size: "smaller", textDecoration: "underline", type: "caption" }, { children: "Buy Back Eligibility and Return Benefit Rules." })) }), jsxs("ol", __assign({ type: "a" }, { children: [jsx("li", { children: jsxs(Body, __assign({ size: "smaller" }, { children: ["Unless otherwise indicated by OPENLANE, every vehicle available for purchase by a Customer in Private Buying (each, an \u201C", jsx("b", { children: "Eligible Vehicle" }), "\u201D) shall be eligible for a buyback as set forth herein."] })) }), jsx("li", { children: jsxs(Body, __assign({ size: "smaller" }, { children: ["Subject to these Private Buying Terms and Conditions, OPENLANE will agree to buy back the Eligible Vehicle and refund to Customer the purchase price, provided that any refund shall not exceed one hundred fifteen percent (115%) of the wholesale value of the vehicle at time of sale as determined by the Black Book\u00AE adjusted clean (adjusted for mileage and condition and any damages identified in a condition report, post-sale inspection, announcements, disclosures or through any similar means, as reasonably estimated by OPENLANE in its discretion) or, upon the mutual agreement by OPENLANE and Customer, OPENLANE will pay a monetary concession in lieu of a buyback (\u201C", jsx("b", { children: "Return Benefit" }), "\u201D). OPENLANE shall not reimburse Customer for reconditioning expenses, purchase price in excess of one hundred fifteen percent (115%) of the wholesale wholesale value of the vehicle at time of sale as determined by the Black Book\u00AE adjusted clean (as stated other costs relating to a repurchased Eligible Vehicle. If a monetary concession in lieu of a buyback with Customer retaining the vehicle is mutually agreed upon by OPENLANE and Customer, Customer shall not be entitled to further concessions or a buyback."] })) }), jsx("li", { children: jsxs(Body, __assign({ size: "smaller" }, { children: ["Private Buying Fees. All Private Buying purchases are subject to the standard OPENLANE\u2019s marketplace buy fees and an additional Private Buying Buyback Guarantee Fee (\u201C", jsx("b", { children: "Private Buying Buyback Guarantee Fee" }), "\u201D). The Private Buying Buyback Guarantee Fee amount charged is determined by Customer\u2019s selling statistics on OPENLANE\u2019s Platform and thresholds and amounts are subject to change."] })) }), jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "Return Transportation Reimbursement. OPENLANE will reimburse transportation charges on a return of an Eligible Vehicle, provided Customer consents to the use of a transport carrier assigned by OPENLANE. Under no circumstance will OPENLANE reimburse Customer for transportation costs charged by a transport carrier that was not assigned by OPENLANE." })) }), jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "OPENLANE reserves the right to deny the Return Benefit that violates these Private Buying Terms and Conditions, including without limitation, Customer\u2019s Warranties and Obligations under Section 4 below." })) }), jsxs("li", { children: [jsxs(Body, __assign({ size: "smaller" }, { children: ["Customer shall only be eligible to receive the Return Benefit in the event all of the following requirements are met (collectively, \u201C", jsx("b", { children: "Return Benefit Requirements" }), "\u201D):"] })), jsxs("ol", __assign({ type: "i" }, { children: [jsxs("li", { children: [jsx(Body, __assign({ size: "smaller" }, { children: "Customer must initiate a return request on the OPENLANE\u2019s Platform and select the \u201CReturn\u201D button on the appropriate vehicle sale transaction within the following timeframes or the Return Benefit will be denied:" })), jsxs("ol", __assign({ type: "A" }, { children: [jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "five (5) calendar days from the date of purchase or seven (7) calendar days from date of delivery if Customer utilized transportation provided by OPENLANE; or" })) }), jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "if Customer purchases an extended guarantee on a Private Buying purchase, the Customer will have fourteen (14) days from date of purchase to initiate a return if Customer arranges their own transportation or fourteen (14) days from the delivery date if Customer elects to use a transportation carrier assigned by OPENLANE;" })) })] }))] }), jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "The Eligible Vehicle is in the same or better condition as its condition at the time of purchase by Customer (subject to additional mileage of up to 100 miles from the Odometer Statement at time of purchase);" })) }), jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "The Eligible Vehicle has not been sold or transferred to a third party at any time after the purchase date;" })) }), jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "The Eligible Vehicle has not been exported outside of the United States after purchase and must be in Buyer\u2019s possession at the time of the return request;" })) }), jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "If Customer has received title prior to or after initiation of return, customer agrees to return title and power of attorney (if title transfer is required) to OPENLANE within seven (7) calendar days of initiation of return or return will be reversed and vehicle will no longer be eligible for return; and" })) }), jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "Customer agrees to store the Eligible Vehicle for a period of up to fourteen (14) calendar days for free to allow for OPENLANE to remarket the Eligible Vehicle on Customer\u2019s lot. If OPENLANE is unable to remarket the Eligible Vehicle by fourteen (14) calendar days, Customer agrees to allow OPENLANE\u2019s arranged transporter to pick up the vehicle. The risk of loss for an Eligible Vehicle remains with the Customer until such time as OPENLANE\u2019s arranged transporter takes possession of the vehicle. Buyer is not entitled to any storage fees on a returned vehicle." })) })] }))] }), jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "Customer must meet all of the Return Benefit Requirements within seven (7) calendar days from the date the return request is initiated in order to be eligible to receive the Return Benefit. In addition, Customer agrees to provide the reason for exercising the Return Benefit." })) }), jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "The amount to be paid to Customer as part of the Return Benefit shall be paid to Customer via Automated Clearing House (\u201CACH\u201D) electronic funds transfer system within ten (10) calendar days after satisfaction of all of the Return Benefit Requirements (subject to any set-off or other similar right under the Terms of Use)." })) })] })), jsx("li", { children: jsx(Body, __assign({ size: "smaller", textDecoration: "underline", type: "caption" }, { children: "Vehicle Condition; Disputes." })) }), jsxs("ol", __assign({ type: "a" }, { children: [jsxs("li", { children: [jsx(Body, __assign({ size: "smaller" }, { children: "If OPENLANE determines that the condition of the Eligible Vehicle is not the same or better than the condition at the time of purchase by Customer (including any missing or replaced parts or accessories, but subject to the permitted additional mileage as set forth above), OPENLANE, in its discretion, may:" })), jsxs("ol", __assign({ type: "i" }, { children: [jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "deny the Return Benefit of the Eligible Vehicle; or" })) }), jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "if the Return Benefit has already been provided to Customer when the discrepancy in condition is discovered, then OPENLANE reserves the right, at its election, to either (1) unwind the Return Benefit and charge Customer\u2019s account for the full repurchase or refund amount, in which case Customer shall be responsible for paying such amount and, if applicable, repurchasing the Eligible Vehicle, in each case in accordance with the normal payment policies of OPENLANE, or (2) proceed to resell such Eligible Vehicle in whatever manner OPENLANE deems appropriate (or proceed to resell such Eligible Vehicle on Customer\u2019s behalf in whatever manner it deems appropriate). In no event shall the acceptance by OPENLANE of any Eligible Vehicle returned to OPENLANE be construed as an acceptance of any Eligible Vehicle with any damage or other defect, or as a waiver by OPENLANE of any rights or remedies that it may have with respect to any damage or other condition issue affecting such Eligible Vehicle." })) }), jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "In the event of any unwind of a repurchase or refund transaction of the Return Benefit pursuant to clause (ii) (1) above, OPENLANE shall relinquish the applicable Eligible Vehicle (and transfer title and ownership thereto) to Customer upon receipt of payment in full from Customer for such Eligible Vehicle. In the event of any resale pursuant to clause (ii) (2) above, OPENLANE shall have the right to invoice Customer for the difference (if any) between the repurchase price or refund amount paid by OPENLANE to Customer for such Eligible Vehicle, and the net proceeds received by OPENLANE from the resale of such Eligible Vehicle. For clarity, Customer acknowledges and agrees that Customer shall be exclusively responsible for any issue with respect to the changed condition of an Eligible Vehicle being returned to OPENLANE, regardless of whether such issue relates to damage caused by Customer, any third party or an act of God (including any hail damage or any other weather-related damage to an Eligible Vehicle, or any other damage that may have been caused by forces outside of Customer\u2019s control) prior to OPENLANE\u2019s arranged transporter taking possession of the returned vehicle. OPENLANE\u2019s determination of the condition of any Eligible Vehicle shall be final and binding on the parties." })) })] }))] }), jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "Customer acknowledges and agrees with respect to the Return Benefit for any Eligible Vehicle, the maximum liability (if any) OPENLANE has to Customer is the refund of the purchase price, buy fee, Private Buying Guarantee Fee, and cost of any transportation arranged by OPENLANE." })) })] })), jsx("li", { children: jsx(Body, __assign({ size: "smaller", textDecoration: "underline", type: "caption" }, { children: "Customer Warranties and Obligations" })) }), jsxs("ol", __assign({ type: "a" }, { children: [jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "Customer will process the necessary paperwork to obtain clear title to the Eligible Vehicle and assign it to OPENLANE or its designee prior to return of the Eligible Vehicle to OPENLANE. Customer will also cooperate in providing any other paperwork or signatures reasonably requested by OPENLANE to process a returned Eligible Vehicle and/or reimbursement request." })) }), jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "Customer represents and warrants that (i) each Eligible Vehicle sold to OPENLANE under these Private Buying Terms and Conditions has clear title and is free and clear of any judgments, liens, or citations, and (ii) the odometer reading on any Eligible Vehicle and the odometer statement related to such Eligible Vehicle are true and accurate in all respects." })) }), jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "Customer further represents and warrants that the Private Buying vehicle is being purchased by Customer as part of a bona fide and valid arm\u2019s length vehicle transaction, that the vehicle transaction involved competitive bidding, that Customer is not purchasing the Eligible Vehicle (for which Private Buying is being purchased) in collusion with any other person or entity, including, without limitation the seller or any subsequent buyer of the Eligible Vehicle, and that there is no crossover representation among parties to the vehicle transaction (i.e. an affiliated buyer and seller, a dual agent, etc.). Without limiting the foregoing, Customer represents and warrants that neither it, nor to its knowledge any other person or entity, has engaged in any kind of fraudulent, wrongful, or improper conduct with respect to the Eligible Vehicle or Private Buying, including, by way of example and not limitation, bidding on the Eligible Vehicle in order to artificially inflate the sale price for such Eligible Vehicle. Customer acknowledges that any fraud or collusion on the part of Customer (or any buyer of an Eligible Vehicle or any other third party) is subject to criminal prosecution, and OPENLANE or its affiliates may report such activities to law enforcement." })) }), jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "Customer hereby authorizes OPENLANE to execute documents and take such other actions as necessary to evidence and perfect OPENLANE\u2019s title in any Eligible Vehicle that may be repurchased or otherwise remarketed by OPENLANE, and Customer hereby agrees that OPENLANE and its affiliates will be held harmless from any and all causes of action associated therewith." })) }), jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "Customer acknowledges and agrees that neither it nor its affiliates shall be permitted to purchase any Eligible Vehicle back from OPENLANE or any of its affiliates within the ninety (90) day period immediately following the date of OPENLANE\u2019s repurchase of such Eligible Vehicle, or the date on which OPENLANE remitted to Customer the applicable refund for such Eligible Vehicle (as the case may be), unless it pays to OPENLANE or its affiliate, as applicable, the full amount of the repurchase price or refund paid by OPENLANE or its affiliate for such Eligible Vehicle. In the event that Customer purchases any such Eligible Vehicle within the ninety (90) day period described above for less than the repurchase price or refund amount previously paid to Customer by OPENLANE with respect to such Eligible Vehicle, then OPENLANE shall have the right to require that Customer pay to OPENLANE the difference between the purchase price paid by Customer for such Eligible Vehicle and the repurchase price or refund amount previously paid to Customer by OPENLANE with respect to such Eligible Vehicle." })) }), jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "Notwithstanding anything to the contrary set forth herein, Customer hereby acknowledges and agrees that if OPENLANE or its affiliate knows or reasonably believes that Customer has breached any of the foregoing representations, warranties, or covenants, OPENLANE and its affiliates may refuse to provide the Return Benefit for any Eligible Vehicle and may pursue any other remedies available at law or in equity, under these Private Buying Terms and Conditions or otherwise. Customer further acknowledges and agrees that such remedies shall include, without limitation, (i) the right to deny Customer access to OPENLANE\u2019s Platform and other sales channels operated by OPENLANE and other affiliates of OPENLANE; (ii) the right to prohibit Customer and its affiliates from purchasing or benefiting from any Private Buying; and (iii) the right to set off any amounts owed to Customer or its affiliates as provided for herein." })) })] })), jsx("li", { children: jsx(Body, __assign({ size: "smaller", textDecoration: "underline", type: "caption" }, { children: "Changes to Terms and Conditions" })) }), jsxs("ol", __assign({ type: "a" }, { children: [jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "OPENLANE reserves the right to modify these Terms and Conditions from time to time and will post any such changes on the OPENLANE platform or otherwise provide notice to Customer." })) }), jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "Customer agrees that the purchase or use of Private Buying after such changes have been posted to the OPENLANE platform or sent to Customer will constitute Customer\u2019s assent to any such changes." })) })] }))] }))] }));
};

var PrivateSaleOldTermsContent = function () { return (jsxs(TermsContainer, { children: [jsxs(Body, __assign({ size: "smaller" }, { children: ["BacklotCars, Inc.\u2019s d/b/a OPENLANE (\u201COPENLANE\u201D) Private Buying is an invitation only program that allows certain Customers (as defined in the Terms and Conditions) to return Eligible Vehicles to OPENLANE within a specified timeframe without the need to have a valid Arbitration Claim (as defined in the Terms and Conditions) for a fee as set forth herein (\u201CPrivate Buying\u201D). These Private Buying Terms and Conditions (\u201C", jsx("b", { children: "Private Buying Terms and Conditions" }), "\u201D), which may be amended from time to time, together with the Terms and Conditions that Customer has entered into with OPENLANE, govern any and all transactions undertaken by Customer and its Authorized Representatives (as defined in the Terms and Conditions), using Private Buying. Please read these Private Buying Terms and Conditions carefully before accessing Private Buying. By clicking acceptance of these Private Buying Terms and Conditions, or by otherwise using Private Buying, you as the Customer acknowledge and agree to these Private Buying Terms and Conditions and that you have full authority to bind to these Private Buying Terms and Conditions any dealership, business, or other entity for whom you may be acting as a representative or agent."] })), jsxs("ol", __assign({ "data-testid": "old_pm_terms" }, { children: [jsx("li", { children: jsx(Body, __assign({ size: "smaller", textDecoration: "underline", type: "caption" }, { children: "Access to Private Buying." })) }), jsx("ol", __assign({ type: "a" }, { children: jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "OPENLANE, in its sole discretion, will determine eligibility for Private Buying. OPENLANE reserves the right, in its sole discretion, to refuse to make the Private Buying available or to revoke access to any Customer. If Customer is selected by OPENLANE to participate in Private Buying, OPENLANE will notify Customer and provide access to Private Buying" })) }) })), jsx("li", { children: jsx(Body, __assign({ size: "smaller", textDecoration: "underline", type: "caption" }, { children: "Buy Back Eligibility and Return Benefit Rules." })) }), jsxs("ol", __assign({ type: "a" }, { children: [jsx("li", { children: jsxs(Body, __assign({ size: "smaller" }, { children: ["Unless otherwise indicated by OPENLANE, every vehicle available for purchase by a Customer in Private Buying (each, an \u201C", jsx("b", { children: "Eligible Vehicle" }), "\u201D) shall be eligible for a buyback as set forth herein"] })) }), jsx("li", { children: jsxs(Body, __assign({ size: "smaller" }, { children: ["Subject to these Private Buying Terms and Conditions, OPENLANE will agree to buy back the Eligible Vehicle and refund to Customer the purchase price, provided that any refund shall not exceed one hundred fifteen percent (115%) of the wholesale value of the vehicle at time of sale as determined by the Black Book\u00AE adjusted clean (adjusted for mileage and condition and any damages identified in a condition report, post-sale inspection, announcements, disclosures or through any similar means, as reasonably estimated by OPENLANE in its discretion) or, upon the mutual agreement by OPENLANE and Customer, OPENLANE will pay a monetary concession in lieu of a buyback (\u201C", jsx("b", { children: "Return Benefit" }), "\u201D). OPENLANE shall not reimburse Customer for reconditioning expenses, purchase price in excess of one hundred fifteen percent (115%) of the wholesale wholesale value of the vehicle at time of sale as determined by the Black Book\u00AE adjusted clean (as stated other costs relating to a repurchased Eligible Vehicle. If a monetary concession in lieu of a buyback with Customer retaining the vehicle is mutually agreed upon by OPENLANE and Customer, Customer shall not be entitled to further concessions or a buyback."] })) }), jsx("li", { children: jsxs(Body, __assign({ size: "smaller" }, { children: ["Private Buying Fees. All Private Buying purchases are subject to the standard OPENLANE\u2019 marketplace buy fees and an additional Private Buying Buyback Guarantee Fee (\u201C", jsx("b", { children: "Private Buying Buyback Guarantee Fee" }), "\u201D). The Private Buying Buyback Guarantee Fee amount charged is determined by Customer\u2019s selling statistics on OPENLANE\u2019s Platform and thresholds and amounts are subject to change."] })) }), jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "Return Transportation Reimbursement. OPENLANE will reimburse transportation charges on a return of an Eligible Vehicle, provided Customer consents to the use of a transport carrier assigned by OPENLANE. Under no circumstance will OPENLANE reimburse Customer for transportation costs charged by a transport carrier that was not assigned by OPENLANE." })) }), jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "OPENLANE reserves the right to deny the Return Benefit that violates these Private Buying Terms and Conditions, including without limitation, Customer\u2019s Warranties and Obligations under Section 4 below." })) }), jsxs("li", { children: [jsxs(Body, __assign({ size: "smaller" }, { children: ["Customer shall only be eligible to receive the Return Benefit in the event all of the following requirements are met (collectively, \u201C", jsx("b", { children: "Return Benefit Requirements" }), "\u201D):"] })), jsxs("ol", __assign({ type: "i" }, { children: [jsxs("li", { children: [jsx(Body, __assign({ size: "smaller" }, { children: "Customer must initiate a return request on the OPENLANE\u2019s Platform and select the \u201CReturn\u201D button on the appropriate vehicle sale transaction within the following timeframes or the Return Benefit will be denied:" })), jsxs("ol", __assign({ type: "A" }, { children: [jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "five (5) calendar days from the date of purchase or seven (7) calendar days from date of delivery if Customer utilized transportation provided by OPENLANE; or" })) }), jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "if Customer purchases an extended guarantee on a Private Buying purchase, the Customer will have fourteen (14) days from date of purchase to initiate a return if Customer arranges their own transportation or fourteen (14) days from the delivery date if Customer elects to use a transportation carrier assigned by OPENLANE;" })) })] }))] }), jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "The Eligible Vehicle is in the same or better condition as its condition at the time of purchase by Customer (subject to additional mileage of up to 100 miles from the Odometer Statement at time of purchase);" })) }), jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "The Eligible Vehicle has not been sold or transferred to a third party at any time after the purchase date;" })) }), jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "The Eligible Vehicle has not been exported outside of the United States after purchase;" })) }), jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "If Customer has received title prior to or after initiation of return, customer agrees to return title and power of attorney (if title transfer is required) to OPENLANE within seven (7) calendar days of initiation of return or return will be reversed and vehicle will no longer be eligible for return; and" })) }), jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "Customer agrees to store the Eligible Vehicle for a period of up to fourteen (14) calendar days for free to allow for a OPENLANE\u2019s to remarket the Eligible Vehicle on Customer\u2019s lot. If OPENLANE is unable to remarket the Eligible Vehicle by fourteen (14) calendar days, Customer agrees to allow a OPENLANE\u2019s arranged transporter to pickup of the vehicle. The risk of loss for an Eligible Vehicle remains with the Customer until such time as the OPENLANE\u2019s arranged transporter takes possession of the vehicle." })) })] }))] }), jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "Customer must meet all of the Return Benefit Requirements within seven (7) calendar days from the date the return request is initiated in order to be eligible to receive the Return Benefit. In addition, Customer agrees to provide the reason for exercising the Return Benefit." })) }), jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "The amount to be paid to Customer as part of the Return Benefit shall be paid to Customer via Automated Clearing House (\u201CACH\u201D) electronic funds transfer system within ten (10) calendar days after satisfaction of all of the Return Benefit Requirements (subject to any set-off or other similar right under the Terms of Use)." })) })] })), jsx("li", { children: jsx(Body, __assign({ size: "smaller", textDecoration: "underline", type: "caption" }, { children: "Vehicle Condition; Disputes." })) }), jsxs("ol", __assign({ type: "a" }, { children: [jsxs("li", { children: [jsx(Body, __assign({ size: "smaller" }, { children: "If OPENLANE determines that the condition of the Eligible Vehicle is not the same or better than the condition at the time of purchase by Customer (including any missing or replaced parts or accessories, but subject to the permitted additional mileage as set forth above), OPENLANE, in its discretion, may:" })), jsxs("ol", __assign({ type: "i" }, { children: [jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "deny the Return Benefit of the Eligible Vehicle; or" })) }), jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "if the Return Benefit has already been provided to Customer when the discrepancy in condition is discovered, then OPENLANE reserves the right, at its election, to either (1) unwind the Return Benefit and charge Customer\u2019s account for the full repurchase or refund amount, in which case Customer shall be responsible for paying such amount and, if applicable, repurchasing the Eligible Vehicle, in each case in accordance with the normal payment policies of OPENLANE, or (2) proceed to resell such Eligible Vehicle in whatever manner OPENLANE deems appropriate (or proceed to resell such Eligible Vehicle on Customer\u2019s behalf in whatever manner it deems appropriate). In no event shall the acceptance by OPENLANE of any Eligible Vehicle returned to OPENLANE be construed as an acceptance of any Eligible Vehicle with any damage or other defect, or as a waiver by OPENLANE of any rights or remedies that it may have with respect to any damage or other condition issue affecting such Eligible Vehicle." })) }), jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "In the event of any unwind of a repurchase or refund transaction of the Return Benefit pursuant to clause (ii) (1) above, OPENLANE shall relinquish the applicable Eligible Vehicle (and transfer title and ownership thereto) to Customer upon receipt of payment in full from Customer for such Eligible Vehicle. In the event of any resale pursuant to clause (ii) (2) above, OPENLANE shall have the right to invoice Customer for the difference (if any) between the repurchase price or refund amount paid by OPENLANE to Customer for such Eligible Vehicle, and the net proceeds received by OPENLANE from the resale of such Eligible Vehicle. For clarity, Customer acknowledges and agrees that Customer shall be exclusively responsible for any issue with respect to the changed condition of an Eligible Vehicle being returned to OPENLANE, regardless of whether such issue relates to damage caused by Customer, any third party or an act of God (including any hail damage or any other weather-related damage to an Eligible Vehicle, or any other damage that may have been caused by forces outside of Customer\u2019s control) prior to OPENLANE\u2019s arranged transporter taking possession of the returned vehicle. OPENLANE\u2019s determination of the condition of any Eligible Vehicle shall be final and binding on the parties." })) })] }))] }), jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "Customer acknowledges and agrees with respect to the Return Benefit for any Eligible Vehicle, the maximum liability (if any) OPENLANE has to Customer is the refund of the purchase price, buy fee, Private Buying Guarantee Fee, and cost of any transportation arranged by OPENLANE." })) })] })), jsx("li", { children: jsx(Body, __assign({ size: "smaller", textDecoration: "underline", type: "caption" }, { children: "Customer Warranties and Obligations" })) }), jsxs("ol", __assign({ type: "a" }, { children: [jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "Customer will process the necessary paperwork to obtain clear title to the Eligible Vehicle and assign it to OPENLANE or its designee prior to return of the Eligible Vehicle to OPENLANE. Customer will also cooperate in providing any other paperwork or signatures reasonably requested by OPENLANE to process a returned Eligible Vehicle and/or reimbursement request." })) }), jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "Customer represents and warrants that (i) each Eligible Vehicle sold to OPENLANE under these Private Buying Terms and Conditions has clear title and is free and clear of any judgments, liens, or citations, and (ii) the odometer reading on any Eligible Vehicle and the odometer statement related to such Eligible Vehicle are true and accurate in all respects" })) }), jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "Customer further represents and warrants that the Private Buying vehicle is being purchased by Customer as part of a bona fide and valid arm\u2019s length vehicle transaction, that the vehicle transaction involved competitive bidding, that Customer is not purchasing the Eligible Vehicle (for which Private Buying is being purchased) in collusion with any other person or entity, including, without limitation the seller or any subsequent buyer of the Eligible Vehicle, and that there is no crossover representation among parties to the vehicle transaction (i.e. an affiliated buyer and seller, a dual agent, etc.). Without limiting the foregoing, Customer represents and warrants that neither it, nor to its knowledge any other person or entity, has engaged in any kind of fraudulent, wrongful, or improper conduct with respect to the Eligible Vehicle or Private Buying, including, by way of example and not limitation, bidding on the Eligible Vehicle in order to artificially inflate the sale price for such Eligible Vehicle. Customer acknowledges that any fraud or collusion on the part of Customer (or any buyer of an Eligible Vehicle or any other third party) is subject to criminal prosecution, and OPENLANE or its affiliates may report such activities to law enforcement." })) }), jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "Customer hereby authorizes OPENLANE to execute documents and take such other actions as necessary to evidence and perfect OPENLANE\u2019s title in any Eligible Vehicle that may be repurchased or otherwise remarketed by OPENLANE, and Customer hereby agrees that OPENLANE and its affiliates will be held harmless from any and all causes of action associated therewith." })) }), jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "Customer acknowledges and agrees that neither it nor its affiliates shall be permitted to purchase any Eligible Vehicle back from OPENLANE or any of its affiliates within the ninety (90) day period immediately following the date of OPENLANE\u2019s repurchase of such Eligible Vehicle, or the date on which OPENLANE remitted to Customer the applicable refund for such Eligible Vehicle (as the case may be), unless it pays to OPENLANE or its affiliate, as applicable, the full amount of the repurchase price or refund paid by OPENLANE or its affiliate for such Eligible Vehicle. In the event that Customer purchases any such Eligible Vehicle within the ninety (90) day period described above for less than the repurchase price or refund amount previously paid to Customer by OPENLANE with respect to such Eligible Vehicle, then OPENLANE shall have the right to require that Customer pay to OPENLANE the difference between the purchase price paid by Customer for such Eligible Vehicle and the repurchase price or refund amount previously paid to Customer by OPENLANE with respect to such Eligible Vehicle." })) }), jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "Notwithstanding anything to the contrary set forth herein, Customer hereby acknowledges and agrees that if OPENLANE or its affiliate knows or reasonably believes that Customer has breached any of the foregoing representations, warranties, or covenants, OPENLANE and its affiliates may refuse to provide the Return Benefit for any Eligible Vehicle and may pursue any other remedies available at law or in equity, under these Private Buying Terms and Conditions or otherwise. Customer further acknowledges and agrees that such remedies shall include, without limitation, (i) the right to deny Customer access to OPENLANE\u2019s Platform and other sales channels operated by OPENLANE and other affiliates of OPENLANE; (ii) the right to prohibit Customer and its affiliates from purchasing or benefiting from any Private Buying; and (iii) the right to set off any amounts owed to Customer or its affiliates as provided for herein." })) })] })), jsx("li", { children: jsx(Body, __assign({ size: "smaller", textDecoration: "underline", type: "caption" }, { children: "Changes to Terms and Conditions" })) }), jsxs("ol", __assign({ type: "a" }, { children: [jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "OPENLANE reserves the right to modify these Terms and Conditions from time to time and will post any such changes on the OPENLANE platform or otherwise provide notice to Customer." })) }), jsx("li", { children: jsx(Body, __assign({ size: "smaller" }, { children: "Customer agrees that the purchase or use of Private Buying after such changes have been posted to the OPENLANE platform or sent to Customer will constitute Customer\u2019s assent to any such changes." })) })] }))] }))] })); };

var TooltipContent = function (_a) {
    var title = _a.title, content = _a.content;
    return (jsxs(FlexBox, __assign({ flexDirection: "column", alignItems: "flex-start", justifyContent: "flex-start", gap: spacingActionGap.spacingActionGapSm }, { children: [jsx(FlexBox, { children: typeof title === 'string' ? jsx(Headline, { children: title }) : title }), jsx(FlexBox, { children: typeof content === 'string' ? jsx(Body, { children: content }) : content })] })));
};
var BubbleContent = function (_a) {
    var id = _a.id, text = _a.text, tooltip = _a.tooltip, iconName = _a.iconName, _b = _a.iconColor, iconColor = _b === void 0 ? 'success' : _b, _c = _a.borderWidth, borderWidth = _c === void 0 ? 1 : _c, _d = _a.borderColor, borderColor = _d === void 0 ? 'grayLight' : _d, _e = _a.background, background = _e === void 0 ? 'white' : _e, children = _a.children, className = _a.className, truncable = _a.truncable, _f = _a.tooltipMaxWidth, tooltipMaxWidth = _f === void 0 ? 300 : _f;
    return (jsx(Bubble, __assign({ borderWidth: borderWidth, borderRadius: 240, borderColor: borderColor, background: background, className: className }, { children: jsxs(FlexBox, __assign({ alignItems: "center", gap: 5, width: "100%" }, { children: [jsx(Icon, { name: iconName, color: iconColor, size: "smaller" }), children || (jsx(FlexBox, __assign({ minWidth: 0 }, { children: jsx(Body, __assign({ color: "fontColor", truncable: truncable }, { children: text })) }))), tooltip && (jsxs(Fragment, { children: [jsx("div", __assign({ "data-tooltip-id": "tooltip-".concat(id) }, { children: jsx(FlexBox, __assign({ alignItems: "center" }, { children: jsx(Icon, { name: "info", color: "grayDark", cursor: "pointer", size: "smaller" }) })) })), jsx(BlcTooltip, __assign({ id: "tooltip-".concat(id), maxWidth: tooltipMaxWidth }, { children: jsx(TooltipContent, __assign({}, tooltip)) }))] }))] })) })));
};
var CondensedBubble = function (_a) {
    var _b = _a.background, background = _b === void 0 ? 'white' : _b, _c = _a.borderColor, borderColor = _c === void 0 ? 'grayLight' : _c, children = _a.children, className = _a.className, minimal = _a.minimal;
    return (jsx(Bubble, __assign({ background: background, borderColor: borderColor, borderRadius: 50, borderWidth: 1, className: className, padding: minimal ? '0' : '0 12px' }, { children: children })));
};
var BadgeBase = function (_a) {
    var condensed = _a.condensed, className = _a.className, minimal = _a.minimal, iconName = _a.iconName, iconColor = _a.iconColor, text = _a.text, tooltipMaxWidth = _a.tooltipMaxWidth;
    return condensed ? (jsx(CondensedBubble, __assign({ minimal: minimal, className: className }, { children: jsx(Icon, { name: iconName, color: iconColor, size: "smaller" }) }))) : (jsx(BubbleContent, { iconName: iconName, iconColor: iconColor, text: text, className: className, tooltipMaxWidth: tooltipMaxWidth }));
};

var AudienceBoost = function (_a) {
    var _b = _a.id, id = _b === void 0 ? 'audienceBoost' : _b, tooltip = _a.tooltip, tooltipMaxWidth = _a.tooltipMaxWidth;
    return (jsx(BubbleContent, { id: id, text: "Audience boost\u2122", tooltip: tooltip, iconName: "flash-inverted", tooltipMaxWidth: tooltipMaxWidth }));
};

var Logo$c = function (props) {
    var _a = props.height, height = _a === void 0 ? '48' : _a, _b = props.width, width = _b === void 0 ? '38' : _b, ariaLabel = props.ariaLabel, svgProps = __rest(props, ["height", "width", "ariaLabel"]);
    return (jsxs("svg", __assign({ width: width, height: height, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-label": ariaLabel }, svgProps, { children: [jsx("path", { fill: "#6BC24A", fillRule: "evenodd", d: "M36.902 9.978C39.185 12.87 40 16.248 40 18.448a6.215 6.215 0 01-5.576 6.177.157.157 0 00-.138.11 5.328 5.328 0 01-5.062 3.696c-2.352 0-4.35-1.538-5.05-3.66a.161.161 0 00-.155-.114h-8.184a.167.167 0 00-.155.115c-.701 2.121-2.698 3.66-5.05 3.66a5.283 5.283 0 01-5.05-3.66.158.158 0 00-.151-.11C2.376 24.6 0 22.169 0 19.181c0-.771.155-1.514.465-2.211 1.216-2.867 4.316-4.064 8.145-5.542l.218-.085c.356-.137.693-.265 1.02-.389 1.808-.684 3.31-1.252 6.003-2.748C18.753 6.595 21.818 5 26.216 5c5.583 0 8.893 2.705 10.686 4.978zM8.188 22.69a2.489 2.489 0 002.87 2.872 2.489 2.489 0 00-.84-4.904 2.492 2.492 0 00-2.03 2.032zm18.594 0a2.489 2.489 0 002.87 2.872 2.487 2.487 0 00-.84-4.904 2.493 2.493 0 00-2.03 2.032zm7.634-.755c.02.086.106.147.196.127a3.703 3.703 0 002.881-3.611c0-1.698-.668-4.529-2.555-6.92-1.451-1.836-4.141-4.027-8.722-4.027-3.696 0-6.014 1.23-9.008 2.818l-.171.091c-2.637 1.396-3.538 1.844-7.32 3.272-4.276 1.612-6.566 2.587-7.137 4.84a2.975 2.975 0 002.686 3.623.167.167 0 00.171-.135 5.325 5.325 0 015.2-4.223c2.56 0 4.704 1.82 5.206 4.235.016.073.081.13.159.13h7.866a.161.161 0 00.159-.13 5.325 5.325 0 015.205-4.235c2.527 0 4.646 1.775 5.184 4.145z", clipRule: "evenodd" }), jsx("path", { fill: "#6BC24A", d: "M14.029 32.511A8.322 8.322 0 0019.959 35c2.234 0 4.37-.902 5.93-2.489a.475.475 0 00-.024-.69l-1.426-1.248a.475.475 0 00-.64.02 5.484 5.484 0 01-3.84 1.571 5.484 5.484 0 01-3.84-1.57.467.467 0 00-.64-.02l-1.426 1.248a.475.475 0 00-.024.69z" })] })));
};

var Logo$b = function (props) {
    var _a = props.height, height = _a === void 0 ? 12 : _a, _b = props.width, width = _b === void 0 ? 68 : _b, ariaLabel = props.ariaLabel, svgProps = __rest(props, ["height", "width", "ariaLabel"]);
    return (jsxs("svg", __assign({ id: "CarBravoDefault", width: width, height: height, viewBox: "0 0 68 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-label": ariaLabel }, svgProps, { children: [jsx("path", { d: "M8.7333 8.07123H10.9766C10.5031 9.81519 8.92074 11.8233 5.99118 11.8233C2.47686 11.8233 0.481445 9.27099 0.481445 6.11409C0.481445 2.95718 2.47686 0.404907 5.99118 0.404907C9.0987 0.404907 10.6906 2.66439 11.0497 4.47201H8.85402C8.5236 3.51411 7.6212 2.31115 6.01974 2.31115C3.86544 2.31115 2.62938 4.00737 2.62938 6.11727C2.62938 8.22717 3.86544 9.92337 6.01974 9.92337C7.45596 9.92019 8.32657 8.95911 8.7333 8.07123Z", fill: "#0A2E3C" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.9552 9.41421C18.9552 9.93615 18.9552 11.3173 19.2094 11.6991H17.2457C17.1027 11.3014 17.0392 10.9068 17.0074 10.4612C16.3433 11.3332 15.3773 11.8264 14.2366 11.8264C12.5907 11.8264 11.6089 10.7476 11.6089 9.33783C11.6089 7.24383 13.8268 6.70599 16.9312 6.87789C16.9312 5.95815 16.5181 5.35671 15.3805 5.35671C14.3987 5.35671 13.9697 5.89449 13.8617 6.37185L11.8663 6.37185C12.1999 4.65975 13.4804 3.70821 15.5077 3.70821C17.2648 3.70821 18.9583 4.40517 18.9583 7.32339V9.41421H18.9552ZM16.928 8.20809C15.3614 8.03307 13.633 8.25585 13.633 9.23919C13.633 9.88839 14.1095 10.2225 14.9484 10.1748C15.8508 10.1271 16.7691 9.22329 16.928 8.20809Z", fill: "#0A2E3C" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M36.064 8.49494C36.064 10.3344 34.828 11.6996 32.5498 11.6996H27.1954V0.532642L31.6282 0.532642C34.0684 0.532642 35.5552 1.57964 35.5552 3.57818C35.5552 4.60928 34.8598 5.49716 34.081 5.8472C35.3518 6.24182 36.064 7.30472 36.064 8.49494ZM29.35 5.09936H31.5838C32.7718 5.09936 33.2932 4.45016 33.2932 3.65456C33.2932 2.86214 32.7688 2.36887 31.5838 2.36887L29.35 2.36887V5.09936ZM33.9094 8.36762C33.9094 7.5434 33.2296 6.87512 31.9936 6.87512H29.35V9.857H31.9936C33.3088 9.86018 33.9094 9.2237 33.9094 8.36762Z", fill: "#0A2E3C" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M50.4099 11.6993C50.1555 11.3174 50.1555 9.93948 50.1555 9.41442H50.1591V7.3236C50.1591 4.40532 48.4653 3.70842 46.7085 3.70842C44.6811 3.70842 43.4007 4.6599 43.0671 6.37206L45.0621 6.37206C45.1701 5.8947 45.5991 5.35686 46.5813 5.35686C47.7189 5.35686 48.1317 5.95836 48.1317 6.87804C45.0273 6.7062 42.8097 7.24404 42.8097 9.33804C42.8097 10.7478 43.7913 11.8267 45.4371 11.8267C46.5777 11.8267 47.5437 11.3334 48.2079 10.4614C48.2397 10.9069 48.3033 11.3015 48.4461 11.6993H50.4099ZM44.8335 9.23934C44.8335 8.256 46.5621 8.03322 48.1287 8.2083C47.9697 9.22344 47.0517 10.1272 46.1493 10.175C45.3099 10.2227 44.8335 9.8886 44.8335 9.23934Z", fill: "#0A2E3C" }), jsx("path", { d: "M54.685 8.87354L52.8802 3.83264H50.6308L53.7988 11.6995H55.5718L58.7398 3.83264L56.4898 3.83264L54.685 8.87354Z", fill: "#0A2E3C" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M62.9469 11.8269C65.3553 11.8269 67.0011 10.0034 67.0011 7.76617C67.0011 5.52895 65.3553 3.70549 62.9469 3.70549C60.3825 3.70549 58.8921 5.52895 58.8921 7.76617C58.8921 10.0034 60.4935 11.8269 62.9469 11.8269ZM62.9499 5.60851C64.1223 5.60851 64.9773 6.57601 64.9773 7.76617C64.9773 8.95321 64.1193 9.92065 62.9499 9.92383C61.7775 9.92383 60.9225 8.95639 60.9225 7.76617C60.9225 6.57601 61.7775 5.60851 62.9499 5.60851Z", fill: "#0A2E3C" }), jsx("path", { d: "M25.9389 3.80065C25.7133 3.76249 25.4973 3.75295 25.2813 3.75295C24.1884 3.75295 23.286 4.25893 22.8126 5.36959V3.83251L20.7854 3.83251V11.6994H22.8126V8.12869C22.8126 6.54391 23.7467 5.81191 24.9189 5.81191C25.2465 5.81191 25.5957 5.86285 25.9425 5.97739V3.80065H25.9389Z", fill: "#0A2E3C" }), jsx("path", { d: "M41.8491 3.75295C42.0657 3.75295 42.2817 3.76249 42.5073 3.80065H42.5103V5.97739C42.1641 5.86285 41.8143 5.81191 41.4873 5.81191C40.3149 5.81191 39.3807 6.54391 39.3807 8.12869V11.6994H37.3533V3.83251L39.3807 3.83251V5.36959C39.8541 4.25893 40.7565 3.75295 41.8491 3.75295Z", fill: "#0A2E3C" })] })));
};

var Wrapper$1 = styled(Bubble)(templateObject_1$17 || (templateObject_1$17 = __makeTemplateObject(["\n  #CarBravoDefault {\n    padding-left: 6px;\n    padding-right: 4px;\n  }\n"], ["\n  #CarBravoDefault {\n    padding-left: 6px;\n    padding-right: 4px;\n  }\n"])));
var Default$1 = function () {
    return (jsxs(Wrapper$1, __assign({ borderWidth: 1, borderRadius: 240, background: "white", borderColor: "grayLight" }, { children: [jsx(Logo$c, { width: 16, height: 16 }), jsx(Logo$b, {}), jsx(Body, __assign({ color: "fontColor" }, { children: "eligible" }))] })));
};
var Condensed$1 = function (_a) {
    var minimal = _a.minimal;
    return (jsx(CondensedBubble, __assign({ minimal: minimal }, { children: jsx(Logo$c, { width: 16, height: 16 }) })));
};
var Carbravo = function (_a) {
    var condensed = _a.condensed, minimal = _a.minimal;
    return condensed ? jsx(Condensed$1, { minimal: minimal }) : jsx(Default$1, {});
};
var templateObject_1$17;

var StyledBadge = styled.div(templateObject_1$16 || (templateObject_1$16 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  width: fit-content;\n  min-height: 28px;\n  padding: 0px 8px;\n  background-color: ", ";\n  cursor: default;\n  p {\n    padding: 0 8px;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  width: fit-content;\n  min-height: 28px;\n  padding: 0px 8px;\n  background-color: ", ";\n  cursor: default;\n  p {\n    padding: 0 8px;\n  }\n"])), customColors.primary);
var EliteDealer = function (_a) {
    var condensed = _a.condensed, minimal = _a.minimal, className = _a.className;
    return condensed ? (jsx(CondensedBubble, __assign({ className: className, minimal: minimal, background: "primary", borderColor: "primary" }, { children: jsx(Icon, { name: "elite", size: "smaller", color: "white" }) }))) : (jsxs(StyledBadge, __assign({ className: className }, { children: [jsx(Icon, { name: "elite", size: "smaller", color: "white" }), !condensed && jsx(Body, __assign({ color: "white" }, { children: "Elite Dealer" }))] })));
};
var templateObject_1$16;

var TextAndCountdownWrapper = styled.span(templateObject_1$15 || (templateObject_1$15 = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  flex-flow: wrap;\n  align-items: center;\n  justify-content: center;\n  gap: 0 6px;\n\n  > span > p {\n    font-weight: ", ";\n  }\n"], ["\n  width: 100%;\n  display: flex;\n  flex-flow: wrap;\n  align-items: center;\n  justify-content: center;\n  gap: 0 6px;\n\n  > span > p {\n    font-weight: ", ";\n  }\n"])), weightMap$1.bold);
var templateObject_1$15;

var DEFAULT_EXCLUSIVE_TOOLTIP = {
    title: 'Exclusivity Period',
    content: 'The buyer with the highest offer has an exclusivity period to accept. After that, any bidder can respond.'
};
var ExclusiveCountdown = function (_a) {
    var _b = _a.id, id = _b === void 0 ? 'exlusiveCountdown' : _b, _c = _a.tooltip, tooltip = _c === void 0 ? DEFAULT_EXCLUSIVE_TOOLTIP : _c, exclusiveUpTo = _a.exclusiveUpTo, onComplete = _a.onComplete, _d = _a.tooltipMaxWidth, tooltipMaxWidth = _d === void 0 ? 370 : _d;
    return (jsx(BubbleContent, __assign({ id: id, tooltip: tooltip, iconName: "clock", borderWidth: 1, borderColor: "warning", iconColor: "warning", tooltipMaxWidth: tooltipMaxWidth }, { children: jsxs(TextAndCountdownWrapper, { children: [jsx(Body, { children: "Exclusive" }), jsx(BasicCountdown, { showHoursIfThereAre: true, date: exclusiveUpTo, onComplete: onComplete })] }) })));
};

var Go = function (_a) {
    var condensed = _a.condensed, minimal = _a.minimal;
    return (jsx(BadgeBase, { condensed: condensed, minimal: minimal, iconName: "go-3", iconColor: "black", text: "Guaranteed offer" }));
};

var Group1 = function (_a) {
    var condensed = _a.condensed, minimal = _a.minimal;
    return (jsx(BadgeBase, { condensed: condensed, minimal: minimal, iconName: "group1", iconColor: "alert", text: "Group exclusive" }));
};

var LenderOwned = function (_a) {
    var condensed = _a.condensed, minimal = _a.minimal;
    return (jsx(BadgeBase, { condensed: condensed, minimal: minimal, iconName: "lender", iconColor: "black", text: "Lender owned" }));
};

var SellingSoon = function (_a) {
    var _b = _a.id, id = _b === void 0 ? 'sellingSoon' : _b, _c = _a.text, text = _c === void 0 ? 'Absolute sale' : _c, tooltip = _a.tooltip, tooltipMaxWidth = _a.tooltipMaxWidth;
    return (jsx(BubbleContent, { id: id, text: text, tooltip: tooltip, iconName: "success", borderWidth: 1, borderColor: "alert", iconColor: "alert", tooltipMaxWidth: tooltipMaxWidth }));
};

var SellingToday = function (_a) {
    var _b = _a.id, id = _b === void 0 ? 'sellToday' : _b, text = _a.text, tooltip = _a.tooltip, truncable = _a.truncable, tooltipMaxWidth = _a.tooltipMaxWidth;
    return (jsx(BubbleContent, { id: id, text: text, tooltip: tooltip, iconName: "success", borderWidth: 1, borderColor: "success", truncable: truncable, tooltipMaxWidth: tooltipMaxWidth }));
};

var createDefaultTooltip = function (date) { return ({
    content: "This vehicle will automatically sell for the best bid at ".concat(dayjs(date).format('hh:mm a'), " today")
}); };
var SellingTodayCountdown = function (_a) {
    var _b = _a.id, id = _b === void 0 ? 'sellTodayCountdown' : _b, tooltip = _a.tooltip, isOnExtensionTime = _a.isOnExtensionTime, endDate = _a.endDate, onComplete = _a.onComplete, tooltipMaxWidth = _a.tooltipMaxWidth;
    var tooltipParam = tooltip || createDefaultTooltip(endDate);
    var color = isOnExtensionTime ? 'alert' : 'success';
    return (jsx(BubbleContent, __assign({ id: id, tooltip: tooltipParam, iconName: "success", borderWidth: 1, borderColor: color, iconColor: color, tooltipMaxWidth: tooltipMaxWidth }, { children: jsxs(TextAndCountdownWrapper, { children: [jsx(Body, { children: "Absolute sale" }), jsx(BasicCountdown, { showHoursIfThereAre: true, date: endDate, onComplete: onComplete })] }) })));
};

var OffLeaseExclusive = function (_a) {
    var condensed = _a.condensed, minimal = _a.minimal;
    return (jsx(BadgeBase, { condensed: condensed, minimal: minimal, iconName: "off-lease", iconColor: "offLeaseExclusiveBadge", text: "Off-lease exclusive" }));
};

var Default = function () {
    return (jsx(BubbleContent, { borderWidth: 1, background: "white", borderColor: "grayLight", iconName: "off-lease", iconColor: "offLeaseExclusiveBadge", text: "Commercial exclusive" }));
};
var Condensed = function (_a) {
    var minimal = _a.minimal;
    return (jsx(CondensedBubble, __assign({ minimal: minimal, background: "offLeaseExclusiveBadge", borderColor: "white" }, { children: jsx(Icon, { name: "off-lease", color: "white", size: "smallest" }) })));
};
var CommercialExclusive = function (_a) {
    var condensed = _a.condensed, minimal = _a.minimal;
    return condensed ? jsx(Condensed, { minimal: minimal }) : jsx(Default, {});
};

var RepoLenderBannerText = styled.div(templateObject_1$14 || (templateObject_1$14 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n"])));
var templateObject_1$14;

/* eslint-disable max-len */
var RepoLenderIcon = function () { return (jsx("svg", __assign({ width: "22", height: "21", viewBox: "0 0 22 21", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsx("path", { d: "M4.16254 17.5228V9.04783H5.80004V17.5228H4.16254ZM10.2843 17.5228V9.04783H11.9158V17.5228H10.2843ZM0.850586 20.5886V18.8853H21.1555V20.5886H0.850586ZM16.2 17.5228V9.04783H17.8375V17.5228H16.2ZM0.850586 7.68533V6.10925L11 0.337502L21.1555 6.10925V7.68533H0.850586Z", fill: "white" }) }))); };

var RepoLenderBanner = function (_a) {
    var className = _a.className;
    return (jsx(BlcBanner, __assign({ className: className, backgroundColor: "fontColor", color: "white", padding: "5px", margin: "0 0 10px 0" }, { children: jsxs(RepoLenderBannerText, { children: [jsx(RepoLenderIcon, {}), jsx(Body, __assign({ color: "white", bold: true }, { children: "Lender owned" }))] }) })));
};

var MARKETPLACE_BID_STATE_COLORS = {
    nonBided: {
        borderColor: 'grayLight',
        backgroundColor: 'smokeLight',
        text: 'Best bid',
        showStar: false
    },
    leader: {
        borderColor: 'success',
        backgroundColor: 'successLightest',
        text: 'Leader',
        showStar: false
    },
    outBided: {
        borderColor: 'alert',
        backgroundColor: 'alertLightest',
        text: 'Outbid',
        showStar: false
    },
    sold: {
        borderColor: 'black',
        backgroundColor: 'neutralGray20',
        text: 'Sold',
        showStar: false
    },
    counter: {
        borderColor: 'warning',
        backgroundColor: 'interactionYellow5',
        text: 'Seller counter',
        showStar: false
    },
    sealedBidOffered: {
        borderColor: 'grayLight',
        backgroundColor: 'smokeLight',
        text: 'You offer',
        showStar: false
    },
    won: {
        borderColor: 'success',
        backgroundColor: 'interactionGreen5',
        text: 'Won',
        showStar: true
    }
};

var userSizeMap$1 = {
    smaller: '24px',
    normal: '32px',
    large: '44px',
    full: '100%'
};
var getSize$1 = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'normal' : _b;
    return "\n  width: ".concat(userSizeMap$1[size], ";\n  height: ").concat(userSizeMap$1[size], ";\n");
};
var AvatarContainer = styled.div(templateObject_1$13 || (templateObject_1$13 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var size = _a.size, width = _a.width, height = _a.height, filled = _a.filled;
    return "\n    ".concat(getSize$1({ size: size, width: width, height: height }), "\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: 1px solid ").concat(filled ? colorBorder$1.colorBorderBorderPrimary : colorBorder$1.colorBorderBorderSecondary, ";\n    background-color: ").concat(filled ? colorSurface.primary : colorSurface.secondary, ";\n    border-radius: ").concat(theming.borderRadiusSmaller, ";\n    overflow: hidden;\n    flex-shrink: 0;\n    img {\n        ").concat(getSize$1({ size: size, width: width, height: height }), "\n        aspect-ratio: 1/1;\n        object-fit: cover;\n    }\n");
});
var templateObject_1$13;

var Avatar = function (_a) {
    var className = _a.className, src = _a.src, size = _a.size, alt = _a.alt, filled = _a.filled, iconSize = _a.iconSize;
    var _b = useState(false), errorLoadingImage = _b[0], setErrorLoadingImage = _b[1];
    var showPlaceholder = !src || errorLoadingImage;
    return (jsx(AvatarContainer, __assign({ className: className, size: size, filled: filled }, { children: showPlaceholder ? (jsx(Icon, { name: "user", color: "colorIconIconSecondary", size: iconSize || (size === 'large' ? 'normal' : 'smaller') })) : (jsx("img", { alt: alt, src: src, onError: function () { return setErrorLoadingImage(true); } })) })));
};

var userSizeMap = {
    normal: '32px',
    large: '96px'
};
var getSize = function (_a) {
    var width = _a.width, height = _a.height, size = _a.size;
    if (width || height) {
        return "\n        width: ".concat(getSizeValue(width), ";\n        height: ").concat(getSizeValue(height), ";\n      ");
    }
    else if (size) {
        return "\n        width: ".concat(userSizeMap[size], ";\n        height: ").concat(userSizeMap[size], ";\n      ");
    }
};
var UserPlaceholder = styled.div(templateObject_1$12 || (templateObject_1$12 = __makeTemplateObject(["\n  background-color: ", ";\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  background-color: ", ";\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])), colorSurface.secondary);
var UserWrapper = styled.div(templateObject_2$t || (templateObject_2$t = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var size = _a.size, width = _a.width, height = _a.height;
    return "\n    ".concat(getSize({ size: size, width: width, height: height }), "\n    border-radius: 50%;\n    border: 2px solid ").concat(colorBorder$1.colorBorderBorderPrimary, ";\n    overflow: hidden;\n    flex-shrink: 0;\n    img {\n        ").concat(getSize({ size: size, width: width, height: height }), "\n        aspect-ratio: 1/1;\n        object-fit: cover;\n    }\n");
});
var templateObject_1$12, templateObject_2$t;

var Placeholder = function (_a) {
    var size = _a.size;
    var iconSize = size === 'large' ? 'normal' : 'smaller';
    return (jsx(UserPlaceholder, { children: jsx(Icon, { name: "user", size: iconSize, color: "colorIconIconSecondary" }) }));
};
var User = function (_a) {
    var className = _a.className, src = _a.src, _b = _a.size, size = _b === void 0 ? 'normal' : _b, width = _a.width, height = _a.height, alt = _a.alt;
    var _c = useState(!src), showPlaceholder = _c[0], setShowPlaceholder = _c[1];
    return (jsx(UserWrapper, __assign({ className: className, size: size, width: width, height: height }, { children: showPlaceholder ? (jsx(Placeholder, { size: size || 'large' })) : (jsx("img", { alt: alt, src: src, onError: function () { return setShowPlaceholder(true); } })) })));
};

var Image = function (_a) {
    var type = _a.type, imageProps = __rest(_a, ["type"]);
    switch (type) {
        case 'user':
            return jsx(User, __assign({}, imageProps));
        case 'avatar':
            return jsx(Avatar, __assign({}, imageProps));
        default:
            return null;
    }
};

var StyledBubble$1 = styled(Bubble).attrs({
    borderWidth: 1,
    padding: '0 8px 0 0',
    borderRadius: 200
})(templateObject_1$11 || (templateObject_1$11 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  gap: 4px;\n  width: 100%;\n  max-width: 337px;\n  align-items: center;\n  border-left: 0;\n  position: relative;\n"], ["\n  display: flex;\n  flex-direction: row;\n  gap: 4px;\n  width: 100%;\n  max-width: 337px;\n  align-items: center;\n  border-left: 0;\n  position: relative;\n"])));
var StyledUserImage = styled(Image).attrs({
    type: 'user',
    size: 'normal',
    width: 30,
    height: 30
})(templateObject_2$s || (templateObject_2$s = __makeTemplateObject(["\n  border: 1px solid ", ";\n  box-sizing: border-box;\n"], ["\n  border: 1px solid ", ";\n  box-sizing: border-box;\n"])), function (_a) {
    var borderColor = _a.borderColor;
    return getBorderColor(borderColor) || borderColor;
});
var WonStarIcon = styled(Icon).attrs({
    name: 'score',
    color: 'warning',
    size: 'larger'
})(templateObject_3$d || (templateObject_3$d = __makeTemplateObject(["\n  position: absolute;\n  bottom: -12px;\n  left: 12px;\n"], ["\n  position: absolute;\n  bottom: -12px;\n  left: 12px;\n"])));
var StyledHeadline = styled(Headline)(templateObject_4$6 || (templateObject_4$6 = __makeTemplateObject(["\n  flex-shrink: 0;\n  width: fit-content;\n"], ["\n  flex-shrink: 0;\n  width: fit-content;\n"])));
var templateObject_1$11, templateObject_2$s, templateObject_3$d, templateObject_4$6;

var BaseBidState = function (_a) {
    var bestOffererImage = _a.bestOffererImage, bestOfferAmount = _a.bestOfferAmount, reserveMet = _a.reserveMet, borderColor = _a.borderColor, backgroundColor = _a.backgroundColor, text = _a.text, showStar = _a.showStar;
    return (jsxs(StyledBubble$1, __assign({ borderColor: borderColor, background: backgroundColor }, { children: [jsx(StyledUserImage, { borderColor: borderColor, src: bestOffererImage }), showStar && jsx(WonStarIcon, {}), jsx(Body, __assign({ truncable: true }, { children: text })), jsx(StyledHeadline, __assign({ size: "H6", truncable: true }, { children: pricify(bestOfferAmount) })), reserveMet && jsx(Icon, { name: "success", color: "colorIconIconSuccess", size: "smaller" })] })));
};

var getRenderStateDependingOnOfferState = function (_a) {
    var didUserBid = _a.didUserBid, isUserTopOfferer = _a.isUserTopOfferer, isSellerCounterOffering = _a.isSellerCounterOffering, isSealedBidSale = _a.isSealedBidSale, wasSold = _a.wasSold;
    var renderState = MARKETPLACE_BID_STATE_COLORS.nonBided;
    if (wasSold && isUserTopOfferer) {
        renderState = MARKETPLACE_BID_STATE_COLORS.won;
    }
    else if (wasSold && !isUserTopOfferer) {
        renderState = MARKETPLACE_BID_STATE_COLORS.sold;
    }
    else if (isSellerCounterOffering) {
        renderState = MARKETPLACE_BID_STATE_COLORS.counter;
    }
    else if (isSealedBidSale) {
        renderState = MARKETPLACE_BID_STATE_COLORS.sealedBidOffered;
    }
    else if (didUserBid && isUserTopOfferer) {
        renderState = MARKETPLACE_BID_STATE_COLORS.leader;
    }
    else if (didUserBid && !isUserTopOfferer) {
        renderState = MARKETPLACE_BID_STATE_COLORS.outBided;
    }
    return renderState;
};
var BidState = function (_a) {
    var bestOffererImage = _a.bestOffererImage, bestOfferAmount = _a.bestOfferAmount, myOfferAmount = _a.myOfferAmount, myProfileImage = _a.myProfileImage, didUserBid = _a.didUserBid, isUserTopOfferer = _a.isUserTopOfferer, isSellerCounterOffering = _a.isSellerCounterOffering, isSealedBidSale = _a.isSealedBidSale, wasSold = _a.wasSold;
    var _b = getRenderStateDependingOnOfferState({
        didUserBid: didUserBid,
        isUserTopOfferer: isUserTopOfferer,
        isSellerCounterOffering: isSellerCounterOffering,
        isSealedBidSale: isSealedBidSale,
        wasSold: wasSold
    }), borderColor = _b.borderColor, backgroundColor = _b.backgroundColor, text = _b.text, showStar = _b.showStar;
    var offerImage = isSealedBidSale ? myProfileImage : bestOffererImage;
    var offerAmount = isSealedBidSale ? myOfferAmount : bestOfferAmount;
    return (jsx(BaseBidState, { bestOffererImage: offerImage, bestOfferAmount: offerAmount, borderColor: borderColor, backgroundColor: backgroundColor, text: text, reserveMet: false, showStar: showStar }));
};

var imageGalleryExports = {};
var imageGallery = {
  get exports(){ return imageGalleryExports; },
  set exports(v){ imageGalleryExports = v; },
};

(function (module, exports) {
	!function(e,t){module.exports=t(React__default);}(commonjsGlobal,(function(e){return (()=>{var t={703:(e,t,n)=>{var i=n(414);function r(){}function a(){}a.resetWarningCache=r,e.exports=function(){function e(e,t,n,r,a,s){if(s!==i){var o=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw o.name="Invariant Violation",o}}function t(){return e}e.isRequired=e;var n={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,elementType:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t,checkPropTypes:a,resetWarningCache:r};return n.PropTypes=n,n};},697:(e,t,n)=>{e.exports=n(703)();},414:e=>{e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";},590:e=>{var t="undefined"!=typeof Element,n="function"==typeof Map,i="function"==typeof Set,r="function"==typeof ArrayBuffer&&!!ArrayBuffer.isView;function a(e,s){if(e===s)return !0;if(e&&s&&"object"==typeof e&&"object"==typeof s){if(e.constructor!==s.constructor)return !1;var o,l,u,c;if(Array.isArray(e)){if((o=e.length)!=s.length)return !1;for(l=o;0!=l--;)if(!a(e[l],s[l]))return !1;return !0}if(n&&e instanceof Map&&s instanceof Map){if(e.size!==s.size)return !1;for(c=e.entries();!(l=c.next()).done;)if(!s.has(l.value[0]))return !1;for(c=e.entries();!(l=c.next()).done;)if(!a(l.value[1],s.get(l.value[0])))return !1;return !0}if(i&&e instanceof Set&&s instanceof Set){if(e.size!==s.size)return !1;for(c=e.entries();!(l=c.next()).done;)if(!s.has(l.value[0]))return !1;return !0}if(r&&ArrayBuffer.isView(e)&&ArrayBuffer.isView(s)){if((o=e.length)!=s.length)return !1;for(l=o;0!=l--;)if(e[l]!==s[l])return !1;return !0}if(e.constructor===RegExp)return e.source===s.source&&e.flags===s.flags;if(e.valueOf!==Object.prototype.valueOf)return e.valueOf()===s.valueOf();if(e.toString!==Object.prototype.toString)return e.toString()===s.toString();if((o=(u=Object.keys(e)).length)!==Object.keys(s).length)return !1;for(l=o;0!=l--;)if(!Object.prototype.hasOwnProperty.call(s,u[l]))return !1;if(t&&e instanceof Element)return !1;for(l=o;0!=l--;)if(("_owner"!==u[l]&&"__v"!==u[l]&&"__o"!==u[l]||!e.$$typeof)&&!a(e[u[l]],s[u[l]]))return !1;return !0}return e!=e&&s!=s}e.exports=function(e,t){try{return a(e,t)}catch(e){if((e.message||"").match(/stack|recursion/i))return console.warn("react-fast-compare cannot handle circular refs"),!1;throw e}};},37:function(e,t,n){!function(e,t){function n(){return (n=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var i in n)Object.prototype.hasOwnProperty.call(n,i)&&(e[i]=n[i]);}return e}).apply(this,arguments)}var i="Left",r="Right",a="Down",s={delta:10,preventDefaultTouchmoveEvent:!1,rotationAngle:0,trackMouse:!1,trackTouch:!0},o={first:!0,initial:[0,0],start:0,swiping:!1,xy:[0,0]},l="mousemove",u="mouseup";function c(e,t){if(0===t)return e;var n=Math.PI/180*t;return [e[0]*Math.cos(n)+e[1]*Math.sin(n),e[1]*Math.cos(n)-e[0]*Math.sin(n)]}function h(e,t){var s=function(t){t&&"touches"in t&&t.touches.length>1||e((function(e,i){i.trackMouse&&(document.addEventListener(l,h),document.addEventListener(u,f));var r="touches"in t?t.touches[0]:t,a=c([r.clientX,r.clientY],i.rotationAngle);return n({},e,o,{initial:[].concat(a),xy:a,start:t.timeStamp||0})}));},h=function(t){e((function(e,s){if("touches"in t&&t.touches.length>1)return e;var o="touches"in t?t.touches[0]:t,l=c([o.clientX,o.clientY],s.rotationAngle),u=l[0],h=l[1],d=u-e.xy[0],f=h-e.xy[1],p=Math.abs(d),m=Math.abs(f),v=(t.timeStamp||0)-e.start,g=Math.sqrt(p*p+m*m)/(v||1),b=[d/(v||1),f/(v||1)];if(p<s.delta&&m<s.delta&&!e.swiping)return e;var y=function(e,t,n,s){return e>t?n>0?r:i:s>0?a:"Up"}(p,m,d,f),w={absX:p,absY:m,deltaX:d,deltaY:f,dir:y,event:t,first:e.first,initial:e.initial,velocity:g,vxvy:b};s.onSwiping&&s.onSwiping(w);var T=!1;return (s.onSwiping||s.onSwiped||"onSwiped"+y in s)&&(T=!0),T&&s.preventDefaultTouchmoveEvent&&s.trackTouch&&t.cancelable&&t.preventDefault(),n({},e,{first:!1,eventData:w,swiping:!0})}));},d=function(t){e((function(e,i){var r;if(e.swiping&&e.eventData){r=n({},e.eventData,{event:t}),i.onSwiped&&i.onSwiped(r);var a="onSwiped"+r.dir;a in i&&i[a](r);}else i.onTap&&i.onTap({event:t});return n({},e,o,{eventData:r})}));},f=function(e){document.removeEventListener(l,h),document.removeEventListener(u,f),d(e);},p=function(e,t){var n=function(){};if(e&&e.addEventListener){var i=[["touchstart",s],["touchmove",h],["touchend",d]];i.forEach((function(n){var i=n[0],r=n[1];return e.addEventListener(i,r,{passive:t})})),n=function(){return i.forEach((function(t){var n=t[0],i=t[1];return e.removeEventListener(n,i)}))};}return n},m={ref:function(t){null!==t&&e((function(e,i){if(e.el===t)return e;var r={};return e.el&&e.el!==t&&e.cleanUpTouch&&(e.cleanUpTouch(),r.cleanUpTouch=void 0),i.trackTouch&&t&&(r.cleanUpTouch=p(t,!i.preventDefaultTouchmoveEvent)),n({},e,{el:t},r)}));}};return t.trackMouse&&(m.onMouseDown=s),[m,p]}e.DOWN=a,e.LEFT=i,e.RIGHT=r,e.UP="Up",e.useSwipeable=function(e){var i=e.trackMouse,r=t.useRef(n({},o)),a=t.useRef(n({},s));a.current=n({},s,e);var l=t.useMemo((function(){return h((function(e){return r.current=e(r.current,a.current)}),{trackMouse:i})}),[i]),u=l[0],c=l[1];return r.current=function(e,t,i){var r={};return !t.trackTouch&&e.cleanUpTouch?(e.cleanUpTouch(),r.cleanUpTouch=void 0):t.trackTouch&&!e.cleanUpTouch&&e.el&&(r.cleanUpTouch=i(e.el,!t.preventDefaultTouchmoveEvent)),n({},e,r)}(r.current,a.current,c),u};}(t,n(888));},888:t=>{t.exports=e;}},n={};function i(e){var r=n[e];if(void 0!==r)return r.exports;var a=n[e]={exports:{}};return t[e].call(a.exports,a,a.exports,i),a.exports}i.n=e=>{var t=e&&e.__esModule?()=>e.default:()=>e;return i.d(t,{a:t}),t},i.d=(e,t)=>{for(var n in t)i.o(t,n)&&!i.o(e,n)&&Object.defineProperty(e,n,{enumerable:!0,get:t[n]});},i.g=function(){if("object"==typeof globalThis)return globalThis;try{return this||new Function("return this")()}catch(e){if("object"==typeof window)return window}}(),i.o=(e,t)=>Object.prototype.hasOwnProperty.call(e,t),i.r=e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0});};var r={};return (()=>{function e(t){var n,i,r="";if("string"==typeof t||"number"==typeof t)r+=t;else if("object"==typeof t)if(Array.isArray(t))for(n=0;n<t.length;n++)t[n]&&(i=e(t[n]))&&(r&&(r+=" "),r+=i);else for(n in t)t[n]&&(r&&(r+=" "),r+=n);return r}function t(){for(var t,n,i=0,r="";i<arguments.length;)(t=arguments[i++])&&(n=e(t))&&(r&&(r+=" "),r+=n);return r}i.r(r),i.d(r,{default:()=>Pe});var n=i(888),a=i.n(n);const s=function(e){var t=typeof e;return null!=e&&("object"==t||"function"==t)},o="object"==typeof commonjsGlobal&&commonjsGlobal&&commonjsGlobal.Object===Object&&commonjsGlobal;var l="object"==typeof self&&self&&self.Object===Object&&self;const u=o||l||Function("return this")(),c=function(){return u.Date.now()};var h=/\s/;var d=/^\s+/;const f=function(e){return e?e.slice(0,function(e){for(var t=e.length;t--&&h.test(e.charAt(t)););return t}(e)+1).replace(d,""):e},p=u.Symbol;var m=Object.prototype,v=m.hasOwnProperty,g=m.toString,b=p?p.toStringTag:void 0;var y=Object.prototype.toString;var w=p?p.toStringTag:void 0;const T=function(e){return null==e?void 0===e?"[object Undefined]":"[object Null]":w&&w in Object(e)?function(e){var t=v.call(e,b),n=e[b];try{e[b]=void 0;var i=!0;}catch(e){}var r=g.call(e);return i&&(t?e[b]=n:delete e[b]),r}(e):function(e){return y.call(e)}(e)};var S=/^[-+]0x[0-9a-f]+$/i,O=/^0b[01]+$/i,E=/^0o[0-7]+$/i,k=parseInt;const I=function(e){if("number"==typeof e)return e;if(function(e){return "symbol"==typeof e||function(e){return null!=e&&"object"==typeof e}(e)&&"[object Symbol]"==T(e)}(e))return NaN;if(s(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=s(t)?t+"":t;}if("string"!=typeof e)return 0===e?e:+e;e=f(e);var n=O.test(e);return n||E.test(e)?k(e.slice(2),n?2:8):S.test(e)?NaN:+e};var x=Math.max,_=Math.min;const R=function(e,t,n){var i,r,a,o,l,u,h=0,d=!1,f=!1,p=!0;if("function"!=typeof e)throw new TypeError("Expected a function");function m(t){var n=i,a=r;return i=r=void 0,h=t,o=e.apply(a,n)}function v(e){return h=e,l=setTimeout(b,t),d?m(e):o}function g(e){var n=e-u;return void 0===u||n>=t||n<0||f&&e-h>=a}function b(){var e=c();if(g(e))return y(e);l=setTimeout(b,function(e){var n=t-(e-u);return f?_(n,a-(e-h)):n}(e));}function y(e){return l=void 0,p&&i?m(e):(i=r=void 0,o)}function w(){var e=c(),n=g(e);if(i=arguments,r=this,u=e,n){if(void 0===l)return v(u);if(f)return clearTimeout(l),l=setTimeout(b,t),m(u)}return void 0===l&&(l=setTimeout(b,t)),o}return t=I(t)||0,s(n)&&(d=!!n.leading,a=(f="maxWait"in n)?x(I(n.maxWait)||0,t):a,p="trailing"in n?!!n.trailing:p),w.cancel=function(){void 0!==l&&clearTimeout(l),h=0,i=u=r=l=void 0;},w.flush=function(){return void 0===l?o:y(c())},w},L=function(e,t,n){var i=!0,r=!0;if("function"!=typeof e)throw new TypeError("Expected a function");return s(n)&&(i="leading"in n?!!n.leading:i,r="trailing"in n?!!n.trailing:r),R(e,t,{leading:i,maxWait:t,trailing:r})};var P=i(590),M=i.n(P),W=function(){if("undefined"!=typeof Map)return Map;function e(e,t){var n=-1;return e.some((function(e,i){return e[0]===t&&(n=i,!0)})),n}return function(){function t(){this.__entries__=[];}return Object.defineProperty(t.prototype,"size",{get:function(){return this.__entries__.length},enumerable:!0,configurable:!0}),t.prototype.get=function(t){var n=e(this.__entries__,t),i=this.__entries__[n];return i&&i[1]},t.prototype.set=function(t,n){var i=e(this.__entries__,t);~i?this.__entries__[i][1]=n:this.__entries__.push([t,n]);},t.prototype.delete=function(t){var n=this.__entries__,i=e(n,t);~i&&n.splice(i,1);},t.prototype.has=function(t){return !!~e(this.__entries__,t)},t.prototype.clear=function(){this.__entries__.splice(0);},t.prototype.forEach=function(e,t){void 0===t&&(t=null);for(var n=0,i=this.__entries__;n<i.length;n++){var r=i[n];e.call(t,r[1],r[0]);}},t}()}(),D="undefined"!=typeof window&&"undefined"!=typeof document&&window.document===document,F=void 0!==i.g&&i.g.Math===Math?i.g:"undefined"!=typeof self&&self.Math===Math?self:"undefined"!=typeof window&&window.Math===Math?window:Function("return this")(),C="function"==typeof requestAnimationFrame?requestAnimationFrame.bind(F):function(e){return setTimeout((function(){return e(Date.now())}),1e3/60)},z=["top","right","bottom","left","width","height","size","weight"],N="undefined"!=typeof MutationObserver,j=function(){function e(){this.connected_=!1,this.mutationEventsAdded_=!1,this.mutationsObserver_=null,this.observers_=[],this.onTransitionEnd_=this.onTransitionEnd_.bind(this),this.refresh=function(e,t){var n=!1,i=!1,r=0;function a(){n&&(n=!1,e()),i&&o();}function s(){C(a);}function o(){var e=Date.now();if(n){if(e-r<2)return;i=!0;}else n=!0,i=!1,setTimeout(s,20);r=e;}return o}(this.refresh.bind(this));}return e.prototype.addObserver=function(e){~this.observers_.indexOf(e)||this.observers_.push(e),this.connected_||this.connect_();},e.prototype.removeObserver=function(e){var t=this.observers_,n=t.indexOf(e);~n&&t.splice(n,1),!t.length&&this.connected_&&this.disconnect_();},e.prototype.refresh=function(){this.updateObservers_()&&this.refresh();},e.prototype.updateObservers_=function(){var e=this.observers_.filter((function(e){return e.gatherActive(),e.hasActive()}));return e.forEach((function(e){return e.broadcastActive()})),e.length>0},e.prototype.connect_=function(){D&&!this.connected_&&(document.addEventListener("transitionend",this.onTransitionEnd_),window.addEventListener("resize",this.refresh),N?(this.mutationsObserver_=new MutationObserver(this.refresh),this.mutationsObserver_.observe(document,{attributes:!0,childList:!0,characterData:!0,subtree:!0})):(document.addEventListener("DOMSubtreeModified",this.refresh),this.mutationEventsAdded_=!0),this.connected_=!0);},e.prototype.disconnect_=function(){D&&this.connected_&&(document.removeEventListener("transitionend",this.onTransitionEnd_),window.removeEventListener("resize",this.refresh),this.mutationsObserver_&&this.mutationsObserver_.disconnect(),this.mutationEventsAdded_&&document.removeEventListener("DOMSubtreeModified",this.refresh),this.mutationsObserver_=null,this.mutationEventsAdded_=!1,this.connected_=!1);},e.prototype.onTransitionEnd_=function(e){var t=e.propertyName,n=void 0===t?"":t;z.some((function(e){return !!~n.indexOf(e)}))&&this.refresh();},e.getInstance=function(){return this.instance_||(this.instance_=new e),this.instance_},e.instance_=null,e}(),B=function(e,t){for(var n=0,i=Object.keys(t);n<i.length;n++){var r=i[n];Object.defineProperty(e,r,{value:t[r],enumerable:!1,writable:!1,configurable:!0});}return e},A=function(e){return e&&e.ownerDocument&&e.ownerDocument.defaultView||F},G=V(0,0,0,0);function U(e){return parseFloat(e)||0}function H(e){for(var t=[],n=1;n<arguments.length;n++)t[n-1]=arguments[n];return t.reduce((function(t,n){return t+U(e["border-"+n+"-width"])}),0)}var q="undefined"!=typeof SVGGraphicsElement?function(e){return e instanceof A(e).SVGGraphicsElement}:function(e){return e instanceof A(e).SVGElement&&"function"==typeof e.getBBox};function K(e){return D?q(e)?function(e){var t=e.getBBox();return V(0,0,t.width,t.height)}(e):function(e){var t=e.clientWidth,n=e.clientHeight;if(!t&&!n)return G;var i=A(e).getComputedStyle(e),r=function(e){for(var t={},n=0,i=["top","right","bottom","left"];n<i.length;n++){var r=i[n],a=e["padding-"+r];t[r]=U(a);}return t}(i),a=r.left+r.right,s=r.top+r.bottom,o=U(i.width),l=U(i.height);if("border-box"===i.boxSizing&&(Math.round(o+a)!==t&&(o-=H(i,"left","right")+a),Math.round(l+s)!==n&&(l-=H(i,"top","bottom")+s)),!function(e){return e===A(e).document.documentElement}(e)){var u=Math.round(o+a)-t,c=Math.round(l+s)-n;1!==Math.abs(u)&&(o-=u),1!==Math.abs(c)&&(l-=c);}return V(r.left,r.top,o,l)}(e):G}function V(e,t,n,i){return {x:e,y:t,width:n,height:i}}var X=function(){function e(e){this.broadcastWidth=0,this.broadcastHeight=0,this.contentRect_=V(0,0,0,0),this.target=e;}return e.prototype.isActive=function(){var e=K(this.target);return this.contentRect_=e,e.width!==this.broadcastWidth||e.height!==this.broadcastHeight},e.prototype.broadcastRect=function(){var e=this.contentRect_;return this.broadcastWidth=e.width,this.broadcastHeight=e.height,e},e}(),Y=function(e,t){var n,i,r,a,s,o,l,u=(i=(n=t).x,r=n.y,a=n.width,s=n.height,o="undefined"!=typeof DOMRectReadOnly?DOMRectReadOnly:Object,l=Object.create(o.prototype),B(l,{x:i,y:r,width:a,height:s,top:r,right:i+a,bottom:s+r,left:i}),l);B(this,{target:e,contentRect:u});},$=function(){function e(e,t,n){if(this.activeObservations_=[],this.observations_=new W,"function"!=typeof e)throw new TypeError("The callback provided as parameter 1 is not a function.");this.callback_=e,this.controller_=t,this.callbackCtx_=n;}return e.prototype.observe=function(e){if(!arguments.length)throw new TypeError("1 argument required, but only 0 present.");if("undefined"!=typeof Element&&Element instanceof Object){if(!(e instanceof A(e).Element))throw new TypeError('parameter 1 is not of type "Element".');var t=this.observations_;t.has(e)||(t.set(e,new X(e)),this.controller_.addObserver(this),this.controller_.refresh());}},e.prototype.unobserve=function(e){if(!arguments.length)throw new TypeError("1 argument required, but only 0 present.");if("undefined"!=typeof Element&&Element instanceof Object){if(!(e instanceof A(e).Element))throw new TypeError('parameter 1 is not of type "Element".');var t=this.observations_;t.has(e)&&(t.delete(e),t.size||this.controller_.removeObserver(this));}},e.prototype.disconnect=function(){this.clearActive(),this.observations_.clear(),this.controller_.removeObserver(this);},e.prototype.gatherActive=function(){var e=this;this.clearActive(),this.observations_.forEach((function(t){t.isActive()&&e.activeObservations_.push(t);}));},e.prototype.broadcastActive=function(){if(this.hasActive()){var e=this.callbackCtx_,t=this.activeObservations_.map((function(e){return new Y(e.target,e.broadcastRect())}));this.callback_.call(e,t,e),this.clearActive();}},e.prototype.clearActive=function(){this.activeObservations_.splice(0);},e.prototype.hasActive=function(){return this.activeObservations_.length>0},e}(),J="undefined"!=typeof WeakMap?new WeakMap:new W,Q=function e(t){if(!(this instanceof e))throw new TypeError("Cannot call a class as a function.");if(!arguments.length)throw new TypeError("1 argument required, but only 0 present.");var n=j.getInstance(),i=new $(t,n,this);J.set(this,i);};["observe","unobserve","disconnect"].forEach((function(e){Q.prototype[e]=function(){var t;return (t=J.get(this))[e].apply(t,arguments)};}));const Z=void 0!==F.ResizeObserver?F.ResizeObserver:Q;var ee=i(37),te=i(697),ne=a().memo((function(e){var t=e.description,n=e.fullscreen,i=e.handleImageLoaded,r=e.isFullscreen,s=e.onImageError,o=e.original,l=e.originalAlt,u=e.originalHeight,c=e.originalWidth,h=e.originalTitle,d=e.sizes,f=e.srcSet,p=e.loading,m=r&&n||o;return a().createElement(a().Fragment,null,a().createElement("img",{className:"image-gallery-image",src:m,alt:l,srcSet:f,height:u,width:c,sizes:d,title:h,onLoad:function(e){return i(e,o)},onError:s,loading:p}),t&&a().createElement("span",{className:"image-gallery-description"},t))}));ne.displayName="Item",ne.propTypes={description:te.string,fullscreen:te.string,handleImageLoaded:te.func.isRequired,isFullscreen:te.bool,onImageError:te.func.isRequired,original:te.string.isRequired,originalAlt:te.string,originalHeight:te.string,originalWidth:te.string,originalTitle:te.string,sizes:te.string,srcSet:te.string,loading:te.string},ne.defaultProps={description:"",fullscreen:"",isFullscreen:!1,originalAlt:"",originalHeight:"",originalWidth:"",originalTitle:"",sizes:"",srcSet:"",loading:"eager"};const ie=ne;var re={left:a().createElement("polyline",{points:"15 18 9 12 15 6"}),right:a().createElement("polyline",{points:"9 18 15 12 9 6"}),maximize:a().createElement("path",{d:"M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"}),minimize:a().createElement("path",{d:"M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"}),play:a().createElement("polygon",{points:"5 3 19 12 5 21 5 3"}),pause:a().createElement(a().Fragment,null,a().createElement("rect",{x:"6",y:"4",width:"4",height:"16"}),a().createElement("rect",{x:"14",y:"4",width:"4",height:"16"}))},ae=function(e){var t=e.strokeWidth,n=e.viewBox,i=e.icon;return a().createElement("svg",{className:"image-gallery-svg",xmlns:"http://www.w3.org/2000/svg",viewBox:n,fill:"none",stroke:"currentColor",strokeWidth:t,strokeLinecap:"round",strokeLinejoin:"round"},re[i])};ae.propTypes={strokeWidth:te.number,viewBox:te.string,icon:(0, te.oneOf)(["left","right","maximize","minimize","play","pause"]).isRequired},ae.defaultProps={strokeWidth:1,viewBox:"0 0 24 24"};const se=ae;var oe=a().memo((function(e){var t=e.isFullscreen,n=e.onClick;return a().createElement("button",{type:"button",className:"image-gallery-icon image-gallery-fullscreen-button",onClick:n,"aria-label":"Open Fullscreen"},a().createElement(se,{strokeWidth:2,icon:t?"minimize":"maximize"}))}));oe.displayName="Fullscreen",oe.propTypes={isFullscreen:te.bool.isRequired,onClick:te.func.isRequired};const le=oe;var ue=a().memo((function(e){var t=e.disabled,n=e.onClick;return a().createElement("button",{type:"button",className:"image-gallery-icon image-gallery-left-nav",disabled:t,onClick:n,"aria-label":"Previous Slide"},a().createElement(se,{icon:"left",viewBox:"6 0 12 24"}))}));ue.displayName="LeftNav",ue.propTypes={disabled:te.bool.isRequired,onClick:te.func.isRequired};const ce=ue;var he=a().memo((function(e){var t=e.disabled,n=e.onClick;return a().createElement("button",{type:"button",className:"image-gallery-icon image-gallery-right-nav",disabled:t,onClick:n,"aria-label":"Next Slide"},a().createElement(se,{icon:"right",viewBox:"6 0 12 24"}))}));he.displayName="RightNav",he.propTypes={disabled:te.bool.isRequired,onClick:te.func.isRequired};const de=he;var fe=a().memo((function(e){var t=e.isPlaying,n=e.onClick;return a().createElement("button",{type:"button",className:"image-gallery-icon image-gallery-play-button",onClick:n,"aria-label":"Play or Pause Slideshow"},a().createElement(se,{strokeWidth:2,icon:t?"pause":"play"}))}));fe.displayName="PlayPause",fe.propTypes={isPlaying:te.bool.isRequired,onClick:te.func.isRequired};const pe=fe;function me(){return (me=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var i in n)Object.prototype.hasOwnProperty.call(n,i)&&(e[i]=n[i]);}return e}).apply(this,arguments)}var ve=function(e){var t=e.children,n=e.className,i=e.delta,r=e.onSwiping,s=e.onSwiped,o=(0, ee.useSwipeable)({delta:i,onSwiping:r,onSwiped:s});return a().createElement("div",me({},o,{className:n}),t)};ve.propTypes={children:te.node.isRequired,className:te.string,delta:te.number,onSwiped:te.func,onSwiping:te.func},ve.defaultProps={className:"",delta:0,onSwiping:function(){},onSwiped:function(){}};const ge=ve;function be(e){return (be="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function ye(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);t&&(i=i.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,i);}return n}function we(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?ye(Object(n),!0).forEach((function(t){Te(e,t,n[t]);})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):ye(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t));}));}return e}function Te(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function Se(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i);}}function Oe(e,t){return (Oe=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function Ee(e,t){return !t||"object"!==be(t)&&"function"!=typeof t?ke(e):t}function ke(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function Ie(e){return (Ie=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}var xe=["fullscreenchange","MSFullscreenChange","mozfullscreenchange","webkitfullscreenchange"],_e=(0, te.arrayOf)((0, te.shape)({srcSet:te.string,media:te.string}));function Re(e){var t=parseInt(e.keyCode||e.which||0,10);return 66===t||62===t}var Le=function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&Oe(e,t);}(l,e);var n,i,r,s,o=(r=l,s=function(){if("undefined"==typeof Reflect||!Reflect.construct)return !1;if(Reflect.construct.sham)return !1;if("function"==typeof Proxy)return !0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return !1}}(),function(){var e,t=Ie(r);if(s){var n=Ie(this).constructor;e=Reflect.construct(t,arguments,n);}else e=t.apply(this,arguments);return Ee(this,e)});function l(e){var t;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,l),(t=o.call(this,e)).state={currentIndex:e.startIndex,thumbsTranslate:0,thumbsSwipedTranslate:0,currentSlideOffset:0,galleryWidth:0,thumbnailsWrapperWidth:0,thumbnailsWrapperHeight:0,thumbsStyle:{transition:"all ".concat(e.slideDuration,"ms ease-out")},isFullscreen:!1,isSwipingThumbnail:!1,isPlaying:!1},t.loadedImages={},t.imageGallery=a().createRef(),t.thumbnailsWrapper=a().createRef(),t.thumbnails=a().createRef(),t.imageGallerySlideWrapper=a().createRef(),t.handleImageLoaded=t.handleImageLoaded.bind(ke(t)),t.handleKeyDown=t.handleKeyDown.bind(ke(t)),t.handleMouseDown=t.handleMouseDown.bind(ke(t)),t.handleResize=t.handleResize.bind(ke(t)),t.handleTouchMove=t.handleTouchMove.bind(ke(t)),t.handleOnSwiped=t.handleOnSwiped.bind(ke(t)),t.handleScreenChange=t.handleScreenChange.bind(ke(t)),t.handleSwiping=t.handleSwiping.bind(ke(t)),t.handleThumbnailSwiping=t.handleThumbnailSwiping.bind(ke(t)),t.handleOnThumbnailSwiped=t.handleOnThumbnailSwiped.bind(ke(t)),t.onThumbnailMouseLeave=t.onThumbnailMouseLeave.bind(ke(t)),t.handleImageError=t.handleImageError.bind(ke(t)),t.pauseOrPlay=t.pauseOrPlay.bind(ke(t)),t.renderThumbInner=t.renderThumbInner.bind(ke(t)),t.renderItem=t.renderItem.bind(ke(t)),t.slideLeft=t.slideLeft.bind(ke(t)),t.slideRight=t.slideRight.bind(ke(t)),t.toggleFullScreen=t.toggleFullScreen.bind(ke(t)),t.togglePlay=t.togglePlay.bind(ke(t)),t.unthrottledSlideToIndex=t.slideToIndex,t.slideToIndex=L(t.unthrottledSlideToIndex,e.slideDuration,{trailing:!1}),e.lazyLoad&&(t.lazyLoaded=[]),t}return n=l,(i=[{key:"componentDidMount",value:function(){var e=this.props,t=e.autoPlay,n=e.useWindowKeyDown;t&&this.play(),n?window.addEventListener("keydown",this.handleKeyDown):this.imageGallery.current.addEventListener("keydown",this.handleKeyDown),window.addEventListener("mousedown",this.handleMouseDown),window.addEventListener("touchmove",this.handleTouchMove,{passive:!1}),this.initSlideWrapperResizeObserver(this.imageGallerySlideWrapper),this.initThumbnailWrapperResizeObserver(this.thumbnailsWrapper),this.addScreenChangeEvent();}},{key:"componentDidUpdate",value:function(e,t){var n=this.props,i=n.items,r=n.lazyLoad,a=n.slideDuration,s=n.slideInterval,o=n.startIndex,l=n.thumbnailPosition,u=n.showThumbnails,c=n.useWindowKeyDown,h=this.state,d=h.currentIndex,f=h.isPlaying,p=e.items.length!==i.length,m=!M()(e.items,i),v=e.startIndex!==o,g=e.thumbnailPosition!==l,b=e.showThumbnails!==u;s===e.slideInterval&&a===e.slideDuration||f&&(this.pause(),this.play()),g&&(this.removeResizeObserver(),this.initSlideWrapperResizeObserver(this.imageGallerySlideWrapper),this.initThumbnailWrapperResizeObserver(this.thumbnailsWrapper)),b&&u&&this.initThumbnailWrapperResizeObserver(this.thumbnailsWrapper),b&&!u&&this.removeThumbnailsResizeObserver(),(p||b)&&this.handleResize(),t.currentIndex!==d&&this.slideThumbnailBar(),e.slideDuration!==a&&(this.slideToIndex=L(this.unthrottledSlideToIndex,a,{trailing:!1})),!r||e.lazyLoad&&!m||(this.lazyLoaded=[]),c!==e.useWindowKeyDown&&(c?(this.imageGallery.current.removeEventListener("keydown",this.handleKeyDown),window.addEventListener("keydown",this.handleKeyDown)):(window.removeEventListener("keydown",this.handleKeyDown),this.imageGallery.current.addEventListener("keydown",this.handleKeyDown))),(v||m)&&this.setState({currentIndex:o,slideStyle:{transition:"none"}});}},{key:"componentWillUnmount",value:function(){var e=this.props.useWindowKeyDown;window.removeEventListener("mousedown",this.handleMouseDown),window.removeEventListener("touchmove",this.handleTouchMove),this.removeScreenChangeEvent(),this.removeResizeObserver(),this.playPauseIntervalId&&(window.clearInterval(this.playPauseIntervalId),this.playPauseIntervalId=null),this.transitionTimer&&window.clearTimeout(this.transitionTimer),e?window.removeEventListener("keydown",this.handleKeyDown):this.imageGallery.current.removeEventListener("keydown",this.handleKeyDown);}},{key:"onSliding",value:function(){var e=this,t=this.state,n=t.currentIndex,i=t.isTransitioning,r=this.props,a=r.onSlide,s=r.slideDuration;this.transitionTimer=window.setTimeout((function(){i&&(e.setState({isTransitioning:!i,isSwipingThumbnail:!1}),a&&a(n));}),s+50);}},{key:"onThumbnailClick",value:function(e,t){var n=this.props.onThumbnailClick;e.target.parentNode.parentNode.blur(),this.slideToIndex(t,e),n&&n(e,t);}},{key:"onThumbnailMouseOver",value:function(e,t){var n=this;this.thumbnailMouseOverTimer&&(window.clearTimeout(this.thumbnailMouseOverTimer),this.thumbnailMouseOverTimer=null),this.thumbnailMouseOverTimer=window.setTimeout((function(){n.slideToIndex(t),n.pause();}),300);}},{key:"onThumbnailMouseLeave",value:function(){if(this.thumbnailMouseOverTimer){var e=this.props.autoPlay;window.clearTimeout(this.thumbnailMouseOverTimer),this.thumbnailMouseOverTimer=null,e&&this.play();}}},{key:"setThumbsTranslate",value:function(e){this.setState({thumbsTranslate:e});}},{key:"setModalFullscreen",value:function(e){var t=this.props.onScreenChange;this.setState({modalFullscreen:e}),t&&t(e);}},{key:"getThumbsTranslate",value:function(e){var t,n=this.props,i=n.disableThumbnailScroll,r=n.items,a=this.state,s=a.thumbnailsWrapperWidth,o=a.thumbnailsWrapperHeight,l=this.thumbnails&&this.thumbnails.current;if(i)return 0;if(l){if(this.isThumbnailVertical()){if(l.scrollHeight<=o)return 0;t=l.scrollHeight-o;}else {if(l.scrollWidth<=s||s<=0)return 0;t=l.scrollWidth-s;}return e*(t/(r.length-1))}return 0}},{key:"getAlignmentClassName",value:function(e){var t=this.state.currentIndex,n=this.props,i=n.infinite,r=n.items,a="",s="left",o="right";switch(e){case t-1:a=" ".concat(s);break;case t:a=" ".concat("center");break;case t+1:a=" ".concat(o);}return r.length>=3&&i&&(0===e&&t===r.length-1?a=" ".concat(o):e===r.length-1&&0===t&&(a=" ".concat(s))),a}},{key:"getTranslateXForTwoSlide",value:function(e){var t=this.state,n=t.currentIndex,i=t.currentSlideOffset,r=t.previousIndex,a=n!==r,s=0===e&&0===r,o=1===e&&1===r,l=0===e&&1===n,u=1===e&&0===n,c=0===i,h=-100*n+100*e+i;return i>0?this.direction="left":i<0&&(this.direction="right"),u&&i>0&&(h=-100+i),l&&i<0&&(h=100+i),a?s&&c&&"left"===this.direction?h=100:o&&c&&"right"===this.direction&&(h=-100):(u&&c&&"left"===this.direction&&(h=-100),l&&c&&"right"===this.direction&&(h=100)),h}},{key:"getThumbnailBarHeight",value:function(){return this.isThumbnailVertical()?{height:this.state.gallerySlideWrapperHeight}:{}}},{key:"getSlideStyle",value:function(e){var t=this.state,n=t.currentIndex,i=t.currentSlideOffset,r=t.slideStyle,a=this.props,s=a.infinite,o=a.items,l=a.useTranslate3D,u=a.isRTL,c=-100*n,h=o.length-1,d=(c+100*e)*(u?-1:1)+i;s&&o.length>2&&(0===n&&e===h?d=-100*(u?-1:1)+i:n===h&&0===e&&(d=100*(u?-1:1)+i)),s&&2===o.length&&(d=this.getTranslateXForTwoSlide(e));var f="translate(".concat(d,"%, 0)");return l&&(f="translate3d(".concat(d,"%, 0, 0)")),we({display:this.isSlideVisible(e)?"inherit":"none",WebkitTransform:f,MozTransform:f,msTransform:f,OTransform:f,transform:f},r)}},{key:"getCurrentIndex",value:function(){return this.state.currentIndex}},{key:"getThumbnailStyle",value:function(){var e,t=this.props,n=t.useTranslate3D,i=t.isRTL,r=this.state,a=r.thumbsTranslate,s=r.thumbsStyle,o=i?-1*a:a;return this.isThumbnailVertical()?(e="translate(0, ".concat(a,"px)"),n&&(e="translate3d(0, ".concat(a,"px, 0)"))):(e="translate(".concat(o,"px, 0)"),n&&(e="translate3d(".concat(o,"px, 0, 0)"))),we({WebkitTransform:e,MozTransform:e,msTransform:e,OTransform:e,transform:e},s)}},{key:"getSlideItems",value:function(){var e=this,n=this.state.currentIndex,i=this.props,r=i.items,s=i.slideOnThumbnailOver,o=i.onClick,l=i.lazyLoad,u=i.onTouchMove,c=i.onTouchEnd,h=i.onTouchStart,d=i.onMouseOver,f=i.onMouseLeave,p=i.renderItem,m=i.renderThumbInner,v=i.showThumbnails,g=i.showBullets,b=[],y=[],w=[];return r.forEach((function(i,r){var T=e.getAlignmentClassName(r),S=i.originalClass?" ".concat(i.originalClass):"",O=i.thumbnailClass?" ".concat(i.thumbnailClass):"",E=i.renderItem||p||e.renderItem,k=i.renderThumbInner||m||e.renderThumbInner,I=!l||T||e.lazyLoaded[r];I&&l&&!e.lazyLoaded[r]&&(e.lazyLoaded[r]=!0);var x=e.getSlideStyle(r),_=a().createElement("div",{"aria-label":"Go to Slide ".concat(r+1),key:"slide-".concat(r),tabIndex:"-1",className:"image-gallery-slide ".concat(T," ").concat(S),style:x,onClick:o,onKeyUp:e.handleSlideKeyUp,onTouchMove:u,onTouchEnd:c,onTouchStart:h,onMouseOver:d,onFocus:d,onMouseLeave:f,role:"button"},I?E(i):a().createElement("div",{style:{height:"100%"}}));if(b.push(_),v&&i.thumbnail){var R=t("image-gallery-thumbnail",O,{active:n===r});y.push(a().createElement("button",{key:"thumbnail-".concat(r),type:"button",tabIndex:"0","aria-pressed":n===r?"true":"false","aria-label":"Go to Slide ".concat(r+1),className:R,onMouseLeave:s?e.onThumbnailMouseLeave:null,onMouseOver:function(t){return e.handleThumbnailMouseOver(t,r)},onFocus:function(t){return e.handleThumbnailMouseOver(t,r)},onKeyUp:function(t){return e.handleThumbnailKeyUp(t,r)},onClick:function(t){return e.onThumbnailClick(t,r)}},k(i)));}if(g){var L=t("image-gallery-bullet",i.bulletClass,{active:n===r});w.push(a().createElement("button",{type:"button",key:"bullet-".concat(r),className:L,onClick:function(t){return i.bulletOnClick&&i.bulletOnClick({item:i,itemIndex:r,currentIndex:n}),t.target.blur(),e.slideToIndex.call(e,r,t)},"aria-pressed":n===r?"true":"false","aria-label":"Go to Slide ".concat(r+1)}));}})),{slides:b,thumbnails:y,bullets:w}}},{key:"ignoreIsTransitioning",value:function(){var e=this.props.items,t=this.state,n=t.previousIndex,i=t.currentIndex,r=e.length-1;return Math.abs(n-i)>1&&!(0===n&&i===r)&&!(n===r&&0===i)}},{key:"isFirstOrLastSlide",value:function(e){return e===this.props.items.length-1||0===e}},{key:"slideIsTransitioning",value:function(e){var t=this.state,n=t.isTransitioning,i=t.previousIndex,r=t.currentIndex;return n&&!(e===i||e===r)}},{key:"isSlideVisible",value:function(e){return !this.slideIsTransitioning(e)||this.ignoreIsTransitioning()&&!this.isFirstOrLastSlide(e)}},{key:"slideThumbnailBar",value:function(){var e=this.state,t=e.currentIndex,n=e.isSwipingThumbnail,i=-this.getThumbsTranslate(t);n||(0===t?this.setState({thumbsTranslate:0,thumbsSwipedTranslate:0}):this.setState({thumbsTranslate:i,thumbsSwipedTranslate:i}));}},{key:"canSlide",value:function(){return this.props.items.length>=2}},{key:"canSlideLeft",value:function(){var e=this.props,t=e.infinite,n=e.isRTL;return t||(n?this.canSlideNext():this.canSlidePrevious())}},{key:"canSlideRight",value:function(){var e=this.props,t=e.infinite,n=e.isRTL;return t||(n?this.canSlidePrevious():this.canSlideNext())}},{key:"canSlidePrevious",value:function(){return this.state.currentIndex>0}},{key:"canSlideNext",value:function(){return this.state.currentIndex<this.props.items.length-1}},{key:"handleSwiping",value:function(e){var t=e.event,n=e.absX,i=e.dir,r=this.props,a=r.disableSwipe,s=r.stopPropagation,o=this.state,l=o.galleryWidth,u=o.isTransitioning,c=o.swipingUpDown,h=o.swipingLeftRight;if(i!==ee.UP&&i!==ee.DOWN&&!c||h){if(i!==ee.LEFT&&i!==ee.RIGHT||h||this.setState({swipingLeftRight:!0}),!a){var d=this.props.swipingTransitionDuration;if(s&&t.preventDefault(),u)this.setState({currentSlideOffset:0});else {var f=i===ee.RIGHT?1:-1,p=n/l*100;Math.abs(p)>=100&&(p=100);var m={transition:"transform ".concat(d,"ms ease-out")};this.setState({currentSlideOffset:f*p,slideStyle:m});}}}else c||this.setState({swipingUpDown:!0});}},{key:"handleThumbnailSwiping",value:function(e){var t=e.event,n=e.absX,i=e.absY,r=e.dir,a=this.props,s=a.stopPropagation,o=a.swipingThumbnailTransitionDuration,l=this.state,u=l.thumbsSwipedTranslate,c=l.thumbnailsWrapperHeight,h=l.thumbnailsWrapperWidth,d=l.swipingUpDown,f=l.swipingLeftRight;if(this.isThumbnailVertical()){if((r===ee.LEFT||r===ee.RIGHT||f)&&!d)return void(f||this.setState({swipingLeftRight:!0}));r!==ee.UP&&r!==ee.DOWN||d||this.setState({swipingUpDown:!0});}else {if((r===ee.UP||r===ee.DOWN||d)&&!f)return void(d||this.setState({swipingUpDown:!0}));r!==ee.LEFT&&r!==ee.RIGHT||f||this.setState({swipingLeftRight:!0});}var p,m,v,g,b,y=this.thumbnails&&this.thumbnails.current;if(this.isThumbnailVertical()?(p=u+(r===ee.DOWN?i:-i),m=y.scrollHeight-c+20,v=Math.abs(p)>m,g=p>20,b=y.scrollHeight<=c):(p=u+(r===ee.RIGHT?n:-n),m=y.scrollWidth-h+20,v=Math.abs(p)>m,g=p>20,b=y.scrollWidth<=h),!b&&(r!==ee.LEFT&&r!==ee.UP||!v)&&(r!==ee.RIGHT&&r!==ee.DOWN||!g)){s&&t.stopPropagation();var w={transition:"transform ".concat(o,"ms ease-out")};this.setState({thumbsTranslate:p,thumbsStyle:w});}}},{key:"handleOnThumbnailSwiped",value:function(){var e=this.state.thumbsTranslate,t=this.props.slideDuration;this.resetSwipingDirection(),this.setState({isSwipingThumbnail:!0,thumbsSwipedTranslate:e,thumbsStyle:{transition:"all ".concat(t,"ms ease-out")}});}},{key:"sufficientSwipe",value:function(){var e=this.state.currentSlideOffset,t=this.props.swipeThreshold;return Math.abs(e)>t}},{key:"resetSwipingDirection",value:function(){var e=this.state,t=e.swipingUpDown,n=e.swipingLeftRight;t&&this.setState({swipingUpDown:!1}),n&&this.setState({swipingLeftRight:!1});}},{key:"handleOnSwiped",value:function(e){var t=e.event,n=e.dir,i=e.velocity,r=this.props,a=r.disableSwipe,s=r.stopPropagation,o=r.flickThreshold;if(!a){var l=this.props.isRTL;s&&t.stopPropagation(),this.resetSwipingDirection();var u=(n===ee.LEFT?1:-1)*(l?-1:1),c=n===ee.UP||n===ee.DOWN,h=i>o&&!c;this.handleOnSwipedTo(u,h);}}},{key:"handleOnSwipedTo",value:function(e,t){var n=this.state,i=n.currentIndex,r=n.isTransitioning,a=i;!this.sufficientSwipe()&&!t||r||(a+=e),(-1===e&&!this.canSlideLeft()||1===e&&!this.canSlideRight())&&(a=i),this.unthrottledSlideToIndex(a);}},{key:"handleTouchMove",value:function(e){this.state.swipingLeftRight&&e.preventDefault();}},{key:"handleMouseDown",value:function(){this.imageGallery.current.classList.add("image-gallery-using-mouse");}},{key:"handleKeyDown",value:function(e){var t=this.props,n=t.disableKeyDown,i=t.useBrowserFullscreen,r=this.state.isFullscreen;if(this.imageGallery.current.classList.remove("image-gallery-using-mouse"),!n)switch(parseInt(e.keyCode||e.which||0,10)){case 37:this.canSlideLeft()&&!this.playPauseIntervalId&&this.slideLeft(e);break;case 39:this.canSlideRight()&&!this.playPauseIntervalId&&this.slideRight(e);break;case 27:r&&!i&&this.exitFullScreen();}}},{key:"handleImageError",value:function(e){var t=this.props.onErrorImageURL;t&&-1===e.target.src.indexOf(t)&&(e.target.src=t);}},{key:"removeThumbnailsResizeObserver",value:function(){this.resizeThumbnailWrapperObserver&&this.thumbnailsWrapper&&this.thumbnailsWrapper.current&&(this.resizeThumbnailWrapperObserver.unobserve(this.thumbnailsWrapper.current),this.resizeThumbnailWrapperObserver=null);}},{key:"removeResizeObserver",value:function(){this.resizeSlideWrapperObserver&&this.imageGallerySlideWrapper&&this.imageGallerySlideWrapper.current&&(this.resizeSlideWrapperObserver.unobserve(this.imageGallerySlideWrapper.current),this.resizeSlideWrapperObserver=null),this.removeThumbnailsResizeObserver();}},{key:"handleResize",value:function(){var e=this.state.currentIndex;this.imageGallery&&(this.imageGallery&&this.imageGallery.current&&this.setState({galleryWidth:this.imageGallery.current.offsetWidth}),this.imageGallerySlideWrapper&&this.imageGallerySlideWrapper.current&&this.setState({gallerySlideWrapperHeight:this.imageGallerySlideWrapper.current.offsetHeight}),this.setThumbsTranslate(-this.getThumbsTranslate(e)));}},{key:"initSlideWrapperResizeObserver",value:function(e){var t=this;e&&!e.current||(this.resizeSlideWrapperObserver=new Z(R((function(e){e&&e.forEach((function(e){t.setState({thumbnailsWrapperWidth:e.contentRect.width},t.handleResize);}));}),50)),this.resizeSlideWrapperObserver.observe(e.current));}},{key:"initThumbnailWrapperResizeObserver",value:function(e){var t=this;e&&!e.current||(this.resizeThumbnailWrapperObserver=new Z(R((function(e){e&&e.forEach((function(e){t.setState({thumbnailsWrapperHeight:e.contentRect.height},t.handleResize);}));}),50)),this.resizeThumbnailWrapperObserver.observe(e.current));}},{key:"toggleFullScreen",value:function(){this.state.isFullscreen?this.exitFullScreen():this.fullScreen();}},{key:"togglePlay",value:function(){this.playPauseIntervalId?this.pause():this.play();}},{key:"handleScreenChange",value:function(){var e=this.props,t=e.onScreenChange,n=e.useBrowserFullscreen,i=document.fullscreenElement||document.msFullscreenElement||document.mozFullScreenElement||document.webkitFullscreenElement,r=this.imageGallery.current===i;t&&t(r),n&&this.setState({isFullscreen:r});}},{key:"slideToIndex",value:function(e,t){var n=this.state,i=n.currentIndex,r=n.isTransitioning,a=this.props,s=a.items,o=a.slideDuration,l=a.onBeforeSlide;if(!r){t&&this.playPauseIntervalId&&(this.pause(!1),this.play(!1));var u=s.length-1,c=e;e<0?c=u:e>u&&(c=0),l&&c!==i&&l(c),this.setState({previousIndex:i,currentIndex:c,isTransitioning:c!==i,currentSlideOffset:0,slideStyle:{transition:"all ".concat(o,"ms ease-out")}},this.onSliding);}}},{key:"slideLeft",value:function(e){var t=this.props.isRTL;this.slideTo(e,t?"right":"left");}},{key:"slideRight",value:function(e){var t=this.props.isRTL;this.slideTo(e,t?"left":"right");}},{key:"slideTo",value:function(e,t){var n=this,i=this.state,r=i.currentIndex,a=i.currentSlideOffset,s=i.isTransitioning,o=this.props.items,l=r+("left"===t?-1:1);s||(2===o.length?this.setState({currentSlideOffset:a+("left"===t?.001:-.001),slideStyle:{transition:"none"}},(function(){window.setTimeout((function(){return n.slideToIndex(l,e)}),25);})):this.slideToIndex(l,e));}},{key:"handleThumbnailMouseOver",value:function(e,t){this.props.slideOnThumbnailOver&&this.onThumbnailMouseOver(e,t);}},{key:"handleThumbnailKeyUp",value:function(e,t){Re(e)&&this.onThumbnailClick(e,t);}},{key:"handleSlideKeyUp",value:function(e){Re(e)&&(0, this.props.onClick)(e);}},{key:"isThumbnailVertical",value:function(){var e=this.props.thumbnailPosition;return "left"===e||"right"===e}},{key:"addScreenChangeEvent",value:function(){var e=this;xe.forEach((function(t){document.addEventListener(t,e.handleScreenChange);}));}},{key:"removeScreenChangeEvent",value:function(){var e=this;xe.forEach((function(t){document.removeEventListener(t,e.handleScreenChange);}));}},{key:"fullScreen",value:function(){var e=this.props.useBrowserFullscreen,t=this.imageGallery.current;e?t.requestFullscreen?t.requestFullscreen():t.msRequestFullscreen?t.msRequestFullscreen():t.mozRequestFullScreen?t.mozRequestFullScreen():t.webkitRequestFullscreen?t.webkitRequestFullscreen():this.setModalFullscreen(!0):this.setModalFullscreen(!0),this.setState({isFullscreen:!0});}},{key:"exitFullScreen",value:function(){var e=this.state.isFullscreen,t=this.props.useBrowserFullscreen;e&&(t?document.exitFullscreen?document.exitFullscreen():document.webkitExitFullscreen?document.webkitExitFullscreen():document.mozCancelFullScreen?document.mozCancelFullScreen():document.msExitFullscreen?document.msExitFullscreen():this.setModalFullscreen(!1):this.setModalFullscreen(!1),this.setState({isFullscreen:!1}));}},{key:"pauseOrPlay",value:function(){var e=this.props.infinite,t=this.state.currentIndex;e||this.canSlideRight()?this.slideToIndex(t+1):this.pause();}},{key:"play",value:function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0],t=this.props,n=t.onPlay,i=t.slideInterval,r=t.slideDuration,a=this.state.currentIndex;this.playPauseIntervalId||(this.setState({isPlaying:!0}),this.playPauseIntervalId=window.setInterval(this.pauseOrPlay,Math.max(i,r)),n&&e&&n(a));}},{key:"pause",value:function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0],t=this.props.onPause,n=this.state.currentIndex;this.playPauseIntervalId&&(window.clearInterval(this.playPauseIntervalId),this.playPauseIntervalId=null,this.setState({isPlaying:!1}),t&&e&&t(n));}},{key:"isImageLoaded",value:function(e){return !!this.loadedImages[e.original]||(this.loadedImages[e.original]=!0,!1)}},{key:"handleImageLoaded",value:function(e,t){var n=this.props.onImageLoad;!this.loadedImages[t]&&n&&(this.loadedImages[t]=!0,n(e));}},{key:"renderItem",value:function(e){var t=this.state.isFullscreen,n=this.props.onImageError||this.handleImageError;return a().createElement(ie,{description:e.description,fullscreen:e.fullscreen,handleImageLoaded:this.handleImageLoaded,isFullscreen:t,onImageError:n,original:e.original,originalAlt:e.originalAlt,originalHeight:e.originalHeight,originalWidth:e.originalWidth,originalTitle:e.originalTitle,sizes:e.sizes,loading:e.loading,srcSet:e.srcSet})}},{key:"renderThumbInner",value:function(e){var t=this.props.onThumbnailError||this.handleImageError;return a().createElement("span",{className:"image-gallery-thumbnail-inner"},a().createElement("img",{className:"image-gallery-thumbnail-image",src:e.thumbnail,height:e.thumbnailHeight,width:e.thumbnailWidth,alt:e.thumbnailAlt,title:e.thumbnailTitle,loading:e.thumbnailLoading,onError:t}),e.thumbnailLabel&&a().createElement("div",{className:"image-gallery-thumbnail-label"},e.thumbnailLabel))}},{key:"render",value:function(){var e=this.state,n=e.currentIndex,i=e.isFullscreen,r=e.modalFullscreen,s=e.isPlaying,o=this.props,l=o.additionalClass,u=o.disableThumbnailSwipe,c=o.indexSeparator,h=o.isRTL,d=o.items,f=o.thumbnailPosition,p=o.renderFullscreenButton,m=o.renderCustomControls,v=o.renderLeftNav,g=o.renderRightNav,b=o.showBullets,y=o.showFullscreenButton,w=o.showIndex,T=o.showThumbnails,S=o.showNav,O=o.showPlayButton,E=o.renderPlayPauseButton,k=this.getThumbnailStyle(),I=this.getSlideItems(),x=I.slides,_=I.thumbnails,R=I.bullets,L=t("image-gallery-slide-wrapper",f,{"image-gallery-rtl":h}),P=a().createElement("div",{ref:this.imageGallerySlideWrapper,className:L},m&&m(),this.canSlide()?a().createElement(a().Fragment,null,S&&a().createElement(a().Fragment,null,v(this.slideLeft,!this.canSlideLeft()),g(this.slideRight,!this.canSlideRight())),a().createElement(ge,{className:"image-gallery-swipe",delta:0,onSwiping:this.handleSwiping,onSwiped:this.handleOnSwiped},a().createElement("div",{className:"image-gallery-slides"},x))):a().createElement("div",{className:"image-gallery-slides"},x),O&&E(this.togglePlay,s),b&&a().createElement("div",{className:"image-gallery-bullets"},a().createElement("div",{className:"image-gallery-bullets-container",role:"navigation","aria-label":"Bullet Navigation"},R)),y&&p(this.toggleFullScreen,i),w&&a().createElement("div",{className:"image-gallery-index"},a().createElement("span",{className:"image-gallery-index-current"},n+1),a().createElement("span",{className:"image-gallery-index-separator"},c),a().createElement("span",{className:"image-gallery-index-total"},d.length))),M=t("image-gallery",l,{"fullscreen-modal":r}),W=t("image-gallery-content",f,{fullscreen:i}),D=t("image-gallery-thumbnails-wrapper",f,{"thumbnails-wrapper-rtl":!this.isThumbnailVertical()&&h},{"thumbnails-swipe-horizontal":!this.isThumbnailVertical()&&!u},{"thumbnails-swipe-vertical":this.isThumbnailVertical()&&!u});return a().createElement("div",{ref:this.imageGallery,className:M,"aria-live":"polite"},a().createElement("div",{className:W},("bottom"===f||"right"===f)&&P,T&&_.length>0?a().createElement(ge,{className:D,delta:0,onSwiping:!u&&this.handleThumbnailSwiping,onSwiped:!u&&this.handleOnThumbnailSwiped},a().createElement("div",{className:"image-gallery-thumbnails",ref:this.thumbnailsWrapper,style:this.getThumbnailBarHeight()},a().createElement("nav",{ref:this.thumbnails,className:"image-gallery-thumbnails-container",style:k,"aria-label":"Thumbnail Navigation"},_))):null,("top"===f||"left"===f)&&P))}}])&&Se(n.prototype,i),l}(a().Component);Le.propTypes={flickThreshold:te.number,items:(0, te.arrayOf)((0, te.shape)({bulletClass:te.string,bulletOnClick:te.func,description:te.string,original:te.string,originalHeight:te.number,originalWidth:te.number,loading:te.string,thumbnailHeight:te.number,thumbnailWidth:te.number,thumbnailLoading:te.string,fullscreen:te.string,originalAlt:te.string,originalTitle:te.string,thumbnail:te.string,thumbnailAlt:te.string,thumbnailLabel:te.string,thumbnailTitle:te.string,originalClass:te.string,thumbnailClass:te.string,renderItem:te.func,renderThumbInner:te.func,imageSet:_e,srcSet:te.string,sizes:te.string})).isRequired,showNav:te.bool,autoPlay:te.bool,lazyLoad:te.bool,infinite:te.bool,showIndex:te.bool,showBullets:te.bool,showThumbnails:te.bool,showPlayButton:te.bool,showFullscreenButton:te.bool,disableThumbnailScroll:te.bool,disableKeyDown:te.bool,disableSwipe:te.bool,disableThumbnailSwipe:te.bool,useBrowserFullscreen:te.bool,onErrorImageURL:te.string,indexSeparator:te.string,thumbnailPosition:(0, te.oneOf)(["top","bottom","left","right"]),startIndex:te.number,slideDuration:te.number,slideInterval:te.number,slideOnThumbnailOver:te.bool,swipeThreshold:te.number,swipingTransitionDuration:te.number,swipingThumbnailTransitionDuration:te.number,onSlide:te.func,onBeforeSlide:te.func,onScreenChange:te.func,onPause:te.func,onPlay:te.func,onClick:te.func,onImageLoad:te.func,onImageError:te.func,onTouchMove:te.func,onTouchEnd:te.func,onTouchStart:te.func,onMouseOver:te.func,onMouseLeave:te.func,onThumbnailError:te.func,onThumbnailClick:te.func,renderCustomControls:te.func,renderLeftNav:te.func,renderRightNav:te.func,renderPlayPauseButton:te.func,renderFullscreenButton:te.func,renderItem:te.func,renderThumbInner:te.func,stopPropagation:te.bool,additionalClass:te.string,useTranslate3D:te.bool,isRTL:te.bool,useWindowKeyDown:te.bool},Le.defaultProps={onErrorImageURL:"",additionalClass:"",showNav:!0,autoPlay:!1,lazyLoad:!1,infinite:!0,showIndex:!1,showBullets:!1,showThumbnails:!0,showPlayButton:!0,showFullscreenButton:!0,disableThumbnailScroll:!1,disableKeyDown:!1,disableSwipe:!1,disableThumbnailSwipe:!1,useTranslate3D:!0,isRTL:!1,useBrowserFullscreen:!0,flickThreshold:.4,stopPropagation:!1,indexSeparator:" / ",thumbnailPosition:"bottom",startIndex:0,slideDuration:450,swipingTransitionDuration:0,swipingThumbnailTransitionDuration:0,onSlide:null,onBeforeSlide:null,onScreenChange:null,onPause:null,onPlay:null,onClick:null,onImageLoad:null,onImageError:null,onTouchMove:null,onTouchEnd:null,onTouchStart:null,onMouseOver:null,onMouseLeave:null,onThumbnailError:null,onThumbnailClick:null,renderCustomControls:null,renderThumbInner:null,renderItem:null,slideInterval:3e3,slideOnThumbnailOver:!1,swipeThreshold:30,renderLeftNav:function(e,t){return a().createElement(ce,{onClick:e,disabled:t})},renderRightNav:function(e,t){return a().createElement(de,{onClick:e,disabled:t})},renderPlayPauseButton:function(e,t){return a().createElement(pe,{onClick:e,isPlaying:t})},renderFullscreenButton:function(e,t){return a().createElement(le,{onClick:e,isFullscreen:t})},useWindowKeyDown:!0};const Pe=Le;})(),r})()}));
} (imageGallery));

var ImageGallery = /*@__PURE__*/getDefaultExportFromCjs(imageGalleryExports);

var Container$6 = styled.div(templateObject_1$10 || (templateObject_1$10 = __makeTemplateObject(["\n  display: flex;\n  z-index: 1;\n  position: absolute;\n  color: white;\n  justify-content: center;\n  width: 100%;\n  padding: 22px 0px 14px;\n  background: linear-gradient(180deg, rgba(17, 17, 19, 0) 0%, rgba(17, 17, 19, 0.75) 50%, ", " 87.5%);\n  bottom: 0px;\n"], ["\n  display: flex;\n  z-index: 1;\n  position: absolute;\n  color: white;\n  justify-content: center;\n  width: 100%;\n  padding: 22px 0px 14px;\n  background: linear-gradient(180deg, rgba(17, 17, 19, 0) 0%, rgba(17, 17, 19, 0.75) 50%, ", " 87.5%);\n  bottom: 0px;\n"])), customColors.black);
var StyledBubble = styled(Bubble).attrs({
    background: 'black',
    borderColor: 'grayLight',
    padding: '2px 12px'
})(templateObject_2$r || (templateObject_2$r = __makeTemplateObject(["\n  border-width: 1px;\n"], ["\n  border-width: 1px;\n"])));
var templateObject_1$10, templateObject_2$r;

var ImageNumber = function (_a) {
    var index = _a.index, images = _a.images;
    return (jsx(Container$6, { children: jsx(StyledBubble, { children: jsxs(Body, __assign({ color: "white" }, { children: [index + 1, " / ", images.length] })) }) }));
};

var NavigationButton = styled(Button).attrs({
    size: 'smaller',
    variant: 'icon',
    iconColor: 'white',
    iconSize: 'normal'
})(templateObject_1$$ || (templateObject_1$$ = __makeTemplateObject(["\n  position: absolute;\n  z-index: 5;\n  bottom: 0px;\n  height: 100%;\n  align-items: flex-end;\n\n  :active::before {\n    background: ", ";\n    opacity: 1;\n  }\n\n  :hover::before {\n    background: ", ";\n    opacity: 1;\n  }\n  &:disabled {\n    :before {\n      background: none;\n    }\n  }\n"], ["\n  position: absolute;\n  z-index: 5;\n  bottom: 0px;\n  height: 100%;\n  align-items: flex-end;\n\n  :active::before {\n    background: ", ";\n    opacity: 1;\n  }\n\n  :hover::before {\n    background: ", ";\n    opacity: 1;\n  }\n  &:disabled {\n    :before {\n      background: none;\n    }\n  }\n"])), customColors.carouselArrowBackgroundActive, customColors.carouselArrowBackgroundHover);
var NavigationButtonContainer = styled.div(templateObject_2$q || (templateObject_2$q = __makeTemplateObject(["\n  height: calc(100% - 70px);\n  position: absolute;\n  ", "\n  bottom: 0;\n"], ["\n  height: calc(100% - 70px);\n  position: absolute;\n  ", "\n  bottom: 0;\n"])), function (_a) {
    var align = _a.align;
    return (align === 'left' ? 'left: 0;' : 'right: 0;');
});
var templateObject_1$$, templateObject_2$q;

var NavigationLeft = function (_a) {
    var onClick = _a.onClick, disabled = _a.disabled;
    return (jsx(NavigationButtonContainer, __assign({ align: "left" }, { children: jsx(NavigationButton, { className: "image-gallery-icon image-gallery-left-nav", "data-testid": "carousel-left-nav", icon: "caret-left", onClick: onClick, disabled: disabled }) })));
};

var NavigationRight = function (_a) {
    var onClick = _a.onClick, disabled = _a.disabled;
    return (jsx(NavigationButtonContainer, { children: jsx(NavigationButton, { align: "right", className: "image-gallery-icon image-gallery-right-nav", "data-testid": "carousel-right-nav", icon: "caret-right", onClick: onClick, disabled: disabled }) }));
};

var Container$5 = styled.div(templateObject_1$_ || (templateObject_1$_ = __makeTemplateObject(["\n  ", "\n\n  .image-gallery-left-nav,\n  .image-gallery-right-nav {\n    padding: 100% 28px 20px;\n    top: auto;\n    transform: initial;\n    bottom: 0px;\n\n    &:disabled {\n      opacity: 0.6 !important;\n    }\n  }\n\n  .image-gallery-thumbnail-inner {\n    height: 100%;\n  }\n\n  .image-gallery-thumbnail-image {\n    height: 100%;\n    object-fit: cover;\n  }\n\n  .image-gallery-content .bottom {\n    display: flex;\n    justify-content: center;\n    overflow: hidden;\n    min-height: 125px;\n  }\n\n  .image-gallery-thumbnail {\n    width: 128px;\n    height: 96px;\n    border: none;\n    margin-left: 8px !important;\n    cursor: pointer;\n\n    &:first-child {\n      margin-left: 16px !important;\n    }\n\n    &:last-child {\n      margin-right: 16px;\n    }\n\n    &.active,\n    &:focus {\n      border: 1px solid ", ";\n      padding: 8px;\n    }\n  }\n  .image-gallery-icon {\n    &:focus {\n      outline: none;\n    }\n  }\n\n  .image-gallery-thumbnails {\n    padding: 16px 0px;\n  }\n\n  .image-gallery-thumbnails-wrapper {\n    background: ", ";\n    width: 100%;\n    box-sizing: border-box;\n  }\n\n  .image-gallery-swipe {\n    width: 100%;\n  }\n\n  .image-gallery-slide .image-gallery-image {\n    object-fit: ", ";\n    background-color: ", ";\n    ", ";\n  }\n\n  .image-gallery-bullets {\n    width: calc(100% - 106px);\n    bottom: 18px;\n  }\n\n  ", "\n"], ["\n  ", "\n\n  .image-gallery-left-nav,\n  .image-gallery-right-nav {\n    padding: 100% 28px 20px;\n    top: auto;\n    transform: initial;\n    bottom: 0px;\n\n    &:disabled {\n      opacity: 0.6 !important;\n    }\n  }\n\n  .image-gallery-thumbnail-inner {\n    height: 100%;\n  }\n\n  .image-gallery-thumbnail-image {\n    height: 100%;\n    object-fit: cover;\n  }\n\n  .image-gallery-content .bottom {\n    display: flex;\n    justify-content: center;\n    overflow: hidden;\n    min-height: 125px;\n  }\n\n  .image-gallery-thumbnail {\n    width: 128px;\n    height: 96px;\n    border: none;\n    margin-left: 8px !important;\n    cursor: pointer;\n\n    &:first-child {\n      margin-left: 16px !important;\n    }\n\n    &:last-child {\n      margin-right: 16px;\n    }\n\n    &.active,\n    &:focus {\n      border: 1px solid ", ";\n      padding: 8px;\n    }\n  }\n  .image-gallery-icon {\n    &:focus {\n      outline: none;\n    }\n  }\n\n  .image-gallery-thumbnails {\n    padding: 16px 0px;\n  }\n\n  .image-gallery-thumbnails-wrapper {\n    background: ", ";\n    width: 100%;\n    box-sizing: border-box;\n  }\n\n  .image-gallery-swipe {\n    width: 100%;\n  }\n\n  .image-gallery-slide .image-gallery-image {\n    object-fit: ", ";\n    background-color: ", ";\n    ", ";\n  }\n\n  .image-gallery-bullets {\n    width: calc(100% - 106px);\n    bottom: 18px;\n  }\n\n  ", "\n"])), function (_a) {
    var width = _a.width, height = _a.height;
    return "\n    width: ".concat(width, ";\n    height: ").concat(height, ";\n    display: inline;\n    position: relative;\n  ");
}, colorBorder$1.colorBorderBorderPrimary, customColors.black, function (_a) {
    var imageObjectFit = _a.imageObjectFit;
    return imageObjectFit || 'contain';
}, function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor ? getLegacyColor(backgroundColor) : customColors.black;
}, function (_a) {
    var aspectRatio = _a.aspectRatio;
    return (aspectRatio ? "aspect-ratio: ".concat(aspectRatio, ";") : "");
}, function (_a) {
    var aspectRatio = _a.aspectRatio;
    return aspectRatio
        ? ""
        : "\n  display: block;\n\n  .image-gallery-content {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .image-gallery,\n  .image-gallery-image,\n  .image-gallery-content,\n  .image-gallery-slide-wrapper,\n  .image-gallery-slides,\n  .image-gallery-slide {\n    height: 100%;\n    width: 100%;\n    max-height: none;\n  }\n\n  .image-gallery-content .image-gallery-slide .image-gallery-image {\n    height: 100%;\n    width: 100%;\n    max-height: none;\n    aspect-ratio: auto;\n  }\n  ";
});
var templateObject_1$_;

var IconContainer$1 = styled.div(templateObject_1$Z || (templateObject_1$Z = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  margin: 8px;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  margin: 8px;\n"])));
var templateObject_1$Z;

var Thumbnail = function (props) {
    var onErrorImageURL = props.onErrorImageURL;
    var handleImageError = function (event) {
        var element = event.target;
        if (onErrorImageURL && element.src.indexOf(onErrorImageURL) === -1) {
            event.target.src = onErrorImageURL;
        }
    };
    return (jsxs("span", __assign({ className: "image-gallery-thumbnail-inner" }, { children: [jsx(IconContainer$1, { children: props.thumbailIcon && jsx(Icon, { name: props.thumbailIcon, color: props.thumbailIconColor, size: "smaller" }) }), jsx("img", { className: "image-gallery-thumbnail-image", src: props.thumbnail, height: props.thumbnailHeight, width: props.thumbnailWidth, alt: props.thumbnailAlt, title: props.thumbnailTitle, loading: props.thumbnailLoading, onError: handleImageError }), props.thumbnailLabel && jsx("div", __assign({ className: "image-gallery-thumbnail-label" }, { children: props.thumbnailLabel }))] })));
};

var VisualBoostWrapper = styled.div(templateObject_1$Y || (templateObject_1$Y = __makeTemplateObject(["\n  align-items: center;\n  background-color: ", ";\n  border-radius: 8px;\n  box-shadow: ", ";\n  box-sizing: content-box;\n  display: flex;\n  flex-wrap: wrap;\n  column-gap: 16px;\n  row-gap: 8px;\n  margin: 10px;\n  padding: 7px 8px 7px 12px;\n  position: absolute;\n  max-width: 268px;\n  z-index: 1;\n"], ["\n  align-items: center;\n  background-color: ", ";\n  border-radius: 8px;\n  box-shadow: ", ";\n  box-sizing: content-box;\n  display: flex;\n  flex-wrap: wrap;\n  column-gap: 16px;\n  row-gap: 8px;\n  margin: 10px;\n  padding: 7px 8px 7px 12px;\n  position: absolute;\n  max-width: 268px;\n  z-index: 1;\n"])), colorSurface.primary, shadow.larger);
var ContentWrapper = styled.div(templateObject_2$p || (templateObject_2$p = __makeTemplateObject(["\n  display: flex;\n  gap: 8px;\n"], ["\n  display: flex;\n  gap: 8px;\n"])));
var NoDamagesWrapper = styled.div(templateObject_3$c || (templateObject_3$c = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: 8px;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 8px;\n"])));
var templateObject_1$Y, templateObject_2$p, templateObject_3$c;

var Content$3 = function () { return (jsxs(ContentWrapper, { children: [jsx(Icon, { name: "damage-overlay", size: "smaller" }), jsx(Body, __assign({ bold: true }, { children: "Visual boost AI" })), jsx(Icon, { name: "help", size: "smaller", "data-tooltip-id": "visual-boost-tooltip" }), jsx(BlcTooltip, __assign({ id: "visual-boost-tooltip" }, { children: "AI generated damage overlays" }))] })); };
var NoDamages = function () { return (jsxs(NoDamagesWrapper, { children: [jsx(Icon, { name: "check", color: "success", size: "smaller" }), jsx(Body, __assign({ color: "success", type: "caption" }, { children: "No damages detected on this image" }))] })); };
var DamageToggle = function (_a) {
    var onChange = _a.onChange, currentIndex = _a.currentIndex, items = _a.items;
    var _b = useState(false), toggleEnabled = _b[0], setToggleEnabled = _b[1];
    var damages = items[currentIndex].cosmetic_damages;
    var showNoDamages = (damages === null || damages === void 0 ? void 0 : damages.length) === 0 && toggleEnabled;
    var handleOnChange = function (isEnabled) {
        setToggleEnabled(isEnabled);
        onChange(isEnabled);
    };
    return (damages && (jsxs(VisualBoostWrapper, { children: [jsx(Content$3, {}), jsx(Toggle, { onChange: handleOnChange, active: toggleEnabled }), showNoDamages && jsx(NoDamages, {})] })));
};

var Carousel = function (_a) {
    var aspectRatio = _a.aspectRatio, _b = _a.autoPlay, autoPlay = _b === void 0 ? false : _b, _c = _a.height, height = _c === void 0 ? '100%' : _c, _d = _a.infinite, infinite = _d === void 0 ? false : _d, items = _a.items, _e = _a.lazyLoad, lazyLoad = _e === void 0 ? true : _e, onClick = _a.onClick, onErrorImageURL = _a.onErrorImageURL, onThumbnailError = _a.onThumbnailError, _f = _a.showBullets, showBullets = _f === void 0 ? false : _f, _g = _a.showImageNumber, showImageNumber = _g === void 0 ? true : _g, _h = _a.showNav, showNav = _h === void 0 ? true : _h, _j = _a.showThumbnails, showThumbnails = _j === void 0 ? true : _j, _k = _a.startIndex, startIndex = _k === void 0 ? 0 : _k, _l = _a.width, width = _l === void 0 ? '100%' : _l, imageObjectFit = _a.imageObjectFit, backgroundColor = _a.backgroundColor, onToggleDamages = _a.onToggleDamages, _m = _a.showDamageToggle, showDamageToggle = _m === void 0 ? false : _m, rest = __rest(_a, ["aspectRatio", "autoPlay", "height", "infinite", "items", "lazyLoad", "onClick", "onErrorImageURL", "onThumbnailError", "showBullets", "showImageNumber", "showNav", "showThumbnails", "startIndex", "width", "imageObjectFit", "backgroundColor", "onToggleDamages", "showDamageToggle"]);
    var _o = useState(startIndex), currentIndex = _o[0], setCurrentIndex = _o[1];
    var carouselRef = useRef();
    var onSlide = function () {
        var _a, _b;
        var currenIndex = (_b = (_a = carouselRef.current) === null || _a === void 0 ? void 0 : _a.getCurrentIndex()) !== null && _b !== void 0 ? _b : startIndex;
        setCurrentIndex(currenIndex);
    };
    return (jsxs(Container$5, __assign({ aspectRatio: aspectRatio, height: height, showThumbnails: showThumbnails, width: width, imageObjectFit: imageObjectFit, backgroundColor: backgroundColor }, { children: [showDamageToggle && (jsx(DamageToggle, { items: items, currentIndex: currentIndex, onChange: function (isEnabled) { return onToggleDamages && onToggleDamages(isEnabled); } })), jsx(ImageGallery, __assign({ autoPlay: autoPlay, disableThumbnailScroll: false, infinite: infinite, isRTL: false, items: items, lazyLoad: lazyLoad, onClick: onClick, onErrorImageURL: onErrorImageURL, onSlide: onSlide, ref: carouselRef, showBullets: showBullets, showFullscreenButton: false, showIndex: false, showNav: showNav, showPlayButton: false, showThumbnails: showThumbnails, startIndex: startIndex, useBrowserFullScreen: true, useTranslate3D: true, renderCustomControls: function () {
                    var _a;
                    return (jsx(Fragment, { children: showImageNumber && jsx(ImageNumber, { index: ((_a = carouselRef === null || carouselRef === void 0 ? void 0 : carouselRef.current) === null || _a === void 0 ? void 0 : _a.getCurrentIndex()) || 0, images: items }) }));
                }, renderLeftNav: function (onClick, disabled) { return jsx(NavigationLeft, { onClick: onClick, disabled: disabled }); }, renderRightNav: function (onClick, disabled) { return jsx(NavigationRight, { onClick: onClick, disabled: disabled }); }, renderThumbInner: function (item) { return (jsx(Thumbnail, __assign({}, item, { onThumbnailError: onThumbnailError, onErrorImageURL: onErrorImageURL }))); } }, rest))] })));
};

var Container$4 = styled.label(templateObject_1$X || (templateObject_1$X = __makeTemplateObject(["\n  position: relative;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  ", "\n  background: ", ";\n  border-radius: var(--checkboxBorderRadius);\n\n  input {\n    border: 1px solid ", ";\n    border-radius: 3px;\n    outline: none;\n    position: absolute;\n    appearance: none;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    cursor: ", ";\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n\n  ", ";\n"], ["\n  position: relative;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  ", "\n  background: ", ";\n  border-radius: var(--checkboxBorderRadius);\n\n  input {\n    border: 1px solid ", ";\n    border-radius: 3px;\n    outline: none;\n    position: absolute;\n    appearance: none;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    cursor: ", ";\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n\n  ", ";\n"])), function (_a) {
    var _b = _a.width, width = _b === void 0 ? '28px' : _b, _c = _a.height, height = _c === void 0 ? '28px' : _c;
    return "\n      min-width: ".concat(getSizeValue(width), ";\n      height: ").concat(getSizeValue(height), ";\n  ");
}, colorFormSurface.colorFormSurfaceDefault, colorFormBorder.colorFormBorderDefault, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'not-allowed' : 'pointer');
}, baseStyle({ borderRadius: radiusAction.radiusActionSm, position: '0px' }), focusWithinStyle, hoverStyle, activeStyle, function (_a) {
    var disabled = _a.disabled, checked = _a.checked;
    return disabled
        ? "\n      input {\n        border-color: ".concat(colorFormBorder.colorFormBorderDefault, ";\n      }\n      background-color: ").concat(colorFormSurface.colorFormSurfaceDisabled, ";\n      ")
        : checked
            ? "\n      background-color: ".concat(colorFormSurface.colorFormSurfaceChecked, ";\n\n      input{\n        border: none;\n      }\n        ")
            : "\n      &:hover,\n      &:active,\n      &:focus,\n      &:focus-within {\n        input{\n          border-color: ".concat(colorBase['colorBrand-500'], ";\n          }\n        }\n      ");
});
var templateObject_1$X;

var Checkbox = forwardRef(function (_a, ref) {
    var _b = _a.checked, checked = _b === void 0 ? false : _b, className = _a.className, _c = _a.disabled, disabled = _c === void 0 ? false : _c, id = _a.id, _d = _a.name, name = _d === void 0 ? 'checkbox' : _d, width = _a.width, height = _a.height, _e = _a.iconSize, iconSize = _e === void 0 ? 'normal' : _e, onChange = _a.onChange, rest = __rest(_a, ["checked", "className", "disabled", "id", "name", "width", "height", "iconSize", "onChange"]);
    var _f = useState(checked), isChecked = _f[0], setIsChecked = _f[1];
    var handleChange = function (event) {
        var checked = event.target.checked;
        setIsChecked(checked);
        onChange && onChange(event);
    };
    useEffect(function () {
        setIsChecked(checked);
    }, [checked]);
    var iconColor = 'colorIconIconBrand';
    if (isChecked)
        iconColor = 'colorIconIconInvert';
    if (disabled)
        iconColor = 'colorIconIconSecondary';
    return (jsxs(Container$4, __assign({ className: "checkbox-container ".concat(className), disabled: disabled, width: width, height: height, "data-form-error": true, checked: isChecked }, { children: [jsx("input", __assign({ ref: ref, type: "checkbox", "aria-label": name, name: name, id: id, disabled: disabled, onChange: function (event) { return !disabled && handleChange(event); }, checked: isChecked !== null && isChecked !== void 0 ? isChecked : false }, rest)), Boolean(isChecked) && jsx(Icon, { size: iconSize, color: iconColor, name: "check" })] })));
});
Checkbox.displayName = 'Checkbox';

/* eslint-disable max-len */
function SvgSprite() {
    return (jsxs("svg", __assign({ style: { display: 'none' }, xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxs("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-NA-inverted", viewBox: "0 0 32 32" }, { children: [jsx("path", { d: "M16 22c.926 0 1.804-.21 2.587-.585l-8.002-8.002A6 6 0 0016 22zm-2.587-11.415l8.002 8.002a6 6 0 00-8.002-8.002z" }), jsx("path", { fillRule: "evenodd", d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16zm0-5c6.075 0 11-4.925 11-11S22.075 5 16 5 5 9.925 5 16s4.925 11 11 11z", clipRule: "evenodd" })] })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-adg", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M16 29c-2.896-.758-5.287-2.486-7.172-5.184C6.943 21.12 6 18.123 6 14.83V6.9L16 3l10 3.9v7.93c0 3.293-.943 6.289-2.828 8.986C21.286 26.514 18.896 28.242 16 29z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-adg-plus", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M14.125 20.55h3.75V17.3H21v-3.9h-3.125v-3.25h-3.75v3.25H11v3.9h3.125v3.25zM16 29c-2.896-.758-5.287-2.486-7.172-5.184C6.943 21.12 6 18.123 6 14.83V6.9L16 3l10 3.9v7.93c0 3.293-.943 6.289-2.828 8.986C21.286 26.514 18.896 28.242 16 29z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-adg-warning", viewBox: "0 0 32 32" }, { children: jsx("path", { fillRule: "evenodd", d: "M16 29c-2.896-.753-5.286-2.47-7.172-5.15C6.943 21.172 6 18.197 6 14.925V6.931L16 3l10 3.931v7.993c0 3.272-.943 6.247-2.828 8.927C21.286 26.53 18.896 28.247 16 29zm-1.462-12.582h2.924V9.754h-2.924v6.664zm2.656 4.519a1.637 1.637 0 01-1.194.472c-.474 0-.872-.157-1.193-.472a1.576 1.576 0 01-.482-1.172c0-.465.16-.856.482-1.17A1.637 1.637 0 0116 18.121c.475 0 .873.157 1.194.472.32.315.481.706.481 1.171 0 .466-.16.857-.481 1.172z", clipRule: "evenodd" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-alert", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M16 28a2.568 2.568 0 01-1.883-.783 2.568 2.568 0 01-.784-1.884c0-.733.262-1.36.784-1.883A2.568 2.568 0 0116 22.667c.733 0 1.361.26 1.884.783.522.522.783 1.15.783 1.883 0 .734-.261 1.361-.784 1.884A2.568 2.568 0 0116 28zm-2.666-8V4h5.333v16h-5.334z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-arrow-sorting", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M7.6 11.067l8-8 8 8-1.867 1.866L15.6 6.8l-6.133 6.133L7.6 11.067zm16 9.866l-8 8-8-8 1.867-1.866L15.6 25.2l6.133-6.133 1.867 1.866z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-barcode", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M1.333 25.333V6.667H4v18.666H1.333zm4 0V6.667H8v18.666H5.333zm4 0V6.667h1.334v18.666H9.334zm4 0V6.667H16v18.666h-2.666zm4 0V6.667h4v18.666h-4zm5.334 0V6.667H24v18.666h-1.333zm4 0V6.667h4v18.666h-4z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-bookmark", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M16 24.681l-5.6 2.4c-.89.378-1.734.306-2.534-.217-.8-.522-1.2-1.26-1.2-2.216v-17.3c0-.734.262-1.361.784-1.884a2.568 2.568 0 011.883-.783h13.333c.734 0 1.362.261 1.884.783a2.57 2.57 0 01.783 1.884v17.3c0 .955-.4 1.694-1.2 2.216-.8.523-1.644.595-2.533.217l-5.6-2.4zm0-2.933l6.666 2.866V7.348H9.333v17.266L16 21.748z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-bookmark-inverted", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M16 24.681l-5.6 2.4c-.89.378-1.734.306-2.534-.217-.8-.522-1.2-1.26-1.2-2.216v-17.3c0-.734.262-1.361.784-1.884a2.568 2.568 0 011.883-.783h13.333c.734 0 1.362.261 1.884.783a2.57 2.57 0 01.783 1.884v17.3c0 .955-.4 1.694-1.2 2.216-.8.523-1.644.595-2.533.217l-5.6-2.4z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-calendar", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M16 18.667a1.29 1.29 0 01-.95-.384 1.29 1.29 0 01-.383-.95c0-.377.127-.694.383-.95A1.29 1.29 0 0116 16c.378 0 .694.128.95.383.256.256.383.573.383.95 0 .378-.127.695-.383.95a1.29 1.29 0 01-.95.384zm-5.333 0a1.29 1.29 0 01-.95-.384 1.29 1.29 0 01-.384-.95c0-.377.128-.694.384-.95a1.29 1.29 0 01.95-.383c.377 0 .694.128.95.383.255.256.383.573.383.95 0 .378-.128.695-.383.95a1.29 1.29 0 01-.95.384zm10.666 0a1.29 1.29 0 01-.95-.384 1.29 1.29 0 01-.383-.95c0-.377.128-.694.383-.95a1.29 1.29 0 01.95-.383c.378 0 .695.128.95.383.256.256.384.573.384.95 0 .378-.128.695-.384.95a1.29 1.29 0 01-.95.384zM16 24a1.29 1.29 0 01-.95-.383 1.29 1.29 0 01-.383-.95c0-.378.127-.695.383-.95a1.29 1.29 0 01.95-.384c.378 0 .694.128.95.384.256.255.383.572.383.95 0 .377-.127.694-.383.95A1.29 1.29 0 0116 24zm-5.333 0a1.29 1.29 0 01-.95-.383 1.29 1.29 0 01-.384-.95c0-.378.128-.695.384-.95a1.29 1.29 0 01.95-.384c.377 0 .694.128.95.384.255.255.383.572.383.95 0 .377-.128.694-.383.95a1.29 1.29 0 01-.95.383zm10.666 0a1.29 1.29 0 01-.95-.383 1.29 1.29 0 01-.383-.95c0-.378.128-.695.383-.95a1.29 1.29 0 01.95-.384c.378 0 .695.128.95.384.256.255.384.572.384.95 0 .377-.128.694-.384.95a1.29 1.29 0 01-.95.383zM6.667 29.333a2.568 2.568 0 01-1.884-.783A2.568 2.568 0 014 26.667V8c0-.733.261-1.361.783-1.883a2.568 2.568 0 011.884-.784H8V2.667h2.667v2.666h10.666V2.667H24v2.666h1.333c.734 0 1.361.261 1.884.784.522.522.783 1.15.783 1.883v18.667a2.57 2.57 0 01-.783 1.883 2.568 2.568 0 01-1.884.783H6.667zm0-2.666h18.666V13.333H6.667v13.334z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-camera", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M16 23.333c1.666 0 3.083-.583 4.25-1.75C21.416 20.417 22 19 22 17.333c0-1.666-.584-3.083-1.75-4.25-1.167-1.166-2.584-1.75-4.25-1.75-1.667 0-3.084.584-4.25 1.75-1.167 1.167-1.75 2.584-1.75 4.25 0 1.667.583 3.084 1.75 4.25 1.166 1.167 2.583 1.75 4.25 1.75zm0-2.666c-.934 0-1.722-.323-2.367-.967-.644-.644-.966-1.433-.966-2.367 0-.933.322-1.722.966-2.366C14.278 14.322 15.067 14 16 14s1.722.322 2.366.967c.645.644.967 1.433.967 2.366 0 .934-.322 1.723-.966 2.367-.645.644-1.434.967-2.367.967zM5.333 28a2.568 2.568 0 01-1.883-.783 2.568 2.568 0 01-.784-1.884v-16c0-.733.262-1.36.784-1.883a2.568 2.568 0 011.883-.783h4.2L12 4h8l2.466 2.667h4.2c.734 0 1.362.26 1.884.783.522.522.783 1.15.783 1.883v16c0 .734-.26 1.361-.783 1.884a2.568 2.568 0 01-1.884.783H5.334z" }) })), jsxs("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-carbravo", viewBox: "0 0 16 16" }, { children: [jsx("path", { fill: "#0 00", fillRule: "evenodd", d: "M14.76 3.991C15.675 5.148 16 6.499 16 7.379a2.486 2.486 0 01-2.23 2.47.063.063 0 00-.056.045 2.131 2.131 0 01-2.025 1.479c-.94 0-1.74-.616-2.02-1.464a.065.065 0 00-.062-.046H6.334a.067.067 0 00-.062.046 2.132 2.132 0 01-2.02 1.464c-.94 0-1.735-.598-2.02-1.464a.063.063 0 00-.06-.044A2.194 2.194 0 01.186 6.788c.486-1.146 1.726-1.625 3.258-2.216l.087-.034.408-.156c.724-.273 1.325-.5 2.401-1.1C7.501 2.639 8.727 2 10.486 2c2.234 0 3.558 1.082 4.275 1.991zM3.276 9.076a.996.996 0 001.148 1.15.996.996 0 00-.336-1.962.997.997 0 00-.812.812zm7.438 0a.996.996 0 001.148 1.15.995.995 0 10-1.148-1.149zm3.054-.302a.066.066 0 00.078.051 1.48 1.48 0 001.152-1.444c0-.68-.267-1.812-1.022-2.768-.58-.735-1.656-1.611-3.489-1.611-1.478 0-2.405.492-3.603 1.127l-.068.037c-1.055.558-1.415.737-2.928 1.309-1.71.644-2.627 1.034-2.855 1.935a1.19 1.19 0 001.074 1.45.067.067 0 00.069-.055 2.13 2.13 0 012.08-1.689A2.13 2.13 0 016.337 8.81c.007.03.033.053.064.053h3.146a.065.065 0 00.064-.053 2.13 2.13 0 012.082-1.694c1.01 0 1.858.71 2.074 1.658z", clipRule: "evenodd" }), jsx("path", { d: "M5.612 13.005A3.329 3.329 0 007.984 14a3.33 3.33 0 002.372-.995.19.19 0 00-.01-.276l-.57-.5a.19.19 0 00-.257.008 2.193 2.193 0 01-3.071 0 .187.187 0 00-.256-.008l-.57.5a.19.19 0 00-.01.276z" })] })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-caret-down", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M23.6 12.933l-8 8-8-8 1.867-1.866L15.6 17.2l6.133-6.133 1.867 1.866z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-caret-left", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M18.667 24l-8-8 8-8 1.866 1.867L14.4 16l6.133 6.133L18.667 24z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-caret-right", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M12.533 8l8 8-8 8-1.866-1.867L16.8 16l-6.133-6.133L12.533 8z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-caret-up", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M7.6 19.067l8-8 8 8-1.867 1.866L15.6 14.8l-6.133 6.133L7.6 19.067z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-cart", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M9.609 30.667c-.88 0-1.635-.288-2.262-.862-.627-.574-.941-1.265-.941-2.072 0-.806.314-1.497.94-2.071.628-.575 1.382-.862 2.263-.862.88 0 1.635.287 2.262.862.627.574.94 1.265.94 2.071 0 .807-.313 1.498-.94 2.072-.627.575-1.381.862-2.262.862zm16.015 0c-.881 0-1.635-.288-2.262-.862-.628-.574-.941-1.265-.941-2.072 0-.806.313-1.497.94-2.071.628-.575 1.382-.862 2.263-.862.88 0 1.635.287 2.262.862.627.574.94 1.265.94 2.071 0 .807-.313 1.498-.94 2.072-.627.575-1.381.862-2.262.862zM6.726 4.267h23.622c.614 0 1.081.25 1.401.751.32.501.334 1.009.04 1.522l-5.685 9.387a3.068 3.068 0 01-1.181 1.136 3.335 3.335 0 01-1.621.404H11.37L9.608 20.4h19.218v2.933H9.609c-1.201 0-2.109-.482-2.723-1.448-.614-.966-.64-1.925-.08-2.878l2.162-3.594L3.203 4.267H0V1.333h5.205l1.521 2.934z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-chart", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M17.333 14.667V2.8c3.178.333 5.861 1.6 8.05 3.8 2.189 2.2 3.461 4.889 3.817 8.067H17.333zm-2.633 14.5c-3.378-.334-6.206-1.756-8.484-4.267C3.94 22.389 2.8 19.422 2.8 16c0-3.444 1.139-6.422 3.416-8.933C8.494 4.556 11.322 3.133 14.7 2.8v26.367zm2.633 0V17.3H29.2c-.311 3.178-1.572 5.872-3.784 8.083-2.21 2.211-4.905 3.473-8.083 3.784z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-check", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M12.733 24l-7.6-7.6 1.9-1.9 5.7 5.7L24.967 7.967l1.9 1.9L12.733 24z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-clock", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M20.4 22.267l1.867-1.867-4.934-4.933V9.333h-2.666v7.2l5.733 5.734zM16 29.333c-1.845 0-3.578-.35-5.2-1.05a13.465 13.465 0 01-4.234-2.85c-1.2-1.2-2.15-2.61-2.85-4.233-.7-1.622-1.05-3.356-1.05-5.2 0-1.845.35-3.578 1.05-5.2.7-1.622 1.65-3.033 2.85-4.233a13.47 13.47 0 014.234-2.85c1.622-.7 3.355-1.05 5.2-1.05 1.844 0 3.578.35 5.2 1.05 1.622.7 3.033 1.65 4.233 2.85 1.2 1.2 2.15 2.61 2.85 4.233.7 1.622 1.05 3.355 1.05 5.2 0 1.844-.35 3.578-1.05 5.2a13.465 13.465 0 01-2.85 4.233c-1.2 1.2-2.61 2.15-4.233 2.85-1.622.7-3.356 1.05-5.2 1.05z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-close", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M8.533 25.333l-1.866-1.866L14.133 16 6.667 8.533l1.866-1.866L16 14.133l7.466-7.466 1.867 1.866L17.867 16l7.466 7.467-1.866 1.866L16 17.867l-7.467 7.466z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-close-inverted", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M11.2 22.667l4.8-4.8 4.8 4.8 1.866-1.867-4.8-4.8 4.8-4.8L20.8 9.333l-4.8 4.8-4.8-4.8L9.333 11.2l4.8 4.8-4.8 4.8 1.867 1.867zm4.8 6.666c-1.845 0-3.578-.35-5.2-1.05a13.465 13.465 0 01-4.234-2.85c-1.2-1.2-2.15-2.61-2.85-4.233-.7-1.622-1.05-3.355-1.05-5.2 0-1.844.35-3.578 1.05-5.2.7-1.622 1.65-3.033 2.85-4.233a13.47 13.47 0 014.234-2.85c1.622-.7 3.355-1.05 5.2-1.05 1.844 0 3.578.35 5.2 1.05 1.622.7 3.033 1.65 4.233 2.85 1.2 1.2 2.15 2.61 2.85 4.233.7 1.622 1.05 3.356 1.05 5.2 0 1.845-.35 3.578-1.05 5.2a13.465 13.465 0 01-2.85 4.233c-1.2 1.2-2.61 2.15-4.233 2.85-1.622.7-3.356 1.05-5.2 1.05z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-copy", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M6.333 30.667a2.568 2.568 0 01-1.883-.784A2.568 2.568 0 013.666 28V9.333h2.667V28H21v2.667H6.333zm5.333-5.334a2.568 2.568 0 01-1.883-.783A2.568 2.568 0 019 22.667V4c0-.733.26-1.361.783-1.883a2.568 2.568 0 011.883-.784H21l8 8v13.334c0 .733-.261 1.36-.784 1.883a2.568 2.568 0 01-1.883.783H11.667zm8-14.666h6.667L19.667 4v6.667z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-counter", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M25.333 25.333V20c0-1.111-.389-2.055-1.166-2.833-.778-.778-1.723-1.167-2.834-1.167H9.1l4.8 4.8-1.9 1.867-8-8 8-8 1.9 1.866-4.8 4.8h12.233c1.845 0 3.417.65 4.717 1.95C27.35 16.583 28 18.156 28 20v5.333h-2.667z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-damage-overlay", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M11.134 21.65v-5.19h-7.07l12-12 12 12h-7.08v5.19h-9.85zm0 .722h9.851v2.325h-9.85v-2.325zm0 3.07h9.851v1.143h-9.85v-1.143z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-dealership", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M13.333 28.467v-7.6l1.867-5.334a1.64 1.64 0 01.483-.616c.211-.167.472-.25.784-.25H26.2c.31 0 .572.083.783.25.211.166.372.372.483.616l1.867 5.334v7.6c0 .244-.083.45-.25.616a.838.838 0 01-.616.25h-.934a.838.838 0 01-.617-.25.838.838 0 01-.25-.616v-1.134H16v1.134c0 .244-.084.45-.25.616a.838.838 0 01-.617.25H14.2a.838.838 0 01-.617-.25.838.838 0 01-.25-.616zM16 19.333h10.666l-.933-2.666h-8.8L16 19.333zm1.333 5.334c.378 0 .695-.128.95-.384a1.29 1.29 0 00.383-.95 1.29 1.29 0 00-.383-.95 1.29 1.29 0 00-.95-.383 1.29 1.29 0 00-.95.383 1.29 1.29 0 00-.383.95c0 .378.128.695.383.95.256.256.572.384.95.384zm8 0c.378 0 .695-.128.95-.384a1.29 1.29 0 00.383-.95 1.29 1.29 0 00-.383-.95 1.29 1.29 0 00-.95-.383 1.29 1.29 0 00-.95.383 1.29 1.29 0 00-.383.95c0 .378.128.695.383.95.256.256.572.384.95.384zM8 18.667V16h2.666v2.667H8zm6.666-8V8h2.667v2.667h-2.666zM8 24v-2.667h2.666V24H8zm0 5.333v-2.666h2.666v2.666H8zm-5.333 0V10.667h6.666v-8h13.333V12H20V5.333h-8v8H5.333v16H2.666z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-dollar", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M14.8 25.333h2.333v-1.666c1.111-.2 2.067-.634 2.867-1.3.8-.667 1.2-1.656 1.2-2.967 0-.933-.267-1.789-.8-2.567-.534-.777-1.6-1.455-3.2-2.033-1.333-.445-2.256-.833-2.767-1.167-.51-.333-.767-.789-.767-1.366 0-.578.206-1.034.617-1.367.411-.333 1.006-.5 1.784-.5.71 0 1.266.172 1.666.517.4.344.69.772.867 1.283l2.133-.867c-.244-.777-.694-1.455-1.35-2.033-.655-.578-1.383-.9-2.183-.967V6.667h-2.333v1.666c-1.112.245-1.978.734-2.6 1.467-.623.733-.934 1.555-.934 2.467 0 1.044.306 1.889.917 2.533.61.644 1.572 1.2 2.883 1.667 1.4.51 2.372.966 2.917 1.366.544.4.816.923.816 1.567 0 .733-.26 1.272-.783 1.617-.522.344-1.15.516-1.883.516a3.025 3.025 0 01-1.95-.683c-.567-.456-.983-1.139-1.25-2.05l-2.2.867c.31 1.066.794 1.927 1.45 2.583.655.655 1.505 1.105 2.55 1.35v1.733zm1.2 4c-1.845 0-3.578-.35-5.2-1.05a13.465 13.465 0 01-4.234-2.85c-1.2-1.2-2.15-2.61-2.85-4.233-.7-1.622-1.05-3.356-1.05-5.2 0-1.845.35-3.578 1.05-5.2.7-1.622 1.65-3.033 2.85-4.233a13.47 13.47 0 014.234-2.85c1.622-.7 3.355-1.05 5.2-1.05 1.844 0 3.578.35 5.2 1.05 1.622.7 3.033 1.65 4.233 2.85 1.2 1.2 2.15 2.61 2.85 4.233.7 1.622 1.05 3.355 1.05 5.2 0 1.844-.35 3.578-1.05 5.2a13.465 13.465 0 01-2.85 4.233c-1.2 1.2-2.61 2.15-4.233 2.85-1.622.7-3.356 1.05-5.2 1.05zm0-2.666c2.978 0 5.5-1.034 7.567-3.1 2.066-2.067 3.1-4.59 3.1-7.567 0-2.978-1.034-5.5-3.1-7.567-2.067-2.066-4.59-3.1-7.567-3.1-2.978 0-5.5 1.034-7.567 3.1-2.066 2.067-3.1 4.59-3.1 7.567 0 2.978 1.034 5.5 3.1 7.567 2.067 2.066 4.59 3.1 7.567 3.1z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-dollar-inverted", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M14.8 25.333h2.333v-1.666c1.111-.2 2.067-.634 2.867-1.3.8-.667 1.2-1.656 1.2-2.967 0-.933-.267-1.789-.8-2.567-.534-.777-1.6-1.455-3.2-2.033-1.333-.445-2.256-.833-2.767-1.167-.51-.333-.767-.789-.767-1.366 0-.578.206-1.034.617-1.367.411-.333 1.006-.5 1.784-.5.71 0 1.266.172 1.666.517.4.344.69.772.867 1.283l2.133-.867c-.244-.777-.694-1.455-1.35-2.033-.655-.578-1.383-.9-2.183-.967V6.667h-2.333v1.666c-1.112.245-1.978.734-2.6 1.467-.623.733-.934 1.555-.934 2.467 0 1.044.306 1.889.917 2.533.61.644 1.572 1.2 2.883 1.667 1.4.51 2.372.966 2.917 1.366.544.4.816.923.816 1.567 0 .733-.26 1.272-.783 1.617-.522.344-1.15.516-1.883.516a3.025 3.025 0 01-1.95-.683c-.567-.456-.983-1.139-1.25-2.05l-2.2.867c.31 1.066.794 1.927 1.45 2.583.655.655 1.505 1.105 2.55 1.35v1.733zm1.2 4c-1.845 0-3.578-.35-5.2-1.05a13.465 13.465 0 01-4.234-2.85c-1.2-1.2-2.15-2.61-2.85-4.233-.7-1.622-1.05-3.356-1.05-5.2 0-1.845.35-3.578 1.05-5.2.7-1.622 1.65-3.033 2.85-4.233a13.47 13.47 0 014.234-2.85c1.622-.7 3.355-1.05 5.2-1.05 1.844 0 3.578.35 5.2 1.05 1.622.7 3.033 1.65 4.233 2.85 1.2 1.2 2.15 2.61 2.85 4.233.7 1.622 1.05 3.355 1.05 5.2 0 1.844-.35 3.578-1.05 5.2a13.465 13.465 0 01-2.85 4.233c-1.2 1.2-2.61 2.15-4.233 2.85-1.622.7-3.356 1.05-5.2 1.05z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-download", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M16 21.333l-6.666-6.666 1.866-1.934 3.467 3.467V5.333h2.667V16.2l3.466-3.467 1.867 1.934L16 21.333zm-8 5.334a2.568 2.568 0 01-1.883-.784A2.568 2.568 0 015.333 24v-4H8v4h16v-4h2.667v4c0 .733-.261 1.361-.784 1.883a2.568 2.568 0 01-1.883.784H8z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-edit", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M4 28v-5.667L21.6 4.767c.267-.245.561-.434.883-.567.323-.133.661-.2 1.017-.2.356 0 .7.067 1.033.2.334.133.623.333.867.6l1.833 1.867c.267.244.461.533.584.866.122.334.183.667.183 1 0 .356-.061.695-.183 1.017a2.498 2.498 0 01-.584.883L9.667 28H4zm19.467-17.6l1.866-1.867-1.866-1.866L21.6 8.533l1.867 1.867z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-elite", viewBox: "0 0 32 33" }, { children: jsx("path", { d: "M12.9 17.767l1.167-3.8L11 11.5h3.8L16 7.767l1.2 3.733H21l-3.1 2.467 1.167 3.8L16 15.4l-3.1 2.367zM8 30.167v-10.3c-.844-.934-1.5-2-1.966-3.2-.467-1.2-.7-2.478-.7-3.834 0-2.977 1.033-5.5 3.1-7.566C10.5 3.2 13.021 2.167 16 2.167c2.978 0 5.5 1.033 7.567 3.1 2.067 2.066 3.1 4.589 3.1 7.566 0 1.356-.234 2.634-.7 3.834a10.275 10.275 0 01-1.967 3.2v10.3L16 27.5l-8 2.667zm8-9.334c2.222 0 4.111-.777 5.667-2.333C23.222 16.945 24 15.056 24 12.833c0-2.222-.778-4.11-2.333-5.666C20.11 5.61 18.222 4.833 16 4.833s-4.11.778-5.666 2.334C8.777 8.722 8 10.61 8 12.833c0 2.223.778 4.112 2.334 5.667 1.555 1.556 3.444 2.333 5.666 2.333zM10.667 26.2L16 24.833l5.334 1.367v-4.133c-.778.444-1.617.794-2.517 1.05-.9.255-1.84.383-2.817.383-.978 0-1.916-.128-2.816-.383-.9-.256-1.74-.606-2.517-1.05V26.2z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-elite-inverted", viewBox: "0 0 32 33" }, { children: jsx("path", { d: "M12.9 17.767l1.167-3.8L11 11.5h3.8L16 7.767l1.2 3.733H21l-3.1 2.467 1.167 3.8L16 15.4l-3.1 2.367zM8 30.167v-10.3c-.844-.934-1.5-2-1.966-3.2-.467-1.2-.7-2.478-.7-3.834 0-2.977 1.033-5.5 3.1-7.566C10.5 3.2 13.021 2.167 16 2.167c2.978 0 5.5 1.033 7.567 3.1 2.067 2.066 3.1 4.589 3.1 7.566 0 1.356-.234 2.634-.7 3.834a10.275 10.275 0 01-1.967 3.2v10.3L16 27.5l-8 2.667zm8-9.334c2.222 0 4.111-.777 5.667-2.333C23.222 16.945 24 15.056 24 12.833c0-2.222-.778-4.11-2.333-5.666C20.11 5.61 18.222 4.833 16 4.833s-4.11.778-5.666 2.334C8.777 8.722 8 10.61 8 12.833c0 2.223.778 4.112 2.334 5.667 1.555 1.556 3.444 2.333 5.666 2.333z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-exclamation", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M15.993 23.01c.584 0 1.075-.198 1.475-.593.4-.395.599-.884.599-1.468 0-.583-.198-1.08-.592-1.49a1.957 1.957 0 00-1.468-.613 1.98 1.98 0 00-1.475.614c-.4.409-.599.906-.599 1.49 0 .583.198 1.072.592 1.467.395.395.884.592 1.468.592zm-1.88-5.752h3.774V9.38h-3.774v7.878zM16 29c-1.817 0-3.514-.34-5.092-1.02a13.097 13.097 0 01-4.116-2.772 13.096 13.096 0 01-2.771-4.116C3.34 19.515 3 17.817 3 16c0-1.817.34-3.514 1.02-5.092a13.096 13.096 0 012.772-4.116 13.096 13.096 0 014.116-2.771C12.486 3.34 14.183 3 16 3c1.817 0 3.515.34 5.092 1.02a13.12 13.12 0 014.116 2.772 13.097 13.097 0 012.771 4.116C28.66 12.486 29 14.183 29 16c0 1.817-.34 3.515-1.02 5.092a13.097 13.097 0 01-2.772 4.116 13.097 13.097 0 01-4.116 2.771C19.515 28.66 17.817 29 16 29z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-exclusive", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M15.584 8.624a.5.5 0 01.832 0l4.615 6.922a.5.5 0 00.728.113l5.17-4.135a.5.5 0 01.802.489l-2.317 11.585a.5.5 0 01-.49.402H7.076a.5.5 0 01-.49-.402L4.268 12.013a.5.5 0 01.803-.489l5.169 4.135a.5.5 0 00.728-.113l4.615-6.922z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-external", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M6.667 28a2.568 2.568 0 01-1.884-.783A2.568 2.568 0 014 25.333V6.667c0-.734.261-1.361.783-1.884A2.568 2.568 0 016.667 4H16v2.667H6.667v18.666h18.666V16H28v9.333a2.57 2.57 0 01-.783 1.884 2.568 2.568 0 01-1.884.783H6.667zm6.266-7.067l-1.866-1.866 12.4-12.4h-4.8V4H28v9.333h-2.667v-4.8l-12.4 12.4z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-favorite", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M16 27.783c-.311 0-.628-.055-.95-.166a2.204 2.204 0 01-.85-.534l-2.3-2.1a91.17 91.17 0 01-6.384-6.416c-1.9-2.122-2.85-4.461-2.85-7.017 0-2.089.7-3.833 2.1-5.233 1.4-1.4 3.145-2.1 5.234-2.1 1.178 0 2.289.25 3.333.75A7.941 7.941 0 0116 7.017a7.943 7.943 0 012.666-2.05A7.622 7.622 0 0122 4.217c2.089 0 3.833.7 5.233 2.1 1.4 1.4 2.1 3.144 2.1 5.233 0 2.556-.944 4.9-2.833 7.033-1.89 2.134-4.034 4.278-6.433 6.434L17.8 27.083a2.203 2.203 0 01-.85.534 2.903 2.903 0 01-.95.166zm-1.267-18.1c-.644-.91-1.333-1.605-2.067-2.083-.733-.478-1.622-.717-2.666-.717-1.334 0-2.445.445-3.333 1.334-.89.889-1.334 2-1.334 3.333 0 1.156.411 2.383 1.233 3.683a25.455 25.455 0 002.95 3.784 51.23 51.23 0 003.534 3.433A239.642 239.642 0 0116 25.083c.755-.688 1.739-1.566 2.95-2.633a51.254 51.254 0 003.533-3.433 25.462 25.462 0 002.95-3.784c.822-1.3 1.233-2.527 1.233-3.683 0-1.333-.444-2.444-1.333-3.333-.889-.89-2-1.334-3.333-1.334-1.045 0-1.933.24-2.667.717-.733.478-1.422 1.172-2.066 2.083A1.517 1.517 0 0116 10.35a1.516 1.516 0 01-1.267-.667z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-favorite-inverted", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M16 27.783c-.311 0-.628-.055-.95-.166a2.204 2.204 0 01-.85-.534l-2.3-2.1a91.17 91.17 0 01-6.384-6.416c-1.9-2.122-2.85-4.461-2.85-7.017 0-2.089.7-3.833 2.1-5.233 1.4-1.4 3.145-2.1 5.234-2.1 1.178 0 2.289.25 3.333.75A7.941 7.941 0 0116 7.017a7.943 7.943 0 012.666-2.05A7.622 7.622 0 0122 4.217c2.089 0 3.833.7 5.233 2.1 1.4 1.4 2.1 3.144 2.1 5.233 0 2.556-.944 4.9-2.833 7.033-1.89 2.134-4.034 4.278-6.433 6.434L17.8 27.083a2.203 2.203 0 01-.85.534 2.903 2.903 0 01-.95.166z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-filter", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M14.666 26.667a1.29 1.29 0 01-.95-.384 1.29 1.29 0 01-.383-.95v-8L5.6 7.467c-.334-.445-.384-.912-.15-1.4.233-.49.639-.734 1.216-.734h18.667c.578 0 .984.245 1.217.734.233.488.183.955-.15 1.4l-7.734 9.866v8c0 .378-.127.695-.383.95a1.29 1.29 0 01-.95.384h-2.667z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-flash", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M10.667 29.333L12 20H5.333l12-17.333H20l-1.333 10.666h8l-13.334 16h-2.666z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-flash-inverted", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M15.2 25.333L21 14h-4V6.667L11 18h4.2v7.333zm.8 4c-1.845 0-3.578-.35-5.2-1.05a13.465 13.465 0 01-4.234-2.85c-1.2-1.2-2.15-2.61-2.85-4.233-.7-1.622-1.05-3.356-1.05-5.2 0-1.845.35-3.578 1.05-5.2.7-1.622 1.65-3.033 2.85-4.233a13.47 13.47 0 014.234-2.85c1.622-.7 3.355-1.05 5.2-1.05 1.844 0 3.578.35 5.2 1.05 1.622.7 3.033 1.65 4.233 2.85 1.2 1.2 2.15 2.61 2.85 4.233.7 1.622 1.05 3.355 1.05 5.2 0 1.844-.35 3.578-1.05 5.2a13.465 13.465 0 01-2.85 4.233c-1.2 1.2-2.61 2.15-4.233 2.85-1.622.7-3.356 1.05-5.2 1.05z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-gavel", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M11.533 21.2L4 13.667 9.6 8l7.47 7.664-5.537 5.536zm5.536-5.536L9.6 8l5.733-5.667 7.534 7.534-5.798 5.797zm9.064 10.67l-17.4-17.4L10.6 7.066l17.4 17.4-1.867 1.866z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-go-1", viewBox: "0 0 34 32" }, { children: jsx("path", { fillRule: "evenodd", d: "M9.8 7.055C4.822 7.055.782 11.058.782 16s4.04 8.945 9.018 8.945a9.03 9.03 0 007.2-3.558 9.03 9.03 0 007.2 3.558c4.98 0 9.019-4.003 9.019-8.945s-4.04-8.945-9.019-8.945a9.03 9.03 0 00-7.376 3.797c-.443.59-1.219 1.997-1.519 3.74H7.262v2.975h7.685A5.379 5.379 0 019.8 21.335c-2.974 0-5.381-2.39-5.381-5.335s2.407-5.335 5.381-5.335c1.134 0 2.184.347 3.051.94l.15.1 2.59-2.568-.195-.152A9.027 9.027 0 009.8 7.055zm13.42 7.537h-4.212a5.377 5.377 0 015.192-3.928c2.974 0 5.382 2.391 5.382 5.336 0 2.945-2.408 5.335-5.382 5.335a5.379 5.379 0 01-5.146-3.768h4.087l-1.291 1.31 1.915 1.857 4.628-4.694-4.628-4.694-1.915 1.857 1.37 1.389z", clipRule: "evenodd" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-go-2", viewBox: "0 0 32 30" }, { children: jsx("path", { fillRule: "evenodd", d: "M16 9.824C17.593 7.511 20.224 6 23.2 6c4.86 0 8.8 4.03 8.8 9s-3.94 9-8.8 9c-2.976 0-5.607-1.511-7.2-3.824C14.407 22.489 11.776 24 8.8 24 3.94 24 0 19.97 0 15s3.94-9 8.8-9a8.64 8.64 0 015.461 1.942l-2.287 2.339A5.488 5.488 0 008.8 9.273c-3.093 0-5.6 2.564-5.6 5.727 0 3.163 2.507 5.727 5.6 5.727 2.624 0 4.826-1.845 5.434-4.336H6.48v-2.618h8.01c.27-1.846 1.07-3.348 1.51-3.949zm1.766 6.567h4.896l-1.503 1.572 1.602 1.602 4.326-4.524-4.326-4.524-1.602 1.602 1.582 1.654h-5.012c.55-2.574 2.79-4.5 5.471-4.5 3.093 0 5.6 2.564 5.6 5.727 0 3.163-2.507 5.727-5.6 5.727-2.624 0-4.826-1.845-5.434-4.336z", clipRule: "evenodd" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-go-3", viewBox: "0 0 32 32" }, { children: jsx("path", { fillRule: "evenodd", d: "M9.778 6a9.56 9.56 0 014.04.89l-2.27 4.35a4.87 4.87 0 00-1.77-.33C7.028 10.91 4.8 13.187 4.8 16s2.229 5.09 4.978 5.09a4.9 4.9 0 003.374-1.347 10.098 10.098 0 01-.53-1.834H6.844v-3.636h5.746C13.39 9.573 17.398 6 22.222 6 27.622 6 32 10.477 32 16s-4.378 10-9.778 10A9.607 9.607 0 0116 23.714 9.607 9.607 0 019.778 26C4.378 26 0 21.523 0 16S4.378 6 9.778 6zm12.444 15.454c2.946 0 5.334-2.442 5.334-5.454 0-3.012-2.388-5.454-5.334-5.454-2.355 0-4.354 1.56-5.06 3.727h2.53l-.032-.034 2.28-2.296 3.95 4.103-3.95 4.102-2.223-2.239h-2.492c.756 2.071 2.708 3.546 4.997 3.546z", clipRule: "evenodd" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-group-exclusive", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M0 24v-2.1c0-.956.489-1.733 1.467-2.333.977-.6 2.266-.9 3.866-.9.29 0 .567.005.834.016.266.011.522.04.766.084a5.547 5.547 0 00-.7 1.466 5.465 5.465 0 00-.233 1.6V24H0zm8 0v-2.167c0-.71.194-1.36.583-1.95.39-.589.94-1.105 1.65-1.55.711-.444 1.561-.777 2.55-1A14.664 14.664 0 0116 17c1.178 0 2.261.111 3.25.333.989.223 1.839.556 2.55 1 .711.445 1.256.961 1.633 1.55.378.59.567 1.24.567 1.95V24H8zm18 0v-2.167a5.96 5.96 0 00-.217-1.633 5.218 5.218 0 00-.65-1.433c.245-.045.495-.073.75-.084.256-.01.517-.016.784-.016 1.6 0 2.889.294 3.866.883.978.589 1.467 1.372 1.467 2.35V24h-6zM5.333 17.333a2.568 2.568 0 01-1.883-.783 2.568 2.568 0 01-.783-1.883c0-.756.26-1.39.783-1.9A2.596 2.596 0 015.333 12c.756 0 1.39.256 1.9.767.511.51.767 1.144.767 1.9 0 .733-.256 1.36-.767 1.883-.51.522-1.144.783-1.9.783zm21.334 0a2.568 2.568 0 01-1.884-.783A2.568 2.568 0 0124 14.667c0-.756.261-1.39.783-1.9A2.596 2.596 0 0126.667 12c.755 0 1.389.256 1.9.767.51.51.766 1.144.766 1.9 0 .733-.255 1.36-.766 1.883-.511.522-1.145.783-1.9.783zM16 16c-1.111 0-2.056-.389-2.833-1.167C12.389 14.056 12 13.111 12 12c0-1.133.389-2.083 1.167-2.85C13.944 8.383 14.889 8 16 8c1.133 0 2.083.383 2.85 1.15.767.767 1.15 1.717 1.15 2.85 0 1.111-.383 2.056-1.15 2.833C18.083 15.611 17.133 16 16 16z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-group1", viewBox: "0 0 32 33" }, { children: jsx("path", { d: "M16 29.833a12.9 12.9 0 01-5.167-1.05 13.524 13.524 0 01-4.25-2.866 13.524 13.524 0 01-2.867-4.25 12.901 12.901 0 01-1.05-5.167c0-1.844.35-3.572 1.05-5.183a13.577 13.577 0 012.867-4.234 13.524 13.524 0 014.25-2.866A12.9 12.9 0 0116 3.167c1.844 0 3.572.35 5.183 1.05 1.611.7 3.022 1.655 4.233 2.866a13.578 13.578 0 012.867 4.234c.7 1.61 1.05 3.339 1.05 5.183 0 1.822-.35 3.544-1.05 5.167a13.525 13.525 0 01-2.867 4.25 13.577 13.577 0 01-4.233 2.866c-1.61.7-3.339 1.05-5.183 1.05zm0-2.733c.578-.8 1.078-1.633 1.5-2.5.422-.867.767-1.789 1.033-2.767h-5.067c.267.978.612 1.9 1.034 2.767.422.867.922 1.7 1.5 2.5zm-3.467-.533c-.4-.734-.75-1.495-1.05-2.284-.3-.789-.55-1.605-.75-2.45H6.8a11.066 11.066 0 002.417 2.9 9.594 9.594 0 003.316 1.834zm6.934 0a9.595 9.595 0 003.316-1.834 11.066 11.066 0 002.417-2.9h-3.933c-.2.845-.45 1.662-.75 2.45-.3.79-.65 1.55-1.05 2.284zm-13.8-7.4H10.2A17.627 17.627 0 0110 16.5a17.631 17.631 0 01.2-2.667H5.667a10.615 10.615 0 00-.333 2.667 10.613 10.613 0 00.333 2.667zm7.2 0h6.266a17.627 17.627 0 00.2-2.667 17.63 17.63 0 00-.2-2.667h-6.266a17.63 17.63 0 00-.2 2.667 17.627 17.627 0 00.2 2.667zm8.933 0h4.533a10.622 10.622 0 00.333-2.667 10.625 10.625 0 00-.333-2.667H21.8A17.58 17.58 0 0122 16.5a17.576 17.576 0 01-.2 2.667zm-.534-8H25.2a11.065 11.065 0 00-2.417-2.9 9.595 9.595 0 00-3.317-1.834c.4.734.75 1.495 1.05 2.284.3.789.55 1.605.75 2.45zm-7.8 0h5.067c-.267-.978-.61-1.9-1.033-2.767-.422-.867-.922-1.7-1.5-2.5a16.94 16.94 0 00-1.5 2.5 15.786 15.786 0 00-1.034 2.767zm-6.666 0h3.933c.2-.845.45-1.661.75-2.45.3-.79.65-1.55 1.05-2.284a9.594 9.594 0 00-3.316 1.834 11.065 11.065 0 00-2.417 2.9z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-help", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M15.85 23.189c.5 0 .929-.18 1.288-.54.36-.359.54-.79.54-1.291a1.7 1.7 0 00-.54-1.274 1.791 1.791 0 00-1.288-.52c-.499 0-.928.174-1.288.52a1.7 1.7 0 00-.539 1.274c0 .502.18.932.54 1.292.359.36.788.539 1.287.539zm-1.408-4.613h2.816c0-.58.08-1.068.24-1.468.16-.4.539-.888 1.138-1.467.46-.44.834-.91 1.123-1.41.29-.5.435-1.102.435-1.804 0-1.193-.39-2.103-1.169-2.732-.778-.63-1.727-.944-2.845-.944-1.218 0-2.232.35-3.04 1.049-.81.698-1.373 1.527-1.693 2.486l2.636.988c.14-.4.36-.799.659-1.198.3-.4.729-.599 1.288-.599.4 0 .709.125.928.374.22.25.33.525.33.824 0 .3-.105.61-.314.929-.21.32-.425.569-.645.748-.798.74-1.313 1.343-1.542 1.813-.23.469-.345 1.273-.345 2.411zM16 29c-1.817 0-3.514-.34-5.092-1.02a13.097 13.097 0 01-4.116-2.772 13.096 13.096 0 01-2.771-4.116C3.34 19.515 3 17.817 3 16c0-1.817.34-3.514 1.02-5.092a13.096 13.096 0 012.772-4.116 13.096 13.096 0 014.116-2.771C12.486 3.34 14.183 3 16 3c1.817 0 3.515.34 5.092 1.02a13.12 13.12 0 014.116 2.772 13.097 13.097 0 012.771 4.116C28.66 12.486 29 14.183 29 16c0 1.817-.34 3.515-1.02 5.092a13.097 13.097 0 01-2.772 4.116 13.097 13.097 0 01-4.116 2.771C19.515 28.66 17.817 29 16 29z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-hot", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M4.333 18.667c0-2.334.556-4.411 1.667-6.234 1.111-1.822 2.334-3.355 3.667-4.6C11 6.59 12.222 5.64 13.334 4.983L15 4v4.4c0 .822.278 1.472.834 1.95.555.478 1.177.717 1.866.717.378 0 .74-.078 1.084-.234.344-.155.66-.41.95-.766l.6-.734c1.6.934 2.888 2.228 3.866 3.884.978 1.655 1.467 3.472 1.467 5.45 0 1.955-.478 3.739-1.434 5.35-.955 1.61-2.21 2.883-3.766 3.816a6.642 6.642 0 00.883-1.75 6.336 6.336 0 00.317-2.016c0-.89-.167-1.728-.5-2.517a6.61 6.61 0 00-1.434-2.117L15 14.8l-4.7 4.633a6.79 6.79 0 00-1.466 2.134 6.278 6.278 0 00-.5 2.5c0 .71.105 1.383.316 2.016.211.634.506 1.217.883 1.75-1.555-.933-2.81-2.205-3.766-3.816-.956-1.611-1.434-3.395-1.434-5.35zM15 18.533l2.834 2.767c.377.378.666.8.866 1.267.2.466.3.966.3 1.5 0 1.089-.389 2.016-1.166 2.783C17.056 27.617 16.11 28 15 28s-2.055-.383-2.833-1.15C11.389 26.083 11 25.156 11 24.067c0-.511.1-1.006.3-1.484.2-.477.49-.905.867-1.283L15 18.533z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-image", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M6.667 28a2.568 2.568 0 01-1.884-.783A2.568 2.568 0 014 25.333V6.667c0-.734.261-1.361.783-1.884A2.568 2.568 0 016.667 4h18.666a2.57 2.57 0 011.884.783A2.57 2.57 0 0128 6.667v18.666a2.57 2.57 0 01-.783 1.884 2.568 2.568 0 01-1.884.783H6.667zM8 22.667h16L19 16l-4 5.333-3-4-4 5.334z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-info", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M14.352 22.44h3.296v-7.638h-3.296v7.638zM16 13.005c.51 0 .936-.173 1.28-.517.345-.345.517-.771.517-1.28 0-.51-.172-.937-.517-1.281A1.739 1.739 0 0016 9.41c-.51 0-.936.172-1.28.517a1.739 1.739 0 00-.517 1.28c0 .51.172.936.517 1.28.344.345.77.518 1.28.518zM16 29c-1.817 0-3.514-.34-5.092-1.02a13.097 13.097 0 01-4.116-2.772 13.096 13.096 0 01-2.771-4.116C3.34 19.515 3 17.817 3 16c0-1.817.34-3.514 1.02-5.092a13.096 13.096 0 012.772-4.116 13.096 13.096 0 014.116-2.771C12.486 3.34 14.183 3 16 3c1.817 0 3.515.34 5.092 1.02a13.12 13.12 0 014.116 2.772 13.097 13.097 0 012.771 4.116C28.66 12.486 29 14.183 29 16c0 1.817-.34 3.515-1.02 5.092a13.097 13.097 0 01-2.772 4.116 13.097 13.097 0 01-4.116 2.771C19.515 28.66 17.817 29 16 29z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-key", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M9.334 20c1.11 0 2.055-.389 2.833-1.167.778-.777 1.167-1.722 1.167-2.833 0-1.111-.39-2.056-1.167-2.833C11.389 12.389 10.445 12 9.334 12c-1.112 0-2.056.389-2.834 1.167-.778.777-1.167 1.722-1.167 2.833 0 1.111.39 2.056 1.167 2.833C7.278 19.611 8.222 20 9.334 20zm0 4c-2.223 0-4.112-.778-5.667-2.333C2.11 20.11 1.334 18.222 1.334 16s.777-4.111 2.333-5.667C5.222 8.778 7.11 8 9.334 8c1.8 0 3.372.511 4.716 1.533 1.345 1.023 2.284 2.29 2.817 3.8h11.166l2.634 2.634L26 21.3l-3.333-2.633L20 21.333l-2.666-2.666h-.467a7.744 7.744 0 01-2.9 3.866C12.589 23.511 11.045 24 9.334 24z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-layout-grid", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M5 14.667V5h9.667v9.667H5zM5 27v-9.667h9.667V27H5zm12.333-12.333V5H27v9.667h-9.667zm0 12.333v-9.667H27V27h-9.667z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-layout-list", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M12.4 25.5H28v-4.75H12.4v4.75zM4 11.25h6V6.5H4v4.75zm0 7.125h6v-4.75H4v4.75zM4 25.5h6v-4.75H4v4.75zm8.4-7.125H28v-4.75H12.4v4.75zm0-7.125H28V6.5H12.4v4.75z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-lender", viewBox: "0 0 32 33" }, { children: jsx("path", { d: "M6.667 24.167v-9.334h2.666v9.334H6.666zm8 0v-9.334h2.666v9.334h-2.666zm-12 5.333v-2.667h26.666V29.5H2.667zm20-5.333v-9.334h2.666v9.334h-2.666zm-20-12V9.5L16 2.833 29.333 9.5v2.667H2.667z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-live", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M16 21c1.383 0 2.563-.488 3.538-1.462C20.512 18.562 21 17.383 21 16s-.488-2.563-1.462-3.537C18.562 11.488 17.383 11 16 11s-2.563.488-3.537 1.463C11.488 13.438 11 14.617 11 16s.488 2.563 1.463 3.538C13.438 20.512 14.617 21 16 21zm0 5a9.738 9.738 0 01-3.9-.788 10.098 10.098 0 01-3.175-2.137c-.9-.9-1.613-1.958-2.138-3.175A9.738 9.738 0 016 16c0-1.383.263-2.683.787-3.9a10.098 10.098 0 012.138-3.175c.9-.9 1.958-1.613 3.175-2.138A9.738 9.738 0 0116 6c1.383 0 2.683.263 3.9.787a10.098 10.098 0 013.175 2.138c.9.9 1.613 1.958 2.137 3.175A9.738 9.738 0 0126 16a9.738 9.738 0 01-.788 3.9 10.098 10.098 0 01-2.137 3.175c-.9.9-1.958 1.613-3.175 2.137A9.738 9.738 0 0116 26zm0-2c2.233 0 4.125-.775 5.675-2.325C23.225 20.125 24 18.233 24 16c0-2.233-.775-4.125-2.325-5.675C20.125 8.775 18.233 8 16 8c-2.233 0-4.125.775-5.675 2.325C8.775 11.875 8 13.767 8 16c0 2.233.775 4.125 2.325 5.675C11.875 23.225 13.767 24 16 24z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-location", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M16 16c.733 0 1.361-.261 1.884-.783a2.57 2.57 0 00.783-1.884c0-.733-.261-1.36-.784-1.883A2.568 2.568 0 0016 10.667c-.733 0-1.36.26-1.883.783a2.568 2.568 0 00-.784 1.883c0 .734.262 1.361.784 1.884.522.522 1.15.783 1.883.783zm0 13.333c-3.578-3.044-6.25-5.872-8.017-8.483-1.766-2.611-2.65-5.028-2.65-7.25 0-3.333 1.073-5.989 3.217-7.967 2.145-1.977 4.628-2.966 7.45-2.966s5.306.989 7.45 2.966c2.145 1.978 3.217 4.634 3.217 7.967 0 2.222-.884 4.639-2.65 7.25-1.767 2.611-4.44 5.439-8.017 8.483z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-lock", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M8 30.333a2.568 2.568 0 01-1.883-.783 2.568 2.568 0 01-.784-1.883V14.333c0-.733.262-1.36.784-1.883A2.568 2.568 0 018 11.667h1.334V9c0-1.844.65-3.417 1.95-4.717 1.3-1.3 2.872-1.95 4.716-1.95 1.845 0 3.417.65 4.717 1.95 1.3 1.3 1.95 2.873 1.95 4.717v2.667H24c.733 0 1.361.26 1.884.783.522.522.783 1.15.783 1.883v13.334c0 .733-.261 1.36-.784 1.883a2.568 2.568 0 01-1.883.783H8zm8-6.666c.733 0 1.361-.261 1.884-.784.522-.522.783-1.15.783-1.883 0-.733-.261-1.361-.784-1.883A2.568 2.568 0 0016 18.333a2.57 2.57 0 00-1.883.784A2.568 2.568 0 0013.333 21c0 .733.262 1.361.784 1.883.522.523 1.15.784 1.883.784zm-4-12h8V9c0-1.111-.389-2.056-1.166-2.833C18.056 5.389 17.11 5 16 5s-2.055.389-2.833 1.167C12.389 6.944 12 7.889 12 9v2.667z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-marketplace", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M30.333 14.452v12.955c0 .897-.312 1.664-.936 2.302-.624.639-1.373.958-2.25.958H4.853c-.876 0-1.625-.32-2.25-.958a3.176 3.176 0 01-.935-2.302V14.452c-.61-.57-1.081-1.304-1.413-2.2-.332-.896-.339-1.874-.02-2.933l1.672-5.541c.212-.706.59-1.29 1.135-1.752a2.835 2.835 0 011.89-.693h22.137c.717 0 1.34.224 1.871.673.531.448.916 1.038 1.155 1.772l1.672 5.54c.319 1.06.312 2.024-.02 2.893a6.457 6.457 0 01-1.413 2.24zm-10.83-1.711c.717 0 1.261-.252 1.633-.754a2.263 2.263 0 00.438-1.69l-.876-5.704h-3.105v6.03c0 .57.185 1.065.557 1.486.372.421.823.632 1.354.632zm-7.166 0c.61 0 1.108-.21 1.493-.632a2.13 2.13 0 00.578-1.487v-6.03h-3.106l-.876 5.704c-.106.652.033 1.223.418 1.711.385.49.883.734 1.493.734zm-7.087 0c.478 0 .896-.177 1.255-.53.358-.353.577-.801.656-1.344l.876-6.274H4.932l-1.593 5.459c-.159.543-.073 1.127.26 1.752.331.624.882.937 1.651.937zm21.5 0c.77 0 1.327-.313 1.672-.937.345-.625.424-1.209.239-1.752l-1.673-5.46h-3.025l.875 6.275c.08.543.3.991.657 1.344.359.353.777.53 1.255.53z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-max-bid", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M14.357 21.575h3.287v-4.912l1.844 1.845 2.315-2.298L16 10.425l-5.803 5.785 2.315 2.298 1.845-1.845v4.912zM16 29c-1.81 0-3.504-.34-5.083-1.022a13.103 13.103 0 01-4.12-2.775 13.103 13.103 0 01-2.775-4.12C3.341 19.503 3 17.809 3 16c0-1.81.34-3.504 1.022-5.083a13.104 13.104 0 012.775-4.12 13.104 13.104 0 014.12-2.775C12.497 3.341 14.191 3 16 3c1.81 0 3.504.34 5.083 1.022a13.104 13.104 0 014.12 2.775 13.105 13.105 0 012.775 4.12C28.659 12.497 29 14.191 29 16c0 1.81-.34 3.504-1.022 5.083a13.104 13.104 0 01-2.775 4.12 13.104 13.104 0 01-4.12 2.775C19.503 28.659 17.809 29 16 29z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-menu", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M2 7.756V4h28v3.756H2zm0 6.407v3.756h28v-3.756H2zM2 24v3.756h28V24H2z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-microphone", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M16 20.667c-1.111 0-2.056-.39-2.834-1.167C12.39 18.722 12 17.778 12 16.667v-8c0-1.111.389-2.056 1.166-2.834.778-.777 1.723-1.166 2.834-1.166 1.11 0 2.055.389 2.833 1.166C19.611 6.611 20 7.556 20 8.667v8c0 1.11-.39 2.055-1.167 2.833-.778.778-1.722 1.167-2.833 1.167zM14.666 30v-4.1c-2.31-.311-4.222-1.344-5.733-3.1-1.51-1.756-2.266-3.8-2.266-6.133h2.666c0 1.844.65 3.416 1.95 4.716 1.3 1.3 2.872 1.95 4.717 1.95 1.844 0 3.416-.65 4.716-1.95 1.3-1.3 1.95-2.872 1.95-4.716h2.667c0 2.333-.755 4.377-2.266 6.133-1.512 1.756-3.423 2.789-5.734 3.1V30h-2.666z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-miles", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M13.933 20.667c.556.555 1.256.816 2.1.783.845-.033 1.456-.339 1.833-.917l7.467-11.2-11.2 7.467c-.578.4-.894 1.005-.95 1.817-.055.81.195 1.494.75 2.05zm-7.133 6c-.489 0-.939-.106-1.35-.317a2.378 2.378 0 01-.984-.95 14.944 14.944 0 01-1.333-3.25 12.979 12.979 0 01-.466-3.483c0-1.845.35-3.578 1.05-5.2.7-1.623 1.65-3.034 2.85-4.234 1.2-1.2 2.61-2.15 4.233-2.85 1.622-.7 3.355-1.05 5.2-1.05 1.822 0 3.533.345 5.133 1.034 1.6.689 3 1.627 4.2 2.816A13.662 13.662 0 0128.2 13.35c.71 1.589 1.078 3.294 1.1 5.117a13.345 13.345 0 01-.417 3.583A13.093 13.093 0 0127.5 25.4a2.378 2.378 0 01-.983.95 2.912 2.912 0 01-1.35.317H6.8z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-minus", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M6.667 17.333v-2.666h18.666v2.666H6.667z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-minus-inverted", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M9.333 17.333h13.333v-2.666H9.333v2.666zm6.667 12c-1.845 0-3.578-.35-5.2-1.05a13.465 13.465 0 01-4.234-2.85c-1.2-1.2-2.15-2.61-2.85-4.233-.7-1.622-1.05-3.355-1.05-5.2 0-1.844.35-3.578 1.05-5.2.7-1.622 1.65-3.033 2.85-4.233a13.47 13.47 0 014.234-2.85c1.622-.7 3.355-1.05 5.2-1.05 1.844 0 3.578.35 5.2 1.05 1.622.7 3.033 1.65 4.233 2.85 1.2 1.2 2.15 2.61 2.85 4.233.7 1.622 1.05 3.356 1.05 5.2 0 1.845-.35 3.578-1.05 5.2a13.465 13.465 0 01-2.85 4.233c-1.2 1.2-2.61 2.15-4.233 2.85-1.622.7-3.356 1.05-5.2 1.05z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-more", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M8 18.667a2.568 2.568 0 01-1.883-.784A2.568 2.568 0 015.333 16c0-.733.262-1.361.784-1.883A2.568 2.568 0 018 13.333c.733 0 1.361.261 1.883.784.523.522.784 1.15.784 1.883 0 .733-.261 1.361-.784 1.883A2.568 2.568 0 018 18.667zm8 0a2.568 2.568 0 01-1.883-.784A2.568 2.568 0 0113.333 16c0-.733.262-1.361.784-1.883A2.568 2.568 0 0116 13.333c.733 0 1.361.261 1.884.784.522.522.783 1.15.783 1.883 0 .733-.261 1.361-.784 1.883a2.568 2.568 0 01-1.883.784zm8 0a2.568 2.568 0 01-1.883-.784A2.568 2.568 0 0121.333 16c0-.733.262-1.361.784-1.883A2.568 2.568 0 0124 13.333c.733 0 1.361.261 1.884.784.522.522.783 1.15.783 1.883 0 .733-.261 1.361-.784 1.883a2.568 2.568 0 01-1.883.784z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-more-inverted", viewBox: "0 0 32 32" }, { children: jsx("path", { fillRule: "evenodd", d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16zM3 15.982c0-1.88 1.64-3.482 3.518-3.482 1.86 0 3.482 1.603 3.482 3.482C10 17.86 8.379 19.5 6.518 19.5 4.64 19.5 3 17.86 3 15.982zm9.5 0c0-1.88 1.64-3.482 3.518-3.482 1.86 0 3.482 1.603 3.482 3.482 0 1.878-1.621 3.518-3.482 3.518-1.879 0-3.518-1.64-3.518-3.518zM25.518 12.5C23.64 12.5 22 14.103 22 15.982c0 1.878 1.64 3.518 3.518 3.518 1.86 0 3.482-1.64 3.482-3.518 0-1.88-1.621-3.482-3.482-3.482z", clipRule: "evenodd" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-more-vertical", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M16 26.667a2.568 2.568 0 01-1.883-.784A2.568 2.568 0 0113.333 24c0-.733.262-1.361.784-1.883A2.568 2.568 0 0116 21.333c.733 0 1.361.262 1.884.784.522.522.783 1.15.783 1.883 0 .733-.261 1.361-.784 1.883a2.568 2.568 0 01-1.883.784zm0-8a2.568 2.568 0 01-1.883-.784A2.568 2.568 0 0113.333 16c0-.733.262-1.361.784-1.883A2.568 2.568 0 0116 13.333c.733 0 1.361.261 1.884.784.522.522.783 1.15.783 1.883 0 .733-.261 1.361-.784 1.883a2.568 2.568 0 01-1.883.784zm0-8a2.568 2.568 0 01-1.883-.784A2.568 2.568 0 0113.333 8c0-.733.262-1.361.784-1.883A2.568 2.568 0 0116 5.333c.733 0 1.361.261 1.884.784.522.522.783 1.15.783 1.883 0 .733-.261 1.361-.784 1.883a2.568 2.568 0 01-1.883.784z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-na", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M16 29c-1.797 0-3.485-.345-5.062-1.033a13.327 13.327 0 01-4.134-2.801 13.072 13.072 0 01-2.786-4.149C3.34 19.43 3 17.737 3 15.94c0-1.797.34-3.48 1.018-5.047a12.984 12.984 0 012.786-4.104 13.245 13.245 0 014.134-2.77C12.515 3.338 14.203 3 16 3c1.797 0 3.485.34 5.062 1.018a13.245 13.245 0 014.134 2.771 12.986 12.986 0 012.786 4.104C28.66 12.46 29 14.143 29 15.94c0 1.797-.34 3.49-1.018 5.077a13.074 13.074 0 01-2.786 4.149 13.327 13.327 0 01-4.134 2.8C19.485 28.657 17.797 29 16 29zm0-3.774c.919 0 1.817-.125 2.696-.375a6.97 6.97 0 002.396-1.213l-12.79-12.76a8.454 8.454 0 00-1.153 2.426 9.396 9.396 0 00-.375 2.636c0 2.576.899 4.768 2.696 6.575 1.797 1.807 3.974 2.71 6.53 2.71zm7.728-4.224c.5-.758.874-1.567 1.123-2.426.25-.859.375-1.737.375-2.636 0-2.556-.899-4.723-2.696-6.5-1.797-1.777-3.974-2.666-6.53-2.666a9.99 9.99 0 00-2.621.345 8.32 8.32 0 00-2.411 1.093l12.76 12.79z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-new", viewBox: "0 0 32 33" }, { children: jsx("path", { fillRule: "evenodd", d: "M16 .5C7.163.5 0 7.663 0 16.5s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16zm2 20v-1.463h-3.333v-1.84h3.083v-1.463h-3.083v-1.771H18V12.5h-5v8h5zm10-8h-1.5l-1 5-1.25-5h-1.5l-1.25 5-1-5H19l1.5 8h2l1-5 1 5h2l1.5-8zm-17 8v-8H9v5l-3-5H4v8h2v-5l3 5h2z", clipRule: "evenodd" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-no-view", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M26.4 29.133L20.8 23.6a16 16 0 01-2.35.55 16.01 16.01 0 01-2.45.183c-3.355 0-6.344-.927-8.966-2.783-2.623-1.856-4.523-4.261-5.7-7.217A15.805 15.805 0 013.1 11.05a15.352 15.352 0 012.433-2.717L1.868 4.6l1.866-1.867 24.534 24.534-1.867 1.866zm-10.4-8.8c.245 0 .472-.01.683-.033a4.33 4.33 0 00.684-.133l-7.2-7.2a4.343 4.343 0 00-.133.683 6.555 6.555 0 00-.034.683c0 1.667.584 3.084 1.75 4.25 1.167 1.167 2.584 1.75 4.25 1.75zm9.733.6l-4.233-4.2a7.28 7.28 0 00.367-1.15 5.6 5.6 0 00.133-1.25c0-1.666-.583-3.083-1.75-4.25-1.166-1.166-2.583-1.75-4.25-1.75a5.6 5.6 0 00-1.25.134 5.655 5.655 0 00-1.15.4l-3.4-3.4A14.773 14.773 0 0116 4.333c3.356 0 6.345.928 8.967 2.784 2.622 1.855 4.522 4.26 5.7 7.216a15.594 15.594 0 01-2.017 3.65 14.68 14.68 0 01-2.916 2.95zM19.567 14.8l-4-4c.622-.111 1.194-.061 1.716.15.523.211.973.517 1.35.917.378.4.65.86.817 1.383.167.522.206 1.039.117 1.55z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-notes", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M6.667 25.333h12v-6.666h6.666v-12H6.667v18.666zm0 2.667a2.568 2.568 0 01-1.884-.783A2.568 2.568 0 014 25.333V6.667c0-.734.261-1.361.783-1.884A2.568 2.568 0 016.667 4h18.666a2.57 2.57 0 011.884.783A2.57 2.57 0 0128 6.667V20l-8 8H6.667zm2.666-9.333V16H16v2.667H9.333zm0-5.334v-2.666h13.334v2.666H9.333z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-notes-inverted", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M6.667 28a2.568 2.568 0 01-1.884-.783A2.568 2.568 0 014 25.333V6.667c0-.734.261-1.361.783-1.884A2.568 2.568 0 016.667 4h18.666a2.57 2.57 0 011.884.783A2.57 2.57 0 0128 6.667V20l-8 8H6.667zm12-2.667l6.666-6.666h-6.666v6.666zm-9.334-6.666H16V16H9.333v2.667zm0-5.334h13.334v-2.666H9.333v2.666z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-notification", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M5.333 26.333v-2.666H8v-9.334c0-1.844.556-3.483 1.667-4.916C10.777 7.983 12.222 7.044 14 6.6v-.933c0-.556.195-1.028.584-1.417A1.929 1.929 0 0116 3.667c.556 0 1.028.194 1.417.583.389.389.583.861.583 1.417V6.6c1.778.444 3.222 1.383 4.334 2.817C23.444 10.85 24 12.489 24 14.333v9.334h2.667v2.666H5.333zm10.667 4a2.568 2.568 0 01-1.883-.783 2.568 2.568 0 01-.784-1.883h5.334c0 .733-.261 1.36-.784 1.883a2.568 2.568 0 01-1.883.783z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-notification-disabled", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M6.333 25.333v-2.666H9v-9.334c0-.733.094-1.455.283-2.166a8.132 8.132 0 01.85-2.034l4.2 4.2H10.6L2.867 5.6l1.866-1.867 24.534 24.534-1.867 1.866-4.867-4.8h-16.2zM25 20.2L11.933 7.133a8.816 8.816 0 011.434-.933A6.84 6.84 0 0115 5.6v-.933c0-.556.194-1.028.583-1.417A1.929 1.929 0 0117 2.667c.556 0 1.028.194 1.417.583.389.389.583.861.583 1.417V5.6c1.778.444 3.222 1.383 4.333 2.817C24.445 9.85 25 11.489 25 13.333V20.2zm-8 9.133a2.568 2.568 0 01-1.883-.783 2.568 2.568 0 01-.784-1.883h5.334c0 .733-.261 1.36-.784 1.883a2.568 2.568 0 01-1.883.783z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-notification-mail", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M5.333 26.667a2.568 2.568 0 01-1.883-.784A2.568 2.568 0 012.666 24V8c0-.733.262-1.361.784-1.883a2.568 2.568 0 011.883-.784h21.334c.733 0 1.36.261 1.883.784.522.522.783 1.15.783 1.883v16c0 .733-.26 1.361-.783 1.883a2.568 2.568 0 01-1.884.784H5.334zM16 17.333l10.666-6.666V8L16 14.667 5.333 8v2.667L16 17.333z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-notification-phone", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M9.333 30.667a2.568 2.568 0 01-1.883-.784A2.568 2.568 0 016.666 28V4c0-.733.262-1.361.784-1.883a2.568 2.568 0 011.883-.784h13.333c.734 0 1.362.261 1.884.784.522.522.783 1.15.783 1.883v24c0 .733-.26 1.361-.783 1.883a2.568 2.568 0 01-1.884.784H9.333zm0-6.667h13.333V8H9.333v16z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-notification-sms", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M9.333 25a1.29 1.29 0 01-.95-.383 1.29 1.29 0 01-.383-.95V21h17.333V9H28c.378 0 .694.128.95.383.255.256.383.573.383.95v20L24 25H9.333zm-6.667-1.333V5c0-.378.128-.694.384-.95A1.29 1.29 0 014 3.667h17.333c.378 0 .695.127.95.383.256.256.383.572.383.95v12c0 .378-.127.694-.383.95a1.29 1.29 0 01-.95.383H8l-5.333 5.334z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-off-lease", viewBox: "0 0 32 33" }, { children: jsx("path", { d: "M5.667 27.5V4.833h12L18.2 7.5h7.466v13.333h-9.333l-.533-2.666H8.333V27.5H5.666z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-offline", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M26.333 29.133L13.8 16.533a11.63 11.63 0 00-2.917 1.1c-.9.49-1.705 1.1-2.416 1.834l-2.8-2.867a14.094 14.094 0 012.3-1.867c.822-.533 1.7-1 2.633-1.4l-3-3c-.911.467-1.761.984-2.55 1.55A18.179 18.179 0 002.8 13.8L0 10.933c.711-.71 1.45-1.35 2.217-1.916A28.322 28.322 0 014.667 7.4l-2.8-2.8 1.866-1.867 24.534 24.534-1.934 1.866zM16 27c-.933 0-1.722-.328-2.367-.983a3.235 3.235 0 01-.966-2.35c0-.934.322-1.723.966-2.367.645-.645 1.434-.967 2.367-.967s1.722.323 2.367.967c.644.644.966 1.433.966 2.367 0 .91-.322 1.694-.966 2.35-.645.655-1.434.983-2.367.983zm7.867-7.933l-6.734-6.734c1.8.178 3.484.634 5.05 1.367a14.53 14.53 0 014.15 2.9l-2.466 2.467zM29.2 13.8a18.81 18.81 0 00-5.95-4.017c-2.256-.966-4.672-1.45-7.25-1.45a17.607 17.607 0 00-2.667.2l-3.4-3.4a22.509 22.509 0 012.984-.6 23.56 23.56 0 013.083-.2c3.156 0 6.1.59 8.833 1.767 2.734 1.178 5.123 2.789 7.167 4.833L29.2 13.8z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-pause", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M18.857 26V6h5.715v20h-5.715zM7.43 26V6h5.714v20H7.429z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-play", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M10.143 26V6l15.714 10-15.714 10z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-plus", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M14.666 17.333h-8v-2.666h8v-8h2.667v8h8v2.666h-8v8h-2.666v-8z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-plus-inverted", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M14.666 22.667h2.667v-5.334h5.334v-2.666h-5.334V9.333h-2.666v5.334H9.332v2.666h5.333v5.334zM16 29.333c-1.845 0-3.578-.35-5.2-1.05a13.465 13.465 0 01-4.234-2.85c-1.2-1.2-2.15-2.61-2.85-4.233-.7-1.622-1.05-3.355-1.05-5.2 0-1.844.35-3.578 1.05-5.2.7-1.622 1.65-3.033 2.85-4.233a13.47 13.47 0 014.234-2.85c1.622-.7 3.355-1.05 5.2-1.05 1.844 0 3.578.35 5.2 1.05 1.622.7 3.033 1.65 4.233 2.85 1.2 1.2 2.15 2.61 2.85 4.233.7 1.622 1.05 3.356 1.05 5.2 0 1.845-.35 3.578-1.05 5.2a13.465 13.465 0 01-2.85 4.233c-1.2 1.2-2.61 2.15-4.233 2.85-1.622.7-3.356 1.05-5.2 1.05z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-reserve", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M17.333 28v-2.667h6.134L17.333 19.2v-3.733l8 8v-6.134H28V28H17.333zM8 22.667v-1.334H4v-2.666h8v-4H6.667a2.568 2.568 0 01-1.884-.784A2.568 2.568 0 014 12V8c0-.733.261-1.361.783-1.883a2.568 2.568 0 011.884-.784H8V4h2.667v1.333h4V8h-8v4H12c.733 0 1.361.261 1.883.783.523.523.784 1.15.784 1.884v4c0 .733-.261 1.36-.784 1.883a2.568 2.568 0 01-1.883.783h-1.333v1.334H8z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-return-left", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M23.667 3.333v13.334H11.433l4.8-4.8-1.866-1.9L6.333 18l8 8 1.9-1.9-4.8-4.767h14.9v-16h-2.666z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-return-right", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M17.667 26l-1.9-1.9 4.8-4.767h-14.9v-16h2.666v13.334h12.234l-4.8-4.8 1.866-1.9L25.667 18l-8 8z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-rotate", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M16.067 26.667c-2.978 0-5.511-1.034-7.6-3.1C6.377 21.5 5.333 18.977 5.333 16v-.233L3.2 17.9l-1.867-1.867L6.667 10.7 12 16.033 10.133 17.9 8 15.767V16c0 2.222.784 4.111 2.35 5.667C11.917 23.222 13.822 24 16.067 24c.578 0 1.144-.067 1.7-.2a7.62 7.62 0 001.633-.6l2 2a11 11 0 01-2.6 1.1c-.889.244-1.8.367-2.733.367zm9.267-5.367L20 15.967l1.867-1.867L24 16.233V16c0-2.222-.783-4.111-2.35-5.667C20.084 8.778 18.178 8 15.934 8a7.26 7.26 0 00-1.7.2 7.62 7.62 0 00-1.634.6l-2-2a11 11 0 012.6-1.1c.89-.245 1.8-.367 2.734-.367 2.977 0 5.51 1.034 7.6 3.1 2.088 2.067 3.133 4.59 3.133 7.567v.233L28.8 14.1l1.867 1.867-5.334 5.333z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-sbs", viewBox: "0 0 32 32" }, { children: jsx("path", { fillRule: "evenodd", d: "M11.394 2.915c.9.207 1.83.422 2.737.305.95-.123 1.816-.605 2.66-1.074l.356-.197a3.652 3.652 0 012.705-.323 3.657 3.657 0 012.373 1.993c.392.84.823 1.707 1.548 2.284.24.19.506.344.786.472l3.333-1.97L32 11.513l-3.557 2.1c.002.156.013.31.036.465.147 1 .755 1.877 1.341 2.701.611.86.849 1.975.554 3.074a3.657 3.657 0 01-2.016 2.384c-.92.421-1.885.875-2.512 1.669-.548.692-.794 1.586-1.007 2.442a3.654 3.654 0 01-1.724 2.29 3.655 3.655 0 01-2.876.34c-.826-.245-1.703-.473-2.556-.346-.916.137-1.723.672-2.482 1.204-.857.6-1.963.831-3.053.54a3.652 3.652 0 01-2.18-1.633 53.34 53.34 0 01-.21-.348c-.497-.83-1.006-1.68-1.767-2.26a4.525 4.525 0 00-.764-.465l-3.119 1.925L0 20.488l3.078-1.9a4.57 4.57 0 00-.014-.979c-.117-.895-.556-1.713-.986-2.514l-.15-.282a3.652 3.652 0 01-.302-2.665 3.652 3.652 0 011.593-2.156l.272-.17c.772-.478 1.562-.967 2.111-1.684.556-.727.834-1.642 1.102-2.526l.081-.267a3.652 3.652 0 011.67-2.098 3.652 3.652 0 012.64-.4l.299.068zM7 16.029c0 .145.004.29.012.433l2.023-1.167a6.999 6.999 0 019.845-5.676l2.023-1.167A8.958 8.958 0 0016 7a8.958 8.958 0 00-5.032 1.537A8.991 8.991 0 007 16v.029zm6.12 6.352l-2.023 1.167A8.96 8.96 0 0016 25a9 9 0 008.988-9.461l-2.023 1.166a7.003 7.003 0 01-9.845 5.676zm-8.128.99l23-13-.984-1.742-23 13 .984 1.742z", clipRule: "evenodd" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-score", viewBox: "0 0 32 33" }, { children: jsx("path", { d: "M16 23.865l-5.534 3.333a1.21 1.21 0 01-.766.2 1.289 1.289 0 01-.7-.267c-.2-.155-.356-.35-.467-.583a1.165 1.165 0 01-.066-.783l1.466-6.3-4.9-4.234a1.278 1.278 0 01-.366-1.433c.088-.245.222-.444.4-.6.177-.156.422-.256.733-.3l6.467-.567 2.5-5.933a1.19 1.19 0 01.516-.6c.234-.133.472-.2.717-.2.244 0 .483.067.716.2.234.133.406.333.517.6l2.5 5.933 6.467.567c.311.044.555.144.733.3.178.155.311.355.4.6a1.278 1.278 0 01-.367 1.433l-4.9 4.234 1.467 6.3c.067.288.045.55-.067.783a1.598 1.598 0 01-.466.583c-.2.156-.433.245-.7.267a1.21 1.21 0 01-.767-.2L16 23.865z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-search", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M26.133 28l-8.4-8.4a8.127 8.127 0 01-5.067 1.733c-2.422 0-4.472-.839-6.15-2.516C4.84 17.139 4 15.089 4 12.667c0-2.423.839-4.473 2.517-6.15C8.194 4.839 10.244 4 12.667 4c2.422 0 4.472.839 6.15 2.517 1.677 1.677 2.516 3.727 2.516 6.15a8.127 8.127 0 01-1.733 5.066l8.4 8.4L26.133 28zm-13.466-9.333c1.666 0 3.083-.584 4.25-1.75 1.166-1.167 1.75-2.584 1.75-4.25 0-1.667-.584-3.084-1.75-4.25-1.167-1.167-2.584-1.75-4.25-1.75-1.667 0-3.084.583-4.25 1.75-1.167 1.166-1.75 2.583-1.75 4.25 0 1.666.583 3.083 1.75 4.25 1.166 1.166 2.583 1.75 4.25 1.75z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-sell", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M5.333 27.111v1.778c0 .504-.17.926-.51 1.267a1.72 1.72 0 01-1.267.51H1.778a1.72 1.72 0 01-1.267-.51A1.72 1.72 0 010 28.889V14.667L3.733 4a2.52 2.52 0 01.956-1.289c.46-.326.97-.489 1.533-.489h19.556a2.58 2.58 0 011.533.49c.46.325.778.755.956 1.288L32 14.667v14.222c0 .504-.17.926-.511 1.267a1.72 1.72 0 01-1.267.51h-1.778a1.72 1.72 0 01-1.266-.51 1.72 1.72 0 01-.511-1.267v-1.778H5.333zm-.355-16h22.044l-1.866-5.333H6.844L4.978 11.11zM8 21.778c.74 0 1.37-.26 1.889-.778a2.572 2.572 0 00.778-1.889c0-.74-.26-1.37-.778-1.889A2.572 2.572 0 008 16.445c-.74 0-1.37.259-1.889.777a2.572 2.572 0 00-.778 1.89c0 .74.26 1.37.778 1.888A2.572 2.572 0 008 21.778zm16 0c.74 0 1.37-.26 1.889-.778a2.572 2.572 0 00.778-1.889c0-.74-.26-1.37-.778-1.889A2.572 2.572 0 0024 16.445c-.74 0-1.37.259-1.889.777a2.572 2.572 0 00-.778 1.89c0 .74.26 1.37.778 1.888a2.572 2.572 0 001.889.778z" }) })), jsxs("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-settings", viewBox: "0 0 32 32" }, { children: [jsx("g", __assign({ clipPath: "url(#dta)" }, { children: jsx("path", { d: "M11.622 32l-.637-5.12a6.02 6.02 0 01-.975-.48 13.13 13.13 0 01-.896-.6l-4.736 2L0 20.2l4.1-3.12a3.84 3.84 0 01-.04-.54v-1.08c0-.173.013-.353.04-.54L0 11.8l4.378-7.6 4.736 2c.292-.213.597-.413.916-.6a8 8 0 01.955-.48L11.622 0h8.756l.637 5.12c.345.133.67.293.975.48.305.187.604.387.896.6l4.736-2L32 11.8l-4.1 3.12c.027.187.04.367.04.54v1.08c0 .173-.026.353-.08.54l4.1 3.12-4.378 7.6-4.696-2a10.85 10.85 0 01-.916.6 7.99 7.99 0 01-.955.48L20.378 32h-8.756zm4.458-10.4c1.539 0 2.852-.547 3.94-1.64s1.632-2.413 1.632-3.96c0-1.547-.544-2.867-1.632-3.96-1.088-1.093-2.401-1.64-3.94-1.64-1.566 0-2.886.547-3.96 1.64-1.075 1.093-1.612 2.413-1.612 3.96 0 1.547.537 2.867 1.611 3.96 1.075 1.093 2.395 1.64 3.96 1.64z" }) })), jsx("defs", { children: jsx("clipPath", __assign({ id: "dta" }, { children: jsx("path", { fill: "#fff", d: "M0 0h32v32H0z" }) })) })] })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-sign-in", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M16 28v-2.667h9.333V6.667H16V4h9.333a2.57 2.57 0 011.884.783A2.57 2.57 0 0128 6.667v18.666a2.57 2.57 0 01-.783 1.884 2.568 2.568 0 01-1.884.783H16zm-2.667-5.333L11.5 20.733l3.4-3.4H4v-2.666h10.9l-3.4-3.4 1.833-1.934L20 16l-6.667 6.667z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-sign-out", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M6.667 28a2.568 2.568 0 01-1.884-.783A2.568 2.568 0 014 25.333V6.667c0-.734.261-1.361.783-1.884A2.568 2.568 0 016.667 4H16v2.667H6.667v18.666H16V28H6.667zm14.666-5.333L19.5 20.733l3.4-3.4H12v-2.666h10.9l-3.4-3.4 1.833-1.934L28 16l-6.667 6.667z" }) })), jsxs("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-sold", viewBox: "0 0 32 32" }, { children: [jsx("g", __assign({ clipPath: "url(#dua)" }, { children: jsx("path", { fillRule: "evenodd", d: "M32 16c0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0s16 7.163 16 16zM18 8.096V6h-4v2.18c-1.499.267-2.71.786-3.634 1.555-1.021.86-1.564 1.948-1.627 3.267-.044 1.32.413 2.362 1.372 3.127.968.765 2.46 1.292 4.477 1.58l.794.118c1.156.148 2.03.308 2.621.48.592.172.883.46.874.866-.027.375-.273.648-.74.82-.465.172-1.066.258-1.8.258-1.22-.008-2.309-.16-3.268-.457a14.34 14.34 0 01-2.73-1.136L8 21.995c.852.515 1.833.93 2.944 1.241.956.262 1.975.449 3.056.56V26h4v-2.213c2-.287 3.374-.789 4.413-1.64 1.031-.842 1.56-2.013 1.587-3.512-.009-1.171-.502-2.143-1.479-2.916-.986-.765-2.402-1.292-4.249-1.58l-.685-.106a33.897 33.897 0 01-2.636-.433c-.735-.164-1.111-.461-1.13-.89.028-.352.274-.61.74-.773.466-.164 1.072-.246 1.816-.246a11.43 11.43 0 012.836.363c.879.242 1.703.554 2.474.937l2.071-3.361a19.192 19.192 0 00-2.555-.96c-.87-.266-1.99-.488-3.203-.574z", clipRule: "evenodd" }) })), jsx("defs", { children: jsx("clipPath", __assign({ id: "dua" }, { children: jsx("path", { fill: "#fff", d: "M0 0h32v32H0z" }) })) })] })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-sort", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M9.333 22.667L11.2 20.8l3.466 3.433v-6.9h2.667v6.9L20.8 20.8l1.866 1.867L16 29.333l-6.667-6.666zm0-13.334L16 2.667l6.666 6.666L20.8 11.2l-3.467-3.433v6.9h-2.666v-6.9L11.2 11.2 9.333 9.333z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-spinner", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M16 30c-1.935 0-3.752-.366-5.45-1.1a14.15 14.15 0 01-4.45-3 14.153 14.153 0 01-3-4.45C2.365 19.753 2 17.937 2 16c0-1.938.366-3.754 1.099-5.448a14.277 14.277 0 013-4.45 14.052 14.052 0 014.45-3.005C12.246 2.366 14.064 2 16 2v4.065c-2.753 0-5.097.967-7.033 2.902-1.935 1.936-2.902 4.28-2.902 7.033s.967 5.097 2.902 7.032c1.936 1.936 4.28 2.904 7.033 2.904s5.097-.968 7.032-2.903c1.936-1.936 2.904-4.28 2.904-7.033H30c0 1.936-.366 3.753-1.099 5.452a14.171 14.171 0 01-3 4.451 14.118 14.118 0 01-4.445 3C19.76 29.634 17.942 30 16 30z" }) })), jsxs("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-stats", viewBox: "0 0 32 32" }, { children: [jsx("path", { d: "M17.333 14.667V2.8c3.178.333 5.861 1.6 8.05 3.8 2.189 2.2 3.461 4.889 3.817 8.067H17.333zm-2.633 14.5c-3.378-.334-6.206-1.756-8.484-4.267C3.94 22.39 2.8 19.422 2.8 16c0-3.444 1.139-6.422 3.416-8.933C8.494 4.556 11.322 3.133 14.7 2.8v26.367zm2.633 0V17.3H29.2c-.311 3.178-1.572 5.872-3.784 8.083-2.21 2.212-4.905 3.473-8.083 3.784z" }), jsx("circle", { cx: "8", cy: "22.548", r: "4.334", fill: "#fff" }), jsx("path", { fill: "var(--primary)", d: "M6.45 25.133l.584-1.9L5.5 22h1.9l.6-1.867L8.6 22h1.9l-1.55 1.233.584 1.9L8 23.95l-1.55 1.183zM4 31.333v-5.15c-.422-.466-.75-1-.983-1.6a5.241 5.241 0 01-.35-1.916c0-1.49.517-2.75 1.55-3.784C5.25 17.85 6.511 17.333 8 17.333c1.49 0 2.75.517 3.784 1.55 1.033 1.034 1.55 2.295 1.55 3.784 0 .677-.117 1.316-.35 1.916a5.14 5.14 0 01-.984 1.6v5.15L8 30l-4 1.333zm4-4.666c1.111 0 2.056-.39 2.834-1.167.777-.778 1.166-1.722 1.166-2.833 0-1.111-.389-2.056-1.166-2.834-.778-.777-1.723-1.166-2.834-1.166-1.11 0-2.055.389-2.833 1.166C4.389 20.611 4 21.556 4 22.667c0 1.11.39 2.055 1.167 2.833.778.778 1.722 1.167 2.833 1.167z" })] })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-stock", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M8 26.667l1.333-5.334H4l.667-2.666H10l1.333-5.334H6l.667-2.666H12l1.333-5.334H16l-1.333 5.334H20l1.333-5.334H24l-1.333 5.334H28l-.667 2.666H22l-1.333 5.334H26l-.667 2.666H20l-1.333 5.334H16l1.333-5.334H12l-1.333 5.334H8zm4.667-8H18l1.333-5.334H14l-1.333 5.334z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-stop", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M6 26V6h20v20H6z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-success", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M14.233 22.11l8.896-8.896-2.486-2.516-6.41 6.41-3.056-3.055-2.486 2.516 5.542 5.542zM16 29c-1.817 0-3.514-.34-5.092-1.02a13.097 13.097 0 01-4.116-2.772 13.096 13.096 0 01-2.771-4.116C3.34 19.515 3 17.817 3 16c0-1.817.34-3.514 1.02-5.092a13.096 13.096 0 012.772-4.116 13.096 13.096 0 014.116-2.771C12.486 3.34 14.183 3 16 3c1.817 0 3.515.34 5.092 1.02a13.12 13.12 0 014.116 2.772 13.097 13.097 0 012.771 4.116C28.66 12.486 29 14.183 29 16c0 1.817-.34 3.515-1.02 5.092a13.097 13.097 0 01-2.772 4.116 13.097 13.097 0 01-4.116 2.771C19.515 28.66 17.817 29 16 29z" }) })), jsxs("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-support", viewBox: "0 0 32 32" }, { children: [jsx("g", __assign({ clipPath: "url(#dwa)" }, { children: jsx("path", { d: "M16 32c-2.213 0-4.293-.42-6.24-1.26-1.947-.84-3.64-1.98-5.08-3.42s-2.58-3.133-3.42-5.08C.42 20.293 0 18.213 0 16s.42-4.293 1.26-6.24c.84-1.947 1.98-3.64 3.42-5.08S7.813 2.1 9.76 1.26C11.707.42 13.787 0 16 0s4.293.42 6.24 1.26c1.947.84 3.64 1.98 5.08 3.42s2.58 3.133 3.42 5.08C31.58 11.707 32 13.787 32 16s-.42 4.293-1.26 6.24c-.84 1.947-1.98 3.64-3.42 5.08s-3.133 2.58-5.08 3.42C20.293 31.58 18.213 32 16 32zm-4.64-4.08l1.92-4.4a7.483 7.483 0 01-2.9-1.86 9.075 9.075 0 01-1.9-2.94l-4.4 1.84a11.99 11.99 0 002.84 4.48c1.28 1.28 2.76 2.24 4.44 2.88zM8.48 13.28a9.075 9.075 0 011.9-2.94 7.483 7.483 0 012.9-1.86l-1.84-4.4c-1.707.64-3.2 1.6-4.48 2.88a12.438 12.438 0 00-2.88 4.48l4.4 1.84zM16 20.8c1.333 0 2.467-.467 3.4-1.4.933-.933 1.4-2.067 1.4-3.4 0-1.333-.467-2.467-1.4-3.4-.933-.933-2.067-1.4-3.4-1.4-1.333 0-2.467.467-3.4 1.4-.933.933-1.4 2.067-1.4 3.4 0 1.333.467 2.467 1.4 3.4.933.933 2.067 1.4 3.4 1.4zm4.64 7.12a12.448 12.448 0 004.42-2.86 12.448 12.448 0 002.86-4.42l-4.4-1.92a7.593 7.593 0 01-1.84 2.9 8.955 8.955 0 01-2.88 1.9l1.84 4.4zm2.88-14.72l4.4-1.84a12.447 12.447 0 00-2.86-4.42 12.448 12.448 0 00-4.42-2.86L18.8 8.56a7.586 7.586 0 012.84 1.82 9.005 9.005 0 011.88 2.82z" }) })), jsx("defs", { children: jsx("clipPath", __assign({ id: "dwa" }, { children: jsx("path", { fill: "#fff", d: "M0 0h32v32H0z" }) })) })] })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-switch", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M9.333 28l-6.667-6.667 6.667-6.666 1.9 1.866L7.766 20H28v2.667H7.767l3.466 3.466L9.333 28zm13.333-10.667l-1.9-1.866L24.233 12H4V9.333h20.233l-3.466-3.466L22.666 4l6.666 6.667-6.666 6.666z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-tag", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M20 29.533c-.511.511-1.145.767-1.9.767-.756 0-1.39-.256-1.9-.767L4.467 17.8a2.77 2.77 0 01-.584-.867 2.654 2.654 0 01-.216-1.066V6.333c0-.733.26-1.36.783-1.883a2.568 2.568 0 011.883-.783h9.534c.377 0 .733.072 1.066.216.334.145.622.34.867.584l11.733 11.766c.511.511.767 1.14.767 1.884s-.256 1.372-.767 1.883L20 29.533zM9.666 11.667a1.93 1.93 0 001.417-.584c.39-.389.583-.86.583-1.416 0-.556-.194-1.028-.583-1.417a1.929 1.929 0 00-1.417-.583c-.555 0-1.027.194-1.416.583a1.929 1.929 0 00-.583 1.417c0 .555.194 1.027.583 1.416.389.39.861.584 1.416.584z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-title", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M10.667 24h10.667v-2.667H10.667V24zm0-5.333h10.667V16H10.667v2.667zM8 29.333a2.568 2.568 0 01-1.883-.783 2.568 2.568 0 01-.784-1.883V5.333c0-.733.262-1.36.784-1.883A2.568 2.568 0 018 2.667h10.667l8 8v16c0 .733-.261 1.36-.784 1.883a2.568 2.568 0 01-1.883.783H8zM17.334 12H24l-6.666-6.667V12z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-transport", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M8 26.667c-1.11 0-2.055-.39-2.833-1.167C4.389 24.722 4 23.778 4 22.667H1.333V8c0-.733.262-1.361.784-1.883A2.568 2.568 0 014 5.333h18.667v5.334h4l4 5.333v6.667H28c0 1.11-.389 2.055-1.166 2.833-.778.778-1.723 1.167-2.834 1.167-1.11 0-2.055-.39-2.833-1.167-.778-.778-1.167-1.722-1.167-2.833h-8c0 1.11-.389 2.055-1.166 2.833-.778.778-1.723 1.167-2.834 1.167zM8 24c.378 0 .695-.128.95-.383a1.29 1.29 0 00.384-.95 1.29 1.29 0 00-.384-.95 1.29 1.29 0 00-.95-.384 1.29 1.29 0 00-.95.384 1.29 1.29 0 00-.383.95c0 .377.128.694.383.95.256.255.572.383.95.383zm16 0c.378 0 .695-.128.95-.383a1.29 1.29 0 00.384-.95 1.29 1.29 0 00-.384-.95 1.29 1.29 0 00-.95-.384 1.29 1.29 0 00-.95.384 1.29 1.29 0 00-.383.95c0 .377.128.694.383.95.256.255.572.383.95.383zm-1.333-6.667h5.666l-3-4h-2.666v4z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-trash", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M9.334 29a2.568 2.568 0 01-1.884-.783 2.568 2.568 0 01-.783-1.884V9H5.334V6.333H12V5h8v1.333h6.667V9h-1.334v17.333c0 .734-.26 1.361-.783 1.884a2.568 2.568 0 01-1.883.783H9.333zM12 23.667h2.667v-12H12v12zm5.334 0H20v-12h-2.666v12z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-unlock", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M14 23.667c.733 0 1.361-.261 1.883-.784.523-.522.784-1.15.784-1.883 0-.733-.261-1.361-.784-1.883A2.568 2.568 0 0014 18.333a2.57 2.57 0 00-1.883.784A2.568 2.568 0 0011.333 21c0 .733.262 1.361.784 1.883.522.523 1.15.784 1.883.784zm-8 6.666a2.568 2.568 0 01-1.883-.783 2.568 2.568 0 01-.784-1.883V14.333c0-.733.262-1.36.784-1.883A2.568 2.568 0 016 11.667h9.334V9c0-1.844.65-3.417 1.95-4.717 1.3-1.3 2.872-1.95 4.716-1.95 1.845 0 3.417.65 4.717 1.95 1.3 1.3 1.95 2.873 1.95 4.717H26c0-1.111-.389-2.056-1.166-2.833C24.056 5.389 23.11 5 22 5s-2.055.389-2.833 1.167C18.389 6.944 18 7.889 18 9v2.667h4c.733 0 1.361.26 1.884.783.522.522.783 1.15.783 1.883v13.334c0 .733-.261 1.36-.784 1.883a2.568 2.568 0 01-1.883.783H6z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-upload", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M14.666 21.333V10.467L11.2 13.933 9.333 12 16 5.333 22.666 12 20.8 13.933l-3.467-3.466v10.866h-2.667zM8 26.667a2.568 2.568 0 01-1.884-.784A2.568 2.568 0 015.333 24v-4H8v4h16v-4h2.666v4c0 .733-.26 1.361-.783 1.883a2.568 2.568 0 01-1.883.784H8z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-user", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M16 16c-1.466 0-2.722-.522-3.767-1.567-1.044-1.044-1.566-2.3-1.566-3.766 0-1.467.522-2.723 1.566-3.767 1.045-1.044 2.3-1.567 3.767-1.567s2.722.523 3.767 1.567c1.044 1.044 1.567 2.3 1.567 3.767 0 1.466-.523 2.722-1.567 3.766C18.722 15.478 17.467 16 16 16zM5.334 26.667v-3.734c0-.755.194-1.45.583-2.083a3.889 3.889 0 011.55-1.45 19.803 19.803 0 014.2-1.55A18.348 18.348 0 0116 17.333c1.467 0 2.911.173 4.334.517 1.422.345 2.822.861 4.2 1.55a3.89 3.89 0 011.55 1.45c.388.633.583 1.328.583 2.083v3.734H5.333z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-users", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M1.333 27.667v-3.734c0-.755.195-1.45.584-2.083a3.889 3.889 0 011.55-1.45 19.803 19.803 0 014.2-1.55A18.347 18.347 0 0112 18.333c1.467 0 2.911.173 4.334.517 1.422.345 2.822.861 4.2 1.55a3.89 3.89 0 011.55 1.45c.388.633.583 1.328.583 2.083v3.734H1.333zm24 0v-4c0-.978-.272-1.917-.816-2.817-.545-.9-1.317-1.672-2.317-2.317a16.688 16.688 0 016 1.867c.8.445 1.411.939 1.834 1.483.422.545.633 1.14.633 1.784v4h-5.334zM12 17c-1.466 0-2.722-.522-3.767-1.567-1.044-1.044-1.566-2.3-1.566-3.766 0-1.467.522-2.723 1.566-3.767 1.045-1.044 2.3-1.567 3.767-1.567s2.722.523 3.767 1.567c1.044 1.044 1.567 2.3 1.567 3.767 0 1.466-.523 2.722-1.567 3.766C14.722 16.478 13.467 17 12 17zm13.334-5.333c0 1.466-.523 2.722-1.567 3.766C22.722 16.478 21.467 17 20 17a6.74 6.74 0 01-.933-.083 8.165 8.165 0 01-.933-.184c.6-.71 1.06-1.5 1.383-2.366a7.685 7.685 0 00.483-2.7c0-.934-.16-1.834-.483-2.7A7.928 7.928 0 0018.134 6.6a4.08 4.08 0 01.933-.217c.31-.033.622-.05.933-.05 1.467 0 2.722.523 3.767 1.567 1.044 1.044 1.567 2.3 1.567 3.767z" }) })), jsxs("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-verified", viewBox: "0 0 16 17" }, { children: [jsx("mask", __assign({ id: "dka", style: { maskType: 'alpha' }, width: "16", height: "17", x: "0", y: "0", maskUnits: "userSpaceOnUse" }, { children: jsx("path", { fill: "#D9D9D9", d: "M0 .75h16v16H0z" }) })), jsx("g", __assign({ mask: "url(#dka)" }, { children: jsx("path", { d: "M7.3 10.083l3.3-3.3-.95-.933L7.3 8.2l-.95-.95-.95.95 1.9 1.883zM3.333 14.75V4.083c0-.366.13-.68.392-.941.261-.261.575-.392.942-.392h6.666c.367 0 .68.13.942.392.261.26.392.575.392.941V14.75L8 12.75l-4.667 2z" }) }))] })), jsxs("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-verified-inverted", viewBox: "0 0 16 16" }, { children: [jsx("mask", __assign({ id: "dja", style: { maskType: 'alpha' }, width: "16", height: "16", x: "0", y: "0", maskUnits: "userSpaceOnUse" }, { children: jsx("path", { fill: "#D9D9D9", d: "M0 0h16v16H0z" }) })), jsx("g", __assign({ mask: "url(#dja)" }, { children: jsx("path", { fill: "#fff", d: "M7.3 9.333l3.3-3.3-.95-.933L7.3 7.45l-.95-.95-.95.95 1.9 1.883zM3.333 14V3.333c0-.366.13-.68.392-.941A1.28 1.28 0 014.667 2h6.666c.367 0 .68.13.942.392.261.26.392.575.392.941V14L8 12l-4.667 2zm1.334-2.033L8 10.533l3.333 1.434V3.333H4.667v8.634z" }) }))] })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-view", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M16 22.333c1.667 0 3.084-.583 4.25-1.75C21.417 19.417 22 18 22 16.333c0-1.666-.583-3.083-1.75-4.25-1.166-1.166-2.583-1.75-4.25-1.75-1.666 0-3.083.584-4.25 1.75-1.166 1.167-1.75 2.584-1.75 4.25 0 1.667.584 3.084 1.75 4.25 1.167 1.167 2.584 1.75 4.25 1.75zm0-2.4c-1 0-1.85-.35-2.55-1.05-.7-.7-1.05-1.55-1.05-2.55 0-1 .35-1.85 1.05-2.55.7-.7 1.55-1.05 2.55-1.05 1 0 1.85.35 2.55 1.05.7.7 1.05 1.55 1.05 2.55 0 1-.35 1.85-1.05 2.55-.7.7-1.55 1.05-2.55 1.05zm0 6.4c-3.244 0-6.2-.905-8.867-2.716-2.666-1.811-4.6-4.24-5.8-7.284 1.2-3.044 3.134-5.472 5.8-7.283C9.8 7.239 12.756 6.333 16 6.333c3.245 0 6.2.906 8.867 2.717 2.666 1.811 4.6 4.239 5.8 7.283-1.2 3.045-3.134 5.473-5.8 7.284-2.667 1.81-5.622 2.716-8.867 2.716z" }) })), jsx("symbol", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "dsicon-warning", viewBox: "0 0 32 32" }, { children: jsx("path", { d: "M1.143 29L16 3l14.857 26H1.143zm14.887-4.14c.443 0 .82-.158 1.133-.474.312-.317.468-.7.468-1.15 0-.45-.156-.833-.468-1.15a1.531 1.531 0 00-1.133-.475c-.443 0-.82.158-1.132.475-.312.317-.468.7-.468 1.15 0 .45.156.833.468 1.15.312.316.69.475 1.132.475zm-1.6-4.384h3.2v-6.254h-3.2v6.254z" }) }))] })));
}

var calculateMargin = function (orientation, margin) {
    if (margin) {
        return "margin: ".concat(margin, ";");
    }
    else {
        return "margin: ".concat(orientation === 'vertical' ? '0 8px' : '8px 0', ";");
    }
};
var StyledLine = styled.div(templateObject_1$W || (templateObject_1$W = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var orientation = _a.orientation, margin = _a.margin, width = _a.width, height = _a.height, _b = _a.color, color = _b === void 0 ? 'grayLight' : _b, _c = _a.lineWidth, lineWidth = _c === void 0 ? 1 : _c;
    return "\n    border-color: ".concat(getBorderColor(color), ";\n    border-style: solid;\n    border-width: 0;\n    ").concat(orientation === 'horizontal'
        ? "\n        width: ".concat(getSizeValue(width), ";\n        border-top-width: ").concat(getSizeValue(lineWidth), ";\n    ")
        : "\n        height: ".concat(getSizeValue(height), ";\n        border-right-width: ").concat(getSizeValue(lineWidth), ";\n    "), "\n    ").concat(calculateMargin(orientation, margin), "\n");
});
var Line$1 = function (_a) {
    var className = _a.className, _b = _a.orientation, orientation = _b === void 0 ? 'horizontal' : _b, margin = _a.margin, width = _a.width, _c = _a.height, height = _c === void 0 ? 32 : _c, lineWidth = _a.lineWidth, color = _a.color;
    return (jsx(StyledLine, { role: "separator", className: className, orientation: orientation, margin: margin, width: width, height: height, color: color, lineWidth: lineWidth }));
};
var templateObject_1$W;

var AutocheckLogo = function (props) {
    var _a = props.height, height = _a === void 0 ? '40' : _a, _b = props.width, width = _b === void 0 ? '144' : _b, _c = props["aria-label"], ariaLabel = _c === void 0 ? 'Autocheck Logo' : _c, svgProps = __rest(props, ["height", "width", 'aria-label']);
    return (jsxs("svg", __assign({ width: width, height: height, viewBox: "0 0 144 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-label": ariaLabel }, svgProps, { children: [jsxs("g", __assign({ clipPath: "url(#clip0_1950_4204)" }, { children: [jsx("path", { d: "M94.7092 37.8873V33.2552L95.8071 33.2948V32.5209H94.7262V31.3911C94.7262 30.8657 94.8855 30.7019 95.3691 30.7019H95.7901V29.9393C95.5604 29.9034 95.3285 29.8846 95.096 29.8828C94.1062 29.8828 93.8046 30.1653 93.8046 31.0973V32.4757H92.7294V33.2552H93.7819V37.8873H94.7092Z", fill: "#757575" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M59.6655 29.9901H60.6326L64.1085 37.8986H63.0049L62.1288 35.9836H58.1466L57.2989 37.8873H56.1611L59.6655 29.9901ZM60.1491 31.4024L58.5619 35.0233H61.7249L60.1491 31.4024Z", fill: "#757575" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M68.4264 33.7467C68.7222 33.1027 69.1205 32.3684 70.2241 32.3684C71.4245 32.3684 72.2209 33.4982 72.2209 35.1589C72.2209 36.8197 71.4074 38.0286 70.1501 38.0286C69.1546 38.0286 68.7791 37.3394 68.4435 36.6502V40.0001H67.5162V32.4757H68.4321L68.4264 33.7467ZM70.7418 36.9327C71.0945 36.5825 71.2367 36.0345 71.2367 35.0911C71.2367 33.8088 70.793 33.1423 69.9453 33.1423C68.9953 33.1423 68.4207 33.9162 68.4207 35.2211C68.4207 36.526 68.9896 37.2829 69.9738 37.2829C70.1191 37.2794 70.2621 37.2465 70.3941 37.1863C70.5262 37.1261 70.6445 37.0398 70.7418 36.9327Z", fill: "#757575" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M75.2701 32.3231C73.5691 32.3231 73.2277 33.0801 73.0286 33.5602L73.791 33.9726C74.0413 33.3625 74.5077 33.1196 75.3099 33.1196C76.112 33.1196 76.3453 33.2834 76.3453 33.9387C76.0039 34.2889 75.9072 34.3228 75.1222 34.4075C74.4551 34.4125 73.8124 34.6574 73.3131 35.0967C73.0052 35.4195 72.8289 35.8442 72.8181 36.2886V36.3564C72.8181 36.8059 72.998 37.2369 73.318 37.5547C73.6381 37.8726 74.0722 38.0511 74.5248 38.0511C74.8934 38.0291 75.2516 37.9216 75.5708 37.7371C75.8899 37.5527 76.161 37.2965 76.3623 36.9891C76.3623 37.4862 76.4192 38.0511 77.136 38.0511C77.3308 38.038 77.5226 37.9961 77.7049 37.9268V37.3054C77.3067 37.2941 77.2726 37.2377 77.2726 36.5711V33.9217C77.2726 33.3851 77.2726 32.3231 75.2701 32.3231ZM75.2132 35.0741C75.6323 35.0524 76.0324 34.8935 76.351 34.6222V35.4808C76.388 35.7335 76.364 35.9913 76.2809 36.2329C76.1978 36.4745 76.058 36.6931 75.8731 36.8705C75.5922 37.1425 75.2185 37.2998 74.8263 37.3111H74.7296C74.6018 37.3053 74.4764 37.2745 74.3606 37.2205C74.2448 37.1666 74.1409 37.0904 74.0547 36.9965C73.9686 36.9026 73.902 36.7927 73.8587 36.6732C73.8154 36.5537 73.7962 36.4268 73.8023 36.2999C73.8022 36.0408 73.8996 35.791 74.0754 35.5995C74.3737 35.2872 74.7805 35.0994 75.2132 35.0741Z", fill: "#757575" }), jsx("path", { d: "M79.5823 33.5263L79.5886 33.515C79.8667 33.0134 80.2368 32.3457 81.0273 32.3457H81.4142V33.3286C81.2581 33.3021 81.1003 33.287 80.942 33.2834C80.7674 33.2781 80.5935 33.3072 80.4303 33.3688C80.2671 33.4305 80.1178 33.5236 79.9909 33.6428C79.864 33.7619 79.7621 33.9048 79.691 34.0632C79.6199 34.2216 79.5811 34.3924 79.5766 34.5657C79.5738 34.6052 79.5738 34.6448 79.5766 34.6843V37.8477H78.6266V32.4756H79.5539L79.5823 33.5263Z", fill: "#757575" }), jsx("path", { d: "M83.6954 32.47V30.3968L82.7681 31.069V32.4756H81.784V33.2213H82.7681V37.0456C82.7681 37.7574 83.0981 38.0342 83.9457 38.0342C84.2283 38.0241 84.5089 37.9824 84.782 37.9099V37.1473C84.5853 37.2017 84.383 37.2339 84.179 37.2433C83.8035 37.2433 83.6954 37.0626 83.6954 36.4977V33.2213H84.8332V32.47H83.6954Z", fill: "#757575" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M92.5645 35.125C92.5645 36.91 91.5519 38.0511 89.9931 38.0511C88.4343 38.0511 87.49 36.8648 87.49 35.1588C87.49 33.4529 88.5254 32.3344 90.0045 32.3344C91.4836 32.3344 92.5645 33.4868 92.5645 35.125ZM88.4628 35.2097C88.4628 36.5146 89.0317 37.2602 90.0841 37.2602C91.0228 37.2828 91.5917 36.4807 91.5917 35.1927C91.5917 33.7127 90.8976 33.1139 89.9931 33.1139C89.0886 33.1139 88.4571 33.8483 88.4571 35.2153L88.4628 35.2097Z", fill: "#757575" }), jsx("path", { d: "M98.5379 29.9901H104.05L103.749 31.4363H100.478V33.0801H103.499V34.5262H100.478V36.4412H103.84L104.136 37.8873H98.5379V29.9901Z", fill: "#757575" }), jsx("path", { d: "M106.559 32.4644H104.796L106.849 35.1024L104.676 37.8817H106.406L107.697 36.2266L108.988 37.8817H110.695L108.533 35.0911L110.541 32.4644H108.835L107.697 33.9614L106.559 32.4644Z", fill: "#757575" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M112.925 33.1592C113.113 32.8849 113.368 32.6634 113.667 32.5159C113.966 32.3685 114.298 32.3001 114.632 32.3175C116.031 32.3175 116.907 33.3569 116.907 35.0459C116.907 36.8988 116.048 38.0342 114.632 38.0342C114.298 38.0394 113.969 37.9639 113.672 37.8143C113.374 37.6647 113.118 37.4455 112.925 37.1756V40H111.344V32.4644H112.925V33.1592ZM112.925 36.3113C113.052 36.5226 113.229 36.7006 113.44 36.8303C113.651 36.9601 113.89 37.0378 114.137 37.0569C114.408 37.0527 114.668 36.9479 114.865 36.7632C115.138 36.4808 115.252 36.0288 115.252 35.1985C115.252 33.95 114.854 33.2948 114.114 33.2948C113.87 33.3003 113.632 33.3701 113.424 33.4972C113.216 33.6243 113.046 33.8039 112.931 34.0178L112.925 36.3113Z", fill: "#757575" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M119.018 35.6334H122.647L122.653 35.0798V34.8482C122.646 34.5085 122.571 34.1735 122.433 33.8624C122.295 33.5513 122.097 33.2702 121.85 33.0352C121.603 32.8002 121.311 32.6158 120.992 32.4927C120.673 32.3695 120.333 32.31 119.991 32.3175C118.381 32.3175 117.334 33.4473 117.334 35.142C117.334 36.2605 117.818 38.0455 120.036 38.0455C120.525 38.0814 121.014 37.9809 121.448 37.7553C121.883 37.5297 122.245 37.188 122.494 36.7689L121.413 36.1531C121.3 36.3937 121.123 36.5995 120.902 36.7486C120.68 36.8978 120.423 36.9848 120.156 37.0005C119.416 37.0005 119.063 36.5655 119.018 35.6334ZM121.049 34.6229L121.049 34.6505L119.018 34.6449C119.018 34.3511 119.035 33.323 120.059 33.323C121.053 33.323 121.05 34.2972 121.049 34.6229Z", fill: "#757575" }), jsx("path", { d: "M124.911 34.1533C125.315 32.8315 125.537 32.3005 126.618 32.3344V33.9782H126.282C125.968 33.9767 125.665 34.0987 125.44 34.3177C125.215 34.5366 125.087 34.8349 125.082 35.1475V37.9099H123.506V32.4643H124.94L124.911 34.1533Z", fill: "#757575" }), jsx("path", { d: "M129.076 32.4644H127.5V37.8817H129.076V32.4644Z", fill: "#757575" }), jsx("path", { d: "M129.076 29.9901H127.5V31.4476H129.076V29.9901Z", fill: "#757575" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M135.078 36.3338C135.07 36.3903 135.073 36.4478 135.088 36.5029C135.102 36.558 135.128 36.6097 135.163 36.6549C135.198 36.7001 135.241 36.738 135.291 36.7663C135.341 36.7946 135.396 36.8127 135.453 36.8197H135.51C135.584 36.8253 135.658 36.8253 135.732 36.8197V37.7913C135.412 37.9428 135.062 38.0182 134.708 38.0116C134.002 38.0116 133.684 37.7404 133.53 37.0117C133.374 37.3249 133.129 37.5864 132.826 37.7648C132.524 37.9432 132.175 38.0308 131.823 38.0172C131.61 38.035 131.394 38.0106 131.19 37.9454C130.986 37.8803 130.797 37.7756 130.633 37.6376C130.47 37.4995 130.336 37.3307 130.238 37.1409C130.141 36.951 130.082 36.744 130.066 36.5316C130.06 36.462 130.06 36.3921 130.066 36.3226C130.066 34.7308 131.628 34.5748 132.318 34.5059L132.341 34.5036C132.758 34.5016 133.171 34.4151 133.553 34.2494V34.0404C133.553 33.5263 133.234 33.2439 132.648 33.2439C132.411 33.2336 132.177 33.2972 131.978 33.4259C131.779 33.5545 131.625 33.7417 131.539 33.9613L130.339 33.3964L130.344 33.3862C130.522 33.0212 130.873 32.3005 132.614 32.3005C134.048 32.3005 135.06 32.4869 135.06 33.9952L135.078 36.3338ZM133.49 34.916C133.26 35.0534 133.005 35.1454 132.739 35.1871C131.937 35.3622 131.659 35.6334 131.659 36.2265C131.65 36.3174 131.659 36.4091 131.686 36.4963C131.714 36.5835 131.758 36.6646 131.816 36.7349C131.875 36.8052 131.947 36.8633 132.028 36.906C132.11 36.9486 132.198 36.975 132.29 36.9835H132.398C132.683 36.9865 132.957 36.8779 133.162 36.6811C133.366 36.4844 133.484 36.2155 133.49 35.9328V34.916Z", fill: "#757575" }), jsx("path", { d: "M138.87 32.5899C138.561 32.7651 138.306 33.0205 138.133 33.3286L138.121 32.4643H136.534V37.8873H138.133V34.5827C138.117 34.2668 138.228 33.9577 138.441 33.7228C138.654 33.4878 138.952 33.3461 139.27 33.3286C139.919 33.3286 140.141 33.7127 140.141 34.8086V37.8986H141.728V34.5092C141.728 33.5037 141.626 33.1987 141.239 32.8145C141.059 32.6463 140.845 32.5168 140.612 32.4342C140.379 32.3516 140.132 32.3176 139.885 32.3344C139.529 32.3264 139.178 32.4148 138.87 32.5899Z", fill: "#757575" }), jsx("path", { d: "M24.7354 2.89225C26.4876 0.960316 30.4243 0 33.0469 0L33.3882 0.773902L28.8712 6.08389L18.7734 19.3419L11.776 30.0749L10.0694 32.9727C9.86664 33.5163 9.51612 33.9934 9.05675 34.3511C8.42528 34.6392 6.96892 34.6392 6.28625 34.6392C4.73317 34.6392 4.39184 34.6392 4.0505 34.3963C3.65535 34.1225 3.42349 33.6314 3.16907 33.0924C3.10849 32.9641 3.04663 32.8331 2.98099 32.7016C1.89441 30.5042 0 25.663 0 23.251C0 22.4319 0.483557 22.0477 1.13778 21.6128C2.1561 20.901 3.61815 20.0706 4.88109 20.0706C5.70451 20.0706 5.90024 20.6575 6.11689 21.307C6.15619 21.4249 6.19618 21.5448 6.24074 21.6636L7.21354 23.9232C7.22959 23.9649 7.24886 24.0179 7.27118 24.0794C7.45457 24.5844 7.84417 25.6574 8.35132 25.6574C8.8268 25.6574 9.2546 24.8682 9.49519 24.4243C9.54246 24.3371 9.5825 24.2632 9.61426 24.2113L20.8385 7.65994L24.7354 2.89225Z", fill: "#134C8C" }), jsx("path", { d: "M92.2115 26.7645L95.568 10.9476H99.4364L98.0768 17.3873H98.1223C98.558 16.7887 99.1348 16.3053 99.8023 15.9793C100.47 15.6534 101.207 15.4948 101.951 15.5175C102.426 15.4931 102.9 15.5766 103.338 15.7616C103.776 15.9466 104.165 16.2283 104.477 16.5852C105.108 17.3548 105.434 18.3274 105.393 19.3193C105.365 20.1005 105.266 20.8776 105.097 21.641L104.107 26.7702H100.125L101.177 21.624C101.309 21.0671 101.395 20.5003 101.433 19.9294C101.433 19.0764 100.938 18.6527 99.9485 18.664C98.475 18.664 97.5307 19.6977 97.104 21.6749L96.0231 26.7589L92.2115 26.7645Z", fill: "#134C8C" }), jsx("path", { d: "M92.5869 15.5741L93.5199 12.5576C91.8378 11.9984 90.0709 11.7327 88.2975 11.7724C85.5327 11.7724 83.3216 12.5557 81.6642 14.1223C80.8509 14.899 80.2117 15.8373 79.7883 16.8758C79.3648 17.9144 79.1666 19.03 79.2066 20.1497C79.1635 21.0652 79.3178 21.9793 79.6592 22.8307C80.0006 23.6822 80.5213 24.4514 81.1864 25.0869C82.5365 26.3673 84.3854 27.0075 86.733 27.0075C88.0825 27.0351 89.4276 26.8444 90.7153 26.4426L91.1419 23.2792C89.9678 23.8451 88.675 24.1258 87.3702 24.0983C86.3132 24.1607 85.2718 23.8214 84.4575 23.1493C84.0648 22.7815 83.7591 22.3319 83.5624 21.8328C83.3656 21.3337 83.2827 20.7974 83.3197 20.2627C83.2678 18.87 83.7289 17.5064 84.6168 16.4271C85.6028 15.2747 87.027 14.6985 88.8891 14.6985C90.1775 14.6654 91.4522 14.9673 92.5869 15.5741Z", fill: "#134C8C" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22.7158 26.7646L31.5393 12.0322H36.5285L38.952 26.7646H34.9697L34.5374 23.6181H28.7745L27.011 26.7589L22.7158 26.7646ZM34.1335 20.8275L33.5134 15.0769H33.4679L30.3276 20.8275H34.1335Z", fill: "#134C8C" }), jsx("path", { d: "M54.1015 15.7661L52.3948 23.8893C52.1843 24.9005 52.025 25.8608 51.9283 26.7589H48.3557L48.6515 24.9626H48.6117C48.0971 25.5886 47.4515 26.0958 46.7196 26.4489C45.9876 26.802 45.1871 26.9927 44.3735 27.0075C43.8918 27.0294 43.4115 26.9422 42.9689 26.7523C42.5263 26.5624 42.1331 26.2749 41.8191 25.9116C41.199 25.1502 40.8813 24.1896 40.926 23.2114C40.9447 22.4349 41.0342 21.6616 41.1934 20.901L42.2174 15.7774H46.1996L45.1358 20.901C45.0037 21.458 44.9181 22.0248 44.8798 22.5957C44.8798 23.4543 45.3747 23.878 46.3703 23.8611C47.8418 23.8309 48.7899 22.8254 49.2147 20.8445L50.3013 15.7605L54.1015 15.7661Z", fill: "#134C8C" }), jsx("path", { d: "M55.7969 15.7661L55.3304 18.4381L57.3841 18.4155L56.7298 21.4942C56.5478 22.2356 56.4336 22.9919 56.3885 23.7537C56.3562 24.2177 56.4311 24.6828 56.6076 25.1136C56.7841 25.5444 57.0575 25.9294 57.4068 26.2392C58.1182 26.7775 58.9998 27.046 59.8929 26.9962C60.6898 26.9888 61.485 26.9189 62.2708 26.7872L62.6975 24.2791C62.2841 24.4422 61.8492 24.5449 61.4061 24.5841C61.3023 24.5984 61.197 24.5984 61.0932 24.5841C60.8065 24.5394 60.5479 24.3875 60.3702 24.1597C60.1926 23.9318 60.1093 23.6451 60.1375 23.3583C60.1942 22.7199 60.3027 22.087 60.4618 21.4659L61.1501 18.4437H63.9547L64.4269 15.7718H61.8157L62.578 12.3147L58.5162 13.3936L57.9871 15.7661H55.7969Z", fill: "#134C8C" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M77.2668 20.4321C77.2668 22.6314 76.5936 24.2979 75.2473 25.4314C74.0109 26.4896 72.3042 27.0169 70.1272 27.0131C68.1873 27.0131 66.7139 26.5216 65.7013 25.5387C65.2452 25.0713 64.8911 24.5156 64.6611 23.9061C64.4311 23.2967 64.3301 22.6468 64.3644 21.9969C64.3295 21.1204 64.4863 20.2469 64.8242 19.4365C65.162 18.6261 65.6728 17.8981 66.3214 17.3026C67.756 16.0685 69.6136 15.4294 71.5097 15.5175C73.0697 15.4321 74.6044 15.9367 75.8048 16.9298C76.2894 17.3736 76.6711 17.9166 76.9236 18.5213C77.176 19.1261 77.2931 19.778 77.2668 20.4321ZM73.2846 20.3926C73.2846 18.9238 72.619 18.1876 71.2878 18.1838C70.8512 18.1866 70.4222 18.2976 70.0397 18.5068C69.6572 18.7159 69.3334 19.0165 69.0976 19.3814C68.5665 20.1224 68.2911 21.0142 68.3125 21.9234C68.2798 22.5635 68.4819 23.1937 68.8814 23.6972C69.0675 23.9145 69.301 24.0869 69.5642 24.2015C69.8273 24.316 70.1132 24.3695 70.4003 24.3581C70.8149 24.3717 71.2263 24.2828 71.5977 24.0994C71.9691 23.916 72.2888 23.6439 72.528 23.3074C73.1005 22.4458 73.376 21.4229 73.313 20.3926H73.2846Z", fill: "#134C8C" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M116.469 26.4031L116.958 23.7255C115.869 24.2472 114.675 24.5157 113.465 24.5107C111.535 24.5145 110.541 23.8121 110.484 22.4037H118.358C118.524 21.7263 118.618 21.0332 118.637 20.3362C118.687 19.6547 118.581 18.9707 118.327 18.3357C118.073 17.7006 117.677 17.1312 117.169 16.67C116.138 15.8627 114.844 15.4605 113.534 15.5402C112.555 15.4887 111.577 15.6664 110.68 16.0589C109.782 16.4513 108.991 17.0477 108.368 17.7998C107.402 18.9864 106.882 20.4709 106.9 21.997C106.878 22.6569 106.997 23.3141 107.25 23.9247C107.503 24.5354 107.884 25.0856 108.368 25.5388C109.527 26.5672 111.049 27.0974 112.601 27.0132C113.913 26.9976 115.216 26.7921 116.469 26.4031ZM115.445 20.2006H110.746C110.883 19.6356 111.195 19.1276 111.639 18.7488C112.176 18.2898 112.865 18.0461 113.573 18.0653C114.821 18.0653 115.445 18.7771 115.445 20.2006Z", fill: "#134C8C" }), jsx("path", { d: "M128.945 23.7255L128.376 26.5499C127.313 26.8599 126.207 27.0028 125.099 26.9736C124.398 27.0026 123.699 26.8882 123.044 26.6375C122.389 26.3868 121.793 26.0051 121.293 25.5162C120.829 25.0515 120.465 24.4978 120.224 23.8889C119.982 23.2799 119.868 22.6285 119.888 21.9743C119.871 21.1136 120.038 20.2592 120.378 19.4674C120.719 18.6757 121.224 17.9648 121.862 17.3817C123.256 16.1159 125.095 15.4444 126.982 15.5119C128.2 15.5187 129.404 15.7704 130.521 16.2519L129.707 18.9069C128.934 18.5458 128.092 18.3532 127.238 18.3421C126.794 18.3227 126.35 18.3928 125.934 18.5481C125.517 18.7034 125.137 18.9408 124.815 19.2459C124.486 19.5978 124.233 20.0117 124.068 20.4629C123.904 20.9142 123.833 21.3935 123.859 21.8726C123.853 22.1896 123.914 22.5043 124.039 22.7963C124.163 23.0883 124.348 23.351 124.582 23.5673C125.102 24.0376 125.79 24.2834 126.493 24.2508C127.337 24.2334 128.169 24.055 128.945 23.7255Z", fill: "#134C8C" }), jsx("path", { d: "M133.394 10.9476L129.98 26.7646H133.872L135.009 21.319H135.049L137.325 26.7646H141.574L138.73 21.0648L143.281 15.7661H138.929L135.271 20.3869H135.231L137.262 10.9476H133.394Z", fill: "#134C8C" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M142.428 13.6252H142.649L142.644 13.2467H142.746C142.871 13.2467 142.945 13.2919 142.945 13.3936C142.958 13.4705 142.983 13.5449 143.019 13.6139H143.258C143.219 13.5424 143.196 13.4634 143.19 13.3823C143.161 13.258 143.11 13.1563 143.019 13.1563C143.072 13.1451 143.12 13.1169 143.155 13.076C143.19 13.0352 143.21 12.9839 143.213 12.9303C143.212 12.8929 143.204 12.8561 143.188 12.822C143.172 12.788 143.15 12.7576 143.122 12.7326C143.022 12.6755 142.907 12.6499 142.792 12.6592C142.67 12.6593 142.548 12.6706 142.428 12.6931V13.6252ZM142.752 13.0998H142.649L142.644 12.823H142.763C142.905 12.823 142.968 12.8682 142.968 12.9642C142.968 13.0603 142.871 13.0998 142.752 13.0998Z", fill: "#134C8C" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M143.481 12.4953C143.299 12.3109 143.051 12.2054 142.792 12.2016H142.763C142.503 12.2054 142.256 12.3109 142.074 12.4953C141.892 12.6797 141.791 12.9279 141.793 13.1859C141.795 13.4438 141.9 13.6906 142.084 13.8723C142.268 14.0541 142.518 14.1561 142.777 14.1561C143.037 14.1561 143.286 14.0541 143.471 13.8723C143.655 13.6906 143.76 13.4438 143.762 13.1859C143.763 12.9279 143.663 12.6797 143.481 12.4953ZM142.3 12.6288C142.427 12.4902 142.603 12.4043 142.792 12.3881C142.89 12.3901 142.987 12.4119 143.076 12.4521C143.165 12.4922 143.246 12.5499 143.312 12.6216C143.379 12.6934 143.43 12.7778 143.462 12.8696C143.495 12.9615 143.509 13.059 143.503 13.1563C143.504 13.2505 143.487 13.3441 143.452 13.4317C143.417 13.5193 143.365 13.5993 143.299 13.6669C143.233 13.7346 143.154 13.7887 143.067 13.8261C142.98 13.8635 142.887 13.8835 142.792 13.885C142.603 13.8687 142.427 13.7828 142.3 13.6443C142.172 13.5057 142.101 13.3245 142.101 13.1365C142.101 12.9485 142.172 12.7674 142.3 12.6288Z", fill: "#134C8C" })] })), jsx("defs", { children: jsx("clipPath", __assign({ id: "clip0_1950_4204" }, { children: jsx("rect", { width: "143.673", height: "40", fill: "white" }) })) })] })));
};

var Logo$a = function (props) {
    var _a = props.height, height = _a === void 0 ? '48' : _a, _b = props.width, width = _b === void 0 ? '38' : _b, color = props.color, ariaLabel = props.ariaLabel, svgProps = __rest(props, ["height", "width", "color", "ariaLabel"]);
    return (jsx("svg", __assign({ width: width, height: height, viewBox: "0 0 38 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-label": ariaLabel }, svgProps, { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.0486 15.8397C17.3821 15.8397 18.3922 16.3853 18.3922 17.7193C18.3922 19.0538 17.3821 19.5994 16.0486 19.5994H13.4622V15.8397H16.0486ZM17.665 11.7967C17.665 13.03 16.8972 13.5352 15.5433 13.5352H13.4619V10.0587H15.5433C16.7352 10.0587 17.665 10.5643 17.665 11.7967ZM25.2346 30.1385C25.2346 31.3717 24.4668 31.8774 23.1133 31.8774H21.0315V28.4004H23.1133C24.3053 28.4004 25.2346 28.9061 25.2346 30.1385ZM23.6181 34.1815C24.9516 34.1815 25.9622 34.7276 25.9622 36.0611C25.9622 37.3956 24.9516 37.9412 23.6181 37.9412H21.0317V34.1815H23.6181ZM23.6988 40.2456C26.3659 40.2456 28.4273 38.5479 28.4273 36.0609C28.4273 33.5145 26.4267 32.7874 26.2244 32.7465C26.4267 32.6857 27.6995 31.8573 27.6995 30.1383C27.6995 27.1675 25.4975 26.0963 23.1938 26.0963H18.6068V40.2456H23.6988ZM11.0376 21.9037H16.1291C18.7962 21.9037 20.8576 20.2057 20.8576 17.7191C20.8576 15.1727 18.857 14.4456 18.6551 14.4047C18.857 14.3439 20.1302 13.515 20.1302 11.7965C20.1302 8.82567 17.9273 7.75444 15.6241 7.75444H11.0376V21.9037ZM26.0002 0L37.8031 48H11.9446L0.141602 0H26.0002Z", fill: color }) })));
};

var Logo$9 = function (props) {
    var _a = props.height, height = _a === void 0 ? '48' : _a, _b = props.width, width = _b === void 0 ? '92' : _b, color = props.color, ariaLabel = props.ariaLabel, svgProps = __rest(props, ["height", "width", "color", "ariaLabel"]);
    return (jsx("svg", __assign({ width: width, height: height, viewBox: "0 0 92 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-label": ariaLabel }, svgProps, { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M54.3446 28.8C56.3373 28.8 57.6235 30.4825 57.6235 32.4921C57.6235 34.5026 56.3373 36.1846 54.3446 36.1846C52.3518 36.1846 51.0656 34.5026 51.0656 32.4921C51.0656 30.4825 52.3518 28.8 54.3446 28.8ZM26.2914 29.9077C26.2914 30.6931 25.7591 31.0154 24.8201 31.0154H23.3768V28.8H24.8201C25.6468 28.8 26.2914 29.1223 26.2914 29.9077ZM25.288 33.2308C26.2736 33.2308 27.0201 33.6598 27.0201 34.7075C27.0201 35.7556 26.2736 36.1846 25.288 36.1846H23.3768V33.2308H25.288ZM41.5931 16.9846L43.0504 13.2923L44.5077 16.9846H41.5931ZM19.7335 13.6612C19.7335 14.447 19.2012 14.7692 18.2623 14.7692H16.8189V12.5538H18.2623C19.089 12.5538 19.7335 12.8761 19.7335 13.6612ZM39.0428 28.8C41.0356 28.8 42.3218 30.4825 42.3218 32.4921C42.3218 34.5026 41.0356 36.1846 39.0428 36.1846C37.0501 36.1846 35.7639 34.5026 35.7639 32.4921C35.7639 30.4825 37.0501 28.8 39.0428 28.8ZM72.4087 20.9H74.7301L70.233 15.6316L74.2341 10.5411H72.0433L68.3931 15.1879V10.5411H66.641V20.9H68.3931V16.2237L72.4087 20.9ZM70.3662 37.478H72.688L68.1904 32.2095L72.192 27.1183H70.0012L66.3505 31.7654V27.1183H64.5984V37.478H66.3505V32.8013L70.3662 37.478ZM57.5048 21.0775C60.0893 21.0775 61.4327 19.317 61.4327 19.317L60.2645 18.1474C60.2645 18.1474 59.3011 19.4204 57.5048 19.4204C55.4897 19.4204 54.1026 17.7185 54.1026 15.7206C54.1026 13.7226 55.4897 12.0207 57.5048 12.0207C59.1841 12.0207 60.1038 13.1604 60.1038 13.1604L61.287 11.9912C61.287 11.9912 59.9582 10.3627 57.5048 10.3627C54.555 10.3627 52.321 12.6572 52.321 15.7206C52.321 18.7835 54.555 21.0775 57.5048 21.0775ZM54.304 37.6555C57.2825 37.6555 59.4733 35.3615 59.4733 32.2981C59.4733 29.2348 57.2825 26.9407 54.304 26.9407C51.325 26.9407 49.1347 29.2348 49.1347 32.2981C49.1347 35.3615 51.325 37.6555 54.304 37.6555ZM46.2225 20.9H47.9892L44.0172 10.5411H42.2355L38.264 20.9H40.0306L40.9654 18.4435H45.2878L46.2225 20.9ZM38.8402 37.6555C41.8187 37.6555 44.0095 35.3615 44.0095 32.2981C44.0095 29.2348 41.8187 26.9407 38.8402 26.9407C35.8616 26.9407 33.6713 29.2348 33.6713 32.2981C33.6713 35.3615 35.8616 37.6555 38.8402 37.6555ZM27.3188 20.9H33.4228L33.9647 19.2129H29.0709V10.5411H27.3188V20.9ZM25.1289 37.478C27.0566 37.478 28.5461 36.2346 28.5461 34.4142C28.5461 32.5495 27.1003 32.0168 26.9547 31.9873C27.1003 31.943 28.0205 31.336 28.0205 30.0783C28.0205 27.9028 26.429 27.1183 24.7639 27.1183H21.4491V37.478H25.1289ZM15.2255 20.9H18.9049C20.8326 20.9 22.3221 19.657 22.3221 17.8362C22.3221 15.9719 20.8763 15.4397 20.7303 15.4097C20.8763 15.3654 21.7965 14.7585 21.7965 13.5003C21.7965 11.3252 20.2046 10.5411 18.5399 10.5411H15.2255V20.9ZM79.4676 0L91.1415 48H12.462L0.788574 0H79.4676ZM18.7301 16.2462C19.7158 16.2462 20.4622 16.6748 20.4622 17.7226C20.4622 18.7714 19.7158 19.2 18.7301 19.2H16.8189V16.2462H18.7301Z", fill: color }) })));
};

var Logo$8 = function (props) {
    var _a = props.height, height = _a === void 0 ? '48' : _a, _b = props.width, width = _b === void 0 ? '173' : _b, color = props.color, ariaLabel = props.ariaLabel, svgProps = __rest(props, ["height", "width", "color", "ariaLabel"]);
    return (jsxs("svg", __assign({ width: width, height: height, viewBox: "0 0 173 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-label": ariaLabel }, svgProps, { children: [jsx("path", { d: "M31.2906 4.35918L29.9831 1.00255H29.1602L31.2939 6.34649L32.6404 2.78495L33.9317 6.34324L36.1759 1.00255H35.353L33.9642 4.35918L32.6567 0.758606L31.2906 4.35918Z", fill: color }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22.4157 3.49075C22.4157 2.78386 22.6748 2.17672 23.1931 1.66932C23.7091 1.16192 24.3293 0.908223 25.0535 0.908223C25.7691 0.908223 26.3827 1.16409 26.8945 1.67583C27.4084 2.18756 27.6653 2.80229 27.6653 3.52002C27.6653 4.24209 27.4073 4.85465 26.8912 5.35771C26.373 5.86294 25.7474 6.11556 25.0145 6.11556C24.3661 6.11556 23.7839 5.89113 23.2679 5.44228C22.6998 4.94572 22.4157 4.29521 22.4157 3.49075ZM23.18 3.50051C23.18 4.05561 23.3665 4.51205 23.7395 4.86983C24.1103 5.22761 24.5385 5.4065 25.0242 5.4065C25.5512 5.4065 25.9957 5.22436 26.3578 4.86007C26.7199 4.49145 26.901 4.0426 26.901 3.51352C26.901 2.97793 26.7221 2.52908 26.3643 2.16696C26.0087 1.80267 25.5685 1.62053 25.0438 1.62053C24.5212 1.62053 24.0799 1.80267 23.72 2.16696C23.36 2.52691 23.18 2.97142 23.18 3.50051Z", fill: color }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.4944 3.98514V6.02449H17.7366V1.00255H18.5952C19.0159 1.00255 19.3336 1.03182 19.5482 1.09037C19.7651 1.14891 19.9559 1.2595 20.1207 1.42213C20.4091 1.70401 20.5533 2.05963 20.5533 2.48896C20.5533 2.94866 20.3993 3.31294 20.0914 3.58182C19.7835 3.8507 19.3683 3.98514 18.8457 3.98514H18.4944ZM18.4944 3.28259H18.7774C19.4734 3.28259 19.8215 3.01479 19.8215 2.47921C19.8215 1.96097 19.4626 1.70185 18.7449 1.70185H18.4944V3.28259Z", fill: color }), jsx("path", { d: "M40.9039 1.71486H38.8905V2.92155H40.8453V3.63386H38.8905V5.31218H40.9039V6.02449H38.1327V1.00255H40.9039V1.71486Z", fill: color }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M46.844 6.02449L45.2893 3.88431C45.6232 3.81275 45.8921 3.64904 46.096 3.39317C46.2998 3.1373 46.4017 2.83157 46.4017 2.47595C46.4017 2.0206 46.2391 1.65414 45.9138 1.37659C45.6189 1.12723 45.1397 1.00255 44.4762 1.00255H43.5882V6.02449H44.3461V3.96887H44.4827L45.9171 6.02449H46.844ZM44.5868 3.30861H44.3461V1.71486H44.616C45.3143 1.71486 45.6634 1.97181 45.6634 2.48571C45.6634 3.03431 45.3045 3.30861 44.5868 3.30861Z", fill: color }), jsx("path", { d: "M51.742 1.71486H49.7287V2.92155H51.6834V3.63386H49.7287V5.31218H51.742V6.02449H48.9708V1.00255H51.742V1.71486Z", fill: color }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M55.2448 1.00255H54.191V6.02449H55.2318C55.7414 6.02449 56.1349 5.97787 56.4125 5.88463C56.7095 5.79139 56.9936 5.62551 57.2646 5.38699C57.8046 4.90995 58.0745 4.28546 58.0745 3.51352C58.0745 2.74375 57.8154 2.12251 57.2972 1.64981C57.0413 1.41562 56.7562 1.24974 56.4417 1.15216C56.149 1.05242 55.75 1.00255 55.2448 1.00255ZM55.2903 5.31218H54.9488V1.71486H55.2903C55.9365 1.71486 56.4255 1.86773 56.7572 2.17347C57.1259 2.51607 57.3102 2.96275 57.3102 3.51352C57.3102 4.05995 57.1237 4.50338 56.7507 4.84381C56.5686 5.00861 56.3648 5.12895 56.1393 5.20484C55.9137 5.2764 55.6308 5.31218 55.2903 5.31218Z", fill: color }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M64.2155 1.00255H64.97C65.3062 1.00255 65.5739 1.02857 65.7734 1.08061C65.9751 1.13265 66.1453 1.22047 66.2841 1.34407C66.425 1.472 66.5367 1.63137 66.6191 1.82219C66.7037 2.01517 66.7459 2.21033 66.7459 2.40765C66.7459 2.7676 66.6082 3.07225 66.3329 3.32162C66.5996 3.41269 66.8099 3.57206 66.9639 3.79974C67.12 4.02525 67.198 4.28762 67.198 4.58686C67.198 4.97933 67.0593 5.31109 66.7817 5.58214C66.6148 5.7491 66.4272 5.86511 66.219 5.93016C65.9913 5.99304 65.7062 6.02449 65.3636 6.02449H64.2155V1.00255ZM64.9733 3.15899H65.2107C65.4926 3.15899 65.6986 3.09719 65.8287 2.97359C65.961 2.84783 66.0271 2.66352 66.0271 2.42066C66.0271 2.18431 65.9599 2.00542 65.8255 1.88399C65.691 1.76039 65.4959 1.69859 65.24 1.69859H64.9733V3.15899ZM64.9733 5.31218H65.4417C65.7843 5.31218 66.0358 5.24496 66.1963 5.11052C66.3654 4.96524 66.45 4.78093 66.45 4.55759C66.45 4.34075 66.3686 4.15861 66.206 4.01116C66.0477 3.86588 65.7647 3.79324 65.3571 3.79324H64.9733V5.31218Z", fill: color }), jsx("path", { d: "M68.8848 1.00255L70.5241 3.85503V6.02449H71.282V3.85503L72.9278 1.00255H72.0561L70.9047 3.00937L69.7565 1.00255H68.8848Z", fill: color }), jsx("path", { d: "M47.6015 31.3227L49.2623 27.1031L50.9232 31.3227H47.6015Z", fill: color }), jsx("path", { d: "M22.6889 27.5247C22.6889 28.4227 22.0821 28.791 21.0121 28.791H19.3672V26.2593H21.0121C21.9542 26.2593 22.6889 26.6275 22.6889 27.5247Z", fill: color }), jsx("path", { d: "M21.5453 30.4788C22.6686 30.4788 23.5193 30.9687 23.5193 32.1661C23.5193 33.3647 22.6686 33.8545 21.5453 33.8545H19.3672V30.4788H21.5453Z", fill: color }), jsx("path", { d: "M136.742 25.8799C139.013 25.8799 140.479 27.8026 140.479 30.0992C140.479 32.3968 139.013 34.319 136.742 34.319C134.471 34.319 133.005 32.3968 133.005 30.0992C133.005 27.8026 134.471 25.8799 136.742 25.8799Z", fill: color }), jsx("path", { d: "M123.04 30.0992C123.04 27.8026 121.574 25.8799 119.303 25.8799C117.032 25.8799 115.567 27.8026 115.567 30.0992C115.567 32.3968 117.032 34.319 119.303 34.319C121.574 34.319 123.04 32.3968 123.04 30.0992Z", fill: color }), jsx("path", { d: "M105.601 32.6308C105.601 31.4336 104.751 30.9433 103.627 30.9433H101.449V34.3189H103.627C104.751 34.3189 105.601 33.8286 105.601 32.6308Z", fill: color }), jsx("path", { d: "M104.771 27.1457C104.771 28.0433 104.164 28.4116 103.094 28.4116H101.449V25.8798H103.094C104.036 25.8798 104.771 26.2481 104.771 27.1457Z", fill: color }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M172.404 48H9.61955L0.803223 11.7551H163.587L172.404 48ZM85.3667 35.7971H82.7211L78.1445 30.4531V35.7971H76.1477V23.959H78.1445V29.2693L82.3046 23.959H84.8014L80.2414 29.7764L85.3667 35.7971ZM65.7355 36C68.6809 36 70.2119 33.9881 70.2119 33.9881L68.8806 32.6515C68.8806 32.6515 67.7826 34.1062 65.7355 34.1062C63.4389 34.1062 61.8581 32.1613 61.8581 29.878C61.8581 27.5948 63.4389 25.6499 65.7355 25.6499C67.6493 25.6499 68.6975 26.9523 68.6975 26.9523L70.0459 25.6161C70.0459 25.6161 68.5315 23.7551 65.7355 23.7551C62.3736 23.7551 59.8276 26.3772 59.8276 29.878C59.8276 33.3784 62.3736 36 65.7355 36ZM52.8773 35.7971H54.8907L50.364 23.959H48.3335L43.8072 35.7971H45.8206L46.8859 32.9899H51.812L52.8773 35.7971ZM31.3334 35.7971H38.29L38.9076 33.8691H33.3302V23.959H31.3334V35.7971ZM17.5512 35.7971H21.7445C23.9415 35.7971 25.639 34.3766 25.639 32.2958C25.639 30.1653 23.9913 29.5571 23.8248 29.5228C23.9913 29.4722 25.04 28.7786 25.04 27.3408C25.04 24.8551 23.2257 23.959 21.3285 23.959H17.5512V35.7971ZM155.002 35.797H157.648L152.522 29.7763L157.082 23.958H154.586L150.425 29.2687V23.958H148.428V35.797H150.425V30.4525L155.002 35.797ZM136.696 36C140.091 36 142.587 33.3784 142.587 29.8775C142.587 26.3767 140.091 23.7551 136.696 23.7551C133.301 23.7551 130.805 26.3767 130.805 29.8775C130.805 33.3784 133.301 36 136.696 36ZM124.964 29.8775C124.964 33.3784 122.467 36 119.072 36C115.678 36 113.182 33.3784 113.182 29.8775C113.182 26.3767 115.678 23.7551 119.072 23.7551C122.467 23.7551 124.964 26.3767 124.964 29.8775ZM107.34 32.2957C107.34 34.3761 105.643 35.797 103.446 35.797H99.2522V23.958H103.03C104.928 23.958 106.741 24.8545 106.741 27.3407C106.741 28.778 105.693 29.4716 105.527 29.5223C105.693 29.556 107.34 30.1648 107.34 32.2957Z", fill: color })] })));
};

var logoVariants$3 = {
    defaultLogo: Logo$9,
    expanded: Logo$8,
    collapsed: Logo$a
};
var BlackbookLogo = function (props) {
    var _a = props.inverted, inverted = _a === void 0 ? false : _a, _b = props.variant, variant = _b === void 0 ? 'defaultLogo' : _b, _c = props.ariaLabel, ariaLabel = _c === void 0 ? 'Blackbook Logo' : _c, svgProps = __rest(props, ["inverted", "variant", "ariaLabel"]);
    var color = inverted ? 'white' : 'black';
    var Logo = logoVariants$3[variant];
    return jsx(Logo, __assign({ color: color, ariaLabel: ariaLabel }, svgProps));
};

var Logo$7 = function (props) {
    var _a = props.height, height = _a === void 0 ? '576.2' : _a, _b = props.width, width = _b === void 0 ? '421.6' : _b, svgProps = __rest(props, ["height", "width"]);
    return (jsxs("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: width, height: height, viewBox: "0 0 576.2 421.6", "aria-label": "Openlane Logo" }, svgProps, { children: [jsxs("g", { children: [jsx("path", { fill: "#0A1B5F", d: "M297.6,9.9c-33.4-0.9-64.1,10.4-88,29.8c-2,1.6-2.2,4.7-0.3,6.5l30.3,30.3c1.5,1.5,3.9,1.7,5.6,0.4c14.3-10.4,31.9-16.3,51-15.8c44.2,1.2,80.1,37.5,80.8,81.8c0.7,46.5-36.8,84.4-83.1,84.4c-18.2,0-35.1-5.9-48.8-15.8c-1.7-1.3-4.1-1.1-5.6,0.4l-30.3,30.3c-1.8,1.8-1.7,4.9,0.3,6.5c23.1,18.6,52.4,29.8,84.4,29.8c74.8,0,135.3-61.2,134.3-136.2C427.2,70.5,369.2,11.8,297.6,9.9z" }), jsx("g", { children: jsx("path", { fill: "#0061FF", d: "M226.3,198.5c1.5-1.5,1.7-3.9,0.4-5.6c-10-13.7-15.8-30.5-15.8-48.8c0-18.2,5.9-35.1,15.8-48.8c1.3-1.7,1.1-4.1-0.4-5.6l-38.6-38.6c-1.8-1.8-4.8-1.7-6.5,0.3c-20.8,25.2-33.2,57.5-33.2,92.7s12.5,67.5,33.2,92.7c1.6,2,4.7,2.2,6.5,0.3L226.3,198.5z" }) })] }), jsx("path", { fill: "#0A1B5F", d: "M150.4,364.9c-0.3-1.7-0.9-3.4-1.7-5.1s-1.7-3.3-2.9-4.8s-2.6-2.9-4.3-4.1s-3.6-2.1-5.8-2.8c-2.2-0.7-4.7-1.1-7.4-1.1H91.6c-1.2,0-2.1,0.9-2.1,2.1v63.1c0,1.2,0.9,2.1,2.1,2.1h8c1.2,0,2.1-0.9,2.1-2.1v-14.4h26.6c1.5,0,3.1-0.2,4.8-0.5s3.4-0.9,5.1-1.6c1.7-0.8,3.3-1.7,4.8-2.9c1.5-1.2,2.9-2.6,4.1-4.3c1.2-1.7,2.1-3.6,2.8-5.8c0.7-2.2,1-4.7,1-7.5v-5.5C150.9,368.2,150.7,366.6,150.4,364.9L150.4,364.9z M138.7,375.3c0,1.6-0.2,3-0.8,4.2c-0.5,1.2-1.2,2.3-2.1,3.2c-0.9,0.9-2,1.6-3.3,2.1s-2.7,0.8-4.3,1h-26.6v-26.4h26.6c1.6,0,3,0.3,4.2,0.8s2.3,1.2,3.1,2.1c0.9,0.9,1.5,2,2,3.3s0.8,2.7,1,4.2L138.7,375.3L138.7,375.3z" }), jsx("path", { fill: "#0A1B5F", d: "M289.7,412c0,1.3-1.1,2.4-2.4,2.4h-7c-0.7,0-1.3-0.3-1.7-0.7l-38-45.4v44.1c0,1.2-0.9,2.1-2.1,2.1h-8c-1.2,0-2.1-0.9-2.1-2.1v-63.1c0-1.2,0.9-2.1,2.1-2.1h7.2c0.7,0,1.3,0.3,1.7,0.7l38.1,45.6v-44.2c0-1.2,0.9-2.1,2.1-2.1h8c1.2,0,2.1,0.9,2.1,2.1V412z" }), jsx("path", { fill: "#0A1B5F", d: "M501.8,412c0,1.3-1.1,2.4-2.4,2.4h-7c-0.7,0-1.3-0.3-1.7-0.7l-38-45.4v44.1c0,1.2-0.9,2.1-2.1,2.1h-8c-1.2,0-2.1-0.9-2.1-2.1v-63.1c0-1.2,0.9-2.1,2.1-2.1h7.2c0.7,0,1.3,0.3,1.7,0.7l38.1,45.6v-44.2c0-1.2,0.9-2.1,2.1-2.1h8c1.2,0,2.1,0.9,2.1,2.1L501.8,412L501.8,412z" }), jsx("path", { fill: "#0A1B5F", d: "M43.6,346.4C24.5,346.4,9,361.9,9,381s15.5,34.6,34.6,34.6s34.6-15.5,34.6-34.6S62.7,346.4,43.6,346.4zM43.6,403.3c-12.4,0-22.4-10-22.4-22.4s10-22.4,22.4-22.4s22.4,10,22.4,22.4S55.9,403.3,43.6,403.3z" }), jsx("path", { fill: "#0A1B5F", d: "M215.1,402.2h-40.9v-15.3h35.4c1.2,0,2.1-0.9,2.1-2.1v-8.1c0-1.2-0.9-2.1-2.1-2.1h-35.4v-15.3h40.9c1.2,0,2.1-0.9,2.1-2.1l0,0v-8c0-1.2-0.9-2.1-2.1-2.1h-51c-1.2,0-2.1,0.9-2.1,2.1v63.1c0,1.2,0.9,2.1,2.1,2.1h51c1.2,0,2.1-0.9,2.1-2.1v-8C217.2,403.1,216.3,402.2,215.1,402.2z" }), jsx("path", { fill: "#0A1B5F", d: "M421,347.1h-19.4c-4.8,0-9.3,0.8-13.4,2.5s-7.7,4-10.7,6.9c-3,3-5.4,6.5-7,10.7c-1.7,4.1-2.5,8.6-2.5,13.6v31.6c0,1.1,0.9,2.1,2.1,2.1h8c1.1,0,2.1-0.9,2.1-2.1V398h37v14.4c0,1.2,0.9,2.1,2.1,2.1h8c1.2,0,2.1-0.9,2.1-2.1V357v-7.6c0-1.2-0.9-2.1-2.1-2.1H421V347.1z M417.1,385.7h-37v-4.9c0-3.4,0.5-6.3,1.4-8.7c1-2.4,2.2-4.4,3.6-6c1.5-1.6,3.1-2.8,4.8-3.8c1.8-0.9,3.4-1.6,5-2s3-0.7,4.2-0.8c1.2-0.1,2-0.2,2.4-0.2H417v26.4H417.1z" }), jsx("path", { fill: "#0A1B5F", d: "M566.1,402.2h-40.9v-15.3h35.4c1.2,0,2.1-0.9,2.1-2.1v-8.1c0-1.2-0.9-2.1-2.1-2.1h-35.4v-15.3h40.9c1.2,0,2.1-0.9,2.1-2.1l0,0v-8c0-1.2-0.9-2.1-2.1-2.1h-51c-1.2,0-2.1,0.9-2.1,2.1v63.1c0,1.2,0.9,2.1,2.1,2.1h51c1.2,0,2.1-0.9,2.1-2.1v-8C568.2,403.1,567.3,402.2,566.1,402.2z" }), jsx("path", { fill: "#0A1B5F", d: "M354.7,402.2h-41.6v-53c0-1.2-0.9-2.1-2.1-2.1h-8c-1.2,0-2.1,0.9-2.1,2.1v63.1c0,1.2,0.9,2.1,2.1,2.1h51.7c1.2,0,2.1-0.9,2.1-2.1l0,0v-8C356.8,403.1,355.8,402.2,354.7,402.2z" })] })));
};

var Svg$3 = styled.svg(templateObject_1$V || (templateObject_1$V = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var cursor = _a.cursor;
    return "cursor: ".concat(getValue$1(cursor));
});
var Logo$6 = function (props) {
    var _a = props.height, height = _a === void 0 ? '21' : _a, _b = props.width, width = _b === void 0 ? '160' : _b, svgProps = __rest(props, ["height", "width"]);
    return (jsx(Svg$3, __assign({ xmlns: "http://www.w3.org/2000/svg", width: width, height: height, viewBox: "0 0 1411.5 189.9", "aria-label": "Openlane Logo" }, svgProps, { children: jsxs("g", { children: [jsx("path", { fill: "#FFFFFF", d: "M110.9,7.4C89.1,6.8,69,14.2,53.3,26.8c-1.3,1.1-1.4,3.1-0.2,4.3l19.8,19.8c1,1,2.6,1.1,3.7,0.3c9.3-6.8,20.9-10.7,33.4-10.3c28.9,0.8,52.4,24.5,52.8,53.5c0.5,30.4-24,55.2-54.3,55.2c-11.9,0-22.9-3.9-31.9-10.4c-1.1-0.8-2.7-0.7-3.7,0.3l-19.8,19.8c-1.2,1.2-1.1,3.2,0.2,4.3c15.1,12.2,34.3,19.5,55.2,19.5c48.9,0,88.5-40,87.8-89.1C195.7,47,157.7,8.6,110.9,7.4z" }), jsx("g", { children: jsx("path", { fill: "#0061FF", d: "M64.2,130.7c1-1,1.1-2.5,0.3-3.7c-6.5-9-10.4-20-10.4-31.9s3.9-23,10.4-31.9c0.8-1.1,0.7-2.7-0.3-3.7L39,34.3c-1.2-1.2-3.2-1.1-4.3,0.2C21.2,51,13,72.1,13,95.2s8.1,44.1,21.7,60.6c1.1,1.3,3.1,1.4,4.3,0.2L64.2,130.7z" }) }), jsxs("g", { children: [jsx("path", { fill: "#FFFFFF", d: "M373.1,56.1c-0.8-4.2-2.2-8.3-4.1-12.4s-4.3-8-7.1-11.8c-2.9-3.8-6.4-7.1-10.5-10s-8.9-5.2-14.2-6.9c-5.4-1.7-11.5-2.6-18.2-2.6h-90c-2.8,0-5.1,2.3-5.1,5.1v154.8c0,2.8,2.3,5.1,5.1,5.1h19.7c2.8,0,5.1-2.3,5.1-5.1v-35.4H319c3.7,0,7.6-0.4,11.8-1.3c4.2-0.8,8.3-2.2,12.4-4s8-4.2,11.8-7.1s7.1-6.4,10-10.5s5.2-8.8,6.9-14.2c1.7-5.4,2.5-11.5,2.5-18.3V67.9C374.3,64.2,373.9,60.3,373.1,56.1L373.1,56.1z M344.4,81.5c0,3.8-0.6,7.3-1.8,10.3c-1.2,3-3,5.6-5.2,7.8c-2.2,2.2-4.9,3.9-8,5.1c-3.1,1.3-6.6,2.1-10.4,2.4h-65.2V42.3H319c3.9,0,7.4,0.6,10.4,1.9c3,1.3,5.6,3,7.7,5.2s3.8,4.9,5,8.1c1.2,3.1,2,6.6,2.4,10.4L344.4,81.5L344.4,81.5z" }), jsx("path", { fill: "#FFFFFF", d: "M715.1,171.6c0,3.2-2.6,5.9-5.9,5.9H692c-1.6,0-3.1-0.7-4.2-1.8L594.4,64.2v108.1c0,2.8-2.3,5.1-5.1,5.1h-19.7c-2.8,0-5.1-2.3-5.1-5.1V17.5c0-2.8,2.3-5.1,5.1-5.1h17.7c1.6,0,3.1,0.7,4.2,1.8L685.1,126V17.5c0-2.8,2.3-5.1,5.1-5.1h19.7c2.8,0,5.1,2.3,5.1,5.1v154.1H715.1z" }), jsx("path", { fill: "#FFFFFF", d: "M1235.6,171.6c0,3.2-2.6,5.9-5.9,5.9h-17.2c-1.6,0-3.1-0.7-4.2-1.8L1115,64.2v108.1c0,2.8-2.3,5.1-5.1,5.1h-19.7c-2.8,0-5.1-2.3-5.1-5.1V17.5c0-2.8,2.3-5.1,5.1-5.1h17.7c1.6,0,3.1,0.7,4.2,1.8l93.5,111.8V17.5c0-2.8,2.3-5.1,5.1-5.1h19.7c2.8,0,5.1,2.3,5.1,5.1v154.1H1235.6z" }), jsx("path", { fill: "#FFFFFF", d: "M532,147.5H431.6V110h86.9c2.8,0,5.1-2.3,5.1-5.1V85c0-2.8-2.3-5.1-5.1-5.1h-86.9V42.3H532c2.8,0,5.1-2.3,5.1-5.1l0,0V17.5c0-2.8-2.3-5.1-5.1-5.1H406.7c-2.8,0-5.1,2.3-5.1,5.1v154.8c0,2.8,2.3,5.1,5.1,5.1h125.2c2.8,0,5.1-2.3,5.1-5.1v-19.7C537.2,149.8,534.9,147.5,532,147.5z" }), jsx("path", { fill: "#FFFFFF", d: "M1037.3,12.4h-47.6c-11.9,0-22.9,2-32.9,6.1c-10.1,4.1-18.8,9.8-26.2,17c-7.4,7.3-13.1,16-17.3,26.1s-6.2,21.2-6.2,33.3v77.4c0,2.8,2.3,5.1,5.1,5.1H932c2.8,0,5.1-2.3,5.1-5.1V137h90.8v35.4c0,2.8,2.3,5.1,5.1,5.1h19.7c2.8,0,5.1-2.3,5.1-5.1V36.2V17.5c0-2.8-2.3-5.1-5.1-5.1H1037.3z M1027.7,107H937V94.9c0-8.4,1.2-15.5,3.5-21.4s5.3-10.8,8.9-14.7c3.6-3.9,7.6-7,11.9-9.2c4.3-2.2,8.4-3.9,12.3-4.9c3.9-1.1,7.3-1.7,10.2-2c3-0.3,4.9-0.4,5.8-0.4h38.1L1027.7,107L1027.7,107z" }), jsx("path", { fill: "#FFFFFF", d: "M1393.3,147.5H1293V110h86.9c2.8,0,5.1-2.3,5.1-5.1V85c0-2.8-2.3-5.1-5.1-5.1H1293V42.3h100.4c2.8,0,5.1-2.3,5.1-5.1l0,0V17.5c0-2.8-2.3-5.1-5.1-5.1h-125.3c-2.8,0-5.1,2.3-5.1,5.1v154.8c0,2.8,2.3,5.1,5.1,5.1h125.2c2.8,0,5.1-2.3,5.1-5.1v-19.7C1398.5,149.8,1396.2,147.5,1393.3,147.5z" }), jsx("path", { fill: "#FFFFFF", d: "M874.5,147.5H772.4v-130c0-2.8-2.3-5.1-5.1-5.1h-19.7c-2.8,0-5.1,2.3-5.1,5.1v154.8c0,2.8,2.3,5.1,5.1,5.1h127c2.8,0,5.1-2.3,5.1-5.1l0,0v-19.7C879.7,149.8,877.3,147.5,874.5,147.5z" })] })] }) })));
};
var templateObject_1$V;

var Svg$2 = styled.svg(templateObject_1$U || (templateObject_1$U = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var cursor = _a.cursor;
    return "cursor: ".concat(getValue$1(cursor));
});
var Logo$5 = function (props) {
    var _a = props.height, height = _a === void 0 ? '21' : _a, _b = props.width, width = _b === void 0 ? '160' : _b, svgProps = __rest(props, ["height", "width"]);
    return (jsxs(Svg$2, __assign({ width: width, height: height, viewBox: "0 0 160 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-label": "Openlane Logo" }, svgProps, { children: [jsxs("g", __assign({ clipPath: "url(#clip0_1228_1616)" }, { children: [jsx("path", { d: "M5.90845 15.0402C5.96374 14.9847 5.99757 14.9114 6.00396 14.8333C6.01034 14.7552 5.98886 14.6774 5.94333 14.6136C5.16347 13.545 4.74324 12.2563 4.74324 10.9334C4.74324 9.61054 5.16347 8.32185 5.94333 7.25317C5.9886 7.18931 6.00991 7.11155 6.00354 7.03354C5.99716 6.95553 5.9635 6.88226 5.90845 6.82659L3.00042 3.91781C2.96692 3.88554 2.92718 3.86044 2.88365 3.84406C2.84011 3.82767 2.79368 3.82034 2.74721 3.82252C2.70074 3.82469 2.6552 3.83633 2.61338 3.85671C2.57157 3.87709 2.53435 3.90579 2.50401 3.94106C0.884926 5.91364 0 8.38645 0 10.9382C0 13.4899 0.884926 15.9627 2.50401 17.9353C2.53435 17.9706 2.57157 17.9993 2.61338 18.0197C2.6552 18.0401 2.70074 18.0517 2.74721 18.0539C2.79368 18.056 2.84011 18.0487 2.88365 18.0323C2.92718 18.0159 2.96692 17.9908 3.00042 17.9586L5.90845 15.0402Z", fill: "#0061FF" }), jsx("path", { d: "M4.64964 3.05372C6.52835 1.54079 8.88509 0.747221 11.2965 0.815566C12.9052 0.860495 14.4802 1.28773 15.891 2.06192C17.3019 2.83612 18.5081 3.93503 19.4099 5.26775C20.3117 6.60047 20.8832 8.12871 21.077 9.72604C21.2709 11.3234 21.0816 12.9439 20.5247 14.4536C19.9679 15.9633 19.0596 17.3187 17.8748 18.4078C16.6901 19.4968 15.2631 20.2882 13.7117 20.7165C12.1604 21.1448 10.5294 21.1977 8.95355 20.8707C7.37773 20.5438 5.90242 19.8464 4.64964 18.8363C4.61437 18.806 4.58567 18.7688 4.56528 18.727C4.54489 18.6852 4.53325 18.6396 4.53107 18.5932C4.5289 18.5467 4.53623 18.5003 4.55262 18.4568C4.56901 18.4132 4.59411 18.3735 4.62639 18.34L6.90947 16.0554C6.96514 16.0004 7.03843 15.9667 7.11646 15.9603C7.19448 15.9539 7.27226 15.9753 7.33613 16.0205C8.13114 16.5989 9.05099 16.9823 10.0215 17.1398C10.9919 17.2973 11.9859 17.2246 12.9231 16.9274C13.8602 16.6303 14.7144 16.117 15.4167 15.4291C16.119 14.7412 16.6497 13.8979 16.9661 12.9671C17.2824 12.0364 17.3755 11.0444 17.2378 10.0711C17.1001 9.09784 16.7355 8.17053 16.1734 7.36403C15.6113 6.55753 14.8675 5.89442 14.002 5.4282C13.1364 4.96197 12.1733 4.70569 11.1905 4.68004C9.80928 4.63398 8.45255 5.05259 7.3375 5.86885C7.27363 5.91411 7.19585 5.93542 7.11782 5.92904C7.0398 5.92267 6.96651 5.88901 6.91084 5.83398L4.62639 3.55002C4.59411 3.51653 4.56901 3.4768 4.55262 3.43327C4.53623 3.38974 4.5289 3.34333 4.53107 3.29687C4.53325 3.2504 4.54489 3.20488 4.56528 3.16307C4.58567 3.12126 4.61437 3.08405 4.64964 3.05372Z", fill: "#0A1B5F" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M41.0797 5.00339C41.2958 5.45901 41.4547 5.93959 41.5529 6.4342L41.5515 6.42941C41.6381 6.87831 41.6882 7.33349 41.7012 7.79049V9.3628C41.713 10.077 41.6157 10.7889 41.4127 11.4738C41.2348 12.0589 40.9663 12.6126 40.6168 13.1145C40.2962 13.5748 39.9069 13.9833 39.4626 14.3258C38.6426 14.9616 37.687 15.3998 36.6701 15.6063C36.2229 15.7042 35.7666 15.7544 35.3088 15.756H27.7874V19.8399C27.7869 19.9958 27.7247 20.1452 27.6144 20.2555C27.5041 20.3657 27.3547 20.4279 27.1987 20.4285H24.9252C24.7692 20.4279 24.6198 20.3657 24.5095 20.2555C24.3992 20.1452 24.337 19.9958 24.3365 19.8399V1.97908C24.337 1.82314 24.3992 1.67375 24.5095 1.56348C24.6198 1.45321 24.7692 1.39103 24.9252 1.39049H35.3081C36.0192 1.38318 36.7273 1.48438 37.4079 1.69059C37.9922 1.8708 38.5456 2.13913 39.0489 2.48632C39.509 2.80763 39.9172 3.19748 40.2592 3.64231C40.5778 4.06726 40.8527 4.52326 41.0797 5.00339ZM38.0363 10.553C38.1792 10.1735 38.2488 9.7703 38.2414 9.36485L38.2442 9.36827L38.2558 7.79596C38.2166 7.38561 38.1235 6.98222 37.9789 6.59621C37.8519 6.24878 37.6556 5.93082 37.4018 5.66171C37.1489 5.40388 36.8465 5.19973 36.5129 5.0615C36.1321 4.90719 35.7237 4.83251 35.3129 4.84206H27.7915V12.3181H35.3129C35.725 12.29 36.1301 12.1966 36.5129 12.0412C36.8584 11.9117 37.1728 11.7112 37.4359 11.4526C37.6952 11.1967 37.8995 10.8906 38.0363 10.553Z", fill: "#0A1B5F" }), jsx("path", { d: "M81.0175 19.7592C81.0175 19.9405 80.9454 20.1144 80.8172 20.2426C80.689 20.3708 80.5151 20.4428 80.3337 20.4428H78.3508C78.1685 20.4411 77.9942 20.3674 77.866 20.2377L67.0893 7.3687V19.8399C67.0888 19.9958 67.0266 20.1452 66.9163 20.2555C66.806 20.3657 66.6565 20.4279 66.5006 20.4285H64.2271C64.0711 20.4279 63.9217 20.3657 63.8114 20.2555C63.7011 20.1452 63.6389 19.9958 63.6384 19.8399V1.98113C63.6389 1.82519 63.7011 1.6758 63.8114 1.56553C63.9217 1.45526 64.0711 1.39308 64.2271 1.39254H66.2695C66.4518 1.39423 66.6261 1.46795 66.7543 1.59762L77.5577 14.4961V1.98113C77.5582 1.82519 77.6204 1.6758 77.7307 1.56553C77.841 1.45526 77.9904 1.39308 78.1464 1.39254H80.4199C80.5759 1.39308 80.7253 1.45526 80.8356 1.56553C80.9459 1.6758 81.0081 1.82519 81.0086 1.98113V19.7592H81.0175Z", fill: "#0A1B5F" }), jsx("path", { d: "M140.88 20.2426C141.008 20.1144 141.08 19.9405 141.08 19.7592H141.068V1.98113C141.068 1.82519 141.005 1.6758 140.895 1.56553C140.785 1.45526 140.635 1.39308 140.479 1.39254H138.206C138.05 1.39308 137.9 1.45526 137.79 1.56553C137.68 1.6758 137.618 1.82519 137.617 1.98113V14.4961L126.828 1.59762C126.7 1.46795 126.526 1.39423 126.343 1.39254H124.301C124.145 1.39308 123.995 1.45526 123.885 1.56553C123.775 1.6758 123.713 1.82519 123.712 1.98113V19.8399C123.713 19.9958 123.775 20.1452 123.885 20.2555C123.995 20.3657 124.145 20.4279 124.301 20.4285H126.574C126.73 20.4279 126.88 20.3657 126.99 20.2555C127.1 20.1452 127.163 19.9958 127.163 19.8399V7.37417L137.929 20.2377C138.057 20.3674 138.231 20.4411 138.414 20.4428H140.397C140.578 20.4428 140.752 20.3708 140.88 20.2426Z", fill: "#0A1B5F" }), jsx("path", { d: "M59.8893 16.979H48.3036V12.6524H58.331C58.487 12.6518 58.6364 12.5896 58.7467 12.4794C58.857 12.3691 58.9192 12.2197 58.9197 12.0638V9.76818C58.9192 9.61225 58.857 9.46285 58.7467 9.35258C58.6364 9.24232 58.487 9.18013 58.331 9.17959H48.3036V4.84206H59.8893C60.0452 4.84152 60.1947 4.77933 60.305 4.66907C60.4152 4.5588 60.4774 4.4094 60.478 4.25346V1.98113C60.4774 1.82519 60.4152 1.6758 60.305 1.56553C60.1947 1.45526 60.0452 1.39308 59.8893 1.39254H45.4305C45.2745 1.39308 45.1251 1.45526 45.0148 1.56553C44.9045 1.6758 44.8423 1.82519 44.8418 1.98113V19.8399C44.8423 19.9958 44.9045 20.1452 45.0148 20.2555C45.1251 20.3657 45.2745 20.4279 45.4305 20.4285H59.8776C60.0336 20.4279 60.183 20.3657 60.2933 20.2555C60.4036 20.1452 60.4658 19.9958 60.4664 19.8399V17.5669C60.4703 17.4896 60.4581 17.4123 60.4307 17.3399C60.4032 17.2675 60.361 17.2016 60.3068 17.1464C60.2525 17.0911 60.1874 17.0477 60.1156 17.0189C60.0437 16.9901 59.9667 16.9765 59.8893 16.979Z", fill: "#0A1B5F" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M112.704 1.39254H119.973C120.129 1.39308 120.279 1.45526 120.389 1.56553C120.499 1.6758 120.562 1.82519 120.562 1.98113V19.8501C120.562 20.0061 120.499 20.1555 120.389 20.2657C120.279 20.376 120.129 20.4382 119.973 20.4387H117.7C117.544 20.4382 117.394 20.376 117.284 20.2657C117.174 20.1555 117.112 20.0061 117.111 19.8501V15.7676H106.633V19.8399C106.633 19.9958 106.57 20.1452 106.46 20.2555C106.35 20.3657 106.2 20.4279 106.044 20.4285H103.761C103.605 20.4279 103.456 20.3657 103.346 20.2555C103.235 20.1452 103.173 19.9958 103.173 19.8399V10.9071C103.154 9.59167 103.397 8.28563 103.888 7.06517C104.344 5.93848 105.023 4.91544 105.884 4.05727C106.755 3.21271 107.782 2.54645 108.908 2.09598C110.115 1.61534 111.405 1.37634 112.704 1.39254ZM106.623 12.3064H117.089L117.09 4.84137H112.693C112.589 4.84137 112.37 4.853 112.024 4.88786C111.116 4.98962 110.235 5.25946 109.426 5.68359C108.909 5.95375 108.444 6.31317 108.053 6.74524C107.608 7.24141 107.26 7.81673 107.027 8.44129C106.74 9.23221 106.603 10.0695 106.623 10.9105V12.3064Z", fill: "#0A1B5F" }), jsx("path", { d: "M159.277 16.979H147.703V12.6524H157.73C157.886 12.6518 158.035 12.5896 158.146 12.4794C158.256 12.3691 158.318 12.2197 158.319 12.0638V9.76818C158.318 9.61225 158.256 9.46285 158.146 9.35258C158.035 9.24232 157.886 9.18013 157.73 9.17959H147.703V4.84206H159.288C159.444 4.84152 159.594 4.77933 159.704 4.66907C159.814 4.5588 159.876 4.4094 159.877 4.25346V1.98113C159.876 1.82519 159.814 1.6758 159.704 1.56553C159.594 1.45526 159.444 1.39308 159.288 1.39254H144.829C144.673 1.39308 144.524 1.45526 144.414 1.56553C144.303 1.6758 144.241 1.82519 144.241 1.98113V19.8399C144.241 19.9958 144.303 20.1452 144.414 20.2555C144.524 20.3657 144.673 20.4279 144.829 20.4285H159.277C159.433 20.4279 159.582 20.3657 159.692 20.2555C159.803 20.1452 159.865 19.9958 159.865 19.8399V17.5669C159.867 17.4892 159.853 17.4119 159.824 17.3399C159.795 17.2678 159.751 17.2023 159.696 17.1474C159.641 17.0925 159.576 17.0492 159.504 17.0203C159.432 16.9913 159.354 16.9773 159.277 16.979Z", fill: "#0A1B5F" }), jsx("path", { d: "M87.6294 16.979H99.4113C99.5682 16.9793 99.7188 17.041 99.8309 17.1508C99.9429 17.2607 100.008 17.41 100.011 17.5669V19.8399C100.01 19.9958 99.9482 20.1452 99.8379 20.2555C99.7276 20.3657 99.5782 20.4279 99.4223 20.4285H84.7672C84.6112 20.4279 84.4618 20.3657 84.3515 20.2555C84.2412 20.1452 84.1791 19.9958 84.1785 19.8399V1.98113C84.1791 1.82519 84.2412 1.6758 84.3515 1.56553C84.4618 1.45526 84.6112 1.39308 84.7672 1.39254H87.0407C87.1967 1.39308 87.3461 1.45526 87.4564 1.56553C87.5667 1.6758 87.6289 1.82519 87.6294 1.98113V16.979Z", fill: "#0A1B5F" })] })), jsx("defs", { children: jsx("clipPath", __assign({ id: "clip0_1228_1616" }, { children: jsx("rect", { width: "160", height: "21.1921", fill: "white", transform: "translate(0 0.404022)" }) })) })] })));
};
var templateObject_1$U;

var Svg$1 = styled.svg(templateObject_1$T || (templateObject_1$T = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var cursor = _a.cursor;
    return "cursor: ".concat(getValue$1(cursor));
});
var Logo$4 = function (props) {
    var _a = props.height, height = _a === void 0 ? '25' : _a, _b = props.width, width = _b === void 0 ? '25' : _b, svgProps = __rest(props, ["height", "width"]);
    return (jsxs(Svg$1, __assign({ width: width, height: height, viewBox: "0 0 26 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-label": "Openlane Logo" }, svgProps, { children: [jsx("path", { d: "M13.8525 0.973573C11.0023 0.892654 8.21666 1.83223 5.99605 3.6235C5.95436 3.65941 5.92044 3.70346 5.89634 3.75296C5.87224 3.80246 5.85848 3.85637 5.85591 3.91137C5.85334 3.96638 5.862 4.02134 5.88138 4.07288C5.90075 4.12442 5.93042 4.17145 5.96858 4.21111L8.66876 6.91526C8.73456 6.98041 8.82118 7.02027 8.91341 7.02781C9.00564 7.03536 9.09757 7.01013 9.17307 6.95654C10.491 5.99011 12.0947 5.49449 13.7272 5.54902C14.889 5.5794 16.0273 5.88282 17.0504 6.43482C18.0734 6.98682 18.9526 7.77193 19.617 8.72681C20.2814 9.68169 20.7123 10.7796 20.8751 11.9319C21.0378 13.0843 20.9278 14.2588 20.5539 15.3608C20.18 16.4627 19.5527 17.4612 18.7226 18.2757C17.8925 19.0902 16.8828 19.6978 15.7751 20.0497C14.6674 20.4015 13.4926 20.4876 12.3455 20.3011C11.1984 20.1146 10.1111 19.6606 9.17145 18.9759C9.09596 18.9223 9.00402 18.8971 8.91179 18.9046C8.81957 18.9122 8.73294 18.952 8.66714 19.0172L5.96858 21.7221C5.93042 21.7618 5.90075 21.8088 5.88138 21.8604C5.862 21.9119 5.85334 21.9669 5.85591 22.0219C5.85848 22.0769 5.87224 22.1308 5.89634 22.1803C5.92044 22.2298 5.95436 22.2738 5.99605 22.3097C7.47682 23.5057 9.22062 24.3313 11.0832 24.7184C12.9458 25.1055 14.8737 25.0429 16.7073 24.5359C18.541 24.0288 20.2277 23.0918 21.6281 21.8023C23.0284 20.5129 24.102 18.9081 24.7602 17.1207C25.4184 15.3332 25.6421 13.4146 25.413 11.5234C25.1839 9.63217 24.5084 7.82277 23.4425 6.24486C22.3766 4.66694 20.9508 3.36586 19.2832 2.44923C17.6156 1.5326 15.7541 1.02677 13.8525 0.973573Z", fill: "#0A1B5F" }), jsx("path", { d: "M7.48371 17.8152C7.54906 17.7494 7.58905 17.6626 7.59659 17.5702C7.60414 17.4777 7.57875 17.3856 7.52493 17.3101C6.60315 16.0448 6.10645 14.519 6.10645 12.9528C6.10645 11.3865 6.60315 9.86075 7.52493 8.59546C7.57844 8.51985 7.60363 8.42778 7.5961 8.33542C7.58856 8.24306 7.54877 8.15631 7.48371 8.0904L4.04646 4.64647C4.00686 4.60826 3.95989 4.57855 3.90843 4.55915C3.85696 4.53975 3.80209 4.53107 3.74716 4.53365C3.69223 4.53622 3.63841 4.55 3.58898 4.57413C3.53955 4.59826 3.49556 4.63224 3.45971 4.67399C1.54597 7.00949 0.5 9.93724 0.5 12.9584C0.5 15.9797 1.54597 18.9074 3.45971 21.2429C3.49556 21.2846 3.53955 21.3186 3.58898 21.3428C3.63841 21.3669 3.69223 21.3807 3.74716 21.3832C3.80209 21.3858 3.85696 21.3771 3.90843 21.3577C3.95989 21.3383 4.00686 21.3086 4.04646 21.2704L7.48371 17.8152Z", fill: "#0061FF" })] })));
};
var templateObject_1$T;

var logoVariants$2 = {
    defaultLogo: Logo$5,
    vertical: Logo$7,
    inverted: Logo$6,
    condensed: Logo$4
};
var OpenLaneLogo = function (props) {
    var _a = props.variant, variant = _a === void 0 ? 'defaultLogo' : _a, _b = props.height, height = _b === void 0 ? '21' : _b, _c = props.width, width = _c === void 0 ? '160' : _c, svgProps = __rest(props, ["variant", "height", "width"]);
    var Logo = logoVariants$2[variant];
    return jsx(Logo, __assign({ height: height, width: width }, svgProps));
};

var Logo$3 = function (props) {
    var _a = props.height, height = _a === void 0 ? 30 : _a, _b = props.width, width = _b === void 0 ? 132 : _b, ariaLabel = props.ariaLabel, svgProps = __rest(props, ["height", "width", "ariaLabel"]);
    return (jsxs("svg", __assign({ width: width, height: height, fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-label": ariaLabel }, svgProps, { children: [jsxs("g", __assign({ clipPath: "url(#clip0_2402_4058)" }, { children: [jsx("path", { fill: "#6BC24A", fillRule: "evenodd", d: "M36.902 4.978C39.185 7.87 40 11.248 40 13.448a6.215 6.215 0 01-5.576 6.177.157.157 0 00-.138.11 5.328 5.328 0 01-5.062 3.696c-2.352 0-4.35-1.538-5.05-3.66a.161.161 0 00-.155-.114h-8.184a.167.167 0 00-.155.115c-.701 2.121-2.698 3.66-5.05 3.66a5.283 5.283 0 01-5.05-3.66.158.158 0 00-.151-.11C2.376 19.6 0 17.169 0 14.181c0-.771.155-1.514.465-2.211C1.68 9.104 4.78 7.907 8.61 6.429l.218-.085c.356-.137.693-.265 1.02-.389 1.808-.684 3.31-1.252 6.003-2.748C18.753 1.595 21.818 0 26.216 0c5.583 0 8.893 2.705 10.686 4.978zM8.188 17.69a2.489 2.489 0 002.87 2.872 2.489 2.489 0 00-.84-4.904 2.492 2.492 0 00-2.03 2.032zm18.594 0a2.489 2.489 0 002.87 2.872 2.487 2.487 0 00-.84-4.904 2.493 2.493 0 00-2.03 2.032zm7.634-.755c.02.086.106.147.196.127a3.703 3.703 0 002.881-3.611c0-1.697-.668-4.529-2.555-6.92-1.451-1.836-4.141-4.027-8.722-4.027-3.696 0-6.014 1.23-9.008 2.818l-.171.091C14.4 6.81 13.499 7.258 9.717 8.686c-4.276 1.612-6.566 2.587-7.137 4.84a2.975 2.975 0 002.686 3.623.167.167 0 00.171-.135 5.325 5.325 0 015.2-4.223c2.56 0 4.704 1.82 5.206 4.235.016.073.081.13.159.13h7.866a.161.161 0 00.159-.13 5.325 5.325 0 015.205-4.235c2.527 0 4.646 1.775 5.184 4.145z", clipRule: "evenodd" }), jsx("path", { fill: "#6BC24A", d: "M14.029 27.511A8.322 8.322 0 0019.959 30c2.234 0 4.37-.902 5.93-2.489a.475.475 0 00-.024-.69l-1.426-1.248a.475.475 0 00-.64.02 5.484 5.484 0 01-3.84 1.571 5.484 5.484 0 01-3.84-1.57.467.467 0 00-.64-.02l-1.426 1.248a.475.475 0 00-.024.69z" }), jsx("path", { fill: "#0A2E3C", d: "M57.544 14.068h2.867c-.605 2.29-2.627 4.927-6.37 4.927-4.491 0-7.041-3.352-7.041-7.497C47 7.352 49.55 4 54.04 4c3.971 0 6.005 2.967 6.464 5.341H57.7c-.423-1.258-1.576-2.838-3.622-2.838-2.753 0-4.332 2.228-4.332 4.999 0 2.77 1.58 4.998 4.332 4.998 1.835-.004 2.948-1.266 3.467-2.432z" }), jsx("path", { fill: "#0A2E3C", fillRule: "evenodd", d: "M70.606 15.832c0 .685 0 2.499.325 3h-2.51c-.182-.522-.263-1.04-.304-1.626-.849 1.146-2.083 1.793-3.54 1.793-2.104 0-3.358-1.416-3.358-3.268 0-2.75 2.834-3.456 6.8-3.23 0-1.208-.527-1.998-1.98-1.998-1.255 0-1.803.706-1.941 1.333h-2.55c.426-2.248 2.062-3.498 4.653-3.498 2.245 0 4.41.915 4.41 4.748v2.745h-.005zm-2.59-1.584c-2.002-.23-4.21.062-4.21 1.354 0 .852.608 1.291 1.68 1.228 1.153-.062 2.327-1.25 2.53-2.582zM92.468 14.624c0 2.416-1.58 4.209-4.49 4.209h-6.843V4.168H86.8c3.118 0 5.018 1.375 5.018 4 0 1.353-.889 2.52-1.884 2.98 1.624.517 2.534 1.913 2.534 3.476zm-8.58-4.459h2.855c1.518 0 2.184-.853 2.184-1.897 0-1.041-.67-1.689-2.184-1.689H83.89v3.586zm5.827 4.292c0-1.082-.869-1.96-2.448-1.96h-3.378v3.916h3.378c1.68.004 2.448-.832 2.448-1.956zM110.8 18.832c-.326-.501-.326-2.31-.326-3h.005v-2.746c0-3.832-2.164-4.748-4.409-4.748-2.591 0-4.227 1.25-4.653 3.498h2.549c.138-.627.686-1.333 1.941-1.333 1.454 0 1.981.79 1.981 1.998-3.966-.226-6.8.48-6.8 3.23 0 1.852 1.254 3.269 3.357 3.269 1.458 0 2.692-.648 3.541-1.793.04.585.122 1.103.304 1.625h2.51zm-7.126-3.23c0-1.292 2.209-1.584 4.211-1.354-.204 1.333-1.377 2.52-2.53 2.583-1.072.062-1.681-.377-1.681-1.23z", clipRule: "evenodd" }), jsx("path", { fill: "#0A2E3C", d: "M116.262 15.121l-2.306-6.62h-2.874l4.048 10.332h2.265L121.444 8.5h-2.876l-2.306 6.62z" }), jsx("path", { fill: "#0A2E3C", fillRule: "evenodd", d: "M126.819 19c3.078 0 5.181-2.395 5.181-5.333s-2.103-5.332-5.181-5.332c-3.276 0-5.181 2.394-5.181 5.332 0 2.938 2.046 5.333 5.181 5.333zm.004-8.166c1.498 0 2.591 1.27 2.591 2.833 0 1.56-1.096 2.83-2.591 2.834-1.498 0-2.59-1.27-2.59-2.834 0-1.563 1.092-2.833 2.59-2.833z", clipRule: "evenodd" }), jsx("path", { fill: "#0A2E3C", d: "M79.53 8.46a4.831 4.831 0 00-.84-.063c-1.397 0-2.55.664-3.155 2.123V8.5h-2.59v10.332h2.59v-4.69c0-2.08 1.194-3.042 2.692-3.042.418 0 .864.067 1.308.217V8.46h-.005zM99.86 8.397c.277 0 .553.012.841.062h.004v2.86a4.076 4.076 0 00-1.307-.218c-1.498 0-2.692.961-2.692 3.042v4.69h-2.59V8.5h2.59v2.019c.605-1.459 1.758-2.123 3.154-2.123z" })] })), jsx("defs", { children: jsx("clipPath", __assign({ id: "clip0_2402_4058" }, { children: jsx("path", { fill: "#fff", d: "M0 0H132V30H0z" }) })) })] })));
};

var logoVariants$1 = {
    default: Logo$b,
    condensed: Logo$c,
    expanded: Logo$3
};
var CarBravoLogo = function (_a) {
    var height = _a.height, width = _a.width, _b = _a.variant, variant = _b === void 0 ? 'default' : _b;
    var Logo = logoVariants$1[variant];
    return jsx(Logo, { height: height, width: width, variant: variant });
};

var FloatLogo = function (props) {
    var _a = props.inverted, inverted = _a === void 0 ? false : _a, _b = props.height, height = _b === void 0 ? '46' : _b, _c = props.width, width = _c === void 0 ? '166' : _c, _d = props["aria-label"], ariaLabel = _d === void 0 ? 'Float Logo' : _d, svgProps = __rest(props, ["inverted", "height", "width", 'aria-label']);
    var color = inverted ? 'white' : '#111113';
    return (jsx("svg", __assign({ width: width, height: height, viewBox: "0 0 166 46", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-label": ariaLabel }, svgProps, { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M27.8116 31.6697H10.2308L7.19893 46H0L7.5274 10.6154H32.9645L31.5755 17.1109H13.3377L11.6198 25.1738H29.2011L27.8116 31.6697ZM41.6255 39.4035H58.8652L57.4381 46H32.9645L40.5551 10.6154H47.8154L41.6255 39.4035ZM68.4895 19.5793C68.4895 25.8045 72.6713 29.8112 78.6215 29.8112C85.5929 29.8112 90.4471 23.8636 90.4471 16.9595C90.4471 10.7596 86.2395 6.72761 80.3396 6.72761C73.3192 6.72761 68.4895 12.7005 68.4895 19.5793ZM97.7163 16.4802C97.7163 27.4172 89.6257 36.5641 78.1484 36.5641C68.4392 36.5641 61.2199 30.0121 61.2199 20.059C61.2199 9.14649 69.3109 0 80.7877 0C90.4966 0 97.7163 6.55071 97.7163 16.4802ZM113.736 31.2646H123.624L121.52 17.6664L113.736 31.2646ZM133.035 46H125.901L124.625 37.7602H110.031L105.326 46H97.7163L118.517 10.6154H127.003L133.035 46ZM164.612 17.2123H154.222L148.221 46H141.154L147.155 17.2123H136.567L137.956 10.6154H166L164.612 17.2123Z", fill: color }) })));
};

var TransportLogo = function (props) {
    var _a = props.inverted, inverted = _a === void 0 ? false : _a, _b = props.height, height = _b === void 0 ? '35' : _b, _c = props.width, width = _c === void 0 ? '356' : _c, _d = props["aria-label"], ariaLabel = _d === void 0 ? 'Transport Logo' : _d, svgProps = __rest(props, ["inverted", "height", "width", 'aria-label']);
    var color = inverted ? 'white' : '#111113';
    return (jsx("svg", __assign({ width: width, height: height, viewBox: "0 0 166 46", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-label": ariaLabel }, svgProps, { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.37715 0H29.1987L27.8216 6.32127H17.5144L11.562 33.9062H4.5511L10.5035 6.32127H0L1.37715 0ZM40.2208 6.24841L38.3866 14.5306H45.8004C50.9513 14.5306 52.2578 12.0851 52.2578 9.85665C52.2578 7.65335 50.399 6.24841 46.9806 6.24841H40.2208ZM47.8352 0C55.4249 0 59.5205 4.06763 59.5205 9.15488C59.5205 13.9985 56.4553 19.9079 46.5532 20.3911L56.2285 33.9062H48.0372L38.9389 20.4164H37.08L34.1136 33.9062H26.9527L34.4407 0H47.8352ZM73.0647 19.7861H82.8105L80.7372 6.75686L73.0647 19.7861ZM92.0883 33.9062H85.0551L83.7979 26.0106H69.4132L64.7744 33.9062H57.2744L77.7778 0H86.1423L92.0883 33.9062ZM126.246 33.9062H119.747L107.589 10.5598L102.504 33.9062H95.4574L102.851 0H109.376L121.507 23.3479L126.594 0H133.64L126.246 33.9062ZM162.49 9.3583C158.996 6.995 154.928 6.24729 151.983 6.24729C147.391 6.24729 145.544 8.298 145.544 10.445C145.544 12.7357 147.915 13.6775 151.01 14.255L153.107 14.6429C158.996 15.7031 163.412 18.3565 163.412 23.6635C163.412 30.5621 157.298 35 148.514 35C144.271 35 137.734 33.7709 133.64 30.272L137.657 24.8688C140.977 27.7887 145.943 28.7764 148.963 28.7764C152.882 28.7764 155.926 27.306 155.926 24.6038C155.926 22.4804 153.879 21.4927 149.787 20.7687L147.566 20.3585C141.876 19.3443 138.032 16.3783 138.032 11.3854C138.032 5.25958 142.873 0 152.159 0C156.325 0 161.343 0.747827 166.208 3.95517L162.49 9.3583ZM180.487 6.22458L178.494 15.3304H184.624C189.158 15.3304 191.601 13.4648 191.601 10.148C191.601 7.67717 189.856 6.22458 186.393 6.22458H180.487ZM177.148 21.506L174.431 33.9062H167.331L174.756 0H187.214C194.765 0 198.776 4.06751 198.776 9.42097C198.776 16.6863 193.468 21.506 184.274 21.506H177.148ZM209.303 18.7416C209.303 24.7 213.422 28.5365 219.28 28.5365C226.143 28.5365 230.924 22.8431 230.924 16.2346C230.924 10.2999 226.781 6.43973 220.971 6.43973C214.058 6.43973 209.303 12.1568 209.303 18.7416ZM238.082 15.7756C238.082 26.2444 230.116 35 218.814 35C209.254 35 202.145 28.7291 202.145 19.2005C202.145 8.75558 210.113 0 221.414 0C230.974 0 238.082 6.27092 238.082 15.7756ZM252.473 6.24841L250.639 14.5306H258.051C263.204 14.5306 264.51 12.0851 264.51 9.85665C264.51 7.65335 262.651 6.24841 259.233 6.24841H252.473ZM260.087 0C267.677 0 271.773 4.06763 271.773 9.15488C271.773 13.9985 268.708 19.9079 258.806 20.3911L268.481 33.9062H260.288L251.191 20.4164H249.332L246.366 33.9062H239.205L246.693 0H260.087ZM354.61 6.32154H292.826L286.816 33.9062H279.739L285.749 6.32154H275.142L276.534 0H356L354.61 6.32154Z", fill: color }) })));
};

var Logo$2 = function (_a) {
    var _b = _a.height, height = _b === void 0 ? '20' : _b, _c = _a.width, width = _c === void 0 ? '142' : _c, ariaLabel = _a.ariaLabel, svgProps = __rest(_a, ["height", "width", "ariaLabel"]);
    return (jsxs("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: width, height: height, fill: "none", "aria-label": ariaLabel, viewBox: "0 0 142 20" }, svgProps, { children: [jsxs("g", __assign({ clipPath: "url(#a)" }, { children: [jsxs("g", __assign({ clipPath: "url(#b)" }, { children: [jsx("path", { fill: "#000D33", d: "M80.178 6.143a8.877 8.877 0 0 0-.968-2.04l-3.62 2.04h4.588Z" }), jsx("path", { fill: "#003468", d: "M75.552 6.143h.039l3.62-2.04c-.92-1.426-2.223-2.506-3.8-3.2l-1.938 3.279a4.652 4.652 0 0 1 2.08 1.96Z" }), jsx("path", { fill: "#005BA8", d: "M70.84 3.618c.989 0 1.872.196 2.633.564L75.412.904C74.063.31 72.516 0 70.84 0c-.056 0-.11.006-.166.007v3.618c.056-.001.11-.007.166-.007Z" }), jsx("path", { fill: "#6DCFF6", d: "M62.36 4.228c-.919 1.328-1.52 2.912-1.693 4.686h4.16c.14-1.05.479-1.973.982-2.742l-3.45-1.944Z" }), jsx("path", { fill: "#238FCF", d: "M70.675 3.625V.007c-1.692.023-3.262.4-4.636 1.07l1.892 3.199c.802-.403 1.726-.629 2.744-.65Z" }), jsx("path", { fill: "#00A5E0", d: "m67.931 4.276-1.892-3.2a9.532 9.532 0 0 0-3.68 3.152l3.45 1.944a5.425 5.425 0 0 1 2.122-1.896Z" }), jsx("path", { fill: "#231F20", d: "m70.694 8.948 1.775 3.001h4.233c-.024.108-.053.212-.081.317-.358 1.36-1.065 2.448-2.087 3.175-.925.659-2.105 1.024-3.521 1.024-.115 0-.226-.007-.339-.011-1.46-.06-2.72-.509-3.698-1.286-.934-.742-1.609-1.781-1.956-3.067-.014-.051-.03-.1-.044-.152h-4.189c.137.767.364 1.489.655 2.169a9.389 9.389 0 0 0 3.632 4.266c1.58 1 3.494 1.575 5.6 1.608.066.002.129.008.194.008 2.114 0 3.956-.576 5.468-1.512a9.597 9.597 0 0 0 3.736-4.277 9.023 9.023 0 0 0 .595-1.84V8.948h-9.973Z" }), jsx("path", { fill: "#238FCF", d: "M70.694 8.948h-.04l-1.74 3.001h3.555l-1.775-3.001Z" }), jsx("path", { fill: "#231F20", d: "M78.51 18.376a.07.07 0 0 0-.03-.06.425.425 0 0 0-.125-.046.314.314 0 0 1-.132-.058.114.114 0 0 1-.038-.088c0-.037.016-.067.047-.09a.212.212 0 0 1 .126-.034c.064 0 .112.013.146.038.034.026.05.061.05.106h-.052c-.005-.037-.018-.061-.04-.075a.203.203 0 0 0-.104-.02c-.08 0-.12.024-.12.074 0 .025.009.044.027.06.018.014.06.03.124.047.065.016.11.036.135.059a.113.113 0 0 1 .039.087c0 .04-.016.07-.048.091a.238.238 0 0 1-.135.033.268.268 0 0 1-.151-.038.132.132 0 0 1-.062-.107h.052c.013.065.066.097.16.097.088 0 .131-.026.131-.076Zm.603-.275-.17.39h-.049l-.172-.403v.403h-.053v-.48h.073l.178.41.18-.41h.067v.48h-.054v-.39Z" })] })), jsx("path", { fill: "#231F20", fillRule: "evenodd", d: "M5.288 16.208h8.351l1.384 3.552h3.936L11.492 0H7.465L0 19.76h3.906l1.382-3.552Zm1.142-2.99 3.034-8.251 3.034 8.25H6.43Z", clipRule: "evenodd" }), jsx("path", { fill: "#231F20", d: "M29.483 19.76h3.553V4.966h-3.553v8.144c0 2.376-1.21 3.658-3.125 3.658-1.865 0-3.1-1.282-3.1-3.658V4.967H19.73v8.678c0 4.059 2.343 6.302 5.594 6.302 1.74 0 3.277-.801 4.159-2.056v1.869ZM35.865 1.147h3.554v3.82h3.125v3.07H39.42v7.156c0 .989.378 1.415 1.487 1.415h1.638v3.151h-2.217c-2.672 0-4.461-1.202-4.461-4.593V1.146Z" }), jsx("path", { fill: "#231F20", fillRule: "evenodd", d: "M44.01 12.363c0-4.673 3.15-7.637 7.182-7.637 4.033 0 7.183 2.964 7.183 7.637 0 4.646-3.226 7.637-7.284 7.637-4.032 0-7.081-2.99-7.081-7.637Zm3.578 0c0 2.937 1.613 4.38 3.503 4.38 1.865 0 3.655-1.443 3.654-4.38 0-2.964-1.739-4.379-3.604-4.379s-3.553 1.415-3.553 4.38Z", clipRule: "evenodd" }), jsx("path", { fill: "#231F20", d: "M82.585 4.967h3.529v2.296c.882-1.522 2.344-2.51 4.284-2.51V8.68h-.932c-2.092 0-3.352.854-3.352 3.711v7.37h-3.529V4.966Z" }), jsx("path", { fill: "#231F20", fillRule: "evenodd", d: "M102.709 7.076c-.832-1.228-2.37-2.35-4.613-2.35-3.553 0-6.376 2.964-6.376 7.584 0 4.62 2.823 7.69 6.351 7.69 2.218 0 3.806-1.122 4.638-2.403v2.162h3.553V4.967h-3.553v2.109Zm-7.385 5.234c0-2.804 1.79-4.3 3.68-4.3 1.941 0 3.705 1.55 3.704 4.353 0 2.804-1.763 4.352-3.704 4.352-1.89 0-3.68-1.602-3.68-4.405ZM115.037 4.726c1.84 0 3.604.908 4.562 2.297V0h3.579v19.76h-3.579v-2.19c-.832 1.362-2.394 2.43-4.587 2.43-3.553 0-6.376-3.07-6.376-7.69 0-4.62 2.823-7.584 6.401-7.584Zm.883 3.285c-1.891 0-3.68 1.495-3.68 4.299 0 2.803 1.79 4.405 3.68 4.405 1.941 0 3.704-1.548 3.704-4.352 0-2.804-1.764-4.352-3.704-4.352ZM125.551 12.363c0 4.646 2.949 7.637 7.006 7.637 3.453 0 5.772-2.163 6.527-4.886h-3.805c-.454.988-1.285 1.789-2.797 1.789-1.765 0-3.176-1.229-3.352-3.418h10.207c.075-.481.1-.962.1-1.442 0-4.406-2.847-7.317-6.88-7.317-4.133 0-7.006 2.964-7.006 7.637Zm10.232-1.389h-6.628c.278-2.029 1.613-3.177 3.301-3.177 1.815 0 3.277 1.228 3.327 3.177ZM140.042 19.576h.135v-.515h.227l.308.515h.158l-.326-.515c.147-.027.275-.118.275-.324 0-.208-.11-.321-.357-.321h-.42v1.16Zm.642-.84c0 .198-.163.203-.329.203h-.178v-.402h.247c.132 0 .26.038.26.2Z", clipRule: "evenodd" }), jsx("path", { fill: "#231F20", fillRule: "evenodd", d: "M140.385 20c.535 0 .948-.44.948-1.004 0-.564-.413-1.004-.948-1.004-.535 0-.948.44-.948 1.004 0 .564.413 1.004.948 1.004Zm0-.143c-.458 0-.799-.38-.799-.86 0-.482.341-.862.799-.862.459 0 .8.38.8.861 0 .48-.341.86-.8.86Z", clipRule: "evenodd" })] })), jsxs("defs", { children: [jsx("clipPath", __assign({ id: "a" }, { children: jsx("path", { fill: "#fff", d: "M0 0h141.333v20H0z" }) })), jsx("clipPath", __assign({ id: "b" }, { children: jsx("path", { fill: "#fff", d: "M60.667 0h20v20h-20z" }) }))] })] })));
};

var Logo$1 = function (_a) {
    var _b = _a.height, height = _b === void 0 ? '40' : _b, _c = _a.width, width = _c === void 0 ? '40' : _c, ariaLabel = _a.ariaLabel, svgProps = __rest(_a, ["height", "width", "ariaLabel"]);
    return (jsxs("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: width, height: height, fill: "none", "aria-label": ariaLabel, viewBox: "0 0 40 40" }, svgProps, { children: [jsx("path", { d: "M39.3561 12.2857C38.8673 10.8011 38.2148 9.43939 37.4198 8.20605L30.182 12.2857H39.3561Z", fill: "#000D33" }), jsx("path", { d: "M30.105 12.2856H30.182L37.4203 8.2059C35.5825 5.35489 32.9755 3.19364 29.8233 1.80713L25.9463 8.36327C27.698 9.209 29.1211 10.5147 30.105 12.2856Z", fill: "#003468" }), jsx("path", { d: "M20.6806 7.23656C22.6576 7.23656 24.4246 7.62837 25.9467 8.36342L29.8232 1.80727C27.1268 0.620637 24.0324 0 20.6806 0C20.5682 0 20.4606 0.0121419 20.3491 0.0140099V7.24963C20.4601 7.24777 20.5677 7.23656 20.6806 7.23656Z", fill: "#005BA8" }), jsx("path", { d: "M3.71861 8.45557C1.88225 11.1114 0.681129 14.279 0.333374 17.8286H8.65559C8.93303 15.7262 9.61179 13.882 10.6173 12.3433L3.71861 8.45557Z", fill: "#6DCFF6" }), jsx("path", { d: "M20.3491 7.25001V0.013916C16.9658 0.0606155 13.826 0.812945 11.0789 2.15322L14.8626 8.55105C16.465 7.74549 18.3143 7.29437 20.3491 7.25001Z", fill: "#238FCF" }), jsx("path", { d: "M14.8625 8.55164L11.0788 2.15381C8.0896 3.6127 5.57687 5.76788 3.71851 8.45544L10.6172 12.3436C11.6863 10.7068 13.1289 9.42352 14.8625 8.55164Z", fill: "#00A5E0" }), jsx("path", { d: "M20.3889 17.8967L23.9386 23.899H31.1186H32.4034C32.3565 24.1152 32.2977 24.3226 32.2422 24.5327C31.5256 27.2525 30.1131 29.4282 28.0687 30.8825C26.2189 32.1994 23.8588 32.9312 21.026 32.9312C20.7964 32.9312 20.574 32.9167 20.3492 32.9078C17.4284 32.7869 14.908 31.8907 12.9516 30.3365C11.0846 28.8529 9.73425 26.7738 9.04018 24.2026C9.01243 24.1003 8.97847 24.0027 8.95312 23.8985H0.574463C0.849032 25.4326 1.30202 26.8756 1.88417 28.236C3.41008 31.8038 5.9276 34.7286 9.14828 36.7685C12.3092 38.77 16.1354 39.9174 20.3492 39.9851C20.4793 39.9875 20.606 40.0005 20.7371 40.0005C24.9637 40.0005 28.6489 38.8485 31.672 36.9772C35.0922 34.8613 37.648 31.8174 39.1437 28.4228C39.6694 27.2282 40.0799 25.9954 40.3334 24.7415V17.8967H20.3889Z", fill: "#231F20" }), jsx("path", { d: "M20.3889 17.896H20.3492H20.309L16.8291 23.8988H23.9387L20.3889 17.896Z", fill: "#238FCF" }), jsx("path", { d: "M36.0209 36.7518C36.0209 36.7006 36.0006 36.6604 35.9601 36.6312C35.9191 36.6024 35.8363 36.5719 35.7104 36.5402C35.5849 36.5085 35.4968 36.4695 35.4461 36.4232C35.3955 36.3769 35.3704 36.3184 35.3704 36.2482C35.3704 36.173 35.4016 36.1129 35.4646 36.0678C35.5272 36.0227 35.6113 36 35.717 36C35.8434 36 35.9407 36.0256 36.0081 36.0768C36.0759 36.1279 36.109 36.1982 36.1081 36.2876H36.0037C35.9945 36.2149 35.968 36.1649 35.9231 36.1377C35.8786 36.1105 35.8099 36.0967 35.717 36.0967C35.5558 36.0967 35.4752 36.1466 35.4752 36.2465C35.4752 36.2953 35.4933 36.3347 35.5302 36.3643C35.5668 36.394 35.6496 36.4257 35.7787 36.459C35.9077 36.4923 35.9975 36.5321 36.0486 36.5776C36.0993 36.6235 36.1253 36.6816 36.1253 36.7518C36.1253 36.8302 36.0936 36.8916 36.0301 36.9346C35.9667 36.9781 35.8764 37 35.7593 37C35.6342 37 35.5333 36.9748 35.4571 36.924C35.3809 36.8737 35.3395 36.8026 35.3334 36.7108H35.4378C35.4637 36.8392 35.5708 36.9037 35.7588 36.9037C35.9337 36.9033 36.0209 36.853 36.0209 36.7518ZM37.2268 36.2019L36.8877 36.9817H36.789L36.4446 36.1767V36.9817H36.338V36.0232H36.4833L36.8397 36.8424L37.1995 36.0232H37.3334V36.9817H37.2268V36.2019Z", fill: "#231F20" })] })));
};

var logoVariants = {
    default: Logo$2,
    condensed: Logo$1
};
var AutoGradeLogo = function (_a) {
    var height = _a.height, width = _a.width, _b = _a.variant, variant = _b === void 0 ? 'default' : _b;
    var Logo = logoVariants[variant];
    return jsx(Logo, { height: height, width: width, variant: variant });
};

/* eslint-disable @typescript-eslint/no-empty-function */
var initialState$1 = {
    notifications: null,
    unreadNotifications: null,
    pendingCheckoutItems: null,
    loadingNotifications: false,
    loadingGroupAccounts: false,
    user: null,
    groupAccounts: null,
    currentPath: '',
    enableChangeAccount: false,
    handleNavigate: function () { },
    handleLogout: function () { },
    handleDeleteNotification: function () { },
    handleDeleteAllNotifications: function () { },
    handleReadAllNotifications: function () { },
    handleClearUnreadNotifications: function () { },
    handleSetNotifications: function () { },
    handleChangeAccount: function () { },
    handleSetGroupAccounts: function () { }
};
var NavigationContext = createContext(initialState$1);
var useNavigationContext = function () { return useContext(NavigationContext); };

var initialWindowSize = {
    width: null,
    height: null
};
var useWindowSize = function () {
    var _a = useState(initialWindowSize), windowSize = _a[0], setWindowSize = _a[1];
    var handleResize = function () {
        setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
        });
    };
    useEffect(handleResize, []);
    useResize(handleResize);
    return windowSize;
};

var viewports = {
    desktop: 'desktop',
    tablet: 'tablet',
    mobile: 'mobile'
};
var viewportsMinWidth = {
    desktop: 1281,
    tablet: 993,
    mobile: 0
};

var HeaderContainer = styled(FlexBox).attrs({
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: spacingActionPadding.spacingActionPaddingLg,
    background: colorSurface.primary
})(templateObject_1$S || (templateObject_1$S = __makeTemplateObject(["\n  border-top: 4px solid ", ";\n  box-shadow: ", ";\n  box-sizing: border-box;\n  cursor: auto;\n  position: sticky;\n  top: 0;\n  width: 485px;\n  z-index: 2;\n\n  @media (max-width: ", "px) {\n    width: 100%;\n  }\n"], ["\n  border-top: 4px solid ", ";\n  box-shadow: ", ";\n  box-sizing: border-box;\n  cursor: auto;\n  position: sticky;\n  top: 0;\n  width: 485px;\n  z-index: 2;\n\n  @media (max-width: ", "px) {\n    width: 100%;\n  }\n"])), colorBorder$1.colorBorderBorderBrand, shadow.larger, viewportsMinWidth.tablet);
var IconCloseContainer$1 = styled(FlexBox).attrs({
    padding: "0 0 0 ".concat(spacingActionPadding.spacingActionPaddingSm)
})(templateObject_2$o || (templateObject_2$o = __makeTemplateObject(["\n  cursor: pointer;\n"], ["\n  cursor: pointer;\n"])));
var templateObject_1$S, templateObject_2$o;

var CustomDropdownHeader = function (_a) {
    var title = _a.title, children = _a.children, onClose = _a.onClose;
    return (jsxs(HeaderContainer, { children: [jsx(Headline, __assign({ size: "H4" }, { children: title })), jsxs(FlexBox, __assign({ alignItems: "center", justifyContent: "center" }, { children: [children, jsx(IconCloseContainer$1, __assign({ alignItems: "center", onClick: onClose, "data-testid": "close-".concat(title) }, { children: jsx(Icon, { name: "close" }) }))] }))] }));
};

var NAVIGATION_HEIGHT = 56;
styled(FlexBox).attrs({
    height: NAVIGATION_HEIGHT,
    width: '100%'
})(templateObject_1$R || (templateObject_1$R = __makeTemplateObject(["\n  box-shadow: ", ";\n"], ["\n  box-shadow: ", ";\n"])), shadow.larger);
var OverlayedBox = styled.div(templateObject_2$n || (templateObject_2$n = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n  ", "\n"])), baseStyle, hoverStyle, activeStyle);
var templateObject_1$R, templateObject_2$n;

// eslint-disable-next-line prettier/prettier
var CustomDropdownContainer = styled(FlexBox)(templateObject_1$Q || (templateObject_1$Q = __makeTemplateObject(["\n  flex-direction: column;\n  background: ", ";\n  box-shadow: ", ";\n  overflow: scroll;\n  position: fixed;\n  right: 0;\n  top: ", "px;\n  min-width: 172px;\n  ", "\n  z-index: ", ";\n  ", "\n  ", "\n  @media (max-width: ", "px) {\n    width: 100%;\n  }\n"], ["\n  flex-direction: column;\n  background: ", ";\n  box-shadow: ", ";\n  overflow: scroll;\n  position: fixed;\n  right: 0;\n  top: ", "px;\n  min-width: 172px;\n  ", "\n  z-index: ", ";\n  ", "\n  ", "\n  @media (max-width: ", "px) {\n    width: 100%;\n  }\n"])), colorSurface.primary, shadow.larger, NAVIGATION_HEIGHT, function (_a) {
    var isMobileViewport = _a.isMobileViewport;
    return isMobileViewport && 'width: 100%;';
}, zIndexMap.navigationBar, hideScrollBarStyle, "height: calc(100vh - ".concat(NAVIGATION_HEIGHT, "px);"), viewportsMinWidth.tablet);
var templateObject_1$Q;

var NoRecordsContainer = styled(FlexBox).attrs({
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
})(templateObject_1$P || (templateObject_1$P = __makeTemplateObject(["\n  width: 485px;\n  flex: 1;\n\n  @media (max-width: ", "px) {\n    width: 100%;\n  }\n"], ["\n  width: 485px;\n  flex: 1;\n\n  @media (max-width: ", "px) {\n    width: 100%;\n  }\n"])), viewportsMinWidth.tablet);
var templateObject_1$P;

var NoRecordsFound = function (_a) {
    var title = _a.title, text = _a.text, icon = _a.icon;
    return (jsxs(NoRecordsContainer, { children: [jsx(FlexBox, { children: icon }), jsxs(FlexBox, __assign({ flexDirection: "column", justifyContent: "center", alignItems: "center" }, { children: [jsx(FlexBox, __assign({ padding: spacingActionPadding.spacingActionPaddingMd }, { children: jsx(Headline, __assign({ size: "H4", color: "colorTextTextSecondary" }, { children: title })) })), jsx(Body, __assign({ color: "colorTextTextSecondary" }, { children: text }))] }))] }));
};

var LoaderContainer = styled(FlexBox).attrs({
    height: '100vh',
    alignItems: 'center',
    justifyContent: 'center',
    width: '485px'
})(templateObject_1$O || (templateObject_1$O = __makeTemplateObject(["\n  box-sizing: border-box;\n  @media (max-width: ", "px) {\n    width: 100%;\n  }\n"], ["\n  box-sizing: border-box;\n  @media (max-width: ", "px) {\n    width: 100%;\n  }\n"])), viewportsMinWidth.tablet);
var NotificationIcon = styled(Icon)(templateObject_2$m || (templateObject_2$m = __makeTemplateObject(["\n  svg {\n    height: 77px;\n    width: 77px;\n  }\n"], ["\n  svg {\n    height: 77px;\n    width: 77px;\n  }\n"])));
var templateObject_1$O, templateObject_2$m;

var AccountItemContainer = styled(FlexBox).attrs({
    padding: spacingActionPadding.spacingActionPaddingLg,
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    background: 'white'
})(templateObject_1$N || (templateObject_1$N = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var active = _a.active;
    return "\n  border-bottom: 1px solid ".concat(colorBorder$1.colorBorderBorderSecondary, ";\n  cursor: ").concat(active ? 'inherit' : 'pointer', ";\n  pointer-events: ").concat(active ? 'none' : 'inherit', ";\n    &:hover {\n      background: ").concat(active ? colorSurface.primary : colorSurface.secondary, ";\n    }\n  ");
});
var ChangeAccountList = styled(FlexBox).attrs({ flexDirection: 'column' })(templateObject_2$l || (templateObject_2$l = __makeTemplateObject(["\n  flex: 1;\n"], ["\n  flex: 1;\n"])));
var templateObject_1$N, templateObject_2$l;

var AccountItem = function (_a) {
    var account = _a.account, active = _a.active, handleChangeAccount = _a.handleChangeAccount;
    return (jsxs(AccountItemContainer, __assign({ active: active, onClick: function () { return handleChangeAccount(account.id); } }, { children: [jsxs(FlexBox, __assign({ flexDirection: "column", gap: spacingActionGap.spacingActionGapMd }, { children: [jsxs(Body, __assign({ color: "colorTextTextPrimary", bold: true }, { children: [account.dealership_name, " ", account.active_vehicles > 0 ? "(".concat(account.active_vehicles, ")") : ''] })), jsx(FlexBox, { children: jsxs(Body, __assign({ size: "smaller", color: "colorTextTextSecondary" }, { children: [account.first_name, " ", account.last_name] })) })] })), active && jsx(Icon, { name: "check", size: "smaller" })] })));
};
var ChangeAccountBody = function (_a) {
    var accounts = _a.accounts;
    var _b = useNavigationContext(), user = _b.user, loadingGroupAccounts = _b.loadingGroupAccounts, handleChangeAccount = _b.handleChangeAccount;
    if (loadingGroupAccounts) {
        return (jsx(LoaderContainer, { children: jsx(BlcLoader, {}) }));
    }
    if (accounts && accounts.length > 0) {
        return (jsx(ChangeAccountList, __assign({ padding: "none" }, { children: accounts.map(function (account, i) {
                var _a;
                var active = ((_a = user === null || user === void 0 ? void 0 : user.on_behalf_of) === null || _a === void 0 ? void 0 : _a.dealership_id) === account.id;
                return jsx(AccountItem, { account: account, active: active, handleChangeAccount: handleChangeAccount }, i);
            }) })));
    }
    return jsx(NoRecordsFound, { text: "There are no accounts in the group" });
};
var ChangeAccount = function (_a) {
    var accounts = _a.accounts, handleClose = _a.handleClose;
    return (jsxs(CustomDropdownContainer, __assign({ isMobileViewport: false }, { children: [jsx(CustomDropdownHeader, { onClose: handleClose, title: "Change account" }), jsx(ChangeAccountBody, { accounts: accounts })] })));
};

/* eslint-disable @typescript-eslint/no-explicit-any */
var useIsComponentVisible = function (initialIsVisible, handleClose) {
    var _a = useState(initialIsVisible), isComponentVisible = _a[0], setIsComponentVisible = _a[1];
    var ref = useRef(null);
    var handleClickOutside = function (event) {
        if (ref.current && !ref.current.contains(event.target)) {
            setIsComponentVisible(false);
            handleClose && handleClose();
        }
    };
    useEffect(function () {
        if (isComponentVisible) {
            document.addEventListener('click', handleClickOutside, true);
        }
        return function () {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, [isComponentVisible]);
    return { ref: ref, isComponentVisible: isComponentVisible, setIsComponentVisible: setIsComponentVisible };
};

var NavItemOverLayedBox = styled.div(templateObject_1$M || (templateObject_1$M = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n  ", "\n"])), baseStyle, hoverStyle, activeStyle);
var Item$1 = styled(NavItemOverLayedBox)(templateObject_2$k || (templateObject_2$k = __makeTemplateObject(["\n  display: flex;\n  gap: 8px;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 0 16px;\n  background: ", ";\n  position: relative;\n  cursor: pointer;\n  box-sizing: border-box;\n  white-space: nowrap;\n  ", "\n  text-decoration: none;\n  @media (max-width: ", "px) {\n    padding: 0;\n    gap: 0;\n  }\n"], ["\n  display: flex;\n  gap: 8px;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 0 16px;\n  background: ", ";\n  position: relative;\n  cursor: pointer;\n  box-sizing: border-box;\n  white-space: nowrap;\n  ", "\n  text-decoration: none;\n  @media (max-width: ", "px) {\n    padding: 0;\n    gap: 0;\n  }\n"])), colorSurface.primary, function (_a) {
    var height = _a.height;
    return "height: ".concat(getSizeValue(height), ";");
}, viewportsMinWidth.tablet);
var Figure$1 = styled.div(templateObject_3$b || (templateObject_3$b = __makeTemplateObject(["\n  width: 0;\n  height: 0;\n  border-left: 10px solid ", ";\n  border-right: 10px solid ", ";\n  border-top: 8px solid ", ";\n  position: absolute;\n  bottom: -6px;\n  right: 5px;\n  z-index: 1;\n"], ["\n  width: 0;\n  height: 0;\n  border-left: 10px solid ", ";\n  border-right: 10px solid ", ";\n  border-top: 8px solid ", ";\n  position: absolute;\n  bottom: -6px;\n  right: 5px;\n  z-index: 1;\n"])), customColors.transparent, customColors.transparent, colorBorder$1.colorBorderBorderBrand);
var LineContainer$2 = styled.div(templateObject_4$5 || (templateObject_4$5 = __makeTemplateObject(["\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n"], ["\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n"])));
var templateObject_1$M, templateObject_2$k, templateObject_3$b, templateObject_4$5;

var Text = styled(Body)(templateObject_1$L || (templateObject_1$L = __makeTemplateObject(["\n  ", "\n  font-weight: ", ";\n"], ["\n  ", "\n  font-weight: ", ";\n"])), function (_a) {
    var disabled = _a.disabled;
    return "\n      cursor: ".concat(disabled ? 'not-allowed' : 'pointer', ";\n      ").concat(disabled ? 'pointer-events: none;' : '', "\n  ");
}, weightMap$1.bold);
var templateObject_1$L;

var ClearAll = function (_a) {
    var _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    return (jsx(Text, __assign({ textDecoration: "underline", disabled: disabled, color: disabled ? 'colorTextTextSecondary' : 'colorTextTextPrimary' }, { children: "Clear All" })));
};

var baseIconStyles = css(templateObject_1$K || (templateObject_1$K = __makeTemplateObject(["\n  ", "\n  background-color: ", ";\n  border-radius: 24px;\n  padding: 1px;\n  box-sizing: border-box;\n"], ["\n  ", "\n  background-color: ", ";\n  border-radius: 24px;\n  padding: 1px;\n  box-sizing: border-box;\n"])), function (_a) {
    var _b = _a.position, position = _b === void 0 ? 'relative' : _b, _c = _a.top, top = _c === void 0 ? 'inherit' : _c, _d = _a.right, right = _d === void 0 ? 'inherit' : _d, _e = _a.margin, margin = _e === void 0 ? 0 : _e;
    return "\n    margin: ".concat(margin, ";\n    position: ").concat(position, ";\n    top: ").concat(top, ";\n    right: ").concat(right, ";\n  ");
}, colorIcon.colorIconIconAlert);
var StyledIcon = styled(Icon)(templateObject_2$j || (templateObject_2$j = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), baseIconStyles);
var templateObject_1$K, templateObject_2$j;

var StyledContainer = styled.div(templateObject_1$J || (templateObject_1$J = __makeTemplateObject(["\n  min-width: 16px;\n  height: 16px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: ", ";\n  font-size: ", ";\n  font-family: ", ";\n  ", "\n  padding: 0 2px;\n"], ["\n  min-width: 16px;\n  height: 16px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: ", ";\n  font-size: ", ";\n  font-family: ", ";\n  ", "\n  padding: 0 2px;\n"])), colorText.colorTextTextInvert, fontMap.smaller.fontSize, fontFamily, baseIconStyles);
var templateObject_1$J;

var NotificationsNumber = function (_a) {
    var number = _a.number, position = _a.position, _b = _a.top, top = _b === void 0 ? '10px' : _b, _c = _a.right, right = _c === void 0 ? '10px' : _c;
    var displayNumber = !number ? '' : number >= 100 ? '99+' : number;
    return (jsx(StyledContainer, __assign({ position: position, top: top, right: right }, { children: displayNumber })));
};

var relativeTimeExports = {};
var relativeTime$1 = {
  get exports(){ return relativeTimeExports; },
  set exports(v){ relativeTimeExports = v; },
};

(function (module, exports) {
	!function(r,e){module.exports=e();}(commonjsGlobal,(function(){return function(r,e,t){r=r||{};var n=e.prototype,o={future:"in %s",past:"%s ago",s:"a few seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"};function i(r,e,t,o){return n.fromToBase(r,e,t,o)}t.en.relativeTime=o,n.fromToBase=function(e,n,i,d,u){for(var f,a,s,l=i.$locale().relativeTime||o,h=r.thresholds||[{l:"s",r:44,d:"second"},{l:"m",r:89},{l:"mm",r:44,d:"minute"},{l:"h",r:89},{l:"hh",r:21,d:"hour"},{l:"d",r:35},{l:"dd",r:25,d:"day"},{l:"M",r:45},{l:"MM",r:10,d:"month"},{l:"y",r:17},{l:"yy",d:"year"}],m=h.length,c=0;c<m;c+=1){var y=h[c];y.d&&(f=d?t(e).diff(i,y.d,!0):i.diff(e,y.d,!0));var p=(r.rounding||Math.round)(Math.abs(f));if(s=f>0,p<=y.r||!y.r){p<=1&&c>0&&(y=h[c-1]);var v=l[y.l];u&&(p=u(""+p)),a="string"==typeof v?v.replace("%d",p):v(p,n,y.l,s);break}}if(n)return a;var M=s?l.future:l.past;return "function"==typeof M?M(a):M.replace("%s",a)},n.to=function(r,e){return i(r,e,this,!0)},n.from=function(r,e){return i(r,e,this)};var d=function(r){return r.$u?t.utc():t()};n.toNow=function(r){return this.to(d(this),r)},n.fromNow=function(r){return this.from(d(this),r)};}}));
} (relativeTime$1));

var relativeTime = relativeTimeExports;

var TextContainer = styled.div(templateObject_1$I || (templateObject_1$I = __makeTemplateObject(["\n  font-size: ", ";\n  list-style: none outside none;\n  text-shadow: none;\n  box-sizing: inherit;\n  color: ", ";\n  font-family: ", ";\n  width: 100%;\n\n  a {\n    text-decoration: underline;\n    color: ", ";\n  }\n"], ["\n  font-size: ", ";\n  list-style: none outside none;\n  text-shadow: none;\n  box-sizing: inherit;\n  color: ", ";\n  font-family: ", ";\n  width: 100%;\n\n  a {\n    text-decoration: underline;\n    color: ", ";\n  }\n"])), fontMap.normal.fontSize, colorText.colorTextTextPrimary, fontFamily, colorTextLink.colorTextLinkLinkPrimary);
var NotificationContainer = styled(FlexBox)(templateObject_2$i || (templateObject_2$i = __makeTemplateObject(["\n  white-space: break-spaces;\n  cursor: initial;\n  width: 485px;\n  border-bottom: 1px solid ", ";\n\n  @media (max-width: ", "px) {\n    width: 100%;\n  }\n"], ["\n  white-space: break-spaces;\n  cursor: initial;\n  width: 485px;\n  border-bottom: 1px solid ", ";\n\n  @media (max-width: ", "px) {\n    width: 100%;\n  }\n"])), colorBorder$1.colorBorderBorderSecondary, viewportsMinWidth.tablet);
var IconCloseContainer = styled(FlexBox).attrs({
    alignItems: 'center'
})(templateObject_3$a || (templateObject_3$a = __makeTemplateObject(["\n  cursor: pointer;\n"], ["\n  cursor: pointer;\n"])));
var ActiveDot = styled.div(templateObject_4$4 || (templateObject_4$4 = __makeTemplateObject(["\n  width: 8px;\n  height: 8px;\n  background: ", ";\n  border-radius: 100px;\n"], ["\n  width: 8px;\n  height: 8px;\n  background: ", ";\n  border-radius: 100px;\n"])), colorIcon.colorIconIconBrand);
var templateObject_1$I, templateObject_2$i, templateObject_3$a, templateObject_4$4;

dayjs.extend(relativeTime);
var NotificationItem = function (_a) {
    var _b;
    var notification = _a.notification, handleDelete = _a.handleDelete, markAsRead = _a.markAsRead;
    var read = markAsRead || (notification === null || notification === void 0 ? void 0 : notification.read);
    var __html = notification === null || notification === void 0 ? void 0 : notification.message;
    var activityId = notification === null || notification === void 0 ? void 0 : notification.activity;
    return (jsxs(NotificationContainer, __assign({ background: read ? colorSurface.secondary : colorSurface.primary }, { children: [jsxs(FlexBox, __assign({ padding: spacingActionPadding.spacingActionPaddingLg, gap: spacingActionGap.spacingActionGapMd, alignItems: "center", width: "100%" }, { children: [jsx(FlexBox, { children: !read ? jsx(ActiveDot, { "data-testid": "unread-notification" }) : jsx(FlexBox, { width: "8px" }) }), jsx(FlexBox, __assign({ width: "100%" }, { children: jsxs(FlexBox, __assign({ flexDirection: "column", alignItems: "flex-start", gap: spacingActionGap.spacingActionGapMd, width: "100%" }, { children: [jsxs(FlexBox, __assign({ width: "100%" }, { children: [__html && jsx(TextContainer, { dangerouslySetInnerHTML: { __html: __html } }), jsx(IconCloseContainer, __assign({ onClick: function () { return handleDelete(activityId); }, "data-testid": "activity-".concat(activityId) }, { children: jsx(Icon, { name: "close", size: "smaller", color: "colorIconIconPrimary" }) }))] })), jsx(FlexBox, { children: jsx(Body, __assign({ color: "colorTextTextSecondary", type: "caption" }, { children: dayjs((_b = notification.options) === null || _b === void 0 ? void 0 : _b.message_time).fromNow() })) })] })) }))] })), jsx(Line$1, { margin: "none" })] })));
};

var NotificationsBody = function (_a) {
    var notifications = _a.notifications, loadingNotifications = _a.loadingNotifications, handleDelete = _a.handleDelete, unreadNotifications = _a.unreadNotifications;
    if (loadingNotifications) {
        return (jsx(LoaderContainer, { children: jsx(BlcLoader, {}) }));
    }
    if (notifications && notifications.length > 0) {
        return (jsx("div", { children: notifications.map(function (notification, index) { return (jsx(NotificationItem, { notification: notification, markAsRead: unreadNotifications === 0, handleDelete: handleDelete }, "notification-".concat(index))); }) }));
    }
    return (jsx(NoRecordsFound, { title: "You're all set", text: "You don't have any notifications", icon: jsx(NotificationIcon, { name: "notification", color: "colorIconIconSecondary", size: "largest" }) }));
};

var DropdownHeader = function (_a) {
    var disableClearAll = _a.disableClearAll, handleClose = _a.handleClose;
    var handleDeleteAllNotifications = useNavigationContext().handleDeleteAllNotifications;
    return (jsx(CustomDropdownHeader, __assign({ onClose: handleClose, title: "Notifications" }, { children: jsx("div", __assign({ onClick: disableClearAll ? undefined : handleDeleteAllNotifications }, { children: jsx(ClearAll, { disabled: disableClearAll }) })) })));
};
var Dropdown$2 = function (_a) {
    var isMobileViewport = _a.isMobileViewport, notifications = _a.notifications, handleClose = _a.handleClose, handleDeleteNotification = _a.handleDeleteNotification, loadingNotifications = _a.loadingNotifications, unreadNotifications = _a.unreadNotifications;
    return (jsxs(CustomDropdownContainer, __assign({ isMobileViewport: isMobileViewport }, { children: [!isMobileViewport && jsx(DropdownHeader, { disableClearAll: !(notifications === null || notifications === void 0 ? void 0 : notifications.length), handleClose: handleClose }), jsx(NotificationsBody, { handleDelete: handleDeleteNotification, loadingNotifications: loadingNotifications, notifications: notifications, unreadNotifications: unreadNotifications })] })));
};
var Notifications = function (_a) {
    var viewport = _a.viewport;
    var _b = useNavigationContext(), handleClearUnreadNotifications = _b.handleClearUnreadNotifications, handleDeleteNotification = _b.handleDeleteNotification, handleReadAllNotifications = _b.handleReadAllNotifications, handleSetNotifications = _b.handleSetNotifications, loadingNotifications = _b.loadingNotifications, notifications = _b.notifications, unreadNotifications = _b.unreadNotifications;
    var hasUnreadNotifications = Boolean(unreadNotifications);
    var _c = useIsComponentVisible(false, function () { return hasUnreadNotifications && handleClearUnreadNotifications(); }), ref = _c.ref, isComponentVisible = _c.isComponentVisible, setIsComponentVisible = _c.setIsComponentVisible;
    var isMobileViewport = viewport === viewports.mobile;
    var toggleDropdown = isComponentVisible || isMobileViewport;
    var openDropdown = function () {
        if (!isComponentVisible || isMobileViewport) {
            if (!notifications) {
                handleSetNotifications();
            }
            setIsComponentVisible(true);
            if (hasUnreadNotifications) {
                handleReadAllNotifications();
            }
        }
    };
    var handleClose = function () {
        setIsComponentVisible(false);
        if (hasUnreadNotifications) {
            handleClearUnreadNotifications();
        }
    };
    return (jsxs(Item$1, __assign({ visible: isComponentVisible, ref: ref, onClick: openDropdown, height: NAVIGATION_HEIGHT }, { children: [jsx(Icon, { name: "notification", color: toggleDropdown ? 'colorIconIconBrand' : 'colorIconIconPrimary', size: "normal" }), hasUnreadNotifications && jsx(NotificationsNumber, { number: unreadNotifications, position: "absolute" }), toggleDropdown && (jsx(Dropdown$2, { isMobileViewport: isMobileViewport, notifications: notifications, handleClose: handleClose, handleDeleteNotification: handleDeleteNotification, loadingNotifications: loadingNotifications, unreadNotifications: unreadNotifications }))] })));
};

var isDevelopment = function () {
    return typeof window !== 'undefined'
        ? window.location.hostname === 'localhost'
        : process.env.NODE_ENV === 'development';
};

/* eslint-disable camelcase */
var getGroupListingsParams = function (params) {
    var queryParams = new URLSearchParams();
    Object.entries(params).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        if (value) {
            queryParams.append(key, value);
        }
    });
    return queryParams.toString();
};
var checkValidPath = function (path) { return path && path !== '#'; };
var prodRoutes = {
    none: '#',
    group_listings: function (params) { return "/search?".concat(getGroupListingsParams(params)); },
    search: '/search',
    private_marketplace: '/search?private_marketplace_sale_only=true',
    my_offers: '/search?tab=marketplace_offers',
    watchlist: '/search?tab=marketplace_watchlist',
    auction_seller: '/webapp/inventory/auction',
    auction_buyer: '/auction',
    checkout: '/checkouts/edit',
    orders: '/purchases',
    vehicles: '/inventory/vehicles',
    sold_vehicles: '/sales',
    transport: '/transport/dashboard',
    change_account: '/change-account',
    title_clerk: '/title_clerks',
    gtv_offers: '/gtv_offers',
    settings: '/users/settings',
    referrals: '/referrals',
    home: '/',
    refer_a_friend: '/refer_a_friend'
};
var WEBAPP_URL = 'http://localhost:3001';
var RAILS_URL = 'http://localhost:3000';
var devRoutes = {
    none: '#',
    group_listings: function (params) { return "".concat(WEBAPP_URL, "/search?").concat(getGroupListingsParams(params)); },
    search: "".concat(WEBAPP_URL, "/search"),
    private_marketplace: "".concat(WEBAPP_URL, "/search?private_marketplace_sale_only=true"),
    my_offers: "".concat(WEBAPP_URL, "/search?tab=marketplace_offers"),
    watchlist: "".concat(WEBAPP_URL, "/search?tab=marketplace_watchlist"),
    auction_seller: "".concat(WEBAPP_URL, "/timed_sale_sellside"),
    auction_buyer: "".concat(WEBAPP_URL, "/timed_sale"),
    checkout: "".concat(RAILS_URL, "/checkouts/edit"),
    orders: "".concat(RAILS_URL, "/purchases"),
    vehicles: "".concat(RAILS_URL, "/inventory/vehicles"),
    sold_vehicles: "".concat(RAILS_URL, "/sales"),
    transport: "".concat(WEBAPP_URL, "/transport/dashboard"),
    change_account: "".concat(RAILS_URL, "/change-account"),
    title_clerk: "".concat(RAILS_URL, "/title_clerks"),
    gtv_offers: "".concat(WEBAPP_URL, "/gtv_offers"),
    settings: "".concat(RAILS_URL, "/users/settings"),
    referrals: "".concat(RAILS_URL, "/referrals"),
    home: "".concat(RAILS_URL, "/"),
    refer_a_friend: "".concat(WEBAPP_URL, "/refer_a_friend")
};
var routes = isDevelopment() ? devRoutes : prodRoutes;

var StyledDropdownItem$1 = styled(OverlayedBox)(templateObject_1$H || (templateObject_1$H = __makeTemplateObject(["\n  ", "\n  box-sizing: border-box;\n  width: 200px;\n  padding: 12px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  text-decoration: none;\n"], ["\n  ", "\n  box-sizing: border-box;\n  width: 200px;\n  padding: 12px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  text-decoration: none;\n"])), function (_a) {
    var background = _a.background;
    return "\n    background-color: ".concat(getLegacyColor(background) || colorSurface.primary, ";\n  ");
});
var templateObject_1$H;

var DropdownItem$1 = function (_a) {
    var background = _a.background, label = _a.label, labelColor = _a.labelColor, path = _a.path, icon = _a.icon, onClick = _a.onClick;
    var currentPath = useNavigationContext().currentPath;
    var hasValidPath = checkValidPath(path);
    var active = currentPath === path;
    return (jsxs(StyledDropdownItem$1, __assign({ as: hasValidPath ? 'a' : 'div', href: path, background: active ? 'dropDownActive' : background, onClick: onClick }, { children: [jsx(Button, __assign({ labelColor: labelColor, variant: "text" }, { children: label })), icon && icon] })));
};

var Figure = styled.div(templateObject_1$G || (templateObject_1$G = __makeTemplateObject(["\n  width: 0;\n  height: 0;\n  border-left: 10px solid ", ";\n  border-right: 10px solid ", ";\n  border-top: 8px solid ", ";\n  position: absolute;\n  bottom: -6px;\n  right: 5px;\n  z-index: ", ";\n"], ["\n  width: 0;\n  height: 0;\n  border-left: 10px solid ", ";\n  border-right: 10px solid ", ";\n  border-top: 8px solid ", ";\n  position: absolute;\n  bottom: -6px;\n  right: 5px;\n  z-index: ", ";\n"])), customColors.transparent, customColors.transparent, colorBorder$1.colorBorderBorderBrand, zIndexMap.navigationBar);
var LineContainer$1 = styled.div(templateObject_2$h || (templateObject_2$h = __makeTemplateObject(["\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n"], ["\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n"])));
var DropdownContent$1 = styled.div(templateObject_3$9 || (templateObject_3$9 = __makeTemplateObject(["\n  text-align: center;\n  min-width: 160px;\n  box-shadow: ", ";\n  position: absolute;\n  right: 0;\n  top: ", "px;\n  z-index: ", ";\n"], ["\n  text-align: center;\n  min-width: 160px;\n  box-shadow: ", ";\n  position: absolute;\n  right: 0;\n  top: ", "px;\n  z-index: ", ";\n"])), shadow.larger, NAVIGATION_HEIGHT, zIndexMap.navigationBar);
var templateObject_1$G, templateObject_2$h, templateObject_3$9;

var Dropdown$1 = function (_a) {
    var handleNavigate = _a.handleNavigate, handleDropdownItemClick = _a.handleDropdownItemClick, items = _a.items, isVisible = _a.isVisible;
    var isArray = Array.isArray(items);
    return isVisible ? (jsxs(Fragment, { children: [jsx(DropdownContent$1, { children: isArray
                    ? items.map(function (item, i) {
                        var name = item.name, styles = item.styles, target = item.target, icon = item.icon, path = item.path, enabled = item.enabled;
                        if (!enabled)
                            return null;
                        return (jsx(DropdownItem$1, { label: name, path: path, icon: isValidElement(icon) && icon, onClick: function () {
                                if ((item === null || item === void 0 ? void 0 : item.path) && handleNavigate) {
                                    handleNavigate({ path: item.path, target: target });
                                }
                                if (handleDropdownItemClick) {
                                    handleDropdownItemClick(item);
                                }
                            }, background: styles === null || styles === void 0 ? void 0 : styles.background, labelColor: (styles === null || styles === void 0 ? void 0 : styles.color) || 'navBarFont' }, "".concat(name, "-").concat(i)));
                    })
                    : items }), jsx(Figure, {}), jsx(LineContainer$1, { children: jsx(Line$1, { orientation: "horizontal", color: "primary", lineWidth: "4px", margin: "none" }) })] })) : null;
};

var ExclamationIcon = function (_a) {
    var position = _a.position, top = _a.top, right = _a.right, margin = _a.margin;
    return (jsx(StyledIcon, { position: position, top: top, right: right, margin: margin, name: "alert", size: "smaller", color: "white" }));
};

var getCurrentPath = function (mockedPath) {
    return typeof window !== 'undefined' ? mockedPath || window.location.pathname + window.location.search : undefined;
};

var matchRoute = function (path, currentPath) {
    return Boolean(path && currentPath && currentPath.includes(path));
};
var findActiveItem = function (items, mockedPath) {
    var currentPath = getCurrentPath(mockedPath);
    if (!currentPath)
        return null;
    for (var _i = 0, _a = Object.keys(items); _i < _a.length; _i++) {
        var key = _a[_i];
        var sectionItems = items[key].items;
        for (var _b = 0, sectionItems_1 = sectionItems; _b < sectionItems_1.length; _b++) {
            var item = sectionItems_1[_b];
            if (matchRoute(item.path, currentPath)) {
                return item;
            }
            // if item has a dropdown
            if (item.dropdown) {
                var found = item.dropdown.find(function (dropdownItem) { return matchRoute(dropdownItem.path, currentPath); });
                if (found)
                    return item;
            }
            // if item has sub-items
            if (item.items) {
                var element = item.items.find(function (subItem) { return matchRoute(subItem.path, currentPath); });
                if (element)
                    return element;
            }
        }
    }
    return null;
};

var Content$2 = function (_a) {
    var children = _a.children, margin = _a.margin;
    return (jsx(FlexBox, __assign({ alignItems: "center", padding: "none", margin: margin }, { children: children })));
};
var NavItem = function (_a) {
    var className = _a.className, items = _a.items, leftContent = _a.leftContent, _b = _a.height, height = _b === void 0 ? NAVIGATION_HEIGHT : _b, path = _a.path, rightContent = _a.rightContent, showAlert = _a.showAlert, text = _a.text, _c = _a.notActiveColor, notActiveColor = _c === void 0 ? 'navBarFont' : _c, _d = _a.enabled, enabled = _d === void 0 ? true : _d, target = _a.target, label = _a.label, leftContentContainerMargin = _a.leftContentContainerMargin, containerMinWidth = _a.containerMinWidth, containerMargin = _a.containerMargin, _e = _a.withActiveBorder, withActiveBorder = _e === void 0 ? true : _e, handleNavigate = _a.handleNavigate, customDropdownItemClickHandler = _a.customDropdownItemClickHandler;
    if (!enabled)
        return null;
    var _f = useIsComponentVisible(false), ref = _f.ref, isComponentVisible = _f.isComponentVisible, setIsComponentVisible = _f.setIsComponentVisible;
    var currentPath = useNavigationContext().currentPath;
    var iconName = isComponentVisible ? 'caret-up' : 'caret-down';
    var hasValidPath = checkValidPath(path);
    var _g = useState(), active = _g[0], setActive = _g[1];
    var isNavigable = items || path;
    useEffect(function () {
        if (isNavigable) {
            setActive(matchRoute(path, currentPath) ||
                (items ? items.some(function (navItem) { return matchRoute(navItem.path, currentPath); }) : false));
        }
    }, [isNavigable, items, path, currentPath]);
    var handleNavItemClick = function () {
        if (!items) {
            if (path) {
                handleNavigate({ path: path, target: target });
            }
            return;
        }
        setIsComponentVisible(!isComponentVisible);
    };
    var handleDropdownItemClick = function (item) {
        if (customDropdownItemClickHandler)
            return customDropdownItemClickHandler(item);
        var name = item.name, path = item.path;
        handleNavigate({ path: path, target: target, name: name });
    };
    if (!enabled)
        return null;
    return (jsxs(Item$1, __assign({ className: className, visible: isComponentVisible, onClick: !hasValidPath ? handleNavItemClick : undefined, minWidth: containerMinWidth, ref: ref, height: height, as: hasValidPath ? 'a' : 'div', href: hasValidPath ? path : undefined, target: hasValidPath && Boolean(target) ? target : undefined }, { children: [leftContent && (jsxs(Content$2, __assign({ margin: leftContentContainerMargin }, { children: [leftContent, showAlert && jsx(ExclamationIcon, { position: "absolute", top: "-5px", right: "-5px" })] }))), jsx(Content$2, __assign({ margin: containerMargin }, { children: jsx(Button, __assign({ labelColor: active ? 'navBarFont' : notActiveColor, variant: "text", icon: items ? iconName : undefined, iconColor: "navBarFont" }, { children: jsxs(FlexBox, __assign({ flexDirection: "column", justifyContent: "center", padding: "none", margin: 0, maxWidth: "300px" }, { children: [label && (jsx(Body, __assign({ bold: true, size: "smaller", color: "primary" }, { children: label }))), jsx(Body, __assign({ truncable: true, bold: true, color: active ? 'colorTextTextPrimary' : notActiveColor }, { children: text }))] })) })) })), rightContent && jsx(Content$2, { children: rightContent }), items && (jsx(Dropdown$1, { items: items, handleNavigate: handleNavigate, isVisible: isComponentVisible, handleDropdownItemClick: handleDropdownItemClick })), withActiveBorder && active && (jsxs(Fragment, { children: [isComponentVisible ? jsx(Figure$1, {}) : null, jsx(LineContainer$2, { children: jsx(Line$1, { orientation: "horizontal", color: "primary", lineWidth: "4px", margin: "none" }) })] }))] })));
};

var Checkout = function (_a) {
    var leftContentContainerMargin = _a.leftContentContainerMargin, containerMinWidth = _a.containerMinWidth, withActiveBorder = _a.withActiveBorder, handleNavigate = _a.handleNavigate;
    var pendingCheckoutItems = useNavigationContext().pendingCheckoutItems;
    var showAlert = pendingCheckoutItems ? pendingCheckoutItems > 0 : false;
    return (jsxs(FlexBox, __assign({ position: "relative" }, { children: [jsx(NavItem, { leftContent: jsx(Icon, { name: "cart", color: "colorIconIconPrimary", size: "normal" }), path: routes.checkout, leftContentContainerMargin: leftContentContainerMargin, containerMinWidth: containerMinWidth, withActiveBorder: withActiveBorder, handleNavigate: handleNavigate }), showAlert ? (jsx(NotificationsNumber, { number: pendingCheckoutItems, position: "absolute", right: "15px", top: "10px" })) : null] })));
};

var NavigationItems = function (_a) {
    var navigationItems = _a.navigationItems, viewport = _a.viewport, handleNavigate = _a.handleNavigate;
    return navigationItems ? (jsx(Fragment, { children: Object.keys(navigationItems[viewport]).map(function (section) {
            var enabledNavItems = navigationItems[viewport][section].items.filter(function (navItem) { return navItem.enabled; });
            if (!enabledNavItems.length)
                return null;
            return (jsxs(React__default.Fragment, { children: [enabledNavItems.map(function (item, i) { return (jsx(React__default.Fragment, { children: jsx(NavItem, { text: item.name, items: item.items, path: item.path, showAlert: item.showAlert, enabled: item.enabled, rightContent: isValidElement(item.icon) ? item.icon : null, target: item.target, label: item === null || item === void 0 ? void 0 : item.label, handleNavigate: handleNavigate }) }, "".concat(item.name, "-").concat(i))); }), jsx(Line$1, { orientation: "vertical", color: "grayDark" })] }, section));
        }) })) : null;
};

var DesktopNavigationHeaderContainer = styled(FlexBox).attrs(function (_a) {
    var hasContent = _a.hasContent;
    return ({
        width: '100%',
        alignItems: 'center',
        background: colorSurface.primary,
        zIndex: zIndexMap.navigationBar,
        position: hasContent ? 'sticky' : 'fixed'
    });
})(templateObject_1$F || (templateObject_1$F = __makeTemplateObject(["\n  border-bottom: 1px solid ", ";\n"], ["\n  border-bottom: 1px solid ", ";\n"])), colorBorder$1.colorBorderBorderSecondary);
var templateObject_1$F;

var navItemsName = {
    titleClerk: 'Title clerk',
    goTrades: 'GO trades',
    settings: 'Settings',
    referrals: 'Referrals',
    contactMyRep: 'Contact My Rep',
    referAFriend: 'Refer a friend',
    changeAccount: 'Change account',
    logout: 'Logout'
};
var getProfileNavItems = function (user, enableChangeAccount, enableContactMyRep) {
    var navigation = user.navigation, title_clerk_token = user.title_clerk_token;
    if (!navigation)
        return;
    var show_title_clerk = navigation.show_title_clerk, show_gtv_offers = navigation.show_gtv_offers, show_badge_alert = navigation.show_badge_alert, show_new_referral = navigation.show_new_referral;
    return [
        {
            name: navItemsName.titleClerk,
            path: "".concat(routes.title_clerk, "?token=").concat(title_clerk_token),
            items: null,
            icon: null,
            enabled: show_title_clerk
        },
        {
            name: navItemsName.goTrades,
            path: routes.gtv_offers,
            items: null,
            icon: null,
            enabled: show_gtv_offers
        },
        {
            name: navItemsName.settings,
            path: routes.settings,
            items: null,
            icon: show_badge_alert ? jsx(ExclamationIcon, { margin: "0 8px" }) : null,
            enabled: true
        },
        {
            name: navItemsName.referrals,
            path: routes.referrals,
            items: null,
            icon: null,
            enabled: !show_new_referral
        },
        {
            name: navItemsName.contactMyRep,
            items: null,
            enabled: enableContactMyRep
        },
        {
            name: navItemsName.referAFriend,
            path: routes.refer_a_friend,
            items: null,
            icon: null,
            enabled: show_new_referral
        },
        {
            name: navItemsName.changeAccount,
            path: null,
            items: null,
            icon: null,
            enabled: enableChangeAccount
        },
        {
            name: navItemsName.logout,
            path: null,
            items: null,
            styles: {
                color: 'alert',
                background: 'white'
            },
            icon: null,
            enabled: true
        }
    ];
};

// text line-height is 20px, with height 40px we just force two lines
var UserNavItem = styled(NavItem)(templateObject_1$E || (templateObject_1$E = __makeTemplateObject(["\n  white-space: normal;\n  button div:first-child {\n    line-height: 16px;\n  }\n"], ["\n  white-space: normal;\n  button div:first-child {\n    line-height: 16px;\n  }\n"])));
var UserItem = function (_a) {
    var user = _a.user, enableChangeAccount = _a.enableChangeAccount, enableContactMyRep = _a.enableContactMyRep, handleNavigate = _a.handleNavigate;
    var dealership_name = user.dealership_name, normal_image = user.normal_image, navigation = user.navigation, on_behalf_of = user.on_behalf_of;
    var items = getProfileNavItems(user, enableChangeAccount, enableContactMyRep);
    var showAlert = navigation === null || navigation === void 0 ? void 0 : navigation.show_badge_alert;
    return (jsx(UserNavItem, { text: (on_behalf_of === null || on_behalf_of === void 0 ? void 0 : on_behalf_of.dealership_name) || dealership_name, leftContent: jsx(Image, { type: "avatar", size: "normal", src: (on_behalf_of === null || on_behalf_of === void 0 ? void 0 : on_behalf_of.normal_image) || normal_image }), rightContent: showAlert ? jsx(ExclamationIcon, {}) : null, items: items, handleNavigate: handleNavigate }));
};
var templateObject_1$E;

var DesktopNavigationHeader = function (_a) {
    var navigationItems = _a.navigationItems, viewport = _a.viewport, user = _a.user, hasContent = _a.hasContent, enableContactMyRep = _a.enableContactMyRep;
    var show_dealership_purchases = (user.navigation || {}).show_dealership_purchases;
    var _b = useNavigationContext(), enableChangeAccount = _b.enableChangeAccount, handleNavigate = _b.handleNavigate;
    return (jsxs(DesktopNavigationHeaderContainer, __assign({ hasContent: hasContent, id: "navigation-bar", as: "nav" }, { children: [jsx(FlexBox, __assign({ padding: spacingActionPadding.spacingActionPaddingMd, onClick: function () { return handleNavigate({ path: routes.home }); } }, { children: jsx(OpenLaneLogo, { width: "160px", height: "21px", inverted: true, cursor: "pointer" }) })), navigationItems && (jsxs(FlexBox, __assign({ width: "100%", justifyContent: "flex-end", alignItems: "center" }, { children: [jsx(NavigationItems, { navigationItems: navigationItems, viewport: viewport, handleNavigate: handleNavigate }), jsx(UserItem, { user: user, enableChangeAccount: enableChangeAccount, enableContactMyRep: enableContactMyRep, handleNavigate: handleNavigate }), jsx(Line$1, { orientation: "vertical", color: "grayDark" }), jsx(Notifications, {}), show_dealership_purchases && (jsxs(Fragment, { children: [jsx(Line$1, { orientation: "vertical", color: "grayDark" }), jsx(Checkout, { handleNavigate: handleNavigate })] }))] })))] })));
};

var ItemContainer$1 = styled(FlexBox).attrs({
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    padding: "".concat(spacingActionPadding.spacingActionPaddingSm, " 0 0 0")
})(templateObject_1$D || (templateObject_1$D = __makeTemplateObject(["\n  max-width: 100.5px;\n  height: 100%;\n  cursor: pointer;\n  position: relative;\n  box-sizing: border-box;\n\n  @media (max-width: ", "px) {\n    width: 80px;\n    text-align: center;\n  }\n"], ["\n  max-width: 100.5px;\n  height: 100%;\n  cursor: pointer;\n  position: relative;\n  box-sizing: border-box;\n\n  @media (max-width: ", "px) {\n    width: 80px;\n    text-align: center;\n  }\n"])), viewportsMinWidth.tablet);
var LineContainer = styled.div(templateObject_2$g || (templateObject_2$g = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  width: 100%;\n"], ["\n  position: absolute;\n  top: 0;\n  width: 100%;\n"])));
var templateObject_1$D, templateObject_2$g;

var Item = function (_a) {
    var item = _a.item, handleNavigate = _a.handleNavigate;
    var path = item.path, target = item.target, icon = item.icon, name = item.name, enabled = item.enabled;
    var _b = useState(), active = _b[0], setActive = _b[1];
    var currentPath = useNavigationContext().currentPath;
    useEffect(function () {
        var active = matchRoute(path, currentPath);
        setActive(active);
    }, [path, currentPath]);
    var handleNavItemClick = function () {
        if (path) {
            handleNavigate({ path: path, target: target });
        }
    };
    var itemColor = active ? 'primary' : 'navBarFont';
    var iconComponent = useMemo(function () {
        var iconColor = active ? 'colorIconIconBrand' : 'colorIconIconPrimary';
        if (isValidElement(icon)) {
            return icon;
        }
        if (typeof icon === 'function') {
            return icon(iconColor);
        }
        return jsx(Icon, { name: item.icon, color: iconColor });
    }, [active]);
    if (!enabled) {
        return null;
    }
    return (jsxs(ItemContainer$1, __assign({ onClick: handleNavItemClick }, { children: [iconComponent, jsx(Body, __assign({ bold: true, size: "smaller", color: itemColor }, { children: name })), active && (jsx(LineContainer, { children: jsx(Line$1, { orientation: "horizontal", color: "primary", lineWidth: "4px", margin: "none" }) }))] })));
};

var ModalCustomHeader$1 = function (_a) {
    var handleClose = _a.handleClose;
    return (jsx(FlexBox, __assign({ width: "100%", alignItems: "center", padding: "0 ".concat(spacingActionPadding.spacingActionPaddingMd), background: colorSurface.secondary, height: "56px", justifyContent: "flex-start" }, { children: jsx(FlexBox, __assign({ onClick: handleClose, "data-testid": "modal-custom-header" }, { children: jsx(Icon, { name: "close", size: "smaller" }) })) })));
};

var MoreItemContainer = styled(FlexBox)(templateObject_1$C || (templateObject_1$C = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var _b = _a.active, active = _b === void 0 ? false : _b;
    return "\n        border-left-color: ".concat(colorBorder$1.colorBorderBorderBrand, ";\n        border-left-width: ").concat(active ? '4px' : '0', ";\n        border-left-style: solid;\n        border-bottom: 1px solid ").concat(colorBorder$1.colorBorderBorderPrimary, ";\n    ");
});
var templateObject_1$C;

var MoreItem = function (_a) {
    var _b;
    var itemData = _a.itemData, handleClick = _a.handleClick;
    var _c = useState(), active = _c[0], setActive = _c[1];
    var currentPath = useNavigationContext().currentPath;
    useEffect(function () {
        var active = currentPath === (itemData === null || itemData === void 0 ? void 0 : itemData.path);
        setActive(active);
    }, [itemData === null || itemData === void 0 ? void 0 : itemData.path]);
    return (jsxs(MoreItemContainer, __assign({ alignItems: "center", width: "100%", height: "56px", active: active, onClick: function () { return handleClick(itemData); } }, { children: [(itemData === null || itemData === void 0 ? void 0 : itemData.icon) && (jsx(FlexBox, __assign({ padding: spacingActionPadding.spacingActionPaddingSm, margin: 0, alignItems: "center" }, { children: itemData === null || itemData === void 0 ? void 0 : itemData.icon }))), jsx(Body, __assign({ color: (_b = itemData === null || itemData === void 0 ? void 0 : itemData.styles) === null || _b === void 0 ? void 0 : _b.color }, { children: itemData.name }))] })));
};

var MoreModal = function (_a) {
    var isOpen = _a.isOpen, navItems = _a.navItems, handleClose = _a.handleClose, handleNavigate = _a.handleNavigate;
    var handleNavItemClick = function (data) {
        handleClose();
        handleNavigate({ path: data === null || data === void 0 ? void 0 : data.path, target: data === null || data === void 0 ? void 0 : data.target, name: data === null || data === void 0 ? void 0 : data.name });
    };
    return (jsxs(BlcModal, __assign({ isOpen: isOpen, closeModal: handleClose, padding: 0, type: "window", noHeader: true, noFooter: true, fullpageModal: true, zIndex: zIndexMap.navigationBarMobile }, { children: [jsx(ModalCustomHeader$1, { handleClose: handleClose }), jsx(FlexBox, __assign({ width: "100%", height: "calc(100% - ".concat(NAVIGATION_HEIGHT, "px)") }, { children: jsx(FlexBox, __assign({ width: "100%", flexDirection: "column" }, { children: navItems &&
                        navItems.items &&
                        navItems.items
                            .filter(function (navItem) { return navItem.enabled; })
                            .map(function (item) { return jsx(MoreItem, { itemData: item, handleClick: handleNavItemClick }, item.name); }) })) }))] })));
};

var MobileContainer = styled(FlexBox).attrs(function (_a) {
    var hasChildren = _a.hasChildren;
    return ({
        zIndex: zIndexMap.navigationBar,
        background: colorSurface.primary,
        height: '60px',
        alignItems: 'center',
        justifyContent: 'space-evenly',
        width: '100%',
        position: hasChildren ? 'sticky' : 'fixed'
    });
})(templateObject_1$B || (templateObject_1$B = __makeTemplateObject(["\n  bottom: 0;\n  left: 0;\n  border-top: solid 1px ", ";\n"], ["\n  bottom: 0;\n  left: 0;\n  border-top: solid 1px ", ";\n"])), colorBorder$1.colorBorderBorderPrimary);
var templateObject_1$B;

var BottomBar = function (_a) {
    var _b, _c;
    var items = _a.items, hasChildren = _a.hasChildren;
    var _d = useState(false), showMore = _d[0], setShowMore = _d[1];
    var handleNavigate = useNavigationContext().handleNavigate;
    return (jsxs(MobileContainer, __assign({ id: "mobile-bottom-bar", hasChildren: hasChildren }, { children: [items &&
                ((_c = (_b = items.common) === null || _b === void 0 ? void 0 : _b.items) === null || _c === void 0 ? void 0 : _c.map(function (item) { return (jsx(Item, { item: item, handleNavigate: handleNavigate }, item.name)); })), jsx(Item, { item: { name: 'More', icon: 'more', path: '#', enabled: true }, handleNavigate: function () { return setShowMore(true); } }), showMore && (jsx(MoreModal, { isOpen: showMore, navItems: items.more, handleClose: function () { return setShowMore(false); }, handleNavigate: handleNavigate }))] })));
};

var StyledDropdownItem = styled(OverlayedBox)(templateObject_1$A || (templateObject_1$A = __makeTemplateObject(["\n  ", "\n  box-sizing: border-box;\n  width: 200px;\n  padding: 12px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n"], ["\n  ", "\n  box-sizing: border-box;\n  width: 200px;\n  padding: 12px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n"])), function (_a) {
    var background = _a.background;
    return "\n    background-color: ".concat(getLegacyColor(background) || colorSurface.primary, ";\n  ");
});
var templateObject_1$A;

var DropdownItem = function (_a) {
    var background = _a.background, label = _a.label, labelColor = _a.labelColor, onClick = _a.onClick;
    return (jsx(StyledDropdownItem, __assign({ background: background, onClick: onClick }, { children: jsx(Button, __assign({ labelColor: labelColor, variant: "text" }, { children: label })) })));
};

var DropdownContainer = styled.div(templateObject_1$z || (templateObject_1$z = __makeTemplateObject(["\n  ", "\n  text-align: center;\n  min-width: 160px;\n  box-shadow: ", ";\n  position: absolute;\n  z-index: ", ";\n"], ["\n  ", "\n  text-align: center;\n  min-width: 160px;\n  box-shadow: ", ";\n  position: absolute;\n  z-index: ", ";\n"])), function (_a) {
    var top = _a.top;
    return "\n      top: ".concat(getValue$1(top), "\n  ");
}, shadow.larger, zIndexMap.navigationBar);
var templateObject_1$z;

var BasicDropdown = function (_a) {
    var options = _a.options, isVisible = _a.isVisible, top = _a.top, handleClick = _a.handleClick;
    if (!isVisible) {
        return null;
    }
    return (jsx(DropdownContainer, __assign({ top: top }, { children: options.map(function (option, i) {
            return option.disabled ? null : (jsx(React__default.Fragment, { children: jsx(DropdownItem, { label: option.name, labelColor: "navBarFont", onClick: function () { return handleClick(option); } }) }, i));
        }) })));
};

var ModalCustomHeader = function (_a) {
    var handleClose = _a.handleClose, handleDeleteAllNotifications = _a.handleDeleteAllNotifications, disableClearAll = _a.disableClearAll;
    return (jsxs(FlexBox, __assign({ width: "100%", alignItems: "center", padding: "0 ".concat(spacingActionPadding.spacingActionPaddingMd), background: colorSurface.secondary, height: "56px", justifyContent: "space-between", zIndex: 1, position: "fixed", boxSizing: "border-box" }, { children: [jsx(FlexBox, __assign({ onClick: handleClose, "data-testid": "close-notifications" }, { children: jsx(Icon, { name: "close", size: "smaller" }) })), jsx(FlexBox, { children: jsx(Headline, __assign({ size: "H4" }, { children: "Notifications" })) }), jsx(FlexBox, __assign({ onClick: handleDeleteAllNotifications }, { children: jsx(ClearAll, { disabled: disableClearAll }) }))] })));
};
var NotificationsCenterModal = function (_a) {
    var handleClose = _a.handleClose, isOpen = _a.isOpen, hasUnreadNotifications = _a.hasUnreadNotifications;
    var _b = useNavigationContext(), handleDeleteAllNotifications = _b.handleDeleteAllNotifications, handleClearUnreadNotifications = _b.handleClearUnreadNotifications, handleReadAllNotifications = _b.handleReadAllNotifications, notifications = _b.notifications;
    useEffect(function () {
        if (isOpen && hasUnreadNotifications) {
            handleReadAllNotifications();
        }
    }, [isOpen]);
    var onClose = function () {
        handleClose();
        if (hasUnreadNotifications) {
            handleClearUnreadNotifications();
        }
    };
    return (jsxs(BlcModal, __assign({ isOpen: isOpen, closeModal: handleClose, padding: 0, type: "window", noHeader: true, noFooter: true, fullpageModal: true, hideScrollBar: true }, { children: [jsx(ModalCustomHeader, { handleClose: onClose, handleDeleteAllNotifications: handleDeleteAllNotifications, disableClearAll: !(notifications === null || notifications === void 0 ? void 0 : notifications.length) }), jsx(Notifications, { viewport: viewports.mobile })] })));
};

var HeadingContainer = styled(FlexBox).attrs({
    width: '100%',
    flexDirection: 'column',
    display: 'flex',
    zIndex: zIndexMap.navigationBar,
    background: colorSurface.primary
})(templateObject_1$y || (templateObject_1$y = __makeTemplateObject(["\n  border-bottom: 1px solid ", ";\n  top: 0;\n  left: 0;\n"], ["\n  border-bottom: 1px solid ", ";\n  top: 0;\n  left: 0;\n"])), colorBorder$1.colorBorderBorderPrimary);
var BoxWithHiddenScroll = styled(FlexBox).attrs({
    padding: "0 ".concat(spacingActionPadding.spacingActionPaddingLg),
    gap: '8px',
    alignItems: 'center',
    width: '100%',
    height: '48px'
})(templateObject_2$f || (templateObject_2$f = __makeTemplateObject(["\n  ", "\n  overflow-x: auto;\n"], ["\n  ", "\n  overflow-x: auto;\n"])), hideScrollBarStyle);
var templateObject_1$y, templateObject_2$f;

var getTabs = function (activeItem) {
    var _a;
    if (activeItem === null || activeItem === void 0 ? void 0 : activeItem.dropdown) {
        var active = activeItem.dropdown[0];
        if (active.items)
            return active.items;
    }
    else if ((_a = activeItem === null || activeItem === void 0 ? void 0 : activeItem.items) === null || _a === void 0 ? void 0 : _a.length) {
        return activeItem === null || activeItem === void 0 ? void 0 : activeItem.items;
    }
    return undefined;
};
var Heading = function (_a) {
    var activeItem = _a.activeItem, hasChildren = _a.hasChildren;
    var _b = useNavigationContext(), currentPath = _b.currentPath, user = _b.user, unreadNotifications = _b.unreadNotifications, notifications = _b.notifications, handleNavigate = _b.handleNavigate, handleSetNotifications = _b.handleSetNotifications;
    var activeDropdownOption = useMemo(function () {
        if (activeItem === null || activeItem === void 0 ? void 0 : activeItem.dropdown) {
            return activeItem.dropdown.find(function (option) { return (option === null || option === void 0 ? void 0 : option.path) === currentPath; });
        }
        return undefined;
    }, [activeItem]);
    var _c = useState(), showNotifications = _c[0], setShowNotifications = _c[1];
    var _d = useState(false), showDropdown = _d[0], setShowDropdown = _d[1];
    var _e = useState(function () { return getTabs(activeItem); }), tabs = _e[0], setTabs = _e[1];
    var _f = useState((activeDropdownOption === null || activeDropdownOption === void 0 ? void 0 : activeDropdownOption.name) || (activeItem === null || activeItem === void 0 ? void 0 : activeItem.name)), dropdownLabel = _f[0], setDropdownLabel = _f[1];
    var navigation = user === null || user === void 0 ? void 0 : user.navigation;
    var iconName = showDropdown ? 'caret-up' : 'caret-down';
    var hasUnreadNotifications = Boolean(unreadNotifications);
    var handleDropdownClick = function (option) {
        handleNavigate({ path: option.path });
        setTabs(option.items);
        setDropdownLabel(option.name);
        setShowDropdown(false);
    };
    var handleShowNotifications = function () {
        if (!notifications) {
            handleSetNotifications();
        }
        setShowNotifications(true);
    };
    return (jsxs(Fragment, { children: [jsxs(HeadingContainer, __assign({ position: hasChildren ? 'sticky' : 'fixed', id: "mobile-top-nav" }, { children: [jsxs(FlexBox, __assign({ padding: "0 ".concat(spacingActionPadding.spacingActionPaddingMd), justifyContent: "space-between", alignItems: "center", width: "100%", height: NAVIGATION_HEIGHT, boxSizing: "border-box" }, { children: [jsxs(FlexBox, { children: [jsx(Button, __assign({ labelColor: "colorTextTextPrimary", variant: "text", icon: (activeItem === null || activeItem === void 0 ? void 0 : activeItem.dropdown) ? iconName : undefined, iconColor: "navBarFont", onClick: function () { return setShowDropdown(!showDropdown); } }, { children: jsx(FlexBox, __assign({ flexDirection: "column" }, { children: jsx(Headline, __assign({ color: "colorTextTextPrimary", size: "H4" }, { children: dropdownLabel })) })) })), (activeItem === null || activeItem === void 0 ? void 0 : activeItem.dropdown) && (jsx(BasicDropdown, { options: activeItem.dropdown, isVisible: showDropdown, top: "30px", handleClick: handleDropdownClick }))] }), jsxs(FlexBox, __assign({ alignItems: "center", flexDirection: "row", gap: 18 }, { children: [jsxs(FlexBox, __assign({ onClick: handleShowNotifications, position: "relative" }, { children: [jsx(Icon, { name: "notification", color: "colorIconIconPrimary" }), hasUnreadNotifications && (jsx(NotificationsNumber, { number: unreadNotifications, position: "absolute", top: "-6px", right: "-6px" }))] })), (navigation === null || navigation === void 0 ? void 0 : navigation.show_dealership_purchases) && (jsx(Checkout, { leftContentContainerMargin: "0", containerMinWidth: 65, withActiveBorder: false, handleNavigate: handleNavigate }))] }))] })), tabs && (jsx(BoxWithHiddenScroll, { children: tabs.map(function (_a) {
                            var name = _a.name, path = _a.path, enabled = _a.enabled;
                            return (jsx(NavItem, { text: name, path: path, notActiveColor: "colorTextTextSecondary", height: 48, enabled: enabled, handleNavigate: handleNavigate }, name));
                        }) }))] })), showNotifications && (jsx(NotificationsCenterModal, { isOpen: showNotifications, handleClose: function () { return setShowNotifications(false); }, hasUnreadNotifications: hasUnreadNotifications }))] }));
};

var MobileNavigationTopBar = function (_a) {
    var items = _a.items, mockedPath = _a.mockedPath, hasContent = _a.hasContent;
    if (!items)
        return null;
    var activeItem = useMemo(function () { return findActiveItem(items, mockedPath); }, [items]);
    return jsx(Heading, { activeItem: activeItem, hasChildren: hasContent });
};
var MobileNavigationBottomBar = function (_a) {
    var items = _a.items, hasContent = _a.hasContent;
    if (!items)
        return null;
    return jsx(BottomBar, { items: items, hasChildren: hasContent });
};

var buyerAuctionMarketplace = function (_a) {
    var showPrivateAuction = _a.showPrivateAuction, showPrivateMarketplace = _a.showPrivateMarketplace, showDealershipPurchases = _a.showDealershipPurchases, showSearchMobileTabs = _a.showSearchMobileTabs, showTransport = _a.showTransport, unifiedMarketplaceItem = _a.unifiedMarketplaceItem;
    var legacyMarketplaceItem = [
        {
            name: 'Marketplace',
            path: showPrivateMarketplace ? routes.private_marketplace : routes.search,
            icon: 'tag',
            items: showSearchMobileTabs
                ? [
                    {
                        name: showPrivateMarketplace ? 'Private marketplace' : 'Search',
                        path: showPrivateMarketplace ? routes.private_marketplace : routes.search,
                        icon: null,
                        enabled: true
                    },
                    {
                        name: 'My bids',
                        path: routes.my_offers,
                        icon: null,
                        enabled: true
                    },
                    {
                        name: 'Watchlist',
                        path: routes.watchlist,
                        icon: null,
                        enabled: true
                    },
                    {
                        name: 'Hidden',
                        path: routes.none,
                        icon: null,
                        enabled: true
                    }
                ]
                : undefined,
            enabled: true
        },
        {
            name: showPrivateAuction ? 'Private auction' : 'Auction',
            path: routes.auction_buyer,
            icon: 'gavel',
            items: null,
            enabled: true
        }
    ];
    return __spreadArray(__spreadArray([], (unifiedMarketplaceItem || legacyMarketplaceItem), true), [
        {
            name: 'Transactions',
            path: showDealershipPurchases ? routes.checkout : routes.transport,
            icon: function (color) { return jsx(Icon, { name: "dollar", color: color }); },
            items: [
                {
                    name: 'Checkout',
                    path: routes.checkout,
                    icon: null,
                    enabled: showDealershipPurchases
                },
                {
                    name: 'My orders',
                    path: routes.orders,
                    icon: null,
                    enabled: showDealershipPurchases
                },
                {
                    name: 'Transport',
                    path: routes.transport,
                    icon: null,
                    enabled: showTransport
                }
            ],
            enabled: showDealershipPurchases || showTransport
        }
    ], false);
};

var buyerAuctionOnly = function (_a) {
    var showPrivateAuction = _a.showPrivateAuction, showDealershipPurchases = _a.showDealershipPurchases, showTransport = _a.showTransport, unifiedMarketplaceItem = _a.unifiedMarketplaceItem;
    return __spreadArray(__spreadArray([], (unifiedMarketplaceItem || [
        {
            name: showPrivateAuction ? 'Private auction' : 'Auction',
            path: routes.auction_buyer,
            icon: 'gavel',
            items: null,
            enabled: true
        }
    ]), true), [
        {
            name: 'Transactions',
            path: showDealershipPurchases ? routes.checkout : routes.transport,
            icon: function (color) { return jsx(Icon, { name: "dollar", color: color }); },
            items: [
                {
                    name: 'Checkout',
                    path: routes.checkout,
                    icon: null,
                    enabled: showDealershipPurchases
                },
                {
                    name: 'My orders',
                    path: routes.orders,
                    icon: null,
                    enabled: showDealershipPurchases
                },
                {
                    name: 'Transport',
                    path: routes.transport,
                    icon: null,
                    enabled: showTransport
                }
            ],
            enabled: showDealershipPurchases || showTransport
        }
    ], false);
};

var buyerMarketplaceOnly = function (_a) {
    var showPrivateMarketplace = _a.showPrivateMarketplace, showDealershipPurchases = _a.showDealershipPurchases, showSearchMobileTabs = _a.showSearchMobileTabs, showTransport = _a.showTransport, unifiedMarketplaceItem = _a.unifiedMarketplaceItem;
    return __spreadArray(__spreadArray([], (unifiedMarketplaceItem || [
        {
            name: 'Marketplace',
            path: showPrivateMarketplace ? routes.private_marketplace : routes.search,
            icon: 'tag',
            items: showSearchMobileTabs
                ? [
                    {
                        name: showPrivateMarketplace ? 'Private marketplace' : 'Search',
                        path: showPrivateMarketplace ? routes.private_marketplace : routes.search,
                        icon: null,
                        enabled: true
                    },
                    {
                        name: 'My bids',
                        path: routes.my_offers,
                        icon: null,
                        enabled: true
                    },
                    {
                        name: 'Watchlist',
                        path: routes.watchlist,
                        icon: null,
                        enabled: true
                    },
                    {
                        name: 'Hidden',
                        path: routes.none,
                        icon: null,
                        enabled: true
                    }
                ]
                : undefined,
            enabled: true
        }
    ]), true), [
        {
            name: 'Transactions',
            path: showDealershipPurchases ? routes.checkout : routes.transport,
            icon: function (color) { return jsx(Icon, { name: "dollar", color: color }); },
            items: [
                {
                    name: 'Checkout',
                    path: routes.checkout,
                    icon: null,
                    enabled: showDealershipPurchases
                },
                {
                    name: 'My orders',
                    path: routes.orders,
                    icon: null,
                    enabled: showDealershipPurchases
                },
                {
                    name: 'Transport',
                    path: routes.transport,
                    icon: null,
                    enabled: showTransport
                }
            ],
            enabled: showDealershipPurchases || showTransport
        }
    ], false);
};

var sellerAuctionMarketplace = function (_a) {
    var showPrivateAuction = _a.showPrivateAuction, showPrivateMarketplace = _a.showPrivateMarketplace, isMasterUser = _a.isMasterUser, showTransport = _a.showTransport, unifiedMarketplaceItem = _a.unifiedMarketplaceItem;
    var auctionText = showPrivateAuction ? 'Private auction' : 'Auction';
    var auctionPath = showPrivateAuction ? routes.auction_buyer : routes.auction_seller;
    var marketplaceText = showPrivateMarketplace ? 'Private marketplace' : 'Marketplace';
    var marketplacePath = showPrivateMarketplace ? routes.private_marketplace : routes.vehicles;
    return __spreadArray(__spreadArray([], (unifiedMarketplaceItem || [
        {
            name: marketplaceText,
            path: marketplacePath,
            icon: 'tag',
            items: null,
            enabled: true
        },
        {
            name: auctionText,
            path: auctionPath,
            icon: 'gavel',
            items: null,
            enabled: true
        }
    ]), true), [
        {
            name: isMasterUser ? 'Transactions' : 'Sold',
            path: routes.sold_vehicles,
            icon: function (color) { return jsx(Icon, { name: "dollar", color: color }); },
            items: isMasterUser
                ? [
                    {
                        name: 'Sold vehicles',
                        path: routes.sold_vehicles,
                        icon: null,
                        enabled: true
                    },
                    {
                        name: 'Transport',
                        path: routes.transport,
                        icon: null,
                        enabled: showTransport
                    }
                ]
                : null,
            enabled: true
        }
    ], false);
};

var sellerAuctionOnly = function (_a) {
    var showPrivateAuction = _a.showPrivateAuction, isMasterUser = _a.isMasterUser, showTransport = _a.showTransport, unifiedMarketplaceItem = _a.unifiedMarketplaceItem;
    var auctionText = showPrivateAuction ? 'Private auction' : 'Auction';
    var auctionPath = showPrivateAuction ? routes.auction_buyer : routes.auction_seller;
    var marketplaceItem = showPrivateAuction && unifiedMarketplaceItem
        ? unifiedMarketplaceItem
        : [
            {
                name: auctionText,
                path: auctionPath,
                icon: 'gavel',
                items: null,
                enabled: true
            }
        ];
    return __spreadArray(__spreadArray([], marketplaceItem, true), [
        {
            name: isMasterUser ? 'Transactions' : 'Sold',
            path: routes.sold_vehicles,
            icon: function (color) { return jsx(Icon, { name: "dollar", color: color }); },
            items: isMasterUser
                ? [
                    {
                        name: 'Sold vehicles',
                        path: routes.sold_vehicles,
                        icon: null,
                        enabled: true
                    },
                    {
                        name: 'Transport',
                        path: routes.transport,
                        icon: null,
                        enabled: showTransport
                    }
                ]
                : null,
            enabled: true
        }
    ], false);
};

var sellerMarketplaceOnly = function (_a) {
    var showPrivateMarketplace = _a.showPrivateMarketplace, isMasterUser = _a.isMasterUser, showTransport = _a.showTransport, unifiedMarketplaceItem = _a.unifiedMarketplaceItem;
    var marketplaceText = showPrivateMarketplace ? 'Private marketplace' : 'Marketplace';
    var marketplacePath = showPrivateMarketplace ? routes.private_marketplace : routes.vehicles;
    var marketplaceItem = showPrivateMarketplace && unifiedMarketplaceItem
        ? unifiedMarketplaceItem
        : [
            {
                name: marketplaceText,
                path: marketplacePath,
                icon: 'tag',
                items: null,
                enabled: true
            }
        ];
    return __spreadArray(__spreadArray([], marketplaceItem, true), [
        {
            name: isMasterUser ? 'Transactions' : 'Sold',
            path: routes.sold_vehicles,
            icon: function (color) { return jsx(Icon, { name: "dollar", color: color }); },
            items: isMasterUser
                ? [
                    {
                        name: 'Sold vehicles',
                        path: routes.sold_vehicles,
                        icon: null,
                        enabled: true
                    },
                    {
                        name: 'Transport',
                        path: routes.transport,
                        icon: null,
                        enabled: showTransport
                    }
                ]
                : null,
            enabled: true
        }
    ], false);
};

var sellerMarketplaceWithPA = function (_a) {
    var showPrivateMarketplace = _a.showPrivateMarketplace, showDealershipPurchases = _a.showDealershipPurchases, showSearchMobileTabs = _a.showSearchMobileTabs, showTransport = _a.showTransport, unifiedMarketplaceItem = _a.unifiedMarketplaceItem;
    var marketplaceItem = showPrivateMarketplace && unifiedMarketplaceItem
        ? unifiedMarketplaceItem
        : [
            {
                name: 'Buy',
                path: showPrivateMarketplace ? routes.private_marketplace : routes.my_offers,
                icon: 'tag',
                dropdown: [
                    {
                        name: 'Marketplace',
                        items: showSearchMobileTabs
                            ? [
                                {
                                    name: 'Private marketplace',
                                    path: routes.private_marketplace,
                                    icon: null,
                                    enabled: showPrivateMarketplace
                                },
                                {
                                    name: 'My bids',
                                    path: routes.my_offers,
                                    icon: null,
                                    enabled: true
                                },
                                {
                                    name: 'Watchlist',
                                    path: routes.watchlist,
                                    icon: null,
                                    enabled: true
                                }
                            ]
                            : undefined
                    },
                    {
                        name: 'Auction',
                        items: [
                            {
                                name: 'Private auction',
                                path: routes.auction_buyer,
                                icon: null,
                                enabled: true
                            }
                        ]
                    }
                ],
                items: null,
                enabled: true
            }
        ];
    return __spreadArray(__spreadArray([], marketplaceItem, true), [
        {
            name: 'Sell',
            path: routes.vehicles,
            icon: 'sell',
            items: null,
            enabled: true
        },
        {
            name: 'Transactions',
            path: showDealershipPurchases ? routes.checkout : showTransport ? routes.transport : routes.sold_vehicles,
            icon: function (color) { return jsx(Icon, { name: "dollar", color: color }); },
            items: [
                {
                    name: 'Checkout',
                    path: routes.checkout,
                    icon: null,
                    enabled: showDealershipPurchases
                },
                {
                    name: 'My orders',
                    path: routes.orders,
                    icon: null,
                    enabled: showDealershipPurchases
                },
                {
                    name: 'Transport',
                    path: routes.transport,
                    icon: null,
                    enabled: showTransport
                },
                {
                    name: 'Sold vehicles',
                    path: routes.sold_vehicles,
                    icon: null,
                    enabled: true
                }
            ],
            enabled: true
        }
    ], false);
};

var sellMarketplaceAndAuctionWithBuyerMarketplaceWithCTN = function (_a) {
    var showMarketplace = _a.showMarketplace, showPrivateMarketplace = _a.showPrivateMarketplace, showGroupListings = _a.showGroupListings, showBuyerAuction = _a.showBuyerAuction, showSellerAuction = _a.showSellerAuction, closedMarketplace = _a.closedMarketplace, showDealershipPurchases = _a.showDealershipPurchases, showPrivateAuction = _a.showPrivateAuction, showSearchMobileTabs = _a.showSearchMobileTabs, showTransport = _a.showTransport, unifiedMarketplaceItem = _a.unifiedMarketplaceItem;
    var marketplaceItem = unifiedMarketplaceItem && (showMarketplace || showPrivateMarketplace || showBuyerAuction || showPrivateAuction)
        ? unifiedMarketplaceItem
        : [
            {
                name: 'Buy',
                path: showPrivateMarketplace ? routes.private_marketplace : routes.search,
                icon: 'tag',
                items: [
                    {
                        name: showPrivateMarketplace ? 'Private marketplace' : 'Search',
                        path: showPrivateMarketplace ? routes.private_marketplace : routes.search,
                        icon: null,
                        enabled: showSearchMobileTabs
                    },
                    {
                        name: 'Group listings',
                        path: routes.group_listings(closedMarketplace),
                        icon: null,
                        enabled: showGroupListings
                    },
                    {
                        name: showPrivateAuction ? 'Private auction' : 'Auction',
                        path: routes.auction_buyer,
                        icon: null,
                        enabled: showBuyerAuction || showPrivateAuction
                    },
                    {
                        name: 'My bids',
                        path: routes.my_offers,
                        icon: null,
                        enabled: showSearchMobileTabs
                    },
                    {
                        name: 'Watchlist',
                        path: routes.watchlist,
                        icon: null,
                        enabled: showSearchMobileTabs
                    }
                ],
                enabled: showMarketplace || showPrivateMarketplace
            }
        ];
    return __spreadArray(__spreadArray([], marketplaceItem, true), [
        {
            name: 'Sell',
            path: routes.vehicles,
            icon: 'sell',
            dropdown: [
                {
                    name: 'Marketplace',
                    path: routes.vehicles
                },
                {
                    name: 'Auction',
                    path: routes.auction_seller,
                    disabled: !showSellerAuction
                }
            ],
            items: null,
            enabled: true
        },
        {
            name: 'Transactions',
            path: showDealershipPurchases ? routes.checkout : showTransport ? routes.transport : routes.sold_vehicles,
            icon: function (color) { return jsx(Icon, { name: "dollar", color: color }); },
            items: [
                {
                    name: 'Checkout',
                    path: routes.checkout,
                    icon: null,
                    enabled: showDealershipPurchases
                },
                {
                    name: 'My orders',
                    path: routes.orders,
                    icon: null,
                    enabled: showDealershipPurchases
                },
                {
                    name: 'Transport',
                    path: routes.transport,
                    icon: null,
                    enabled: showTransport
                },
                {
                    name: 'Sold vehicles',
                    path: routes.sold_vehicles,
                    icon: null,
                    enabled: true
                }
            ],
            enabled: true
        }
    ], false);
};

var sellMarketplaceAndAuctionWithPA = function (_a) {
    var showDealershipPurchases = _a.showDealershipPurchases, showSearchMobileTabs = _a.showSearchMobileTabs, showTransport = _a.showTransport, unifiedMarketplaceItem = _a.unifiedMarketplaceItem;
    return __spreadArray(__spreadArray([], (unifiedMarketplaceItem || [
        {
            name: 'Buy',
            path: routes.auction_buyer,
            icon: 'tag',
            items: showSearchMobileTabs
                ? [
                    {
                        name: 'Private auction',
                        path: routes.auction_buyer,
                        icon: null,
                        enabled: true
                    },
                    {
                        name: 'Watchlist',
                        path: routes.watchlist,
                        icon: null,
                        enabled: true
                    }
                ]
                : undefined,
            enabled: true
        }
    ]), true), [
        {
            name: 'Sell',
            path: routes.vehicles,
            icon: 'sell',
            dropdown: [
                {
                    name: 'Marketplace',
                    path: routes.vehicles
                },
                {
                    name: 'Auction',
                    path: routes.auction_seller
                }
            ],
            items: null,
            enabled: true
        },
        {
            name: 'Transactions',
            path: showDealershipPurchases ? routes.checkout : showTransport ? routes.transport : routes.sold_vehicles,
            icon: function (color) { return jsx(Icon, { name: "dollar", color: color }); },
            items: [
                {
                    name: 'Checkout',
                    path: routes.checkout,
                    icon: null,
                    enabled: showDealershipPurchases
                },
                {
                    name: 'My orders',
                    path: routes.orders,
                    icon: null,
                    enabled: showDealershipPurchases
                },
                {
                    name: 'Transport',
                    path: routes.transport,
                    icon: null,
                    enabled: showTransport
                },
                {
                    name: 'Sold vehicles',
                    path: routes.sold_vehicles,
                    icon: null,
                    enabled: true
                }
            ],
            enabled: true
        }
    ], false);
};

/* eslint-disable camelcase */
var getMobileItems = function (user, closedMarketplace) {
    var _a;
    var _b = user.navigation || {}, showBuyerAuction = _b.show_buyer_auction, showGroupListings = _b.show_group_listings, showMarketplace = _b.show_marketplace, showPrivateMarketplace = _b.show_private_marketplace, showSellTabAsDropdown = _b.show_sell_tab_as_dropdown, showSellTab = _b.show_sell_tab, showSellVehicles = _b.show_sell_vehicles, showSellerAuction = _b.show_seller_auction, showPrivateAuction = _b.show_private_auction, showDealershipPurchases = _b.show_dealership_purchases, showSearchMobileTabs = _b.show_search_mobile_tabs, showTransport = _b.show_transport, showUnifiedMarketplace = _b.show_unified_marketplace_react;
    var isMasterUser = user.is_account_master || user.master_on_behalf_of || ((_a = user === null || user === void 0 ? void 0 : user.on_behalf_of) === null || _a === void 0 ? void 0 : _a.user_id);
    var unifiedMarketplaceItem = showUnifiedMarketplace
        ? [
            {
                name: 'Buy',
                path: routes.search,
                icon: 'tag',
                enabled: showBuyerAuction || showMarketplace || showPrivateAuction || showPrivateMarketplace
            }
        ]
        : null;
    // Buyer Private/Marketplace and Private/Auction case 1
    if (showBuyerAuction && showMarketplace && !showSellTab) {
        return buyerAuctionMarketplace({
            showPrivateAuction: showPrivateAuction,
            showPrivateMarketplace: showPrivateMarketplace,
            showDealershipPurchases: showDealershipPurchases,
            showSearchMobileTabs: showSearchMobileTabs,
            showTransport: showTransport,
            unifiedMarketplaceItem: unifiedMarketplaceItem
        });
    }
    // Buyer Private/Marketplace Only case 2
    if ((showMarketplace || showPrivateMarketplace) && !showSellTab && !showBuyerAuction) {
        return buyerMarketplaceOnly({
            showPrivateMarketplace: showPrivateMarketplace,
            showDealershipPurchases: showDealershipPurchases,
            showSearchMobileTabs: showSearchMobileTabs,
            showTransport: showTransport,
            unifiedMarketplaceItem: unifiedMarketplaceItem
        });
    }
    // Buyer Private/Auction Only case 3
    if ((showBuyerAuction || showPrivateAuction) && !showMarketplace && !showSellTab) {
        return buyerAuctionOnly({ showPrivateAuction: showPrivateAuction, showDealershipPurchases: showDealershipPurchases, showTransport: showTransport, unifiedMarketplaceItem: unifiedMarketplaceItem });
    }
    // Auction as seller, Marketplace as seller and PA as buyer case 4
    if (showSellTab &&
        showSellTabAsDropdown &&
        showSellerAuction &&
        showPrivateAuction &&
        !showPrivateMarketplace &&
        !showMarketplace &&
        !showBuyerAuction &&
        showSellVehicles) {
        return sellMarketplaceAndAuctionWithPA({
            showDealershipPurchases: showDealershipPurchases,
            showSearchMobileTabs: showSearchMobileTabs,
            showTransport: showTransport,
            unifiedMarketplaceItem: unifiedMarketplaceItem
        });
    }
    // Master/Seller Private/Marketplace and Private/Auction case 5
    if (showSellTab &&
        (showSellerAuction || showPrivateAuction) &&
        !showMarketplace &&
        !showBuyerAuction &&
        showSellVehicles) {
        return sellerAuctionMarketplace({
            showPrivateAuction: showPrivateAuction,
            showPrivateMarketplace: showPrivateMarketplace,
            isMasterUser: isMasterUser,
            showTransport: showTransport,
            unifiedMarketplaceItem: unifiedMarketplaceItem
        });
    }
    // Master/Seller with Private/Marketplace Only case 6
    if (showSellTab && showSellVehicles && !showMarketplace && !showBuyerAuction && !showSellerAuction) {
        return sellerMarketplaceOnly({ showPrivateMarketplace: showPrivateMarketplace, isMasterUser: isMasterUser, showTransport: showTransport, unifiedMarketplaceItem: unifiedMarketplaceItem });
    }
    // Master/Seller Private/Auction Only case 7
    if (showSellTab && (showSellerAuction || showPrivateAuction) && !showMarketplace && !showBuyerAuction) {
        return sellerAuctionOnly({ showPrivateAuction: showPrivateAuction, isMasterUser: isMasterUser, showTransport: showTransport, unifiedMarketplaceItem: unifiedMarketplaceItem });
    }
    // Seller Private/Marketplace with PA case 8
    if (showSellTab && showSellVehicles && showPrivateAuction && !showSellerAuction) {
        return sellerMarketplaceWithPA({
            showPrivateMarketplace: showPrivateMarketplace,
            showDealershipPurchases: showDealershipPurchases,
            showSearchMobileTabs: showSearchMobileTabs,
            showTransport: showTransport,
            unifiedMarketplaceItem: unifiedMarketplaceItem
        });
    }
    // Sell Marketplace and Auction with Buyer Private/Auction and Private/Marketplace with/without CTN case 9
    if (showSellTab && showSellVehicles) {
        return sellMarketplaceAndAuctionWithBuyerMarketplaceWithCTN({
            showMarketplace: showMarketplace,
            showPrivateMarketplace: showPrivateMarketplace,
            showGroupListings: showGroupListings,
            showBuyerAuction: showBuyerAuction,
            showSellerAuction: showSellerAuction,
            closedMarketplace: closedMarketplace,
            showDealershipPurchases: showDealershipPurchases,
            showPrivateAuction: showPrivateAuction,
            showSearchMobileTabs: showSearchMobileTabs,
            showTransport: showTransport,
            unifiedMarketplaceItem: unifiedMarketplaceItem
        });
    }
    return [];
};

/* eslint-disable camelcase */
var getNavigationItems = function (user, closedMarketplace, enableChangeAccount) {
    var navigation = user.navigation, title_clerk_token = user.title_clerk_token;
    if (!navigation)
        return;
    var show_buyer_auction = navigation.show_buyer_auction, show_dealership_purchases = navigation.show_dealership_purchases, show_group_listings = navigation.show_group_listings, show_gtv_offers = navigation.show_gtv_offers, show_marketplace = navigation.show_marketplace, show_offers_made = navigation.show_offers_made, show_private_marketplace = navigation.show_private_marketplace, show_search = navigation.show_search, show_sell_tab_as_dropdown = navigation.show_sell_tab_as_dropdown, show_sell_vehicles = navigation.show_sell_vehicles, show_seller_auction = navigation.show_seller_auction, show_timed_sale_inventory = navigation.show_timed_sale_inventory, show_title_clerk = navigation.show_title_clerk, show_private_auction = navigation.show_private_auction, show_sell_tab = navigation.show_sell_tab, show_transport = navigation.show_transport, show_unified_marketplace_react = navigation.show_unified_marketplace_react;
    var marketplaceItem = show_unified_marketplace_react
        ? [
            {
                name: 'Buy',
                path: routes.search,
                icon: null,
                enabled: show_buyer_auction || show_marketplace || show_private_auction || show_private_marketplace
            }
        ]
        : [
            {
                name: 'Marketplace',
                path: routes.none,
                icon: null,
                enabled: show_marketplace || show_private_marketplace,
                label: show_private_marketplace ? 'Private' : null,
                items: [
                    {
                        name: 'Group listings',
                        path: routes.group_listings(closedMarketplace),
                        icon: null,
                        enabled: show_group_listings
                    },
                    {
                        name: 'Search',
                        path: routes.search,
                        icon: null,
                        enabled: show_search
                    },
                    {
                        name: 'Private marketplace',
                        path: routes.private_marketplace,
                        icon: null,
                        enabled: show_private_marketplace
                    },
                    {
                        name: 'My bids',
                        path: routes.my_offers,
                        icon: null,
                        enabled: show_offers_made
                    },
                    {
                        name: 'Watchlist',
                        path: routes.watchlist,
                        icon: null,
                        enabled: true
                    }
                ]
            },
            {
                name: 'Auction',
                path: routes.auction_buyer,
                icon: null,
                items: null,
                enabled: show_buyer_auction || show_private_auction,
                label: show_private_auction ? 'Private' : null
            }
        ];
    return {
        desktop: {
            common: {
                items: __spreadArray(__spreadArray([], marketplaceItem, true), [
                    {
                        name: 'My purchases',
                        path: routes.none,
                        icon: null,
                        enabled: show_dealership_purchases,
                        items: [
                            {
                                name: 'Checkout',
                                path: routes.checkout,
                                icon: null,
                                enabled: true
                            },
                            {
                                name: 'Orders',
                                path: routes.orders,
                                icon: null,
                                enabled: true
                            }
                        ]
                    },
                    {
                        name: 'Transport',
                        path: routes.transport,
                        items: null,
                        enabled: show_transport,
                        icon: jsx(Icon, { name: "external", size: "smallest", color: "colorIconIconPrimary" }),
                        target: '_blank'
                    }
                ], false)
            },
            seller: {
                items: [
                    {
                        name: 'Sell',
                        path: show_sell_tab_as_dropdown
                            ? routes.none
                            : show_timed_sale_inventory
                                ? routes.auction_seller
                                : show_sell_vehicles
                                    ? routes.vehicles
                                    : routes.none,
                        icon: null,
                        items: show_sell_tab_as_dropdown
                            ? [
                                {
                                    name: 'Auction',
                                    path: routes.auction_seller,
                                    icon: null,
                                    enabled: show_seller_auction
                                },
                                {
                                    name: 'Marketplace',
                                    path: routes.vehicles,
                                    icon: null,
                                    enabled: true
                                }
                            ]
                            : null,
                        enabled: show_sell_tab
                    },
                    {
                        name: 'Sold vehicles',
                        path: routes.sold_vehicles,
                        icon: null,
                        enabled: show_sell_tab
                    }
                ]
            }
        },
        tablet: {
            common: {
                items: __spreadArray(__spreadArray([], marketplaceItem, true), [
                    {
                        name: 'My purchases',
                        path: routes.none,
                        icon: null,
                        enabled: show_dealership_purchases,
                        items: [
                            {
                                name: 'Checkout',
                                path: routes.checkout,
                                icon: null,
                                enabled: true
                            },
                            {
                                name: 'Orders',
                                path: routes.orders,
                                icon: null,
                                enabled: true
                            }
                        ]
                    }
                ], false)
            },
            seller: {
                items: [
                    {
                        name: 'Sell',
                        path: show_sell_tab_as_dropdown
                            ? routes.none
                            : show_timed_sale_inventory
                                ? routes.auction_seller
                                : show_sell_vehicles
                                    ? routes.vehicles
                                    : routes.none,
                        icon: null,
                        items: show_sell_tab_as_dropdown
                            ? [
                                {
                                    name: 'Auction',
                                    path: routes.auction_seller,
                                    icon: null,
                                    enabled: show_seller_auction
                                },
                                {
                                    name: 'Marketplace',
                                    path: routes.vehicles,
                                    icon: null,
                                    enabled: true
                                }
                            ]
                            : null,
                        enabled: show_sell_tab
                    },
                    {
                        name: 'Sold vehicles',
                        path: routes.sold_vehicles,
                        icon: null,
                        enabled: show_sell_tab
                    },
                    {
                        name: 'Transport',
                        path: routes.transport,
                        items: null,
                        enabled: show_transport,
                        icon: jsx(Icon, { name: "external", size: "smallest", color: "colorIconIconPrimary" }),
                        target: '_blank'
                    }
                ]
            }
        },
        mobile: {
            common: {
                items: getMobileItems(user, closedMarketplace)
            },
            more: {
                items: [
                    {
                        name: 'Title clerk',
                        path: "".concat(routes.title_clerk, "?token=").concat(title_clerk_token),
                        items: null,
                        icon: jsx(Icon, { name: "title" }),
                        enabled: show_title_clerk
                    },
                    {
                        name: 'GO',
                        path: routes.gtv_offers,
                        items: null,
                        icon: jsx(Icon, { name: "go-1" }),
                        enabled: show_gtv_offers
                    },
                    {
                        name: 'Settings',
                        path: routes.settings,
                        items: null,
                        icon: jsx(Icon, { name: "settings" }),
                        enabled: true
                    },
                    {
                        name: 'Openlane support',
                        path: routes.none,
                        items: null,
                        enabled: false
                    },
                    {
                        name: navItemsName.changeAccount,
                        path: null,
                        items: null,
                        icon: jsx(Icon, { name: "rotate" }),
                        enabled: enableChangeAccount
                    },
                    {
                        name: 'Logout',
                        path: null,
                        items: null,
                        icon: jsx(Icon, { name: "sign-out" }),
                        enabled: true
                    }
                ]
            }
        }
    };
};

var ContactMyRepEmailLink = function (_a) {
    var repEmailAddress = _a.repEmailAddress;
    return (jsx(Button, __assign({ variant: "link", iconSize: "smallest", icon: "notification-mail", iconPosition: "left", iconColor: "colorIconIconBrand", labelColor: "colorTextLinkLinkVisited", href: "mailto:".concat(repEmailAddress) }, { children: "Contact via email" })));
};

var ContactMyRepPhoneNumber = function (_a) {
    var repPhoneNumber = _a.repPhoneNumber;
    return (jsx(Button, __assign({ variant: "link", href: "tel:".concat(repPhoneNumber), iconSize: "smallest", icon: "notification-phone", iconPosition: "left" }, { children: repPhoneNumber })));
};

var RepImage = styled(Avatar)(templateObject_1$x || (templateObject_1$x = __makeTemplateObject(["\n  border-radius: 5px;\n  border: none;\n  object-fit: cover;\n  width: 124px;\n  height: 124px;\n"], ["\n  border-radius: 5px;\n  border: none;\n  object-fit: cover;\n  width: 124px;\n  height: 124px;\n"])));
var templateObject_1$x;

var ContactMyRepItem = function (_a) {
    var rep = _a.rep;
    return (jsxs(FlexBox, __assign({ padding: 16, gap: 16 }, { children: [jsx(FlexBox, { children: jsx(RepImage, { src: rep.repImageUrl, width: "124px", height: "124px", size: "full" }) }), jsxs(FlexBox, __assign({ flexDirection: "column", justifyContent: "space-between" }, { children: [jsxs(FlexBox, __assign({ flexDirection: "column", gap: 4 }, { children: [jsx(Body, __assign({ color: "coreSecondaryBlue", bold: true }, { children: rep.repName })), jsx(Body, __assign({ color: "neutralGray70" }, { children: rep.repTitle }))] })), jsxs(FlexBox, __assign({ flexDirection: "row", gap: 12 }, { children: [rep.repEmailAddress && jsx(ContactMyRepEmailLink, { repEmailAddress: rep.repEmailAddress }), rep.repPhoneNumber && jsx(ContactMyRepPhoneNumber, { repPhoneNumber: rep.repPhoneNumber })] }))] }))] })));
};

var ContactMyRepBody = function (_a) {
    var myReps = _a.myReps;
    return (jsx(FlexBox, __assign({ flex: 0, padding: 16, flexDirection: "column" }, { children: myReps.map(function (rep, i) { return (jsx(ContactMyRepItem, { rep: rep }, i)); }) })));
};

var ContactMyRep = function (_a) {
    var myReps = _a.myReps, handleContactMyRepClose = _a.handleContactMyRepClose;
    return (jsxs(CustomDropdownContainer, __assign({ isMobileViewport: false, height: "auto" }, { children: [jsx(CustomDropdownHeader, { onClose: handleContactMyRepClose, title: "Contact My Rep" }), jsx(ContactMyRepBody, { myReps: myReps })] })));
};

var Navigation = function (_a) {
    var children = _a.children, notifications = _a.notifications, unreadNotifications = _a.unreadNotifications, loadingNotifications = _a.loadingNotifications, loadingGroupAccounts = _a.loadingGroupAccounts, user = _a.user, pendingCheckoutItems = _a.pendingCheckoutItems, groupAccounts = _a.groupAccounts, closedMarketplace = _a.closedMarketplace, handleDeleteNotification = _a.handleDeleteNotification, handleDeleteAllNotifications = _a.handleDeleteAllNotifications, handleReadAllNotifications = _a.handleReadAllNotifications, handleClearUnreadNotifications = _a.handleClearUnreadNotifications, handleSetNotifications = _a.handleSetNotifications, handleChangeAccount = _a.handleChangeAccount, handleSetGroupAccounts = _a.handleSetGroupAccounts, handleNavigate = _a.handleNavigate, handleLogout = _a.handleLogout, mockedPath = _a.mockedPath;
    var currentPath = getCurrentPath(mockedPath);
    var _b = useState(viewports.desktop), viewport = _b[0], setViewport = _b[1];
    var _c = useState(false), showChangeAccount = _c[0], setShowChangeAccount = _c[1];
    var _d = useState(false), showContactMyRep = _d[0], setShowContactMyRep = _d[1];
    var enableChangeAccount = Boolean((user === null || user === void 0 ? void 0 : user.is_account_master) || (user === null || user === void 0 ? void 0 : user.multiple_dealerships));
    var dealershipReps = user.dealership_reps;
    var enableContactMyRep = Boolean(dealershipReps && dealershipReps.length);
    var width = useWindowSize().width;
    var navigationItems = useMemo(function () { return getNavigationItems(user, closedMarketplace, enableChangeAccount); }, [user]);
    useEffect(function () {
        if (width) {
            if (width < viewportsMinWidth.tablet) {
                setViewport(viewports.mobile);
            }
            else if (width <= viewportsMinWidth.desktop) {
                setViewport(viewports.tablet);
            }
            else {
                setViewport(viewports.desktop);
            }
        }
    }, [width]);
    var onHandleNavigate = function (args) {
        var path = args.path, target = args.target, name = args.name;
        if (name === navItemsName.logout && handleLogout) {
            handleLogout();
            return;
        }
        if (name === navItemsName.changeAccount) {
            handleShowChangeAccount();
            return;
        }
        if (name === navItemsName.contactMyRep) {
            setShowContactMyRep(true);
            return;
        }
        if (path) {
            handleNavigate(path, target);
        }
    };
    var handleShowChangeAccount = function () {
        if (!groupAccounts) {
            handleSetGroupAccounts();
        }
        setShowChangeAccount(true);
    };
    var isMobileView = viewport === viewports.mobile;
    var handleContactMyRepClose = function () { return setShowContactMyRep(false); };
    return (jsxs(NavigationContext.Provider, __assign({ value: {
            notifications: notifications,
            unreadNotifications: unreadNotifications,
            pendingCheckoutItems: pendingCheckoutItems,
            loadingGroupAccounts: loadingGroupAccounts,
            loadingNotifications: loadingNotifications,
            groupAccounts: groupAccounts,
            user: user,
            currentPath: currentPath,
            enableChangeAccount: enableChangeAccount,
            handleNavigate: onHandleNavigate,
            handleLogout: handleLogout,
            handleDeleteAllNotifications: handleDeleteAllNotifications,
            handleDeleteNotification: handleDeleteNotification,
            handleReadAllNotifications: handleReadAllNotifications,
            handleClearUnreadNotifications: handleClearUnreadNotifications,
            handleSetNotifications: handleSetNotifications,
            handleChangeAccount: handleChangeAccount,
            handleSetGroupAccounts: handleSetGroupAccounts
        } }, { children: [isMobileView ? (jsx(MobileNavigationTopBar, { items: navigationItems === null || navigationItems === void 0 ? void 0 : navigationItems.mobile, mockedPath: mockedPath, hasContent: Boolean(children) })) : (jsx(DesktopNavigationHeader, { viewport: viewport, user: user, navigationItems: navigationItems, groupAccounts: groupAccounts, hasContent: Boolean(children), enableContactMyRep: enableContactMyRep })), children, isMobileView && jsx(MobileNavigationBottomBar, { items: navigationItems === null || navigationItems === void 0 ? void 0 : navigationItems.mobile, hasContent: Boolean(children) }), showChangeAccount && jsx(ChangeAccount, { accounts: groupAccounts, handleClose: function () { return setShowChangeAccount(false); } }), enableContactMyRep && showContactMyRep && (jsx(ContactMyRep, { myReps: dealershipReps, handleContactMyRepClose: handleContactMyRepClose }))] })));
};

var RADIO_BUTTON_SIZE = '22px';
var Container$3 = styled.div(templateObject_1$w || (templateObject_1$w = __makeTemplateObject(["\n  position: relative;\n  box-sizing: border-box;\n  width: ", ";\n  min-width: ", ";\n  max-width: ", ";\n  height: ", ";\n  min-height: ", ";\n  max-height: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 100%;\n\n  input[type='radio'] {\n    border: 1px solid ", ";\n    border-radius: 100%;\n    outline: none;\n    position: absolute;\n    appearance: none;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    cursor: ", ";\n  }\n\n  ", "\n\n  ", ";\n\n  ", "\n\n  .dot {\n    width: 14px;\n    height: 14px;\n    border-radius: 100%;\n    ", "\n  }\n"], ["\n  position: relative;\n  box-sizing: border-box;\n  width: ", ";\n  min-width: ", ";\n  max-width: ", ";\n  height: ", ";\n  min-height: ", ";\n  max-height: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 100%;\n\n  input[type='radio'] {\n    border: 1px solid ", ";\n    border-radius: 100%;\n    outline: none;\n    position: absolute;\n    appearance: none;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    cursor: ", ";\n  }\n\n  ", "\n\n  ", ";\n\n  ", "\n\n  .dot {\n    width: 14px;\n    height: 14px;\n    border-radius: 100%;\n    ", "\n  }\n"])), RADIO_BUTTON_SIZE, RADIO_BUTTON_SIZE, RADIO_BUTTON_SIZE, RADIO_BUTTON_SIZE, RADIO_BUTTON_SIZE, RADIO_BUTTON_SIZE, colorFormBorder.colorFormBorderDefault, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'not-allowed' : 'pointer');
}, baseStyle({ borderRadius: '100%', position: '0px' }), function (_a) {
    var disabled = _a.disabled, checked = _a.checked;
    return disabled
        ? "\n      input[type='radio'] {\n        border: 1px solid ".concat(colorFormBorder.colorFormBorderDefault, ";\n      }\n      background: ").concat(colorFormSurface.colorFormSurfaceDisabled, " !important;\n      ")
        : checked
            ? "\n      input[type='radio']{\n         border: 1px solid ".concat(colorFormBorder.colorFormBorderActive, ";\n      }\n        ")
            : "\n      &:hover,\n      &:active,\n      &:focus,\n      &:focus-within {\n        input[type='radio']{\n          border: 1px solid ".concat(colorFormBorder.colorFormBorderActive, ";\n        }\n      }\n\n\n      ");
}, function (_a) {
    var disabled = _a.disabled;
    return !disabled
        ? "\n        ".concat(focusWithinStyle, "\n        ").concat(hoverStyle, "\n        ").concat(activeStyle, "\n      ")
        : "";
}, function (_a) {
    var checked = _a.checked, disabled = _a.disabled, _b = _a.radioColor, radioColor = _b === void 0 ? 'colorFormSurfaceChecked' : _b;
    return checked && disabled
        ? "\n        background: ".concat(colorIcon.colorIconIconSecondary, " !important;\n        ")
        : checked
            ? "\n        background: ".concat(getFormSurfaceColor(radioColor), " !important;\n        ")
            : '';
});
var templateObject_1$w;

var Radio = forwardRef(function (_a, ref) {
    var _b = _a.checked, checked = _b === void 0 ? false : _b, className = _a.className, _c = _a.disabled, disabled = _c === void 0 ? false : _c, id = _a.id, _d = _a.name, name = _d === void 0 ? 'radio' : _d, value = _a.value, color = _a.color, onChange = _a.onChange;
    var handleOnChange = function (value) { return onChange && onChange(value); };
    var handleChange = function (event) {
        handleOnChange(event.target.value);
    };
    return (jsxs(Container$3, __assign({ className: "radio-container ".concat(className), disabled: disabled, checked: checked, radioColor: color, "data-form-error": true }, { children: [jsx("input", { type: "radio", "aria-label": name, name: name, value: value, id: id, checked: checked, disabled: disabled, onChange: function (event) {
                    if (!disabled)
                        handleChange(event);
                }, ref: ref }), jsx("div", { className: "dot" })] })));
});
Radio.displayName = 'Radio';

var SpinningIcon = styled(Icon)(templateObject_1$v || (templateObject_1$v = __makeTemplateObject(["\n  animation: spin 1s linear infinite;\n\n  @keyframes spin {\n    0% {\n      transform: rotate(0deg);\n    }\n\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n"], ["\n  animation: spin 1s linear infinite;\n\n  @keyframes spin {\n    0% {\n      transform: rotate(0deg);\n    }\n\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n"])));
var templateObject_1$v;

var Spinner = function (_a) {
    var size = _a.size, color = _a.color, className = _a.className;
    return (jsx(SpinningIcon, { name: "spinner", size: size, color: color, className: "chromatic-ignore ".concat(className) }));
};

var DefaultButton = styled(Button).attrs({ size: 'smaller', variant: 'text' })(templateObject_1$u || (templateObject_1$u = __makeTemplateObject([""], [""])));
var DefaultMoreButton = styled(DefaultButton).attrs({
    className: 'show-more-button show-more-button__more',
    icon: 'caret-down'
})(templateObject_2$e || (templateObject_2$e = __makeTemplateObject([""], [""])));
var DefaultLessButton = styled(DefaultButton).attrs({
    className: 'show-more-button show-more-button__less',
    icon: 'caret-up'
})(templateObject_3$8 || (templateObject_3$8 = __makeTemplateObject([""], [""])));
var templateObject_1$u, templateObject_2$e, templateObject_3$8;

var ItemsContainer = styled.div.attrs({ className: 'show-more-items-container' })(templateObject_1$t || (templateObject_1$t = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n\n  ", "\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n\n  ", "\n  ", "\n"])), function (_a) {
    var gap = _a.gap;
    return (gap ? "gap: ".concat(gap, ";") : '');
}, function (_a) {
    var orientation = _a.orientation;
    return orientation === 'vertical'
        ? "\n    flex-direction: column;\n    "
        : "\n    flex-direction: row;\n    ";
});
var ItemContainer = styled.div.attrs({ className: 'show-more-item' })(templateObject_2$d || (templateObject_2$d = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var orientation = _a.orientation;
    return orientation === 'vertical'
        ? "\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    "
        : "\n\n    ";
});
var templateObject_1$t, templateObject_2$d;

var ShowMore = function (_a) {
    var children = _a.children, ShowMoreComponent = _a.ShowMoreComponent, ShowLessComponent = _a.ShowLessComponent, _b = _a.collapsable, collapsable = _b === void 0 ? true : _b, _c = _a.showMoreText, showMoreText = _c === void 0 ? 'Show more' : _c, _d = _a.showLessText, showLessText = _d === void 0 ? 'Show less' : _d, _e = _a.showRemainingItemsNumber, showRemainingItemsNumber = _e === void 0 ? false : _e, _f = _a.minVisibleItems, minVisibleItems = _f === void 0 ? 6 : _f, gap = _a.gap, orientation = _a.orientation;
    var _g = useState(false), showAll = _g[0], setShowAll = _g[1];
    var ShowMore = ShowMoreComponent || DefaultMoreButton;
    var ShowLess = ShowLessComponent || DefaultLessButton;
    var items = Children.toArray(children);
    var showMoreButton = !showAll && items.length > minVisibleItems;
    var remainingCount = items.length - minVisibleItems;
    var showMoreButtonText = "".concat(showMoreText, " ").concat(showRemainingItemsNumber ? "(+".concat(remainingCount, ")") : '');
    var showLessButton = showAll && items.length > minVisibleItems;
    var itemsToShow = showAll || items.length <= minVisibleItems ? items.length : minVisibleItems;
    return (jsx(Fragment, { children: jsxs(ItemsContainer, __assign({ gap: gap, orientation: orientation }, { children: [items &&
                    items.slice(0, collapsable ? itemsToShow : items.length).map(function (item, index) { return (jsx(ItemContainer, __assign({ orientation: orientation }, { children: item }), index)); }), collapsable && showMoreButton && (jsx(ShowMore, __assign({ remaining: remainingCount, onClick: function () { return setShowAll(true); } }, { children: showMoreButtonText }))), collapsable && showLessButton && jsx(ShowLess, __assign({ onClick: function () { return setShowAll(false); } }, { children: showLessText }))] })) }));
};

var FormLabelContainer = styled(Body).attrs({ type: 'label' })(templateObject_1$s || (templateObject_1$s = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n\n  ", "\n"])), function (_a) {
    var labelMinWidth = _a.labelMinWidth;
    return labelMinWidth && "min-width: ".concat(getSizeValue(labelMinWidth));
});
var FormLabelRequiredIcon = styled(Body).attrs({
    type: 'caption'
})(templateObject_2$c || (templateObject_2$c = __makeTemplateObject(["\n  margin-left: 4px;\n"], ["\n  margin-left: 4px;\n"])));
var IconContainer = styled.div(templateObject_3$7 || (templateObject_3$7 = __makeTemplateObject(["\n  margin-left: 5px;\n  line-height: 0px;\n"], ["\n  margin-left: 5px;\n  line-height: 0px;\n"])));
var templateObject_1$s, templateObject_2$c, templateObject_3$7;

var FormLabel = function (_a) {
    var name = _a.name, required = _a.required, text = _a.text, information = _a.information, informationTooltipPosition = _a.informationTooltipPosition, labelMinWidth = _a.labelMinWidth;
    return (jsxs(FormLabelContainer, __assign({ htmlFor: name, labelMinWidth: labelMinWidth }, { children: [text, jsxs(Fragment, { children: [Boolean(required) && (jsx(FormLabelRequiredIcon, __assign({ bold: true, color: "alert" }, { children: "*" }))), information && (jsx(IconContainer, { children: jsx(Tooltip, __assign({ position: informationTooltipPosition, width: "276px", content: information }, { children: jsx(Icon, { name: "info", size: "smaller", color: "grayLight" }) })) }))] })] })));
};

var FormComponentContainer = styled.div(templateObject_1$r || (templateObject_1$r = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n\n  ", "\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n\n  ", "\n"])), function (_a) {
    var hasErrors = _a.hasErrors;
    return hasErrors &&
        "\n    & [data-form-error]\n    {\n      border-color: ".concat(colorFormBorder.colorFormBorderError, " !important;\n\n      &.radio-container {\n        background: ").concat(colorFormSurface.colorFormSurfaceDefault, ";\n\n        &:not([disabled]){\n          :focus-within,\n          :hover,\n          :active {\n            .dot {\n              background: ").concat(colorInteractionBase['colorInteractionAlert-100'], ";\n            }\n          }\n        }\n      }\n\n      input[type='radio'],\n      input[type='checkbox'] {\n        border: 1px solid ").concat(colorFormBorder.colorFormBorderError, " !important;\n      }\n    }\n\n    .input-prefix-container {\n      border-color: ").concat(colorFormBorder.colorFormBorderError, " !important;\n    }\n  ");
});
var ColumnLabelContainer = styled.div(templateObject_2$b || (templateObject_2$b = __makeTemplateObject(["\n  display: flex;\n  flex-direction: ", ";\n  gap: 8px;\n"], ["\n  display: flex;\n  flex-direction: ", ";\n  gap: 8px;\n"])), function (_a) {
    var reverse = _a.reverse;
    return (reverse ? 'column-reverse' : 'column');
});
var RowLabelContainer = styled.div(templateObject_3$6 || (templateObject_3$6 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  white-space: ", ";\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  white-space: ", ";\n  ", "\n"])), function (_a) {
    var labelWrap = _a.labelWrap;
    return (labelWrap ? 'normal' : 'nowrap');
}, function (_a) {
    var reverse = _a.reverse;
    return reverse
        ? "\n  flex-direction: row-reverse;\n  justify-content: flex-end;\n  "
        : '';
});
var templateObject_1$r, templateObject_2$b, templateObject_3$6;

var FormControl = function (_a) {
    var children = _a.children, formErrors = _a.formErrors, label = _a.label, _b = _a.labelPosition, labelPosition = _b === void 0 ? 'top' : _b, _c = _a.labelWrap, labelWrap = _c === void 0 ? false : _c, required = _a.required, _d = _a.hideErrorMessage, hideErrorMessage = _d === void 0 ? false : _d, inputName = _a.inputName, tooltipMessage = _a.tooltipMessage, tooltipPosition = _a.tooltipPosition, dataTestid = _a["data-testid"], labelMinWidth = _a.labelMinWidth;
    if (isValidElement(children)) {
        var name_1 = children.props.name;
        var formInputName = inputName || name_1;
        var _e = (formErrors === null || formErrors === void 0 ? void 0 : formErrors[formInputName]) || {}, errorType = _e.type, message = _e.message;
        var errorMessage = message || errorType;
        var hasErrors = Boolean(errorMessage);
        var reverse = labelPosition === 'right';
        var horizontal = labelPosition === 'right' || labelPosition === 'left';
        var LabelContainer = horizontal ? RowLabelContainer : ColumnLabelContainer;
        return (jsxs(FormComponentContainer, __assign({ hasErrors: hasErrors }, { children: [jsxs(LabelContainer, __assign({ reverse: reverse, labelWrap: labelWrap }, { children: [label && (jsx(FormLabel, { name: name_1, required: required, text: label, information: tooltipMessage, informationTooltipPosition: tooltipPosition, labelMinWidth: labelMinWidth })), children] })), !hideErrorMessage && hasErrors && jsx(FormError, { "data-testid": dataTestid, text: errorMessage })] })));
    }
    return null;
};

var reactInputMaskExports = {};
var reactInputMask = {
  get exports(){ return reactInputMaskExports; },
  set exports(v){ reactInputMaskExports = v; },
};

var reactInputMask_production_min;
var hasRequiredReactInputMask_production_min;

function requireReactInputMask_production_min () {
	if (hasRequiredReactInputMask_production_min) return reactInputMask_production_min;
	hasRequiredReactInputMask_production_min = 1;
function _interopDefault(e){return e&&"object"==typeof e&&"default"in e?e["default"]:e}var React=_interopDefault(React__default),reactDom=require$$1__default;function _defaults2(e,t){for(var n=Object.getOwnPropertyNames(t),a=0;a<n.length;a++){var i=n[a],r=Object.getOwnPropertyDescriptor(t,i);r&&r.configurable&&e[i]===undefined&&Object.defineProperty(e,i,r);}return e}function _extends(){return (_extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);}return e}).apply(this,arguments)}function _inheritsLoose(e,t){e.prototype=Object.create(t.prototype),_defaults2(e.prototype.constructor=e,t);}function _objectWithoutPropertiesLoose(e,t){if(null==e)return {};var n,a,i={},r=Object.keys(e);for(a=0;a<r.length;a++)n=r[a],0<=t.indexOf(n)||(i[n]=e[n]);return i}function _assertThisInitialized(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}var invariant=function(e,t,n,a,i,r,o,s){if(!e){var l;if(t===undefined)l=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {var u=[n,a,i,r,o,s],c=0;(l=new Error(t.replace(/%s/g,function(){return u[c++]}))).name="Invariant Violation";}throw l.framesToPop=1,l}},invariant_1=invariant;function setInputSelection(e,t,n){if("selectionStart"in e&&"selectionEnd"in e)e.selectionStart=t,e.selectionEnd=n;else {var a=e.createTextRange();a.collapse(!0),a.moveStart("character",t),a.moveEnd("character",n-t),a.select();}}function getInputSelection(e){var t=0,n=0;if("selectionStart"in e&&"selectionEnd"in e)t=e.selectionStart,n=e.selectionEnd;else {var a=document.selection.createRange();a.parentElement()===e&&(t=-a.moveStart("character",-e.value.length),n=-a.moveEnd("character",-e.value.length));}return {start:t,end:n,length:n-t}}var defaultFormatChars={9:"[0-9]",a:"[A-Za-z]","*":"[A-Za-z0-9]"},defaultMaskChar="_";function parseMask(e,t,n){var a="",i="",r=null,o=[];if(t===undefined&&(t=defaultMaskChar),null==n&&(n=defaultFormatChars),!e||"string"!=typeof e)return {maskChar:t,formatChars:n,mask:null,prefix:null,lastEditablePosition:null,permanents:[]};var s=!1;return e.split("").forEach(function(e){s=!s&&"\\"===e||(s||!n[e]?(o.push(a.length),a.length===o.length-1&&(i+=e)):r=a.length+1,a+=e,!1);}),{maskChar:t,formatChars:n,prefix:i,mask:a,lastEditablePosition:r,permanents:o}}function isPermanentCharacter(e,t){return -1!==e.permanents.indexOf(t)}function isAllowedCharacter(e,t,n){var a=e.mask,i=e.formatChars;if(!n)return !1;if(isPermanentCharacter(e,t))return a[t]===n;var r=i[a[t]];return new RegExp(r).test(n)}function isEmpty(n,e){return e.split("").every(function(e,t){return isPermanentCharacter(n,t)||!isAllowedCharacter(n,t,e)})}function getFilledLength(e,t){var n=e.maskChar,a=e.prefix;if(!n){for(;t.length>a.length&&isPermanentCharacter(e,t.length-1);)t=t.slice(0,t.length-1);return t.length}for(var i=a.length,r=t.length;r>=a.length;r--){var o=t[r];if(!isPermanentCharacter(e,r)&&isAllowedCharacter(e,r,o)){i=r+1;break}}return i}function isFilled(e,t){return getFilledLength(e,t)===e.mask.length}function formatValue(e,t){var n=e.maskChar,a=e.mask,i=e.prefix;if(!n){for((t=insertString(e,"",t,0)).length<i.length&&(t=i);t.length<a.length&&isPermanentCharacter(e,t.length);)t+=a[t.length];return t}if(t)return insertString(e,formatValue(e,""),t,0);for(var r=0;r<a.length;r++)isPermanentCharacter(e,r)?t+=a[r]:t+=n;return t}function clearRange(n,e,a,t){var i=a+t,r=n.maskChar,o=n.mask,s=n.prefix,l=e.split("");if(r)return l.map(function(e,t){return t<a||i<=t?e:isPermanentCharacter(n,t)?o[t]:r}).join("");for(var u=i;u<l.length;u++)isPermanentCharacter(n,u)&&(l[u]="");return a=Math.max(s.length,a),l.splice(a,i-a),e=l.join(""),formatValue(n,e)}function insertString(r,o,e,s){var l=r.mask,u=r.maskChar,c=r.prefix,t=e.split(""),h=isFilled(r,o);return !u&&s>o.length&&(o+=l.slice(o.length,s)),t.every(function(e){for(;i=e,isPermanentCharacter(r,a=s)&&i!==l[a];){if(s>=o.length&&(o+=l[s]),t=e,n=s,u&&isPermanentCharacter(r,n)&&t===u)return !0;if(++s>=l.length)return !1}var t,n,a,i;return !isAllowedCharacter(r,s,e)&&e!==u||(s<o.length?o=u||h||s<c.length?o.slice(0,s)+e+o.slice(s+1):(o=o.slice(0,s)+e+o.slice(s),formatValue(r,o)):u||(o+=e),++s<l.length)}),o}function getInsertStringLength(a,e,t,i){var r=a.mask,o=a.maskChar,n=t.split(""),s=i;return n.every(function(e){for(;n=e,isPermanentCharacter(a,t=i)&&n!==r[t];)if(++i>=r.length)return !1;var t,n;return (isAllowedCharacter(a,i,e)||e===o)&&i++,i<r.length}),i-s}function getLeftEditablePosition(e,t){for(var n=t;0<=n;--n)if(!isPermanentCharacter(e,n))return n;return null}function getRightEditablePosition(e,t){for(var n=e.mask,a=t;a<n.length;++a)if(!isPermanentCharacter(e,a))return a;return null}function getStringValue(e){return e||0===e?e+"":""}function processChange(e,t,n,a,i){var r=e.mask,o=e.prefix,s=e.lastEditablePosition,l=t,u="",c=0,h=0,f=Math.min(i.start,n.start);if(n.end>i.start?h=(c=getInsertStringLength(e,a,u=l.slice(i.start,n.end),f))?i.length:0:l.length<a.length&&(h=a.length-l.length),l=a,h){if(1===h&&!i.length)f=i.start===n.start?getRightEditablePosition(e,n.start):getLeftEditablePosition(e,n.start);l=clearRange(e,l,f,h);}return l=insertString(e,l,u,f),(f+=c)>=r.length?f=r.length:f<o.length&&!c?f=o.length:f>=o.length&&f<s&&c&&(f=getRightEditablePosition(e,f)),u||(u=null),{value:l=formatValue(e,l),enteredString:u,selection:{start:f,end:f}}}function isWindowsPhoneBrowser(){var e=new RegExp("windows","i"),t=new RegExp("phone","i"),n=navigator.userAgent;return e.test(n)&&t.test(n)}function isFunction(e){return "function"==typeof e}function getRequestAnimationFrame(){return window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame}function getCancelAnimationFrame(){return window.cancelAnimationFrame||window.webkitCancelRequestAnimationFrame||window.webkitCancelAnimationFrame||window.mozCancelAnimationFrame}function defer(e){return (!!getCancelAnimationFrame()?getRequestAnimationFrame():function(){return setTimeout(e,1e3/60)})(e)}function cancelDefer(e){(getCancelAnimationFrame()||clearTimeout)(e);}var InputElement=function(c){function e(e){var f=c.call(this,e)||this;f.focused=!1,f.mounted=!1,f.previousSelection=null,f.selectionDeferId=null,f.saveSelectionLoopDeferId=null,f.saveSelectionLoop=function(){f.previousSelection=f.getSelection(),f.saveSelectionLoopDeferId=defer(f.saveSelectionLoop);},f.runSaveSelectionLoop=function(){null===f.saveSelectionLoopDeferId&&f.saveSelectionLoop();},f.stopSaveSelectionLoop=function(){null!==f.saveSelectionLoopDeferId&&(cancelDefer(f.saveSelectionLoopDeferId),f.saveSelectionLoopDeferId=null,f.previousSelection=null);},f.getInputDOMNode=function(){if(!f.mounted)return null;var e=reactDom.findDOMNode(_assertThisInitialized(_assertThisInitialized(f))),t="undefined"!=typeof window&&e instanceof window.Element;if(e&&!t)return null;if("INPUT"!==e.nodeName&&(e=e.querySelector("input")),!e)throw new Error("react-input-mask: inputComponent doesn't contain input node");return e},f.getInputValue=function(){var e=f.getInputDOMNode();return e?e.value:null},f.setInputValue=function(e){var t=f.getInputDOMNode();t&&(f.value=e,t.value=e);},f.setCursorToEnd=function(){var e=getFilledLength(f.maskOptions,f.value),t=getRightEditablePosition(f.maskOptions,e);null!==t&&f.setCursorPosition(t);},f.setSelection=function(e,t,n){void 0===n&&(n={});var a=f.getInputDOMNode(),i=f.isFocused();a&&i&&(n.deferred||setInputSelection(a,e,t),null!==f.selectionDeferId&&cancelDefer(f.selectionDeferId),f.selectionDeferId=defer(function(){f.selectionDeferId=null,setInputSelection(a,e,t);}),f.previousSelection={start:e,end:t,length:Math.abs(t-e)});},f.getSelection=function(){return getInputSelection(f.getInputDOMNode())},f.getCursorPosition=function(){return f.getSelection().start},f.setCursorPosition=function(e){f.setSelection(e,e);},f.isFocused=function(){return f.focused},f.getBeforeMaskedValueChangeConfig=function(){var e=f.maskOptions,t=e.mask,n=e.maskChar,a=e.permanents,i=e.formatChars;return {mask:t,maskChar:n,permanents:a,alwaysShowMask:!!f.props.alwaysShowMask,formatChars:i}},f.isInputAutofilled=function(e,t,n,a){var i=f.getInputDOMNode();try{if(i.matches(":-webkit-autofill"))return !0}catch(r){}return !f.focused||a.end<n.length&&t.end===e.length},f.onChange=function(e){var t=_assertThisInitialized(_assertThisInitialized(f)).beforePasteState,n=_assertThisInitialized(_assertThisInitialized(f)).previousSelection,a=f.props.beforeMaskedValueChange,i=f.getInputValue(),r=f.value,o=f.getSelection();f.isInputAutofilled(i,o,r,n)&&(r=formatValue(f.maskOptions,""),n={start:0,end:0,length:0}),t&&(n=t.selection,r=t.value,o={start:n.start+i.length,end:n.start+i.length,length:0},i=r.slice(0,n.start)+i+r.slice(n.end),f.beforePasteState=null);var s=processChange(f.maskOptions,i,o,r,n),l=s.enteredString,u=s.selection,c=s.value;if(isFunction(a)){var h=a({value:c,selection:u},{value:r,selection:n},l,f.getBeforeMaskedValueChangeConfig());c=h.value,u=h.selection;}f.setInputValue(c),isFunction(f.props.onChange)&&f.props.onChange(e),f.isWindowsPhoneBrowser?f.setSelection(u.start,u.end,{deferred:!0}):f.setSelection(u.start,u.end);},f.onFocus=function(e){var t=f.props.beforeMaskedValueChange,n=f.maskOptions,a=n.mask,i=n.prefix;if(f.focused=!0,f.mounted=!0,a){if(f.value)getFilledLength(f.maskOptions,f.value)<f.maskOptions.mask.length&&f.setCursorToEnd();else {var r=formatValue(f.maskOptions,i),o=formatValue(f.maskOptions,r),s=getFilledLength(f.maskOptions,o),l=getRightEditablePosition(f.maskOptions,s),u={start:l,end:l};if(isFunction(t)){var c=t({value:o,selection:u},{value:f.value,selection:null},null,f.getBeforeMaskedValueChangeConfig());o=c.value,u=c.selection;}var h=o!==f.getInputValue();h&&f.setInputValue(o),h&&isFunction(f.props.onChange)&&f.props.onChange(e),f.setSelection(u.start,u.end);}f.runSaveSelectionLoop();}isFunction(f.props.onFocus)&&f.props.onFocus(e);},f.onBlur=function(e){var t=f.props.beforeMaskedValueChange,n=f.maskOptions.mask;if(f.stopSaveSelectionLoop(),f.focused=!1,n&&!f.props.alwaysShowMask&&isEmpty(f.maskOptions,f.value)){var a="";if(isFunction(t))a=t({value:a,selection:null},{value:f.value,selection:f.previousSelection},null,f.getBeforeMaskedValueChangeConfig()).value;var i=a!==f.getInputValue();i&&f.setInputValue(a),i&&isFunction(f.props.onChange)&&f.props.onChange(e);}isFunction(f.props.onBlur)&&f.props.onBlur(e);},f.onMouseDown=function(e){if(!f.focused&&document.addEventListener){f.mouseDownX=e.clientX,f.mouseDownY=e.clientY,f.mouseDownTime=(new Date).getTime();var r=function r(e){if(document.removeEventListener("mouseup",r),f.focused){var t=Math.abs(e.clientX-f.mouseDownX),n=Math.abs(e.clientY-f.mouseDownY),a=Math.max(t,n),i=(new Date).getTime()-f.mouseDownTime;(a<=10&&i<=200||a<=5&&i<=300)&&f.setCursorToEnd();}};document.addEventListener("mouseup",r);}isFunction(f.props.onMouseDown)&&f.props.onMouseDown(e);},f.onPaste=function(e){isFunction(f.props.onPaste)&&f.props.onPaste(e),e.defaultPrevented||(f.beforePasteState={value:f.getInputValue(),selection:f.getSelection()},f.setInputValue(""));},f.handleRef=function(e){null==f.props.children&&isFunction(f.props.inputRef)&&f.props.inputRef(e);};var t=e.mask,n=e.maskChar,a=e.formatChars,i=e.alwaysShowMask,r=e.beforeMaskedValueChange,o=e.defaultValue,s=e.value;f.maskOptions=parseMask(t,n,a),null==o&&(o=""),null==s&&(s=o);var l=getStringValue(s);if(f.maskOptions.mask&&(i||l)&&(l=formatValue(f.maskOptions,l),isFunction(r))){var u=e.value;null==e.value&&(u=o),l=r({value:l,selection:null},{value:u=getStringValue(u),selection:null},null,f.getBeforeMaskedValueChangeConfig()).value;}return f.value=l,f}_inheritsLoose(e,c);var t=e.prototype;return t.componentDidMount=function(){this.mounted=!0,this.getInputDOMNode()&&(this.isWindowsPhoneBrowser=isWindowsPhoneBrowser(),this.maskOptions.mask&&this.getInputValue()!==this.value&&this.setInputValue(this.value));},t.componentDidUpdate=function(){var e=this.previousSelection,t=this.props,n=t.beforeMaskedValueChange,a=t.alwaysShowMask,i=t.mask,r=t.maskChar,o=t.formatChars,s=this.maskOptions,l=a||this.isFocused(),u=null!=this.props.value,c=u?getStringValue(this.props.value):this.value,h=e?e.start:null;if(this.maskOptions=parseMask(i,r,o),this.maskOptions.mask){!s.mask&&this.isFocused()&&this.runSaveSelectionLoop();var f=this.maskOptions.mask&&this.maskOptions.mask!==s.mask;if(s.mask||u||(c=this.getInputValue()),(f||this.maskOptions.mask&&(c||l))&&(c=formatValue(this.maskOptions,c)),f){var p=getFilledLength(this.maskOptions,c);(null===h||p<h)&&(h=isFilled(this.maskOptions,c)?p:getRightEditablePosition(this.maskOptions,p));}!this.maskOptions.mask||!isEmpty(this.maskOptions,c)||l||u&&this.props.value||(c="");var d={start:h,end:h};if(isFunction(n)){var m=n({value:c,selection:d},{value:this.value,selection:this.previousSelection},null,this.getBeforeMaskedValueChangeConfig());c=m.value,d=m.selection;}this.value=c;var g=this.getInputValue()!==this.value;g?(this.setInputValue(this.value),this.forceUpdate()):f&&this.forceUpdate();var v=!1;null!=d.start&&null!=d.end&&(v=!e||e.start!==d.start||e.end!==d.end),(v||g)&&this.setSelection(d.start,d.end);}else s.mask&&(this.stopSaveSelectionLoop(),this.forceUpdate());},t.componentWillUnmount=function(){this.mounted=!1,null!==this.selectionDeferId&&cancelDefer(this.selectionDeferId),this.stopSaveSelectionLoop();},t.render=function(){var t,e=this.props,n=(e.mask,e.alwaysShowMask,e.maskChar,e.formatChars,e.inputRef,e.beforeMaskedValueChange,e.children),a=_objectWithoutPropertiesLoose(e,["mask","alwaysShowMask","maskChar","formatChars","inputRef","beforeMaskedValueChange","children"]);if(n){isFunction(n)||invariant_1(!1);var i=["onChange","onPaste","onMouseDown","onFocus","onBlur","value","disabled","readOnly"],r=_extends({},a);i.forEach(function(e){return delete r[e]}),t=n(r),i.filter(function(e){return null!=t.props[e]&&t.props[e]!==a[e]}).length&&invariant_1(!1);}else t=React.createElement("input",_extends({ref:this.handleRef},a));var o={onFocus:this.onFocus,onBlur:this.onBlur};return this.maskOptions.mask&&(a.disabled||a.readOnly||(o.onChange=this.onChange,o.onPaste=this.onPaste,o.onMouseDown=this.onMouseDown),null!=a.value&&(o.value=this.value)),t=React.cloneElement(t,o)},e}(React.Component);reactInputMask_production_min=InputElement;
	return reactInputMask_production_min;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var invariant_1;
var hasRequiredInvariant;

function requireInvariant () {
	if (hasRequiredInvariant) return invariant_1;
	hasRequiredInvariant = 1;

	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */

	var NODE_ENV = process.env.NODE_ENV;

	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (NODE_ENV !== 'production') {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }

	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }

	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};

	invariant_1 = invariant;
	return invariant_1;
}

var reactInputMask_development;
var hasRequiredReactInputMask_development;

function requireReactInputMask_development () {
	if (hasRequiredReactInputMask_development) return reactInputMask_development;
	hasRequiredReactInputMask_development = 1;

	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

	var React = _interopDefault(React__default);
	var reactDom = require$$1__default;
	var invariant = _interopDefault(requireInvariant());
	var warning = _interopDefault(warning_1);

	function _defaults2(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];

	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }

	    return target;
	  };

	  return _extends.apply(this, arguments);
	}

	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;

	  _defaults2(subClass, superClass);
	}

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;

	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }

	  return target;
	}

	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }

	  return self;
	}

	function setInputSelection(input, start, end) {
	  if ('selectionStart' in input && 'selectionEnd' in input) {
	    input.selectionStart = start;
	    input.selectionEnd = end;
	  } else {
	    var range = input.createTextRange();
	    range.collapse(true);
	    range.moveStart('character', start);
	    range.moveEnd('character', end - start);
	    range.select();
	  }
	}
	function getInputSelection(input) {
	  var start = 0;
	  var end = 0;

	  if ('selectionStart' in input && 'selectionEnd' in input) {
	    start = input.selectionStart;
	    end = input.selectionEnd;
	  } else {
	    var range = document.selection.createRange();

	    if (range.parentElement() === input) {
	      start = -range.moveStart('character', -input.value.length);
	      end = -range.moveEnd('character', -input.value.length);
	    }
	  }

	  return {
	    start: start,
	    end: end,
	    length: end - start
	  };
	}

	var defaultFormatChars = {
	  '9': '[0-9]',
	  'a': '[A-Za-z]',
	  '*': '[A-Za-z0-9]'
	};
	var defaultMaskChar = '_';

	function parseMask (mask, maskChar, formatChars) {
	  var parsedMaskString = '';
	  var prefix = '';
	  var lastEditablePosition = null;
	  var permanents = [];

	  if (maskChar === undefined) {
	    maskChar = defaultMaskChar;
	  }

	  if (formatChars == null) {
	    formatChars = defaultFormatChars;
	  }

	  if (!mask || typeof mask !== 'string') {
	    return {
	      maskChar: maskChar,
	      formatChars: formatChars,
	      mask: null,
	      prefix: null,
	      lastEditablePosition: null,
	      permanents: []
	    };
	  }

	  var isPermanent = false;
	  mask.split('').forEach(function (character) {
	    if (!isPermanent && character === '\\') {
	      isPermanent = true;
	    } else {
	      if (isPermanent || !formatChars[character]) {
	        permanents.push(parsedMaskString.length);

	        if (parsedMaskString.length === permanents.length - 1) {
	          prefix += character;
	        }
	      } else {
	        lastEditablePosition = parsedMaskString.length + 1;
	      }

	      parsedMaskString += character;
	      isPermanent = false;
	    }
	  });
	  return {
	    maskChar: maskChar,
	    formatChars: formatChars,
	    prefix: prefix,
	    mask: parsedMaskString,
	    lastEditablePosition: lastEditablePosition,
	    permanents: permanents
	  };
	}

	/* eslint no-use-before-define: ["error", { functions: false }] */
	function isPermanentCharacter(maskOptions, pos) {
	  return maskOptions.permanents.indexOf(pos) !== -1;
	}
	function isAllowedCharacter(maskOptions, pos, character) {
	  var mask = maskOptions.mask,
	      formatChars = maskOptions.formatChars;

	  if (!character) {
	    return false;
	  }

	  if (isPermanentCharacter(maskOptions, pos)) {
	    return mask[pos] === character;
	  }

	  var ruleChar = mask[pos];
	  var charRule = formatChars[ruleChar];
	  return new RegExp(charRule).test(character);
	}
	function isEmpty(maskOptions, value) {
	  return value.split('').every(function (character, i) {
	    return isPermanentCharacter(maskOptions, i) || !isAllowedCharacter(maskOptions, i, character);
	  });
	}
	function getFilledLength(maskOptions, value) {
	  var maskChar = maskOptions.maskChar,
	      prefix = maskOptions.prefix;

	  if (!maskChar) {
	    while (value.length > prefix.length && isPermanentCharacter(maskOptions, value.length - 1)) {
	      value = value.slice(0, value.length - 1);
	    }

	    return value.length;
	  }

	  var filledLength = prefix.length;

	  for (var i = value.length; i >= prefix.length; i--) {
	    var character = value[i];
	    var isEnteredCharacter = !isPermanentCharacter(maskOptions, i) && isAllowedCharacter(maskOptions, i, character);

	    if (isEnteredCharacter) {
	      filledLength = i + 1;
	      break;
	    }
	  }

	  return filledLength;
	}
	function isFilled(maskOptions, value) {
	  return getFilledLength(maskOptions, value) === maskOptions.mask.length;
	}
	function formatValue(maskOptions, value) {
	  var maskChar = maskOptions.maskChar,
	      mask = maskOptions.mask,
	      prefix = maskOptions.prefix;

	  if (!maskChar) {
	    value = insertString(maskOptions, '', value, 0);

	    if (value.length < prefix.length) {
	      value = prefix;
	    }

	    while (value.length < mask.length && isPermanentCharacter(maskOptions, value.length)) {
	      value += mask[value.length];
	    }

	    return value;
	  }

	  if (value) {
	    var emptyValue = formatValue(maskOptions, '');
	    return insertString(maskOptions, emptyValue, value, 0);
	  }

	  for (var i = 0; i < mask.length; i++) {
	    if (isPermanentCharacter(maskOptions, i)) {
	      value += mask[i];
	    } else {
	      value += maskChar;
	    }
	  }

	  return value;
	}
	function clearRange(maskOptions, value, start, len) {
	  var end = start + len;
	  var maskChar = maskOptions.maskChar,
	      mask = maskOptions.mask,
	      prefix = maskOptions.prefix;
	  var arrayValue = value.split('');

	  if (!maskChar) {
	    // remove any permanent chars after clear range, they will be added back by formatValue
	    for (var i = end; i < arrayValue.length; i++) {
	      if (isPermanentCharacter(maskOptions, i)) {
	        arrayValue[i] = '';
	      }
	    }

	    start = Math.max(prefix.length, start);
	    arrayValue.splice(start, end - start);
	    value = arrayValue.join('');
	    return formatValue(maskOptions, value);
	  }

	  return arrayValue.map(function (character, i) {
	    if (i < start || i >= end) {
	      return character;
	    }

	    if (isPermanentCharacter(maskOptions, i)) {
	      return mask[i];
	    }

	    return maskChar;
	  }).join('');
	}
	function insertString(maskOptions, value, insertStr, insertPosition) {
	  var mask = maskOptions.mask,
	      maskChar = maskOptions.maskChar,
	      prefix = maskOptions.prefix;
	  var arrayInsertStr = insertStr.split('');
	  var isInputFilled = isFilled(maskOptions, value);

	  var isUsablePosition = function isUsablePosition(pos, character) {
	    return !isPermanentCharacter(maskOptions, pos) || character === mask[pos];
	  };

	  var isUsableCharacter = function isUsableCharacter(character, pos) {
	    return !maskChar || !isPermanentCharacter(maskOptions, pos) || character !== maskChar;
	  };

	  if (!maskChar && insertPosition > value.length) {
	    value += mask.slice(value.length, insertPosition);
	  }

	  arrayInsertStr.every(function (insertCharacter) {
	    while (!isUsablePosition(insertPosition, insertCharacter)) {
	      if (insertPosition >= value.length) {
	        value += mask[insertPosition];
	      }

	      if (!isUsableCharacter(insertCharacter, insertPosition)) {
	        return true;
	      }

	      insertPosition++; // stop iteration if maximum value length reached

	      if (insertPosition >= mask.length) {
	        return false;
	      }
	    }

	    var isAllowed = isAllowedCharacter(maskOptions, insertPosition, insertCharacter) || insertCharacter === maskChar;

	    if (!isAllowed) {
	      return true;
	    }

	    if (insertPosition < value.length) {
	      if (maskChar || isInputFilled || insertPosition < prefix.length) {
	        value = value.slice(0, insertPosition) + insertCharacter + value.slice(insertPosition + 1);
	      } else {
	        value = value.slice(0, insertPosition) + insertCharacter + value.slice(insertPosition);
	        value = formatValue(maskOptions, value);
	      }
	    } else if (!maskChar) {
	      value += insertCharacter;
	    }

	    insertPosition++; // stop iteration if maximum value length reached

	    return insertPosition < mask.length;
	  });
	  return value;
	}
	function getInsertStringLength(maskOptions, value, insertStr, insertPosition) {
	  var mask = maskOptions.mask,
	      maskChar = maskOptions.maskChar;
	  var arrayInsertStr = insertStr.split('');
	  var initialInsertPosition = insertPosition;

	  var isUsablePosition = function isUsablePosition(pos, character) {
	    return !isPermanentCharacter(maskOptions, pos) || character === mask[pos];
	  };

	  arrayInsertStr.every(function (insertCharacter) {
	    while (!isUsablePosition(insertPosition, insertCharacter)) {
	      insertPosition++; // stop iteration if maximum value length reached

	      if (insertPosition >= mask.length) {
	        return false;
	      }
	    }

	    var isAllowed = isAllowedCharacter(maskOptions, insertPosition, insertCharacter) || insertCharacter === maskChar;

	    if (isAllowed) {
	      insertPosition++;
	    } // stop iteration if maximum value length reached


	    return insertPosition < mask.length;
	  });
	  return insertPosition - initialInsertPosition;
	}
	function getLeftEditablePosition(maskOptions, pos) {
	  for (var i = pos; i >= 0; --i) {
	    if (!isPermanentCharacter(maskOptions, i)) {
	      return i;
	    }
	  }

	  return null;
	}
	function getRightEditablePosition(maskOptions, pos) {
	  var mask = maskOptions.mask;

	  for (var i = pos; i < mask.length; ++i) {
	    if (!isPermanentCharacter(maskOptions, i)) {
	      return i;
	    }
	  }

	  return null;
	}
	function getStringValue(value) {
	  return !value && value !== 0 ? '' : value + '';
	}

	function processChange(maskOptions, value, selection, previousValue, previousSelection) {
	  var mask = maskOptions.mask,
	      prefix = maskOptions.prefix,
	      lastEditablePosition = maskOptions.lastEditablePosition;
	  var newValue = value;
	  var enteredString = '';
	  var formattedEnteredStringLength = 0;
	  var removedLength = 0;
	  var cursorPosition = Math.min(previousSelection.start, selection.start);

	  if (selection.end > previousSelection.start) {
	    enteredString = newValue.slice(previousSelection.start, selection.end);
	    formattedEnteredStringLength = getInsertStringLength(maskOptions, previousValue, enteredString, cursorPosition);

	    if (!formattedEnteredStringLength) {
	      removedLength = 0;
	    } else {
	      removedLength = previousSelection.length;
	    }
	  } else if (newValue.length < previousValue.length) {
	    removedLength = previousValue.length - newValue.length;
	  }

	  newValue = previousValue;

	  if (removedLength) {
	    if (removedLength === 1 && !previousSelection.length) {
	      var deleteFromRight = previousSelection.start === selection.start;
	      cursorPosition = deleteFromRight ? getRightEditablePosition(maskOptions, selection.start) : getLeftEditablePosition(maskOptions, selection.start);
	    }

	    newValue = clearRange(maskOptions, newValue, cursorPosition, removedLength);
	  }

	  newValue = insertString(maskOptions, newValue, enteredString, cursorPosition);
	  cursorPosition = cursorPosition + formattedEnteredStringLength;

	  if (cursorPosition >= mask.length) {
	    cursorPosition = mask.length;
	  } else if (cursorPosition < prefix.length && !formattedEnteredStringLength) {
	    cursorPosition = prefix.length;
	  } else if (cursorPosition >= prefix.length && cursorPosition < lastEditablePosition && formattedEnteredStringLength) {
	    cursorPosition = getRightEditablePosition(maskOptions, cursorPosition);
	  }

	  newValue = formatValue(maskOptions, newValue);

	  if (!enteredString) {
	    enteredString = null;
	  }

	  return {
	    value: newValue,
	    enteredString: enteredString,
	    selection: {
	      start: cursorPosition,
	      end: cursorPosition
	    }
	  };
	}

	function isWindowsPhoneBrowser() {
	  var windows = new RegExp('windows', 'i');
	  var phone = new RegExp('phone', 'i');
	  var ua = navigator.userAgent;
	  return windows.test(ua) && phone.test(ua);
	}

	function isFunction(value) {
	  return typeof value === 'function';
	}

	function getRequestAnimationFrame() {
	  return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;
	}

	function getCancelAnimationFrame() {
	  return window.cancelAnimationFrame || window.webkitCancelRequestAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame;
	}

	function defer(fn) {
	  var hasCancelAnimationFrame = !!getCancelAnimationFrame();
	  var deferFn;

	  if (hasCancelAnimationFrame) {
	    deferFn = getRequestAnimationFrame();
	  } else {
	    deferFn = function deferFn() {
	      return setTimeout(fn, 1000 / 60);
	    };
	  }

	  return deferFn(fn);
	}
	function cancelDefer(deferId) {
	  var cancelFn = getCancelAnimationFrame() || clearTimeout;
	  cancelFn(deferId);
	}

	var InputElement =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(InputElement, _React$Component);

	  function InputElement(props) {
	    var _this;

	    _this = _React$Component.call(this, props) || this;
	    _this.focused = false;
	    _this.mounted = false;
	    _this.previousSelection = null;
	    _this.selectionDeferId = null;
	    _this.saveSelectionLoopDeferId = null;

	    _this.saveSelectionLoop = function () {
	      _this.previousSelection = _this.getSelection();
	      _this.saveSelectionLoopDeferId = defer(_this.saveSelectionLoop);
	    };

	    _this.runSaveSelectionLoop = function () {
	      if (_this.saveSelectionLoopDeferId === null) {
	        _this.saveSelectionLoop();
	      }
	    };

	    _this.stopSaveSelectionLoop = function () {
	      if (_this.saveSelectionLoopDeferId !== null) {
	        cancelDefer(_this.saveSelectionLoopDeferId);
	        _this.saveSelectionLoopDeferId = null;
	        _this.previousSelection = null;
	      }
	    };

	    _this.getInputDOMNode = function () {
	      if (!_this.mounted) {
	        return null;
	      }

	      var input = reactDom.findDOMNode(_assertThisInitialized(_assertThisInitialized(_this)));
	      var isDOMNode = typeof window !== 'undefined' && input instanceof window.Element; // workaround for react-test-renderer
	      // https://github.com/sanniassin/react-input-mask/issues/147

	      if (input && !isDOMNode) {
	        return null;
	      }

	      if (input.nodeName !== 'INPUT') {
	        input = input.querySelector('input');
	      }

	      if (!input) {
	        throw new Error('react-input-mask: inputComponent doesn\'t contain input node');
	      }

	      return input;
	    };

	    _this.getInputValue = function () {
	      var input = _this.getInputDOMNode();

	      if (!input) {
	        return null;
	      }

	      return input.value;
	    };

	    _this.setInputValue = function (value) {
	      var input = _this.getInputDOMNode();

	      if (!input) {
	        return;
	      }

	      _this.value = value;
	      input.value = value;
	    };

	    _this.setCursorToEnd = function () {
	      var filledLength = getFilledLength(_this.maskOptions, _this.value);
	      var pos = getRightEditablePosition(_this.maskOptions, filledLength);

	      if (pos !== null) {
	        _this.setCursorPosition(pos);
	      }
	    };

	    _this.setSelection = function (start, end, options) {
	      if (options === void 0) {
	        options = {};
	      }

	      var input = _this.getInputDOMNode();

	      var isFocused = _this.isFocused(); // don't change selection on unfocused input
	      // because Safari sets focus on selection change (#154)


	      if (!input || !isFocused) {
	        return;
	      }

	      var _options = options,
	          deferred = _options.deferred;

	      if (!deferred) {
	        setInputSelection(input, start, end);
	      }

	      if (_this.selectionDeferId !== null) {
	        cancelDefer(_this.selectionDeferId);
	      } // deferred selection update is required for pre-Lollipop Android browser,
	      // but for consistent behavior we do it for all browsers


	      _this.selectionDeferId = defer(function () {
	        _this.selectionDeferId = null;
	        setInputSelection(input, start, end);
	      });
	      _this.previousSelection = {
	        start: start,
	        end: end,
	        length: Math.abs(end - start)
	      };
	    };

	    _this.getSelection = function () {
	      var input = _this.getInputDOMNode();

	      return getInputSelection(input);
	    };

	    _this.getCursorPosition = function () {
	      return _this.getSelection().start;
	    };

	    _this.setCursorPosition = function (pos) {
	      _this.setSelection(pos, pos);
	    };

	    _this.isFocused = function () {
	      return _this.focused;
	    };

	    _this.getBeforeMaskedValueChangeConfig = function () {
	      var _this$maskOptions = _this.maskOptions,
	          mask = _this$maskOptions.mask,
	          maskChar = _this$maskOptions.maskChar,
	          permanents = _this$maskOptions.permanents,
	          formatChars = _this$maskOptions.formatChars;
	      var alwaysShowMask = _this.props.alwaysShowMask;
	      return {
	        mask: mask,
	        maskChar: maskChar,
	        permanents: permanents,
	        alwaysShowMask: !!alwaysShowMask,
	        formatChars: formatChars
	      };
	    };

	    _this.isInputAutofilled = function (value, selection, previousValue, previousSelection) {
	      var input = _this.getInputDOMNode(); // only check for positive match because it will be false negative
	      // in case of autofill simulation in tests
	      //
	      // input.matches throws an exception if selector isn't supported


	      try {
	        if (input.matches(':-webkit-autofill')) {
	          return true;
	        }
	      } catch (e) {} // if input isn't focused then change event must have been triggered
	      // either by autofill or event simulation in tests


	      if (!_this.focused) {
	        return true;
	      } // if cursor has moved to the end while previousSelection forbids it
	      // then it must be autofill


	      return previousSelection.end < previousValue.length && selection.end === value.length;
	    };

	    _this.onChange = function (event) {
	      var _assertThisInitialize = _assertThisInitialized(_assertThisInitialized(_this)),
	          beforePasteState = _assertThisInitialize.beforePasteState;

	      var _assertThisInitialize2 = _assertThisInitialized(_assertThisInitialized(_this)),
	          previousSelection = _assertThisInitialize2.previousSelection;

	      var beforeMaskedValueChange = _this.props.beforeMaskedValueChange;

	      var value = _this.getInputValue();

	      var previousValue = _this.value;

	      var selection = _this.getSelection(); // autofill replaces entire value, ignore old one
	      // https://github.com/sanniassin/react-input-mask/issues/113


	      if (_this.isInputAutofilled(value, selection, previousValue, previousSelection)) {
	        previousValue = formatValue(_this.maskOptions, '');
	        previousSelection = {
	          start: 0,
	          end: 0,
	          length: 0
	        };
	      } // set value and selection as if we haven't
	      // cleared input in onPaste handler


	      if (beforePasteState) {
	        previousSelection = beforePasteState.selection;
	        previousValue = beforePasteState.value;
	        selection = {
	          start: previousSelection.start + value.length,
	          end: previousSelection.start + value.length,
	          length: 0
	        };
	        value = previousValue.slice(0, previousSelection.start) + value + previousValue.slice(previousSelection.end);
	        _this.beforePasteState = null;
	      }

	      var changedState = processChange(_this.maskOptions, value, selection, previousValue, previousSelection);
	      var enteredString = changedState.enteredString;
	      var newSelection = changedState.selection;
	      var newValue = changedState.value;

	      if (isFunction(beforeMaskedValueChange)) {
	        var modifiedValue = beforeMaskedValueChange({
	          value: newValue,
	          selection: newSelection
	        }, {
	          value: previousValue,
	          selection: previousSelection
	        }, enteredString, _this.getBeforeMaskedValueChangeConfig());
	        newValue = modifiedValue.value;
	        newSelection = modifiedValue.selection;
	      }

	      _this.setInputValue(newValue);

	      if (isFunction(_this.props.onChange)) {
	        _this.props.onChange(event);
	      }

	      if (_this.isWindowsPhoneBrowser) {
	        _this.setSelection(newSelection.start, newSelection.end, {
	          deferred: true
	        });
	      } else {
	        _this.setSelection(newSelection.start, newSelection.end);
	      }
	    };

	    _this.onFocus = function (event) {
	      var beforeMaskedValueChange = _this.props.beforeMaskedValueChange;
	      var _this$maskOptions2 = _this.maskOptions,
	          mask = _this$maskOptions2.mask,
	          prefix = _this$maskOptions2.prefix;
	      _this.focused = true; // if autoFocus is set, onFocus triggers before componentDidMount

	      _this.mounted = true;

	      if (mask) {
	        if (!_this.value) {
	          var emptyValue = formatValue(_this.maskOptions, prefix);
	          var newValue = formatValue(_this.maskOptions, emptyValue);
	          var filledLength = getFilledLength(_this.maskOptions, newValue);
	          var cursorPosition = getRightEditablePosition(_this.maskOptions, filledLength);
	          var newSelection = {
	            start: cursorPosition,
	            end: cursorPosition
	          };

	          if (isFunction(beforeMaskedValueChange)) {
	            var modifiedValue = beforeMaskedValueChange({
	              value: newValue,
	              selection: newSelection
	            }, {
	              value: _this.value,
	              selection: null
	            }, null, _this.getBeforeMaskedValueChangeConfig());
	            newValue = modifiedValue.value;
	            newSelection = modifiedValue.selection;
	          }

	          var isInputValueChanged = newValue !== _this.getInputValue();

	          if (isInputValueChanged) {
	            _this.setInputValue(newValue);
	          }

	          if (isInputValueChanged && isFunction(_this.props.onChange)) {
	            _this.props.onChange(event);
	          }

	          _this.setSelection(newSelection.start, newSelection.end);
	        } else if (getFilledLength(_this.maskOptions, _this.value) < _this.maskOptions.mask.length) {
	          _this.setCursorToEnd();
	        }

	        _this.runSaveSelectionLoop();
	      }

	      if (isFunction(_this.props.onFocus)) {
	        _this.props.onFocus(event);
	      }
	    };

	    _this.onBlur = function (event) {
	      var beforeMaskedValueChange = _this.props.beforeMaskedValueChange;
	      var mask = _this.maskOptions.mask;

	      _this.stopSaveSelectionLoop();

	      _this.focused = false;

	      if (mask && !_this.props.alwaysShowMask && isEmpty(_this.maskOptions, _this.value)) {
	        var newValue = '';

	        if (isFunction(beforeMaskedValueChange)) {
	          var modifiedValue = beforeMaskedValueChange({
	            value: newValue,
	            selection: null
	          }, {
	            value: _this.value,
	            selection: _this.previousSelection
	          }, null, _this.getBeforeMaskedValueChangeConfig());
	          newValue = modifiedValue.value;
	        }

	        var isInputValueChanged = newValue !== _this.getInputValue();

	        if (isInputValueChanged) {
	          _this.setInputValue(newValue);
	        }

	        if (isInputValueChanged && isFunction(_this.props.onChange)) {
	          _this.props.onChange(event);
	        }
	      }

	      if (isFunction(_this.props.onBlur)) {
	        _this.props.onBlur(event);
	      }
	    };

	    _this.onMouseDown = function (event) {
	      // tiny unintentional mouse movements can break cursor
	      // position on focus, so we have to restore it in that case
	      //
	      // https://github.com/sanniassin/react-input-mask/issues/108
	      if (!_this.focused && document.addEventListener) {
	        _this.mouseDownX = event.clientX;
	        _this.mouseDownY = event.clientY;
	        _this.mouseDownTime = new Date().getTime();

	        var mouseUpHandler = function mouseUpHandler(mouseUpEvent) {
	          document.removeEventListener('mouseup', mouseUpHandler);

	          if (!_this.focused) {
	            return;
	          }

	          var deltaX = Math.abs(mouseUpEvent.clientX - _this.mouseDownX);
	          var deltaY = Math.abs(mouseUpEvent.clientY - _this.mouseDownY);
	          var axisDelta = Math.max(deltaX, deltaY);

	          var timeDelta = new Date().getTime() - _this.mouseDownTime;

	          if (axisDelta <= 10 && timeDelta <= 200 || axisDelta <= 5 && timeDelta <= 300) {
	            _this.setCursorToEnd();
	          }
	        };

	        document.addEventListener('mouseup', mouseUpHandler);
	      }

	      if (isFunction(_this.props.onMouseDown)) {
	        _this.props.onMouseDown(event);
	      }
	    };

	    _this.onPaste = function (event) {
	      if (isFunction(_this.props.onPaste)) {
	        _this.props.onPaste(event);
	      } // event.clipboardData might not work in Android browser
	      // cleaning input to get raw text inside onChange handler


	      if (!event.defaultPrevented) {
	        _this.beforePasteState = {
	          value: _this.getInputValue(),
	          selection: _this.getSelection()
	        };

	        _this.setInputValue('');
	      }
	    };

	    _this.handleRef = function (ref) {
	      if (_this.props.children == null && isFunction(_this.props.inputRef)) {
	        _this.props.inputRef(ref);
	      }
	    };

	    var _mask = props.mask,
	        _maskChar = props.maskChar,
	        _formatChars = props.formatChars,
	        _alwaysShowMask = props.alwaysShowMask,
	        _beforeMaskedValueChange = props.beforeMaskedValueChange;
	    var defaultValue = props.defaultValue,
	        _value = props.value;
	    _this.maskOptions = parseMask(_mask, _maskChar, _formatChars);

	    if (defaultValue == null) {
	      defaultValue = '';
	    }

	    if (_value == null) {
	      _value = defaultValue;
	    }

	    var _newValue = getStringValue(_value);

	    if (_this.maskOptions.mask && (_alwaysShowMask || _newValue)) {
	      _newValue = formatValue(_this.maskOptions, _newValue);

	      if (isFunction(_beforeMaskedValueChange)) {
	        var oldValue = props.value;

	        if (props.value == null) {
	          oldValue = defaultValue;
	        }

	        oldValue = getStringValue(oldValue);

	        var modifiedValue = _beforeMaskedValueChange({
	          value: _newValue,
	          selection: null
	        }, {
	          value: oldValue,
	          selection: null
	        }, null, _this.getBeforeMaskedValueChangeConfig());

	        _newValue = modifiedValue.value;
	      }
	    }

	    _this.value = _newValue;
	    return _this;
	  }

	  var _proto = InputElement.prototype;

	  _proto.componentDidMount = function componentDidMount() {
	    this.mounted = true; // workaround for react-test-renderer
	    // https://github.com/sanniassin/react-input-mask/issues/147

	    if (!this.getInputDOMNode()) {
	      return;
	    }

	    this.isWindowsPhoneBrowser = isWindowsPhoneBrowser();

	    if (this.maskOptions.mask && this.getInputValue() !== this.value) {
	      this.setInputValue(this.value);
	    }
	  };

	  _proto.componentDidUpdate = function componentDidUpdate() {
	    var previousSelection = this.previousSelection;
	    var _this$props = this.props,
	        beforeMaskedValueChange = _this$props.beforeMaskedValueChange,
	        alwaysShowMask = _this$props.alwaysShowMask,
	        mask = _this$props.mask,
	        maskChar = _this$props.maskChar,
	        formatChars = _this$props.formatChars;
	    var previousMaskOptions = this.maskOptions;
	    var showEmpty = alwaysShowMask || this.isFocused();
	    var hasValue = this.props.value != null;
	    var newValue = hasValue ? getStringValue(this.props.value) : this.value;
	    var cursorPosition = previousSelection ? previousSelection.start : null;
	    this.maskOptions = parseMask(mask, maskChar, formatChars);

	    if (!this.maskOptions.mask) {
	      if (previousMaskOptions.mask) {
	        this.stopSaveSelectionLoop(); // render depends on this.maskOptions and this.value,
	        // call forceUpdate to keep it in sync

	        this.forceUpdate();
	      }

	      return;
	    } else if (!previousMaskOptions.mask && this.isFocused()) {
	      this.runSaveSelectionLoop();
	    }

	    var isMaskChanged = this.maskOptions.mask && this.maskOptions.mask !== previousMaskOptions.mask;

	    if (!previousMaskOptions.mask && !hasValue) {
	      newValue = this.getInputValue();
	    }

	    if (isMaskChanged || this.maskOptions.mask && (newValue || showEmpty)) {
	      newValue = formatValue(this.maskOptions, newValue);
	    }

	    if (isMaskChanged) {
	      var filledLength = getFilledLength(this.maskOptions, newValue);

	      if (cursorPosition === null || filledLength < cursorPosition) {
	        if (isFilled(this.maskOptions, newValue)) {
	          cursorPosition = filledLength;
	        } else {
	          cursorPosition = getRightEditablePosition(this.maskOptions, filledLength);
	        }
	      }
	    }

	    if (this.maskOptions.mask && isEmpty(this.maskOptions, newValue) && !showEmpty && (!hasValue || !this.props.value)) {
	      newValue = '';
	    }

	    var newSelection = {
	      start: cursorPosition,
	      end: cursorPosition
	    };

	    if (isFunction(beforeMaskedValueChange)) {
	      var modifiedValue = beforeMaskedValueChange({
	        value: newValue,
	        selection: newSelection
	      }, {
	        value: this.value,
	        selection: this.previousSelection
	      }, null, this.getBeforeMaskedValueChangeConfig());
	      newValue = modifiedValue.value;
	      newSelection = modifiedValue.selection;
	    }

	    this.value = newValue;
	    var isValueChanged = this.getInputValue() !== this.value; // render depends on this.maskOptions and this.value,
	    // call forceUpdate to keep it in sync

	    if (isValueChanged) {
	      this.setInputValue(this.value);
	      this.forceUpdate();
	    } else if (isMaskChanged) {
	      this.forceUpdate();
	    }

	    var isSelectionChanged = false;

	    if (newSelection.start != null && newSelection.end != null) {
	      isSelectionChanged = !previousSelection || previousSelection.start !== newSelection.start || previousSelection.end !== newSelection.end;
	    }

	    if (isSelectionChanged || isValueChanged) {
	      this.setSelection(newSelection.start, newSelection.end);
	    }
	  };

	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.mounted = false;

	    if (this.selectionDeferId !== null) {
	      cancelDefer(this.selectionDeferId);
	    }

	    this.stopSaveSelectionLoop();
	  };

	  _proto.render = function render() {
	    var _this$props2 = this.props,
	        mask = _this$props2.mask;
	        _this$props2.alwaysShowMask;
	        var maskChar = _this$props2.maskChar,
	        formatChars = _this$props2.formatChars,
	        inputRef = _this$props2.inputRef;
	        _this$props2.beforeMaskedValueChange;
	        var children = _this$props2.children,
	        restProps = _objectWithoutPropertiesLoose(_this$props2, ["mask", "alwaysShowMask", "maskChar", "formatChars", "inputRef", "beforeMaskedValueChange", "children"]);

	    var inputElement;
	    process.env.NODE_ENV !== "production" ? warning( // parse mask to test against actual mask prop as this.maskOptions
	    // will be updated later in componentDidUpdate
	    !restProps.maxLength || !parseMask(mask, maskChar, formatChars).mask, 'react-input-mask: maxLength property shouldn\'t be passed to the masked input. It breaks masking and unnecessary because length is limited by the mask length.') : void 0;

	    if (children) {
	      !isFunction(children) ? process.env.NODE_ENV !== "production" ? invariant(false, 'react-input-mask: children must be a function') : invariant(false) : void 0;
	      var controlledProps = ['onChange', 'onPaste', 'onMouseDown', 'onFocus', 'onBlur', 'value', 'disabled', 'readOnly'];

	      var childrenProps = _extends({}, restProps);

	      controlledProps.forEach(function (propId) {
	        return delete childrenProps[propId];
	      });
	      inputElement = children(childrenProps);
	      var conflictProps = controlledProps.filter(function (propId) {
	        return inputElement.props[propId] != null && inputElement.props[propId] !== restProps[propId];
	      });
	      !!conflictProps.length ? process.env.NODE_ENV !== "production" ? invariant(false, "react-input-mask: the following props should be passed to the react-input-mask's component and should not be altered in children's function: " + conflictProps.join(', ')) : invariant(false) : void 0;
	      process.env.NODE_ENV !== "production" ? warning(!inputRef, 'react-input-mask: inputRef is ignored when children is passed, attach ref to the children instead') : void 0;
	    } else {
	      inputElement = React.createElement("input", _extends({
	        ref: this.handleRef
	      }, restProps));
	    }

	    var changedProps = {
	      onFocus: this.onFocus,
	      onBlur: this.onBlur
	    };

	    if (this.maskOptions.mask) {
	      if (!restProps.disabled && !restProps.readOnly) {
	        changedProps.onChange = this.onChange;
	        changedProps.onPaste = this.onPaste;
	        changedProps.onMouseDown = this.onMouseDown;
	      }

	      if (restProps.value != null) {
	        changedProps.value = this.value;
	      }
	    }

	    inputElement = React.cloneElement(inputElement, changedProps);
	    return inputElement;
	  };

	  return InputElement;
	}(React.Component);

	reactInputMask_development = InputElement;
	return reactInputMask_development;
}

(function (module) {
	if (process.env.NODE_ENV === 'production') {
	  module.exports = requireReactInputMask_production_min();
	} else {
	  module.exports = requireReactInputMask_development();
	}
} (reactInputMask));

var ReactInputMask = /*@__PURE__*/getDefaultExportFromCjs(reactInputMaskExports);

var Container$2 = styled.div(templateObject_1$q || (templateObject_1$q = __makeTemplateObject(["\n  ", "\n  ", "\n  display: flex;\n  border-width: 1px;\n  background-color: ", ";\n\n  padding: 0px;\n  margin: 0;\n  width: 100%;\n  align-items: center;\n  overflow: hidden;\n\n  &:focus-within,\n  &:focus {\n    border-color: ", ";\n    box-shadow: 0px 0px 2px 2px var(--focus);\n  }\n\n  ", "\n\n  input {\n    ", "\n    border-width: 0px;\n    box-shadow: none !important;\n    ", "\n  }\n\n  .react-datepicker__input-container {\n    height: 100%;\n\n    > div {\n      height: 100%;\n    }\n  }\n"], ["\n  ", "\n  ", "\n  display: flex;\n  border-width: 1px;\n  background-color: ", ";\n\n  padding: 0px;\n  margin: 0;\n  width: 100%;\n  align-items: center;\n  overflow: hidden;\n\n  &:focus-within,\n  &:focus {\n    border-color: ", ";\n    box-shadow: 0px 0px 2px 2px var(--focus);\n  }\n\n  ", "\n\n  input {\n    ", "\n    border-width: 0px;\n    box-shadow: none !important;\n    ", "\n  }\n\n  .react-datepicker__input-container {\n    height: 100%;\n\n    > div {\n      height: 100%;\n    }\n  }\n"])), inputStyles, function (_a) {
    var borderWidth = _a.borderWidth;
    return "".concat(getInputBorder({ borderWidth: borderWidth, borderRadius: 'var(--inputBorderRadius)' }));
}, colorFormSurface.colorFormSurfaceDefault, colorFormBorder.colorFormBorderActive, function (_a) {
    var disabled = _a.disabled;
    return "background-color: ".concat(disabled ? colorFormSurface.colorFormSurfaceDisabled : colorFormSurface.colorFormSurfaceDefault, ";");
}, inputStyles, function (_a) {
    var disabled = _a.disabled;
    return "background-color: ".concat(disabled ? colorFormSurface.colorFormSurfaceDisabled : colorFormSurface.colorFormSurfaceDefault, ";");
});
var ChildrenContainer = styled.div(templateObject_2$a || (templateObject_2$a = __makeTemplateObject(["\n  flex: 1;\n  display: flex;\n"], ["\n  flex: 1;\n  display: flex;\n"])));
var templateObject_1$q, templateObject_2$a;

var InputMask = forwardRef(function (props, ref) {
    var prefix = props.prefix, borderWidth = props.borderWidth, disabled = props.disabled, size = props.size;
    return (jsxs(Container$2, __assign({ borderWidth: borderWidth, prefix: prefix, disabled: disabled, "$size": size, "data-form-error": true }, { children: [jsx(Prefix, { children: prefix }), jsx(ChildrenContainer, { children: jsx(ReactInputMask, __assign({}, props, { inputRef: ref })) })] })));
});
InputMask.displayName = 'InputMask';

var customParseFormatExports = {};
var customParseFormat$1 = {
  get exports(){ return customParseFormatExports; },
  set exports(v){ customParseFormatExports = v; },
};

(function (module, exports) {
	!function(e,t){module.exports=t();}(commonjsGlobal,(function(){var e={LTS:"h:mm:ss A",LT:"h:mm A",L:"MM/DD/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"},t=/(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g,n=/\d\d/,r=/\d\d?/,i=/\d*[^-_:/,()\s\d]+/,o={},s=function(e){return (e=+e)+(e>68?1900:2e3)};var a=function(e){return function(t){this[e]=+t;}},f=[/[+-]\d\d:?(\d\d)?|Z/,function(e){(this.zone||(this.zone={})).offset=function(e){if(!e)return 0;if("Z"===e)return 0;var t=e.match(/([+-]|\d\d)/g),n=60*t[1]+(+t[2]||0);return 0===n?0:"+"===t[0]?-n:n}(e);}],h=function(e){var t=o[e];return t&&(t.indexOf?t:t.s.concat(t.f))},u=function(e,t){var n,r=o.meridiem;if(r){for(var i=1;i<=24;i+=1)if(e.indexOf(r(i,0,t))>-1){n=i>12;break}}else n=e===(t?"pm":"PM");return n},d={A:[i,function(e){this.afternoon=u(e,!1);}],a:[i,function(e){this.afternoon=u(e,!0);}],S:[/\d/,function(e){this.milliseconds=100*+e;}],SS:[n,function(e){this.milliseconds=10*+e;}],SSS:[/\d{3}/,function(e){this.milliseconds=+e;}],s:[r,a("seconds")],ss:[r,a("seconds")],m:[r,a("minutes")],mm:[r,a("minutes")],H:[r,a("hours")],h:[r,a("hours")],HH:[r,a("hours")],hh:[r,a("hours")],D:[r,a("day")],DD:[n,a("day")],Do:[i,function(e){var t=o.ordinal,n=e.match(/\d+/);if(this.day=n[0],t)for(var r=1;r<=31;r+=1)t(r).replace(/\[|\]/g,"")===e&&(this.day=r);}],M:[r,a("month")],MM:[n,a("month")],MMM:[i,function(e){var t=h("months"),n=(h("monthsShort")||t.map((function(e){return e.slice(0,3)}))).indexOf(e)+1;if(n<1)throw new Error;this.month=n%12||n;}],MMMM:[i,function(e){var t=h("months").indexOf(e)+1;if(t<1)throw new Error;this.month=t%12||t;}],Y:[/[+-]?\d+/,a("year")],YY:[n,function(e){this.year=s(e);}],YYYY:[/\d{4}/,a("year")],Z:f,ZZ:f};function c(n){var r,i;r=n,i=o&&o.formats;for(var s=(n=r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g,(function(t,n,r){var o=r&&r.toUpperCase();return n||i[r]||e[r]||i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g,(function(e,t,n){return t||n.slice(1)}))}))).match(t),a=s.length,f=0;f<a;f+=1){var h=s[f],u=d[h],c=u&&u[0],l=u&&u[1];s[f]=l?{regex:c,parser:l}:h.replace(/^\[|\]$/g,"");}return function(e){for(var t={},n=0,r=0;n<a;n+=1){var i=s[n];if("string"==typeof i)r+=i.length;else {var o=i.regex,f=i.parser,h=e.slice(r),u=o.exec(h)[0];f.call(t,u),e=e.replace(u,"");}}return function(e){var t=e.afternoon;if(void 0!==t){var n=e.hours;t?n<12&&(e.hours+=12):12===n&&(e.hours=0),delete e.afternoon;}}(t),t}}return function(e,t,n){n.p.customParseFormat=!0,e&&e.parseTwoDigitYear&&(s=e.parseTwoDigitYear);var r=t.prototype,i=r.parse;r.parse=function(e){var t=e.date,r=e.utc,s=e.args;this.$u=r;var a=s[1];if("string"==typeof a){var f=!0===s[2],h=!0===s[3],u=f||h,d=s[2];h&&(d=s[2]),o=this.$locale(),!f&&d&&(o=n.Ls[d]),this.$d=function(e,t,n){try{if(["x","X"].indexOf(t)>-1)return new Date(("X"===t?1e3:1)*e);var r=c(t)(e),i=r.year,o=r.month,s=r.day,a=r.hours,f=r.minutes,h=r.seconds,u=r.milliseconds,d=r.zone,l=new Date,m=s||(i||o?1:l.getDate()),M=i||l.getFullYear(),Y=0;i&&!o||(Y=o>0?o-1:l.getMonth());var p=a||0,v=f||0,D=h||0,g=u||0;return d?new Date(Date.UTC(M,Y,m,p,v,D,g+60*d.offset*1e3)):n?new Date(Date.UTC(M,Y,m,p,v,D,g)):new Date(M,Y,m,p,v,D,g)}catch(e){return new Date("")}}(t,a,r),this.init(),d&&!0!==d&&(this.$L=this.locale(d).$L),u&&t!=this.format(a)&&(this.$d=new Date("")),o={};}else if(a instanceof Array)for(var l=a.length,m=1;m<=l;m+=1){s[1]=a[m-1];var M=n.apply(this,s);if(M.isValid()){this.$d=M.$d,this.$L=M.$L,this.init();break}m===l&&(this.$d=new Date(""));}else i.call(this,e);};}}));
} (customParseFormat$1));

var customParseFormat = customParseFormatExports;

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */
function isDate(value) {
  requiredArgs(1, arguments);
  return value instanceof Date || _typeof(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate$1(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument);

  // Clone the date
  if (argument instanceof Date || _typeof(argument) === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      // eslint-disable-next-line no-console
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */
function isValid(dirtyDate) {
  requiredArgs(1, arguments);
  if (!isDate(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }
  var date = toDate$1(dirtyDate);
  return !isNaN(Number(date));
}

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate$1(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}

var MILLISECONDS_IN_DAY$1 = 86400000;
function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY$1) + 1;
}

function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate$1(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK$2 = 604800000;
function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK$2) + 1;
}

var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}

function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = toDate$1(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, options);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getUTCWeekYear(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, options);
  return date;
}

var MILLISECONDS_IN_WEEK$1 = 604800000;
function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return sign + output;
}

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */
var formatters$2 = {
  // Year
  y: function y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    var signedYear = date.getUTCFullYear();
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function M(date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function d(date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function a(date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();
      case 'aaa':
        return dayPeriodEnumValue;
      case 'aaaaa':
        return dayPeriodEnumValue[0];
      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function h(date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function H(date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function m(date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function s(date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function S(date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
var lightFormatters = formatters$2;

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters = {
  // Era
  G: function G(date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B
      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ
      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function y(date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear();
      // Returns 1 for 1 BC (which is year 0 in JavaScript)
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }
    return lightFormatters.y(date, token);
  },
  // Local week-numbering year
  Y: function Y(date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options);
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

    // Two digit year
    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }

    // Ordinal number
    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    }

    // Padding
    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function R(date, token) {
    var isoWeekYear = getUTCISOWeekYear(date);

    // Padding
    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u(date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function Q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...
      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...
      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function M(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      case 'M':
      case 'MM':
        return lightFormatters.M(date, token);
      // 1st, 2nd, ..., 12th
      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D
      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December
      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function L(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12
      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th
      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D
      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December
      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function w(date, token, localize, options) {
    var week = getUTCWeek(date, options);
    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }
    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function I(date, token, localize) {
    var isoWeek = getUTCISOWeek(date);
    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }
    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function d(date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }
    return lightFormatters.d(date, token);
  },
  // Day of year
  D: function D(date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);
    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }
    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function E(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function e(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function c(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th
      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T
      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu
      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday
      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function i(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02
      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd
      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue
      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function a(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }
    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function h(date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return lightFormatters.h(date, token);
  },
  // Hour [0-23]
  H: function H(date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }
    return lightFormatters.H(date, token);
  },
  // Hour [0-11]
  K: function K(date, token, localize) {
    var hours = date.getUTCHours() % 12;
    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function k(date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;
    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function m(date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }
    return lightFormatters.m(date, token);
  },
  // Second
  s: function s(date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }
    return lightFormatters.s(date, token);
  },
  // Fraction of second
  S: function S(date, token) {
    return lightFormatters.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return 'Z';
    }
    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function O(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function z(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function t(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function T(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}
var formatters$1 = formatters;

var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });
    case 'PP':
      return formatLong.date({
        width: 'medium'
      });
    case 'PPP':
      return formatLong.date({
        width: 'long'
      });
    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });
    case 'pp':
      return formatLong.time({
        width: 'medium'
      });
    case 'ppp':
      return formatLong.time({
        width: 'long'
      });
    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
};
var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;
    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;
    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;
    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }
  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
var longFormatters$1 = longFormatters;

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }
  return result;
};
var formatDistance$1 = formatDistance;

function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
var formatLong$1 = formatLong;

var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};
var formatRelative$1 = formatRelative;

function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;
    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
    return valuesArray[index];
  };
}

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';
      case 2:
        return number + 'nd';
      case 3:
        return number + 'rd';
    }
  }
  return number + 'th';
};
var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
var localize$1 = localize;

function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return undefined;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}

function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
var match$1 = match;

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale = {
  code: 'en-US',
  formatDistance: formatDistance$1,
  formatLong: formatLong$1,
  formatRelative: formatRelative$1,
  localize: localize$1,
  match: match$1,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1
  }
};
var defaultLocale = locale;

// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp$1 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp$1 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp$1 = /^'([^]*?)'?$/;
var doubleQuoteRegExp$1 = /''/g;
var unescapedLatinCharacterRegExp$1 = /[a-zA-Z]/;

/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions = getDefaultOptions();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale;
  var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }
  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }
  var originalDate = toDate$1(dirtyDate);
  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp$1).map(function (substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters$1[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join('').match(formattingTokensRegExp$1).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString$1(substring);
    }
    var formatter = formatters$1[firstCharacter];
    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp$1)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }
    return substring;
  }).join('');
  return result;
}
function cleanEscapedString$1(input) {
  var matched = input.match(escapedStringRegExp$1);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp$1, "'");
}

var MILLISECONDS_IN_MINUTE = 60000;

/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the minutes added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */
function addMinutes(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_MINUTE);
}

var MILLISECONDS_IN_HOUR = 3600000;

/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the hours added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */
function addHours(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_HOUR);
}

/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} - the new date with the days added
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate$1(dirtyDate);
  var amount = toInteger(dirtyAmount);
  if (isNaN(amount)) {
    return new Date(NaN);
  }
  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
  }
  date.setDate(date.getDate() + amount);
  return date;
}

/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the weeks added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */
function addWeeks(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  var days = amount * 7;
  return addDays(dirtyDate, days);
}

/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */
function addMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate$1(dirtyDate);
  var amount = toInteger(dirtyAmount);
  if (isNaN(amount)) {
    return new Date(NaN);
  }
  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
  }
  var dayOfMonth = date.getDate();

  // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.
  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();
  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}

/**
 * @name addQuarters
 * @category Quarter Helpers
 * @summary Add the specified number of year quarters to the given date.
 *
 * @description
 * Add the specified number of year quarters to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of quarters to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the quarters added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 1 quarter to 1 September 2014:
 * const result = addQuarters(new Date(2014, 8, 1), 1)
 * //=> Mon Dec 01 2014 00:00:00
 */
function addQuarters(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  var months = amount * 3;
  return addMonths(dirtyDate, months);
}

/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */
function addYears(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMonths(dirtyDate, amount * 12);
}

/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the days subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */
function subDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addDays(dirtyDate, -amount);
}

/**
 * @name subWeeks
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the weeks subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * const result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */
function subWeeks(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addWeeks(dirtyDate, -amount);
}

/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * const result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */
function subMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMonths(dirtyDate, -amount);
}

/**
 * @name subQuarters
 * @category Quarter Helpers
 * @summary Subtract the specified number of year quarters from the given date.
 *
 * @description
 * Subtract the specified number of year quarters from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of quarters to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the quarters subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 3 quarters from 1 September 2014:
 * const result = subQuarters(new Date(2014, 8, 1), 3)
 * //=> Sun Dec 01 2013 00:00:00
 */
function subQuarters(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addQuarters(dirtyDate, -amount);
}

/**
 * @name subYears
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * const result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */
function subYears(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addYears(dirtyDate, -amount);
}

/**
 * @name getSeconds
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the seconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */
function getSeconds(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  var seconds = date.getSeconds();
  return seconds;
}

/**
 * @name getMinutes
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the minutes
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */
function getMinutes(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  var minutes = date.getMinutes();
  return minutes;
}

/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the hours
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * const result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */
function getHours(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  var hours = date.getHours();
  return hours;
}

/**
 * @name getDay
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {0|1|2|3|4|5|6} the day of week, 0 represents Sunday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * const result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */
function getDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  var day = date.getDay();
  return day;
}

/**
 * @name getDate
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the day of month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * const result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */
function getDate(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  var dayOfMonth = date.getDate();
  return dayOfMonth;
}

/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = toDate$1(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  return startOfWeek(dirtyDate, {
    weekStartsOn: 1
  });
}

/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the ISO week-numbering year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */
function getISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  var year = date.getFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  var startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  var startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an ISO week-numbering year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  var date = startOfISOWeek(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK = 604800000;

/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */
function getISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  var diff = startOfISOWeek(date).getTime() - startOfISOWeekYear(date).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

/**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which month is 29 February 2012?
 * const result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */
function getMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  var month = date.getMonth();
  return month;
}

/**
 * @name getQuarter
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the quarter
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which quarter is 2 July 2014?
 * const result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */
function getQuarter(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  var quarter = Math.floor(date.getMonth() / 3) + 1;
  return quarter;
}

/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which year is 2 July 2014?
 * const result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */
function getYear(dirtyDate) {
  requiredArgs(1, arguments);
  return toDate$1(dirtyDate).getFullYear();
}

/**
 * @name getTime
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the timestamp
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */
function getTime(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  var timestamp = date.getTime();
  return timestamp;
}

/**
 * @name setSeconds
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} seconds - the seconds of the new date
 * @returns {Date} the new date with the seconds set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */
function setSeconds(dirtyDate, dirtySeconds) {
  requiredArgs(2, arguments);
  var date = toDate$1(dirtyDate);
  var seconds = toInteger(dirtySeconds);
  date.setSeconds(seconds);
  return date;
}

/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} minutes - the minutes of the new date
 * @returns {Date} the new date with the minutes set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */
function setMinutes(dirtyDate, dirtyMinutes) {
  requiredArgs(2, arguments);
  var date = toDate$1(dirtyDate);
  var minutes = toInteger(dirtyMinutes);
  date.setMinutes(minutes);
  return date;
}

/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} hours - the hours of the new date
 * @returns {Date} the new date with the hours set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * const result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */
function setHours(dirtyDate, dirtyHours) {
  requiredArgs(2, arguments);
  var date = toDate$1(dirtyDate);
  var hours = toInteger(dirtyHours);
  date.setHours(hours);
  return date;
}

/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the number of days in a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */
function getDaysInMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  var year = date.getFullYear();
  var monthIndex = date.getMonth();
  var lastDayOfMonth = new Date(0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}

/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} month - the month of the new date
 * @returns {Date} the new date with the month set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */
function setMonth(dirtyDate, dirtyMonth) {
  requiredArgs(2, arguments);
  var date = toDate$1(dirtyDate);
  var month = toInteger(dirtyMonth);
  var year = date.getFullYear();
  var day = date.getDate();
  var dateWithDesiredMonth = new Date(0);
  dateWithDesiredMonth.setFullYear(year, month, 15);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth);
  // Set the last day of the new month
  // if the original date was the last day of the longer month
  date.setMonth(month, Math.min(day, daysInMonth));
  return date;
}

/**
 * @name setQuarter
 * @category Quarter Helpers
 * @summary Set the year quarter to the given date.
 *
 * @description
 * Set the year quarter to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} quarter - the quarter of the new date
 * @returns {Date} the new date with the quarter set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set the 2nd quarter to 2 July 2014:
 * const result = setQuarter(new Date(2014, 6, 2), 2)
 * //=> Wed Apr 02 2014 00:00:00
 */
function setQuarter(dirtyDate, dirtyQuarter) {
  requiredArgs(2, arguments);
  var date = toDate$1(dirtyDate);
  var quarter = toInteger(dirtyQuarter);
  var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
  var diff = quarter - oldQuarter;
  return setMonth(date, date.getMonth() + diff * 3);
}

/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} year - the year of the new date
 * @returns {Date} the new date with the year set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */
function setYear(dirtyDate, dirtyYear) {
  requiredArgs(2, arguments);
  var date = toDate$1(dirtyDate);
  var year = toInteger(dirtyYear);

  // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
  if (isNaN(date.getTime())) {
    return new Date(NaN);
  }
  date.setFullYear(year);
  return date;
}

/**
 * @name min
 * @category Common Helpers
 * @summary Returns the earliest of the given dates.
 *
 * @description
 * Returns the earliest of the given dates.
 *
 * @param {Date[]|Number[]} datesArray - the dates to compare
 * @returns {Date} - the earliest of the dates
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which of these dates is the earliest?
 * const result = min([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Wed Feb 11 1987 00:00:00
 */
function min$1(dirtyDatesArray) {
  requiredArgs(1, arguments);
  var datesArray;
  // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
    datesArray = dirtyDatesArray;
    // If `dirtyDatesArray` is Array-like Object, convert to Array.
  } else if (_typeof(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  } else {
    // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
  }
  var result;
  datesArray.forEach(function (dirtyDate) {
    var currentDate = toDate$1(dirtyDate);
    if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) {
      result = currentDate;
    }
  });
  return result || new Date(NaN);
}

/**
 * @name max
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @param {Date[]|Number[]} datesArray - the dates to compare
 * @returns {Date} the latest of the dates
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which of these dates is the latest?
 * const result = max([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Sun Jul 02 1995 00:00:00
 */
function max$1(dirtyDatesArray) {
  requiredArgs(1, arguments);
  var datesArray;
  // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
    datesArray = dirtyDatesArray;

    // If `dirtyDatesArray` is Array-like Object, convert to Array.
  } else if (_typeof(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  } else {
    // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
  }
  var result;
  datesArray.forEach(function (dirtyDate) {
    var currentDate = toDate$1(dirtyDate);
    if (result === undefined || result < currentDate || isNaN(Number(currentDate))) {
      result = currentDate;
    }
  });
  return result || new Date(NaN);
}

/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

var MILLISECONDS_IN_DAY = 86400000;

/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var startOfDayLeft = startOfDay(dirtyDateLeft);
  var startOfDayRight = startOfDay(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - getTimezoneOffsetInMilliseconds(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - getTimezoneOffsetInMilliseconds(startOfDayRight);

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}

/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar months
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */
function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate$1(dirtyDateLeft);
  var dateRight = toDate$1(dirtyDateRight);
  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
  return yearDiff * 12 + monthDiff;
}

/**
 * @name differenceInCalendarYears
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar years
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */
function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate$1(dirtyDateLeft);
  var dateRight = toDate$1(dirtyDateRight);
  return dateLeft.getFullYear() - dateRight.getFullYear();
}

/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name startOfQuarter
 * @category Quarter Helpers
 * @summary Return the start of a year quarter for the given date.
 *
 * @description
 * Return the start of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a quarter
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * const result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Jul 01 2014 00:00:00
 */
function startOfQuarter(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  var currentMonth = date.getMonth();
  var month = currentMonth - currentMonth % 3;
  date.setMonth(month, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */
function startOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var cleanDate = toDate$1(dirtyDate);
  var date = new Date(0);
  date.setFullYear(cleanDate.getFullYear(), 0, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */
function endOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  date.setHours(23, 59, 59, 999);
  return date;
}

/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}

/**
 * @name endOfYear
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * const result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */
function endOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  var year = date.getFullYear();
  date.setFullYear(year + 1, 0, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}

/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Boolean} the dates are equal
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * const result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */
function isEqual$1(dirtyLeftDate, dirtyRightDate) {
  requiredArgs(2, arguments);
  var dateLeft = toDate$1(dirtyLeftDate);
  var dateRight = toDate$1(dirtyRightDate);
  return dateLeft.getTime() === dateRight.getTime();
}

/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day (and year and month)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */
function isSameDay(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft);
  var dateRightStartOfDay = startOfDay(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same month (and year)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */
function isSameMonth(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate$1(dirtyDateLeft);
  var dateRight = toDate$1(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same year
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * const result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */
function isSameYear(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate$1(dirtyDateLeft);
  var dateRight = toDate$1(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear();
}

/**
 * @name isSameQuarter
 * @category Quarter Helpers
 * @summary Are the given dates in the same quarter (and year)?
 *
 * @description
 * Are the given dates in the same quarter (and year)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same quarter (and year)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
 * //=> true
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */
function isSameQuarter(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfQuarter = startOfQuarter(dirtyDateLeft);
  var dateRightStartOfQuarter = startOfQuarter(dirtyDateRight);
  return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
}

/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @param {Date|Number} date - the date that should be after the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */
function isAfter(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date = toDate$1(dirtyDate);
  var dateToCompare = toDate$1(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}

/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @param {Date|Number} date - the date that should be before the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */
function isBefore(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date = toDate$1(dirtyDate);
  var dateToCompare = toDate$1(dirtyDateToCompare);
  return date.getTime() < dateToCompare.getTime();
}

/**
 * @name isWithinInterval
 * @category Interval Helpers
 * @summary Is the given date within the interval?
 *
 * @description
 * Is the given date within the interval? (Including start and end.)
 *
 * @param {Date|Number} date - the date to check
 * @param {Interval} interval - the interval to check
 * @returns {Boolean} the date is within the interval
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // For the date within the interval:
 * isWithinInterval(new Date(2014, 0, 3), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> true
 *
 * @example
 * // For the date outside of the interval:
 * isWithinInterval(new Date(2014, 0, 10), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> false
 *
 * @example
 * // For date equal to interval start:
 * isWithinInterval(date, { start, end: date }) // => true
 *
 * @example
 * // For date equal to interval end:
 * isWithinInterval(date, { start: date, end }) // => true
 */
function isWithinInterval(dirtyDate, interval) {
  requiredArgs(2, arguments);
  var time = toDate$1(dirtyDate).getTime();
  var startTime = toDate$1(interval.start).getTime();
  var endTime = toDate$1(interval.end).getTime();

  // Throw an exception if start date is after end date or if any date is `Invalid Date`
  if (!(startTime <= endTime)) {
    throw new RangeError('Invalid interval');
  }
  return time >= startTime && time <= endTime;
}

function _arrayLikeToArray$2(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

function _unsupportedIterableToArray$2(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$2(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen);
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$2(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function assign(target, object) {
  if (target == null) {
    throw new TypeError('assign requires that input parameter not be null or undefined');
  }
  for (var property in object) {
    if (Object.prototype.hasOwnProperty.call(object, property)) {
      target[property] = object[property];
    }
  }
  return target;
}

function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _setPrototypeOf$1(o, p) {
  _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf$1(o, p);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf$1(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$1(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty$2(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var TIMEZONE_UNIT_PRIORITY = 10;
var Setter = /*#__PURE__*/function () {
  function Setter() {
    _classCallCheck(this, Setter);
    _defineProperty$2(this, "priority", void 0);
    _defineProperty$2(this, "subPriority", 0);
  }
  _createClass(Setter, [{
    key: "validate",
    value: function validate(_utcDate, _options) {
      return true;
    }
  }]);
  return Setter;
}();
var ValueSetter = /*#__PURE__*/function (_Setter) {
  _inherits(ValueSetter, _Setter);
  var _super = _createSuper(ValueSetter);
  function ValueSetter(value, validateValue, setValue, priority, subPriority) {
    var _this;
    _classCallCheck(this, ValueSetter);
    _this = _super.call(this);
    _this.value = value;
    _this.validateValue = validateValue;
    _this.setValue = setValue;
    _this.priority = priority;
    if (subPriority) {
      _this.subPriority = subPriority;
    }
    return _this;
  }
  _createClass(ValueSetter, [{
    key: "validate",
    value: function validate(utcDate, options) {
      return this.validateValue(utcDate, this.value, options);
    }
  }, {
    key: "set",
    value: function set(utcDate, flags, options) {
      return this.setValue(utcDate, flags, this.value, options);
    }
  }]);
  return ValueSetter;
}(Setter);
var DateToSystemTimezoneSetter = /*#__PURE__*/function (_Setter2) {
  _inherits(DateToSystemTimezoneSetter, _Setter2);
  var _super2 = _createSuper(DateToSystemTimezoneSetter);
  function DateToSystemTimezoneSetter() {
    var _this2;
    _classCallCheck(this, DateToSystemTimezoneSetter);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _super2.call.apply(_super2, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$1(_this2), "priority", TIMEZONE_UNIT_PRIORITY);
    _defineProperty$2(_assertThisInitialized$1(_this2), "subPriority", -1);
    return _this2;
  }
  _createClass(DateToSystemTimezoneSetter, [{
    key: "set",
    value: function set(date, flags) {
      if (flags.timestampIsSet) {
        return date;
      }
      var convertedDate = new Date(0);
      convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
      convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
      return convertedDate;
    }
  }]);
  return DateToSystemTimezoneSetter;
}(Setter);

var Parser = /*#__PURE__*/function () {
  function Parser() {
    _classCallCheck(this, Parser);
    _defineProperty$2(this, "incompatibleTokens", void 0);
    _defineProperty$2(this, "priority", void 0);
    _defineProperty$2(this, "subPriority", void 0);
  }
  _createClass(Parser, [{
    key: "run",
    value: function run(dateString, token, match, options) {
      var result = this.parse(dateString, token, match, options);
      if (!result) {
        return null;
      }
      return {
        setter: new ValueSetter(result.value, this.validate, this.set, this.priority, this.subPriority),
        rest: result.rest
      };
    }
  }, {
    key: "validate",
    value: function validate(_utcDate, _value, _options) {
      return true;
    }
  }]);
  return Parser;
}();

var EraParser = /*#__PURE__*/function (_Parser) {
  _inherits(EraParser, _Parser);
  var _super = _createSuper(EraParser);
  function EraParser() {
    var _this;
    _classCallCheck(this, EraParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$1(_this), "priority", 140);
    _defineProperty$2(_assertThisInitialized$1(_this), "incompatibleTokens", ['R', 'u', 't', 'T']);
    return _this;
  }
  _createClass(EraParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // AD, BC
        case 'G':
        case 'GG':
        case 'GGG':
          return match.era(dateString, {
            width: 'abbreviated'
          }) || match.era(dateString, {
            width: 'narrow'
          });
        // A, B
        case 'GGGGG':
          return match.era(dateString, {
            width: 'narrow'
          });
        // Anno Domini, Before Christ
        case 'GGGG':
        default:
          return match.era(dateString, {
            width: 'wide'
          }) || match.era(dateString, {
            width: 'abbreviated'
          }) || match.era(dateString, {
            width: 'narrow'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      flags.era = value;
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return EraParser;
}(Parser);

/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */

/**
 * Milliseconds in 1 minute
 *
 * @name millisecondsInMinute
 * @constant
 * @type {number}
 * @default
 */
var millisecondsInMinute = 60000;

/**
 * Milliseconds in 1 hour
 *
 * @name millisecondsInHour
 * @constant
 * @type {number}
 * @default
 */
var millisecondsInHour = 3600000;

/**
 * Milliseconds in 1 second
 *
 * @name millisecondsInSecond
 * @constant
 * @type {number}
 * @default
 */
var millisecondsInSecond = 1000;

var numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59

  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999

  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};

var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

function mapValue(parseFnResult, mapFn) {
  if (!parseFnResult) {
    return parseFnResult;
  }
  return {
    value: mapFn(parseFnResult.value),
    rest: parseFnResult.rest
  };
}
function parseNumericPattern(pattern, dateString) {
  var matchResult = dateString.match(pattern);
  if (!matchResult) {
    return null;
  }
  return {
    value: parseInt(matchResult[0], 10),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseTimezonePattern(pattern, dateString) {
  var matchResult = dateString.match(pattern);
  if (!matchResult) {
    return null;
  }

  // Input is 'Z'
  if (matchResult[0] === 'Z') {
    return {
      value: 0,
      rest: dateString.slice(1)
    };
  }
  var sign = matchResult[1] === '+' ? 1 : -1;
  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign * (hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * millisecondsInSecond),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseAnyDigitsSigned(dateString) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, dateString);
}
function parseNDigits(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, dateString);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, dateString);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, dateString);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, dateString);
    default:
      return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), dateString);
  }
}
function parseNDigitsSigned(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, dateString);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, dateString);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, dateString);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, dateString);
    default:
      return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), dateString);
  }
}
function dayPeriodEnumToHours(dayPeriod) {
  switch (dayPeriod) {
    case 'morning':
      return 4;
    case 'evening':
      return 17;
    case 'pm':
    case 'noon':
    case 'afternoon':
      return 12;
    case 'am':
    case 'midnight':
    case 'night':
    default:
      return 0;
  }
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  var isCommonEra = currentYear > 0;
  // Absolute number of the current year:
  // 1 -> 1 AC
  // 0 -> 1 BC
  // -1 -> 2 BC
  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  var result;
  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    var rangeEnd = absCurrentYear + 50;
    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }
  return isCommonEra ? result : 1 - result;
}
function isLeapYearIndex$1(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

// From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
// | Year     |     y | yy |   yyy |  yyyy | yyyyy |
// |----------|-------|----|-------|-------|-------|
// | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
// | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
// | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
// | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
// | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
var YearParser = /*#__PURE__*/function (_Parser) {
  _inherits(YearParser, _Parser);
  var _super = _createSuper(YearParser);
  function YearParser() {
    var _this;
    _classCallCheck(this, YearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$1(_this), "priority", 130);
    _defineProperty$2(_assertThisInitialized$1(_this), "incompatibleTokens", ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(YearParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(year) {
        return {
          year: year,
          isTwoDigitYear: token === 'yy'
        };
      };
      switch (token) {
        case 'y':
          return mapValue(parseNDigits(4, dateString), valueCallback);
        case 'yo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'year'
          }), valueCallback);
        default:
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value.isTwoDigitYear || value.year > 0;
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      var currentYear = date.getUTCFullYear();
      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }
      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return YearParser;
}(Parser);

// Local week-numbering year
var LocalWeekYearParser = /*#__PURE__*/function (_Parser) {
  _inherits(LocalWeekYearParser, _Parser);
  var _super = _createSuper(LocalWeekYearParser);
  function LocalWeekYearParser() {
    var _this;
    _classCallCheck(this, LocalWeekYearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$1(_this), "priority", 130);
    _defineProperty$2(_assertThisInitialized$1(_this), "incompatibleTokens", ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']);
    return _this;
  }
  _createClass(LocalWeekYearParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(year) {
        return {
          year: year,
          isTwoDigitYear: token === 'YY'
        };
      };
      switch (token) {
        case 'Y':
          return mapValue(parseNDigits(4, dateString), valueCallback);
        case 'Yo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'year'
          }), valueCallback);
        default:
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value.isTwoDigitYear || value.year > 0;
    }
  }, {
    key: "set",
    value: function set(date, flags, value, options) {
      var currentYear = getUTCWeekYear(date, options);
      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
        date.setUTCHours(0, 0, 0, 0);
        return startOfUTCWeek(date, options);
      }
      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
      date.setUTCHours(0, 0, 0, 0);
      return startOfUTCWeek(date, options);
    }
  }]);
  return LocalWeekYearParser;
}(Parser);

var ISOWeekYearParser = /*#__PURE__*/function (_Parser) {
  _inherits(ISOWeekYearParser, _Parser);
  var _super = _createSuper(ISOWeekYearParser);
  function ISOWeekYearParser() {
    var _this;
    _classCallCheck(this, ISOWeekYearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$1(_this), "priority", 130);
    _defineProperty$2(_assertThisInitialized$1(_this), "incompatibleTokens", ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(ISOWeekYearParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      if (token === 'R') {
        return parseNDigitsSigned(4, dateString);
      }
      return parseNDigitsSigned(token.length, dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      var firstWeekOfYear = new Date(0);
      firstWeekOfYear.setUTCFullYear(value, 0, 4);
      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
      return startOfUTCISOWeek(firstWeekOfYear);
    }
  }]);
  return ISOWeekYearParser;
}(Parser);

var ExtendedYearParser = /*#__PURE__*/function (_Parser) {
  _inherits(ExtendedYearParser, _Parser);
  var _super = _createSuper(ExtendedYearParser);
  function ExtendedYearParser() {
    var _this;
    _classCallCheck(this, ExtendedYearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$1(_this), "priority", 130);
    _defineProperty$2(_assertThisInitialized$1(_this), "incompatibleTokens", ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(ExtendedYearParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      if (token === 'u') {
        return parseNDigitsSigned(4, dateString);
      }
      return parseNDigitsSigned(token.length, dateString);
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return ExtendedYearParser;
}(Parser);

var QuarterParser = /*#__PURE__*/function (_Parser) {
  _inherits(QuarterParser, _Parser);
  var _super = _createSuper(QuarterParser);
  function QuarterParser() {
    var _this;
    _classCallCheck(this, QuarterParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$1(_this), "priority", 120);
    _defineProperty$2(_assertThisInitialized$1(_this), "incompatibleTokens", ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(QuarterParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // 1, 2, 3, 4
        case 'Q':
        case 'QQ':
          // 01, 02, 03, 04
          return parseNDigits(token.length, dateString);
        // 1st, 2nd, 3rd, 4th
        case 'Qo':
          return match.ordinalNumber(dateString, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4
        case 'QQQ':
          return match.quarter(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case 'QQQQQ':
          return match.quarter(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1st quarter, 2nd quarter, ...
        case 'QQQQ':
        default:
          return match.quarter(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.quarter(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 4;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return QuarterParser;
}(Parser);

var StandAloneQuarterParser = /*#__PURE__*/function (_Parser) {
  _inherits(StandAloneQuarterParser, _Parser);
  var _super = _createSuper(StandAloneQuarterParser);
  function StandAloneQuarterParser() {
    var _this;
    _classCallCheck(this, StandAloneQuarterParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$1(_this), "priority", 120);
    _defineProperty$2(_assertThisInitialized$1(_this), "incompatibleTokens", ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(StandAloneQuarterParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // 1, 2, 3, 4
        case 'q':
        case 'qq':
          // 01, 02, 03, 04
          return parseNDigits(token.length, dateString);
        // 1st, 2nd, 3rd, 4th
        case 'qo':
          return match.ordinalNumber(dateString, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4
        case 'qqq':
          return match.quarter(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case 'qqqqq':
          return match.quarter(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1st quarter, 2nd quarter, ...
        case 'qqqq':
        default:
          return match.quarter(dateString, {
            width: 'wide',
            context: 'standalone'
          }) || match.quarter(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 4;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return StandAloneQuarterParser;
}(Parser);

var MonthParser = /*#__PURE__*/function (_Parser) {
  _inherits(MonthParser, _Parser);
  var _super = _createSuper(MonthParser);
  function MonthParser() {
    var _this;
    _classCallCheck(this, MonthParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$1(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
    _defineProperty$2(_assertThisInitialized$1(_this), "priority", 110);
    return _this;
  }
  _createClass(MonthParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(value) {
        return value - 1;
      };
      switch (token) {
        // 1, 2, ..., 12
        case 'M':
          return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback);
        // 01, 02, ..., 12
        case 'MM':
          return mapValue(parseNDigits(2, dateString), valueCallback);
        // 1st, 2nd, ..., 12th
        case 'Mo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'month'
          }), valueCallback);
        // Jan, Feb, ..., Dec
        case 'MMM':
          return match.month(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // J, F, ..., D
        case 'MMMMM':
          return match.month(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // January, February, ..., December
        case 'MMMM':
        default:
          return match.month(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.month(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return MonthParser;
}(Parser);

var StandAloneMonthParser = /*#__PURE__*/function (_Parser) {
  _inherits(StandAloneMonthParser, _Parser);
  var _super = _createSuper(StandAloneMonthParser);
  function StandAloneMonthParser() {
    var _this;
    _classCallCheck(this, StandAloneMonthParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$1(_this), "priority", 110);
    _defineProperty$2(_assertThisInitialized$1(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(StandAloneMonthParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(value) {
        return value - 1;
      };
      switch (token) {
        // 1, 2, ..., 12
        case 'L':
          return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback);
        // 01, 02, ..., 12
        case 'LL':
          return mapValue(parseNDigits(2, dateString), valueCallback);
        // 1st, 2nd, ..., 12th
        case 'Lo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'month'
          }), valueCallback);
        // Jan, Feb, ..., Dec
        case 'LLL':
          return match.month(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // J, F, ..., D
        case 'LLLLL':
          return match.month(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // January, February, ..., December
        case 'LLLL':
        default:
          return match.month(dateString, {
            width: 'wide',
            context: 'standalone'
          }) || match.month(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return StandAloneMonthParser;
}(Parser);

function setUTCWeek(dirtyDate, dirtyWeek, options) {
  requiredArgs(2, arguments);
  var date = toDate$1(dirtyDate);
  var week = toInteger(dirtyWeek);
  var diff = getUTCWeek(date, options) - week;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}

var LocalWeekParser = /*#__PURE__*/function (_Parser) {
  _inherits(LocalWeekParser, _Parser);
  var _super = _createSuper(LocalWeekParser);
  function LocalWeekParser() {
    var _this;
    _classCallCheck(this, LocalWeekParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$1(_this), "priority", 100);
    _defineProperty$2(_assertThisInitialized$1(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']);
    return _this;
  }
  _createClass(LocalWeekParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'w':
          return parseNumericPattern(numericPatterns.week, dateString);
        case 'wo':
          return match.ordinalNumber(dateString, {
            unit: 'week'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 53;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      return startOfUTCWeek(setUTCWeek(date, value, options), options);
    }
  }]);
  return LocalWeekParser;
}(Parser);

function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
  requiredArgs(2, arguments);
  var date = toDate$1(dirtyDate);
  var isoWeek = toInteger(dirtyISOWeek);
  var diff = getUTCISOWeek(date) - isoWeek;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}

var ISOWeekParser = /*#__PURE__*/function (_Parser) {
  _inherits(ISOWeekParser, _Parser);
  var _super = _createSuper(ISOWeekParser);
  function ISOWeekParser() {
    var _this;
    _classCallCheck(this, ISOWeekParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$1(_this), "priority", 100);
    _defineProperty$2(_assertThisInitialized$1(_this), "incompatibleTokens", ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(ISOWeekParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'I':
          return parseNumericPattern(numericPatterns.week, dateString);
        case 'Io':
          return match.ordinalNumber(dateString, {
            unit: 'week'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 53;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      return startOfUTCISOWeek(setUTCISOWeek(date, value));
    }
  }]);
  return ISOWeekParser;
}(Parser);

var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

// Day of the month
var DateParser = /*#__PURE__*/function (_Parser) {
  _inherits(DateParser, _Parser);
  var _super = _createSuper(DateParser);
  function DateParser() {
    var _this;
    _classCallCheck(this, DateParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$1(_this), "priority", 90);
    _defineProperty$2(_assertThisInitialized$1(_this), "subPriority", 1);
    _defineProperty$2(_assertThisInitialized$1(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(DateParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'd':
          return parseNumericPattern(numericPatterns.date, dateString);
        case 'do':
          return match.ordinalNumber(dateString, {
            unit: 'date'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(date, value) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex$1(year);
      var month = date.getUTCMonth();
      if (isLeapYear) {
        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
      } else {
        return value >= 1 && value <= DAYS_IN_MONTH[month];
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCDate(value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return DateParser;
}(Parser);

var DayOfYearParser = /*#__PURE__*/function (_Parser) {
  _inherits(DayOfYearParser, _Parser);
  var _super = _createSuper(DayOfYearParser);
  function DayOfYearParser() {
    var _this;
    _classCallCheck(this, DayOfYearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$1(_this), "priority", 90);
    _defineProperty$2(_assertThisInitialized$1(_this), "subpriority", 1);
    _defineProperty$2(_assertThisInitialized$1(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(DayOfYearParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'D':
        case 'DD':
          return parseNumericPattern(numericPatterns.dayOfYear, dateString);
        case 'Do':
          return match.ordinalNumber(dateString, {
            unit: 'date'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(date, value) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex$1(year);
      if (isLeapYear) {
        return value >= 1 && value <= 366;
      } else {
        return value >= 1 && value <= 365;
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth(0, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return DayOfYearParser;
}(Parser);

function setUTCDay(dirtyDate, dirtyDay, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(2, arguments);
  var defaultOptions = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = toDate$1(dirtyDate);
  var day = toInteger(dirtyDay);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

var DayParser = /*#__PURE__*/function (_Parser) {
  _inherits(DayParser, _Parser);
  var _super = _createSuper(DayParser);
  function DayParser() {
    var _this;
    _classCallCheck(this, DayParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$1(_this), "priority", 90);
    _defineProperty$2(_assertThisInitialized$1(_this), "incompatibleTokens", ['D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(DayParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // Tue
        case 'E':
        case 'EE':
        case 'EEE':
          return match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // T
        case 'EEEEE':
          return match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu
        case 'EEEEEE':
          return match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday
        case 'EEEE':
        default:
          return match.day(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return DayParser;
}(Parser);

var LocalDayParser = /*#__PURE__*/function (_Parser) {
  _inherits(LocalDayParser, _Parser);
  var _super = _createSuper(LocalDayParser);
  function LocalDayParser() {
    var _this;
    _classCallCheck(this, LocalDayParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$1(_this), "priority", 90);
    _defineProperty$2(_assertThisInitialized$1(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']);
    return _this;
  }
  _createClass(LocalDayParser, [{
    key: "parse",
    value: function parse(dateString, token, match, options) {
      var valueCallback = function valueCallback(value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };
      switch (token) {
        // 3
        case 'e':
        case 'ee':
          // 03
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
        // 3rd
        case 'eo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'day'
          }), valueCallback);
        // Tue
        case 'eee':
          return match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // T
        case 'eeeee':
          return match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu
        case 'eeeeee':
          return match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday
        case 'eeee':
        default:
          return match.day(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return LocalDayParser;
}(Parser);

var StandAloneLocalDayParser = /*#__PURE__*/function (_Parser) {
  _inherits(StandAloneLocalDayParser, _Parser);
  var _super = _createSuper(StandAloneLocalDayParser);
  function StandAloneLocalDayParser() {
    var _this;
    _classCallCheck(this, StandAloneLocalDayParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$1(_this), "priority", 90);
    _defineProperty$2(_assertThisInitialized$1(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']);
    return _this;
  }
  _createClass(StandAloneLocalDayParser, [{
    key: "parse",
    value: function parse(dateString, token, match, options) {
      var valueCallback = function valueCallback(value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };
      switch (token) {
        // 3
        case 'c':
        case 'cc':
          // 03
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
        // 3rd
        case 'co':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'day'
          }), valueCallback);
        // Tue
        case 'ccc':
          return match.day(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'short',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // T
        case 'ccccc':
          return match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tu
        case 'cccccc':
          return match.day(dateString, {
            width: 'short',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tuesday
        case 'cccc':
        default:
          return match.day(dateString, {
            width: 'wide',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'short',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return StandAloneLocalDayParser;
}(Parser);

function setUTCISODay(dirtyDate, dirtyDay) {
  requiredArgs(2, arguments);
  var day = toInteger(dirtyDay);
  if (day % 7 === 0) {
    day = day - 7;
  }
  var weekStartsOn = 1;
  var date = toDate$1(dirtyDate);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

var ISODayParser = /*#__PURE__*/function (_Parser) {
  _inherits(ISODayParser, _Parser);
  var _super = _createSuper(ISODayParser);
  function ISODayParser() {
    var _this;
    _classCallCheck(this, ISODayParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$1(_this), "priority", 90);
    _defineProperty$2(_assertThisInitialized$1(_this), "incompatibleTokens", ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(ISODayParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(value) {
        if (value === 0) {
          return 7;
        }
        return value;
      };
      switch (token) {
        // 2
        case 'i':
        case 'ii':
          // 02
          return parseNDigits(token.length, dateString);
        // 2nd
        case 'io':
          return match.ordinalNumber(dateString, {
            unit: 'day'
          });
        // Tue
        case 'iii':
          return mapValue(match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
        // T
        case 'iiiii':
          return mapValue(match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
        // Tu
        case 'iiiiii':
          return mapValue(match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
        // Tuesday
        case 'iiii':
        default:
          return mapValue(match.day(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 7;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date = setUTCISODay(date, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return ISODayParser;
}(Parser);

var AMPMParser = /*#__PURE__*/function (_Parser) {
  _inherits(AMPMParser, _Parser);
  var _super = _createSuper(AMPMParser);
  function AMPMParser() {
    var _this;
    _classCallCheck(this, AMPMParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$1(_this), "priority", 80);
    _defineProperty$2(_assertThisInitialized$1(_this), "incompatibleTokens", ['b', 'B', 'H', 'k', 't', 'T']);
    return _this;
  }
  _createClass(AMPMParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'a':
        case 'aa':
        case 'aaa':
          return match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'aaaaa':
          return match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'aaaa':
        default:
          return match.dayPeriod(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    }
  }]);
  return AMPMParser;
}(Parser);

var AMPMMidnightParser = /*#__PURE__*/function (_Parser) {
  _inherits(AMPMMidnightParser, _Parser);
  var _super = _createSuper(AMPMMidnightParser);
  function AMPMMidnightParser() {
    var _this;
    _classCallCheck(this, AMPMMidnightParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$1(_this), "priority", 80);
    _defineProperty$2(_assertThisInitialized$1(_this), "incompatibleTokens", ['a', 'B', 'H', 'k', 't', 'T']);
    return _this;
  }
  _createClass(AMPMMidnightParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'b':
        case 'bb':
        case 'bbb':
          return match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'bbbbb':
          return match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'bbbb':
        default:
          return match.dayPeriod(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    }
  }]);
  return AMPMMidnightParser;
}(Parser);

var DayPeriodParser = /*#__PURE__*/function (_Parser) {
  _inherits(DayPeriodParser, _Parser);
  var _super = _createSuper(DayPeriodParser);
  function DayPeriodParser() {
    var _this;
    _classCallCheck(this, DayPeriodParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$1(_this), "priority", 80);
    _defineProperty$2(_assertThisInitialized$1(_this), "incompatibleTokens", ['a', 'b', 't', 'T']);
    return _this;
  }
  _createClass(DayPeriodParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'B':
        case 'BB':
        case 'BBB':
          return match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'BBBBB':
          return match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'BBBB':
        default:
          return match.dayPeriod(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    }
  }]);
  return DayPeriodParser;
}(Parser);

var Hour1to12Parser = /*#__PURE__*/function (_Parser) {
  _inherits(Hour1to12Parser, _Parser);
  var _super = _createSuper(Hour1to12Parser);
  function Hour1to12Parser() {
    var _this;
    _classCallCheck(this, Hour1to12Parser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$1(_this), "priority", 70);
    _defineProperty$2(_assertThisInitialized$1(_this), "incompatibleTokens", ['H', 'K', 'k', 't', 'T']);
    return _this;
  }
  _createClass(Hour1to12Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'h':
          return parseNumericPattern(numericPatterns.hour12h, dateString);
        case 'ho':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 12;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      var isPM = date.getUTCHours() >= 12;
      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else if (!isPM && value === 12) {
        date.setUTCHours(0, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }
      return date;
    }
  }]);
  return Hour1to12Parser;
}(Parser);

var Hour0to23Parser = /*#__PURE__*/function (_Parser) {
  _inherits(Hour0to23Parser, _Parser);
  var _super = _createSuper(Hour0to23Parser);
  function Hour0to23Parser() {
    var _this;
    _classCallCheck(this, Hour0to23Parser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$1(_this), "priority", 70);
    _defineProperty$2(_assertThisInitialized$1(_this), "incompatibleTokens", ['a', 'b', 'h', 'K', 'k', 't', 'T']);
    return _this;
  }
  _createClass(Hour0to23Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'H':
          return parseNumericPattern(numericPatterns.hour23h, dateString);
        case 'Ho':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 23;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(value, 0, 0, 0);
      return date;
    }
  }]);
  return Hour0to23Parser;
}(Parser);

var Hour0To11Parser = /*#__PURE__*/function (_Parser) {
  _inherits(Hour0To11Parser, _Parser);
  var _super = _createSuper(Hour0To11Parser);
  function Hour0To11Parser() {
    var _this;
    _classCallCheck(this, Hour0To11Parser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$1(_this), "priority", 70);
    _defineProperty$2(_assertThisInitialized$1(_this), "incompatibleTokens", ['h', 'H', 'k', 't', 'T']);
    return _this;
  }
  _createClass(Hour0To11Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'K':
          return parseNumericPattern(numericPatterns.hour11h, dateString);
        case 'Ko':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      var isPM = date.getUTCHours() >= 12;
      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }
      return date;
    }
  }]);
  return Hour0To11Parser;
}(Parser);

var Hour1To24Parser = /*#__PURE__*/function (_Parser) {
  _inherits(Hour1To24Parser, _Parser);
  var _super = _createSuper(Hour1To24Parser);
  function Hour1To24Parser() {
    var _this;
    _classCallCheck(this, Hour1To24Parser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$1(_this), "priority", 70);
    _defineProperty$2(_assertThisInitialized$1(_this), "incompatibleTokens", ['a', 'b', 'h', 'H', 'K', 't', 'T']);
    return _this;
  }
  _createClass(Hour1To24Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'k':
          return parseNumericPattern(numericPatterns.hour24h, dateString);
        case 'ko':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 24;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      var hours = value <= 24 ? value % 24 : value;
      date.setUTCHours(hours, 0, 0, 0);
      return date;
    }
  }]);
  return Hour1To24Parser;
}(Parser);

var MinuteParser = /*#__PURE__*/function (_Parser) {
  _inherits(MinuteParser, _Parser);
  var _super = _createSuper(MinuteParser);
  function MinuteParser() {
    var _this;
    _classCallCheck(this, MinuteParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$1(_this), "priority", 60);
    _defineProperty$2(_assertThisInitialized$1(_this), "incompatibleTokens", ['t', 'T']);
    return _this;
  }
  _createClass(MinuteParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'm':
          return parseNumericPattern(numericPatterns.minute, dateString);
        case 'mo':
          return match.ordinalNumber(dateString, {
            unit: 'minute'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 59;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMinutes(value, 0, 0);
      return date;
    }
  }]);
  return MinuteParser;
}(Parser);

var SecondParser = /*#__PURE__*/function (_Parser) {
  _inherits(SecondParser, _Parser);
  var _super = _createSuper(SecondParser);
  function SecondParser() {
    var _this;
    _classCallCheck(this, SecondParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$1(_this), "priority", 50);
    _defineProperty$2(_assertThisInitialized$1(_this), "incompatibleTokens", ['t', 'T']);
    return _this;
  }
  _createClass(SecondParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 's':
          return parseNumericPattern(numericPatterns.second, dateString);
        case 'so':
          return match.ordinalNumber(dateString, {
            unit: 'second'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 59;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCSeconds(value, 0);
      return date;
    }
  }]);
  return SecondParser;
}(Parser);

var FractionOfSecondParser = /*#__PURE__*/function (_Parser) {
  _inherits(FractionOfSecondParser, _Parser);
  var _super = _createSuper(FractionOfSecondParser);
  function FractionOfSecondParser() {
    var _this;
    _classCallCheck(this, FractionOfSecondParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$1(_this), "priority", 30);
    _defineProperty$2(_assertThisInitialized$1(_this), "incompatibleTokens", ['t', 'T']);
    return _this;
  }
  _createClass(FractionOfSecondParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      var valueCallback = function valueCallback(value) {
        return Math.floor(value * Math.pow(10, -token.length + 3));
      };
      return mapValue(parseNDigits(token.length, dateString), valueCallback);
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMilliseconds(value);
      return date;
    }
  }]);
  return FractionOfSecondParser;
}(Parser);

var ISOTimezoneWithZParser = /*#__PURE__*/function (_Parser) {
  _inherits(ISOTimezoneWithZParser, _Parser);
  var _super = _createSuper(ISOTimezoneWithZParser);
  function ISOTimezoneWithZParser() {
    var _this;
    _classCallCheck(this, ISOTimezoneWithZParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$1(_this), "priority", 10);
    _defineProperty$2(_assertThisInitialized$1(_this), "incompatibleTokens", ['t', 'T', 'x']);
    return _this;
  }
  _createClass(ISOTimezoneWithZParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      switch (token) {
        case 'X':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);
        case 'XX':
          return parseTimezonePattern(timezonePatterns.basic, dateString);
        case 'XXXX':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);
        case 'XXXXX':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);
        case 'XXX':
        default:
          return parseTimezonePattern(timezonePatterns.extended, dateString);
      }
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      if (flags.timestampIsSet) {
        return date;
      }
      return new Date(date.getTime() - value);
    }
  }]);
  return ISOTimezoneWithZParser;
}(Parser);

var ISOTimezoneParser = /*#__PURE__*/function (_Parser) {
  _inherits(ISOTimezoneParser, _Parser);
  var _super = _createSuper(ISOTimezoneParser);
  function ISOTimezoneParser() {
    var _this;
    _classCallCheck(this, ISOTimezoneParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$1(_this), "priority", 10);
    _defineProperty$2(_assertThisInitialized$1(_this), "incompatibleTokens", ['t', 'T', 'X']);
    return _this;
  }
  _createClass(ISOTimezoneParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      switch (token) {
        case 'x':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);
        case 'xx':
          return parseTimezonePattern(timezonePatterns.basic, dateString);
        case 'xxxx':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);
        case 'xxxxx':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);
        case 'xxx':
        default:
          return parseTimezonePattern(timezonePatterns.extended, dateString);
      }
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      if (flags.timestampIsSet) {
        return date;
      }
      return new Date(date.getTime() - value);
    }
  }]);
  return ISOTimezoneParser;
}(Parser);

var TimestampSecondsParser = /*#__PURE__*/function (_Parser) {
  _inherits(TimestampSecondsParser, _Parser);
  var _super = _createSuper(TimestampSecondsParser);
  function TimestampSecondsParser() {
    var _this;
    _classCallCheck(this, TimestampSecondsParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$1(_this), "priority", 40);
    _defineProperty$2(_assertThisInitialized$1(_this), "incompatibleTokens", '*');
    return _this;
  }
  _createClass(TimestampSecondsParser, [{
    key: "parse",
    value: function parse(dateString) {
      return parseAnyDigitsSigned(dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      return [new Date(value * 1000), {
        timestampIsSet: true
      }];
    }
  }]);
  return TimestampSecondsParser;
}(Parser);

var TimestampMillisecondsParser = /*#__PURE__*/function (_Parser) {
  _inherits(TimestampMillisecondsParser, _Parser);
  var _super = _createSuper(TimestampMillisecondsParser);
  function TimestampMillisecondsParser() {
    var _this;
    _classCallCheck(this, TimestampMillisecondsParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$1(_this), "priority", 20);
    _defineProperty$2(_assertThisInitialized$1(_this), "incompatibleTokens", '*');
    return _this;
  }
  _createClass(TimestampMillisecondsParser, [{
    key: "parse",
    value: function parse(dateString) {
      return parseAnyDigitsSigned(dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      return [new Date(value), {
        timestampIsSet: true
      }];
    }
  }]);
  return TimestampMillisecondsParser;
}(Parser);

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */
var parsers = {
  G: new EraParser(),
  y: new YearParser(),
  Y: new LocalWeekYearParser(),
  R: new ISOWeekYearParser(),
  u: new ExtendedYearParser(),
  Q: new QuarterParser(),
  q: new StandAloneQuarterParser(),
  M: new MonthParser(),
  L: new StandAloneMonthParser(),
  w: new LocalWeekParser(),
  I: new ISOWeekParser(),
  d: new DateParser(),
  D: new DayOfYearParser(),
  E: new DayParser(),
  e: new LocalDayParser(),
  c: new StandAloneLocalDayParser(),
  i: new ISODayParser(),
  a: new AMPMParser(),
  b: new AMPMMidnightParser(),
  B: new DayPeriodParser(),
  h: new Hour1to12Parser(),
  H: new Hour0to23Parser(),
  K: new Hour0To11Parser(),
  k: new Hour1To24Parser(),
  m: new MinuteParser(),
  s: new SecondParser(),
  S: new FractionOfSecondParser(),
  X: new ISOTimezoneWithZParser(),
  x: new ISOTimezoneParser(),
  t: new TimestampSecondsParser(),
  T: new TimestampMillisecondsParser()
};

// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {String} dateString - the string to parse
 * @param {String} formatString - the string of tokens
 * @param {Date|Number} referenceDate - defines values missing from the parsed dateString
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {Date} the parsed date
 * @throws {TypeError} 3 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.locale` must contain `match` property
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */
function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  requiredArgs(3, arguments);
  var dateString = String(dirtyDateString);
  var formatString = String(dirtyFormatString);
  var defaultOptions = getDefaultOptions();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale;
  if (!locale.match) {
    throw new RangeError('locale must contain match property');
  }
  var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  if (formatString === '') {
    if (dateString === '') {
      return toDate$1(dirtyReferenceDate);
    } else {
      return new Date(NaN);
    }
  }
  var subFnOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale
  };

  // If timezone isn't specified, it will be set to the system timezone
  var setters = [new DateToSystemTimezoneSetter()];
  var tokens = formatString.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];
    if (firstCharacter in longFormatters$1) {
      var longFormatter = longFormatters$1[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join('').match(formattingTokensRegExp);
  var usedTokens = [];
  var _iterator = _createForOfIteratorHelper(tokens),
    _step;
  try {
    var _loop = function _loop() {
      var token = _step.value;
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(token)) {
        throwProtectedError(token, formatString, dirtyDateString);
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(token)) {
        throwProtectedError(token, formatString, dirtyDateString);
      }
      var firstCharacter = token[0];
      var parser = parsers[firstCharacter];
      if (parser) {
        var incompatibleTokens = parser.incompatibleTokens;
        if (Array.isArray(incompatibleTokens)) {
          var incompatibleToken = usedTokens.find(function (usedToken) {
            return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
          });
          if (incompatibleToken) {
            throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
          }
        } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) {
          throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
        }
        usedTokens.push({
          token: firstCharacter,
          fullToken: token
        });
        var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
        if (!parseResult) {
          return {
            v: new Date(NaN)
          };
        }
        setters.push(parseResult.setter);
        dateString = parseResult.rest;
      } else {
        if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
          throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        }

        // Replace two single quote characters with one single quote character
        if (token === "''") {
          token = "'";
        } else if (firstCharacter === "'") {
          token = cleanEscapedString(token);
        }

        // Cut token from string, or, if string doesn't match the token, return Invalid Date
        if (dateString.indexOf(token) === 0) {
          dateString = dateString.slice(token.length);
        } else {
          return {
            v: new Date(NaN)
          };
        }
      }
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _ret = _loop();
      if (_typeof(_ret) === "object") return _ret.v;
    }

    // Check if the remaining input contains something other than whitespace
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
    return new Date(NaN);
  }
  var uniquePrioritySetters = setters.map(function (setter) {
    return setter.priority;
  }).sort(function (a, b) {
    return b - a;
  }).filter(function (priority, index, array) {
    return array.indexOf(priority) === index;
  }).map(function (priority) {
    return setters.filter(function (setter) {
      return setter.priority === priority;
    }).sort(function (a, b) {
      return b.subPriority - a.subPriority;
    });
  }).map(function (setterArray) {
    return setterArray[0];
  });
  var date = toDate$1(dirtyReferenceDate);
  if (isNaN(date.getTime())) {
    return new Date(NaN);
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  var utcDate = subMilliseconds(date, getTimezoneOffsetInMilliseconds(date));
  var flags = {};
  var _iterator2 = _createForOfIteratorHelper(uniquePrioritySetters),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var setter = _step2.value;
      if (!setter.validate(utcDate, subFnOptions)) {
        return new Date(NaN);
      }
      var result = setter.set(utcDate, flags, subFnOptions);
      // Result is tuple (date, flags)
      if (Array.isArray(result)) {
        utcDate = result[0];
        assign(flags, result[1]);
        // Result is date
      } else {
        utcDate = result;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return utcDate;
}
function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

/**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * @param {String} argument - the value to convert
 * @param {Object} [options] - an object with options.
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */
function parseISO(argument, options) {
  var _options$additionalDi;
  requiredArgs(1, arguments);
  var additionalDigits = toInteger((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2');
  }
  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN);
  }
  var dateStrings = splitDateString(argument);
  var date;
  if (dateStrings.date) {
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }
  if (!date || isNaN(date.getTime())) {
    return new Date(NaN);
  }
  var timestamp = date.getTime();
  var time = 0;
  var offset;
  if (dateStrings.time) {
    time = parseTime(dateStrings.time);
    if (isNaN(time)) {
      return new Date(NaN);
    }
  }
  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);
    if (isNaN(offset)) {
      return new Date(NaN);
    }
  } else {
    var dirtyDate = new Date(timestamp + time);
    // js parsed string assuming it's in UTC timezone
    // but we need it to be parsed in our timezone
    // so we use utc values to build date in our timezone.
    // Year values from 0 to 99 map to the years 1900 to 1999
    // so set year explicitly with setFullYear.
    var result = new Date(0);
    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
    result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
    return result;
  }
  return new Date(timestamp + time + offset);
}
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimiter);
  var timeString;

  // The regex match should only return at maximum two array elements.
  // [date], [time], or [date, time].
  if (array.length > 2) {
    return dateStrings;
  }
  if (/:/.test(array[0])) {
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];
    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }
  if (timeString) {
    var token = patterns.timezone.exec(timeString);
    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }
  return dateStrings;
}
function parseYear(dateString, additionalDigits) {
  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
  var captures = dateString.match(regex);
  // Invalid ISO-formatted year
  if (!captures) return {
    year: NaN,
    restDateString: ''
  };
  var year = captures[1] ? parseInt(captures[1]) : null;
  var century = captures[2] ? parseInt(captures[2]) : null;

  // either year or century is null, not both
  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}
function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) return new Date(NaN);
  var captures = dateString.match(dateRegex);
  // Invalid ISO-formatted string
  if (!captures) return new Date(NaN);
  var isWeekDate = !!captures[4];
  var dayOfYear = parseDateUnit(captures[1]);
  var month = parseDateUnit(captures[2]) - 1;
  var day = parseDateUnit(captures[3]);
  var week = parseDateUnit(captures[4]);
  var dayOfWeek = parseDateUnit(captures[5]) - 1;
  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }
    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    var date = new Date(0);
    if (!validateDate$1(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }
    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}
function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}
function parseTime(timeString) {
  var captures = timeString.match(timeRegex);
  if (!captures) return NaN; // Invalid ISO-formatted time

  var hours = parseTimeUnit(captures[1]);
  var minutes = parseTimeUnit(captures[2]);
  var seconds = parseTimeUnit(captures[3]);
  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }
  return hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * 1000;
}
function parseTimeUnit(value) {
  return value && parseFloat(value.replace(',', '.')) || 0;
}
function parseTimezone(timezoneString) {
  if (timezoneString === 'Z') return 0;
  var captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  var sign = captures[1] === '+' ? -1 : 1;
  var hours = parseInt(captures[2]);
  var minutes = captures[3] && parseInt(captures[3]) || 0;
  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }
  return sign * (hours * millisecondsInHour + minutes * millisecondsInMinute);
}
function dayOfISOWeekYear(isoWeekYear, week, day) {
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

// Validation functions

// February is null to handle the leap year (using ||)
var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate$1(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}
function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}
function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }
  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17


  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }

  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */

function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.
  // Also cover shadowRoot node by checking current.host


  while (current.parentNode || current.host) {
    // Only check normal node without shadowRoot
    if (current.parentNode && isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }

    current = current.parentNode || current.host;
  }

  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */

function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}// ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */

function getEventHandlerOptions(instance, eventName) {
  var handlerOptions = {};
  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

  if (isTouchEvent && passiveEventSupport) {
    handlerOptions.passive = !instance.props.preventDefault;
  }

  return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */


function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  return _temp = _class = /*#__PURE__*/function (_Component) {
    _inheritsLoose(onClickOutside, _Component);

    function onClickOutside(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);

          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
      };

      _this.__getComponentNode = function () {
        var instance = _this.getInstance();

        if (config && typeof config.setClickOutsideRef === 'function') {
          return config.setClickOutsideRef()(instance);
        }

        if (typeof instance.setClickOutsideRef === 'function') {
          return instance.setClickOutsideRef();
        }

        return findDOMNode(instance);
      };

      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }

        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = testPassiveEventSupport();
        }

        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;

        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.componentNode === null) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.composed && event.composedPath && event.composedPath().shift() || event.target;

          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_assertThisInitialized(_this), eventName));
        });
      };

      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];

        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;

          if (!events.forEach) {
            events = [events];
          }

          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_assertThisInitialized(_this), eventName));
          });
          delete handlersMap[_this._uid];
        }
      };

      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };

      _this._uid = uid();
      return _this;
    }
    /**
     * Access the WrappedComponent's instance.
     */


    var _proto = onClickOutside.prototype;

    _proto.getInstance = function getInstance() {
      if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) {
        return this;
      }

      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    _proto.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      var instance = this.getInstance();

      if (config && typeof config.handleClickOutside === 'function') {
        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);

        if (typeof this.__clickOutsideHandlerProp !== 'function') {
          throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
        }
      }

      this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside

      if (this.props.disableOnClickOutside) return;
      this.enableOnClickOutside();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = this.__getComponentNode();
    }
    /**
     * Remove all document's event listeners for this component
     */
    ;

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    }
    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */
    ;

    /**
     * Pass-through render
     */
    _proto.render = function render() {
      // eslint-disable-next-line no-unused-vars
      var _this$props = this.props;
          _this$props.excludeScrollbar;
          var props = _objectWithoutPropertiesLoose$2(_this$props, ["excludeScrollbar"]);

      if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return createElement(WrappedComponent, props);
    };

    return onClickOutside;
  }(Component), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: config && config.excludeScrollbar || false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}

var ManagerReferenceNodeContext = React.createContext();
var ManagerReferenceNodeSetterContext = React.createContext();
function Manager(_ref) {
  var children = _ref.children;

  var _React$useState = React.useState(null),
      referenceNode = _React$useState[0],
      setReferenceNode = _React$useState[1];

  var hasUnmounted = React.useRef(false);
  React.useEffect(function () {
    return function () {
      hasUnmounted.current = true;
    };
  }, []);
  var handleSetReferenceNode = React.useCallback(function (node) {
    if (!hasUnmounted.current) {
      setReferenceNode(node);
    }
  }, []);
  return /*#__PURE__*/React.createElement(ManagerReferenceNodeContext.Provider, {
    value: referenceNode
  }, /*#__PURE__*/React.createElement(ManagerReferenceNodeSetterContext.Provider, {
    value: handleSetReferenceNode
  }, children));
}

/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */
var unwrapArray = function unwrapArray(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};
/**
 * Takes a maybe-undefined function and arbitrary args and invokes the function
 * only if it is defined.
 */

var safeInvoke = function safeInvoke(fn) {
  if (typeof fn === 'function') {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return fn.apply(void 0, args);
  }
};
/**
 * Sets a ref using either a ref callback or a ref object
 */

var setRef = function setRef(ref, node) {
  // if its a function call it
  if (typeof ref === 'function') {
    return safeInvoke(ref, node);
  } // otherwise we should treat it as a ref object
  else if (ref != null) {
      ref.current = node;
    }
};
/**
 * Simple ponyfill for Object.fromEntries
 */

var fromEntries = function fromEntries(entries) {
  return entries.reduce(function (acc, _ref) {
    var key = _ref[0],
        value = _ref[1];
    acc[key] = value;
    return acc;
  }, {});
};
/**
 * Small wrapper around `useLayoutEffect` to get rid of the warning on SSR envs
 */

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && window.document && window.document.createElement ? React.useLayoutEffect : React.useEffect;

var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}

function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function effect$2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


var applyStyles$1 = {
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect$2,
  requires: ['computeStyles']
};

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

var max = Math.max;
var min = Math.min;
var round = Math.round;

function getUAString() {
  var uaData = navigator.userAgentData;

  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }

  return navigator.userAgent;
}

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}

function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }

  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }

  var _ref = isElement(element) ? getWindow(element) : window,
      visualViewport = _ref.visualViewport;

  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}

// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}

function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle$1(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());

  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle$1(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle$1(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle$1(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

function within(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}

function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function effect$1(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (!contains(state.elements.popper, arrowElement)) {
    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


var arrow$1 = {
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect$1,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
};

function getVariation(placement) {
  return placement.split('-')[1];
}

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref, win) {
  var x = _ref.x,
      y = _ref.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle$1(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }, getWindow(popper)) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var computeStyles$1 = {
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
};

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


var eventListeners = {
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
};

var hash$1 = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash$1[matched];
  });
}

var hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash[matched];
  });
}

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();

    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}

// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle$1(body || html).direction === 'rtl') {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle$1(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}

/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}

function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle$1(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;
    }
  }

  return offsets;
}

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$strategy = _options.strategy,
      strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}

function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


var flip$1 = {
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
};

function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


var hide$1 = {
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
};

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var offset$1 = {
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
};

function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var popperOffsets$1 = {
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
};

function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min$1 = offset + overflow[mainSide];
    var max$1 = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? top : left;

    var _altSide = mainAxis === 'x' ? bottom : right;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var preventOverflow$1 = {
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
};

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref) {
        var name = _ref.name,
            _ref$options = _ref.options,
            options = _ref$options === void 0 ? {} : _ref$options,
            effect = _ref.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}

var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.3
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }

    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    // START: Modifications:
    // Apply guards for `Object.create(null)` handling. See:
    // - https://github.com/FormidableLabs/react-fast-compare/issues/64
    // - https://github.com/epoberezkin/fast-deep-equal/issues/49
    if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
    // END: Modifications

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

var reactFastCompare = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (((error.message || '').match(/stack|recursion/i))) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};

var EMPTY_MODIFIERS$1 = [];
var usePopper = function usePopper(referenceElement, popperElement, options) {
  if (options === void 0) {
    options = {};
  }

  var prevOptions = React.useRef(null);
  var optionsWithDefaults = {
    onFirstUpdate: options.onFirstUpdate,
    placement: options.placement || 'bottom',
    strategy: options.strategy || 'absolute',
    modifiers: options.modifiers || EMPTY_MODIFIERS$1
  };

  var _React$useState = React.useState({
    styles: {
      popper: {
        position: optionsWithDefaults.strategy,
        left: '0',
        top: '0'
      },
      arrow: {
        position: 'absolute'
      }
    },
    attributes: {}
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var updateStateModifier = React.useMemo(function () {
    return {
      name: 'updateState',
      enabled: true,
      phase: 'write',
      fn: function fn(_ref) {
        var state = _ref.state;
        var elements = Object.keys(state.elements);
        require$$1.flushSync(function () {
          setState({
            styles: fromEntries(elements.map(function (element) {
              return [element, state.styles[element] || {}];
            })),
            attributes: fromEntries(elements.map(function (element) {
              return [element, state.attributes[element]];
            }))
          });
        });
      },
      requires: ['computeStyles']
    };
  }, []);
  var popperOptions = React.useMemo(function () {
    var newOptions = {
      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
      placement: optionsWithDefaults.placement,
      strategy: optionsWithDefaults.strategy,
      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
        name: 'applyStyles',
        enabled: false
      }])
    };

    if (reactFastCompare(prevOptions.current, newOptions)) {
      return prevOptions.current || newOptions;
    } else {
      prevOptions.current = newOptions;
      return newOptions;
    }
  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
  var popperInstanceRef = React.useRef();
  useIsomorphicLayoutEffect(function () {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.setOptions(popperOptions);
    }
  }, [popperOptions]);
  useIsomorphicLayoutEffect(function () {
    if (referenceElement == null || popperElement == null) {
      return;
    }

    var createPopper$1 = options.createPopper || createPopper;
    var popperInstance = createPopper$1(referenceElement, popperElement, popperOptions);
    popperInstanceRef.current = popperInstance;
    return function () {
      popperInstance.destroy();
      popperInstanceRef.current = null;
    };
  }, [referenceElement, popperElement, options.createPopper]);
  return {
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: state.styles,
    attributes: state.attributes,
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
  };
};

var NOOP = function NOOP() {
  return void 0;
};

var NOOP_PROMISE = function NOOP_PROMISE() {
  return Promise.resolve(null);
};

var EMPTY_MODIFIERS = [];
function Popper(_ref) {
  var _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'bottom' : _ref$placement,
      _ref$strategy = _ref.strategy,
      strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy,
      _ref$modifiers = _ref.modifiers,
      modifiers = _ref$modifiers === void 0 ? EMPTY_MODIFIERS : _ref$modifiers,
      referenceElement = _ref.referenceElement,
      onFirstUpdate = _ref.onFirstUpdate,
      innerRef = _ref.innerRef,
      children = _ref.children;
  var referenceNode = React.useContext(ManagerReferenceNodeContext);

  var _React$useState = React.useState(null),
      popperElement = _React$useState[0],
      setPopperElement = _React$useState[1];

  var _React$useState2 = React.useState(null),
      arrowElement = _React$useState2[0],
      setArrowElement = _React$useState2[1];

  React.useEffect(function () {
    setRef(innerRef, popperElement);
  }, [innerRef, popperElement]);
  var options = React.useMemo(function () {
    return {
      placement: placement,
      strategy: strategy,
      onFirstUpdate: onFirstUpdate,
      modifiers: [].concat(modifiers, [{
        name: 'arrow',
        enabled: arrowElement != null,
        options: {
          element: arrowElement
        }
      }])
    };
  }, [placement, strategy, onFirstUpdate, modifiers, arrowElement]);

  var _usePopper = usePopper(referenceElement || referenceNode, popperElement, options),
      state = _usePopper.state,
      styles = _usePopper.styles,
      forceUpdate = _usePopper.forceUpdate,
      update = _usePopper.update;

  var childrenProps = React.useMemo(function () {
    return {
      ref: setPopperElement,
      style: styles.popper,
      placement: state ? state.placement : placement,
      hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
      isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
      arrowProps: {
        style: styles.arrow,
        ref: setArrowElement
      },
      forceUpdate: forceUpdate || NOOP,
      update: update || NOOP_PROMISE
    };
  }, [setPopperElement, setArrowElement, placement, state, styles, update, forceUpdate]);
  return unwrapArray(children)(childrenProps);
}

function Reference(_ref) {
  var children = _ref.children,
      innerRef = _ref.innerRef;
  var setReferenceNode = React.useContext(ManagerReferenceNodeSetterContext);
  var refHandler = React.useCallback(function (node) {
    setRef(innerRef, node);
    safeInvoke(setReferenceNode, node);
  }, [innerRef, setReferenceNode]); // ran on unmount
  // eslint-disable-next-line react-hooks/exhaustive-deps

  React.useEffect(function () {
    return function () {
      return setRef(innerRef, null);
    };
  }, []);
  React.useEffect(function () {
    warning_1(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
  }, [setReferenceNode]);
  return unwrapArray(children)({
    ref: refHandler
  });
}

/**
 * @name set
 * @category Common Helpers
 * @summary Set date values to a given date.
 *
 * @description
 * Set date values to a given date.
 *
 * Sets time values to date from object `values`.
 * A value is not set if it is undefined or null or doesn't exist in `values`.
 *
 * Note about bundle size: `set` does not internally use `setX` functions from date-fns but instead opts
 * to use native `Date#setX` methods. If you use this function, you may not want to include the
 * other `setX` functions that date-fns provides if you are concerned about the bundle size.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Object} values - an object with options
 * @param {Number} [values.year] - the number of years to be set
 * @param {Number} [values.month] - the number of months to be set
 * @param {Number} [values.date] - the number of days to be set
 * @param {Number} [values.hours] - the number of hours to be set
 * @param {Number} [values.minutes] - the number of minutes to be set
 * @param {Number} [values.seconds] - the number of seconds to be set
 * @param {Number} [values.milliseconds] - the number of milliseconds to be set
 * @returns {Date} the new date with options set
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `values` must be an object
 *
 * @example
 * // Transform 1 September 2014 into 20 October 2015 in a single line:
 * const result = set(new Date(2014, 8, 20), { year: 2015, month: 9, date: 20 })
 * //=> Tue Oct 20 2015 00:00:00
 *
 * @example
 * // Set 12 PM to 1 September 2014 01:23:45 to 1 September 2014 12:00:00:
 * const result = set(new Date(2014, 8, 1, 1, 23, 45), { hours: 12 })
 * //=> Mon Sep 01 2014 12:23:45
 */
function set(dirtyDate, values) {
  requiredArgs(2, arguments);
  if (_typeof(values) !== 'object' || values === null) {
    throw new RangeError('values parameter must be an object');
  }
  var date = toDate$1(dirtyDate);

  // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
  if (isNaN(date.getTime())) {
    return new Date(NaN);
  }
  if (values.year != null) {
    date.setFullYear(values.year);
  }
  if (values.month != null) {
    date = setMonth(date, values.month);
  }
  if (values.date != null) {
    date.setDate(toInteger(values.date));
  }
  if (values.hours != null) {
    date.setHours(toInteger(values.hours));
  }
  if (values.minutes != null) {
    date.setMinutes(toInteger(values.minutes));
  }
  if (values.seconds != null) {
    date.setSeconds(toInteger(values.seconds));
  }
  if (values.milliseconds != null) {
    date.setMilliseconds(toInteger(values.milliseconds));
  }
  return date;
}

function le(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n);}return r}function de(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?le(Object(r),!0).forEach((function(t){ye(e,t,r[t]);})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):le(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t));}));}return e}function ue(e){return ue="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},ue(e)}function he(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function me(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,_e(n.key),n);}}function fe(e,t,r){return t&&me(e.prototype,t),r&&me(e,r),Object.defineProperty(e,"prototype",{writable:!1}),e}function ye(e,t,r){return (t=_e(t))in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}function ve(){return ve=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n]);}return e},ve.apply(this,arguments)}function De(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),Object.defineProperty(e,"prototype",{writable:!1}),t&&we(e,t);}function ge(e){return ge=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(e){return e.__proto__||Object.getPrototypeOf(e)},ge(e)}function we(e,t){return we=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(e,t){return e.__proto__=t,e},we(e,t)}function ke(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function be(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return !1;if(Reflect.construct.sham)return !1;if("function"==typeof Proxy)return !0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return !1}}();return function(){var r,n=ge(e);if(t){var o=ge(this).constructor;r=Reflect.construct(n,arguments,o);}else r=n.apply(this,arguments);return function(e,t){if(t&&("object"==typeof t||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return ke(e)}(this,r)}}function Se(e){return function(e){if(Array.isArray(e))return Ce(e)}(e)||function(e){if("undefined"!=typeof Symbol&&null!=e[Symbol.iterator]||null!=e["@@iterator"])return Array.from(e)}(e)||function(e,t){if(!e)return;if("string"==typeof e)return Ce(e,t);var r=Object.prototype.toString.call(e).slice(8,-1);"Object"===r&&e.constructor&&(r=e.constructor.name);if("Map"===r||"Set"===r)return Array.from(e);if("Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))return Ce(e,t)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function Ce(e,t){(null==t||t>e.length)&&(t=e.length);for(var r=0,n=new Array(t);r<t;r++)n[r]=e[r];return n}function _e(e){var t=function(e,t){if("object"!=typeof e||null===e)return e;var r=e[Symbol.toPrimitive];if(void 0!==r){var n=r.call(e,t||"default");if("object"!=typeof n)return n;throw new TypeError("@@toPrimitive must return a primitive value.")}return ("string"===t?String:Number)(e)}(e,"string");return "symbol"==typeof t?t:String(t)}var Me=function(e,t){switch(e){case"P":return t.date({width:"short"});case"PP":return t.date({width:"medium"});case"PPP":return t.date({width:"long"});default:return t.date({width:"full"})}},Ee=function(e,t){switch(e){case"p":return t.time({width:"short"});case"pp":return t.time({width:"medium"});case"ppp":return t.time({width:"long"});default:return t.time({width:"full"})}},Pe={p:Ee,P:function(e,t){var r,n=e.match(/(P+)(p+)?/)||[],o=n[1],a=n[2];if(!a)return Me(e,t);switch(o){case"P":r=t.dateTime({width:"short"});break;case"PP":r=t.dateTime({width:"medium"});break;case"PPP":r=t.dateTime({width:"long"});break;default:r=t.dateTime({width:"full"});}return r.replace("{{date}}",Me(o,t)).replace("{{time}}",Ee(a,t))}},Ne=12,xe=/P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;function Ye(e){var t=e?"string"==typeof e||e instanceof String?parseISO(e):toDate$1(e):new Date;return Te(t)?t:null}function Te(e,t){return t=t||new Date("1/1/1000"),isValid(e)&&!isBefore(e,t)}function Ie(e,t,r){if("en"===r)return format(e,t,{awareOfUnicodeTokens:!0});var n=Ge(r);return r&&!n&&console.warn('A locale object was not found for the provided string ["'.concat(r,'"].')),!n&&$e()&&Ge($e())&&(n=Ge($e())),format(e,t,{locale:n||null,awareOfUnicodeTokens:!0})}function Oe(e,t){var r=t.dateFormat,n=t.locale;return e&&Ie(e,Array.isArray(r)?r[0]:r,n)||""}function Re(e,t){var r=t.hour,n=void 0===r?0:r,o=t.minute,a=void 0===o?0:o,s=t.second;return setHours(setMinutes(setSeconds(e,void 0===s?0:s),a),n)}function Le(e,t,r){var n=Ge(t||$e());return startOfWeek(e,{locale:n,weekStartsOn:r})}function Fe(e){return startOfMonth(e)}function Ae(e){return startOfYear(e)}function Ke(e){return startOfQuarter(e)}function Be(){return startOfDay(Ye())}function Qe(e,t){return e&&t?isSameYear(e,t):!e&&!t}function He(e,t){return e&&t?isSameMonth(e,t):!e&&!t}function je(e,t){return e&&t?isSameQuarter(e,t):!e&&!t}function We(e,t){return e&&t?isSameDay(e,t):!e&&!t}function Ve(e,t){return e&&t?isEqual$1(e,t):!e&&!t}function qe(e,t,r){var n,o=startOfDay(t),a=endOfDay(r);try{n=isWithinInterval(e,{start:o,end:a});}catch(e){n=!1;}return n}function $e(){return ("undefined"!=typeof window?window:globalThis).__localeId__}function Ge(e){if("string"==typeof e){var t="undefined"!=typeof window?window:globalThis;return t.__localeData__?t.__localeData__[e]:null}return e}function Je(e,t){return Ie(setMonth(Ye(),e),"LLLL",t)}function Xe(e,t){return Ie(setMonth(Ye(),e),"LLL",t)}function Ze(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate,o=t.excludeDates,a=t.excludeDateIntervals,s=t.includeDates,i=t.includeDateIntervals,p=t.filterDate;return it(e,{minDate:r,maxDate:n})||o&&o.some((function(t){return We(e,t)}))||a&&a.some((function(t){var r=t.start,n=t.end;return isWithinInterval(e,{start:r,end:n})}))||s&&!s.some((function(t){return We(e,t)}))||i&&!i.some((function(t){var r=t.start,n=t.end;return isWithinInterval(e,{start:r,end:n})}))||p&&!p(Ye(e))||!1}function et(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.excludeDates,n=t.excludeDateIntervals;return n&&n.length>0?n.some((function(t){var r=t.start,n=t.end;return isWithinInterval(e,{start:r,end:n})})):r&&r.some((function(t){return We(e,t)}))||!1}function tt(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate,o=t.excludeDates,a=t.includeDates,s=t.filterDate;return it(e,{minDate:startOfMonth(r),maxDate:endOfMonth(n)})||o&&o.some((function(t){return He(e,t)}))||a&&!a.some((function(t){return He(e,t)}))||s&&!s(Ye(e))||!1}function rt(e,t,r,n){var o=getYear(e),a=getMonth(e),s=getYear(t),i=getMonth(t),p=getYear(n);return o===s&&o===p?a<=r&&r<=i:o<s?p===o&&a<=r||p===s&&i>=r||p<s&&p>o:void 0}function nt(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate,o=t.excludeDates,a=t.includeDates,s=t.filterDate;return it(e,{minDate:r,maxDate:n})||o&&o.some((function(t){return je(e,t)}))||a&&!a.some((function(t){return je(e,t)}))||s&&!s(Ye(e))||!1}function ot(e,t,r){if(!isValid(t)||!isValid(r))return !1;var n=getYear(t),a=getYear(r);return n<=e&&a>=e}function at(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate,o=t.excludeDates,a=t.includeDates,s=t.filterDate,i=new Date(e,0,1);return it(i,{minDate:startOfYear(r),maxDate:endOfYear(n)})||o&&o.some((function(e){return Qe(i,e)}))||a&&!a.some((function(e){return Qe(i,e)}))||s&&!s(Ye(i))||!1}function st(e,t,r,n){var o=getYear(e),a=getQuarter(e),s=getYear(t),i=getQuarter(t),p=getYear(n);return o===s&&o===p?a<=r&&r<=i:o<s?p===o&&a<=r||p===s&&i>=r||p<s&&p>o:void 0}function it(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate;return r&&differenceInCalendarDays(e,r)<0||n&&differenceInCalendarDays(e,n)>0}function pt(e,t){return t.some((function(t){return getHours(t)===getHours(e)&&getMinutes(t)===getMinutes(e)}))}function ct(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.excludeTimes,n=t.includeTimes,o=t.filterTime;return r&&pt(e,r)||n&&!pt(e,n)||o&&!o(e)||!1}function lt(e,t){var r=t.minTime,n=t.maxTime;if(!r||!n)throw new Error("Both minTime and maxTime props required");var o,a=Ye(),s=setHours(setMinutes(a,getMinutes(e)),getHours(e)),i=setHours(setMinutes(a,getMinutes(r)),getHours(r)),p=setHours(setMinutes(a,getMinutes(n)),getHours(n));try{o=!isWithinInterval(s,{start:i,end:p});}catch(e){o=!1;}return o}function dt(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.includeDates,o=subMonths(e,1);return r&&differenceInCalendarMonths(r,o)>0||n&&n.every((function(e){return differenceInCalendarMonths(e,o)>0}))||!1}function ut(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,n=t.includeDates,o=addMonths(e,1);return r&&differenceInCalendarMonths(o,r)>0||n&&n.every((function(e){return differenceInCalendarMonths(o,e)>0}))||!1}function ht(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.includeDates,o=subYears(e,1);return r&&differenceInCalendarYears(r,o)>0||n&&n.every((function(e){return differenceInCalendarYears(e,o)>0}))||!1}function mt(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,n=t.includeDates,o=addYears(e,1);return r&&differenceInCalendarYears(o,r)>0||n&&n.every((function(e){return differenceInCalendarYears(o,e)>0}))||!1}function ft(e){var t=e.minDate,r=e.includeDates;if(r&&t){var n=r.filter((function(e){return differenceInCalendarDays(e,t)>=0}));return min$1(n)}return r?min$1(r):t}function yt(e){var t=e.maxDate,r=e.includeDates;if(r&&t){var n=r.filter((function(e){return differenceInCalendarDays(e,t)<=0}));return max$1(n)}return r?max$1(r):t}function vt(){for(var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"react-datepicker__day--highlighted",r=new Map,o=0,a=e.length;o<a;o++){var s=e[o];if(isDate(s)){var i=Ie(s,"MM.dd.yyyy"),p=r.get(i)||[];p.includes(t)||(p.push(t),r.set(i,p));}else if("object"===ue(s)){var c=Object.keys(s),l=c[0],d=s[c[0]];if("string"==typeof l&&d.constructor===Array)for(var u=0,h=d.length;u<h;u++){var m=Ie(d[u],"MM.dd.yyyy"),f=r.get(m)||[];f.includes(l)||(f.push(l),r.set(m,f));}}}return r}function Dt(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"react-datepicker__day--holidays",r=new Map;return e.forEach((function(e){var o=e.date,a=e.holidayName;if(isDate(o)){var s=Ie(o,"MM.dd.yyyy"),i=r.get(s)||{};if(!("className"in i)||i.className!==t||(p=i.holidayNames,c=[a],p.length!==c.length||!p.every((function(e,t){return e===c[t]})))){var p,c;i.className=t;var l=i.holidayNames;i.holidayNames=l?[].concat(Se(l),[a]):[a],r.set(s,i);}}})),r}function gt(e,t,r,n,o){for(var a=o.length,p=[],c=0;c<a;c++){var l=addMinutes(addHours(e,getHours(o[c])),getMinutes(o[c])),d=addMinutes(e,(r+1)*n);isAfter(l,t)&&isBefore(l,d)&&p.push(o[c]);}return p}function wt(e){return e<10?"0".concat(e):"".concat(e)}function kt(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:Ne,r=Math.ceil(getYear(e)/t)*t;return {startPeriod:r-(t-1),endPeriod:r}}function bt(e){var t=e.getSeconds(),r=e.getMilliseconds();return toDate$1(e.getTime()-1e3*t-r)}function St(e,t,r,n){for(var o=[],a=0;a<2*t+1;a++){var s=e+t-a,i=!0;r&&(i=getYear(r)<=s),n&&i&&(i=getYear(n)>=s),i&&o.push(s);}return o}var Ct=onClickOutsideHOC(function(n){De(a,React__default.Component);var o=be(a);function a(r){var n;he(this,a),ye(ke(n=o.call(this,r)),"renderOptions",(function(){var t=n.props.year,r=n.state.yearsList.map((function(r){return React__default.createElement("div",{className:t===r?"react-datepicker__year-option react-datepicker__year-option--selected_year":"react-datepicker__year-option",key:r,onClick:n.onChange.bind(ke(n),r),"aria-selected":t===r?"true":void 0},t===r?React__default.createElement("span",{className:"react-datepicker__year-option--selected"},"✓"):"",r)})),o=n.props.minDate?getYear(n.props.minDate):null,a=n.props.maxDate?getYear(n.props.maxDate):null;return a&&n.state.yearsList.find((function(e){return e===a}))||r.unshift(React__default.createElement("div",{className:"react-datepicker__year-option",key:"upcoming",onClick:n.incrementYears},React__default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"}))),o&&n.state.yearsList.find((function(e){return e===o}))||r.push(React__default.createElement("div",{className:"react-datepicker__year-option",key:"previous",onClick:n.decrementYears},React__default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"}))),r})),ye(ke(n),"onChange",(function(e){n.props.onChange(e);})),ye(ke(n),"handleClickOutside",(function(){n.props.onCancel();})),ye(ke(n),"shiftYears",(function(e){var t=n.state.yearsList.map((function(t){return t+e}));n.setState({yearsList:t});})),ye(ke(n),"incrementYears",(function(){return n.shiftYears(1)})),ye(ke(n),"decrementYears",(function(){return n.shiftYears(-1)}));var s=r.yearDropdownItemNumber,i=r.scrollableYearDropdown,p=s||(i?10:5);return n.state={yearsList:St(n.props.year,p,n.props.minDate,n.props.maxDate)},n.dropdownRef=createRef(),n}return fe(a,[{key:"componentDidMount",value:function(){var e=this.dropdownRef.current;if(e){var t=e.children?Array.from(e.children):null,r=t?t.find((function(e){return e.ariaSelected})):null;e.scrollTop=r?r.offsetTop+(r.clientHeight-e.clientHeight)/2:(e.scrollHeight-e.clientHeight)/2;}}},{key:"render",value:function(){var t=cls({"react-datepicker__year-dropdown":!0,"react-datepicker__year-dropdown--scrollable":this.props.scrollableYearDropdown});return React__default.createElement("div",{className:t,ref:this.dropdownRef},this.renderOptions())}}]),a}()),_t=function(t){De(n,React__default.Component);var r=be(n);function n(){var t;he(this,n);for(var o=arguments.length,a=new Array(o),s=0;s<o;s++)a[s]=arguments[s];return ye(ke(t=r.call.apply(r,[this].concat(a))),"state",{dropdownVisible:!1}),ye(ke(t),"renderSelectOptions",(function(){for(var r=t.props.minDate?getYear(t.props.minDate):1900,n=t.props.maxDate?getYear(t.props.maxDate):2100,o=[],a=r;a<=n;a++)o.push(React__default.createElement("option",{key:a,value:a},a));return o})),ye(ke(t),"onSelectChange",(function(e){t.onChange(e.target.value);})),ye(ke(t),"renderSelectMode",(function(){return React__default.createElement("select",{value:t.props.year,className:"react-datepicker__year-select",onChange:t.onSelectChange},t.renderSelectOptions())})),ye(ke(t),"renderReadView",(function(r){return React__default.createElement("div",{key:"read",style:{visibility:r?"visible":"hidden"},className:"react-datepicker__year-read-view",onClick:function(e){return t.toggleDropdown(e)}},React__default.createElement("span",{className:"react-datepicker__year-read-view--down-arrow"}),React__default.createElement("span",{className:"react-datepicker__year-read-view--selected-year"},t.props.year))})),ye(ke(t),"renderDropdown",(function(){return React__default.createElement(Ct,{key:"dropdown",year:t.props.year,onChange:t.onChange,onCancel:t.toggleDropdown,minDate:t.props.minDate,maxDate:t.props.maxDate,scrollableYearDropdown:t.props.scrollableYearDropdown,yearDropdownItemNumber:t.props.yearDropdownItemNumber})})),ye(ke(t),"renderScrollMode",(function(){var e=t.state.dropdownVisible,r=[t.renderReadView(!e)];return e&&r.unshift(t.renderDropdown()),r})),ye(ke(t),"onChange",(function(e){t.toggleDropdown(),e!==t.props.year&&t.props.onChange(e);})),ye(ke(t),"toggleDropdown",(function(e){t.setState({dropdownVisible:!t.state.dropdownVisible},(function(){t.props.adjustDateOnChange&&t.handleYearChange(t.props.date,e);}));})),ye(ke(t),"handleYearChange",(function(e,r){t.onSelect(e,r),t.setOpen();})),ye(ke(t),"onSelect",(function(e,r){t.props.onSelect&&t.props.onSelect(e,r);})),ye(ke(t),"setOpen",(function(){t.props.setOpen&&t.props.setOpen(!0);})),t}return fe(n,[{key:"render",value:function(){var t;switch(this.props.dropdownMode){case"scroll":t=this.renderScrollMode();break;case"select":t=this.renderSelectMode();}return React__default.createElement("div",{className:"react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)},t)}}]),n}(),Mt=onClickOutsideHOC(function(t){De(n,React__default.Component);var r=be(n);function n(){var t;he(this,n);for(var o=arguments.length,a=new Array(o),s=0;s<o;s++)a[s]=arguments[s];return ye(ke(t=r.call.apply(r,[this].concat(a))),"isSelectedMonth",(function(e){return t.props.month===e})),ye(ke(t),"renderOptions",(function(){return t.props.monthNames.map((function(r,n){return React__default.createElement("div",{className:t.isSelectedMonth(n)?"react-datepicker__month-option react-datepicker__month-option--selected_month":"react-datepicker__month-option",key:r,onClick:t.onChange.bind(ke(t),n),"aria-selected":t.isSelectedMonth(n)?"true":void 0},t.isSelectedMonth(n)?React__default.createElement("span",{className:"react-datepicker__month-option--selected"},"✓"):"",r)}))})),ye(ke(t),"onChange",(function(e){return t.props.onChange(e)})),ye(ke(t),"handleClickOutside",(function(){return t.props.onCancel()})),t}return fe(n,[{key:"render",value:function(){return React__default.createElement("div",{className:"react-datepicker__month-dropdown"},this.renderOptions())}}]),n}()),Et=function(t){De(n,React__default.Component);var r=be(n);function n(){var t;he(this,n);for(var o=arguments.length,a=new Array(o),s=0;s<o;s++)a[s]=arguments[s];return ye(ke(t=r.call.apply(r,[this].concat(a))),"state",{dropdownVisible:!1}),ye(ke(t),"renderSelectOptions",(function(t){return t.map((function(t,r){return React__default.createElement("option",{key:r,value:r},t)}))})),ye(ke(t),"renderSelectMode",(function(r){return React__default.createElement("select",{value:t.props.month,className:"react-datepicker__month-select",onChange:function(e){return t.onChange(e.target.value)}},t.renderSelectOptions(r))})),ye(ke(t),"renderReadView",(function(r,n){return React__default.createElement("div",{key:"read",style:{visibility:r?"visible":"hidden"},className:"react-datepicker__month-read-view",onClick:t.toggleDropdown},React__default.createElement("span",{className:"react-datepicker__month-read-view--down-arrow"}),React__default.createElement("span",{className:"react-datepicker__month-read-view--selected-month"},n[t.props.month]))})),ye(ke(t),"renderDropdown",(function(r){return React__default.createElement(Mt,{key:"dropdown",month:t.props.month,monthNames:r,onChange:t.onChange,onCancel:t.toggleDropdown})})),ye(ke(t),"renderScrollMode",(function(e){var r=t.state.dropdownVisible,n=[t.renderReadView(!r,e)];return r&&n.unshift(t.renderDropdown(e)),n})),ye(ke(t),"onChange",(function(e){t.toggleDropdown(),e!==t.props.month&&t.props.onChange(e);})),ye(ke(t),"toggleDropdown",(function(){return t.setState({dropdownVisible:!t.state.dropdownVisible})})),t}return fe(n,[{key:"render",value:function(){var t,r=this,n=[0,1,2,3,4,5,6,7,8,9,10,11].map(this.props.useShortMonthInDropdown?function(e){return Xe(e,r.props.locale)}:function(e){return Je(e,r.props.locale)});switch(this.props.dropdownMode){case"scroll":t=this.renderScrollMode(n);break;case"select":t=this.renderSelectMode(n);}return React__default.createElement("div",{className:"react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)},t)}}]),n}();function Pt(e,t){for(var r=[],n=Fe(e),o=Fe(t);!isAfter(n,o);)r.push(Ye(n)),n=addMonths(n,1);return r}var Nt,xt=onClickOutsideHOC(function(t){De(o,React__default.Component);var n=be(o);function o(t){var r;return he(this,o),ye(ke(r=n.call(this,t)),"renderOptions",(function(){return r.state.monthYearsList.map((function(t){var n=getTime(t),o=Qe(r.props.date,t)&&He(r.props.date,t);return React__default.createElement("div",{className:o?"react-datepicker__month-year-option--selected_month-year":"react-datepicker__month-year-option",key:n,onClick:r.onChange.bind(ke(r),n),"aria-selected":o?"true":void 0},o?React__default.createElement("span",{className:"react-datepicker__month-year-option--selected"},"✓"):"",Ie(t,r.props.dateFormat,r.props.locale))}))})),ye(ke(r),"onChange",(function(e){return r.props.onChange(e)})),ye(ke(r),"handleClickOutside",(function(){r.props.onCancel();})),r.state={monthYearsList:Pt(r.props.minDate,r.props.maxDate)},r}return fe(o,[{key:"render",value:function(){var t=cls({"react-datepicker__month-year-dropdown":!0,"react-datepicker__month-year-dropdown--scrollable":this.props.scrollableMonthYearDropdown});return React__default.createElement("div",{className:t},this.renderOptions())}}]),o}()),Yt=function(t){De(n,React__default.Component);var r=be(n);function n(){var t;he(this,n);for(var o=arguments.length,a=new Array(o),s=0;s<o;s++)a[s]=arguments[s];return ye(ke(t=r.call.apply(r,[this].concat(a))),"state",{dropdownVisible:!1}),ye(ke(t),"renderSelectOptions",(function(){for(var r=Fe(t.props.minDate),n=Fe(t.props.maxDate),o=[];!isAfter(r,n);){var a=getTime(r);o.push(React__default.createElement("option",{key:a,value:a},Ie(r,t.props.dateFormat,t.props.locale))),r=addMonths(r,1);}return o})),ye(ke(t),"onSelectChange",(function(e){t.onChange(e.target.value);})),ye(ke(t),"renderSelectMode",(function(){return React__default.createElement("select",{value:getTime(Fe(t.props.date)),className:"react-datepicker__month-year-select",onChange:t.onSelectChange},t.renderSelectOptions())})),ye(ke(t),"renderReadView",(function(r){var n=Ie(t.props.date,t.props.dateFormat,t.props.locale);return React__default.createElement("div",{key:"read",style:{visibility:r?"visible":"hidden"},className:"react-datepicker__month-year-read-view",onClick:function(e){return t.toggleDropdown(e)}},React__default.createElement("span",{className:"react-datepicker__month-year-read-view--down-arrow"}),React__default.createElement("span",{className:"react-datepicker__month-year-read-view--selected-month-year"},n))})),ye(ke(t),"renderDropdown",(function(){return React__default.createElement(xt,{key:"dropdown",date:t.props.date,dateFormat:t.props.dateFormat,onChange:t.onChange,onCancel:t.toggleDropdown,minDate:t.props.minDate,maxDate:t.props.maxDate,scrollableMonthYearDropdown:t.props.scrollableMonthYearDropdown,locale:t.props.locale})})),ye(ke(t),"renderScrollMode",(function(){var e=t.state.dropdownVisible,r=[t.renderReadView(!e)];return e&&r.unshift(t.renderDropdown()),r})),ye(ke(t),"onChange",(function(e){t.toggleDropdown();var r=Ye(parseInt(e));Qe(t.props.date,r)&&He(t.props.date,r)||t.props.onChange(r);})),ye(ke(t),"toggleDropdown",(function(){return t.setState({dropdownVisible:!t.state.dropdownVisible})})),t}return fe(n,[{key:"render",value:function(){var t;switch(this.props.dropdownMode){case"scroll":t=this.renderScrollMode();break;case"select":t=this.renderSelectMode();}return React__default.createElement("div",{className:"react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)},t)}}]),n}(),Tt=function(t){De(o,React__default.Component);var n=be(o);function o(){var t;he(this,o);for(var a=arguments.length,s=new Array(a),i=0;i<a;i++)s[i]=arguments[i];return ye(ke(t=n.call.apply(n,[this].concat(s))),"dayEl",React__default.createRef()),ye(ke(t),"handleClick",(function(e){!t.isDisabled()&&t.props.onClick&&t.props.onClick(e);})),ye(ke(t),"handleMouseEnter",(function(e){!t.isDisabled()&&t.props.onMouseEnter&&t.props.onMouseEnter(e);})),ye(ke(t),"handleOnKeyDown",(function(e){" "===e.key&&(e.preventDefault(),e.key="Enter"),t.props.handleOnKeyDown(e);})),ye(ke(t),"isSameDay",(function(e){return We(t.props.day,e)})),ye(ke(t),"isKeyboardSelected",(function(){return !t.props.disabledKeyboardNavigation&&!t.isSameDay(t.props.selected)&&t.isSameDay(t.props.preSelection)})),ye(ke(t),"isDisabled",(function(){return Ze(t.props.day,t.props)})),ye(ke(t),"isExcluded",(function(){return et(t.props.day,t.props)})),ye(ke(t),"getHighLightedClass",(function(){var e=t.props,r=e.day,n=e.highlightDates;if(!n)return !1;var o=Ie(r,"MM.dd.yyyy");return n.get(o)})),ye(ke(t),"getHolidaysClass",(function(){var e=t.props,r=e.day,n=e.holidays;if(!n)return !1;var o=Ie(r,"MM.dd.yyyy");return n.has(o)?[n.get(o).className]:void 0})),ye(ke(t),"isInRange",(function(){var e=t.props,r=e.day,n=e.startDate,o=e.endDate;return !(!n||!o)&&qe(r,n,o)})),ye(ke(t),"isInSelectingRange",(function(){var e,r=t.props,n=r.day,o=r.selectsStart,a=r.selectsEnd,s=r.selectsRange,i=r.selectsDisabledDaysInRange,p=r.startDate,c=r.endDate,l=null!==(e=t.props.selectingDate)&&void 0!==e?e:t.props.preSelection;return !(!(o||a||s)||!l||!i&&t.isDisabled())&&(o&&c&&(isBefore(l,c)||Ve(l,c))?qe(n,l,c):(a&&p&&(isAfter(l,p)||Ve(l,p))||!(!s||!p||c||!isAfter(l,p)&&!Ve(l,p)))&&qe(n,p,l))})),ye(ke(t),"isSelectingRangeStart",(function(){var e;if(!t.isInSelectingRange())return !1;var r=t.props,n=r.day,o=r.startDate,a=r.selectsStart,s=null!==(e=t.props.selectingDate)&&void 0!==e?e:t.props.preSelection;return We(n,a?s:o)})),ye(ke(t),"isSelectingRangeEnd",(function(){var e;if(!t.isInSelectingRange())return !1;var r=t.props,n=r.day,o=r.endDate,a=r.selectsEnd,s=r.selectsRange,i=null!==(e=t.props.selectingDate)&&void 0!==e?e:t.props.preSelection;return We(n,a||s?i:o)})),ye(ke(t),"isRangeStart",(function(){var e=t.props,r=e.day,n=e.startDate,o=e.endDate;return !(!n||!o)&&We(n,r)})),ye(ke(t),"isRangeEnd",(function(){var e=t.props,r=e.day,n=e.startDate,o=e.endDate;return !(!n||!o)&&We(o,r)})),ye(ke(t),"isWeekend",(function(){var e=getDay(t.props.day);return 0===e||6===e})),ye(ke(t),"isAfterMonth",(function(){return void 0!==t.props.month&&(t.props.month+1)%12===getMonth(t.props.day)})),ye(ke(t),"isBeforeMonth",(function(){return void 0!==t.props.month&&(getMonth(t.props.day)+1)%12===t.props.month})),ye(ke(t),"isCurrentDay",(function(){return t.isSameDay(Ye())})),ye(ke(t),"isSelected",(function(){return t.isSameDay(t.props.selected)})),ye(ke(t),"getClassNames",(function(e){var n,o=t.props.dayClassName?t.props.dayClassName(e):void 0;return cls("react-datepicker__day",o,"react-datepicker__day--"+Ie(t.props.day,"ddd",n),{"react-datepicker__day--disabled":t.isDisabled(),"react-datepicker__day--excluded":t.isExcluded(),"react-datepicker__day--selected":t.isSelected(),"react-datepicker__day--keyboard-selected":t.isKeyboardSelected(),"react-datepicker__day--range-start":t.isRangeStart(),"react-datepicker__day--range-end":t.isRangeEnd(),"react-datepicker__day--in-range":t.isInRange(),"react-datepicker__day--in-selecting-range":t.isInSelectingRange(),"react-datepicker__day--selecting-range-start":t.isSelectingRangeStart(),"react-datepicker__day--selecting-range-end":t.isSelectingRangeEnd(),"react-datepicker__day--today":t.isCurrentDay(),"react-datepicker__day--weekend":t.isWeekend(),"react-datepicker__day--outside-month":t.isAfterMonth()||t.isBeforeMonth()},t.getHighLightedClass("react-datepicker__day--highlighted"),t.getHolidaysClass())})),ye(ke(t),"getAriaLabel",(function(){var e=t.props,r=e.day,n=e.ariaLabelPrefixWhenEnabled,o=void 0===n?"Choose":n,a=e.ariaLabelPrefixWhenDisabled,s=void 0===a?"Not available":a,i=t.isDisabled()||t.isExcluded()?s:o;return "".concat(i," ").concat(Ie(r,"PPPP",t.props.locale))})),ye(ke(t),"getTitle",(function(){var e=t.props,r=e.day,n=e.holidays,o=void 0===n?new Map:n,a=Ie(r,"MM.dd.yyyy");return o.has(a)&&o.get(a).holidayNames.length>0?o.get(a).holidayNames.join(", "):""})),ye(ke(t),"getTabIndex",(function(e,r){var n=e||t.props.selected,o=r||t.props.preSelection;return t.isKeyboardSelected()||t.isSameDay(n)&&We(o,n)?0:-1})),ye(ke(t),"handleFocusDay",(function(){var e,r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n=!1;0===t.getTabIndex()&&!r.isInputFocused&&t.isSameDay(t.props.preSelection)&&(document.activeElement&&document.activeElement!==document.body||(n=!0),t.props.inline&&!t.props.shouldFocusDayInline&&(n=!1),t.props.containerRef&&t.props.containerRef.current&&t.props.containerRef.current.contains(document.activeElement)&&document.activeElement.classList.contains("react-datepicker__day")&&(n=!0),t.props.monthShowsDuplicateDaysEnd&&t.isAfterMonth()&&(n=!1),t.props.monthShowsDuplicateDaysStart&&t.isBeforeMonth()&&(n=!1)),n&&(null===(e=t.dayEl.current)||void 0===e||e.focus({preventScroll:!0}));})),ye(ke(t),"renderDayContents",(function(){return t.props.monthShowsDuplicateDaysEnd&&t.isAfterMonth()||t.props.monthShowsDuplicateDaysStart&&t.isBeforeMonth()?null:t.props.renderDayContents?t.props.renderDayContents(getDate(t.props.day),t.props.day):getDate(t.props.day)})),ye(ke(t),"render",(function(){return React__default.createElement("div",{ref:t.dayEl,className:t.getClassNames(t.props.day),onKeyDown:t.handleOnKeyDown,onClick:t.handleClick,onMouseEnter:t.handleMouseEnter,tabIndex:t.getTabIndex(),"aria-label":t.getAriaLabel(),role:"option",title:t.getTitle(),"aria-disabled":t.isDisabled(),"aria-current":t.isCurrentDay()?"date":void 0,"aria-selected":t.isSelected()||t.isInRange()},t.renderDayContents(),""!==t.getTitle()&&React__default.createElement("span",{className:"holiday-overlay"},t.getTitle()))})),t}return fe(o,[{key:"componentDidMount",value:function(){this.handleFocusDay();}},{key:"componentDidUpdate",value:function(e){this.handleFocusDay(e);}}]),o}(),It=function(t){De(o,React__default.Component);var n=be(o);function o(){var e;he(this,o);for(var t=arguments.length,r=new Array(t),a=0;a<t;a++)r[a]=arguments[a];return ye(ke(e=n.call.apply(n,[this].concat(r))),"handleClick",(function(t){e.props.onClick&&e.props.onClick(t);})),e}return fe(o,[{key:"render",value:function(){var t=this.props,n=t.weekNumber,o=t.ariaLabelPrefix,a=void 0===o?"week ":o,s={"react-datepicker__week-number":!0,"react-datepicker__week-number--clickable":!!t.onClick};return React__default.createElement("div",{className:cls(s),"aria-label":"".concat(a," ").concat(this.props.weekNumber),onClick:this.handleClick},n)}}],[{key:"defaultProps",get:function(){return {ariaLabelPrefix:"week "}}}]),o}(),Ot=function(t){De(n,React__default.Component);var r=be(n);function n(){var t;he(this,n);for(var o=arguments.length,a=new Array(o),s=0;s<o;s++)a[s]=arguments[s];return ye(ke(t=r.call.apply(r,[this].concat(a))),"handleDayClick",(function(e,r){t.props.onDayClick&&t.props.onDayClick(e,r);})),ye(ke(t),"handleDayMouseEnter",(function(e){t.props.onDayMouseEnter&&t.props.onDayMouseEnter(e);})),ye(ke(t),"handleWeekClick",(function(e,r,n){"function"==typeof t.props.onWeekSelect&&t.props.onWeekSelect(e,r,n),t.props.shouldCloseOnSelect&&t.props.setOpen(!1);})),ye(ke(t),"formatWeekNumber",(function(e){return t.props.formatWeekNumber?t.props.formatWeekNumber(e):function(e,t){var r=t&&Ge(t)||$e()&&Ge($e());return getISOWeek(e,r?{locale:r}:null)}(e)})),ye(ke(t),"renderDays",(function(){var r=Le(t.props.day,t.props.locale,t.props.calendarStartDay),n=[],o=t.formatWeekNumber(r);if(t.props.showWeekNumber){var a=t.props.onWeekSelect?t.handleWeekClick.bind(ke(t),r,o):void 0;n.push(React__default.createElement(It,{key:"W",weekNumber:o,onClick:a,ariaLabelPrefix:t.props.ariaLabelPrefix}));}return n.concat([0,1,2,3,4,5,6].map((function(n){var o=addDays(r,n);return React__default.createElement(Tt,{ariaLabelPrefixWhenEnabled:t.props.chooseDayAriaLabelPrefix,ariaLabelPrefixWhenDisabled:t.props.disabledDayAriaLabelPrefix,key:o.valueOf(),day:o,month:t.props.month,onClick:t.handleDayClick.bind(ke(t),o),onMouseEnter:t.handleDayMouseEnter.bind(ke(t),o),minDate:t.props.minDate,maxDate:t.props.maxDate,excludeDates:t.props.excludeDates,excludeDateIntervals:t.props.excludeDateIntervals,includeDates:t.props.includeDates,includeDateIntervals:t.props.includeDateIntervals,highlightDates:t.props.highlightDates,holidays:t.props.holidays,selectingDate:t.props.selectingDate,filterDate:t.props.filterDate,preSelection:t.props.preSelection,selected:t.props.selected,selectsStart:t.props.selectsStart,selectsEnd:t.props.selectsEnd,selectsRange:t.props.selectsRange,selectsDisabledDaysInRange:t.props.selectsDisabledDaysInRange,startDate:t.props.startDate,endDate:t.props.endDate,dayClassName:t.props.dayClassName,renderDayContents:t.props.renderDayContents,disabledKeyboardNavigation:t.props.disabledKeyboardNavigation,handleOnKeyDown:t.props.handleOnKeyDown,isInputFocused:t.props.isInputFocused,containerRef:t.props.containerRef,inline:t.props.inline,shouldFocusDayInline:t.props.shouldFocusDayInline,monthShowsDuplicateDaysEnd:t.props.monthShowsDuplicateDaysEnd,monthShowsDuplicateDaysStart:t.props.monthShowsDuplicateDaysStart,locale:t.props.locale})})))})),t}return fe(n,[{key:"render",value:function(){return React__default.createElement("div",{className:"react-datepicker__week"},this.renderDays())}}],[{key:"defaultProps",get:function(){return {shouldCloseOnSelect:!0}}}]),n}(),Rt="two_columns",Lt="three_columns",Ft="four_columns",At=(ye(Nt={},Rt,{grid:[[0,1],[2,3],[4,5],[6,7],[8,9],[10,11]],verticalNavigationOffset:2}),ye(Nt,Lt,{grid:[[0,1,2],[3,4,5],[6,7,8],[9,10,11]],verticalNavigationOffset:3}),ye(Nt,Ft,{grid:[[0,1,2,3],[4,5,6,7],[8,9,10,11]],verticalNavigationOffset:4}),Nt);function Kt(e,t){return e?Ft:t?Rt:Lt}var Bt=function(t){De(o,React__default.Component);var n=be(o);function o(){var t;he(this,o);for(var a=arguments.length,s=new Array(a),i=0;i<a;i++)s[i]=arguments[i];return ye(ke(t=n.call.apply(n,[this].concat(s))),"MONTH_REFS",Se(Array(12)).map((function(){return React__default.createRef()}))),ye(ke(t),"QUARTER_REFS",Se(Array(4)).map((function(){return React__default.createRef()}))),ye(ke(t),"isDisabled",(function(e){return Ze(e,t.props)})),ye(ke(t),"isExcluded",(function(e){return et(e,t.props)})),ye(ke(t),"handleDayClick",(function(e,r){t.props.onDayClick&&t.props.onDayClick(e,r,t.props.orderInDisplay);})),ye(ke(t),"handleDayMouseEnter",(function(e){t.props.onDayMouseEnter&&t.props.onDayMouseEnter(e);})),ye(ke(t),"handleMouseLeave",(function(){t.props.onMouseLeave&&t.props.onMouseLeave();})),ye(ke(t),"isRangeStartMonth",(function(e){var r=t.props,n=r.day,o=r.startDate,a=r.endDate;return !(!o||!a)&&He(setMonth(n,e),o)})),ye(ke(t),"isRangeStartQuarter",(function(e){var r=t.props,n=r.day,o=r.startDate,a=r.endDate;return !(!o||!a)&&je(setQuarter(n,e),o)})),ye(ke(t),"isRangeEndMonth",(function(e){var r=t.props,n=r.day,o=r.startDate,a=r.endDate;return !(!o||!a)&&He(setMonth(n,e),a)})),ye(ke(t),"isRangeEndQuarter",(function(e){var r=t.props,n=r.day,o=r.startDate,a=r.endDate;return !(!o||!a)&&je(setQuarter(n,e),a)})),ye(ke(t),"isInSelectingRangeMonth",(function(e){var r,n=t.props,o=n.day,a=n.selectsStart,s=n.selectsEnd,i=n.selectsRange,p=n.startDate,c=n.endDate,l=null!==(r=t.props.selectingDate)&&void 0!==r?r:t.props.preSelection;return !(!(a||s||i)||!l)&&(a&&c?rt(l,c,e,o):(s&&p||!(!i||!p||c))&&rt(p,l,e,o))})),ye(ke(t),"isSelectingMonthRangeStart",(function(e){var r;if(!t.isInSelectingRangeMonth(e))return !1;var n=t.props,o=n.day,a=n.startDate,s=n.selectsStart,i=setMonth(o,e),p=null!==(r=t.props.selectingDate)&&void 0!==r?r:t.props.preSelection;return He(i,s?p:a)})),ye(ke(t),"isSelectingMonthRangeEnd",(function(e){var r;if(!t.isInSelectingRangeMonth(e))return !1;var n=t.props,o=n.day,a=n.endDate,s=n.selectsEnd,i=n.selectsRange,p=setMonth(o,e),c=null!==(r=t.props.selectingDate)&&void 0!==r?r:t.props.preSelection;return He(p,s||i?c:a)})),ye(ke(t),"isInSelectingRangeQuarter",(function(e){var r,n=t.props,o=n.day,a=n.selectsStart,s=n.selectsEnd,i=n.selectsRange,p=n.startDate,c=n.endDate,l=null!==(r=t.props.selectingDate)&&void 0!==r?r:t.props.preSelection;return !(!(a||s||i)||!l)&&(a&&c?st(l,c,e,o):(s&&p||!(!i||!p||c))&&st(p,l,e,o))})),ye(ke(t),"isWeekInMonth",(function(e){var r=t.props.day,n=addDays(e,6);return He(e,r)||He(n,r)})),ye(ke(t),"isCurrentMonth",(function(e,t){return getYear(e)===getYear(Ye())&&t===getMonth(Ye())})),ye(ke(t),"isCurrentQuarter",(function(e,t){return getYear(e)===getYear(Ye())&&t===getQuarter(Ye())})),ye(ke(t),"isSelectedMonth",(function(e,t,r){return getMonth(r)===t&&getYear(e)===getYear(r)})),ye(ke(t),"isSelectedQuarter",(function(e,t,r){return getQuarter(e)===t&&getYear(e)===getYear(r)})),ye(ke(t),"renderWeeks",(function(){for(var r=[],n=t.props.fixedHeight,o=0,a=!1,s=Le(Fe(t.props.day),t.props.locale,t.props.calendarStartDay);r.push(React__default.createElement(Ot,{ariaLabelPrefix:t.props.weekAriaLabelPrefix,chooseDayAriaLabelPrefix:t.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:t.props.disabledDayAriaLabelPrefix,key:o,day:s,month:getMonth(t.props.day),onDayClick:t.handleDayClick,onDayMouseEnter:t.handleDayMouseEnter,onWeekSelect:t.props.onWeekSelect,formatWeekNumber:t.props.formatWeekNumber,locale:t.props.locale,minDate:t.props.minDate,maxDate:t.props.maxDate,excludeDates:t.props.excludeDates,excludeDateIntervals:t.props.excludeDateIntervals,includeDates:t.props.includeDates,includeDateIntervals:t.props.includeDateIntervals,inline:t.props.inline,shouldFocusDayInline:t.props.shouldFocusDayInline,highlightDates:t.props.highlightDates,holidays:t.props.holidays,selectingDate:t.props.selectingDate,filterDate:t.props.filterDate,preSelection:t.props.preSelection,selected:t.props.selected,selectsStart:t.props.selectsStart,selectsEnd:t.props.selectsEnd,selectsRange:t.props.selectsRange,selectsDisabledDaysInRange:t.props.selectsDisabledDaysInRange,showWeekNumber:t.props.showWeekNumbers,startDate:t.props.startDate,endDate:t.props.endDate,dayClassName:t.props.dayClassName,setOpen:t.props.setOpen,shouldCloseOnSelect:t.props.shouldCloseOnSelect,disabledKeyboardNavigation:t.props.disabledKeyboardNavigation,renderDayContents:t.props.renderDayContents,handleOnKeyDown:t.props.handleOnKeyDown,isInputFocused:t.props.isInputFocused,containerRef:t.props.containerRef,calendarStartDay:t.props.calendarStartDay,monthShowsDuplicateDaysEnd:t.props.monthShowsDuplicateDaysEnd,monthShowsDuplicateDaysStart:t.props.monthShowsDuplicateDaysStart})),!a;){o++,s=addWeeks(s,1);var i=n&&o>=6,p=!n&&!t.isWeekInMonth(s);if(i||p){if(!t.props.peekNextMonth)break;a=!0;}}return r})),ye(ke(t),"onMonthClick",(function(e,r){t.handleDayClick(Fe(setMonth(t.props.day,r)),e);})),ye(ke(t),"onMonthMouseEnter",(function(e){t.handleDayMouseEnter(Fe(setMonth(t.props.day,e)));})),ye(ke(t),"handleMonthNavigation",(function(e,r){t.isDisabled(r)||t.isExcluded(r)||(t.props.setPreSelection(r),t.MONTH_REFS[e].current&&t.MONTH_REFS[e].current.focus());})),ye(ke(t),"onMonthKeyDown",(function(e,r){var n=t.props,o=n.selected,a=n.preSelection,s=n.disabledKeyboardNavigation,i=n.showTwoColumnMonthYearPicker,p=n.showFourColumnMonthYearPicker,c=n.setPreSelection,d=e.key;if("Tab"!==d&&e.preventDefault(),!s){var u=Kt(p,i),h=At[u].verticalNavigationOffset,m=At[u].grid;switch(d){case"Enter":t.onMonthClick(e,r),c(o);break;case"ArrowRight":t.handleMonthNavigation(11===r?0:r+1,addMonths(a,1));break;case"ArrowLeft":t.handleMonthNavigation(0===r?11:r-1,subMonths(a,1));break;case"ArrowUp":t.handleMonthNavigation(m[0].includes(r)?r+12-h:r-h,subMonths(a,h));break;case"ArrowDown":t.handleMonthNavigation(m[m.length-1].includes(r)?r-12+h:r+h,addMonths(a,h));}}})),ye(ke(t),"onQuarterClick",(function(e,r){t.handleDayClick(Ke(setQuarter(t.props.day,r)),e);})),ye(ke(t),"onQuarterMouseEnter",(function(e){t.handleDayMouseEnter(Ke(setQuarter(t.props.day,e)));})),ye(ke(t),"handleQuarterNavigation",(function(e,r){t.isDisabled(r)||t.isExcluded(r)||(t.props.setPreSelection(r),t.QUARTER_REFS[e-1].current&&t.QUARTER_REFS[e-1].current.focus());})),ye(ke(t),"onQuarterKeyDown",(function(e,r){var n=e.key;if(!t.props.disabledKeyboardNavigation)switch(n){case"Enter":t.onQuarterClick(e,r),t.props.setPreSelection(t.props.selected);break;case"ArrowRight":t.handleQuarterNavigation(4===r?1:r+1,addQuarters(t.props.preSelection,1));break;case"ArrowLeft":t.handleQuarterNavigation(1===r?4:r-1,subQuarters(t.props.preSelection,1));}})),ye(ke(t),"getMonthClassNames",(function(e){var n=t.props,o=n.day,a=n.startDate,s=n.endDate,i=n.selected,p=n.minDate,c=n.maxDate,l=n.preSelection,d=n.monthClassName,u=n.excludeDates,h=n.includeDates,m=d?d(setMonth(o,e)):void 0,f=setMonth(o,e);return cls("react-datepicker__month-text","react-datepicker__month-".concat(e),m,{"react-datepicker__month-text--disabled":(p||c||u||h)&&tt(f,t.props),"react-datepicker__month-text--selected":t.isSelectedMonth(o,e,i),"react-datepicker__month-text--keyboard-selected":!t.props.disabledKeyboardNavigation&&getMonth(l)===e,"react-datepicker__month-text--in-selecting-range":t.isInSelectingRangeMonth(e),"react-datepicker__month-text--in-range":rt(a,s,e,o),"react-datepicker__month-text--range-start":t.isRangeStartMonth(e),"react-datepicker__month-text--range-end":t.isRangeEndMonth(e),"react-datepicker__month-text--selecting-range-start":t.isSelectingMonthRangeStart(e),"react-datepicker__month-text--selecting-range-end":t.isSelectingMonthRangeEnd(e),"react-datepicker__month-text--today":t.isCurrentMonth(o,e)})})),ye(ke(t),"getTabIndex",(function(e){var r=getMonth(t.props.preSelection);return t.props.disabledKeyboardNavigation||e!==r?"-1":"0"})),ye(ke(t),"getQuarterTabIndex",(function(e){var r=getQuarter(t.props.preSelection);return t.props.disabledKeyboardNavigation||e!==r?"-1":"0"})),ye(ke(t),"getAriaLabel",(function(e){var r=t.props,n=r.chooseDayAriaLabelPrefix,o=void 0===n?"Choose":n,a=r.disabledDayAriaLabelPrefix,s=void 0===a?"Not available":a,i=r.day,p=setMonth(i,e),c=t.isDisabled(p)||t.isExcluded(p)?s:o;return "".concat(c," ").concat(Ie(p,"MMMM yyyy"))})),ye(ke(t),"getQuarterClassNames",(function(e){var n=t.props,o=n.day,a=n.startDate,s=n.endDate,i=n.selected,p=n.minDate,c=n.maxDate,l=n.preSelection;return cls("react-datepicker__quarter-text","react-datepicker__quarter-".concat(e),{"react-datepicker__quarter-text--disabled":(p||c)&&nt(setQuarter(o,e),t.props),"react-datepicker__quarter-text--selected":t.isSelectedQuarter(o,e,i),"react-datepicker__quarter-text--keyboard-selected":getQuarter(l)===e,"react-datepicker__quarter-text--in-selecting-range":t.isInSelectingRangeQuarter(e),"react-datepicker__quarter-text--in-range":st(a,s,e,o),"react-datepicker__quarter-text--range-start":t.isRangeStartQuarter(e),"react-datepicker__quarter-text--range-end":t.isRangeEndQuarter(e)})})),ye(ke(t),"getMonthContent",(function(e){var r=t.props,n=r.showFullMonthYearPicker,o=r.renderMonthContent,a=r.locale,s=Xe(e,a),i=Je(e,a);return o?o(e,s,i):n?i:s})),ye(ke(t),"getQuarterContent",(function(e){var r=t.props,n=r.renderQuarterContent,o=function(e,t){return Ie(setQuarter(Ye(),e),"QQQ",t)}(e,r.locale);return n?n(e,o):o})),ye(ke(t),"renderMonths",(function(){var r=t.props,n=r.showTwoColumnMonthYearPicker,o=r.showFourColumnMonthYearPicker,a=r.day,s=r.selected;return At[Kt(o,n)].grid.map((function(r,n){return React__default.createElement("div",{className:"react-datepicker__month-wrapper",key:n},r.map((function(r,n){return React__default.createElement("div",{ref:t.MONTH_REFS[r],key:n,onClick:function(e){t.onMonthClick(e,r);},onKeyDown:function(e){t.onMonthKeyDown(e,r);},onMouseEnter:function(){return t.onMonthMouseEnter(r)},tabIndex:t.getTabIndex(r),className:t.getMonthClassNames(r),role:"option","aria-label":t.getAriaLabel(r),"aria-current":t.isCurrentMonth(a,r)?"date":void 0,"aria-selected":t.isSelectedMonth(a,r,s)},t.getMonthContent(r))})))}))})),ye(ke(t),"renderQuarters",(function(){var r=t.props,n=r.day,o=r.selected;return React__default.createElement("div",{className:"react-datepicker__quarter-wrapper"},[1,2,3,4].map((function(r,a){return React__default.createElement("div",{key:a,ref:t.QUARTER_REFS[a],role:"option",onClick:function(e){t.onQuarterClick(e,r);},onKeyDown:function(e){t.onQuarterKeyDown(e,r);},onMouseEnter:function(){return t.onQuarterMouseEnter(r)},className:t.getQuarterClassNames(r),"aria-selected":t.isSelectedQuarter(n,r,o),tabIndex:t.getQuarterTabIndex(r),"aria-current":t.isCurrentQuarter(n,r)?"date":void 0},t.getQuarterContent(r))})))})),ye(ke(t),"getClassNames",(function(){var e=t.props,n=e.selectingDate,o=e.selectsStart,a=e.selectsEnd,s=e.showMonthYearPicker,i=e.showQuarterYearPicker;return cls("react-datepicker__month",{"react-datepicker__month--selecting-range":n&&(o||a)},{"react-datepicker__monthPicker":s},{"react-datepicker__quarterPicker":i})})),t}return fe(o,[{key:"render",value:function(){var t=this.props,r=t.showMonthYearPicker,n=t.showQuarterYearPicker,o=t.day,a=t.ariaLabelPrefix,s=void 0===a?"month ":a;return React__default.createElement("div",{className:this.getClassNames(),onMouseLeave:this.handleMouseLeave,"aria-label":"".concat(s," ").concat(Ie(o,"yyyy-MM")),role:"listbox"},r?this.renderMonths():n?this.renderQuarters():this.renderWeeks())}}]),o}(),Qt=function(t){De(n,React__default.Component);var r=be(n);function n(){var t;he(this,n);for(var o=arguments.length,a=new Array(o),i=0;i<o;i++)a[i]=arguments[i];return ye(ke(t=r.call.apply(r,[this].concat(a))),"state",{height:null}),ye(ke(t),"handleClick",(function(e){(t.props.minTime||t.props.maxTime)&&lt(e,t.props)||(t.props.excludeTimes||t.props.includeTimes||t.props.filterTime)&&ct(e,t.props)||t.props.onChange(e);})),ye(ke(t),"isSelectedTime",(function(e){return t.props.selected&&(r=t.props.selected,n=e,bt(r).getTime()===bt(n).getTime());var r,n;})),ye(ke(t),"liClasses",(function(e){var r=["react-datepicker__time-list-item",t.props.timeClassName?t.props.timeClassName(e):void 0];return t.isSelectedTime(e)&&r.push("react-datepicker__time-list-item--selected"),((t.props.minTime||t.props.maxTime)&&lt(e,t.props)||(t.props.excludeTimes||t.props.includeTimes||t.props.filterTime)&&ct(e,t.props))&&r.push("react-datepicker__time-list-item--disabled"),t.props.injectTimes&&(60*getHours(e)+getMinutes(e))%t.props.intervals!=0&&r.push("react-datepicker__time-list-item--injected"),r.join(" ")})),ye(ke(t),"handleOnKeyDown",(function(e,r){" "===e.key&&(e.preventDefault(),e.key="Enter"),"ArrowUp"!==e.key&&"ArrowLeft"!==e.key||!e.target.previousSibling||(e.preventDefault(),e.target.previousSibling.focus()),"ArrowDown"!==e.key&&"ArrowRight"!==e.key||!e.target.nextSibling||(e.preventDefault(),e.target.nextSibling.focus()),"Enter"===e.key&&t.handleClick(r),t.props.handleOnKeyDown(e);})),ye(ke(t),"renderTimes",(function(){for(var r=[],n=t.props.format?t.props.format:"p",o=t.props.intervals,a=t.props.selected||t.props.openToDate||Ye(),i=startOfDay(a),p=t.props.injectTimes&&t.props.injectTimes.sort((function(e,t){return e-t})),c=60*function(e){var t=new Date(e.getFullYear(),e.getMonth(),e.getDate()),r=new Date(e.getFullYear(),e.getMonth(),e.getDate(),24);return Math.round((+r-+t)/36e5)}(a),l=c/o,d=0;d<l;d++){var u=addMinutes(i,d*o);if(r.push(u),p){var h=gt(i,u,d,o,p);r=r.concat(h);}}var m=r.reduce((function(e,t){return t.getTime()<=a.getTime()?t:e}),r[0]);return r.map((function(r,o){return React__default.createElement("li",{key:o,onClick:t.handleClick.bind(ke(t),r),className:t.liClasses(r),ref:function(e){r===m&&(t.centerLi=e);},onKeyDown:function(e){t.handleOnKeyDown(e,r);},tabIndex:r===m?0:-1,role:"option","aria-selected":t.isSelectedTime(r)?"true":void 0},Ie(r,n,t.props.locale))}))})),t}return fe(n,[{key:"componentDidMount",value:function(){this.list.scrollTop=this.centerLi&&n.calcCenterPosition(this.props.monthRef?this.props.monthRef.clientHeight-this.header.clientHeight:this.list.clientHeight,this.centerLi),this.props.monthRef&&this.header&&this.setState({height:this.props.monthRef.clientHeight-this.header.clientHeight});}},{key:"render",value:function(){var t=this,r=this.state.height;return React__default.createElement("div",{className:"react-datepicker__time-container ".concat(this.props.todayButton?"react-datepicker__time-container--with-today-button":"")},React__default.createElement("div",{className:"react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly?"react-datepicker__header--time--only":""),ref:function(e){t.header=e;}},React__default.createElement("div",{className:"react-datepicker-time__header"},this.props.timeCaption)),React__default.createElement("div",{className:"react-datepicker__time"},React__default.createElement("div",{className:"react-datepicker__time-box"},React__default.createElement("ul",{className:"react-datepicker__time-list",ref:function(e){t.list=e;},style:r?{height:r}:{},role:"listbox","aria-label":this.props.timeCaption},this.renderTimes()))))}}],[{key:"defaultProps",get:function(){return {intervals:30,onTimeChange:function(){},todayButton:null,timeCaption:"Time"}}}]),n}();ye(Qt,"calcCenterPosition",(function(e,t){return t.offsetTop-(e/2-t.clientHeight/2)}));var Ht=function(t){De(o,React__default.Component);var n=be(o);function o(t){var a;return he(this,o),ye(ke(a=n.call(this,t)),"YEAR_REFS",Se(Array(a.props.yearItemNumber)).map((function(){return React__default.createRef()}))),ye(ke(a),"isDisabled",(function(e){return Ze(e,a.props)})),ye(ke(a),"isExcluded",(function(e){return et(e,a.props)})),ye(ke(a),"selectingDate",(function(){var e;return null!==(e=a.props.selectingDate)&&void 0!==e?e:a.props.preSelection})),ye(ke(a),"updateFocusOnPaginate",(function(e){var t=function(){this.YEAR_REFS[e].current.focus();}.bind(ke(a));window.requestAnimationFrame(t);})),ye(ke(a),"handleYearClick",(function(e,t){a.props.onDayClick&&a.props.onDayClick(e,t);})),ye(ke(a),"handleYearNavigation",(function(e,t){var r=a.props,n=r.date,o=r.yearItemNumber,s=kt(n,o).startPeriod;a.isDisabled(t)||a.isExcluded(t)||(a.props.setPreSelection(t),e-s==-1?a.updateFocusOnPaginate(o-1):e-s===o?a.updateFocusOnPaginate(0):a.YEAR_REFS[e-s].current.focus());})),ye(ke(a),"isSameDay",(function(e,t){return We(e,t)})),ye(ke(a),"isCurrentYear",(function(e){return e===getYear(Ye())})),ye(ke(a),"isRangeStart",(function(e){return a.props.startDate&&a.props.endDate&&Qe(setYear(Ye(),e),a.props.startDate)})),ye(ke(a),"isRangeEnd",(function(e){return a.props.startDate&&a.props.endDate&&Qe(setYear(Ye(),e),a.props.endDate)})),ye(ke(a),"isInRange",(function(e){return ot(e,a.props.startDate,a.props.endDate)})),ye(ke(a),"isInSelectingRange",(function(e){var t=a.props,r=t.selectsStart,n=t.selectsEnd,o=t.selectsRange,s=t.startDate,i=t.endDate;return !(!(r||n||o)||!a.selectingDate())&&(r&&i?ot(e,a.selectingDate(),i):(n&&s||!(!o||!s||i))&&ot(e,s,a.selectingDate()))})),ye(ke(a),"isSelectingRangeStart",(function(e){if(!a.isInSelectingRange(e))return !1;var t=a.props,r=t.startDate,n=t.selectsStart,o=setYear(Ye(),e);return Qe(o,n?a.selectingDate():r)})),ye(ke(a),"isSelectingRangeEnd",(function(e){if(!a.isInSelectingRange(e))return !1;var t=a.props,r=t.endDate,n=t.selectsEnd,o=t.selectsRange,s=setYear(Ye(),e);return Qe(s,n||o?a.selectingDate():r)})),ye(ke(a),"isKeyboardSelected",(function(e){var t=Ae(setYear(a.props.date,e));return !a.props.disabledKeyboardNavigation&&!a.props.inline&&!We(t,Ae(a.props.selected))&&We(t,Ae(a.props.preSelection))})),ye(ke(a),"onYearClick",(function(e,t){var r=a.props.date;a.handleYearClick(Ae(setYear(r,t)),e);})),ye(ke(a),"onYearKeyDown",(function(e,t){var r=e.key;if(!a.props.disabledKeyboardNavigation)switch(r){case"Enter":a.onYearClick(e,t),a.props.setPreSelection(a.props.selected);break;case"ArrowRight":a.handleYearNavigation(t+1,addYears(a.props.preSelection,1));break;case"ArrowLeft":a.handleYearNavigation(t-1,subYears(a.props.preSelection,1));}})),ye(ke(a),"getYearClassNames",(function(e){var t=a.props,n=t.minDate,o=t.maxDate,s=t.selected,i=t.excludeDates,p=t.includeDates,c=t.filterDate;return cls("react-datepicker__year-text",{"react-datepicker__year-text--selected":e===getYear(s),"react-datepicker__year-text--disabled":(n||o||i||p||c)&&at(e,a.props),"react-datepicker__year-text--keyboard-selected":a.isKeyboardSelected(e),"react-datepicker__year-text--range-start":a.isRangeStart(e),"react-datepicker__year-text--range-end":a.isRangeEnd(e),"react-datepicker__year-text--in-range":a.isInRange(e),"react-datepicker__year-text--in-selecting-range":a.isInSelectingRange(e),"react-datepicker__year-text--selecting-range-start":a.isSelectingRangeStart(e),"react-datepicker__year-text--selecting-range-end":a.isSelectingRangeEnd(e),"react-datepicker__year-text--today":a.isCurrentYear(e)})})),ye(ke(a),"getYearTabIndex",(function(e){return a.props.disabledKeyboardNavigation?"-1":e===getYear(a.props.preSelection)?"0":"-1"})),ye(ke(a),"getYearContainerClassNames",(function(){var e=a.props,t=e.selectingDate,n=e.selectsStart,o=e.selectsEnd,s=e.selectsRange;return cls("react-datepicker__year",{"react-datepicker__year--selecting-range":t&&(n||o||s)})})),ye(ke(a),"getYearContent",(function(e){return a.props.renderYearContent?a.props.renderYearContent(e):e})),a}return fe(o,[{key:"render",value:function(){for(var t=this,r=[],n=this.props,o=n.date,a=n.yearItemNumber,s=n.onYearMouseEnter,i=n.onYearMouseLeave,p=kt(o,a),c=p.startPeriod,l=p.endPeriod,d=function(n){r.push(React__default.createElement("div",{ref:t.YEAR_REFS[n-c],onClick:function(e){t.onYearClick(e,n);},onKeyDown:function(e){t.onYearKeyDown(e,n);},tabIndex:t.getYearTabIndex(n),className:t.getYearClassNames(n),onMouseEnter:function(e){return s(e,n)},onMouseLeave:function(e){return i(e,n)},key:n,"aria-current":t.isCurrentYear(n)?"date":void 0},t.getYearContent(n)));},u=c;u<=l;u++)d(u);return React__default.createElement("div",{className:this.getYearContainerClassNames()},React__default.createElement("div",{className:"react-datepicker__year-wrapper",onMouseLeave:this.props.clearSelectingDate},r))}}]),o}(),jt=function(t){De(n,React__default.Component);var r=be(n);function n(t){var o;return he(this,n),ye(ke(o=r.call(this,t)),"onTimeChange",(function(e){o.setState({time:e});var t=new Date;t.setHours(e.split(":")[0]),t.setMinutes(e.split(":")[1]),o.props.onChange(t);})),ye(ke(o),"renderTimeInput",(function(){var t=o.state.time,r=o.props,n=r.date,a=r.timeString,s=r.customTimeInput;return s?React__default.cloneElement(s,{date:n,value:t,onChange:o.onTimeChange}):React__default.createElement("input",{type:"time",className:"react-datepicker-time__input",placeholder:"Time",name:"time-input",required:!0,value:t,onChange:function(e){o.onTimeChange(e.target.value||a);}})})),o.state={time:o.props.timeString},o}return fe(n,[{key:"render",value:function(){return React__default.createElement("div",{className:"react-datepicker__input-time-container"},React__default.createElement("div",{className:"react-datepicker-time__caption"},this.props.timeInputLabel),React__default.createElement("div",{className:"react-datepicker-time__input-container"},React__default.createElement("div",{className:"react-datepicker-time__input"},this.renderTimeInput())))}}],[{key:"getDerivedStateFromProps",value:function(e,t){return e.timeString!==t.time?{time:e.timeString}:null}}]),n}();function Wt(t){var r=t.className,n=t.children,o=t.showPopperArrow,a=t.arrowProps,s=void 0===a?{}:a;return React__default.createElement("div",{className:r},o&&React__default.createElement("div",ve({className:"react-datepicker__triangle"},s)),n)}var Vt=["react-datepicker__year-select","react-datepicker__month-select","react-datepicker__month-year-select"],qt=function(t){De(o,React__default.Component);var n=be(o);function o(t){var a;return he(this,o),ye(ke(a=n.call(this,t)),"handleClickOutside",(function(e){a.props.onClickOutside(e);})),ye(ke(a),"setClickOutsideRef",(function(){return a.containerRef.current})),ye(ke(a),"handleDropdownFocus",(function(e){(function(){var e=((arguments.length>0&&void 0!==arguments[0]?arguments[0]:{}).className||"").split(/\s+/);return Vt.some((function(t){return e.indexOf(t)>=0}))})(e.target)&&a.props.onDropdownFocus();})),ye(ke(a),"getDateInView",(function(){var e=a.props,t=e.preSelection,r=e.selected,n=e.openToDate,o=ft(a.props),s=yt(a.props),i=Ye(),p=n||r||t;return p||(o&&isBefore(i,o)?o:s&&isAfter(i,s)?s:i)})),ye(ke(a),"increaseMonth",(function(){a.setState((function(e){var t=e.date;return {date:addMonths(t,1)}}),(function(){return a.handleMonthChange(a.state.date)}));})),ye(ke(a),"decreaseMonth",(function(){a.setState((function(e){var t=e.date;return {date:subMonths(t,1)}}),(function(){return a.handleMonthChange(a.state.date)}));})),ye(ke(a),"handleDayClick",(function(e,t,r){a.props.onSelect(e,t,r),a.props.setPreSelection&&a.props.setPreSelection(e);})),ye(ke(a),"handleDayMouseEnter",(function(e){a.setState({selectingDate:e}),a.props.onDayMouseEnter&&a.props.onDayMouseEnter(e);})),ye(ke(a),"handleMonthMouseLeave",(function(){a.setState({selectingDate:null}),a.props.onMonthMouseLeave&&a.props.onMonthMouseLeave();})),ye(ke(a),"handleYearMouseEnter",(function(e,t){a.setState({selectingDate:setYear(Ye(),t)}),a.props.onYearMouseEnter&&a.props.onYearMouseEnter(e,t);})),ye(ke(a),"handleYearMouseLeave",(function(e,t){a.props.onYearMouseLeave&&a.props.onYearMouseLeave(e,t);})),ye(ke(a),"handleYearChange",(function(e){a.props.onYearChange&&(a.props.onYearChange(e),a.setState({isRenderAriaLiveMessage:!0})),a.props.adjustDateOnChange&&(a.props.onSelect&&a.props.onSelect(e),a.props.setOpen&&a.props.setOpen(!0)),a.props.setPreSelection&&a.props.setPreSelection(e);})),ye(ke(a),"handleMonthChange",(function(e){a.handleCustomMonthChange(e),a.props.adjustDateOnChange&&(a.props.onSelect&&a.props.onSelect(e),a.props.setOpen&&a.props.setOpen(!0)),a.props.setPreSelection&&a.props.setPreSelection(e);})),ye(ke(a),"handleCustomMonthChange",(function(e){a.props.onMonthChange&&(a.props.onMonthChange(e),a.setState({isRenderAriaLiveMessage:!0}));})),ye(ke(a),"handleMonthYearChange",(function(e){a.handleYearChange(e),a.handleMonthChange(e);})),ye(ke(a),"changeYear",(function(e){a.setState((function(t){var r=t.date;return {date:setYear(r,e)}}),(function(){return a.handleYearChange(a.state.date)}));})),ye(ke(a),"changeMonth",(function(e){a.setState((function(t){var r=t.date;return {date:setMonth(r,e)}}),(function(){return a.handleMonthChange(a.state.date)}));})),ye(ke(a),"changeMonthYear",(function(e){a.setState((function(t){var r=t.date;return {date:setYear(setMonth(r,getMonth(e)),getYear(e))}}),(function(){return a.handleMonthYearChange(a.state.date)}));})),ye(ke(a),"header",(function(){var t=Le(arguments.length>0&&void 0!==arguments[0]?arguments[0]:a.state.date,a.props.locale,a.props.calendarStartDay),n=[];return a.props.showWeekNumbers&&n.push(React__default.createElement("div",{key:"W",className:"react-datepicker__day-name"},a.props.weekLabel||"#")),n.concat([0,1,2,3,4,5,6].map((function(n){var o=addDays(t,n),s=a.formatWeekday(o,a.props.locale),i=a.props.weekDayClassName?a.props.weekDayClassName(o):void 0;return React__default.createElement("div",{key:n,className:cls("react-datepicker__day-name",i)},s)})))})),ye(ke(a),"formatWeekday",(function(e,t){return a.props.formatWeekDay?function(e,t,r){return t(Ie(e,"EEEE",r))}(e,a.props.formatWeekDay,t):a.props.useWeekdaysShort?function(e,t){return Ie(e,"EEE",t)}(e,t):function(e,t){return Ie(e,"EEEEEE",t)}(e,t)})),ye(ke(a),"decreaseYear",(function(){a.setState((function(e){var t=e.date;return {date:subYears(t,a.props.showYearPicker?a.props.yearItemNumber:1)}}),(function(){return a.handleYearChange(a.state.date)}));})),ye(ke(a),"clearSelectingDate",(function(){a.setState({selectingDate:null});})),ye(ke(a),"renderPreviousButton",(function(){if(!a.props.renderCustomHeader){var t;switch(!0){case a.props.showMonthYearPicker:t=ht(a.state.date,a.props);break;case a.props.showYearPicker:t=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.yearItemNumber,o=void 0===n?Ne:n,a=kt(Ae(subYears(e,o)),o).endPeriod,s=r&&getYear(r);return s&&s>a||!1}(a.state.date,a.props);break;default:t=dt(a.state.date,a.props);}if((a.props.forceShowMonthNavigation||a.props.showDisabledMonthNavigation||!t)&&!a.props.showTimeSelectOnly){var r=["react-datepicker__navigation","react-datepicker__navigation--previous"],n=a.decreaseMonth;(a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker)&&(n=a.decreaseYear),t&&a.props.showDisabledMonthNavigation&&(r.push("react-datepicker__navigation--previous--disabled"),n=null);var o=a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker,s=a.props,i=s.previousMonthButtonLabel,p=s.previousYearButtonLabel,c=a.props,l=c.previousMonthAriaLabel,d=void 0===l?"string"==typeof i?i:"Previous Month":l,u=c.previousYearAriaLabel,h=void 0===u?"string"==typeof p?p:"Previous Year":u;return React__default.createElement("button",{type:"button",className:r.join(" "),onClick:n,onKeyDown:a.props.handleOnKeyDown,"aria-label":o?h:d},React__default.createElement("span",{className:["react-datepicker__navigation-icon","react-datepicker__navigation-icon--previous"].join(" ")},o?a.props.previousYearButtonLabel:a.props.previousMonthButtonLabel))}}})),ye(ke(a),"increaseYear",(function(){a.setState((function(e){var t=e.date;return {date:addYears(t,a.props.showYearPicker?a.props.yearItemNumber:1)}}),(function(){return a.handleYearChange(a.state.date)}));})),ye(ke(a),"renderNextButton",(function(){if(!a.props.renderCustomHeader){var t;switch(!0){case a.props.showMonthYearPicker:t=mt(a.state.date,a.props);break;case a.props.showYearPicker:t=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,n=t.yearItemNumber,o=void 0===n?Ne:n,a=kt(addYears(e,o),o).startPeriod,s=r&&getYear(r);return s&&s<a||!1}(a.state.date,a.props);break;default:t=ut(a.state.date,a.props);}if((a.props.forceShowMonthNavigation||a.props.showDisabledMonthNavigation||!t)&&!a.props.showTimeSelectOnly){var r=["react-datepicker__navigation","react-datepicker__navigation--next"];a.props.showTimeSelect&&r.push("react-datepicker__navigation--next--with-time"),a.props.todayButton&&r.push("react-datepicker__navigation--next--with-today-button");var n=a.increaseMonth;(a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker)&&(n=a.increaseYear),t&&a.props.showDisabledMonthNavigation&&(r.push("react-datepicker__navigation--next--disabled"),n=null);var o=a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker,s=a.props,i=s.nextMonthButtonLabel,p=s.nextYearButtonLabel,c=a.props,l=c.nextMonthAriaLabel,d=void 0===l?"string"==typeof i?i:"Next Month":l,h=c.nextYearAriaLabel,m=void 0===h?"string"==typeof p?p:"Next Year":h;return React__default.createElement("button",{type:"button",className:r.join(" "),onClick:n,onKeyDown:a.props.handleOnKeyDown,"aria-label":o?m:d},React__default.createElement("span",{className:["react-datepicker__navigation-icon","react-datepicker__navigation-icon--next"].join(" ")},o?a.props.nextYearButtonLabel:a.props.nextMonthButtonLabel))}}})),ye(ke(a),"renderCurrentMonth",(function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:a.state.date,r=["react-datepicker__current-month"];return a.props.showYearDropdown&&r.push("react-datepicker__current-month--hasYearDropdown"),a.props.showMonthDropdown&&r.push("react-datepicker__current-month--hasMonthDropdown"),a.props.showMonthYearDropdown&&r.push("react-datepicker__current-month--hasMonthYearDropdown"),React__default.createElement("div",{className:r.join(" ")},Ie(t,a.props.dateFormat,a.props.locale))})),ye(ke(a),"renderYearDropdown",(function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(a.props.showYearDropdown&&!t)return React__default.createElement(_t,{adjustDateOnChange:a.props.adjustDateOnChange,date:a.state.date,onSelect:a.props.onSelect,setOpen:a.props.setOpen,dropdownMode:a.props.dropdownMode,onChange:a.changeYear,minDate:a.props.minDate,maxDate:a.props.maxDate,year:getYear(a.state.date),scrollableYearDropdown:a.props.scrollableYearDropdown,yearDropdownItemNumber:a.props.yearDropdownItemNumber})})),ye(ke(a),"renderMonthDropdown",(function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(a.props.showMonthDropdown&&!t)return React__default.createElement(Et,{dropdownMode:a.props.dropdownMode,locale:a.props.locale,onChange:a.changeMonth,month:getMonth(a.state.date),useShortMonthInDropdown:a.props.useShortMonthInDropdown})})),ye(ke(a),"renderMonthYearDropdown",(function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(a.props.showMonthYearDropdown&&!t)return React__default.createElement(Yt,{dropdownMode:a.props.dropdownMode,locale:a.props.locale,dateFormat:a.props.dateFormat,onChange:a.changeMonthYear,minDate:a.props.minDate,maxDate:a.props.maxDate,date:a.state.date,scrollableMonthYearDropdown:a.props.scrollableMonthYearDropdown})})),ye(ke(a),"handleTodayButtonClick",(function(e){a.props.onSelect(Be(),e),a.props.setPreSelection&&a.props.setPreSelection(Be());})),ye(ke(a),"renderTodayButton",(function(){if(a.props.todayButton&&!a.props.showTimeSelectOnly)return React__default.createElement("div",{className:"react-datepicker__today-button",onClick:function(e){return a.handleTodayButtonClick(e)}},a.props.todayButton)})),ye(ke(a),"renderDefaultHeader",(function(t){var r=t.monthDate,n=t.i;return React__default.createElement("div",{className:"react-datepicker__header ".concat(a.props.showTimeSelect?"react-datepicker__header--has-time-select":"")},a.renderCurrentMonth(r),React__default.createElement("div",{className:"react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(a.props.dropdownMode),onFocus:a.handleDropdownFocus},a.renderMonthDropdown(0!==n),a.renderMonthYearDropdown(0!==n),a.renderYearDropdown(0!==n)),React__default.createElement("div",{className:"react-datepicker__day-names"},a.header(r)))})),ye(ke(a),"renderCustomHeader",(function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=t.monthDate,n=t.i;if(a.props.showTimeSelect&&!a.state.monthContainer||a.props.showTimeSelectOnly)return null;var o=dt(a.state.date,a.props),s=ut(a.state.date,a.props),i=ht(a.state.date,a.props),p=mt(a.state.date,a.props),c=!a.props.showMonthYearPicker&&!a.props.showQuarterYearPicker&&!a.props.showYearPicker;return React__default.createElement("div",{className:"react-datepicker__header react-datepicker__header--custom",onFocus:a.props.onDropdownFocus},a.props.renderCustomHeader(de(de({},a.state),{},{customHeaderCount:n,monthDate:r,changeMonth:a.changeMonth,changeYear:a.changeYear,decreaseMonth:a.decreaseMonth,increaseMonth:a.increaseMonth,decreaseYear:a.decreaseYear,increaseYear:a.increaseYear,prevMonthButtonDisabled:o,nextMonthButtonDisabled:s,prevYearButtonDisabled:i,nextYearButtonDisabled:p})),c&&React__default.createElement("div",{className:"react-datepicker__day-names"},a.header(r)))})),ye(ke(a),"renderYearHeader",(function(){var t=a.state.date,r=a.props,n=r.showYearPicker,o=kt(t,r.yearItemNumber),s=o.startPeriod,i=o.endPeriod;return React__default.createElement("div",{className:"react-datepicker__header react-datepicker-year-header"},n?"".concat(s," - ").concat(i):getYear(t))})),ye(ke(a),"renderHeader",(function(e){switch(!0){case void 0!==a.props.renderCustomHeader:return a.renderCustomHeader(e);case a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker:return a.renderYearHeader(e);default:return a.renderDefaultHeader(e)}})),ye(ke(a),"renderMonths",(function(){var t;if(!a.props.showTimeSelectOnly&&!a.props.showYearPicker){for(var r=[],n=a.props.showPreviousMonths?a.props.monthsShown-1:0,o=subMonths(a.state.date,n),s=null!==(t=a.props.monthSelectedIn)&&void 0!==t?t:n,i=0;i<a.props.monthsShown;++i){var p=addMonths(o,i-s+n),c="month-".concat(i),d=i<a.props.monthsShown-1,u=i>0;r.push(React__default.createElement("div",{key:c,ref:function(e){a.monthContainer=e;},className:"react-datepicker__month-container"},a.renderHeader({monthDate:p,i:i}),React__default.createElement(Bt,{chooseDayAriaLabelPrefix:a.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:a.props.disabledDayAriaLabelPrefix,weekAriaLabelPrefix:a.props.weekAriaLabelPrefix,ariaLabelPrefix:a.props.monthAriaLabelPrefix,onChange:a.changeMonthYear,day:p,dayClassName:a.props.dayClassName,calendarStartDay:a.props.calendarStartDay,monthClassName:a.props.monthClassName,onDayClick:a.handleDayClick,handleOnKeyDown:a.props.handleOnDayKeyDown,onDayMouseEnter:a.handleDayMouseEnter,onMouseLeave:a.handleMonthMouseLeave,onWeekSelect:a.props.onWeekSelect,orderInDisplay:i,formatWeekNumber:a.props.formatWeekNumber,locale:a.props.locale,minDate:a.props.minDate,maxDate:a.props.maxDate,excludeDates:a.props.excludeDates,excludeDateIntervals:a.props.excludeDateIntervals,highlightDates:a.props.highlightDates,holidays:a.props.holidays,selectingDate:a.state.selectingDate,includeDates:a.props.includeDates,includeDateIntervals:a.props.includeDateIntervals,inline:a.props.inline,shouldFocusDayInline:a.props.shouldFocusDayInline,fixedHeight:a.props.fixedHeight,filterDate:a.props.filterDate,preSelection:a.props.preSelection,setPreSelection:a.props.setPreSelection,selected:a.props.selected,selectsStart:a.props.selectsStart,selectsEnd:a.props.selectsEnd,selectsRange:a.props.selectsRange,selectsDisabledDaysInRange:a.props.selectsDisabledDaysInRange,showWeekNumbers:a.props.showWeekNumbers,startDate:a.props.startDate,endDate:a.props.endDate,peekNextMonth:a.props.peekNextMonth,setOpen:a.props.setOpen,shouldCloseOnSelect:a.props.shouldCloseOnSelect,renderDayContents:a.props.renderDayContents,renderMonthContent:a.props.renderMonthContent,renderQuarterContent:a.props.renderQuarterContent,renderYearContent:a.props.renderYearContent,disabledKeyboardNavigation:a.props.disabledKeyboardNavigation,showMonthYearPicker:a.props.showMonthYearPicker,showFullMonthYearPicker:a.props.showFullMonthYearPicker,showTwoColumnMonthYearPicker:a.props.showTwoColumnMonthYearPicker,showFourColumnMonthYearPicker:a.props.showFourColumnMonthYearPicker,showYearPicker:a.props.showYearPicker,showQuarterYearPicker:a.props.showQuarterYearPicker,isInputFocused:a.props.isInputFocused,containerRef:a.containerRef,monthShowsDuplicateDaysEnd:d,monthShowsDuplicateDaysStart:u})));}return r}})),ye(ke(a),"renderYears",(function(){if(!a.props.showTimeSelectOnly)return a.props.showYearPicker?React__default.createElement("div",{className:"react-datepicker__year--container"},a.renderHeader(),React__default.createElement(Ht,ve({onDayClick:a.handleDayClick,selectingDate:a.state.selectingDate,clearSelectingDate:a.clearSelectingDate,date:a.state.date},a.props,{onYearMouseEnter:a.handleYearMouseEnter,onYearMouseLeave:a.handleYearMouseLeave}))):void 0})),ye(ke(a),"renderTimeSection",(function(){if(a.props.showTimeSelect&&(a.state.monthContainer||a.props.showTimeSelectOnly))return React__default.createElement(Qt,{selected:a.props.selected,openToDate:a.props.openToDate,onChange:a.props.onTimeChange,timeClassName:a.props.timeClassName,format:a.props.timeFormat,includeTimes:a.props.includeTimes,intervals:a.props.timeIntervals,minTime:a.props.minTime,maxTime:a.props.maxTime,excludeTimes:a.props.excludeTimes,filterTime:a.props.filterTime,timeCaption:a.props.timeCaption,todayButton:a.props.todayButton,showMonthDropdown:a.props.showMonthDropdown,showMonthYearDropdown:a.props.showMonthYearDropdown,showYearDropdown:a.props.showYearDropdown,withPortal:a.props.withPortal,monthRef:a.state.monthContainer,injectTimes:a.props.injectTimes,locale:a.props.locale,handleOnKeyDown:a.props.handleOnKeyDown,showTimeSelectOnly:a.props.showTimeSelectOnly})})),ye(ke(a),"renderInputTimeSection",(function(){var t=new Date(a.props.selected),r=Te(t)&&Boolean(a.props.selected)?"".concat(wt(t.getHours()),":").concat(wt(t.getMinutes())):"";if(a.props.showTimeInput)return React__default.createElement(jt,{date:t,timeString:r,timeInputLabel:a.props.timeInputLabel,onChange:a.props.onTimeChange,customTimeInput:a.props.customTimeInput})})),ye(ke(a),"renderAriaLiveRegion",(function(){var t,r=kt(a.state.date,a.props.yearItemNumber),n=r.startPeriod,o=r.endPeriod;return t=a.props.showYearPicker?"".concat(n," - ").concat(o):a.props.showMonthYearPicker||a.props.showQuarterYearPicker?getYear(a.state.date):"".concat(Je(getMonth(a.state.date),a.props.locale)," ").concat(getYear(a.state.date)),React__default.createElement("span",{role:"alert","aria-live":"polite",className:"react-datepicker__aria-live"},a.state.isRenderAriaLiveMessage&&t)})),ye(ke(a),"renderChildren",(function(){if(a.props.children)return React__default.createElement("div",{className:"react-datepicker__children-container"},a.props.children)})),a.containerRef=React__default.createRef(),a.state={date:a.getDateInView(),selectingDate:null,monthContainer:null,isRenderAriaLiveMessage:!1},a}return fe(o,[{key:"componentDidMount",value:function(){var e=this;this.props.showTimeSelect&&(this.assignMonthContainer=void e.setState({monthContainer:e.monthContainer}));}},{key:"componentDidUpdate",value:function(e){var t=this;if(!this.props.preSelection||We(this.props.preSelection,e.preSelection)&&this.props.monthSelectedIn===e.monthSelectedIn)this.props.openToDate&&!We(this.props.openToDate,e.openToDate)&&this.setState({date:this.props.openToDate});else {var r=!He(this.state.date,this.props.preSelection);this.setState({date:this.props.preSelection},(function(){return r&&t.handleCustomMonthChange(t.state.date)}));}}},{key:"render",value:function(){var t=this.props.container||Wt;return React__default.createElement("div",{ref:this.containerRef},React__default.createElement(t,{className:cls("react-datepicker",this.props.className,{"react-datepicker--time-only":this.props.showTimeSelectOnly}),showPopperArrow:this.props.showPopperArrow,arrowProps:this.props.arrowProps},this.renderAriaLiveRegion(),this.renderPreviousButton(),this.renderNextButton(),this.renderMonths(),this.renderYears(),this.renderTodayButton(),this.renderTimeSection(),this.renderInputTimeSection(),this.renderChildren()))}}],[{key:"defaultProps",get:function(){return {onDropdownFocus:function(){},monthsShown:1,forceShowMonthNavigation:!1,timeCaption:"Time",previousYearButtonLabel:"Previous Year",nextYearButtonLabel:"Next Year",previousMonthButtonLabel:"Previous Month",nextMonthButtonLabel:"Next Month",customTimeInput:null,yearItemNumber:Ne}}}]),o}(),Ut=function(t){De(n,React__default.Component);var r=be(n);function n(e){var t;return he(this,n),(t=r.call(this,e)).el=document.createElement("div"),t}return fe(n,[{key:"componentDidMount",value:function(){this.portalRoot=(this.props.portalHost||document).getElementById(this.props.portalId),this.portalRoot||(this.portalRoot=document.createElement("div"),this.portalRoot.setAttribute("id",this.props.portalId),(this.props.portalHost||document.body).appendChild(this.portalRoot)),this.portalRoot.appendChild(this.el);}},{key:"componentWillUnmount",value:function(){this.portalRoot.removeChild(this.el);}},{key:"render",value:function(){return require$$1__default.createPortal(this.props.children,this.el)}}]),n}(),zt=function(e){return !e.disabled&&-1!==e.tabIndex},$t=function(t){De(n,React__default.Component);var r=be(n);function n(t){var o;return he(this,n),ye(ke(o=r.call(this,t)),"getTabChildren",(function(){return Array.prototype.slice.call(o.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"),1,-1).filter(zt)})),ye(ke(o),"handleFocusStart",(function(){var e=o.getTabChildren();e&&e.length>1&&e[e.length-1].focus();})),ye(ke(o),"handleFocusEnd",(function(){var e=o.getTabChildren();e&&e.length>1&&e[0].focus();})),o.tabLoopRef=React__default.createRef(),o}return fe(n,[{key:"render",value:function(){return this.props.enableTabLoop?React__default.createElement("div",{className:"react-datepicker__tab-loop",ref:this.tabLoopRef},React__default.createElement("div",{className:"react-datepicker__tab-loop__start",tabIndex:"0",onFocus:this.handleFocusStart}),this.props.children,React__default.createElement("div",{className:"react-datepicker__tab-loop__end",tabIndex:"0",onFocus:this.handleFocusEnd})):this.props.children}}],[{key:"defaultProps",get:function(){return {enableTabLoop:!0}}}]),n}(),Gt=function(t){De(o,React__default.Component);var n=be(o);function o(){return he(this,o),n.apply(this,arguments)}return fe(o,[{key:"render",value:function(){var t,n=this.props,o=n.className,a=n.wrapperClassName,s=n.hidePopper,i=n.popperComponent,p=n.popperModifiers,c=n.popperPlacement,l=n.popperProps,d=n.targetComponent,u=n.enableTabLoop,h=n.popperOnKeyDown,m=n.portalId,f=n.portalHost;if(!s){var y=cls("react-datepicker-popper",o);t=React__default.createElement(Popper,ve({modifiers:p,placement:c},l),(function(t){var r=t.ref,n=t.style,o=t.placement,a=t.arrowProps;return React__default.createElement($t,{enableTabLoop:u},React__default.createElement("div",{ref:r,style:n,className:y,"data-placement":o,onKeyDown:h},React__default.cloneElement(i,{arrowProps:a})))}));}this.props.popperContainer&&(t=React__default.createElement(this.props.popperContainer,{},t)),m&&!s&&(t=React__default.createElement(Ut,{portalId:m,portalHost:f},t));var v=cls("react-datepicker-wrapper",a);return React__default.createElement(Manager,{className:"react-datepicker-manager"},React__default.createElement(Reference,null,(function(t){var r=t.ref;return React__default.createElement("div",{ref:r,className:v},d)})),t)}}],[{key:"defaultProps",get:function(){return {hidePopper:!0,popperModifiers:[],popperProps:{},popperPlacement:"bottom-start"}}}]),o}(),Jt="react-datepicker-ignore-onclickoutside",Xt=onClickOutsideHOC(qt);var Zt="Date input not valid.",er=function(t){De(s,React__default.Component);var a=be(s);function s(t){var i;return he(this,s),ye(ke(i=a.call(this,t)),"getPreSelection",(function(){return i.props.openToDate?i.props.openToDate:i.props.selectsEnd&&i.props.startDate?i.props.startDate:i.props.selectsStart&&i.props.endDate?i.props.endDate:Ye()})),ye(ke(i),"calcInitialState",(function(){var e,t,r=null===(e=i.props.holidays)||void 0===e?void 0:e.reduce((function(e,t){var r=new Date(t.date);return isValid(r)?[].concat(Se(e),[de(de({},t),{},{date:r})]):e}),[]),n=i.getPreSelection(),a=ft(i.props),s=yt(i.props),p=a&&isBefore(n,startOfDay(a))?a:s&&isAfter(n,endOfDay(s))?s:n;return {open:i.props.startOpen||!1,preventFocus:!1,preSelection:null!==(t=i.props.selectsRange?i.props.startDate:i.props.selected)&&void 0!==t?t:p,highlightDates:vt(i.props.highlightDates),holidays:Dt(r),focused:!1,shouldFocusDayInline:!1,isRenderAriaLiveMessage:!1}})),ye(ke(i),"clearPreventFocusTimeout",(function(){i.preventFocusTimeout&&clearTimeout(i.preventFocusTimeout);})),ye(ke(i),"setFocus",(function(){i.input&&i.input.focus&&i.input.focus({preventScroll:!0});})),ye(ke(i),"setBlur",(function(){i.input&&i.input.blur&&i.input.blur(),i.cancelFocusInput();})),ye(ke(i),"setOpen",(function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];i.setState({open:e,preSelection:e&&i.state.open?i.state.preSelection:i.calcInitialState().preSelection,lastPreSelectChange:rr},(function(){e||i.setState((function(e){return {focused:!!t&&e.focused}}),(function(){!t&&i.setBlur(),i.setState({inputValue:null});}));}));})),ye(ke(i),"inputOk",(function(){return isDate(i.state.preSelection)})),ye(ke(i),"isCalendarOpen",(function(){return void 0===i.props.open?i.state.open&&!i.props.disabled&&!i.props.readOnly:i.props.open})),ye(ke(i),"handleFocus",(function(e){i.state.preventFocus||(i.props.onFocus(e),i.props.preventOpenOnFocus||i.props.readOnly||i.setOpen(!0)),i.setState({focused:!0});})),ye(ke(i),"cancelFocusInput",(function(){clearTimeout(i.inputFocusTimeout),i.inputFocusTimeout=null;})),ye(ke(i),"deferFocusInput",(function(){i.cancelFocusInput(),i.inputFocusTimeout=setTimeout((function(){return i.setFocus()}),1);})),ye(ke(i),"handleDropdownFocus",(function(){i.cancelFocusInput();})),ye(ke(i),"handleBlur",(function(e){(!i.state.open||i.props.withPortal||i.props.showTimeInput)&&i.props.onBlur(e),i.setState({focused:!1});})),ye(ke(i),"handleCalendarClickOutside",(function(e){i.props.inline||i.setOpen(!1),i.props.onClickOutside(e),i.props.withPortal&&e.preventDefault();})),ye(ke(i),"handleChange",(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];var n=t[0];if(!i.props.onChangeRaw||(i.props.onChangeRaw.apply(ke(i),t),"function"==typeof n.isDefaultPrevented&&!n.isDefaultPrevented())){i.setState({inputValue:n.target.value,lastPreSelectChange:tr});var o,a,s,p,c,l,d,u,h=(o=n.target.value,a=i.props.dateFormat,s=i.props.locale,p=i.props.strictParsing,c=i.props.minDate,l=null,d=Ge(s)||Ge($e()),u=!0,Array.isArray(a)?(a.forEach((function(e){var t=parse(o,e,new Date,{locale:d});p&&(u=Te(t,c)&&o===Ie(t,e,s)),Te(t,c)&&u&&(l=t);})),l):(l=parse(o,a,new Date,{locale:d}),p?u=Te(l)&&o===Ie(l,a,s):Te(l)||(a=a.match(xe).map((function(e){var t=e[0];return "p"===t||"P"===t?d?(0, Pe[t])(e,d.formatLong):t:e})).join(""),o.length>0&&(l=parse(o,a.slice(0,o.length),new Date)),Te(l)||(l=new Date(o))),Te(l)&&u?l:null));i.props.showTimeSelectOnly&&i.props.selected&&!We(h,i.props.selected)&&(h=set(i.props.selected,null==h?{hours:getHours(i.props.selected),minutes:getMinutes(i.props.selected),seconds:getSeconds(i.props.selected)}:{hours:getHours(h),minutes:getMinutes(h),seconds:getSeconds(h)})),!h&&n.target.value||i.setSelected(h,n,!0);}})),ye(ke(i),"handleSelect",(function(e,t,r){if(i.setState({preventFocus:!0},(function(){return i.preventFocusTimeout=setTimeout((function(){return i.setState({preventFocus:!1})}),50),i.preventFocusTimeout})),i.props.onChangeRaw&&i.props.onChangeRaw(t),i.setSelected(e,t,!1,r),i.props.showDateSelect&&i.setState({isRenderAriaLiveMessage:!0}),!i.props.shouldCloseOnSelect||i.props.showTimeSelect)i.setPreSelection(e);else if(!i.props.inline){i.props.selectsRange||i.setOpen(!1);var n=i.props,o=n.startDate,a=n.endDate;!o||a||isBefore(e,o)||i.setOpen(!1);}})),ye(ke(i),"setSelected",(function(e,t,r,n){var o=e;if(i.props.showYearPicker){if(null!==o&&at(getYear(o),i.props))return}else if(i.props.showMonthYearPicker){if(null!==o&&tt(o,i.props))return}else if(null!==o&&Ze(o,i.props))return;var a=i.props,s=a.onChange,p=a.selectsRange,c=a.startDate,l=a.endDate;if(!Ve(i.props.selected,o)||i.props.allowSameDay||p)if(null!==o&&(!i.props.selected||r&&(i.props.showTimeSelect||i.props.showTimeSelectOnly||i.props.showTimeInput)||(o=Re(o,{hour:getHours(i.props.selected),minute:getMinutes(i.props.selected),second:getSeconds(i.props.selected)})),i.props.inline||i.setState({preSelection:o}),i.props.focusSelectedMonth||i.setState({monthSelectedIn:n})),p){var d=c&&!l,u=c&&l;!c&&!l?s([o,null],t):d&&(isBefore(o,c)?s([o,null],t):s([c,o],t)),u&&s([o,null],t);}else s(o,t);r||(i.props.onSelect(o,t),i.setState({inputValue:null}));})),ye(ke(i),"setPreSelection",(function(e){var t=void 0!==i.props.minDate,r=void 0!==i.props.maxDate,n=!0;if(e){var o=startOfDay(e);if(t&&r)n=qe(e,i.props.minDate,i.props.maxDate);else if(t){var a=startOfDay(i.props.minDate);n=isAfter(e,a)||Ve(o,a);}else if(r){var s=endOfDay(i.props.maxDate);n=isBefore(e,s)||Ve(o,s);}}n&&i.setState({preSelection:e});})),ye(ke(i),"handleTimeChange",(function(e){var t=i.props.selected?i.props.selected:i.getPreSelection(),r=i.props.selected?e:Re(t,{hour:getHours(e),minute:getMinutes(e)});i.setState({preSelection:r}),i.props.onChange(r),i.props.shouldCloseOnSelect&&i.setOpen(!1),i.props.showTimeInput&&i.setOpen(!0),(i.props.showTimeSelectOnly||i.props.showTimeSelect)&&i.setState({isRenderAriaLiveMessage:!0}),i.setState({inputValue:null});})),ye(ke(i),"onInputClick",(function(){i.props.disabled||i.props.readOnly||i.setOpen(!0),i.props.onInputClick();})),ye(ke(i),"onInputKeyDown",(function(e){i.props.onKeyDown(e);var t=e.key;if(i.state.open||i.props.inline||i.props.preventOpenOnFocus){if(i.state.open){if("ArrowDown"===t||"ArrowUp"===t){e.preventDefault();var r=i.calendar.componentNode&&i.calendar.componentNode.querySelector('.react-datepicker__day[tabindex="0"]');return void(r&&r.focus({preventScroll:!0}))}var n=Ye(i.state.preSelection);"Enter"===t?(e.preventDefault(),i.inputOk()&&i.state.lastPreSelectChange===rr?(i.handleSelect(n,e),!i.props.shouldCloseOnSelect&&i.setPreSelection(n)):i.setOpen(!1)):"Escape"===t?(e.preventDefault(),i.setOpen(!1)):"Tab"===t&&i.setOpen(!1),i.inputOk()||i.props.onInputError({code:1,msg:Zt});}}else "ArrowDown"!==t&&"ArrowUp"!==t&&"Enter"!==t||i.onInputClick();})),ye(ke(i),"onPortalKeyDown",(function(e){"Escape"===e.key&&(e.preventDefault(),i.setState({preventFocus:!0},(function(){i.setOpen(!1),setTimeout((function(){i.setFocus(),i.setState({preventFocus:!1});}));})));})),ye(ke(i),"onDayKeyDown",(function(e){i.props.onKeyDown(e);var t=e.key,r=Ye(i.state.preSelection);if("Enter"===t)e.preventDefault(),i.handleSelect(r,e),!i.props.shouldCloseOnSelect&&i.setPreSelection(r);else if("Escape"===t)e.preventDefault(),i.setOpen(!1),i.inputOk()||i.props.onInputError({code:1,msg:Zt});else if(!i.props.disabledKeyboardNavigation){var n;switch(t){case"ArrowLeft":n=subDays(r,1);break;case"ArrowRight":n=addDays(r,1);break;case"ArrowUp":n=subWeeks(r,1);break;case"ArrowDown":n=addWeeks(r,1);break;case"PageUp":n=subMonths(r,1);break;case"PageDown":n=addMonths(r,1);break;case"Home":n=subYears(r,1);break;case"End":n=addYears(r,1);}if(!n)return void(i.props.onInputError&&i.props.onInputError({code:1,msg:Zt}));if(e.preventDefault(),i.setState({lastPreSelectChange:rr}),i.props.adjustDateOnChange&&i.setSelected(n),i.setPreSelection(n),i.props.inline){var o=getMonth(r),a=getMonth(n),s=getYear(r),d=getYear(n);o!==a||s!==d?i.setState({shouldFocusDayInline:!0}):i.setState({shouldFocusDayInline:!1});}}})),ye(ke(i),"onPopperKeyDown",(function(e){"Escape"===e.key&&(e.preventDefault(),i.setState({preventFocus:!0},(function(){i.setOpen(!1),setTimeout((function(){i.setFocus(),i.setState({preventFocus:!1});}));})));})),ye(ke(i),"onClearClick",(function(e){e&&e.preventDefault&&e.preventDefault(),i.props.selectsRange?i.props.onChange([null,null],e):i.props.onChange(null,e),i.setState({inputValue:null});})),ye(ke(i),"clear",(function(){i.onClearClick();})),ye(ke(i),"onScroll",(function(e){"boolean"==typeof i.props.closeOnScroll&&i.props.closeOnScroll?e.target!==document&&e.target!==document.documentElement&&e.target!==document.body||i.setOpen(!1):"function"==typeof i.props.closeOnScroll&&i.props.closeOnScroll(e)&&i.setOpen(!1);})),ye(ke(i),"renderCalendar",(function(){return i.props.inline||i.isCalendarOpen()?React__default.createElement(Xt,{ref:function(e){i.calendar=e;},locale:i.props.locale,calendarStartDay:i.props.calendarStartDay,chooseDayAriaLabelPrefix:i.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:i.props.disabledDayAriaLabelPrefix,weekAriaLabelPrefix:i.props.weekAriaLabelPrefix,monthAriaLabelPrefix:i.props.monthAriaLabelPrefix,adjustDateOnChange:i.props.adjustDateOnChange,setOpen:i.setOpen,shouldCloseOnSelect:i.props.shouldCloseOnSelect,dateFormat:i.props.dateFormatCalendar,useWeekdaysShort:i.props.useWeekdaysShort,formatWeekDay:i.props.formatWeekDay,dropdownMode:i.props.dropdownMode,selected:i.props.selected,preSelection:i.state.preSelection,onSelect:i.handleSelect,onWeekSelect:i.props.onWeekSelect,openToDate:i.props.openToDate,minDate:i.props.minDate,maxDate:i.props.maxDate,selectsStart:i.props.selectsStart,selectsEnd:i.props.selectsEnd,selectsRange:i.props.selectsRange,startDate:i.props.startDate,endDate:i.props.endDate,excludeDates:i.props.excludeDates,excludeDateIntervals:i.props.excludeDateIntervals,filterDate:i.props.filterDate,onClickOutside:i.handleCalendarClickOutside,formatWeekNumber:i.props.formatWeekNumber,highlightDates:i.state.highlightDates,holidays:i.state.holidays,includeDates:i.props.includeDates,includeDateIntervals:i.props.includeDateIntervals,includeTimes:i.props.includeTimes,injectTimes:i.props.injectTimes,inline:i.props.inline,shouldFocusDayInline:i.state.shouldFocusDayInline,peekNextMonth:i.props.peekNextMonth,showMonthDropdown:i.props.showMonthDropdown,showPreviousMonths:i.props.showPreviousMonths,useShortMonthInDropdown:i.props.useShortMonthInDropdown,showMonthYearDropdown:i.props.showMonthYearDropdown,showWeekNumbers:i.props.showWeekNumbers,showYearDropdown:i.props.showYearDropdown,withPortal:i.props.withPortal,forceShowMonthNavigation:i.props.forceShowMonthNavigation,showDisabledMonthNavigation:i.props.showDisabledMonthNavigation,scrollableYearDropdown:i.props.scrollableYearDropdown,scrollableMonthYearDropdown:i.props.scrollableMonthYearDropdown,todayButton:i.props.todayButton,weekLabel:i.props.weekLabel,outsideClickIgnoreClass:Jt,fixedHeight:i.props.fixedHeight,monthsShown:i.props.monthsShown,monthSelectedIn:i.state.monthSelectedIn,onDropdownFocus:i.handleDropdownFocus,onMonthChange:i.props.onMonthChange,onYearChange:i.props.onYearChange,dayClassName:i.props.dayClassName,weekDayClassName:i.props.weekDayClassName,monthClassName:i.props.monthClassName,timeClassName:i.props.timeClassName,showDateSelect:i.props.showDateSelect,showTimeSelect:i.props.showTimeSelect,showTimeSelectOnly:i.props.showTimeSelectOnly,onTimeChange:i.handleTimeChange,timeFormat:i.props.timeFormat,timeIntervals:i.props.timeIntervals,minTime:i.props.minTime,maxTime:i.props.maxTime,excludeTimes:i.props.excludeTimes,filterTime:i.props.filterTime,timeCaption:i.props.timeCaption,className:i.props.calendarClassName,container:i.props.calendarContainer,yearItemNumber:i.props.yearItemNumber,yearDropdownItemNumber:i.props.yearDropdownItemNumber,previousMonthAriaLabel:i.props.previousMonthAriaLabel,previousMonthButtonLabel:i.props.previousMonthButtonLabel,nextMonthAriaLabel:i.props.nextMonthAriaLabel,nextMonthButtonLabel:i.props.nextMonthButtonLabel,previousYearAriaLabel:i.props.previousYearAriaLabel,previousYearButtonLabel:i.props.previousYearButtonLabel,nextYearAriaLabel:i.props.nextYearAriaLabel,nextYearButtonLabel:i.props.nextYearButtonLabel,timeInputLabel:i.props.timeInputLabel,disabledKeyboardNavigation:i.props.disabledKeyboardNavigation,renderCustomHeader:i.props.renderCustomHeader,popperProps:i.props.popperProps,renderDayContents:i.props.renderDayContents,renderMonthContent:i.props.renderMonthContent,renderQuarterContent:i.props.renderQuarterContent,renderYearContent:i.props.renderYearContent,onDayMouseEnter:i.props.onDayMouseEnter,onMonthMouseLeave:i.props.onMonthMouseLeave,onYearMouseEnter:i.props.onYearMouseEnter,onYearMouseLeave:i.props.onYearMouseLeave,selectsDisabledDaysInRange:i.props.selectsDisabledDaysInRange,showTimeInput:i.props.showTimeInput,showMonthYearPicker:i.props.showMonthYearPicker,showFullMonthYearPicker:i.props.showFullMonthYearPicker,showTwoColumnMonthYearPicker:i.props.showTwoColumnMonthYearPicker,showFourColumnMonthYearPicker:i.props.showFourColumnMonthYearPicker,showYearPicker:i.props.showYearPicker,showQuarterYearPicker:i.props.showQuarterYearPicker,showPopperArrow:i.props.showPopperArrow,excludeScrollbar:i.props.excludeScrollbar,handleOnKeyDown:i.props.onKeyDown,handleOnDayKeyDown:i.onDayKeyDown,isInputFocused:i.state.focused,customTimeInput:i.props.customTimeInput,setPreSelection:i.setPreSelection},i.props.children):null})),ye(ke(i),"renderAriaLiveRegion",(function(){var t,r=i.props,n=r.dateFormat,o=r.locale,a=i.props.showTimeInput||i.props.showTimeSelect?"PPPPp":"PPPP";return t=i.props.selectsRange?"Selected start date: ".concat(Oe(i.props.startDate,{dateFormat:a,locale:o}),". ").concat(i.props.endDate?"End date: "+Oe(i.props.endDate,{dateFormat:a,locale:o}):""):i.props.showTimeSelectOnly?"Selected time: ".concat(Oe(i.props.selected,{dateFormat:n,locale:o})):i.props.showYearPicker?"Selected year: ".concat(Oe(i.props.selected,{dateFormat:"yyyy",locale:o})):i.props.showMonthYearPicker?"Selected month: ".concat(Oe(i.props.selected,{dateFormat:"MMMM yyyy",locale:o})):i.props.showQuarterYearPicker?"Selected quarter: ".concat(Oe(i.props.selected,{dateFormat:"yyyy, QQQ",locale:o})):"Selected date: ".concat(Oe(i.props.selected,{dateFormat:a,locale:o})),React__default.createElement("span",{role:"alert","aria-live":"polite",className:"react-datepicker__aria-live"},t)})),ye(ke(i),"renderDateInput",(function(){var t,n=cls(i.props.className,ye({},Jt,i.state.open)),o=i.props.customInput||React__default.createElement("input",{type:"text"}),a=i.props.customInputRef||"ref",s="string"==typeof i.props.value?i.props.value:"string"==typeof i.state.inputValue?i.state.inputValue:i.props.selectsRange?function(e,t,r){if(!e)return "";var n=Oe(e,r),o=t?Oe(t,r):"";return "".concat(n," - ").concat(o)}(i.props.startDate,i.props.endDate,i.props):Oe(i.props.selected,i.props);return React__default.cloneElement(o,(ye(t={},a,(function(e){i.input=e;})),ye(t,"value",s),ye(t,"onBlur",i.handleBlur),ye(t,"onChange",i.handleChange),ye(t,"onClick",i.onInputClick),ye(t,"onFocus",i.handleFocus),ye(t,"onKeyDown",i.onInputKeyDown),ye(t,"id",i.props.id),ye(t,"name",i.props.name),ye(t,"form",i.props.form),ye(t,"autoFocus",i.props.autoFocus),ye(t,"placeholder",i.props.placeholderText),ye(t,"disabled",i.props.disabled),ye(t,"autoComplete",i.props.autoComplete),ye(t,"className",cls(o.props.className,n)),ye(t,"title",i.props.title),ye(t,"readOnly",i.props.readOnly),ye(t,"required",i.props.required),ye(t,"tabIndex",i.props.tabIndex),ye(t,"aria-describedby",i.props.ariaDescribedBy),ye(t,"aria-invalid",i.props.ariaInvalid),ye(t,"aria-labelledby",i.props.ariaLabelledBy),ye(t,"aria-required",i.props.ariaRequired),t))})),ye(ke(i),"renderClearButton",(function(){var t=i.props,r=t.isClearable,n=t.selected,o=t.startDate,a=t.endDate,s=t.clearButtonTitle,p=t.clearButtonClassName,c=void 0===p?"":p,l=t.ariaLabelClose,d=void 0===l?"Close":l;return !r||null==n&&null==o&&null==a?null:React__default.createElement("button",{type:"button",className:"react-datepicker__close-icon ".concat(c).trim(),"aria-label":d,onClick:i.onClearClick,title:s,tabIndex:-1})})),i.state=i.calcInitialState(),i}return fe(s,[{key:"componentDidMount",value:function(){window.addEventListener("scroll",this.onScroll,!0);}},{key:"componentDidUpdate",value:function(e,t){var r,n;e.inline&&(r=e.selected,n=this.props.selected,r&&n?getMonth(r)!==getMonth(n)||getYear(r)!==getYear(n):r!==n)&&this.setPreSelection(this.props.selected),void 0!==this.state.monthSelectedIn&&e.monthsShown!==this.props.monthsShown&&this.setState({monthSelectedIn:0}),e.highlightDates!==this.props.highlightDates&&this.setState({highlightDates:vt(this.props.highlightDates)}),t.focused||Ve(e.selected,this.props.selected)||this.setState({inputValue:null}),t.open!==this.state.open&&(!1===t.open&&!0===this.state.open&&this.props.onCalendarOpen(),!0===t.open&&!1===this.state.open&&this.props.onCalendarClose());}},{key:"componentWillUnmount",value:function(){this.clearPreventFocusTimeout(),window.removeEventListener("scroll",this.onScroll,!0);}},{key:"renderInputContainer",value:function(){var t=this.props.showIcon;return React__default.createElement("div",{className:"react-datepicker__input-container".concat(t?" react-datepicker__view-calendar-icon":"")},t&&React__default.createElement("svg",{className:"react-datepicker__calendar-icon",xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 448 512"},React__default.createElement("path",{d:"M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"})),this.state.isRenderAriaLiveMessage&&this.renderAriaLiveRegion(),this.renderDateInput(),this.renderClearButton())}},{key:"render",value:function(){var t=this.renderCalendar();if(this.props.inline)return t;if(this.props.withPortal){var r=this.state.open?React__default.createElement($t,{enableTabLoop:this.props.enableTabLoop},React__default.createElement("div",{className:"react-datepicker__portal",tabIndex:-1,onKeyDown:this.onPortalKeyDown},t)):null;return this.state.open&&this.props.portalId&&(r=React__default.createElement(Ut,{portalId:this.props.portalId,portalHost:this.props.portalHost},r)),React__default.createElement("div",null,this.renderInputContainer(),r)}return React__default.createElement(Gt,{className:this.props.popperClassName,wrapperClassName:this.props.wrapperClassName,hidePopper:!this.isCalendarOpen(),portalId:this.props.portalId,portalHost:this.props.portalHost,popperModifiers:this.props.popperModifiers,targetComponent:this.renderInputContainer(),popperContainer:this.props.popperContainer,popperComponent:t,popperPlacement:this.props.popperPlacement,popperProps:this.props.popperProps,popperOnKeyDown:this.onPopperKeyDown,enableTabLoop:this.props.enableTabLoop})}}],[{key:"defaultProps",get:function(){return {allowSameDay:!1,dateFormat:"MM/dd/yyyy",dateFormatCalendar:"LLLL yyyy",onChange:function(){},disabled:!1,disabledKeyboardNavigation:!1,dropdownMode:"scroll",onFocus:function(){},onBlur:function(){},onKeyDown:function(){},onInputClick:function(){},onSelect:function(){},onClickOutside:function(){},onMonthChange:function(){},onCalendarOpen:function(){},onCalendarClose:function(){},preventOpenOnFocus:!1,onYearChange:function(){},onInputError:function(){},monthsShown:1,readOnly:!1,withPortal:!1,selectsDisabledDaysInRange:!1,shouldCloseOnSelect:!0,showTimeSelect:!1,showTimeInput:!1,showPreviousMonths:!1,showMonthYearPicker:!1,showFullMonthYearPicker:!1,showTwoColumnMonthYearPicker:!1,showFourColumnMonthYearPicker:!1,showYearPicker:!1,showQuarterYearPicker:!1,strictParsing:!1,timeIntervals:30,timeCaption:"Time",previousMonthAriaLabel:"Previous Month",previousMonthButtonLabel:"Previous Month",nextMonthAriaLabel:"Next Month",nextMonthButtonLabel:"Next Month",previousYearAriaLabel:"Previous Year",previousYearButtonLabel:"Previous Year",nextYearAriaLabel:"Next Year",nextYearButtonLabel:"Next Year",timeInputLabel:"Time",enableTabLoop:!0,yearItemNumber:Ne,focusSelectedMonth:!1,showPopperArrow:!0,excludeScrollbar:!0,customTimeInput:null,calendarStartDay:void 0}}}]),s}(),tr="input",rr="navigate";

var DatePickerWrapper = styled.div(templateObject_1$p || (templateObject_1$p = __makeTemplateObject(["\n  display: contents;\n\n  .react-datepicker-wrapper {\n    display: block;\n    height: 38px;\n  }\n\n  .react-datepicker {\n    border-radius: 0px;\n  }\n\n  div.react-datepicker-popper {\n    z-index: 10000;\n  }\n  .react-datepicker__day--today,\n  .react-datepicker__day--today:hover,\n  .react-datepicker__day--selected,\n  .react-datepicker__day--selected:hover,\n  .react-datepicker__day:hover {\n    border-radius: ", ";\n  }\n\n  .react-datepicker__day--selected {\n    background-color: ", ";\n    color: ", ";\n  }\n  .react-datepicker__day--selected:hover {\n    background-color: ", ";\n  }\n  .react-datepicker__day--keyboard-selected,\n  .react-datepicker__day--keyboard-selected:hover {\n    background-color: ", ";\n  }\n"], ["\n  display: contents;\n\n  .react-datepicker-wrapper {\n    display: block;\n    height: 38px;\n  }\n\n  .react-datepicker {\n    border-radius: 0px;\n  }\n\n  div.react-datepicker-popper {\n    z-index: 10000;\n  }\n  .react-datepicker__day--today,\n  .react-datepicker__day--today:hover,\n  .react-datepicker__day--selected,\n  .react-datepicker__day--selected:hover,\n  .react-datepicker__day:hover {\n    border-radius: ", ";\n  }\n\n  .react-datepicker__day--selected {\n    background-color: ", ";\n    color: ", ";\n  }\n  .react-datepicker__day--selected:hover {\n    background-color: ", ";\n  }\n  .react-datepicker__day--keyboard-selected,\n  .react-datepicker__day--keyboard-selected:hover {\n    background-color: ", ";\n  }\n"])), radiusAction.radiusActionSm, colorSurface.brand, colorText.colorTextTextPrimary, colorSurface.secondary, colorSurface.secondary);
var templateObject_1$p;

dayjs.extend(customParseFormat);
var DEFAULT_FORMATS = ['MM-DD-YYYY', 'MM-D-YYYY', 'M-DD-YYYY', 'M-D-YYYY'];
var DEFAULT_FORMAT = 'MM-DD-YYYY';
var validateDate = function (date, defaultFormats) {
    if (defaultFormats === void 0) { defaultFormats = DEFAULT_FORMATS; }
    return dayjs(date, defaultFormats, true).isValid();
};
var toDate = function (date, defaultFormats) {
    if (defaultFormats === void 0) { defaultFormats = DEFAULT_FORMATS; }
    return dayjs(date, defaultFormats, true).toDate();
};
var formatJSDate = function (date, format) {
    if (format === void 0) { format = DEFAULT_FORMAT; }
    return dayjs(date).format(format);
};
var CustomInput = forwardRef(function (props, ref) { return (jsx(Prefix, __assign({ onClick: props.onClick, ref: ref, background: "transparent" }, { children: jsx(Icon, { name: "calendar", color: "colorIconIconSecondary" }) }))); });
CustomInput.displayName = 'InputPrefix';
var InputMaskDate = forwardRef(function (props, ref) {
    var name = props.name, id = props.id, format = props.format, validFormats = props.validFormats, prefix = props.prefix, borderWidth = props.borderWidth, onChange = props.onChange, minDate = props.minDate, size = props.size, rest = __rest(props, ["name", "id", "format", "validFormats", "prefix", "borderWidth", "onChange", "minDate", "size"]);
    var DATE_DEFAULT_FORMAT = 'MM-DD-YYYY';
    var getMask = function (format) { return format.replace(/([YMD])/gi, '9'); };
    var _a = useState(props.value || ''), value = _a[0], setValue = _a[1];
    var getSelectedDate = function () {
        if (value && validFormats && validateDate(value, validFormats || [])) {
            return toDate(value, validFormats || []);
        }
        return null;
    };
    var handleDateChange = function (date) {
        var formattedDate = formatJSDate(date, format || DATE_DEFAULT_FORMAT);
        setValue(formattedDate);
        // this makes react datepicker compatible with react-hook-form
        if (onChange) {
            onChange({
                target: {
                    value: formattedDate,
                    name: name
                }
            });
        }
    };
    var handleInputChange = function (e) {
        var inputValue = e.target.value;
        setValue(inputValue);
        props.onChange && props.onChange(e);
    };
    return (jsxs(Container$2, __assign({ "data-form-error": true, borderWidth: borderWidth, "$prefix": prefix, borderRadius: "var(--inputBorderRadius)", disabled: props.disabled, "$size": size }, { children: [jsx(DatePickerWrapper, { children: jsx(er, { selected: getSelectedDate(), onChange: handleDateChange, customInput: jsx(CustomInput, {}), minDate: minDate }) }), jsx(ChildrenContainer, { children: jsx(ReactInputMask, __assign({}, rest, { id: id || name, name: name, mask: getMask(format || DATE_DEFAULT_FORMAT), maskChar: false, inputRef: ref, autoComplete: "off", value: value, onChange: handleInputChange })) })] })));
});
InputMaskDate.displayName = 'InputMaskDate';

var Wrapper = styled.div(templateObject_1$o || (templateObject_1$o = __makeTemplateObject(["\n  display: flex;\n  width: 100%;\n  text-align: center;\n  flex-direction: column;\n\n  .filename {\n    border: 1px solid ", ";\n    border-radius: 10px;\n    padding: 8px 16px;\n    width: fit-content;\n    min-width: 200px;\n    max-width: 100%;\n    margin-top: 8px;\n    box-sizing: border-box;\n  }\n\n  .filename a {\n    overflow-wrap: anywhere;\n    color: ", ";\n    text-decoration: none;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 8px;\n  }\n\n  .filename .filename__text {\n    max-width: 280px;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n"], ["\n  display: flex;\n  width: 100%;\n  text-align: center;\n  flex-direction: column;\n\n  .filename {\n    border: 1px solid ", ";\n    border-radius: 10px;\n    padding: 8px 16px;\n    width: fit-content;\n    min-width: 200px;\n    max-width: 100%;\n    margin-top: 8px;\n    box-sizing: border-box;\n  }\n\n  .filename a {\n    overflow-wrap: anywhere;\n    color: ", ";\n    text-decoration: none;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 8px;\n  }\n\n  .filename .filename__text {\n    max-width: 280px;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n"])), colorFormBorder.colorFormBorderDefault, colorTextLink.colorTextLinkLinkPrimary);
var InputFileStyled = styled.input.attrs({ type: 'file' })(templateObject_2$9 || (templateObject_2$9 = __makeTemplateObject(["\n  height: 0;\n  opacity: 0;\n  padding: 0;\n  position: absolute;\n  width: 0;\n  z-index: -1;\n"], ["\n  height: 0;\n  opacity: 0;\n  padding: 0;\n  position: absolute;\n  width: 0;\n  z-index: -1;\n"])));
var Content$1 = styled.div(templateObject_3$5 || (templateObject_3$5 = __makeTemplateObject(["\n  ", "\n  display: flex;\n  align-items: center;\n  gap: 8px;\n"], ["\n  ", "\n  display: flex;\n  align-items: center;\n  gap: 8px;\n"])), function (_a) {
    var minWidth = _a.minWidth;
    return (minWidth ? "min-width: ".concat(minWidth, ";") : '');
});
var templateObject_1$o, templateObject_2$9, templateObject_3$5;

var FileDownload = function (_a) {
    var urlDownload = _a.urlDownload, urlDownloadText = _a.urlDownloadText, clearFile = _a.clearFile;
    return (jsx("div", __assign({ className: "filename" }, { children: jsxs("a", __assign({ target: "_blank", href: urlDownload, rel: "noreferrer" }, { children: [jsxs(Content$1, __assign({ className: "filename__text", minWidth: "0" }, { children: [jsx(Icon, { name: "title", size: "normal", color: "grayDark" }), jsx(Body, __assign({ truncable: true }, { children: urlDownloadText }))] })), clearFile && (jsx(Content$1, __assign({ onClick: clearFile, "data-testid": "file-remove-button" }, { children: jsx(Icon, { name: "close-inverted", size: "normal" }) })))] })) })));
};

var getFileData = function (file, lastFileName, lastFileUrl) {
    if (file) {
        var fileName = file.name;
        var fileUrl = URL.createObjectURL(file);
        return [fileName, fileUrl];
    }
    else if (lastFileName && lastFileUrl) {
        return typeof lastFileUrl === 'string' || (lastFileUrl === null || lastFileUrl === void 0 ? void 0 : lastFileUrl.length) > 0 ? [lastFileName, lastFileUrl] : null;
    }
    return null;
};

var InputFile = forwardRef(function (props, ref) {
    var _a = useState(null), file = _a[0], setFile = _a[1];
    var inputRef = useRef(null);
    var id = props.id, onChange = props.onChange, handleRemove = props.handleRemove, lastFileName = props.lastFileName, lastFileUrl = props.lastFileUrl, _b = props.placeholder, placeholder = _b === void 0 ? 'Attach' : _b, rest = __rest(props, ["id", "onChange", "handleRemove", "lastFileName", "lastFileUrl", "placeholder"]);
    var _c = getFileData(file, lastFileName, lastFileUrl) || [null], urlDownloadText = _c[0], urlDownload = _c[1];
    var handleFileSelect = function (e) {
        var _a;
        var selectedFile = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
        selectedFile && setFile(selectedFile);
        onChange && onChange(e);
    };
    var onRemoveFile = function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (inputRef.current) {
            inputRef.current.value = '';
            setFile(null);
        }
        handleRemove && handleRemove();
    };
    return (jsxs(Wrapper, { children: [jsx(InputFileStyled, __assign({ id: id, onChange: handleFileSelect, ref: function (node) {
                    inputRef.current = node;
                    if (typeof ref === 'function') {
                        ref(node);
                    }
                    else if (ref) {
                        ref.current = node;
                    }
                } }, rest)), jsx(Button, __assign({ variant: "tertiary", onClick: function () { var _a; return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click(); } }, { children: placeholder })), Boolean(urlDownload) && (jsx(FileDownload, { clearFile: handleRemove && onRemoveFile, urlDownloadText: urlDownloadText, urlDownload: urlDownload }))] }));
});
InputFile.displayName = 'InputFile';

var handleArrowKeyPress = function (event, selectedResult, setSelectedResult, results) {
    var result = null;
    if (event.key === 'ArrowDown') {
        event.preventDefault();
        if (selectedResult === null || selectedResult === results.length - 1) {
            result = 0;
        }
        else if (selectedResult < results.length - 1) {
            result = selectedResult + 1;
        }
        setSelectedResult(result);
    }
    else if (event.key === 'ArrowUp') {
        event.preventDefault();
        if (selectedResult === null || selectedResult === 0) {
            result = results.length - 1;
        }
        else if (selectedResult > 0) {
            result = selectedResult - 1;
        }
        setSelectedResult(result);
    }
};
var removeHTMLfromQuery = function (query) { return (query || '').replace(/<\/?[^>]+(>|$)/g, ''); };

var DynamicContainer = styled.div(templateObject_1$n || (templateObject_1$n = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var ResultsContainer = styled.div(templateObject_2$8 || (templateObject_2$8 = __makeTemplateObject(["\n  position: absolute;\n  background-color: ", ";\n  border: 2px solid ", ";\n  border-radius: var(--inputBorderRadius);\n  box-shadow: ", ";\n  padding: 8px;\n  margin-top: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  z-index: 1;\n  box-sizing: border-box;\n  width: 100%;\n  > div {\n    cursor: pointer;\n    padding: 8px;\n    &:active {\n      background-color: ", ";\n      border-radius: var(--inputBorderRadius);\n    }\n  }\n"], ["\n  position: absolute;\n  background-color: ", ";\n  border: 2px solid ", ";\n  border-radius: var(--inputBorderRadius);\n  box-shadow: ", ";\n  padding: 8px;\n  margin-top: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  z-index: 1;\n  box-sizing: border-box;\n  width: 100%;\n  > div {\n    cursor: pointer;\n    padding: 8px;\n    &:active {\n      background-color: ", ";\n      border-radius: var(--inputBorderRadius);\n    }\n  }\n"])), colorSurface.primary, colorBorder$1.colorBorderBorderPrimary, shadow.larger, colorSurface.tertiary);
var ResultItem = styled.div(templateObject_3$4 || (templateObject_3$4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var selected = _a.selected;
    return selected
        ? "\n        background-color: ".concat(colorSurface.secondary, ";\n        border-radius: var(--inputBorderRadius);")
        : '';
});
var templateObject_1$n, templateObject_2$8, templateObject_3$4;

var ResultsDropdown = function (_a) {
    var results = _a.results, selected = _a.selected, handleClick = _a.handleClick, onMouseEnter = _a.onMouseEnter;
    return (jsx(ResultsContainer, __assign({ "data-testid": "results-container" }, { children: results.map(function (item, index) { return (jsx(ResultItem, __assign({ selected: index === selected, onClick: function (event) { return handleClick(index, event); }, "data-testid": index === selected ? 'selected' : "result ".concat(index), onMouseEnter: function () { return onMouseEnter(index); } }, { children: jsx(Body, { children: jsx("span", { dangerouslySetInnerHTML: { __html: item === null || item === void 0 ? void 0 : item.label } }) }) }), index)); }) })));
};

var DynamicSearch = forwardRef(function (_a, inputRef) {
    var _b = _a.results, results = _b === void 0 ? [] : _b, clearResults = _a.clearResults, getResults = _a.getResults, onSubmit = _a.onSubmit, onChangeInput = _a.onChangeInput, _c = _a.maxResultsDisplayed, maxResultsDisplayed = _c === void 0 ? 5 : _c, _d = _a.debounceTime, debounceTime = _d === void 0 ? 300 : _d, value = _a.value, mandatoryOption = _a.mandatoryOption, rest = __rest(_a, ["results", "clearResults", "getResults", "onSubmit", "onChangeInput", "maxResultsDisplayed", "debounceTime", "value", "mandatoryOption"]);
    var slicedResults = results.slice(0, maxResultsDisplayed);
    var resultsAvailable = slicedResults.length > 0;
    var _e = useIsComponentVisible(true), ref = _e.ref, isComponentVisible = _e.isComponentVisible, setIsComponentVisible = _e.setIsComponentVisible;
    var _f = useState(resultsAvailable), showResults = _f[0], setShowResults = _f[1];
    var _g = useState(null), selectedResult = _g[0], setSelectedResult = _g[1];
    var _h = useState(value ? value.label : ''), query = _h[0], setQuery = _h[1];
    var debouncedGetResults = useMemo(function () { return debounce$1(debounceTime, function (query, callback) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, callback(query)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    }); }); }); }, []);
    useEffect(function () {
        setQuery(value ? value.label : '');
    }, [value]);
    useEffect(function () {
        if (!showResults && resultsAvailable) {
            setShowResults(true);
        }
        else if (!resultsAvailable) {
            setShowResults(false);
        }
    }, [slicedResults]);
    var handleSubmit = function (selectedIndex, event) {
        if (!onSubmit)
            return;
        event && event.stopPropagation();
        var value;
        if (selectedIndex) {
            value = slicedResults[selectedIndex];
        }
        else if (selectedResult !== null) {
            value = slicedResults[selectedResult];
        }
        value || (value = { label: query });
        var sanitizedQuery = removeHTMLfromQuery(value === null || value === void 0 ? void 0 : value.label);
        value.label = sanitizedQuery;
        setQuery(sanitizedQuery);
        onSubmit(value);
        setIsComponentVisible(false);
    };
    var handleKeyDown = function (event) {
        handleArrowKeyPress(event, selectedResult, setSelectedResult, slicedResults);
        if (event.key === 'Enter') {
            var isMandatoryOptionWithValue = mandatoryOption && selectedResult !== null && selectedResult >= 0;
            if (isMandatoryOptionWithValue || !mandatoryOption || !query) {
                handleSubmit();
            }
        }
    };
    var handleInputChange = function (e) {
        var value = e.target.value;
        onChangeInput && onChangeInput(value || '');
        setQuery(value);
        setSelectedResult(null);
        setIsComponentVisible(true);
        if (value.length > 1) {
            debouncedGetResults(e.target.value, getResults);
        }
        else {
            clearResults();
        }
    };
    return (jsxs(DynamicContainer, __assign({ ref: ref }, { children: [jsx(InputSearch, __assign({ onKeyDown: handleKeyDown, value: query, onChange: handleInputChange }, rest, { ref: inputRef })), showResults && query !== '' && isComponentVisible && (jsx(ResultsDropdown, { onMouseEnter: setSelectedResult, results: slicedResults, selected: selectedResult, handleClick: handleSubmit }))] })));
});
DynamicSearch.displayName = 'DynamicSearch';

var Container$1 = styled.div(templateObject_1$m || (templateObject_1$m = __makeTemplateObject(["\n  display: flex;\n  width: 100%;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 16px;\n  border-radius: var(--borderRadiusSmaller);\n  border: 1px solid;\n  ", "\n  ", "\n"], ["\n  display: flex;\n  width: 100%;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 16px;\n  border-radius: var(--borderRadiusSmaller);\n  border: 1px solid;\n  ", "\n  ", "\n"])), function (_a) {
    var color = _a.color;
    return (color ? "background-color: ".concat(getLegacyColor(color), ";") : "");
}, function (_a) {
    var borderColor = _a.borderColor;
    return (borderColor ? "border-color: ".concat(getBorderColor(borderColor), ";") : "");
});
var templateObject_1$m;

var Message = function (_a) {
    var className = _a.className, color = _a.color, borderColor = _a.borderColor, iconName = _a.iconName, _b = _a.iconSize, iconSize = _b === void 0 ? 'normal' : _b, iconColor = _a.iconColor, children = _a.children;
    return (jsxs(Container$1, __assign({ className: className, color: color, borderColor: borderColor }, { children: [Boolean(iconName) && jsx(Icon, { name: iconName, size: iconSize, color: iconColor }), children] })));
};

var SvgContainer = styled.div(templateObject_1$l || (templateObject_1$l = __makeTemplateObject(["\n  height: 100%;\n  width: 100%;\n  animation: fade 1s;\n  @keyframes fade {\n    0% {\n      opacity: 0.2;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n"], ["\n  height: 100%;\n  width: 100%;\n  animation: fade 1s;\n  @keyframes fade {\n    0% {\n      opacity: 0.2;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n"])));
var Svg = styled.svg.attrs({
    width: '100%',
    height: '100%',
    viewBox: '0 0 40 40'
})(templateObject_2$7 || (templateObject_2$7 = __makeTemplateObject([""], [""])));
var Title = styled.tspan(templateObject_3$3 || (templateObject_3$3 = __makeTemplateObject(["\n  color: var(--black);\n  text-align: center;\n  font-family: ", ";\n  font-size: 10px;\n  font-weight: ", ";\n  animation: fade 1s;\n"], ["\n  color: var(--black);\n  text-align: center;\n  font-family: ", ";\n  font-size: 10px;\n  font-weight: ", ";\n  animation: fade 1s;\n"])), fontFamily, weightMap$1.bold);
var Subtitle = styled.tspan(templateObject_4$3 || (templateObject_4$3 = __makeTemplateObject(["\n  animation: fade 1s;\n  color: var(--black);\n  text-align: center;\n  font-family: ", ";\n  font-size: 10px;\n  font-weight: ", ";\n"], ["\n  animation: fade 1s;\n  color: var(--black);\n  text-align: center;\n  font-family: ", ";\n  font-size: 10px;\n  font-weight: ", ";\n"])), fontFamily, weightMap$1.regular);
var Donut = styled.circle.attrs({
    cx: 20,
    cy: 20,
    fill: customColors.transparent
})(templateObject_5$2 || (templateObject_5$2 = __makeTemplateObject([""], [""])));
var DonutHole = styled(Donut)(templateObject_6$1 || (templateObject_6$1 = __makeTemplateObject(["\n  fill: ", ";\n"], ["\n  fill: ", ";\n"])), function (_a) {
    var color = _a.color;
    return "".concat(getLegacyColor(color), ";");
});
var DonutRing = styled(Donut)(templateObject_7$1 || (templateObject_7$1 = __makeTemplateObject(["\n  stroke: ", ";\n"], ["\n  stroke: ", ";\n"])), function (_a) {
    var color = _a.color;
    return "".concat(getLegacyColor(color), ";");
});
var DonutSegment = styled(Donut)(templateObject_8$1 || (templateObject_8$1 = __makeTemplateObject(["\n  transform-origin: center;\n  stroke: ", ";\n  animation: animateSegment 1s;\n  transform: rotate(-90deg);\n\n  @keyframes animateSegment {\n    0% {\n      stroke-dasharray: 0, ", ";\n    }\n    100% {\n      stroke-dasharray: ", ";\n    }\n  }\n"], ["\n  transform-origin: center;\n  stroke: ", ";\n  animation: animateSegment 1s;\n  transform: rotate(-90deg);\n\n  @keyframes animateSegment {\n    0% {\n      stroke-dasharray: 0, ", ";\n    }\n    100% {\n      stroke-dasharray: ", ";\n    }\n  }\n"])), function (_a) {
    var color = _a.color;
    return "".concat(getLegacyColor(color), ";");
}, function (_a) {
    var circunference = _a.circunference;
    return "".concat(circunference);
}, function (_a) {
    var strokeDasharray = _a.strokeDasharray;
    return "".concat(strokeDasharray);
});
var Content = function (_a) {
    var title = _a.title, subtitle = _a.subtitle;
    return (jsxs("g", __assign({ className: "donut-text donut-text-1" }, { children: [Boolean(title) && (jsx("text", __assign({ y: "45%", transform: "translate(0, 2)" }, { children: jsx(Title, __assign({ x: "50%", textAnchor: "middle" }, { children: title })) }))), Boolean(subtitle) && (jsx("text", __assign({ y: "65%", transform: "translate(0, 2)" }, { children: jsx(Subtitle, __assign({ x: "50%", textAnchor: "middle" }, { children: subtitle })) })))] })));
};
var templateObject_1$l, templateObject_2$7, templateObject_3$3, templateObject_4$3, templateObject_5$2, templateObject_6$1, templateObject_7$1, templateObject_8$1;

var DonutChart = function (_a) {
    var value = _a.value, _b = _a.backgroundColor, backgroundColor = _b === void 0 ? 'transparent' : _b, _c = _a.color1, color1 = _c === void 0 ? 'primary' : _c, _d = _a.color2, color2 = _d === void 0 ? 'grayLight' : _d, title = _a.title, subtitle = _a.subtitle, _e = _a.strokeWidth, strokeWidth = _e === void 0 ? 2 : _e;
    var radius = 40 / 2 - strokeWidth;
    var circunference = 2 * Math.PI * radius;
    var strokeDasharray = "".concat(circunference * (value / 100), " ").concat(circunference);
    return (jsx(SvgContainer, { children: jsxs(Svg, { children: [jsx(DonutHole, { color: backgroundColor, r: radius }), jsx(DonutRing, { color: color2, r: radius, strokeWidth: strokeWidth }), jsx(DonutSegment, { r: radius, strokeWidth: strokeWidth, strokeDasharray: strokeDasharray, color: color1, circunference: circunference }), jsx(Content, { title: title, subtitle: subtitle })] }) }));
};

function useMediaQuery(query, doNotEvaluateInitialValue, initialValue) {
    if (doNotEvaluateInitialValue === void 0) { doNotEvaluateInitialValue = false; }
    if (initialValue === void 0) { initialValue = false; }
    var getMatches = function (query) {
        // Prevents SSR issues
        if (typeof window !== 'undefined') {
            return window.matchMedia(query).matches;
        }
        return false;
    };
    var getInitialValue = function () {
        if (doNotEvaluateInitialValue) {
            return initialValue;
        }
        return getMatches(query);
    };
    var _a = useState(getInitialValue()), matches = _a[0], setMatches = _a[1];
    function handleChange() {
        setMatches(getMatches(query));
    }
    useEffect(function () {
        var matchMedia = window.matchMedia(query);
        // Triggered at the first client-side load and if query changes
        handleChange();
        // Listen matchMedia
        if (matchMedia.addListener) {
            matchMedia.addListener(handleChange);
        }
        else {
            matchMedia.addEventListener('change', handleChange);
        }
        return function () {
            if (matchMedia.removeListener) {
                matchMedia.removeListener(handleChange);
            }
            else {
                matchMedia.removeEventListener('change', handleChange);
            }
        };
    }, [query]);
    return matches;
}

/**
 * Custom hook to determine the type of media device being used.
 *
 * @param doNotEvaluateInitialValue - When true, it will evaluate the media device on mount.
 *                                    It causes errors on server-side render, so please set it as true
 *                                    for components that will be HYDRATED.
 * @returns An object containing boolean values indicating the type of media device:
 *          - `isDesktop`: true if the device is a desktop.
 *          - `isSmallDesktop`: true if the device is a small desktop.
 *          - `isTablet`: true if the device is a tablet.
 *          - `isMobile`: true if the device is a mobile.
 */
var useMediaDevices = function (doNotEvaluateInitialValue) {
    if (doNotEvaluateInitialValue === void 0) { doNotEvaluateInitialValue = false; }
    var isDesktop = useMediaQuery(mediaDevicesSizeMap.desktop, doNotEvaluateInitialValue);
    var isSmallDesktop = useMediaQuery(mediaDevicesSizeMap.smallDesktop, doNotEvaluateInitialValue);
    var isTablet = useMediaQuery(mediaDevicesSizeMap.tablet, doNotEvaluateInitialValue);
    var isMobile = useMediaQuery(mediaDevicesSizeMap.mobile, doNotEvaluateInitialValue);
    return { isDesktop: isDesktop, isSmallDesktop: isSmallDesktop, isTablet: isTablet, isMobile: isMobile };
};

var userNavigationPermissions = {
    show_dealership_purchases: 'show_dealership_purchases',
    show_group_listings: 'show_group_listings',
    show_marketplace: 'show_marketplace',
    show_offers_made: 'show_offers_made',
    show_private_marketplace: 'show_private_marketplace',
    show_search: 'show_search',
    show_sell_tab_as_dropdown: 'show_sell_tab_as_dropdown',
    show_sell_vehicles: 'show_sell_vehicles',
    show_timed_sale_inventory: 'show_timed_sale_inventory',
    show_buyer_auction: 'show_buyer_auction',
    show_seller_auction: 'show_seller_auction',
    show_title_clerk: 'show_title_clerk',
    show_gtv_offers: 'show_gtv_offers',
    show_badge_alert: 'show_badge_alert',
    show_private_auction: 'show_private_auction',
    show_sell_tab: 'show_sell_tab',
    show_search_mobile_tabs: 'show_search_mobile_tabs',
    show_transport: 'show_transport',
    show_new_referral: 'show_new_referral',
    show_unified_marketplace_react: 'show_unified_marketplace_react'
};

var useAdjustedStep = function (activeStep, totalSteps) {
    var step = useMemo(function () {
        if (activeStep < 1)
            return 1;
        if (activeStep > totalSteps)
            return totalSteps;
        return activeStep;
    }, [activeStep]);
    return step;
};

var Step = styled.div(templateObject_1$k || (templateObject_1$k = __makeTemplateObject(["\n  ", "\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2;\n"], ["\n  ", "\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2;\n"])), function (_a) {
    var active = _a.active, filled = _a.filled;
    return "\n  background: ".concat(filled ? customColors.primary : colorSurface.primary, ";\n  border: 1px solid ").concat(active ? customColors.primary : colorBorder$1.colorBorderBorderPrimary, ";\n");
});
var Divider = styled.div(templateObject_2$6 || (templateObject_2$6 = __makeTemplateObject(["\n  ", "\n  height: 8px;\n  border-radius: 0 16px 16px 0;\n  left: 10%;\n  position: absolute;\n  width: 95%;\n  z-index: 1;\n"], ["\n  ", "\n  height: 8px;\n  border-radius: 0 16px 16px 0;\n  left: 10%;\n  position: absolute;\n  width: 95%;\n  z-index: 1;\n"])), function (_a) {
    var filled = _a.filled;
    return "\n      background-color: ".concat(filled ? customColors.primary : colorSurface.primary, ";\n      border: 1px solid ").concat(colorBorder$1.colorBorderBorderPrimary, ";\n  ");
});
var templateObject_1$k, templateObject_2$6;

var StepperTitle = styled(Body).attrs({ size: 'largest', color: 'secondary', bold: true })(templateObject_1$j || (templateObject_1$j = __makeTemplateObject([""], [""])));
var templateObject_1$j;

var DesktopVariant = function (_a) {
    var steps = _a.steps, activeStep = _a.activeStep;
    var step = useAdjustedStep(activeStep, steps.length);
    var activeStepInfo = steps[step - 1];
    return (jsxs(FlexBox, __assign({ flexDirection: "column" }, { children: [jsx(FlexBox, __assign({ padding: "16px 0" }, { children: jsx(StepperTitle, { children: activeStepInfo === null || activeStepInfo === void 0 ? void 0 : activeStepInfo.title }) })), jsx(FlexBox, __assign({ alignItems: "center" }, { children: steps.map(function (_, i) {
                    var disabled = step > i + 1;
                    var active = i + 1 === step;
                    var filled = i + 1 < step;
                    var stepWidth = i + 1 === steps.length ? '20px' : "".concat(100 / (steps.length - 1), "%");
                    return (jsxs(FlexBox, __assign({ position: "relative", width: stepWidth, alignItems: "center" }, { children: [jsx(Step, __assign({ active: active, disabled: disabled, filled: filled }, { children: jsx(Body, __assign({ color: filled ? 'white' : active ? 'primary' : 'grayLight', type: "caption" }, { children: i + 1 })) })), steps.length - 1 !== i && jsx(Divider, { filled: filled })] }), "step-".concat(i + 1)));
                }) })), jsx(FlexBox, __assign({ padding: "16px 0" }, { children: jsx(Body, { children: activeStepInfo === null || activeStepInfo === void 0 ? void 0 : activeStepInfo.description }) }))] })));
};

var ProgressBarContainer = styled.div(templateObject_1$i || (templateObject_1$i = __makeTemplateObject(["\n  width: 100%;\n  border: 1px solid ", ";\n  border-radius: 16px;\n  height: 8px;\n  z-index: 1;\n"], ["\n  width: 100%;\n  border: 1px solid ", ";\n  border-radius: 16px;\n  height: 8px;\n  z-index: 1;\n"])), colorBorder$1.colorBorderBorderPrimary);
var ProgressIndicator = styled.div(templateObject_2$5 || (templateObject_2$5 = __makeTemplateObject(["\n  width: ", ";\n  background-color: ", ";\n  height: 8px;\n  border-radius: 16px;\n  border-right: 1px solid ", ";\n"], ["\n  width: ", ";\n  background-color: ", ";\n  height: 8px;\n  border-radius: 16px;\n  border-right: 1px solid ", ";\n"])), function (_a) {
    var progress = _a.progress;
    return "".concat(progress, "%");
}, customColors.primary, colorBorder$1.colorBorderBorderPrimary);
var templateObject_1$i, templateObject_2$5;

var ProgressBar = function (_a) {
    var progress = _a.progress;
    return (jsx(ProgressBarContainer, { children: jsx(ProgressIndicator, { progress: progress }) }));
};

var MobileProgressVariant = function (_a) {
    var steps = _a.steps, activeStep = _a.activeStep;
    var step = useAdjustedStep(activeStep, steps.length);
    var progress = (100 / steps.length) * step;
    return (jsxs(FlexBox, __assign({ flexDirection: "column" }, { children: [jsx(ProgressBar, { progress: progress }), jsx(FlexBox, __assign({ justifyContent: "space-between" }, { children: steps.map(function (_a, i) {
                    var title = _a.title;
                    var disabled = i + 1 > step;
                    var color = disabled ? 'grayLight' : step === i + 1 ? 'primary' : 'secondary';
                    return (jsx(FlexBox, __assign({ justifyContent: "center", width: "35px", textAlign: "center", padding: "12px 0 0 0" }, { children: jsx(Body, __assign({ type: "caption", color: color }, { children: title })) }), "step-".concat(i)));
                }) }))] })));
};

var MobileStepsVariant = function (_a) {
    var activeStep = _a.activeStep, steps = _a.steps;
    var step = useAdjustedStep(activeStep, steps.length);
    var progress = (100 / steps.length) * step;
    var activeStepInfo = steps[step - 1];
    return (jsxs(FlexBox, __assign({ flexDirection: "column" }, { children: [jsxs(FlexBox, __assign({ justifyContent: "space-between", padding: "16px 0", alignItems: "center" }, { children: [jsx(StepperTitle, { children: activeStepInfo.title }), jsxs(Body, __assign({ color: "secondary", bold: true }, { children: ["(step ", step, "/", steps.length, ")"] }))] })), jsx(ProgressBar, { progress: progress }), jsx(FlexBox, __assign({ padding: "16px 0" }, { children: jsx(Body, { children: activeStepInfo.description }) }))] })));
};

var variants$1 = {
    desktop: 'desktop',
    mobileProgress: 'mobileProgress',
    mobileSteps: 'mobileSteps'
};

var _a;
var mobileProgress = variants$1.mobileProgress, mobileSteps = variants$1.mobileSteps, desktop = variants$1.desktop;
var componentVariants = (_a = {},
    _a[mobileProgress] = MobileProgressVariant,
    _a[mobileSteps] = MobileStepsVariant,
    _a[desktop] = DesktopVariant,
    _a);
var Stepper = function (props) {
    var _a = props.variant, variant = _a === void 0 ? desktop : _a;
    var Variant = componentVariants[variant];
    return jsx(Variant, __assign({}, props));
};

function ownKeys$2(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$2(Object(t), !0).forEach(function (r) {
      _defineProperty$2(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}

function _arrayWithoutHoles$2(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$2(arr);
}

function _iterableToArray$2(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _nonIterableSpread$2() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray$2(arr) {
  return _arrayWithoutHoles$2(arr) || _iterableToArray$2(arr) || _unsupportedIterableToArray$2(arr) || _nonIterableSpread$2();
}

function _arrayWithHoles$2(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit$2(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

function _nonIterableRest$2() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray$2(arr, i) {
  return _arrayWithHoles$2(arr) || _iterableToArrayLimit$2(arr, i) || _unsupportedIterableToArray$2(arr, i) || _nonIterableRest$2();
}

function useEvent(callback) {
  var fnRef = React.useRef();
  fnRef.current = callback;
  var memoFn = React.useCallback(function () {
    var _fnRef$current;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (_fnRef$current = fnRef.current) === null || _fnRef$current === void 0 ? void 0 : _fnRef$current.call.apply(_fnRef$current, [fnRef].concat(args));
  }, []);
  return memoFn;
}

function canUseDom() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}

/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */
var useInternalLayoutEffect = process.env.NODE_ENV !== 'test' && canUseDom() ? React.useLayoutEffect : React.useEffect;
var useLayoutEffect = function useLayoutEffect(callback, deps) {
  var firstMountRef = React.useRef(true);
  useInternalLayoutEffect(function () {
    return callback(firstMountRef.current);
  }, deps);

  // We tell react that first mount has passed
  useInternalLayoutEffect(function () {
    firstMountRef.current = false;
    return function () {
      firstMountRef.current = true;
    };
  }, []);
};
var useLayoutUpdateEffect = function useLayoutUpdateEffect(callback, deps) {
  useLayoutEffect(function (firstMount) {
    if (!firstMount) {
      return callback();
    }
  }, deps);
};

/**
 * Same as React.useState but `setState` accept `ignoreDestroy` param to not to setState after destroyed.
 * We do not make this auto is to avoid real memory leak.
 * Developer should confirm it's safe to ignore themselves.
 */
function useSafeState(defaultValue) {
  var destroyRef = React.useRef(false);
  var _React$useState = React.useState(defaultValue),
    _React$useState2 = _slicedToArray$2(_React$useState, 2),
    value = _React$useState2[0],
    setValue = _React$useState2[1];
  React.useEffect(function () {
    destroyRef.current = false;
    return function () {
      destroyRef.current = true;
    };
  }, []);
  function safeSetState(updater, ignoreDestroy) {
    if (ignoreDestroy && destroyRef.current) {
      return;
    }
    setValue(updater);
  }
  return [value, safeSetState];
}

/** We only think `undefined` is empty */
function hasValue(value) {
  return value !== undefined;
}

/**
 * Similar to `useState` but will use props value if provided.
 * Note that internal use rc-util `useState` hook.
 */
function useMergedState(defaultStateValue, option) {
  var _ref = option || {},
    defaultValue = _ref.defaultValue,
    value = _ref.value,
    onChange = _ref.onChange,
    postState = _ref.postState;

  // ======================= Init =======================
  var _useState = useSafeState(function () {
      if (hasValue(value)) {
        return value;
      } else if (hasValue(defaultValue)) {
        return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
      } else {
        return typeof defaultStateValue === 'function' ? defaultStateValue() : defaultStateValue;
      }
    }),
    _useState2 = _slicedToArray$2(_useState, 2),
    innerValue = _useState2[0],
    setInnerValue = _useState2[1];
  var mergedValue = value !== undefined ? value : innerValue;
  var postMergedValue = postState ? postState(mergedValue) : mergedValue;

  // ====================== Change ======================
  var onChangeFn = useEvent(onChange);
  var _useState3 = useSafeState([mergedValue]),
    _useState4 = _slicedToArray$2(_useState3, 2),
    prevValue = _useState4[0],
    setPrevValue = _useState4[1];
  useLayoutUpdateEffect(function () {
    var prev = prevValue[0];
    if (innerValue !== prev) {
      onChangeFn(innerValue, prev);
    }
  }, [prevValue]);

  // Sync value back to `undefined` when it from control to un-control
  useLayoutUpdateEffect(function () {
    if (!hasValue(value)) {
      setInnerValue(value);
    }
  }, [value]);

  // ====================== Update ======================
  var triggerChange = useEvent(function (updater, ignoreDestroy) {
    setInnerValue(updater, ignoreDestroy);
    setPrevValue([mergedValue], ignoreDestroy);
  });
  return [postMergedValue, triggerChange];
}

var reactIsExports = {};
var reactIs = {
  get exports(){ return reactIsExports; },
  set exports(v){ reactIsExports = v; },
};

var reactIs_production_min = {};

/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min;

function requireReactIs_production_min () {
	if (hasRequiredReactIs_production_min) return reactIs_production_min;
	hasRequiredReactIs_production_min = 1;
var b=Symbol.for("react.element"),c=Symbol.for("react.portal"),d=Symbol.for("react.fragment"),e=Symbol.for("react.strict_mode"),f=Symbol.for("react.profiler"),g=Symbol.for("react.provider"),h=Symbol.for("react.context"),k=Symbol.for("react.server_context"),l=Symbol.for("react.forward_ref"),m=Symbol.for("react.suspense"),n=Symbol.for("react.suspense_list"),p=Symbol.for("react.memo"),q=Symbol.for("react.lazy"),t=Symbol.for("react.offscreen"),u;u=Symbol.for("react.module.reference");
	function v(a){if("object"===typeof a&&null!==a){var r=a.$$typeof;switch(r){case b:switch(a=a.type,a){case d:case f:case e:case m:case n:return a;default:switch(a=a&&a.$$typeof,a){case k:case h:case l:case q:case p:case g:return a;default:return r}}case c:return r}}}reactIs_production_min.ContextConsumer=h;reactIs_production_min.ContextProvider=g;reactIs_production_min.Element=b;reactIs_production_min.ForwardRef=l;reactIs_production_min.Fragment=d;reactIs_production_min.Lazy=q;reactIs_production_min.Memo=p;reactIs_production_min.Portal=c;reactIs_production_min.Profiler=f;reactIs_production_min.StrictMode=e;reactIs_production_min.Suspense=m;
	reactIs_production_min.SuspenseList=n;reactIs_production_min.isAsyncMode=function(){return !1};reactIs_production_min.isConcurrentMode=function(){return !1};reactIs_production_min.isContextConsumer=function(a){return v(a)===h};reactIs_production_min.isContextProvider=function(a){return v(a)===g};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===b};reactIs_production_min.isForwardRef=function(a){return v(a)===l};reactIs_production_min.isFragment=function(a){return v(a)===d};reactIs_production_min.isLazy=function(a){return v(a)===q};reactIs_production_min.isMemo=function(a){return v(a)===p};
	reactIs_production_min.isPortal=function(a){return v(a)===c};reactIs_production_min.isProfiler=function(a){return v(a)===f};reactIs_production_min.isStrictMode=function(a){return v(a)===e};reactIs_production_min.isSuspense=function(a){return v(a)===m};reactIs_production_min.isSuspenseList=function(a){return v(a)===n};
	reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===d||a===f||a===e||a===m||a===n||a===t||"object"===typeof a&&null!==a&&(a.$$typeof===q||a.$$typeof===p||a.$$typeof===g||a.$$typeof===h||a.$$typeof===l||a.$$typeof===u||void 0!==a.getModuleId)?!0:!1};reactIs_production_min.typeOf=v;
	return reactIs_production_min;
}

var reactIs_development = {};

/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development;

function requireReactIs_development () {
	if (hasRequiredReactIs_development) return reactIs_development;
	hasRequiredReactIs_development = 1;

	if (process.env.NODE_ENV !== "production") {
	  (function() {

	// ATTENTION
	// When adding new symbols to this file,
	// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
	// The Symbol used to tag the ReactElement-like types.
	var REACT_ELEMENT_TYPE = Symbol.for('react.element');
	var REACT_PORTAL_TYPE = Symbol.for('react.portal');
	var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
	var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
	var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
	var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
	var REACT_CONTEXT_TYPE = Symbol.for('react.context');
	var REACT_SERVER_CONTEXT_TYPE = Symbol.for('react.server_context');
	var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
	var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
	var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
	var REACT_MEMO_TYPE = Symbol.for('react.memo');
	var REACT_LAZY_TYPE = Symbol.for('react.lazy');
	var REACT_OFFSCREEN_TYPE = Symbol.for('react.offscreen');

	// -----------------------------------------------------------------------------

	var enableScopeAPI = false; // Experimental Create Event Handle API.
	var enableCacheElement = false;
	var enableTransitionTracing = false; // No known bugs, but needs performance testing

	var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
	// stuff. Intended to enable React core members to more easily debug scheduling
	// issues in DEV builds.

	var enableDebugTracing = false; // Track which Fiber(s) schedule render work.

	var REACT_MODULE_REFERENCE;

	{
	  REACT_MODULE_REFERENCE = Symbol.for('react.module.reference');
	}

	function isValidElementType(type) {
	  if (typeof type === 'string' || typeof type === 'function') {
	    return true;
	  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


	  if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing  || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden  || type === REACT_OFFSCREEN_TYPE || enableScopeAPI  || enableCacheElement  || enableTransitionTracing ) {
	    return true;
	  }

	  if (typeof type === 'object' && type !== null) {
	    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
	    // types supported by any Flight configuration anywhere since
	    // we don't know which Flight build this will end up being used
	    // with.
	    type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) {
	      return true;
	    }
	  }

	  return false;
	}

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;

	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	          case REACT_SUSPENSE_LIST_TYPE:
	            return type;

	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_SERVER_CONTEXT_TYPE:
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;

	              default:
	                return $$typeof;
	            }

	        }

	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	}
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var SuspenseList = REACT_SUSPENSE_LIST_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false;
	var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated

	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
	    }
	  }

	  return false;
	}
	function isConcurrentMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
	      hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isConcurrentMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
	    }
	  }

	  return false;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}
	function isSuspenseList(object) {
	  return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
	}

	reactIs_development.ContextConsumer = ContextConsumer;
	reactIs_development.ContextProvider = ContextProvider;
	reactIs_development.Element = Element;
	reactIs_development.ForwardRef = ForwardRef;
	reactIs_development.Fragment = Fragment;
	reactIs_development.Lazy = Lazy;
	reactIs_development.Memo = Memo;
	reactIs_development.Portal = Portal;
	reactIs_development.Profiler = Profiler;
	reactIs_development.StrictMode = StrictMode;
	reactIs_development.Suspense = Suspense;
	reactIs_development.SuspenseList = SuspenseList;
	reactIs_development.isAsyncMode = isAsyncMode;
	reactIs_development.isConcurrentMode = isConcurrentMode;
	reactIs_development.isContextConsumer = isContextConsumer;
	reactIs_development.isContextProvider = isContextProvider;
	reactIs_development.isElement = isElement;
	reactIs_development.isForwardRef = isForwardRef;
	reactIs_development.isFragment = isFragment;
	reactIs_development.isLazy = isLazy;
	reactIs_development.isMemo = isMemo;
	reactIs_development.isPortal = isPortal;
	reactIs_development.isProfiler = isProfiler;
	reactIs_development.isStrictMode = isStrictMode;
	reactIs_development.isSuspense = isSuspense;
	reactIs_development.isSuspenseList = isSuspenseList;
	reactIs_development.isValidElementType = isValidElementType;
	reactIs_development.typeOf = typeOf;
	  })();
	}
	return reactIs_development;
}

(function (module) {

	if (process.env.NODE_ENV === 'production') {
	  module.exports = requireReactIs_production_min();
	} else {
	  module.exports = requireReactIs_development();
	}
} (reactIs));

function isReactElement(node) {
  return /*#__PURE__*/isValidElement(node) && !reactIsExports.isFragment(node);
}

/**
 * In React 19. `ref` is not a property from node.
 * But a property from `props.ref`.
 * To check if `props.ref` exist or fallback to `ref`.
 */
Number(version.split('.')[0]) >= 19 ?
// >= React 19
function (node) {
  if (isReactElement(node)) {
    return node.props.ref;
  }
  return null;
} :
// < React 19
function (node) {
  if (isReactElement(node)) {
    return node.ref;
  }
  return null;
};

/* eslint-disable no-console */
var warned = {};
var preWarningFns = [];

/**
 * Pre warning enable you to parse content before console.error.
 * Modify to null will prevent warning.
 */
var preMessage = function preMessage(fn) {
  preWarningFns.push(fn);
};

/**
 * Warning if condition not match.
 * @param valid Condition
 * @param message Warning message
 * @example
 * ```js
 * warning(false, 'some error'); // print some error
 * warning(true, 'some error'); // print nothing
 * warning(1 === 2, 'some error'); // print some error
 * ```
 */
function warning$1(valid, message) {
  if (process.env.NODE_ENV !== 'production' && !valid && console !== undefined) {
    var finalMessage = preWarningFns.reduce(function (msg, preMessageFn) {
      return preMessageFn(msg !== null && msg !== void 0 ? msg : '', 'warning');
    }, message);
    if (finalMessage) {
      console.error("Warning: ".concat(finalMessage));
    }
  }
}

/** @see Similar to {@link warning} */
function note(valid, message) {
  if (process.env.NODE_ENV !== 'production' && !valid && console !== undefined) {
    var finalMessage = preWarningFns.reduce(function (msg, preMessageFn) {
      return preMessageFn(msg !== null && msg !== void 0 ? msg : '', 'note');
    }, message);
    if (finalMessage) {
      console.warn("Note: ".concat(finalMessage));
    }
  }
}
function resetWarned() {
  warned = {};
}
function call(method, valid, message) {
  if (!valid && !warned[message]) {
    method(false, message);
    warned[message] = true;
  }
}

/** @see Same as {@link warning}, but only warn once for the same message */
function warningOnce(valid, message) {
  call(warning$1, valid, message);
}

/** @see Same as {@link warning}, but only warn once for the same message */
function noteOnce(valid, message) {
  call(note, valid, message);
}
warningOnce.preMessage = preMessage;
warningOnce.resetWarned = resetWarned;
warningOnce.noteOnce = noteOnce;

/**
 * Deeply compares two object literals.
 * @param obj1 object 1
 * @param obj2 object 2
 * @param shallow shallow compare
 * @returns
 */
function isEqual(obj1, obj2) {
  var shallow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  // https://github.com/mapbox/mapbox-gl-js/pull/5979/files#diff-fde7145050c47cc3a306856efd5f9c3016e86e859de9afbd02c879be5067e58f
  var refSet = new Set();
  function deepEqual(a, b) {
    var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var circular = refSet.has(a);
    warningOnce(!circular, 'Warning: There may be circular references');
    if (circular) {
      return false;
    }
    if (a === b) {
      return true;
    }
    if (shallow && level > 1) {
      return false;
    }
    refSet.add(a);
    var newLevel = level + 1;
    if (Array.isArray(a)) {
      if (!Array.isArray(b) || a.length !== b.length) {
        return false;
      }
      for (var i = 0; i < a.length; i++) {
        if (!deepEqual(a[i], b[i], newLevel)) {
          return false;
        }
      }
      return true;
    }
    if (a && b && _typeof(a) === 'object' && _typeof(b) === 'object') {
      var keys = Object.keys(a);
      if (keys.length !== Object.keys(b).length) {
        return false;
      }
      return keys.every(function (key) {
        return deepEqual(a[key], b[key], newLevel);
      });
    }
    // other
    return false;
  }
  return deepEqual(obj1, obj2);
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$1(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

function getOffset(value, min, max) {
  return (value - min) / (max - min);
}
function getDirectionStyle(direction, value, min, max) {
  var offset = getOffset(value, min, max);
  var positionStyle = {};
  switch (direction) {
    case 'rtl':
      positionStyle.right = "".concat(offset * 100, "%");
      positionStyle.transform = 'translateX(50%)';
      break;
    case 'btt':
      positionStyle.bottom = "".concat(offset * 100, "%");
      positionStyle.transform = 'translateY(50%)';
      break;
    case 'ttb':
      positionStyle.top = "".concat(offset * 100, "%");
      positionStyle.transform = 'translateY(-50%)';
      break;
    default:
      positionStyle.left = "".concat(offset * 100, "%");
      positionStyle.transform = 'translateX(-50%)';
      break;
  }
  return positionStyle;
}

/** Return index value if is list or return value directly */
function getIndex(value, index) {
  return Array.isArray(value) ? value[index] : value;
}

/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */

var KeyCode = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,
  // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * PAUSE
   */
  PAUSE: 19,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33,
  // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,
  // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35,
  // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36,
  // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37,
  // also NUM_WEST
  /**
   * UP
   */
  UP: 38,
  // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39,
  // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40,
  // also NUM_SOUTH
  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,
  /**
   * INSERT
   */
  INSERT: 45,
  // also NUM_INSERT
  /**
   * DELETE
   */
  DELETE: 46,
  // also NUM_DELETE
  /**
   * ZERO
   */
  ZERO: 48,
  /**
   * ONE
   */
  ONE: 49,
  /**
   * TWO
   */
  TWO: 50,
  /**
   * THREE
   */
  THREE: 51,
  /**
   * FOUR
   */
  FOUR: 52,
  /**
   * FIVE
   */
  FIVE: 53,
  /**
   * SIX
   */
  SIX: 54,
  /**
   * SEVEN
   */
  SEVEN: 55,
  /**
   * EIGHT
   */
  EIGHT: 56,
  /**
   * NINE
   */
  NINE: 57,
  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,
  // needs localization
  /**
   * A
   */
  A: 65,
  /**
   * B
   */
  B: 66,
  /**
   * C
   */
  C: 67,
  /**
   * D
   */
  D: 68,
  /**
   * E
   */
  E: 69,
  /**
   * F
   */
  F: 70,
  /**
   * G
   */
  G: 71,
  /**
   * H
   */
  H: 72,
  /**
   * I
   */
  I: 73,
  /**
   * J
   */
  J: 74,
  /**
   * K
   */
  K: 75,
  /**
   * L
   */
  L: 76,
  /**
   * M
   */
  M: 77,
  /**
   * N
   */
  N: 78,
  /**
   * O
   */
  O: 79,
  /**
   * P
   */
  P: 80,
  /**
   * Q
   */
  Q: 81,
  /**
   * R
   */
  R: 82,
  /**
   * S
   */
  S: 83,
  /**
   * T
   */
  T: 84,
  /**
   * U
   */
  U: 85,
  /**
   * V
   */
  V: 86,
  /**
   * W
   */
  W: 87,
  /**
   * X
   */
  X: 88,
  /**
   * Y
   */
  Y: 89,
  /**
   * Z
   */
  Z: 90,
  /**
   * META
   */
  META: 91,
  // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,
  /**
   * NUM_ONE
   */
  NUM_ONE: 97,
  /**
   * NUM_TWO
   */
  NUM_TWO: 98,
  /**
   * NUM_THREE
   */
  NUM_THREE: 99,
  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,
  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,
  /**
   * NUM_SIX
   */
  NUM_SIX: 102,
  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,
  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,
  /**
   * NUM_NINE
   */
  NUM_NINE: 105,
  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,
  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,
  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,
  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,
  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * NUMLOCK
   */
  NUMLOCK: 144,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186,
  // needs localization
  /**
   * DASH
   */
  DASH: 189,
  // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187,
  // needs localization
  /**
   * COMMA
   */
  COMMA: 188,
  // needs localization
  /**
   * PERIOD
   */
  PERIOD: 190,
  // needs localization
  /**
   * SLASH
   */
  SLASH: 191,
  // needs localization
  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,
  // needs localization
  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,
  // needs localization
  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,
  // needs localization
  /**
   * BACKSLASH
   */
  BACKSLASH: 220,
  // needs localization
  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,
  // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224,
  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,
  // Firefox (Gecko) fires this for the meta key instead of 91
  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================
  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
    var keyCode = e.keyCode;
    if (e.altKey && !e.ctrlKey || e.metaKey ||
    // Function keys don't generate text
    keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
      return false;
    }

    // The following keys are quite harmless, even in combination with
    // CTRL, ALT or SHIFT.
    switch (keyCode) {
      case KeyCode.ALT:
      case KeyCode.CAPS_LOCK:
      case KeyCode.CONTEXT_MENU:
      case KeyCode.CTRL:
      case KeyCode.DOWN:
      case KeyCode.END:
      case KeyCode.ESC:
      case KeyCode.HOME:
      case KeyCode.INSERT:
      case KeyCode.LEFT:
      case KeyCode.MAC_FF_META:
      case KeyCode.META:
      case KeyCode.NUMLOCK:
      case KeyCode.NUM_CENTER:
      case KeyCode.PAGE_DOWN:
      case KeyCode.PAGE_UP:
      case KeyCode.PAUSE:
      case KeyCode.PRINT_SCREEN:
      case KeyCode.RIGHT:
      case KeyCode.SHIFT:
      case KeyCode.UP:
      case KeyCode.WIN_KEY:
      case KeyCode.WIN_KEY_RIGHT:
        return false;
      default:
        return true;
    }
  },
  /**
   * whether character is entered.
   */
  isCharacterKey: function isCharacterKey(keyCode) {
    if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
      return true;
    }
    if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
      return true;
    }
    if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
      return true;
    }

    // Safari sends zero key code for non-latin characters.
    if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
      return true;
    }
    switch (keyCode) {
      case KeyCode.SPACE:
      case KeyCode.QUESTION_MARK:
      case KeyCode.NUM_PLUS:
      case KeyCode.NUM_MINUS:
      case KeyCode.NUM_PERIOD:
      case KeyCode.NUM_DIVISION:
      case KeyCode.SEMICOLON:
      case KeyCode.DASH:
      case KeyCode.EQUALS:
      case KeyCode.COMMA:
      case KeyCode.PERIOD:
      case KeyCode.SLASH:
      case KeyCode.APOSTROPHE:
      case KeyCode.SINGLE_QUOTE:
      case KeyCode.OPEN_SQUARE_BRACKET:
      case KeyCode.BACKSLASH:
      case KeyCode.CLOSE_SQUARE_BRACKET:
        return true;
      default:
        return false;
    }
  }
};

var SliderContext = /*#__PURE__*/React.createContext({
  min: 0,
  max: 0,
  direction: 'ltr',
  step: 1,
  includedStart: 0,
  includedEnd: 0,
  tabIndex: 0,
  keyboard: true,
  styles: {},
  classNames: {}
});
/** @private NOT PROMISE AVAILABLE. DO NOT USE IN PRODUCTION. */
var UnstableContext = /*#__PURE__*/React.createContext({});

var _excluded$2 = ["prefixCls", "value", "valueIndex", "onStartMove", "onDelete", "style", "render", "dragging", "draggingDelete", "onOffsetChange", "onChangeComplete", "onFocus", "onMouseEnter"];
var Handle = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var prefixCls = props.prefixCls,
    value = props.value,
    valueIndex = props.valueIndex,
    onStartMove = props.onStartMove,
    onDelete = props.onDelete,
    style = props.style,
    render = props.render,
    dragging = props.dragging,
    draggingDelete = props.draggingDelete,
    onOffsetChange = props.onOffsetChange,
    onChangeComplete = props.onChangeComplete,
    onFocus = props.onFocus,
    onMouseEnter = props.onMouseEnter,
    restProps = _objectWithoutProperties$1(props, _excluded$2);
  var _React$useContext = React.useContext(SliderContext),
    min = _React$useContext.min,
    max = _React$useContext.max,
    direction = _React$useContext.direction,
    disabled = _React$useContext.disabled,
    keyboard = _React$useContext.keyboard,
    range = _React$useContext.range,
    tabIndex = _React$useContext.tabIndex,
    ariaLabelForHandle = _React$useContext.ariaLabelForHandle,
    ariaLabelledByForHandle = _React$useContext.ariaLabelledByForHandle,
    ariaValueTextFormatterForHandle = _React$useContext.ariaValueTextFormatterForHandle,
    styles = _React$useContext.styles,
    classNames = _React$useContext.classNames;
  var handlePrefixCls = "".concat(prefixCls, "-handle");

  // ============================ Events ============================
  var onInternalStartMove = function onInternalStartMove(e) {
    if (!disabled) {
      onStartMove(e, valueIndex);
    }
  };
  var onInternalFocus = function onInternalFocus(e) {
    onFocus === null || onFocus === void 0 || onFocus(e, valueIndex);
  };
  var onInternalMouseEnter = function onInternalMouseEnter(e) {
    onMouseEnter(e, valueIndex);
  };

  // =========================== Keyboard ===========================
  var onKeyDown = function onKeyDown(e) {
    if (!disabled && keyboard) {
      var offset = null;

      // Change the value
      switch (e.which || e.keyCode) {
        case KeyCode.LEFT:
          offset = direction === 'ltr' || direction === 'btt' ? -1 : 1;
          break;
        case KeyCode.RIGHT:
          offset = direction === 'ltr' || direction === 'btt' ? 1 : -1;
          break;

        // Up is plus
        case KeyCode.UP:
          offset = direction !== 'ttb' ? 1 : -1;
          break;

        // Down is minus
        case KeyCode.DOWN:
          offset = direction !== 'ttb' ? -1 : 1;
          break;
        case KeyCode.HOME:
          offset = 'min';
          break;
        case KeyCode.END:
          offset = 'max';
          break;
        case KeyCode.PAGE_UP:
          offset = 2;
          break;
        case KeyCode.PAGE_DOWN:
          offset = -2;
          break;
        case KeyCode.BACKSPACE:
        case KeyCode.DELETE:
          onDelete(valueIndex);
          break;
      }
      if (offset !== null) {
        e.preventDefault();
        onOffsetChange(offset, valueIndex);
      }
    }
  };
  var handleKeyUp = function handleKeyUp(e) {
    switch (e.which || e.keyCode) {
      case KeyCode.LEFT:
      case KeyCode.RIGHT:
      case KeyCode.UP:
      case KeyCode.DOWN:
      case KeyCode.HOME:
      case KeyCode.END:
      case KeyCode.PAGE_UP:
      case KeyCode.PAGE_DOWN:
        onChangeComplete === null || onChangeComplete === void 0 || onChangeComplete();
        break;
    }
  };

  // ============================ Offset ============================
  var positionStyle = getDirectionStyle(direction, value, min, max);

  // ============================ Render ============================
  var divProps = {};
  if (valueIndex !== null) {
    var _getIndex;
    divProps = {
      tabIndex: disabled ? null : getIndex(tabIndex, valueIndex),
      role: 'slider',
      'aria-valuemin': min,
      'aria-valuemax': max,
      'aria-valuenow': value,
      'aria-disabled': disabled,
      'aria-label': getIndex(ariaLabelForHandle, valueIndex),
      'aria-labelledby': getIndex(ariaLabelledByForHandle, valueIndex),
      'aria-valuetext': (_getIndex = getIndex(ariaValueTextFormatterForHandle, valueIndex)) === null || _getIndex === void 0 ? void 0 : _getIndex(value),
      'aria-orientation': direction === 'ltr' || direction === 'rtl' ? 'horizontal' : 'vertical',
      onMouseDown: onInternalStartMove,
      onTouchStart: onInternalStartMove,
      onFocus: onInternalFocus,
      onMouseEnter: onInternalMouseEnter,
      onKeyDown: onKeyDown,
      onKeyUp: handleKeyUp
    };
  }
  var handleNode = /*#__PURE__*/React.createElement("div", _extends({
    ref: ref,
    className: cls(handlePrefixCls, _defineProperty$2(_defineProperty$2(_defineProperty$2({}, "".concat(handlePrefixCls, "-").concat(valueIndex + 1), valueIndex !== null && range), "".concat(handlePrefixCls, "-dragging"), dragging), "".concat(handlePrefixCls, "-dragging-delete"), draggingDelete), classNames.handle),
    style: _objectSpread2(_objectSpread2(_objectSpread2({}, positionStyle), style), styles.handle)
  }, divProps, restProps));

  // Customize
  if (render) {
    handleNode = render(handleNode, {
      index: valueIndex,
      prefixCls: prefixCls,
      value: value,
      dragging: dragging,
      draggingDelete: draggingDelete
    });
  }
  return handleNode;
});
if (process.env.NODE_ENV !== 'production') {
  Handle.displayName = 'Handle';
}

var _excluded$1 = ["prefixCls", "style", "onStartMove", "onOffsetChange", "values", "handleRender", "activeHandleRender", "draggingIndex", "draggingDelete", "onFocus"];
var Handles = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var prefixCls = props.prefixCls,
    style = props.style,
    onStartMove = props.onStartMove,
    onOffsetChange = props.onOffsetChange,
    values = props.values,
    handleRender = props.handleRender,
    activeHandleRender = props.activeHandleRender,
    draggingIndex = props.draggingIndex,
    draggingDelete = props.draggingDelete,
    onFocus = props.onFocus,
    restProps = _objectWithoutProperties$1(props, _excluded$1);
  var handlesRef = React.useRef({});

  // =========================== Active ===========================
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray$2(_React$useState, 2),
    activeVisible = _React$useState2[0],
    setActiveVisible = _React$useState2[1];
  var _React$useState3 = React.useState(-1),
    _React$useState4 = _slicedToArray$2(_React$useState3, 2),
    activeIndex = _React$useState4[0],
    setActiveIndex = _React$useState4[1];
  var onActive = function onActive(index) {
    setActiveIndex(index);
    setActiveVisible(true);
  };
  var onHandleFocus = function onHandleFocus(e, index) {
    onActive(index);
    onFocus === null || onFocus === void 0 || onFocus(e);
  };
  var onHandleMouseEnter = function onHandleMouseEnter(e, index) {
    onActive(index);
  };

  // =========================== Render ===========================
  React.useImperativeHandle(ref, function () {
    return {
      focus: function focus(index) {
        var _handlesRef$current$i;
        (_handlesRef$current$i = handlesRef.current[index]) === null || _handlesRef$current$i === void 0 || _handlesRef$current$i.focus();
      },
      hideHelp: function hideHelp() {
        flushSync(function () {
          setActiveVisible(false);
        });
      }
    };
  });

  // =========================== Render ===========================
  // Handle Props
  var handleProps = _objectSpread2({
    prefixCls: prefixCls,
    onStartMove: onStartMove,
    onOffsetChange: onOffsetChange,
    render: handleRender,
    onFocus: onHandleFocus,
    onMouseEnter: onHandleMouseEnter
  }, restProps);
  return /*#__PURE__*/React.createElement(React.Fragment, null, values.map(function (value, index) {
    var dragging = draggingIndex === index;
    return /*#__PURE__*/React.createElement(Handle, _extends({
      ref: function ref(node) {
        if (!node) {
          delete handlesRef.current[index];
        } else {
          handlesRef.current[index] = node;
        }
      },
      dragging: dragging,
      draggingDelete: dragging && draggingDelete,
      style: getIndex(style, index),
      key: index,
      value: value,
      valueIndex: index
    }, handleProps));
  }), activeHandleRender && activeVisible && /*#__PURE__*/React.createElement(Handle, _extends({
    key: "a11y"
  }, handleProps, {
    value: values[activeIndex],
    valueIndex: null,
    dragging: draggingIndex !== -1,
    draggingDelete: draggingDelete,
    render: activeHandleRender,
    style: {
      pointerEvents: 'none'
    },
    tabIndex: null,
    "aria-hidden": true
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Handles.displayName = 'Handles';
}

var Mark = function Mark(props) {
  var prefixCls = props.prefixCls,
    style = props.style,
    children = props.children,
    value = props.value,
    _onClick = props.onClick;
  var _React$useContext = React.useContext(SliderContext),
    min = _React$useContext.min,
    max = _React$useContext.max,
    direction = _React$useContext.direction,
    includedStart = _React$useContext.includedStart,
    includedEnd = _React$useContext.includedEnd,
    included = _React$useContext.included;
  var textCls = "".concat(prefixCls, "-text");

  // ============================ Offset ============================
  var positionStyle = getDirectionStyle(direction, value, min, max);
  return /*#__PURE__*/React.createElement("span", {
    className: cls(textCls, _defineProperty$2({}, "".concat(textCls, "-active"), included && includedStart <= value && value <= includedEnd)),
    style: _objectSpread2(_objectSpread2({}, positionStyle), style),
    onMouseDown: function onMouseDown(e) {
      e.stopPropagation();
    },
    onClick: function onClick() {
      _onClick(value);
    }
  }, children);
};

var Marks = function Marks(props) {
  var prefixCls = props.prefixCls,
    marks = props.marks,
    onClick = props.onClick;
  var markPrefixCls = "".concat(prefixCls, "-mark");

  // Not render mark if empty
  if (!marks.length) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: markPrefixCls
  }, marks.map(function (_ref) {
    var value = _ref.value,
      style = _ref.style,
      label = _ref.label;
    return /*#__PURE__*/React.createElement(Mark, {
      key: value,
      prefixCls: markPrefixCls,
      style: style,
      value: value,
      onClick: onClick
    }, label);
  }));
};

var Dot = function Dot(props) {
  var prefixCls = props.prefixCls,
    value = props.value,
    style = props.style,
    activeStyle = props.activeStyle;
  var _React$useContext = React.useContext(SliderContext),
    min = _React$useContext.min,
    max = _React$useContext.max,
    direction = _React$useContext.direction,
    included = _React$useContext.included,
    includedStart = _React$useContext.includedStart,
    includedEnd = _React$useContext.includedEnd;
  var dotClassName = "".concat(prefixCls, "-dot");
  var active = included && includedStart <= value && value <= includedEnd;

  // ============================ Offset ============================
  var mergedStyle = _objectSpread2(_objectSpread2({}, getDirectionStyle(direction, value, min, max)), typeof style === 'function' ? style(value) : style);
  if (active) {
    mergedStyle = _objectSpread2(_objectSpread2({}, mergedStyle), typeof activeStyle === 'function' ? activeStyle(value) : activeStyle);
  }
  return /*#__PURE__*/React.createElement("span", {
    className: cls(dotClassName, _defineProperty$2({}, "".concat(dotClassName, "-active"), active)),
    style: mergedStyle
  });
};

var Steps = function Steps(props) {
  var prefixCls = props.prefixCls,
    marks = props.marks,
    dots = props.dots,
    style = props.style,
    activeStyle = props.activeStyle;
  var _React$useContext = React.useContext(SliderContext),
    min = _React$useContext.min,
    max = _React$useContext.max,
    step = _React$useContext.step;
  var stepDots = React.useMemo(function () {
    var dotSet = new Set();

    // Add marks
    marks.forEach(function (mark) {
      dotSet.add(mark.value);
    });

    // Fill dots
    if (dots && step !== null) {
      var current = min;
      while (current <= max) {
        dotSet.add(current);
        current += step;
      }
    }
    return Array.from(dotSet);
  }, [min, max, step, dots, marks]);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-step")
  }, stepDots.map(function (dotValue) {
    return /*#__PURE__*/React.createElement(Dot, {
      prefixCls: prefixCls,
      key: dotValue,
      value: dotValue,
      style: style,
      activeStyle: activeStyle
    });
  }));
};

var Track = function Track(props) {
  var prefixCls = props.prefixCls,
    style = props.style,
    start = props.start,
    end = props.end,
    index = props.index,
    onStartMove = props.onStartMove,
    replaceCls = props.replaceCls;
  var _React$useContext = React.useContext(SliderContext),
    direction = _React$useContext.direction,
    min = _React$useContext.min,
    max = _React$useContext.max,
    disabled = _React$useContext.disabled,
    range = _React$useContext.range,
    classNames = _React$useContext.classNames;
  var trackPrefixCls = "".concat(prefixCls, "-track");
  var offsetStart = getOffset(start, min, max);
  var offsetEnd = getOffset(end, min, max);

  // ============================ Events ============================
  var onInternalStartMove = function onInternalStartMove(e) {
    if (!disabled && onStartMove) {
      onStartMove(e, -1);
    }
  };

  // ============================ Render ============================
  var positionStyle = {};
  switch (direction) {
    case 'rtl':
      positionStyle.right = "".concat(offsetStart * 100, "%");
      positionStyle.width = "".concat(offsetEnd * 100 - offsetStart * 100, "%");
      break;
    case 'btt':
      positionStyle.bottom = "".concat(offsetStart * 100, "%");
      positionStyle.height = "".concat(offsetEnd * 100 - offsetStart * 100, "%");
      break;
    case 'ttb':
      positionStyle.top = "".concat(offsetStart * 100, "%");
      positionStyle.height = "".concat(offsetEnd * 100 - offsetStart * 100, "%");
      break;
    default:
      positionStyle.left = "".concat(offsetStart * 100, "%");
      positionStyle.width = "".concat(offsetEnd * 100 - offsetStart * 100, "%");
  }
  var className = replaceCls || cls(trackPrefixCls, _defineProperty$2(_defineProperty$2({}, "".concat(trackPrefixCls, "-").concat(index + 1), index !== null && range), "".concat(prefixCls, "-track-draggable"), onStartMove), classNames.track);
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    style: _objectSpread2(_objectSpread2({}, positionStyle), style),
    onMouseDown: onInternalStartMove,
    onTouchStart: onInternalStartMove
  });
};

var Tracks = function Tracks(props) {
  var prefixCls = props.prefixCls,
    style = props.style,
    values = props.values,
    startPoint = props.startPoint,
    onStartMove = props.onStartMove;
  var _React$useContext = React.useContext(SliderContext),
    included = _React$useContext.included,
    range = _React$useContext.range,
    min = _React$useContext.min,
    styles = _React$useContext.styles,
    classNames = _React$useContext.classNames;

  // =========================== List ===========================
  var trackList = React.useMemo(function () {
    if (!range) {
      // null value do not have track
      if (values.length === 0) {
        return [];
      }
      var startValue = startPoint !== null && startPoint !== void 0 ? startPoint : min;
      var endValue = values[0];
      return [{
        start: Math.min(startValue, endValue),
        end: Math.max(startValue, endValue)
      }];
    }

    // Multiple
    var list = [];
    for (var i = 0; i < values.length - 1; i += 1) {
      list.push({
        start: values[i],
        end: values[i + 1]
      });
    }
    return list;
  }, [values, range, startPoint, min]);
  if (!included) {
    return null;
  }

  // ========================== Render ==========================
  var tracksNode = classNames.tracks || styles.tracks ? /*#__PURE__*/React.createElement(Track, {
    index: null,
    prefixCls: prefixCls,
    start: trackList[0].start,
    end: trackList[trackList.length - 1].end,
    replaceCls: cls(classNames.tracks, "".concat(prefixCls, "-tracks")),
    style: styles.tracks
  }) : null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, tracksNode, trackList.map(function (_ref, index) {
    var start = _ref.start,
      end = _ref.end;
    return /*#__PURE__*/React.createElement(Track, {
      index: index,
      prefixCls: prefixCls,
      style: _objectSpread2(_objectSpread2({}, getIndex(style, index)), styles.track),
      start: start,
      end: end,
      key: index,
      onStartMove: onStartMove
    });
  }));
};

/** Drag to delete offset. It's a user experience number for dragging out */
var REMOVE_DIST = 130;
function getPosition(e) {
  var obj = 'touches' in e ? e.touches[0] : e;
  return {
    pageX: obj.pageX,
    pageY: obj.pageY
  };
}
function useDrag(containerRef, direction, rawValues, min, max, formatValue, triggerChange, finishChange, offsetValues, editable, minCount) {
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray$2(_React$useState, 2),
    draggingValue = _React$useState2[0],
    setDraggingValue = _React$useState2[1];
  var _React$useState3 = React.useState(-1),
    _React$useState4 = _slicedToArray$2(_React$useState3, 2),
    draggingIndex = _React$useState4[0],
    setDraggingIndex = _React$useState4[1];
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray$2(_React$useState5, 2),
    draggingDelete = _React$useState6[0],
    setDraggingDelete = _React$useState6[1];
  var _React$useState7 = React.useState(rawValues),
    _React$useState8 = _slicedToArray$2(_React$useState7, 2),
    cacheValues = _React$useState8[0],
    setCacheValues = _React$useState8[1];
  var _React$useState9 = React.useState(rawValues),
    _React$useState10 = _slicedToArray$2(_React$useState9, 2),
    originValues = _React$useState10[0],
    setOriginValues = _React$useState10[1];
  var mouseMoveEventRef = React.useRef(null);
  var mouseUpEventRef = React.useRef(null);
  var _React$useContext = React.useContext(UnstableContext),
    onDragStart = _React$useContext.onDragStart,
    onDragChange = _React$useContext.onDragChange;
  React.useLayoutEffect(function () {
    if (draggingIndex === -1) {
      setCacheValues(rawValues);
    }
  }, [rawValues, draggingIndex]);

  // Clean up event
  React.useEffect(function () {
    return function () {
      document.removeEventListener('mousemove', mouseMoveEventRef.current);
      document.removeEventListener('mouseup', mouseUpEventRef.current);
      document.removeEventListener('touchmove', mouseMoveEventRef.current);
      document.removeEventListener('touchend', mouseUpEventRef.current);
    };
  }, []);
  var flushValues = function flushValues(nextValues, nextValue, deleteMark) {
    // Perf: Only update state when value changed
    if (nextValue !== undefined) {
      setDraggingValue(nextValue);
    }
    setCacheValues(nextValues);
    var changeValues = nextValues;
    if (deleteMark) {
      changeValues = nextValues.filter(function (_, i) {
        return i !== draggingIndex;
      });
    }
    triggerChange(changeValues);
    if (onDragChange) {
      onDragChange({
        rawValues: nextValues,
        deleteIndex: deleteMark ? draggingIndex : -1,
        draggingIndex: draggingIndex,
        draggingValue: nextValue
      });
    }
  };
  var updateCacheValue = useEvent(function (valueIndex, offsetPercent, deleteMark) {
    if (valueIndex === -1) {
      // >>>> Dragging on the track
      var startValue = originValues[0];
      var endValue = originValues[originValues.length - 1];
      var maxStartOffset = min - startValue;
      var maxEndOffset = max - endValue;

      // Get valid offset
      var offset = offsetPercent * (max - min);
      offset = Math.max(offset, maxStartOffset);
      offset = Math.min(offset, maxEndOffset);

      // Use first value to revert back of valid offset (like steps marks)
      var formatStartValue = formatValue(startValue + offset);
      offset = formatStartValue - startValue;
      var cloneCacheValues = originValues.map(function (val) {
        return val + offset;
      });
      flushValues(cloneCacheValues);
    } else {
      // >>>> Dragging on the handle
      var offsetDist = (max - min) * offsetPercent;

      // Always start with the valueIndex origin value
      var cloneValues = _toConsumableArray$2(cacheValues);
      cloneValues[valueIndex] = originValues[valueIndex];
      var next = offsetValues(cloneValues, offsetDist, valueIndex, 'dist');
      flushValues(next.values, next.value, deleteMark);
    }
  });
  var onStartMove = function onStartMove(e, valueIndex, startValues) {
    e.stopPropagation();

    // 如果是点击 track 触发的，需要传入变化后的初始值，而不能直接用 rawValues
    var initialValues = startValues || rawValues;
    var originValue = initialValues[valueIndex];
    setDraggingIndex(valueIndex);
    setDraggingValue(originValue);
    setOriginValues(initialValues);
    setCacheValues(initialValues);
    setDraggingDelete(false);
    var _getPosition = getPosition(e),
      startX = _getPosition.pageX,
      startY = _getPosition.pageY;

    // We declare it here since closure can't get outer latest value
    var deleteMark = false;

    // Internal trigger event
    if (onDragStart) {
      onDragStart({
        rawValues: initialValues,
        draggingIndex: valueIndex,
        draggingValue: originValue
      });
    }

    // Moving
    var onMouseMove = function onMouseMove(event) {
      event.preventDefault();
      var _getPosition2 = getPosition(event),
        moveX = _getPosition2.pageX,
        moveY = _getPosition2.pageY;
      var offsetX = moveX - startX;
      var offsetY = moveY - startY;
      var _containerRef$current = containerRef.current.getBoundingClientRect(),
        width = _containerRef$current.width,
        height = _containerRef$current.height;
      var offSetPercent;
      var removeDist;
      switch (direction) {
        case 'btt':
          offSetPercent = -offsetY / height;
          removeDist = offsetX;
          break;
        case 'ttb':
          offSetPercent = offsetY / height;
          removeDist = offsetX;
          break;
        case 'rtl':
          offSetPercent = -offsetX / width;
          removeDist = offsetY;
          break;
        default:
          offSetPercent = offsetX / width;
          removeDist = offsetY;
      }

      // Check if need mark remove
      deleteMark = editable ? Math.abs(removeDist) > REMOVE_DIST && minCount < cacheValues.length : false;
      setDraggingDelete(deleteMark);
      updateCacheValue(valueIndex, offSetPercent, deleteMark);
    };

    // End
    var onMouseUp = function onMouseUp(event) {
      event.preventDefault();
      document.removeEventListener('mouseup', onMouseUp);
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('touchend', onMouseUp);
      document.removeEventListener('touchmove', onMouseMove);
      mouseMoveEventRef.current = null;
      mouseUpEventRef.current = null;
      finishChange(deleteMark);
      setDraggingIndex(-1);
      setDraggingDelete(false);
    };
    document.addEventListener('mouseup', onMouseUp);
    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('touchend', onMouseUp);
    document.addEventListener('touchmove', onMouseMove);
    mouseMoveEventRef.current = onMouseMove;
    mouseUpEventRef.current = onMouseUp;
  };

  // Only return cache value when it mapping with rawValues
  var returnValues = React.useMemo(function () {
    var sourceValues = _toConsumableArray$2(rawValues).sort(function (a, b) {
      return a - b;
    });
    var targetValues = _toConsumableArray$2(cacheValues).sort(function (a, b) {
      return a - b;
    });
    var counts = {};
    targetValues.forEach(function (val) {
      counts[val] = (counts[val] || 0) + 1;
    });
    sourceValues.forEach(function (val) {
      counts[val] = (counts[val] || 0) - 1;
    });
    var maxDiffCount = editable ? 1 : 0;
    var diffCount = Object.values(counts).reduce(function (prev, next) {
      return prev + Math.abs(next);
    }, 0);
    return diffCount <= maxDiffCount ? cacheValues : rawValues;
  }, [rawValues, cacheValues, editable]);
  return [draggingIndex, draggingValue, draggingDelete, returnValues, onStartMove];
}

/** Format the value in the range of [min, max] */

/** Format value align with step */

/** Format value align with step & marks */

function useOffset(min, max, step, markList, allowCross, pushable) {
  var formatRangeValue = React.useCallback(function (val) {
    return Math.max(min, Math.min(max, val));
  }, [min, max]);
  var formatStepValue = React.useCallback(function (val) {
    if (step !== null) {
      var stepValue = min + Math.round((formatRangeValue(val) - min) / step) * step;

      // Cut number in case to be like 0.30000000000000004
      var getDecimal = function getDecimal(num) {
        return (String(num).split('.')[1] || '').length;
      };
      var maxDecimal = Math.max(getDecimal(step), getDecimal(max), getDecimal(min));
      var fixedValue = Number(stepValue.toFixed(maxDecimal));
      return min <= fixedValue && fixedValue <= max ? fixedValue : null;
    }
    return null;
  }, [step, min, max, formatRangeValue]);
  var formatValue = React.useCallback(function (val) {
    var formatNextValue = formatRangeValue(val);

    // List align values
    var alignValues = markList.map(function (mark) {
      return mark.value;
    });
    if (step !== null) {
      alignValues.push(formatStepValue(val));
    }

    // min & max
    alignValues.push(min, max);

    // Align with marks
    var closeValue = alignValues[0];
    var closeDist = max - min;
    alignValues.forEach(function (alignValue) {
      var dist = Math.abs(formatNextValue - alignValue);
      if (dist <= closeDist) {
        closeValue = alignValue;
        closeDist = dist;
      }
    });
    return closeValue;
  }, [min, max, markList, step, formatRangeValue, formatStepValue]);

  // ========================== Offset ==========================
  // Single Value
  var offsetValue = function offsetValue(values, offset, valueIndex) {
    var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'unit';
    if (typeof offset === 'number') {
      var nextValue;
      var originValue = values[valueIndex];

      // Only used for `dist` mode
      var targetDistValue = originValue + offset;

      // Compare next step value & mark value which is best match
      var potentialValues = [];
      markList.forEach(function (mark) {
        potentialValues.push(mark.value);
      });

      // Min & Max
      potentialValues.push(min, max);

      // In case origin value is align with mark but not with step
      potentialValues.push(formatStepValue(originValue));

      // Put offset step value also
      var sign = offset > 0 ? 1 : -1;
      if (mode === 'unit') {
        potentialValues.push(formatStepValue(originValue + sign * step));
      } else {
        potentialValues.push(formatStepValue(targetDistValue));
      }

      // Find close one
      potentialValues = potentialValues.filter(function (val) {
        return val !== null;
      })
      // Remove reverse value
      .filter(function (val) {
        return offset < 0 ? val <= originValue : val >= originValue;
      });
      if (mode === 'unit') {
        // `unit` mode can not contain itself
        potentialValues = potentialValues.filter(function (val) {
          return val !== originValue;
        });
      }
      var compareValue = mode === 'unit' ? originValue : targetDistValue;
      nextValue = potentialValues[0];
      var valueDist = Math.abs(nextValue - compareValue);
      potentialValues.forEach(function (potentialValue) {
        var dist = Math.abs(potentialValue - compareValue);
        if (dist < valueDist) {
          nextValue = potentialValue;
          valueDist = dist;
        }
      });

      // Out of range will back to range
      if (nextValue === undefined) {
        return offset < 0 ? min : max;
      }

      // `dist` mode
      if (mode === 'dist') {
        return nextValue;
      }

      // `unit` mode may need another round
      if (Math.abs(offset) > 1) {
        var cloneValues = _toConsumableArray$2(values);
        cloneValues[valueIndex] = nextValue;
        return offsetValue(cloneValues, offset - sign, valueIndex, mode);
      }
      return nextValue;
    } else if (offset === 'min') {
      return min;
    } else if (offset === 'max') {
      return max;
    }
  };

  /** Same as `offsetValue` but return `changed` mark to tell value changed */
  var offsetChangedValue = function offsetChangedValue(values, offset, valueIndex) {
    var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'unit';
    var originValue = values[valueIndex];
    var nextValue = offsetValue(values, offset, valueIndex, mode);
    return {
      value: nextValue,
      changed: nextValue !== originValue
    };
  };
  var needPush = function needPush(dist) {
    return pushable === null && dist === 0 || typeof pushable === 'number' && dist < pushable;
  };

  // Values
  var offsetValues = function offsetValues(values, offset, valueIndex) {
    var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'unit';
    var nextValues = values.map(formatValue);
    var originValue = nextValues[valueIndex];
    var nextValue = offsetValue(nextValues, offset, valueIndex, mode);
    nextValues[valueIndex] = nextValue;
    if (allowCross === false) {
      // >>>>> Allow Cross
      var pushNum = pushable || 0;

      // ============ AllowCross ===============
      if (valueIndex > 0 && nextValues[valueIndex - 1] !== originValue) {
        nextValues[valueIndex] = Math.max(nextValues[valueIndex], nextValues[valueIndex - 1] + pushNum);
      }
      if (valueIndex < nextValues.length - 1 && nextValues[valueIndex + 1] !== originValue) {
        nextValues[valueIndex] = Math.min(nextValues[valueIndex], nextValues[valueIndex + 1] - pushNum);
      }
    } else if (typeof pushable === 'number' || pushable === null) {
      // >>>>> Pushable
      // =============== Push ==================

      // >>>>>> Basic push
      // End values
      for (var i = valueIndex + 1; i < nextValues.length; i += 1) {
        var changed = true;
        while (needPush(nextValues[i] - nextValues[i - 1]) && changed) {
          var _offsetChangedValue = offsetChangedValue(nextValues, 1, i);
          nextValues[i] = _offsetChangedValue.value;
          changed = _offsetChangedValue.changed;
        }
      }

      // Start values
      for (var _i = valueIndex; _i > 0; _i -= 1) {
        var _changed = true;
        while (needPush(nextValues[_i] - nextValues[_i - 1]) && _changed) {
          var _offsetChangedValue2 = offsetChangedValue(nextValues, -1, _i - 1);
          nextValues[_i - 1] = _offsetChangedValue2.value;
          _changed = _offsetChangedValue2.changed;
        }
      }

      // >>>>> Revert back to safe push range
      // End to Start
      for (var _i2 = nextValues.length - 1; _i2 > 0; _i2 -= 1) {
        var _changed2 = true;
        while (needPush(nextValues[_i2] - nextValues[_i2 - 1]) && _changed2) {
          var _offsetChangedValue3 = offsetChangedValue(nextValues, -1, _i2 - 1);
          nextValues[_i2 - 1] = _offsetChangedValue3.value;
          _changed2 = _offsetChangedValue3.changed;
        }
      }

      // Start to End
      for (var _i3 = 0; _i3 < nextValues.length - 1; _i3 += 1) {
        var _changed3 = true;
        while (needPush(nextValues[_i3 + 1] - nextValues[_i3]) && _changed3) {
          var _offsetChangedValue4 = offsetChangedValue(nextValues, 1, _i3 + 1);
          nextValues[_i3 + 1] = _offsetChangedValue4.value;
          _changed3 = _offsetChangedValue4.changed;
        }
      }
    }
    return {
      value: nextValues[valueIndex],
      values: nextValues
    };
  };
  return [formatValue, offsetValues];
}

function useRange(range) {
  return useMemo(function () {
    if (range === true || !range) {
      return [!!range, false, false, 0];
    }
    var editable = range.editable,
      draggableTrack = range.draggableTrack,
      minCount = range.minCount,
      maxCount = range.maxCount;
    if (process.env.NODE_ENV !== 'production') {
      warning$1(!editable || !draggableTrack, '`editable` can not work with `draggableTrack`.');
    }
    return [true, editable, !editable && draggableTrack, minCount || 0, maxCount];
  }, [range]);
}

/**
 * New:
 * - click mark to update range value
 * - handleRender
 * - Fix handle with count not correct
 * - Fix pushable not work in some case
 * - No more FindDOMNode
 * - Move all position related style into inline style
 * - Key: up is plus, down is minus
 * - fix Key with step = null not align with marks
 * - Change range should not trigger onChange
 * - keyboard support pushable
 */

var Slider$1 = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _props$prefixCls = props.prefixCls,
    prefixCls = _props$prefixCls === void 0 ? 'rc-slider' : _props$prefixCls,
    className = props.className,
    style = props.style,
    classNames = props.classNames,
    styles = props.styles,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$keyboard = props.keyboard,
    keyboard = _props$keyboard === void 0 ? true : _props$keyboard,
    autoFocus = props.autoFocus,
    onFocus = props.onFocus,
    onBlur = props.onBlur,
    _props$min = props.min,
    min = _props$min === void 0 ? 0 : _props$min,
    _props$max = props.max,
    max = _props$max === void 0 ? 100 : _props$max,
    _props$step = props.step,
    step = _props$step === void 0 ? 1 : _props$step,
    value = props.value,
    defaultValue = props.defaultValue,
    range = props.range,
    count = props.count,
    onChange = props.onChange,
    onBeforeChange = props.onBeforeChange,
    onAfterChange = props.onAfterChange,
    onChangeComplete = props.onChangeComplete,
    _props$allowCross = props.allowCross,
    allowCross = _props$allowCross === void 0 ? true : _props$allowCross,
    _props$pushable = props.pushable,
    pushable = _props$pushable === void 0 ? false : _props$pushable,
    reverse = props.reverse,
    vertical = props.vertical,
    _props$included = props.included,
    included = _props$included === void 0 ? true : _props$included,
    startPoint = props.startPoint,
    trackStyle = props.trackStyle,
    handleStyle = props.handleStyle,
    railStyle = props.railStyle,
    dotStyle = props.dotStyle,
    activeDotStyle = props.activeDotStyle,
    marks = props.marks,
    dots = props.dots,
    handleRender = props.handleRender,
    activeHandleRender = props.activeHandleRender,
    track = props.track,
    _props$tabIndex = props.tabIndex,
    tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex,
    ariaLabelForHandle = props.ariaLabelForHandle,
    ariaLabelledByForHandle = props.ariaLabelledByForHandle,
    ariaValueTextFormatterForHandle = props.ariaValueTextFormatterForHandle;
  var handlesRef = React.useRef(null);
  var containerRef = React.useRef(null);
  var direction = React.useMemo(function () {
    if (vertical) {
      return reverse ? 'ttb' : 'btt';
    }
    return reverse ? 'rtl' : 'ltr';
  }, [reverse, vertical]);

  // ============================ Range =============================
  var _useRange = useRange(range),
    _useRange2 = _slicedToArray$2(_useRange, 5),
    rangeEnabled = _useRange2[0],
    rangeEditable = _useRange2[1],
    rangeDraggableTrack = _useRange2[2],
    minCount = _useRange2[3],
    maxCount = _useRange2[4];
  var mergedMin = React.useMemo(function () {
    return isFinite(min) ? min : 0;
  }, [min]);
  var mergedMax = React.useMemo(function () {
    return isFinite(max) ? max : 100;
  }, [max]);

  // ============================= Step =============================
  var mergedStep = React.useMemo(function () {
    return step !== null && step <= 0 ? 1 : step;
  }, [step]);

  // ============================= Push =============================
  var mergedPush = React.useMemo(function () {
    if (typeof pushable === 'boolean') {
      return pushable ? mergedStep : false;
    }
    return pushable >= 0 ? pushable : false;
  }, [pushable, mergedStep]);

  // ============================ Marks =============================
  var markList = React.useMemo(function () {
    return Object.keys(marks || {}).map(function (key) {
      var mark = marks[key];
      var markObj = {
        value: Number(key)
      };
      if (mark && _typeof(mark) === 'object' && ! /*#__PURE__*/React.isValidElement(mark) && ('label' in mark || 'style' in mark)) {
        markObj.style = mark.style;
        markObj.label = mark.label;
      } else {
        markObj.label = mark;
      }
      return markObj;
    }).filter(function (_ref) {
      var label = _ref.label;
      return label || typeof label === 'number';
    }).sort(function (a, b) {
      return a.value - b.value;
    });
  }, [marks]);

  // ============================ Format ============================
  var _useOffset = useOffset(mergedMin, mergedMax, mergedStep, markList, allowCross, mergedPush),
    _useOffset2 = _slicedToArray$2(_useOffset, 2),
    formatValue = _useOffset2[0],
    offsetValues = _useOffset2[1];

  // ============================ Values ============================
  var _useMergedState = useMergedState(defaultValue, {
      value: value
    }),
    _useMergedState2 = _slicedToArray$2(_useMergedState, 2),
    mergedValue = _useMergedState2[0],
    setValue = _useMergedState2[1];
  var rawValues = React.useMemo(function () {
    var valueList = mergedValue === null || mergedValue === undefined ? [] : Array.isArray(mergedValue) ? mergedValue : [mergedValue];
    var _valueList = _slicedToArray$2(valueList, 1),
      _valueList$ = _valueList[0],
      val0 = _valueList$ === void 0 ? mergedMin : _valueList$;
    var returnValues = mergedValue === null ? [] : [val0];

    // Format as range
    if (rangeEnabled) {
      returnValues = _toConsumableArray$2(valueList);

      // When count provided or value is `undefined`, we fill values
      if (count || mergedValue === undefined) {
        var pointCount = count >= 0 ? count + 1 : 2;
        returnValues = returnValues.slice(0, pointCount);

        // Fill with count
        while (returnValues.length < pointCount) {
          var _returnValues;
          returnValues.push((_returnValues = returnValues[returnValues.length - 1]) !== null && _returnValues !== void 0 ? _returnValues : mergedMin);
        }
      }
      returnValues.sort(function (a, b) {
        return a - b;
      });
    }

    // Align in range
    returnValues.forEach(function (val, index) {
      returnValues[index] = formatValue(val);
    });
    return returnValues;
  }, [mergedValue, rangeEnabled, mergedMin, count, formatValue]);

  // =========================== onChange ===========================
  var getTriggerValue = function getTriggerValue(triggerValues) {
    return rangeEnabled ? triggerValues : triggerValues[0];
  };
  var triggerChange = useEvent(function (nextValues) {
    // Order first
    var cloneNextValues = _toConsumableArray$2(nextValues).sort(function (a, b) {
      return a - b;
    });

    // Trigger event if needed
    if (onChange && !isEqual(cloneNextValues, rawValues, true)) {
      onChange(getTriggerValue(cloneNextValues));
    }

    // We set this later since it will re-render component immediately
    setValue(cloneNextValues);
  });
  var finishChange = useEvent(function (draggingDelete) {
    // Trigger from `useDrag` will tell if it's a delete action
    if (draggingDelete) {
      handlesRef.current.hideHelp();
    }
    var finishValue = getTriggerValue(rawValues);
    onAfterChange === null || onAfterChange === void 0 || onAfterChange(finishValue);
    warningOnce(!onAfterChange, '[rc-slider] `onAfterChange` is deprecated. Please use `onChangeComplete` instead.');
    onChangeComplete === null || onChangeComplete === void 0 || onChangeComplete(finishValue);
  });
  var onDelete = function onDelete(index) {
    if (disabled || !rangeEditable || rawValues.length <= minCount) {
      return;
    }
    var cloneNextValues = _toConsumableArray$2(rawValues);
    cloneNextValues.splice(index, 1);
    onBeforeChange === null || onBeforeChange === void 0 || onBeforeChange(getTriggerValue(cloneNextValues));
    triggerChange(cloneNextValues);
    var nextFocusIndex = Math.max(0, index - 1);
    handlesRef.current.hideHelp();
    handlesRef.current.focus(nextFocusIndex);
  };
  var _useDrag = useDrag(containerRef, direction, rawValues, mergedMin, mergedMax, formatValue, triggerChange, finishChange, offsetValues, rangeEditable, minCount),
    _useDrag2 = _slicedToArray$2(_useDrag, 5),
    draggingIndex = _useDrag2[0],
    draggingValue = _useDrag2[1],
    draggingDelete = _useDrag2[2],
    cacheValues = _useDrag2[3],
    onStartDrag = _useDrag2[4];

  /**
   * When `rangeEditable` will insert a new value in the values array.
   * Else it will replace the value in the values array.
   */
  var changeToCloseValue = function changeToCloseValue(newValue, e) {
    if (!disabled) {
      // Create new values
      var cloneNextValues = _toConsumableArray$2(rawValues);
      var valueIndex = 0;
      var valueBeforeIndex = 0; // Record the index which value < newValue
      var valueDist = mergedMax - mergedMin;
      rawValues.forEach(function (val, index) {
        var dist = Math.abs(newValue - val);
        if (dist <= valueDist) {
          valueDist = dist;
          valueIndex = index;
        }
        if (val < newValue) {
          valueBeforeIndex = index;
        }
      });
      var focusIndex = valueIndex;
      if (rangeEditable && valueDist !== 0 && (!maxCount || rawValues.length < maxCount)) {
        cloneNextValues.splice(valueBeforeIndex + 1, 0, newValue);
        focusIndex = valueBeforeIndex + 1;
      } else {
        cloneNextValues[valueIndex] = newValue;
      }

      // Fill value to match default 2 (only when `rawValues` is empty)
      if (rangeEnabled && !rawValues.length && count === undefined) {
        cloneNextValues.push(newValue);
      }
      var nextValue = getTriggerValue(cloneNextValues);
      onBeforeChange === null || onBeforeChange === void 0 || onBeforeChange(nextValue);
      triggerChange(cloneNextValues);
      if (e) {
        var _document$activeEleme, _document$activeEleme2;
        (_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 || (_document$activeEleme2 = _document$activeEleme.blur) === null || _document$activeEleme2 === void 0 || _document$activeEleme2.call(_document$activeEleme);
        handlesRef.current.focus(focusIndex);
        onStartDrag(e, focusIndex, cloneNextValues);
      } else {
        // https://github.com/ant-design/ant-design/issues/49997
        onAfterChange === null || onAfterChange === void 0 || onAfterChange(nextValue);
        warningOnce(!onAfterChange, '[rc-slider] `onAfterChange` is deprecated. Please use `onChangeComplete` instead.');
        onChangeComplete === null || onChangeComplete === void 0 || onChangeComplete(nextValue);
      }
    }
  };

  // ============================ Click =============================
  var onSliderMouseDown = function onSliderMouseDown(e) {
    e.preventDefault();
    var _containerRef$current = containerRef.current.getBoundingClientRect(),
      width = _containerRef$current.width,
      height = _containerRef$current.height,
      left = _containerRef$current.left,
      top = _containerRef$current.top,
      bottom = _containerRef$current.bottom,
      right = _containerRef$current.right;
    var clientX = e.clientX,
      clientY = e.clientY;
    var percent;
    switch (direction) {
      case 'btt':
        percent = (bottom - clientY) / height;
        break;
      case 'ttb':
        percent = (clientY - top) / height;
        break;
      case 'rtl':
        percent = (right - clientX) / width;
        break;
      default:
        percent = (clientX - left) / width;
    }
    var nextValue = mergedMin + percent * (mergedMax - mergedMin);
    changeToCloseValue(formatValue(nextValue), e);
  };

  // =========================== Keyboard ===========================
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray$2(_React$useState, 2),
    keyboardValue = _React$useState2[0],
    setKeyboardValue = _React$useState2[1];
  var onHandleOffsetChange = function onHandleOffsetChange(offset, valueIndex) {
    if (!disabled) {
      var next = offsetValues(rawValues, offset, valueIndex);
      onBeforeChange === null || onBeforeChange === void 0 || onBeforeChange(getTriggerValue(rawValues));
      triggerChange(next.values);
      setKeyboardValue(next.value);
    }
  };
  React.useEffect(function () {
    if (keyboardValue !== null) {
      var valueIndex = rawValues.indexOf(keyboardValue);
      if (valueIndex >= 0) {
        handlesRef.current.focus(valueIndex);
      }
    }
    setKeyboardValue(null);
  }, [keyboardValue]);

  // ============================= Drag =============================
  var mergedDraggableTrack = React.useMemo(function () {
    if (rangeDraggableTrack && mergedStep === null) {
      if (process.env.NODE_ENV !== 'production') {
        warningOnce(false, '`draggableTrack` is not supported when `step` is `null`.');
      }
      return false;
    }
    return rangeDraggableTrack;
  }, [rangeDraggableTrack, mergedStep]);
  var onStartMove = useEvent(function (e, valueIndex) {
    onStartDrag(e, valueIndex);
    onBeforeChange === null || onBeforeChange === void 0 || onBeforeChange(getTriggerValue(rawValues));
  });

  // Auto focus for updated handle
  var dragging = draggingIndex !== -1;
  React.useEffect(function () {
    if (!dragging) {
      var valueIndex = rawValues.lastIndexOf(draggingValue);
      handlesRef.current.focus(valueIndex);
    }
  }, [dragging]);

  // =========================== Included ===========================
  var sortedCacheValues = React.useMemo(function () {
    return _toConsumableArray$2(cacheValues).sort(function (a, b) {
      return a - b;
    });
  }, [cacheValues]);

  // Provide a range values with included [min, max]
  // Used for Track, Mark & Dot
  var _React$useMemo = React.useMemo(function () {
      if (!rangeEnabled) {
        return [mergedMin, sortedCacheValues[0]];
      }
      return [sortedCacheValues[0], sortedCacheValues[sortedCacheValues.length - 1]];
    }, [sortedCacheValues, rangeEnabled, mergedMin]),
    _React$useMemo2 = _slicedToArray$2(_React$useMemo, 2),
    includedStart = _React$useMemo2[0],
    includedEnd = _React$useMemo2[1];

  // ============================= Refs =============================
  React.useImperativeHandle(ref, function () {
    return {
      focus: function focus() {
        handlesRef.current.focus(0);
      },
      blur: function blur() {
        var _containerRef$current2;
        var _document = document,
          activeElement = _document.activeElement;
        if ((_containerRef$current2 = containerRef.current) !== null && _containerRef$current2 !== void 0 && _containerRef$current2.contains(activeElement)) {
          activeElement === null || activeElement === void 0 || activeElement.blur();
        }
      }
    };
  });

  // ========================== Auto Focus ==========================
  React.useEffect(function () {
    if (autoFocus) {
      handlesRef.current.focus(0);
    }
  }, []);

  // =========================== Context ============================
  var context = React.useMemo(function () {
    return {
      min: mergedMin,
      max: mergedMax,
      direction: direction,
      disabled: disabled,
      keyboard: keyboard,
      step: mergedStep,
      included: included,
      includedStart: includedStart,
      includedEnd: includedEnd,
      range: rangeEnabled,
      tabIndex: tabIndex,
      ariaLabelForHandle: ariaLabelForHandle,
      ariaLabelledByForHandle: ariaLabelledByForHandle,
      ariaValueTextFormatterForHandle: ariaValueTextFormatterForHandle,
      styles: styles || {},
      classNames: classNames || {}
    };
  }, [mergedMin, mergedMax, direction, disabled, keyboard, mergedStep, included, includedStart, includedEnd, rangeEnabled, tabIndex, ariaLabelForHandle, ariaLabelledByForHandle, ariaValueTextFormatterForHandle, styles, classNames]);

  // ============================ Render ============================
  return /*#__PURE__*/React.createElement(SliderContext.Provider, {
    value: context
  }, /*#__PURE__*/React.createElement("div", {
    ref: containerRef,
    className: cls(prefixCls, className, _defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2({}, "".concat(prefixCls, "-disabled"), disabled), "".concat(prefixCls, "-vertical"), vertical), "".concat(prefixCls, "-horizontal"), !vertical), "".concat(prefixCls, "-with-marks"), markList.length)),
    style: style,
    onMouseDown: onSliderMouseDown
  }, /*#__PURE__*/React.createElement("div", {
    className: cls("".concat(prefixCls, "-rail"), classNames === null || classNames === void 0 ? void 0 : classNames.rail),
    style: _objectSpread2(_objectSpread2({}, railStyle), styles === null || styles === void 0 ? void 0 : styles.rail)
  }), track !== false && /*#__PURE__*/React.createElement(Tracks, {
    prefixCls: prefixCls,
    style: trackStyle,
    values: rawValues,
    startPoint: startPoint,
    onStartMove: mergedDraggableTrack ? onStartMove : undefined
  }), /*#__PURE__*/React.createElement(Steps, {
    prefixCls: prefixCls,
    marks: markList,
    dots: dots,
    style: dotStyle,
    activeStyle: activeDotStyle
  }), /*#__PURE__*/React.createElement(Handles, {
    ref: handlesRef,
    prefixCls: prefixCls,
    style: handleStyle,
    values: cacheValues,
    draggingIndex: draggingIndex,
    draggingDelete: draggingDelete,
    onStartMove: onStartMove,
    onOffsetChange: onHandleOffsetChange,
    onFocus: onFocus,
    onBlur: onBlur,
    handleRender: handleRender,
    activeHandleRender: activeHandleRender,
    onChangeComplete: finishChange,
    onDelete: rangeEditable ? onDelete : undefined
  }), /*#__PURE__*/React.createElement(Marks, {
    prefixCls: prefixCls,
    marks: markList,
    onClick: changeToCloseValue
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Slider$1.displayName = 'Slider';
}

var Container = styled.div(templateObject_1$h || (templateObject_1$h = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  align-content: center;\n\n  .rc-slider-disabled {\n    background: none;\n    .rc-slider-track {\n      background-color: ", ";\n    }\n    .rc-slider-handle {\n      border-color: ", ";\n      background-color: ", ";\n      pointer-events: none;\n      &:focus-visible {\n        outline: none;\n        box-shadow: none;\n      }\n    }\n  }\n\n  .rc-slider-rail {\n    background-color: ", ";\n    border-radius: 0px;\n  }\n\n  .rc-slider-track {\n    border-radius: 0px;\n    background-color: ", ";\n  }\n\n  .rc-slider-handle {\n    width: 16px;\n    height: 16px;\n    border: solid 1px ", ";\n    background-color: ", ";\n    opacity: 1;\n    margin-top: -6px;\n    &:focus-visible {\n      outline: 2px solid ", ";\n      box-shadow: 0px 0px 2px 4px var(--focus);\n    }\n  }\n\n  .rc-slider-handle-dragging.rc-slider-handle-dragging.rc-slider-handle-dragging {\n    border-color: ", ";\n    outline: none;\n    box-shadow: none;\n    outline: 2px solid ", ";\n    box-shadow: 0px 0px 2px 4px var(--focus);\n  }\n\n  .rc-slider-handle-click-focused {\n    border: none;\n    &:focus {\n      border: none;\n    }\n  }\n\n  .rc-slider-handle:hover {\n    border-color: ", ";\n  }\n  .rc-slider-handle:active {\n    border-color: ", ";\n    box-shadow: none;\n    outline: none;\n  }\n\n  .rc-slider-dot-active {\n    border-color: ", ";\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  align-content: center;\n\n  .rc-slider-disabled {\n    background: none;\n    .rc-slider-track {\n      background-color: ", ";\n    }\n    .rc-slider-handle {\n      border-color: ", ";\n      background-color: ", ";\n      pointer-events: none;\n      &:focus-visible {\n        outline: none;\n        box-shadow: none;\n      }\n    }\n  }\n\n  .rc-slider-rail {\n    background-color: ", ";\n    border-radius: 0px;\n  }\n\n  .rc-slider-track {\n    border-radius: 0px;\n    background-color: ", ";\n  }\n\n  .rc-slider-handle {\n    width: 16px;\n    height: 16px;\n    border: solid 1px ", ";\n    background-color: ", ";\n    opacity: 1;\n    margin-top: -6px;\n    &:focus-visible {\n      outline: 2px solid ", ";\n      box-shadow: 0px 0px 2px 4px var(--focus);\n    }\n  }\n\n  .rc-slider-handle-dragging.rc-slider-handle-dragging.rc-slider-handle-dragging {\n    border-color: ", ";\n    outline: none;\n    box-shadow: none;\n    outline: 2px solid ", ";\n    box-shadow: 0px 0px 2px 4px var(--focus);\n  }\n\n  .rc-slider-handle-click-focused {\n    border: none;\n    &:focus {\n      border: none;\n    }\n  }\n\n  .rc-slider-handle:hover {\n    border-color: ", ";\n  }\n  .rc-slider-handle:active {\n    border-color: ", ";\n    box-shadow: none;\n    outline: none;\n  }\n\n  .rc-slider-dot-active {\n    border-color: ", ";\n  }\n"
    /* stylelint-enable */
])), colorSurface.tertiary, colorSurface.secondary, colorSurface.secondary, colorSurface.secondary, colorBase['colorBrand-500'], customColors.primary, customColors.primary, colorBase['colorNeutral-0'], customColors.primary, colorBase['colorNeutral-0'], customColors.primary, customColors.primary, colorSurface.secondary);
/* stylelint-enable */
var HEIGHT = '4px';
var Line = styled.div(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject(["\n  width: 16px;\n  height: ", ";\n  ", "\n"], ["\n  width: 16px;\n  height: ", ";\n  ", "\n"])), HEIGHT, function (_a) {
    var disabled = _a.disabled;
    return "\n    background-color: ".concat(disabled ? colorSurface.secondary : colorSurface.secondary, ";\n  ");
});
var LeftLine = styled(Line)(templateObject_3$2 || (templateObject_3$2 = __makeTemplateObject(["\n  border-top-left-radius: ", ";\n  border-bottom-left-radius: ", ";\n"], ["\n  border-top-left-radius: ", ";\n  border-bottom-left-radius: ", ";\n"])), HEIGHT, HEIGHT);
var RightLine = styled(Line)(templateObject_4$2 || (templateObject_4$2 = __makeTemplateObject(["\n  border-top-right-radius: ", ";\n  border-bottom-right-radius: ", ";\n"], ["\n  border-top-right-radius: ", ";\n  border-bottom-right-radius: ", ";\n"])), HEIGHT, HEIGHT);
var templateObject_1$h, templateObject_2$4, templateObject_3$2, templateObject_4$2;

var BaseSlider = function (_a) {
    var children = _a.children, disabled = _a.disabled;
    return (jsxs(Container, { children: [jsx(LeftLine, { disabled: disabled }), children, jsx(RightLine, { disabled: disabled })] }));
};

var generateRandomId = function () { return "".concat(Math.random().toString(36).substring(7)); };
var formatSliderId = function (id) { return "Slider-".concat(id); };
var SliderTooltip = function (_a) {
    var sliderId = _a.sliderId, value = _a.value, visible = _a.visible, tipFormatter = _a.tipFormatter, children = _a.children;
    var _b = useState(formatSliderId(sliderId)), id = _b[0], setId = _b[1];
    useEffect(function () {
        if (!sliderId) {
            setId(formatSliderId(generateRandomId()));
        }
    }, []);
    return (jsxs("div", __assign({ id: id }, { children: [children, jsx(M, { isOpen: visible, anchorSelect: "#".concat(id, " .rc-slider-handle"), place: "top", content: tipFormatter ? tipFormatter(value) : String(value) })] })));
};

var createTooltip = function (id, tipFormatter, showTooltip) { return function (node, handleProps) {
    return (jsx(SliderTooltip, __assign({ sliderId: id, value: handleProps.value, visible: showTooltip && handleProps.dragging, tipFormatter: tipFormatter }, { children: node })));
}; };

var Slider = function (_a) {
    var defaultValue = _a.defaultValue, disabled = _a.disabled, max = _a.max, min = _a.min, onAfterChange = _a.onAfterChange, onChange = _a.onChange, step = _a.step, tipFormatter = _a.tipFormatter, value = _a.value, id = _a.id, _b = _a.showTooltip, showTooltip = _b === void 0 ? false : _b, props = __rest(_a, ["defaultValue", "disabled", "max", "min", "onAfterChange", "onChange", "step", "tipFormatter", "value", "id", "showTooltip"]);
    var TooltipMemo = useMemo(function () { return createTooltip(id, tipFormatter, showTooltip); }, [tipFormatter, id, showTooltip]);
    return (jsx(BaseSlider, __assign({ disabled: disabled }, { children: jsx(Slider$1, __assign({ handleRender: TooltipMemo, defaultValue: defaultValue, disabled: disabled, max: max, min: min, onChangeComplete: onAfterChange, onChange: onChange, step: step, value: value }, props)) })));
};

var RangeSlider = function (_a) {
    var disabled = _a.disabled, _b = _a.min, min = _b === void 0 ? 0 : _b, _c = _a.max, max = _c === void 0 ? 5 : _c, _d = _a.defaultValue, defaultValue = _d === void 0 ? [min, max] : _d, onAfterChange = _a.onAfterChange, onChange = _a.onChange, step = _a.step, tipFormatter = _a.tipFormatter, value = _a.value, id = _a.id, _e = _a.showTooltip, showTooltip = _e === void 0 ? false : _e, props = __rest(_a, ["disabled", "min", "max", "defaultValue", "onAfterChange", "onChange", "step", "tipFormatter", "value", "id", "showTooltip"]);
    var TooltipMemo = useMemo(function () { return createTooltip(id, tipFormatter, showTooltip); }, [tipFormatter, id, showTooltip]);
    return (jsx(BaseSlider, __assign({ disabled: disabled }, { children: jsx(Slider$1, __assign({ range: true, handleRender: TooltipMemo, defaultValue: defaultValue, disabled: disabled, max: max, min: min, onChangeComplete: onAfterChange, onChange: onChange, step: step, value: value }, props)) })));
};

var Table = styled.table(templateObject_1$g || (templateObject_1$g = __makeTemplateObject(["\n  border-spacing: 0;\n  border: 1px solid ", ";\n  border-radius: ", " ", " 0 0;\n  width: 100%;\n"], ["\n  border-spacing: 0;\n  border: 1px solid ", ";\n  border-radius: ", " ", " 0 0;\n  width: 100%;\n"])), colorBorder$1.colorBorderBorderPrimary, theming.borderRadius, theming.borderRadius);
var TableBody = styled.tbody(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n  tr:last-child td:first-child {\n    border-bottom-left-radius: ", ";\n  }\n\n  tr:last-child td:last-child {\n    border-bottom-right-radius: ", ";\n  }\n\n  tr:nth-child(odd) {\n    background-color: ", ";\n  }\n  tr:nth-child(even) {\n    background-color: ", ";\n  }\n"], ["\n  tr:last-child td:first-child {\n    border-bottom-left-radius: ", ";\n  }\n\n  tr:last-child td:last-child {\n    border-bottom-right-radius: ", ";\n  }\n\n  tr:nth-child(odd) {\n    background-color: ", ";\n  }\n  tr:nth-child(even) {\n    background-color: ", ";\n  }\n"])), theming.borderRadius, theming.borderRadius, colorSurface.primary, colorSurface.secondary);
var TableRow = styled.tr(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var _b = _a.background, background = _b === void 0 ? 'white' : _b, clickableRows = _a.clickableRows;
    return "\n      background: ".concat(getFormSurfaceColor(background), ";\n      ").concat(clickableRows ? 'cursor: pointer;' : '', "\n  ");
});
var TableHeader = styled.thead(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject(["\n  ", "\n\n  th {\n    border-bottom: 1px solid ", ";\n  }\n\n  th:first-child {\n    border-top-left-radius: ", ";\n  }\n\n  th:last-child {\n    border-top-right-radius: ", ";\n  }\n"], ["\n  ", "\n\n  th {\n    border-bottom: 1px solid ", ";\n  }\n\n  th:first-child {\n    border-top-left-radius: ", ";\n  }\n\n  th:last-child {\n    border-top-right-radius: ", ";\n  }\n"])), function (_a) {
    var _b = _a.showShadow, showShadow = _b === void 0 ? false : _b;
    return showShadow
        ? "\n        box-shadow: ".concat(shadow.larger, ";\n      ")
        : '';
}, colorBorder$1.colorBorderBorderPrimary, theming.borderRadius, theming.borderRadius);
var TableHead = styled.th(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject(["\n  padding: 16px 8px;\n  text-align: left;\n"], ["\n  padding: 16px 8px;\n  text-align: left;\n"])));
var TableCell = styled.td(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  padding: 16px 8px;\n  text-align: left;\n"], ["\n  padding: 16px 8px;\n  text-align: left;\n"])));
var HeadActionContainer = styled(FlexBox)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  cursor: pointer;\n"], ["\n  cursor: pointer;\n"])));
var TableContainer = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var maxHeight = _a.maxHeight;
    return maxHeight
        ? "\n          overflow: auto;\n          max-height: ".concat(maxHeight, ";\n\n          thead {\n            position: sticky;\n            top: 0;\n            z-index: 1;\n          }\n        ")
        : "\n          overflow-x: auto;\n        ";
});
var templateObject_1$g, templateObject_2$3, templateObject_3$1, templateObject_4$1, templateObject_5$1, templateObject_6, templateObject_7, templateObject_8;

var SELECT_ALL_CHECKBOX = 'select-all';
var DataGrid = function (_a) {
    var columns = _a.columns, rows = _a.rows, checkboxSelection = _a.checkboxSelection, maxHeight = _a.maxHeight, handleSorting = _a.handleSorting, handleCheckboxSelection = _a.handleCheckboxSelection, handleRowClick = _a.handleRowClick;
    var _b = useState(false), selectAll = _b[0], setSelectAll = _b[1];
    var onCheckboxChange = function (e) {
        if (e.target.name === SELECT_ALL_CHECKBOX) {
            setSelectAll(!selectAll);
        }
        handleCheckboxSelection && handleCheckboxSelection(e);
    };
    var onRowClick = function (index) {
        handleRowClick && handleRowClick(index);
    };
    return (jsx(TableContainer, __assign({ maxHeight: maxHeight }, { children: jsxs(Table, { children: [jsx(TableHeader, __assign({ showShadow: Boolean(maxHeight) }, { children: jsxs(TableRow, __assign({ background: "infoLightest" }, { children: [checkboxSelection && (jsx(TableHead, { children: jsx(FlexBox, { children: jsx(Checkbox, { name: SELECT_ALL_CHECKBOX, onChange: onCheckboxChange }) }) })), columns.length &&
                                columns.map(function (_a, i) {
                                    var field = _a.field, headerName = _a.headerName, sortable = _a.sortable, sortedDirection = _a.sortedDirection;
                                    var isSortable = sortable && sortedDirection;
                                    var isAsc = sortedDirection === 'asc';
                                    var isDesc = sortedDirection === 'desc';
                                    var direction = sortedDirection ? (isAsc ? 'desc' : 'asc') : undefined;
                                    return (jsx(TableHead, { children: jsxs(FlexBox, __assign({ alignItems: "center", gap: 6 }, { children: [typeof headerName === 'string' ? (jsx(Body, __assign({ color: isSortable ? 'primary' : 'black', bold: true }, { children: headerName }))) : (headerName), sortable && (jsxs(HeadActionContainer, __assign({ flexDirection: "column", justifyContent: "center", alignItems: "center", "data-testid": "sort-action-".concat(i), onClick: function () { return handleSorting && handleSorting(field, direction); } }, { children: [isAsc && jsx(Icon, { name: "caret-up", color: "primary", size: "smaller", noFix: true }), isDesc && jsx(Icon, { name: "caret-down", color: "primary", size: "smaller", noFix: true }), !sortedDirection && jsx(Icon, { name: "arrow-sorting", size: "smallest", noFix: true })] })))] })) }, field));
                                })] })) })), jsx(TableBody, { children: rows.length > 0 &&
                        rows.map(function (data, idx) { return (jsxs(TableRow, __assign({ clickableRows: Boolean(handleRowClick), onClick: function () { return onRowClick(idx); } }, { children: [checkboxSelection && (jsx(TableCell, { children: jsx(Checkbox, { name: "select-".concat(idx), checked: selectAll, onChange: onCheckboxChange }) })), Object.values(data).map(function (entry, eIdx) { return (jsx(TableCell, { children: typeof entry === 'string' ? jsx(Body, { children: entry }) : entry }, "entry-".concat(idx, "-").concat(eIdx))); })] }), "entry-".concat(idx))); }) })] }) })));
};

/* -------------------------------------------------------------------------------------------------
 * Popover
 * -----------------------------------------------------------------------------------------------*/ const $cb5cc270b50c6fcd$var$POPOVER_NAME = 'Popover';
const [$cb5cc270b50c6fcd$var$createPopoverContext, $cb5cc270b50c6fcd$export$c8393c9e73286932] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($cb5cc270b50c6fcd$var$POPOVER_NAME, [
    $cf1ac5d9fe0e8206$export$722aac194ae923
]);
const $cb5cc270b50c6fcd$var$usePopperScope = $cf1ac5d9fe0e8206$export$722aac194ae923();
const [$cb5cc270b50c6fcd$var$PopoverProvider, $cb5cc270b50c6fcd$var$usePopoverContext] = $cb5cc270b50c6fcd$var$createPopoverContext($cb5cc270b50c6fcd$var$POPOVER_NAME);
const $cb5cc270b50c6fcd$export$5b6b19405a83ff9d = (props)=>{
    const { __scopePopover: __scopePopover , children: children , open: openProp , defaultOpen: defaultOpen , onOpenChange: onOpenChange , modal: modal = false  } = props;
    const popperScope = $cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
    const triggerRef = useRef(null);
    const [hasCustomAnchor, setHasCustomAnchor] = useState(false);
    const [open = false, setOpen] = $71cd76cc60e0454e$export$6f32135080cb4c3({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ createElement($cf1ac5d9fe0e8206$export$be92b6f5f03c0fe9, popperScope, /*#__PURE__*/ createElement($cb5cc270b50c6fcd$var$PopoverProvider, {
        scope: __scopePopover,
        contentId: $1746a345f3d73bb7$export$f680877a34711e37(),
        triggerRef: triggerRef,
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: useCallback(()=>setOpen((prevOpen)=>!prevOpen
            )
        , [
            setOpen
        ]),
        hasCustomAnchor: hasCustomAnchor,
        onCustomAnchorAdd: useCallback(()=>setHasCustomAnchor(true)
        , []),
        onCustomAnchorRemove: useCallback(()=>setHasCustomAnchor(false)
        , []),
        modal: modal
    }, children));
};
/* -------------------------------------------------------------------------------------------------
 * PopoverTrigger
 * -----------------------------------------------------------------------------------------------*/ const $cb5cc270b50c6fcd$var$TRIGGER_NAME = 'PopoverTrigger';
const $cb5cc270b50c6fcd$export$7dacb05d26466c3 = /*#__PURE__*/ forwardRef((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover , ...triggerProps } = props;
    const context = $cb5cc270b50c6fcd$var$usePopoverContext($cb5cc270b50c6fcd$var$TRIGGER_NAME, __scopePopover);
    const popperScope = $cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
    const composedTriggerRef = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, context.triggerRef);
    const trigger = /*#__PURE__*/ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.button, _extends({
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": $cb5cc270b50c6fcd$var$getState(context.open)
    }, triggerProps, {
        ref: composedTriggerRef,
        onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onClick, context.onOpenToggle)
    }));
    return context.hasCustomAnchor ? trigger : /*#__PURE__*/ createElement($cf1ac5d9fe0e8206$export$b688253958b8dfe7, _extends({
        asChild: true
    }, popperScope), trigger);
});
/* -------------------------------------------------------------------------------------------------
 * PopoverPortal
 * -----------------------------------------------------------------------------------------------*/ const $cb5cc270b50c6fcd$var$PORTAL_NAME = 'PopoverPortal';
const [$cb5cc270b50c6fcd$var$PortalProvider, $cb5cc270b50c6fcd$var$usePortalContext] = $cb5cc270b50c6fcd$var$createPopoverContext($cb5cc270b50c6fcd$var$PORTAL_NAME, {
    forceMount: undefined
});
/* -------------------------------------------------------------------------------------------------
 * PopoverContent
 * -----------------------------------------------------------------------------------------------*/ const $cb5cc270b50c6fcd$var$CONTENT_NAME = 'PopoverContent';
const $cb5cc270b50c6fcd$export$d7e1f420b25549ff = /*#__PURE__*/ forwardRef((props, forwardedRef)=>{
    const portalContext = $cb5cc270b50c6fcd$var$usePortalContext($cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
    const { forceMount: forceMount = portalContext.forceMount , ...contentProps } = props;
    const context = $cb5cc270b50c6fcd$var$usePopoverContext($cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
    return /*#__PURE__*/ createElement($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
        present: forceMount || context.open
    }, context.modal ? /*#__PURE__*/ createElement($cb5cc270b50c6fcd$var$PopoverContentModal, _extends({}, contentProps, {
        ref: forwardedRef
    })) : /*#__PURE__*/ createElement($cb5cc270b50c6fcd$var$PopoverContentNonModal, _extends({}, contentProps, {
        ref: forwardedRef
    })));
});
/* -----------------------------------------------------------------------------------------------*/ const $cb5cc270b50c6fcd$var$PopoverContentModal = /*#__PURE__*/ forwardRef((props, forwardedRef)=>{
    const context = $cb5cc270b50c6fcd$var$usePopoverContext($cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
    const contentRef = useRef(null);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, contentRef);
    const isRightClickOutsideRef = useRef(false); // aria-hide everything except the content (better supported equivalent to setting aria-modal)
    useEffect(()=>{
        const content = contentRef.current;
        if (content) return hideOthers(content);
    }, []);
    return /*#__PURE__*/ createElement($am6gm$RemoveScroll, {
        as: $5e63c961fc1ce211$export$8c6ed5c666ac1360,
        allowPinchZoom: true
    }, /*#__PURE__*/ createElement($cb5cc270b50c6fcd$var$PopoverContentImpl, _extends({}, props, {
        ref: composedRefs // we make sure we're not trapping once it's been closed
        ,
        trapFocus: context.open,
        disableOutsidePointerEvents: true,
        onCloseAutoFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onCloseAutoFocus, (event)=>{
            var _context$triggerRef$c;
            event.preventDefault();
            if (!isRightClickOutsideRef.current) (_context$triggerRef$c = context.triggerRef.current) === null || _context$triggerRef$c === void 0 || _context$triggerRef$c.focus();
        }),
        onPointerDownOutside: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerDownOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            isRightClickOutsideRef.current = isRightClick;
        }, {
            checkForDefaultPrevented: false
        }) // When focus is trapped, a `focusout` event may still happen.
        ,
        onFocusOutside: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onFocusOutside, (event)=>event.preventDefault()
        , {
            checkForDefaultPrevented: false
        })
    })));
});
const $cb5cc270b50c6fcd$var$PopoverContentNonModal = /*#__PURE__*/ forwardRef((props, forwardedRef)=>{
    const context = $cb5cc270b50c6fcd$var$usePopoverContext($cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
    const hasInteractedOutsideRef = useRef(false);
    const hasPointerDownOutsideRef = useRef(false);
    return /*#__PURE__*/ createElement($cb5cc270b50c6fcd$var$PopoverContentImpl, _extends({}, props, {
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            var _props$onCloseAutoFoc;
            (_props$onCloseAutoFoc = props.onCloseAutoFocus) === null || _props$onCloseAutoFoc === void 0 || _props$onCloseAutoFoc.call(props, event);
            if (!event.defaultPrevented) {
                var _context$triggerRef$c2;
                if (!hasInteractedOutsideRef.current) (_context$triggerRef$c2 = context.triggerRef.current) === null || _context$triggerRef$c2 === void 0 || _context$triggerRef$c2.focus(); // Always prevent auto focus because we either focus manually or want user agent focus
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            var _props$onInteractOuts, _context$triggerRef$c3;
            (_props$onInteractOuts = props.onInteractOutside) === null || _props$onInteractOuts === void 0 || _props$onInteractOuts.call(props, event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === 'pointerdown') hasPointerDownOutsideRef.current = true;
            } // Prevent dismissing when clicking the trigger.
            // As the trigger is already setup to close, without doing so would
            // cause it to close and immediately open.
            const target = event.target;
            const targetIsTrigger = (_context$triggerRef$c3 = context.triggerRef.current) === null || _context$triggerRef$c3 === void 0 ? void 0 : _context$triggerRef$c3.contains(target);
            if (targetIsTrigger) event.preventDefault(); // On Safari if the trigger is inside a container with tabIndex={0}, when clicked
            // we will get the pointer down outside event on the trigger, but then a subsequent
            // focus outside event on the container, we ignore any focus outside event when we've
            // already had a pointer down outside event.
            if (event.detail.originalEvent.type === 'focusin' && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const $cb5cc270b50c6fcd$var$PopoverContentImpl = /*#__PURE__*/ forwardRef((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover , trapFocus: trapFocus , onOpenAutoFocus: onOpenAutoFocus , onCloseAutoFocus: onCloseAutoFocus , disableOutsidePointerEvents: disableOutsidePointerEvents , onEscapeKeyDown: onEscapeKeyDown , onPointerDownOutside: onPointerDownOutside , onFocusOutside: onFocusOutside , onInteractOutside: onInteractOutside , ...contentProps } = props;
    const context = $cb5cc270b50c6fcd$var$usePopoverContext($cb5cc270b50c6fcd$var$CONTENT_NAME, __scopePopover);
    const popperScope = $cb5cc270b50c6fcd$var$usePopperScope(__scopePopover); // Make sure the whole tree has focus guards as our `Popover` may be
    // the last element in the DOM (beacuse of the `Portal`)
    $3db38b7d1fb3fe6a$export$b7ece24a22aeda8c();
    return /*#__PURE__*/ createElement($d3863c46a17e8a28$export$20e40289641fbbb6, {
        asChild: true,
        loop: true,
        trapped: trapFocus,
        onMountAutoFocus: onOpenAutoFocus,
        onUnmountAutoFocus: onCloseAutoFocus
    }, /*#__PURE__*/ createElement($5cb92bef7577960e$export$177fb62ff3ec1f22, {
        asChild: true,
        disableOutsidePointerEvents: disableOutsidePointerEvents,
        onInteractOutside: onInteractOutside,
        onEscapeKeyDown: onEscapeKeyDown,
        onPointerDownOutside: onPointerDownOutside,
        onFocusOutside: onFocusOutside,
        onDismiss: ()=>context.onOpenChange(false)
    }, /*#__PURE__*/ createElement($cf1ac5d9fe0e8206$export$7c6e2c02157bb7d2, _extends({
        "data-state": $cb5cc270b50c6fcd$var$getState(context.open),
        role: "dialog",
        id: context.contentId
    }, popperScope, contentProps, {
        ref: forwardedRef,
        style: {
            ...contentProps.style,
            '--radix-popover-content-transform-origin': 'var(--radix-popper-transform-origin)',
            '--radix-popover-content-available-width': 'var(--radix-popper-available-width)',
            '--radix-popover-content-available-height': 'var(--radix-popper-available-height)',
            '--radix-popover-trigger-width': 'var(--radix-popper-anchor-width)',
            '--radix-popover-trigger-height': 'var(--radix-popper-anchor-height)'
        }
    }))));
});
/* -------------------------------------------------------------------------------------------------
 * PopoverClose
 * -----------------------------------------------------------------------------------------------*/ const $cb5cc270b50c6fcd$var$CLOSE_NAME = 'PopoverClose';
const $cb5cc270b50c6fcd$export$d6ac43ebaa40d53e = /*#__PURE__*/ forwardRef((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover , ...closeProps } = props;
    const context = $cb5cc270b50c6fcd$var$usePopoverContext($cb5cc270b50c6fcd$var$CLOSE_NAME, __scopePopover);
    return /*#__PURE__*/ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.button, _extends({
        type: "button"
    }, closeProps, {
        ref: forwardedRef,
        onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onClick, ()=>context.onOpenChange(false)
        )
    }));
});
/* -----------------------------------------------------------------------------------------------*/ function $cb5cc270b50c6fcd$var$getState(open) {
    return open ? 'open' : 'closed';
}
const $cb5cc270b50c6fcd$export$be92b6f5f03c0fe9 = $cb5cc270b50c6fcd$export$5b6b19405a83ff9d;
const $cb5cc270b50c6fcd$export$41fb9f06171c75f4 = $cb5cc270b50c6fcd$export$7dacb05d26466c3;
const $cb5cc270b50c6fcd$export$7c6e2c02157bb7d2 = $cb5cc270b50c6fcd$export$d7e1f420b25549ff;
const $cb5cc270b50c6fcd$export$f39c2d165cd861fe = $cb5cc270b50c6fcd$export$d6ac43ebaa40d53e;

var ButtonMenuItem = styled.button(templateObject_1$f || (templateObject_1$f = __makeTemplateObject(["\n  font-family: ", ";\n  color: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  padding: 8px 16px;\n  height: 36px;\n  display: inline-flex;\n  gap: 8px;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  background: ", ";\n  overflow: hidden;\n  ", "\n  & > span {\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n\n  ", "\n  &:active, &:hover {\n    border-color: ", ";\n  }\n  &.focus,\n  &:focus-visible {\n    outline: 2px solid ", ";\n    box-shadow: 0px 0px 2px 4px var(--focus);\n  }\n"], ["\n  font-family: ", ";\n  color: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  padding: 8px 16px;\n  height: 36px;\n  display: inline-flex;\n  gap: 8px;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  background: ", ";\n  overflow: hidden;\n  ", "\n  & > span {\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n\n  ", "\n  &:active, &:hover {\n    border-color: ", ";\n  }\n  &.focus,\n  &:focus-visible {\n    outline: 2px solid ", ";\n    box-shadow: 0px 0px 2px 4px var(--focus);\n  }\n"])), fontFamily, colorText.colorTextTextPrimary, fontMap.normal.fontSize, fontMap.normal.lineHeight, weightMap$1.bold, colorFormBorder.colorFormBorderDefault, theming.borderRadius, colorSurface.primary, function (_a) {
    var maxWidth = _a.maxWidth, minWidth = _a.minWidth;
    return "\n    max-width: ".concat(getSizeValue(maxWidth), ";\n    min-width: ").concat(getSizeValue(minWidth), ";\n  ");
}, function (_a) {
    var isOpen = _a.isOpen;
    return isOpen &&
        "\n    border-color: ".concat(colorFormBorder.colorFormBorderActive, ";\n    cursor: pointer;\n  ");
}, colorFormBorder.colorFormBorderActive, colorBase['colorNeutral-0']);
var DropdownButton = forwardRef(function (_a, ref) {
    var _b = _a.type, type = _b === void 0 ? 'dropdown' : _b, icon = _a.icon, label = _a.label, name = _a.name, _c = _a.maxWidth, maxWidth = _c === void 0 ? 250 : _c, _d = _a.minWidth, minWidth = _d === void 0 ? 100 : _d, _e = _a.isOpen, isOpen = _e === void 0 ? false : _e, rest = __rest(_a, ["type", "icon", "label", "name", "maxWidth", "minWidth", "isOpen"]);
    return (jsx(ButtonMenuItem, __assign({ "data-testid": "".concat(name, "-button"), isOpen: isOpen, maxWidth: maxWidth, minWidth: minWidth, name: name, ref: ref }, rest, { children: Boolean(label) && (jsx(WithLabel, { highlightedIcon: false, icon: icon, iconPosition: type === 'button' ? 'left' : 'right', iconColor: "grayDark", label: jsx("span", { children: label }) })) })));
});
DropdownButton.displayName = 'DropdownButton';
var templateObject_1$f;

var DropdownContent = styled($cb5cc270b50c6fcd$export$7c6e2c02157bb7d2)(templateObject_1$e || (templateObject_1$e = __makeTemplateObject(["\n  background-color: ", ";\n  z-index: ", ";\n  position: relative;\n  border-radius: ", ";\n  border: 2px solid ", ";\n  margin-top: 4px;\n  box-shadow: ", ";\n  &:focus-visible {\n    outline: none;\n  }\n"], ["\n  background-color: ", ";\n  z-index: ", ";\n  position: relative;\n  border-radius: ", ";\n  border: 2px solid ", ";\n  margin-top: 4px;\n  box-shadow: ", ";\n  &:focus-visible {\n    outline: none;\n  }\n"])), colorSurface.primary, zIndexMap.dropdown, theming.borderRadius, colorBorder$1.colorBorderBorderPrimary, shadow.larger);
var templateObject_1$e;

function Dropdown(_a) {
    var children = _a.children, label = _a.label, _b = _a.name, name = _b === void 0 ? 'dropdown' : _b, onClickOutside = _a.onClickOutside, onClose = _a.onClose, onOpen = _a.onOpen, _c = _a.filtersButton, filtersButton = _c === void 0 ? true : _c, _d = _a.triggerComponentProps, triggerComponentProps = _d === void 0 ? {} : _d, dropdownContentProps = __rest(_a, ["children", "label", "name", "onClickOutside", "onClose", "onOpen", "filtersButton", "triggerComponentProps"]);
    var _e = useState(false), open = _e[0], setOpen = _e[1];
    var _f = dropdownContentProps.align, align = _f === void 0 ? 'start' : _f;
    var handleOpenChange = function (open) {
        setOpen(open);
        if (!open) {
            onClose === null || onClose === void 0 ? void 0 : onClose();
        }
        else {
            onOpen === null || onOpen === void 0 ? void 0 : onOpen();
        }
    };
    var TriggerComponent = filtersButton ? DropdownButton : Button;
    return (jsxs($cb5cc270b50c6fcd$export$be92b6f5f03c0fe9, __assign({ onOpenChange: handleOpenChange }, { children: [jsx($cb5cc270b50c6fcd$export$41fb9f06171c75f4, __assign({ asChild: true }, { children: jsx(TriggerComponent, __assign({ name: name, isOpen: open, label: label, type: "dropdown", icon: open ? 'caret-up' : 'caret-down' }, triggerComponentProps, { asChild: true })) })), jsx(DropdownContent, __assign({ "data-testid": "".concat(name, "-content"), align: align }, dropdownContentProps, { onPointerDownOutside: onClickOutside }, { children: children }))] })));
}

var sortChildrenByLabel = function (list) {
    return list === null || list === void 0 ? void 0 : list.sort(function (a, b) { return a.props.label.localeCompare(b.props.label); });
};
var getSortFunction = function (_a) {
    var enableShowMoreButton = _a.enableShowMoreButton, showAllOptions = _a.showAllOptions, defaultSortFunction = _a.defaultSortFunction, expandedSortFunction = _a.expandedSortFunction, collapsedSortFunction = _a.collapsedSortFunction;
    if (!enableShowMoreButton) {
        return defaultSortFunction;
    }
    return showAllOptions ? expandedSortFunction : collapsedSortFunction;
};
var sort = function (sortFunction, list) { return (sortFunction ? sortFunction(list) : list); };
var getSortedOptions = function (_a) {
    var enableShowMoreButton = _a.enableShowMoreButton, showAllOptions = _a.showAllOptions, defaultSortFunction = _a.defaultSortFunction, expandedSortFunction = _a.expandedSortFunction, collapsedSortFunction = _a.collapsedSortFunction, options = _a.options;
    return sort(getSortFunction({
        enableShowMoreButton: enableShowMoreButton,
        showAllOptions: showAllOptions,
        defaultSortFunction: defaultSortFunction,
        expandedSortFunction: expandedSortFunction,
        collapsedSortFunction: collapsedSortFunction
    }), options);
};

var DEAFAULT_MAX_VISIBLE_OPTIONS_COLLAPSED = 5;
var DEFAULT_MIN_OPTIONS_TO_SHOW_COLLAPSED_BUTTON = 10;
var Expandable = function (_a) {
    var children = _a.children, _b = _a.maxVisibleOptionsCollapsed, maxVisibleOptionsCollapsed = _b === void 0 ? DEAFAULT_MAX_VISIBLE_OPTIONS_COLLAPSED : _b, _c = _a.minOptionsToShowCollapsedButton, minOptionsToShowCollapsedButton = _c === void 0 ? DEFAULT_MIN_OPTIONS_TO_SHOW_COLLAPSED_BUTTON : _c, defaultSortFunction = _a.defaultSortFunction, expandedSortFunction = _a.expandedSortFunction, collapsedSortFunction = _a.collapsedSortFunction, collapsedButtonText = _a.collapsedButtonText, expandedButtonText = _a.expandedButtonText, buttonProps = _a.buttonProps;
    var enableShowMoreButton = (children === null || children === void 0 ? void 0 : children.length) > minOptionsToShowCollapsedButton;
    var _d = useState(!enableShowMoreButton), showAllOptions = _d[0], setShowAllOptions = _d[1];
    var orderedChildren = useMemo(function () {
        var options = __spreadArray([], children, true);
        var orderedOptions = getSortedOptions({
            enableShowMoreButton: enableShowMoreButton,
            showAllOptions: showAllOptions,
            defaultSortFunction: defaultSortFunction,
            expandedSortFunction: expandedSortFunction,
            collapsedSortFunction: collapsedSortFunction,
            options: options
        });
        var visibleOptions = orderedOptions.slice(0, showAllOptions ? orderedOptions.length : maxVisibleOptionsCollapsed);
        return visibleOptions;
    }, [showAllOptions, children]);
    return (jsxs(Fragment, { children: [orderedChildren, enableShowMoreButton && (jsx(Button, __assign({ variant: "tertiary", size: "smaller", onClick: function () { return setShowAllOptions(!showAllOptions); } }, buttonProps, { children: showAllOptions ? expandedButtonText : collapsedButtonText })))] }));
};

var Input = styled.input(templateObject_1$d || (templateObject_1$d = __makeTemplateObject(["\n  display: none;\n"], ["\n  display: none;\n"])));
var CustomFileUpload = styled.button(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n  ", "\n  display: flex;\n  cursor: pointer;\n  height: 72px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  background: ", ";\n  &:focus-visible,\n  &.focus {\n    box-shadow: 0px 0px 2px 2px var(--focus);\n  }\n"], ["\n  ", "\n  display: flex;\n  cursor: pointer;\n  height: 72px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  background: ", ";\n  &:focus-visible,\n  &.focus {\n    box-shadow: 0px 0px 2px 2px var(--focus);\n  }\n"])), function (_a) {
    var showError = _a.showError, fullWidth = _a.fullWidth;
    return "\n    border: 2px dashed ".concat(showError ? colorFormBorder.colorFormBorderError : colorFormBorder.colorFormBorderActive, ";\n    width: ").concat(fullWidth ? '100%' : '250px', ";\n  ");
}, colorFormSurface.colorFormSurfaceWashed);
var templateObject_1$d, templateObject_2$2;

var COMMON_MIME_TYPES = new Map([
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
    ['aac', 'audio/aac'],
    ['abw', 'application/x-abiword'],
    ['arc', 'application/x-freearc'],
    ['avif', 'image/avif'],
    ['avi', 'video/x-msvideo'],
    ['azw', 'application/vnd.amazon.ebook'],
    ['bin', 'application/octet-stream'],
    ['bmp', 'image/bmp'],
    ['bz', 'application/x-bzip'],
    ['bz2', 'application/x-bzip2'],
    ['cda', 'application/x-cdf'],
    ['csh', 'application/x-csh'],
    ['css', 'text/css'],
    ['csv', 'text/csv'],
    ['doc', 'application/msword'],
    ['docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
    ['eot', 'application/vnd.ms-fontobject'],
    ['epub', 'application/epub+zip'],
    ['gz', 'application/gzip'],
    ['gif', 'image/gif'],
    ['heic', 'image/heic'],
    ['heif', 'image/heif'],
    ['htm', 'text/html'],
    ['html', 'text/html'],
    ['ico', 'image/vnd.microsoft.icon'],
    ['ics', 'text/calendar'],
    ['jar', 'application/java-archive'],
    ['jpeg', 'image/jpeg'],
    ['jpg', 'image/jpeg'],
    ['js', 'text/javascript'],
    ['json', 'application/json'],
    ['jsonld', 'application/ld+json'],
    ['mid', 'audio/midi'],
    ['midi', 'audio/midi'],
    ['mjs', 'text/javascript'],
    ['mp3', 'audio/mpeg'],
    ['mp4', 'video/mp4'],
    ['mpeg', 'video/mpeg'],
    ['mpkg', 'application/vnd.apple.installer+xml'],
    ['odp', 'application/vnd.oasis.opendocument.presentation'],
    ['ods', 'application/vnd.oasis.opendocument.spreadsheet'],
    ['odt', 'application/vnd.oasis.opendocument.text'],
    ['oga', 'audio/ogg'],
    ['ogv', 'video/ogg'],
    ['ogx', 'application/ogg'],
    ['opus', 'audio/opus'],
    ['otf', 'font/otf'],
    ['png', 'image/png'],
    ['pdf', 'application/pdf'],
    ['php', 'application/x-httpd-php'],
    ['ppt', 'application/vnd.ms-powerpoint'],
    ['pptx', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'],
    ['rar', 'application/vnd.rar'],
    ['rtf', 'application/rtf'],
    ['sh', 'application/x-sh'],
    ['svg', 'image/svg+xml'],
    ['swf', 'application/x-shockwave-flash'],
    ['tar', 'application/x-tar'],
    ['tif', 'image/tiff'],
    ['tiff', 'image/tiff'],
    ['ts', 'video/mp2t'],
    ['ttf', 'font/ttf'],
    ['txt', 'text/plain'],
    ['vsd', 'application/vnd.visio'],
    ['wav', 'audio/wav'],
    ['weba', 'audio/webm'],
    ['webm', 'video/webm'],
    ['webp', 'image/webp'],
    ['woff', 'font/woff'],
    ['woff2', 'font/woff2'],
    ['xhtml', 'application/xhtml+xml'],
    ['xls', 'application/vnd.ms-excel'],
    ['xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
    ['xml', 'application/xml'],
    ['xul', 'application/vnd.mozilla.xul+xml'],
    ['zip', 'application/zip'],
    ['7z', 'application/x-7z-compressed'],
    // Others
    ['mkv', 'video/x-matroska'],
    ['mov', 'video/quicktime'],
    ['msg', 'application/vnd.ms-outlook']
]);
function toFileWithPath(file, path) {
    var f = withMimeType(file);
    if (typeof f.path !== 'string') { // on electron, path is already set to the absolute path
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, 'path', {
            value: typeof path === 'string'
                ? path
                // If <input webkitdirectory> is set,
                // the File will have a {webkitRelativePath} property
                // https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/webkitdirectory
                : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0
                    ? webkitRelativePath
                    : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf('.') !== -1;
    if (hasExtension && !file.type) {
        var ext = name.split('.')
            .pop().toLowerCase();
        var type = COMMON_MIME_TYPES.get(ext);
        if (type) {
            Object.defineProperty(file, 'type', {
                value: type,
                writable: false,
                configurable: false,
                enumerable: true
            });
        }
    }
    return file;
}

var FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    '.DS_Store',
    'Thumbs.db' // Windows
];
/**
 * Convert a DragEvent's DataTrasfer object to a list of File objects
 * NOTE: If some of the items are folders,
 * everything will be flattened and placed in the same list but the paths will be kept as a {path} property.
 *
 * EXPERIMENTAL: A list of https://developer.mozilla.org/en-US/docs/Web/API/FileSystemHandle objects can also be passed as an arg
 * and a list of File objects will be returned.
 *
 * @param evt
 */
function fromEvent(evt) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (isObject(evt) && isDataTransfer(evt.dataTransfer)) {
                return [2 /*return*/, getDataTransferFiles(evt.dataTransfer, evt.type)];
            }
            else if (isChangeEvt(evt)) {
                return [2 /*return*/, getInputFiles(evt)];
            }
            else if (Array.isArray(evt) && evt.every(function (item) { return 'getFile' in item && typeof item.getFile === 'function'; })) {
                return [2 /*return*/, getFsHandleFiles(evt)];
            }
            return [2 /*return*/, []];
        });
    });
}
function isDataTransfer(value) {
    return isObject(value);
}
function isChangeEvt(value) {
    return isObject(value) && isObject(value.target);
}
function isObject(v) {
    return typeof v === 'object' && v !== null;
}
function getInputFiles(evt) {
    return fromList(evt.target.files).map(function (file) { return toFileWithPath(file); });
}
// Ee expect each handle to be https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileHandle
function getFsHandleFiles(handles) {
    return __awaiter(this, void 0, void 0, function () {
        var files;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.all(handles.map(function (h) { return h.getFile(); }))];
                case 1:
                    files = _a.sent();
                    return [2 /*return*/, files.map(function (file) { return toFileWithPath(file); })];
            }
        });
    });
}
function getDataTransferFiles(dt, type) {
    return __awaiter(this, void 0, void 0, function () {
        var items, files;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!dt.items) return [3 /*break*/, 2];
                    items = fromList(dt.items)
                        .filter(function (item) { return item.kind === 'file'; });
                    // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
                    // only 'dragstart' and 'drop' has access to the data (source node)
                    if (type !== 'drop') {
                        return [2 /*return*/, items];
                    }
                    return [4 /*yield*/, Promise.all(items.map(toFilePromises))];
                case 1:
                    files = _a.sent();
                    return [2 /*return*/, noIgnoredFiles(flatten(files))];
                case 2: return [2 /*return*/, noIgnoredFiles(fromList(dt.files)
                        .map(function (file) { return toFileWithPath(file); }))];
            }
        });
    });
}
function noIgnoredFiles(files) {
    return files.filter(function (file) { return FILES_TO_IGNORE.indexOf(file.name) === -1; });
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function fromList(items) {
    if (items === null) {
        return [];
    }
    var files = [];
    // tslint:disable: prefer-for-of
    for (var i = 0; i < items.length; i++) {
        var file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== 'function') {
        return fromDataTransferItem(item);
    }
    var entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) {
        return fromDirEntry(entry);
    }
    return fromDataTransferItem(item);
}
function flatten(items) {
    return items.reduce(function (acc, files) { return __spreadArray(__spreadArray([], __read(acc), false), __read((Array.isArray(files) ? flatten(files) : [files])), false); }, []);
}
function fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) {
        return Promise.reject("".concat(item, " is not a File"));
    }
    var fwp = toFileWithPath(file);
    return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function fromEntry(entry) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry)];
        });
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function (resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries(function (batch) { return __awaiter(_this, void 0, void 0, function () {
                var files, err_1, items;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!batch.length) return [3 /*break*/, 5];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, Promise.all(entries)];
                        case 2:
                            files = _a.sent();
                            resolve(files);
                            return [3 /*break*/, 4];
                        case 3:
                            err_1 = _a.sent();
                            reject(err_1);
                            return [3 /*break*/, 4];
                        case 4: return [3 /*break*/, 6];
                        case 5:
                            items = Promise.all(batch.map(fromEntry));
                            entries.push(items);
                            // Continue reading
                            readEntries();
                            _a.label = 6;
                        case 6: return [2 /*return*/];
                    }
                });
            }); }, function (err) {
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function fromFileEntry(entry) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    entry.file(function (file) {
                        var fwp = toFileWithPath(file, entry.fullPath);
                        resolve(fwp);
                    }, function (err) {
                        reject(err);
                    });
                })];
        });
    });
}

var _default = function (file, acceptedFiles) {
  if (file && acceptedFiles) {
    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
    var fileName = file.name || '';
    var mimeType = (file.type || '').toLowerCase();
    var baseMimeType = mimeType.replace(/\/.*$/, '');
    return acceptedFilesArray.some(function (type) {
      var validType = type.trim().toLowerCase();

      if (validType.charAt(0) === '.') {
        return fileName.toLowerCase().endsWith(validType);
      } else if (validType.endsWith('/*')) {
        // This is something like a image/* mime type
        return baseMimeType === validType.replace(/\/.*$/, '');
      }

      return mimeType === validType;
    });
  }

  return true;
};

function _toConsumableArray$1(arr) { return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableSpread$1(); }

function _nonIterableSpread$1() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray$1(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles$1(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$1(arr); }

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray$1(arr, i) { return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest$1(); }

function _nonIterableRest$1() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }

function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$1(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$1(arr) { if (Array.isArray(arr)) return arr; }

var FILE_INVALID_TYPE = "file-invalid-type";
var FILE_TOO_LARGE = "file-too-large";
var FILE_TOO_SMALL = "file-too-small";
var TOO_MANY_FILES = "too-many-files";

var getInvalidTypeRejectionErr = function getInvalidTypeRejectionErr(accept) {
  accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
  var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(", ")) : accept;
  return {
    code: FILE_INVALID_TYPE,
    message: "File type must be ".concat(messageSuffix)
  };
};
var getTooLargeRejectionErr = function getTooLargeRejectionErr(maxSize) {
  return {
    code: FILE_TOO_LARGE,
    message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? "byte" : "bytes")
  };
};
var getTooSmallRejectionErr = function getTooSmallRejectionErr(minSize) {
  return {
    code: FILE_TOO_SMALL,
    message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? "byte" : "bytes")
  };
};
var TOO_MANY_FILES_REJECTION = {
  code: TOO_MANY_FILES,
  message: "Too many files"
}; // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
// that MIME type will always be accepted

function fileAccepted(file, accept) {
  var isAcceptable = file.type === "application/x-moz-file" || _default(file, accept);
  return [isAcceptable, isAcceptable ? null : getInvalidTypeRejectionErr(accept)];
}
function fileMatchSize(file, minSize, maxSize) {
  if (isDefined(file.size)) {
    if (isDefined(minSize) && isDefined(maxSize)) {
      if (file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
      if (file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];
    } else if (isDefined(minSize) && file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];else if (isDefined(maxSize) && file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
  }

  return [true, null];
}

function isDefined(value) {
  return value !== undefined && value !== null;
}
/**
 *
 * @param {object} options
 * @param {File[]} options.files
 * @param {string|string[]} [options.accept]
 * @param {number} [options.minSize]
 * @param {number} [options.maxSize]
 * @param {boolean} [options.multiple]
 * @param {number} [options.maxFiles]
 * @param {(f: File) => FileError|FileError[]|null} [options.validator]
 * @returns
 */


function allFilesAccepted(_ref) {
  var files = _ref.files,
      accept = _ref.accept,
      minSize = _ref.minSize,
      maxSize = _ref.maxSize,
      multiple = _ref.multiple,
      maxFiles = _ref.maxFiles,
      validator = _ref.validator;

  if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) {
    return false;
  }

  return files.every(function (file) {
    var _fileAccepted = fileAccepted(file, accept),
        _fileAccepted2 = _slicedToArray$1(_fileAccepted, 1),
        accepted = _fileAccepted2[0];

    var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
        _fileMatchSize2 = _slicedToArray$1(_fileMatchSize, 1),
        sizeMatch = _fileMatchSize2[0];

    var customErrors = validator ? validator(file) : null;
    return accepted && sizeMatch && !customErrors;
  });
} // React's synthetic events has event.isPropagationStopped,
// but to remain compatibility with other libs (Preact) fall back
// to check event.cancelBubble

function isPropagationStopped(event) {
  if (typeof event.isPropagationStopped === "function") {
    return event.isPropagationStopped();
  } else if (typeof event.cancelBubble !== "undefined") {
    return event.cancelBubble;
  }

  return false;
}
function isEvtWithFiles(event) {
  if (!event.dataTransfer) {
    return !!event.target && !!event.target.files;
  } // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
  // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file


  return Array.prototype.some.call(event.dataTransfer.types, function (type) {
    return type === "Files" || type === "application/x-moz-file";
  });
}

function onDocumentDragOver(event) {
  event.preventDefault();
}

function isIe(userAgent) {
  return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}

function isEdge(userAgent) {
  return userAgent.indexOf("Edge/") !== -1;
}

function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  return isIe(userAgent) || isEdge(userAgent);
}
/**
 * This is intended to be used to compose event handlers
 * They are executed in order until one of them calls `event.isPropagationStopped()`.
 * Note that the check is done on the first invoke too,
 * meaning that if propagation was stopped before invoking the fns,
 * no handlers will be executed.
 *
 * @param {Function} fns the event hanlder functions
 * @return {Function} the event handler to add to an element
 */

function composeEventHandlers() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (event) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return fns.some(function (fn) {
      if (!isPropagationStopped(event) && fn) {
        fn.apply(void 0, [event].concat(args));
      }

      return isPropagationStopped(event);
    });
  };
}
/**
 * canUseFileSystemAccessAPI checks if the [File System Access API](https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API)
 * is supported by the browser.
 * @returns {boolean}
 */

function canUseFileSystemAccessAPI() {
  return "showOpenFilePicker" in window;
}
/**
 * Convert the `{accept}` dropzone prop to the
 * `{types}` option for https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker
 *
 * @param {AcceptProp} accept
 * @returns {{accept: string[]}[]}
 */

function pickerOptionsFromAccept(accept) {
  if (isDefined(accept)) {
    var acceptForPicker = Object.entries(accept).filter(function (_ref2) {
      var _ref3 = _slicedToArray$1(_ref2, 2),
          mimeType = _ref3[0],
          ext = _ref3[1];

      var ok = true;

      if (!isMIMEType(mimeType)) {
        console.warn("Skipped \"".concat(mimeType, "\" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types."));
        ok = false;
      }

      if (!Array.isArray(ext) || !ext.every(isExt)) {
        console.warn("Skipped \"".concat(mimeType, "\" because an invalid file extension was provided."));
        ok = false;
      }

      return ok;
    }).reduce(function (agg, _ref4) {
      var _ref5 = _slicedToArray$1(_ref4, 2),
          mimeType = _ref5[0],
          ext = _ref5[1];

      return _objectSpread$1(_objectSpread$1({}, agg), {}, _defineProperty$1({}, mimeType, ext));
    }, {});
    return [{
      // description is required due to https://crbug.com/1264708
      description: "Files",
      accept: acceptForPicker
    }];
  }

  return accept;
}
/**
 * Convert the `{accept}` dropzone prop to an array of MIME types/extensions.
 * @param {AcceptProp} accept
 * @returns {string}
 */

function acceptPropAsAcceptAttr(accept) {
  if (isDefined(accept)) {
    return Object.entries(accept).reduce(function (a, _ref6) {
      var _ref7 = _slicedToArray$1(_ref6, 2),
          mimeType = _ref7[0],
          ext = _ref7[1];

      return [].concat(_toConsumableArray$1(a), [mimeType], _toConsumableArray$1(ext));
    }, []) // Silently discard invalid entries as pickerOptionsFromAccept warns about these
    .filter(function (v) {
      return isMIMEType(v) || isExt(v);
    }).join(",");
  }

  return undefined;
}
/**
 * Check if v is an exception caused by aborting a request (e.g window.showOpenFilePicker()).
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/DOMException.
 * @param {any} v
 * @returns {boolean} True if v is an abort exception.
 */

function isAbort(v) {
  return v instanceof DOMException && (v.name === "AbortError" || v.code === v.ABORT_ERR);
}
/**
 * Check if v is a security error.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/DOMException.
 * @param {any} v
 * @returns {boolean} True if v is a security error.
 */

function isSecurityError(v) {
  return v instanceof DOMException && (v.name === "SecurityError" || v.code === v.SECURITY_ERR);
}
/**
 * Check if v is a MIME type string.
 *
 * See accepted format: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#unique_file_type_specifiers.
 *
 * @param {string} v
 */

function isMIMEType(v) {
  return v === "audio/*" || v === "video/*" || v === "image/*" || v === "text/*" || /\w+\/[-+.\w]+/g.test(v);
}
/**
 * Check if v is a file extension.
 * @param {string} v
 */

function isExt(v) {
  return /^.*\.[\w]+$/.test(v);
}
/**
 * @typedef {Object.<string, string[]>} AcceptProp
 */

/**
 * @typedef {object} FileError
 * @property {string} message
 * @property {ErrorCode|string} code
 */

/**
 * @typedef {"file-invalid-type"|"file-too-large"|"file-too-small"|"too-many-files"} ErrorCode
 */

var _excluded = ["children"],
    _excluded2 = ["open"],
    _excluded3 = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"],
    _excluded4 = ["refKey", "onChange", "onClick"];

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */

var Dropzone = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      params = _objectWithoutProperties(_ref, _excluded);

  var _useDropzone = useDropzone(params),
      open = _useDropzone.open,
      props = _objectWithoutProperties(_useDropzone, _excluded2);

  useImperativeHandle(ref, function () {
    return {
      open: open
    };
  }, [open]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element

  return /*#__PURE__*/React__default.createElement(Fragment$1, null, children(_objectSpread(_objectSpread({}, props), {}, {
    open: open
  })));
});
Dropzone.displayName = "Dropzone"; // Add default props for react-docgen

var defaultProps = {
  disabled: false,
  getFilesFromEvent: fromEvent,
  maxSize: Infinity,
  minSize: 0,
  multiple: true,
  maxFiles: 0,
  preventDropOnDocument: true,
  noClick: false,
  noKeyboard: false,
  noDrag: false,
  noDragEventsBubbling: false,
  validator: null,
  useFsAccessApi: true,
  autoFocus: false
};
Dropzone.defaultProps = defaultProps;
Dropzone.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: propTypesExports.func,

  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: propTypesExports.objectOf(propTypesExports.arrayOf(propTypesExports.string)),

  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: propTypesExports.bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: propTypesExports.bool,

  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: propTypesExports.bool,

  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: propTypesExports.bool,

  /**
   * If true, disables drag 'n' drop
   */
  noDrag: propTypesExports.bool,

  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: propTypesExports.bool,

  /**
   * Minimum file size (in bytes)
   */
  minSize: propTypesExports.number,

  /**
   * Maximum file size (in bytes)
   */
  maxSize: propTypesExports.number,

  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: propTypesExports.number,

  /**
   * Enable/disable the dropzone
   */
  disabled: propTypesExports.bool,

  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: propTypesExports.func,

  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: propTypesExports.func,

  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: propTypesExports.func,

  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: propTypesExports.bool,

  /**
   * Set to true to focus the root element on render
   */
  autoFocus: propTypesExports.bool,

  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: propTypesExports.func,

  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: propTypesExports.func,

  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: propTypesExports.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: propTypesExports.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: propTypesExports.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: propTypesExports.func,

  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: propTypesExports.func,

  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: propTypesExports.func
};
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */

/**
 * An object with the current dropzone state.
 *
 * @typedef {object} DropzoneState
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */

/**
 * An object with the dropzone methods.
 *
 * @typedef {object} DropzoneMethods
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 */

var initialState = {
  isFocused: false,
  isFileDialogActive: false,
  isDragActive: false,
  isDragAccept: false,
  isDragReject: false,
  acceptedFiles: [],
  fileRejections: []
};
/**
 * A React hook that creates a drag 'n' drop area.
 *
 * ```jsx
 * function MyDropzone(props) {
 *   const {getRootProps, getInputProps} = useDropzone({
 *     onDrop: acceptedFiles => {
 *       // do something with the File objects, e.g. upload to some server
 *     }
 *   });
 *   return (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag and drop some files here, or click to select files</p>
 *     </div>
 *   )
 * }
 * ```
 *
 * @function useDropzone
 *
 * @param {object} props
 * @param {import("./utils").AcceptProp} [props.accept] Set accepted file types.
 * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
 * Keep in mind that mime type determination is not reliable across platforms. CSV files,
 * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
 * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
 * @param {boolean} [props.multiple=true] Allow drag 'n' drop (or selection from the file dialog) of multiple files
 * @param {boolean} [props.preventDropOnDocument=true] If false, allow dropped items to take over the current browser window
 * @param {boolean} [props.noClick=false] If true, disables click to open the native file selection dialog
 * @param {boolean} [props.noKeyboard=false] If true, disables SPACE/ENTER to open the native file selection dialog.
 * Note that it also stops tracking the focus state.
 * @param {boolean} [props.noDrag=false] If true, disables drag 'n' drop
 * @param {boolean} [props.noDragEventsBubbling=false] If true, stops drag event propagation to parents
 * @param {number} [props.minSize=0] Minimum file size (in bytes)
 * @param {number} [props.maxSize=Infinity] Maximum file size (in bytes)
 * @param {boolean} [props.disabled=false] Enable/disable the dropzone
 * @param {getFilesFromEvent} [props.getFilesFromEvent] Use this to provide a custom file aggregator
 * @param {Function} [props.onFileDialogCancel] Cb for when closing the file dialog with no selection
 * @param {boolean} [props.useFsAccessApi] Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
 * to open the file picker instead of using an `<input type="file">` click event.
 * @param {boolean} autoFocus Set to true to auto focus the root element.
 * @param {Function} [props.onFileDialogOpen] Cb for when opening the file dialog
 * @param {dragCb} [props.onDragEnter] Cb for when the `dragenter` event occurs.
 * @param {dragCb} [props.onDragLeave] Cb for when the `dragleave` event occurs
 * @param {dragCb} [props.onDragOver] Cb for when the `dragover` event occurs
 * @param {dropCb} [props.onDrop] Cb for when the `drop` event occurs.
 * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
 *
 * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
 * `accept` must be an object with keys as a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) and the value an array of file extensions (optional).
 * If `multiple` is set to false and additional files are dropped,
 * all files besides the first will be rejected.
 * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
 *
 * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
 * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
 *
 * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
 * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
 *
 * ```js
 * function onDrop(acceptedFiles) {
 *   const req = request.post('/upload')
 *   acceptedFiles.forEach(file => {
 *     req.attach(file.name, file)
 *   })
 *   req.end(callback)
 * }
 * ```
 * @param {dropAcceptedCb} [props.onDropAccepted]
 * @param {dropRejectedCb} [props.onDropRejected]
 * @param {(error: Error) => void} [props.onError]
 *
 * @returns {DropzoneState & DropzoneMethods}
 */

function useDropzone() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _defaultProps$props = _objectSpread(_objectSpread({}, defaultProps), props),
      accept = _defaultProps$props.accept,
      disabled = _defaultProps$props.disabled,
      getFilesFromEvent = _defaultProps$props.getFilesFromEvent,
      maxSize = _defaultProps$props.maxSize,
      minSize = _defaultProps$props.minSize,
      multiple = _defaultProps$props.multiple,
      maxFiles = _defaultProps$props.maxFiles,
      onDragEnter = _defaultProps$props.onDragEnter,
      onDragLeave = _defaultProps$props.onDragLeave,
      onDragOver = _defaultProps$props.onDragOver,
      onDrop = _defaultProps$props.onDrop,
      onDropAccepted = _defaultProps$props.onDropAccepted,
      onDropRejected = _defaultProps$props.onDropRejected,
      onFileDialogCancel = _defaultProps$props.onFileDialogCancel,
      onFileDialogOpen = _defaultProps$props.onFileDialogOpen,
      useFsAccessApi = _defaultProps$props.useFsAccessApi,
      autoFocus = _defaultProps$props.autoFocus,
      preventDropOnDocument = _defaultProps$props.preventDropOnDocument,
      noClick = _defaultProps$props.noClick,
      noKeyboard = _defaultProps$props.noKeyboard,
      noDrag = _defaultProps$props.noDrag,
      noDragEventsBubbling = _defaultProps$props.noDragEventsBubbling,
      onError = _defaultProps$props.onError,
      validator = _defaultProps$props.validator;

  var acceptAttr = useMemo(function () {
    return acceptPropAsAcceptAttr(accept);
  }, [accept]);
  var pickerTypes = useMemo(function () {
    return pickerOptionsFromAccept(accept);
  }, [accept]);
  var onFileDialogOpenCb = useMemo(function () {
    return typeof onFileDialogOpen === "function" ? onFileDialogOpen : noop;
  }, [onFileDialogOpen]);
  var onFileDialogCancelCb = useMemo(function () {
    return typeof onFileDialogCancel === "function" ? onFileDialogCancel : noop;
  }, [onFileDialogCancel]);
  /**
   * @constant
   * @type {React.MutableRefObject<HTMLElement>}
   */

  var rootRef = useRef(null);
  var inputRef = useRef(null);

  var _useReducer = useReducer(reducer, initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var isFocused = state.isFocused,
      isFileDialogActive = state.isFileDialogActive;
  var fsAccessApiWorksRef = useRef(typeof window !== "undefined" && window.isSecureContext && useFsAccessApi && canUseFileSystemAccessAPI()); // Update file dialog active state when the window is focused on

  var onWindowFocus = function onWindowFocus() {
    // Execute the timeout only if the file dialog is opened in the browser
    if (!fsAccessApiWorksRef.current && isFileDialogActive) {
      setTimeout(function () {
        if (inputRef.current) {
          var files = inputRef.current.files;

          if (!files.length) {
            dispatch({
              type: "closeDialog"
            });
            onFileDialogCancelCb();
          }
        }
      }, 300);
    }
  };

  useEffect(function () {
    window.addEventListener("focus", onWindowFocus, false);
    return function () {
      window.removeEventListener("focus", onWindowFocus, false);
    };
  }, [inputRef, isFileDialogActive, onFileDialogCancelCb, fsAccessApiWorksRef]);
  var dragTargetsRef = useRef([]);

  var onDocumentDrop = function onDocumentDrop(event) {
    if (rootRef.current && rootRef.current.contains(event.target)) {
      // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
      return;
    }

    event.preventDefault();
    dragTargetsRef.current = [];
  };

  useEffect(function () {
    if (preventDropOnDocument) {
      document.addEventListener("dragover", onDocumentDragOver, false);
      document.addEventListener("drop", onDocumentDrop, false);
    }

    return function () {
      if (preventDropOnDocument) {
        document.removeEventListener("dragover", onDocumentDragOver);
        document.removeEventListener("drop", onDocumentDrop);
      }
    };
  }, [rootRef, preventDropOnDocument]); // Auto focus the root when autoFocus is true

  useEffect(function () {
    if (!disabled && autoFocus && rootRef.current) {
      rootRef.current.focus();
    }

    return function () {};
  }, [rootRef, autoFocus, disabled]);
  var onErrCb = useCallback(function (e) {
    if (onError) {
      onError(e);
    } else {
      // Let the user know something's gone wrong if they haven't provided the onError cb.
      console.error(e);
    }
  }, [onError]);
  var onDragEnterCb = useCallback(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [].concat(_toConsumableArray(dragTargetsRef.current), [event.target]);

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        var fileCount = files.length;
        var isDragAccept = fileCount > 0 && allFilesAccepted({
          files: files,
          accept: acceptAttr,
          minSize: minSize,
          maxSize: maxSize,
          multiple: multiple,
          maxFiles: maxFiles,
          validator: validator
        });
        var isDragReject = fileCount > 0 && !isDragAccept;
        dispatch({
          isDragAccept: isDragAccept,
          isDragReject: isDragReject,
          isDragActive: true,
          type: "setDraggedFiles"
        });

        if (onDragEnter) {
          onDragEnter(event);
        }
      }).catch(function (e) {
        return onErrCb(e);
      });
    }
  }, [getFilesFromEvent, onDragEnter, onErrCb, noDragEventsBubbling, acceptAttr, minSize, maxSize, multiple, maxFiles, validator]);
  var onDragOverCb = useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    var hasFiles = isEvtWithFiles(event);

    if (hasFiles && event.dataTransfer) {
      try {
        event.dataTransfer.dropEffect = "copy";
      } catch (_unused) {}
      /* eslint-disable-line no-empty */

    }

    if (hasFiles && onDragOver) {
      onDragOver(event);
    }

    return false;
  }, [onDragOver, noDragEventsBubbling]);
  var onDragLeaveCb = useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event); // Only deactivate once the dropzone and all children have been left

    var targets = dragTargetsRef.current.filter(function (target) {
      return rootRef.current && rootRef.current.contains(target);
    }); // Make sure to remove a target present multiple times only once
    // (Firefox may fire dragenter/dragleave multiple times on the same element)

    var targetIdx = targets.indexOf(event.target);

    if (targetIdx !== -1) {
      targets.splice(targetIdx, 1);
    }

    dragTargetsRef.current = targets;

    if (targets.length > 0) {
      return;
    }

    dispatch({
      type: "setDraggedFiles",
      isDragActive: false,
      isDragAccept: false,
      isDragReject: false
    });

    if (isEvtWithFiles(event) && onDragLeave) {
      onDragLeave(event);
    }
  }, [rootRef, onDragLeave, noDragEventsBubbling]);
  var setFiles = useCallback(function (files, event) {
    var acceptedFiles = [];
    var fileRejections = [];
    files.forEach(function (file) {
      var _fileAccepted = fileAccepted(file, acceptAttr),
          _fileAccepted2 = _slicedToArray(_fileAccepted, 2),
          accepted = _fileAccepted2[0],
          acceptError = _fileAccepted2[1];

      var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
          _fileMatchSize2 = _slicedToArray(_fileMatchSize, 2),
          sizeMatch = _fileMatchSize2[0],
          sizeError = _fileMatchSize2[1];

      var customErrors = validator ? validator(file) : null;

      if (accepted && sizeMatch && !customErrors) {
        acceptedFiles.push(file);
      } else {
        var errors = [acceptError, sizeError];

        if (customErrors) {
          errors = errors.concat(customErrors);
        }

        fileRejections.push({
          file: file,
          errors: errors.filter(function (e) {
            return e;
          })
        });
      }
    });

    if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
      // Reject everything and empty accepted files
      acceptedFiles.forEach(function (file) {
        fileRejections.push({
          file: file,
          errors: [TOO_MANY_FILES_REJECTION]
        });
      });
      acceptedFiles.splice(0);
    }

    dispatch({
      acceptedFiles: acceptedFiles,
      fileRejections: fileRejections,
      type: "setFiles"
    });

    if (onDrop) {
      onDrop(acceptedFiles, fileRejections, event);
    }

    if (fileRejections.length > 0 && onDropRejected) {
      onDropRejected(fileRejections, event);
    }

    if (acceptedFiles.length > 0 && onDropAccepted) {
      onDropAccepted(acceptedFiles, event);
    }
  }, [dispatch, multiple, acceptAttr, minSize, maxSize, maxFiles, onDrop, onDropAccepted, onDropRejected, validator]);
  var onDropCb = useCallback(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [];

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        setFiles(files, event);
      }).catch(function (e) {
        return onErrCb(e);
      });
    }

    dispatch({
      type: "reset"
    });
  }, [getFilesFromEvent, setFiles, onErrCb, noDragEventsBubbling]); // Fn for opening the file dialog programmatically

  var openFileDialog = useCallback(function () {
    // No point to use FS access APIs if context is not secure
    // https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts#feature_detection
    if (fsAccessApiWorksRef.current) {
      dispatch({
        type: "openDialog"
      });
      onFileDialogOpenCb(); // https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker

      var opts = {
        multiple: multiple,
        types: pickerTypes
      };
      window.showOpenFilePicker(opts).then(function (handles) {
        return getFilesFromEvent(handles);
      }).then(function (files) {
        setFiles(files, null);
        dispatch({
          type: "closeDialog"
        });
      }).catch(function (e) {
        // AbortError means the user canceled
        if (isAbort(e)) {
          onFileDialogCancelCb(e);
          dispatch({
            type: "closeDialog"
          });
        } else if (isSecurityError(e)) {
          fsAccessApiWorksRef.current = false; // CORS, so cannot use this API
          // Try using the input

          if (inputRef.current) {
            inputRef.current.value = null;
            inputRef.current.click();
          } else {
            onErrCb(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."));
          }
        } else {
          onErrCb(e);
        }
      });
      return;
    }

    if (inputRef.current) {
      dispatch({
        type: "openDialog"
      });
      onFileDialogOpenCb();
      inputRef.current.value = null;
      inputRef.current.click();
    }
  }, [dispatch, onFileDialogOpenCb, onFileDialogCancelCb, useFsAccessApi, setFiles, onErrCb, pickerTypes, multiple]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone

  var onKeyDownCb = useCallback(function (event) {
    // Ignore keyboard events bubbling up the DOM tree
    if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) {
      return;
    }

    if (event.key === " " || event.key === "Enter" || event.keyCode === 32 || event.keyCode === 13) {
      event.preventDefault();
      openFileDialog();
    }
  }, [rootRef, openFileDialog]); // Update focus state for the dropzone

  var onFocusCb = useCallback(function () {
    dispatch({
      type: "focus"
    });
  }, []);
  var onBlurCb = useCallback(function () {
    dispatch({
      type: "blur"
    });
  }, []); // Cb to open the file dialog when click occurs on the dropzone

  var onClickCb = useCallback(function () {
    if (noClick) {
      return;
    } // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
    // to ensure React can handle state changes
    // See: https://github.com/react-dropzone/react-dropzone/issues/450


    if (isIeOrEdge()) {
      setTimeout(openFileDialog, 0);
    } else {
      openFileDialog();
    }
  }, [noClick, openFileDialog]);

  var composeHandler = function composeHandler(fn) {
    return disabled ? null : fn;
  };

  var composeKeyboardHandler = function composeKeyboardHandler(fn) {
    return noKeyboard ? null : composeHandler(fn);
  };

  var composeDragHandler = function composeDragHandler(fn) {
    return noDrag ? null : composeHandler(fn);
  };

  var stopPropagation = function stopPropagation(event) {
    if (noDragEventsBubbling) {
      event.stopPropagation();
    }
  };

  var getRootProps = useMemo(function () {
    return function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$refKey = _ref2.refKey,
          refKey = _ref2$refKey === void 0 ? "ref" : _ref2$refKey,
          role = _ref2.role,
          onKeyDown = _ref2.onKeyDown,
          onFocus = _ref2.onFocus,
          onBlur = _ref2.onBlur,
          onClick = _ref2.onClick,
          onDragEnter = _ref2.onDragEnter,
          onDragOver = _ref2.onDragOver,
          onDragLeave = _ref2.onDragLeave,
          onDrop = _ref2.onDrop,
          rest = _objectWithoutProperties(_ref2, _excluded3);

      return _objectSpread(_objectSpread(_defineProperty({
        onKeyDown: composeKeyboardHandler(composeEventHandlers(onKeyDown, onKeyDownCb)),
        onFocus: composeKeyboardHandler(composeEventHandlers(onFocus, onFocusCb)),
        onBlur: composeKeyboardHandler(composeEventHandlers(onBlur, onBlurCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onClickCb)),
        onDragEnter: composeDragHandler(composeEventHandlers(onDragEnter, onDragEnterCb)),
        onDragOver: composeDragHandler(composeEventHandlers(onDragOver, onDragOverCb)),
        onDragLeave: composeDragHandler(composeEventHandlers(onDragLeave, onDragLeaveCb)),
        onDrop: composeDragHandler(composeEventHandlers(onDrop, onDropCb)),
        role: typeof role === "string" && role !== "" ? role : "presentation"
      }, refKey, rootRef), !disabled && !noKeyboard ? {
        tabIndex: 0
      } : {}), rest);
    };
  }, [rootRef, onKeyDownCb, onFocusCb, onBlurCb, onClickCb, onDragEnterCb, onDragOverCb, onDragLeaveCb, onDropCb, noKeyboard, noDrag, disabled]);
  var onInputElementClick = useCallback(function (event) {
    event.stopPropagation();
  }, []);
  var getInputProps = useMemo(function () {
    return function () {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$refKey = _ref3.refKey,
          refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey,
          onChange = _ref3.onChange,
          onClick = _ref3.onClick,
          rest = _objectWithoutProperties(_ref3, _excluded4);

      var inputProps = _defineProperty({
        accept: acceptAttr,
        multiple: multiple,
        type: "file",
        style: {
          display: "none"
        },
        onChange: composeHandler(composeEventHandlers(onChange, onDropCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onInputElementClick)),
        tabIndex: -1
      }, refKey, inputRef);

      return _objectSpread(_objectSpread({}, inputProps), rest);
    };
  }, [inputRef, accept, multiple, onDropCb, disabled]);
  return _objectSpread(_objectSpread({}, state), {}, {
    isFocused: isFocused && !disabled,
    getRootProps: getRootProps,
    getInputProps: getInputProps,
    rootRef: rootRef,
    inputRef: inputRef,
    open: composeHandler(openFileDialog)
  });
}
/**
 * @param {DropzoneState} state
 * @param {{type: string} & DropzoneState} action
 * @returns {DropzoneState}
 */

function reducer(state, action) {
  /* istanbul ignore next */
  switch (action.type) {
    case "focus":
      return _objectSpread(_objectSpread({}, state), {}, {
        isFocused: true
      });

    case "blur":
      return _objectSpread(_objectSpread({}, state), {}, {
        isFocused: false
      });

    case "openDialog":
      return _objectSpread(_objectSpread({}, initialState), {}, {
        isFileDialogActive: true
      });

    case "closeDialog":
      return _objectSpread(_objectSpread({}, state), {}, {
        isFileDialogActive: false
      });

    case "setDraggedFiles":
      return _objectSpread(_objectSpread({}, state), {}, {
        isDragActive: action.isDragActive,
        isDragAccept: action.isDragAccept,
        isDragReject: action.isDragReject
      });

    case "setFiles":
      return _objectSpread(_objectSpread({}, state), {}, {
        acceptedFiles: action.acceptedFiles,
        fileRejections: action.fileRejections
      });

    case "reset":
      return _objectSpread({}, initialState);

    default:
      return state;
  }
}

function noop() {}

var AttachedFileContainer = styled(FlexBox).attrs({
    gap: 8,
    justifyContent: 'space-between',
    alignItems: 'center'
})(templateObject_1$c || (templateObject_1$c = __makeTemplateObject(["\n  ", "\n  border: 2px solid ", ";\n  border-radius: ", ";\n"], ["\n  ", "\n  border: 2px solid ", ";\n  border-radius: ", ";\n"])), function (_a) {
    var fullWidth = _a.fullWidth;
    return "\n    width: ".concat(fullWidth ? '100%' : '250px', ";\n  ");
}, colorFormBorder.colorFormBorderDefault, theming.borderRadius);
var AttachedFileName = styled(Body)(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"], ["\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])));
var templateObject_1$c, templateObject_2$1;

var AttachedFile = function (_a) {
    var urlDownloadText = _a.urlDownloadText, urlDownload = _a.urlDownload, fullWidth = _a.fullWidth, handleRemoveFile = _a.handleRemoveFile;
    var containerRef = useRef(null);
    var _b = useDimension(containerRef), containerWidth = _b[1];
    return (jsxs(AttachedFileContainer, __assign({ fullWidth: fullWidth, ref: containerRef }, { children: [jsx(FlexBox, __assign({ background: colorSurface.secondary, width: "40px", height: "40px", alignItems: "center", justifyContent: "center", margin: "2px", borderRadius: theming.borderRadius }, { children: jsx(Icon, { name: "copy", color: "grayLight" }) })), jsx(FlexBox, { children: containerWidth > 0 ? (jsx("a", __assign({ target: "_blank", href: urlDownload, rel: "noreferrer" }, { children: jsx(AttachedFileName, __assign({ color: "primary", bold: true, width: getSizeValue(containerWidth / 2), textAlign: "center", textDecoration: "underline" }, { children: urlDownloadText })) }))) : null }), jsx(FlexBox, __assign({ padding: "0 8px" }, { children: jsx(Button, { variant: "tertiary", icon: "trash", iconSize: "normal", onClick: function () { return handleRemoveFile(); }, "data-testid": "file-remove-button" }) }))] })));
};

var FileUpload = forwardRef(function (props, ref) {
    var name = props.name, accept = props.accept, multiple = props.multiple, showError = props.showError, fullWidth = props.fullWidth, lastFileName = props.lastFileName, lastFileUrl = props.lastFileUrl, onChange = props.onChange, handleRemove = props.handleRemove;
    var _a = useState(null), file = _a[0], setFile = _a[1];
    var inputRef = useRef(null);
    var _b = getFileData(file, lastFileName, lastFileUrl) || [null], urlDownloadText = _b[0], urlDownload = _b[1];
    var acceptTypes = useMemo(function () {
        return accept === null || accept === void 0 ? void 0 : accept.reduce(function (acc, current) {
            var _a;
            return (__assign(__assign({}, acc), (_a = {}, _a[current] = [], _a)));
        }, {});
    }, [accept]);
    var getRootProps = useDropzone({
        accept: acceptTypes,
        multiple: multiple,
        onDrop: function (_a) {
            var selectedFile = _a[0];
            if (selectedFile && (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current)) {
                var dataTransfer = new DataTransfer();
                dataTransfer.items.add(selectedFile);
                inputRef.current.files = dataTransfer.files;
                inputRef.current.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }
    }).getRootProps;
    var handleFileSelect = function (e) {
        var _a;
        var selectedFile = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
        selectedFile && setFile(selectedFile);
        onChange && onChange(e);
    };
    var handleRemoveFile = function () {
        if (inputRef.current) {
            inputRef.current.value = '';
            setFile(null);
        }
        handleRemove && handleRemove();
    };
    return (jsxs(Fragment, { children: [urlDownload ? (jsx(AttachedFile, { urlDownloadText: urlDownloadText, urlDownload: urlDownload, fullWidth: fullWidth, handleRemoveFile: function () { return handleRemoveFile(); } })) : (jsx(CustomFileUpload, __assign({ onClick: function () { var _a; return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click(); }, showError: showError, fullWidth: fullWidth }, getRootProps(), { children: jsxs(FlexBox, __assign({ alignItems: "center", justifyContent: "center" }, { children: [jsx(FlexBox, __assign({ padding: "8px" }, { children: jsx(Icon, { name: "upload", size: "smaller", color: "primary" }) })), jsxs(FlexBox, __assign({ flexDirection: "column", padding: "0 8px" }, { children: [jsx(Body, __assign({ color: "primary", textDecoration: "underline", bold: true }, { children: "Click to upload" })), jsx(Body, { children: "or drag and drop" })] }))] })) }))), jsx(Input, { id: name, name: name, type: "file", accept: accept === null || accept === void 0 ? void 0 : accept.join(','), ref: function (node) {
                    inputRef.current = node;
                    if (typeof ref === 'function') {
                        ref(node);
                    }
                    else if (ref) {
                        ref.current = node;
                    }
                }, onChange: handleFileSelect, "data-testid": "input-file-".concat(name) })] }));
});
FileUpload.displayName = 'FileUpload';

var ToggleGroupSize = {
    default: '48px',
    smallest: '36px'
};
var ToggleGroupContainer = styled.div(templateObject_1$b || (templateObject_1$b = __makeTemplateObject(["\n  display: flex;\n  width: ", ";\n  box-shadow: ", ";\n  border-radius: ", ";\n  ", "\n\n  button {\n    border-radius: 0;\n    ", "\n    flex: 1;\n    height: ", ";\n    box-shadow: none;\n    &.selected {\n      background: ", ";\n      border-color: ", ";\n      + button {\n        ", "\n      }\n    }\n    overflow: hidden;\n    @media ", " {\n      font-size: ", ";\n      line-height: ", ";\n    }\n  }\n\n  ", "\n"], ["\n  display: flex;\n  width: ", ";\n  box-shadow: ", ";\n  border-radius: ", ";\n  ", "\n\n  button {\n    border-radius: 0;\n    ", "\n    flex: 1;\n    height: ", ";\n    box-shadow: none;\n    &.selected {\n      background: ", ";\n      border-color: ", ";\n      + button {\n        ", "\n      }\n    }\n    overflow: hidden;\n    @media ", " {\n      font-size: ", ";\n      line-height: ", ";\n    }\n  }\n\n  ", "\n"])), function (_a) {
    var width = _a.width;
    return getSizeValue(width);
}, shadow.normal, theming.borderRadius, function (_a) {
    var direction = _a.direction;
    return "".concat(direction === 'vertical' ? 'flex-direction: column;' : '');
}, function (_a) {
    var direction = _a.direction;
    return "".concat(direction === 'vertical' ? 'margin-top: -2px;' : 'margin-right: -2px;');
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'default' : _b;
    return ToggleGroupSize[size];
}, colorFormSurface.colorFormSurfaceWashed, customColors.primary, function (_a) {
    var direction = _a.direction;
    return "".concat(direction === 'vertical' ? 'border-top-color' : 'border-left-color', ": ").concat(customColors.primary, ";");
}, mediaSizeMap.smallest, fontMap.smaller.fontSize, fontMap.smaller.lineHeight, function (_a) {
    var direction = _a.direction;
    return "".concat(direction === 'horizontal'
        ? "\n   button:first-child {\n    border-top-left-radius: ".concat(theming.borderRadius, ";\n    border-bottom-left-radius: ").concat(theming.borderRadius, ";\n    margin-left: 0;\n  }\n\n  button:last-child {\n    border-top-right-radius: ").concat(theming.borderRadius, ";\n    border-bottom-right-radius: ").concat(theming.borderRadius, ";\n    margin-right: 0;\n  }\n  ")
        : "\n   button:first-child {\n    border-top-left-radius: ".concat(theming.borderRadius, ";\n    border-top-right-radius: ").concat(theming.borderRadius, ";\n    margin-top: 0;\n  }\n\n  button:last-child {\n    border-bottom-left-radius: ").concat(theming.borderRadius, ";\n    border-bottom-right-radius: ").concat(theming.borderRadius, ";\n    margin-bottom: 0;\n  }\n  "));
});
var templateObject_1$b;

var ToggleGroup = function (_a) {
    var onChange = _a.onChange, size = _a.size, textWrap = _a.textWrap, controlledValue = _a.value, _b = _a.direction, direction = _b === void 0 ? 'horizontal' : _b, _c = _a.iconColor, iconColor = _c === void 0 ? 'primary' : _c, _d = _a.iconPosition, iconPosition = _d === void 0 ? 'left' : _d, _e = _a.variant, variant = _e === void 0 ? 'tertiary' : _e, _f = _a.checkedIcon, checkedIcon = _f === void 0 ? 'check' : _f, width = _a.width, children = _a.children;
    if (!(children === null || children === void 0 ? void 0 : children.length)) {
        console.warn('ToggleGroup: children are required');
        return null;
    }
    var isSelected = function (childValue) {
        if (Array.isArray(controlledValue)) {
            return controlledValue.includes(childValue);
        }
        return controlledValue === childValue;
    };
    var handleToggle = function (childValue) {
        if (Array.isArray(controlledValue)) {
            if (controlledValue.includes(childValue)) {
                onChange === null || onChange === void 0 ? void 0 : onChange(controlledValue.filter(function (val) { return val !== childValue; }));
            }
            else {
                onChange === null || onChange === void 0 ? void 0 : onChange(__spreadArray(__spreadArray([], controlledValue, true), [childValue], false));
            }
        }
        else {
            onChange === null || onChange === void 0 ? void 0 : onChange(childValue);
        }
    };
    return (jsx(ToggleGroupContainer, __assign({ size: size, width: width, direction: direction }, { children: Children.map(children, function (child) {
            return cloneElement(child, {
                className: isSelected(child.props.value) ? 'selected' : undefined,
                key: child.key,
                name: child.key,
                iconColor: iconColor,
                iconPosition: iconPosition,
                gap: 2,
                icon: isSelected(child.props.value) ? checkedIcon || child.props.icon : child.props.icon,
                variant: variant,
                onClick: function (e) {
                    var _a, _b;
                    handleToggle(child.props.value);
                    (_b = (_a = child.props) === null || _a === void 0 ? void 0 : _a.onClick) === null || _b === void 0 ? void 0 : _b.call(_a, e);
                },
                textWrap: textWrap,
                padding: child.props.padding || '12px 16px'
            });
        }) })));
};

var FilterChipContainer = styled.button(templateObject_1$a || (templateObject_1$a = __makeTemplateObject(["\n  position: relative;\n  display: inline-flex;\n  min-width: 80px;\n  height: 32px;\n  padding: 4px 6px;\n  cursor: pointer;\n  justify-content: center;\n  align-items: center;\n  gap: 6px;\n  box-sizing: border-box;\n  border: 1px solid ", ";\n  background: ", ";\n\n  svg {\n    fill: ", ";\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  position: relative;\n  display: inline-flex;\n  min-width: 80px;\n  height: 32px;\n  padding: 4px 6px;\n  cursor: pointer;\n  justify-content: center;\n  align-items: center;\n  gap: 6px;\n  box-sizing: border-box;\n  border: 1px solid ", ";\n  background: ", ";\n\n  svg {\n    fill: ", ";\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"])), colorBorder$1.colorBorderBorderPrimary, colorSurface.secondary, colorText.colorTextTextPrimary, baseStyle({ borderRadius: '4px' }), hoverStyle, focusStyle, activeStyle);
var templateObject_1$a;

var FilterChip = function (_a) {
    var className = _a.className, text = _a.text, onClick = _a.onClick;
    return (jsxs(FilterChipContainer, __assign({ className: className, onClick: onClick }, { children: [jsx(Body, { children: text }), jsx(Icon, { name: "close", size: "smaller" })] })));
};

var StyledFilterToggleBase = styled.button.attrs(function (props) { return ({
    'aria-label': props.ariaLabel
}); })(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["\n  display: inline-flex;\n  min-height: 40px;\n  max-height: 40px;\n  justify-content: center;\n  align-items: center;\n  color: ", ";\n  border: 1px solid ", ";\n  gap: 4px;\n  padding: 8px 16px;\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  position: relative;\n  appearance: none;\n  box-sizing: border-box;\n  cursor: pointer;\n  text-decoration: none;\n  text-align: center;\n  text-wrap: ", ";\n\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  display: inline-flex;\n  min-height: 40px;\n  max-height: 40px;\n  justify-content: center;\n  align-items: center;\n  color: ", ";\n  border: 1px solid ", ";\n  gap: 4px;\n  padding: 8px 16px;\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  position: relative;\n  appearance: none;\n  box-sizing: border-box;\n  cursor: pointer;\n  text-decoration: none;\n  text-align: center;\n  text-wrap: ", ";\n\n  ", "\n  ", "\n  ", "\n  ", "\n"])), colorText.colorTextTextPrimary, colorBorder$1.colorBorderBorderPrimary, fontFamily, fontMap.normal.fontSize, fontMap.normal.lineHeight, weightMap$1.bold, function (_a) {
    var textWrap = _a.textWrap;
    return "".concat(getValue$1(textWrap));
}, baseStyle({ borderRadius: '40px' }), hoverStyle, focusStyle, activeStyle);
var templateObject_1$9;

var FilterChipToggleBase = function (_a) {
    var children = _a.children, className = _a.className, disabled = _a.disabled, _b = _a.highlightedIcon, highlightedIcon = _b === void 0 ? false : _b, iconColor = _a.iconColor, iconSize = _a.iconSize, id = _a.id, name = _a.name, ariaLabel = _a.ariaLabel, type = _a.type, width = _a.width, textWrap = _a.textWrap, onClick = _a.onClick, active = _a.active, defaultIcon = _a.defaultIcon, activeIcon = _a.activeIcon, iconPosition = _a.iconPosition, props = __rest(_a, ["children", "className", "disabled", "highlightedIcon", "iconColor", "iconSize", "id", "name", "ariaLabel", "type", "width", "textWrap", "onClick", "active", "defaultIcon", "activeIcon", "iconPosition"]);
    return (jsx(StyledFilterToggleBase, __assign({ className: className, disabled: disabled, id: id, name: name, onClick: onClick, type: type, width: width, textWrap: textWrap, ariaLabel: ariaLabel || name }, props, { children: jsx(WithLabel, { label: children, icon: active ? activeIcon : defaultIcon, iconPosition: iconPosition, highlightedIcon: highlightedIcon, iconColor: iconColor, iconSize: iconSize }) })));
};

var getFilterChipToggleStyle = function (_a) {
    var background = _a.background, borderColor = _a.borderColor;
    return "\n  border-color: ".concat(borderColor, ";\n  background: ").concat(background, ";\n\n  svg {\n    fill: ").concat(borderColor, ";\n  }\n\n  ").concat(baseStyle({ borderRadius: '40px' }), "\n  ").concat(hoverStyle, "\n  ").concat(activeStyle, "\n");
};

var primary = styled(FilterChipToggleBase)(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var active = _a.active;
    return getFilterChipToggleStyle({
        active: active,
        borderColor: active ? colorActionPrimary.colorActionPrimarySurface : colorAction.colorActionActionGrey,
        background: active ? colorAction.colorActionActionWashed : colorAction.colorActionActionWhite
    });
});
var templateObject_1$8;

var success = styled(FilterChipToggleBase)(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var active = _a.active;
    return getFilterChipToggleStyle({
        active: active,
        borderColor: colorBorder$1.colorBorderBorderSuccess,
        background: active ? colorSurface.success : colorSurface.primary
    });
});
var templateObject_1$7;

var warning = styled(FilterChipToggleBase)(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var active = _a.active;
    return getFilterChipToggleStyle({
        active: active,
        borderColor: colorBorder$1.colorBorderBorderWarning,
        background: active ? colorSurface.warning : colorSurface.primary
    });
});
var templateObject_1$6;

var alert = styled(FilterChipToggleBase)(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var active = _a.active;
    return getFilterChipToggleStyle({
        active: active,
        borderColor: colorBorder$1.colorBorderBorderAlert,
        background: active ? colorSurface.alert : colorSurface.primary
    });
});
var templateObject_1$5;

var variants = {
    primary: primary,
    success: success,
    warning: warning,
    alert: alert
};

var FilterChipToggle = function (_a) {
    var id = _a.id, className = _a.className, name = _a.name, children = _a.children, disabled = _a.disabled, ariaLabel = _a.ariaLabel, _b = _a.variant, variantName = _b === void 0 ? 'primary' : _b, onClick = _a.onClick, defaultIcon = _a.defaultIcon, _c = _a.activeIcon, activeIcon = _c === void 0 ? 'check' : _c, _d = _a.iconPosition, iconPosition = _d === void 0 ? 'left' : _d, _e = _a.active, active = _e === void 0 ? false : _e, props = __rest(_a, ["id", "className", "name", "children", "disabled", "ariaLabel", "variant", "onClick", "defaultIcon", "activeIcon", "iconPosition", "active"]);
    var ChipVariant = variants[variantName];
    return (jsx(ChipVariant, __assign({ id: id, name: name, ariaLabel: ariaLabel, className: className, disabled: disabled, defaultIcon: defaultIcon, activeIcon: activeIcon, iconPosition: iconPosition, onClick: onClick, active: active }, props, { children: children })));
};

var CondensedTagContainer = styled.div(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n  ", "\n  display: flex;\n  width: 24px;\n  height: 24px;\n  min-width: 24px;\n  max-width: 24px;\n  min-height: 24px;\n  max-height: 24px;\n  padding: 4px;\n  justify-content: center;\n  align-items: center;\n  box-sizing: border-box;\n  border-radius: 24px;\n  border: 1px solid ", ";\n  ", "\n"], ["\n  ", "\n  display: flex;\n  width: 24px;\n  height: 24px;\n  min-width: 24px;\n  max-width: 24px;\n  min-height: 24px;\n  max-height: 24px;\n  padding: 4px;\n  justify-content: center;\n  align-items: center;\n  box-sizing: border-box;\n  border-radius: 24px;\n  border: 1px solid ", ";\n  ", "\n"])), baseStyle$1, colorBase['colorNeutral-0'], function (_a) {
    var background = _a.background;
    return "background-color: ".concat(getLegacyColor(background), ";");
});
var templateObject_1$4;

var CondensedTag = function (_a) {
    var iconName = _a.iconName, _b = _a.iconSize, iconSize = _b === void 0 ? 'smallest' : _b, iconColor = _a.iconColor, background = _a.background, text = _a.text;
    var id = useId();
    var tooltipId = "".concat(id, "-tooltip");
    return (jsxs(CondensedTagContainer, __assign({ background: background, "data-tooltip-id": tooltipId }, { children: [iconName && jsx(Icon, { name: iconName, color: iconColor, size: iconSize, noFix: true }), jsx(BlcTooltip, __assign({ id: tooltipId }, { children: text }))] })));
};

var logos = {
    autocheck: AutocheckLogo,
    autograde: AutoGradeLogo,
    carbravo: CarBravoLogo,
    blackbook: BlackbookLogo,
    float: FloatLogo,
    openlane: OpenLaneLogo,
    transport: TransportLogo
};
var Logo = function (_a) {
    var name = _a.name, logoProps = _a.logoProps;
    var Logo = logos[name];
    return jsx(Logo, __assign({}, logoProps));
};

var DefaultTagContainer = styled.div(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n  border-radius: 4px;\n  border: 1px solid ", ";\n  box-sizing: border-box;\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n  border-radius: 4px;\n  border: 1px solid ", ";\n  box-sizing: border-box;\n  ", ";\n  ", ";\n  ", ";\n"])), colorBorder$1.colorBorderBorderPrimary, function (_a) {
    var background = _a.background;
    return "background-color: ".concat(getLegacyColor(background) || colorSurface.primary, ";");
}, function (_a) {
    var padding = _a.padding;
    return (padding ? "padding: ".concat(padding, ";") : '');
}, function (_a) {
    var height = _a.height;
    return (height ? "height: ".concat(height, ";") : '');
});
var templateObject_1$3;

var DefaultTag = function (_a) {
    var text = _a.text, iconName = _a.iconName, _b = _a.iconSize, iconSize = _b === void 0 ? 'smaller' : _b, iconColor = _a.iconColor, logoName = _a.logoName, logoProps = _a.logoProps, background = _a.background, _c = _a.textColor, textColor = _c === void 0 ? 'colorTextTextPrimary' : _c, _d = _a.padding, padding = _d === void 0 ? '2px 6px' : _d, _e = _a.height, height = _e === void 0 ? '22px' : _e;
    return (jsxs(DefaultTagContainer, __assign({ background: background, padding: padding, height: height }, { children: [iconName && jsx(Icon, { name: iconName, color: iconColor, size: iconSize, noFix: true }), logoName && jsx(Logo, { name: logoName, logoProps: logoProps }), text && (jsx(Body, __assign({ whiteSpace: "nowrap", color: textColor }, { children: text })))] })));
};

var tagVariants = {
    off_lease_exclusive: {
        iconName: 'off-lease',
        iconColor: 'primary',
        text: 'Off-Lease Exclusive',
        condensedTagProps: {
            background: 'primary',
            iconColor: 'white',
            iconSize: 'smallest'
        }
    },
    private_auction: {
        iconName: 'gavel',
        iconColor: 'primary',
        text: 'Private auction',
        condensedTagProps: {
            background: 'primary',
            iconColor: 'white'
        }
    },
    private_marketplace: {
        iconName: 'tag',
        text: 'Private marketplace',
        iconColor: 'primary',
        condensedTagProps: {
            background: 'primary',
            iconColor: 'white'
        }
    },
    group_exclusive: {
        iconName: 'group-exclusive',
        iconColor: 'groupRed',
        text: 'Group exclusive',
        condensedTagProps: {
            background: 'groupRed',
            iconColor: 'white'
        }
    },
    lender_owned: {
        iconName: 'lender',
        text: 'Lender owned',
        condensedTagProps: {
            background: 'black',
            iconColor: 'white'
        }
    },
    guaranteed_offer: {
        iconName: 'go-3',
        text: 'Guaranteed Offer',
        condensedTagProps: {
            background: 'black',
            iconColor: 'white'
        }
    },
    audience_boost: {
        iconColor: 'success',
        iconName: 'flash-inverted',
        text: 'Audience boost™',
        condensedTagProps: {
            iconName: 'flash',
            background: 'success',
            iconColor: 'white'
        }
    },
    carbravo_eligible: {
        iconColor: 'carbravoGreen',
        iconName: 'carbravo',
        logoName: 'carbravo',
        text: 'Elegible',
        condensedTagProps: {
            background: 'carbravoBlue',
            iconColor: 'carbravoGreen'
        }
    }
};

var TagBase = function (_a) {
    var _b = _a.condensed, condensed = _b === void 0 ? false : _b, defaultTagProps = _a.defaultTagProps, condensedTagProps = _a.condensedTagProps, commonProps = __rest(_a, ["condensed", "defaultTagProps", "condensedTagProps"]);
    if (condensed)
        return jsx(CondensedTag, __assign({}, commonProps, condensedTagProps));
    else
        return jsx(DefaultTag, __assign({}, commonProps, defaultTagProps));
};
var Tag = function (_a) {
    var name = _a.name, props = __rest(_a, ["name"]);
    return jsx(TagBase, __assign({}, __assign(__assign({}, tagVariants[name]), props)));
};

var Surface = styled(FlexBox)(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n  ", "\n  ", "\n"])), function (_a) {
    var _b = _a.boxSizing, boxSizing = _b === void 0 ? 'border-box' : _b;
    return getCssProp('box-sizing', boxSizing);
}, function (_a) {
    var surfaceColor = _a.surfaceColor;
    return (surfaceColor ? "background-color: ".concat(getSurfaceColor(surfaceColor), ";") : '');
}, function (_a) {
    var borderRadius = _a.borderRadius;
    return (borderRadius ? "border-radius: ".concat(getRadius(borderRadius), ";") : '');
}, function (_a) {
    var borderColor = _a.borderColor, surfaceColor = _a.surfaceColor, _b = _a.borderWidth, borderWidth = _b === void 0 ? 1 : _b, _c = _a.borderStyle, borderStyle = _c === void 0 ? 'solid' : _c;
    return borderColor
        ? "\n      border-color: ".concat(getBorderColor(borderColor) || getSurfaceColor(surfaceColor), ";\n      ").concat(getCssProp('border-width', getSizeValue(borderWidth)), "}\n      ").concat(getCssProp('border-style', borderStyle), "}\n      ")
        : '';
});
var templateObject_1$2;

var maximizeAnimation = css(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  @keyframes maximize {\n    0% {\n      opacity: 0;\n      visibility: collapse;\n      transform: scale(0);\n    }\n    100% {\n      opacity: 1;\n      visibility: visible;\n      transform: scale(1);\n    }\n  }\n"], ["\n  @keyframes maximize {\n    0% {\n      opacity: 0;\n      visibility: collapse;\n      transform: scale(0);\n    }\n    100% {\n      opacity: 1;\n      visibility: visible;\n      transform: scale(1);\n    }\n  }\n"])));
var particlesUpAnimation = css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  @keyframes particles-up {\n    0% {\n      visibility: collapse;\n      opacity: 0;\n      transform: translate(0px, 0px);\n    }\n    10% {\n      opacity: 1;\n      transform: translate(0px, -15%);\n    }\n    100% {\n      visibility: visible;\n      opacity: 0;\n      transform: translate(0px, -30%);\n    }\n  }\n"], ["\n  @keyframes particles-up {\n    0% {\n      visibility: collapse;\n      opacity: 0;\n      transform: translate(0px, 0px);\n    }\n    10% {\n      opacity: 1;\n      transform: translate(0px, -15%);\n    }\n    100% {\n      visibility: visible;\n      opacity: 0;\n      transform: translate(0px, -30%);\n    }\n  }\n"])));
var particleUpAnimation = css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  @keyframes particle-up {\n    0% {\n      translate: 0px 0px;\n    }\n    100% {\n      translate: 0px -20%;\n    }\n  }\n"], ["\n  @keyframes particle-up {\n    0% {\n      translate: 0px 0px;\n    }\n    100% {\n      translate: 0px -20%;\n    }\n  }\n"])));
var particleCss = function (scale, translateX, translateY) { return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  transform: scale(", ") translate(", ", ", ");\n"], ["\n  transform: scale(", ") translate(", ", ", ");\n"])), scale, translateX, translateY); };
var AnimatedIconContainer = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n\n  input {\n    display: none;\n  }\n\n  label {\n    display: flex;\n    height: 100%;\n    width: 100%;\n    align-items: center;\n    justify-content: center;\n    border-radius: inherit;\n  }\n\n  svg {\n    overflow: visible;\n  }\n\n  input[type='checkbox'] {\n    visibility: collapse;\n  }\n\n  input[type='checkbox'] + label {\n    .particles-container {\n      opacity: 0;\n    }\n  }\n\n  .default-icon,\n  .checked-icon {\n    transition: all 0.8s;\n    transform-origin: center;\n    transform-box: fill-box;\n  }\n\n  .default-icon {\n    fill: ", ";\n  }\n\n  .checked-icon {\n    fill: ", ";\n  }\n\n  input[type='checkbox']:not(:checked) + label {\n    .default-icon {\n      opacity: 1;\n      visibility: visible;\n      transform: scale(1);\n    }\n    .checked-icon {\n      opacity: 0;\n      visibility: collapse;\n      transform: scale(0);\n    }\n  }\n\n  input[type='checkbox']:checked + label {\n    .default-icon {\n      opacity: 0;\n      visibility: collapse;\n      transform: scale(0);\n    }\n    .checked-icon {\n      opacity: 1;\n      visibility: visible;\n      transform: scale(1);\n    }\n\n    .particles-container {\n      animation: particles-up 0.5s forwards;\n    }\n\n    .particle-1,\n    .particle-2 {\n      animation: particle-up 0.5s linear;\n      animation-iteration-count: infinite;\n    }\n    .particle-3,\n    .particle-4 {\n      animation: particle-up 0.3s linear;\n      animation-iteration-count: infinite;\n    }\n  }\n\n  ", "\n  ", "\n  .particle {\n    fill: ", ";\n    transform-origin: center;\n    transform-box: fill-box;\n\n    &.particle-1 {\n      ", "\n    }\n\n    &.particle-2 {\n      ", "\n    }\n\n    &.particle-3 {\n      ", "\n    }\n\n    &.particle-4 {\n      transform: scale(0.4) translate(35%, 130%);\n      ", "\n    }\n  }\n"], ["\n  ", "\n\n  input {\n    display: none;\n  }\n\n  label {\n    display: flex;\n    height: 100%;\n    width: 100%;\n    align-items: center;\n    justify-content: center;\n    border-radius: inherit;\n  }\n\n  svg {\n    overflow: visible;\n  }\n\n  input[type='checkbox'] {\n    visibility: collapse;\n  }\n\n  input[type='checkbox'] + label {\n    .particles-container {\n      opacity: 0;\n    }\n  }\n\n  .default-icon,\n  .checked-icon {\n    transition: all 0.8s;\n    transform-origin: center;\n    transform-box: fill-box;\n  }\n\n  .default-icon {\n    fill: ", ";\n  }\n\n  .checked-icon {\n    fill: ", ";\n  }\n\n  input[type='checkbox']:not(:checked) + label {\n    .default-icon {\n      opacity: 1;\n      visibility: visible;\n      transform: scale(1);\n    }\n    .checked-icon {\n      opacity: 0;\n      visibility: collapse;\n      transform: scale(0);\n    }\n  }\n\n  input[type='checkbox']:checked + label {\n    .default-icon {\n      opacity: 0;\n      visibility: collapse;\n      transform: scale(0);\n    }\n    .checked-icon {\n      opacity: 1;\n      visibility: visible;\n      transform: scale(1);\n    }\n\n    .particles-container {\n      animation: particles-up 0.5s forwards;\n    }\n\n    .particle-1,\n    .particle-2 {\n      animation: particle-up 0.5s linear;\n      animation-iteration-count: infinite;\n    }\n    .particle-3,\n    .particle-4 {\n      animation: particle-up 0.3s linear;\n      animation-iteration-count: infinite;\n    }\n  }\n\n  ", "\n  ", "\n  .particle {\n    fill: ", ";\n    transform-origin: center;\n    transform-box: fill-box;\n\n    &.particle-1 {\n      ", "\n    }\n\n    &.particle-2 {\n      ", "\n    }\n\n    &.particle-3 {\n      ", "\n    }\n\n    &.particle-4 {\n      transform: scale(0.4) translate(35%, 130%);\n      ", "\n    }\n  }\n"])), maximizeAnimation, function (_a) {
    var defaultIconColor = _a.defaultIconColor;
    return getIconColor(defaultIconColor);
}, function (_a) {
    var checkedIconColor = _a.checkedIconColor;
    return getIconColor(checkedIconColor);
}, particlesUpAnimation, particleUpAnimation, colors.grayLight, particleCss(0.4, '-50%', '-50%'), particleCss(0.3, '50%', '50%'), particleCss(0.2, '50%', '-50%'), particleCss(0.2, '-50%', '50%'));
var templateObject_1$1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;

var AnimatedIcon = forwardRef(function (_a, ref) {
    var defaultIcon = _a.defaultIcon, checkedIcon = _a.checkedIcon, particleIcon = _a.particleIcon, _b = _a.defaultIconColor, defaultIconColor = _b === void 0 ? 'colorIconIconPrimary' : _b, _c = _a.checkedIconColor, checkedIconColor = _c === void 0 ? 'colorIconIconPrimary' : _c, size = _a.size, checked = _a.checked, floatingIconButton = _a.floatingIconButton, onChange = _a.onChange, _d = _a.disabled, disabled = _d === void 0 ? false : _d;
    var id = useId();
    var animatedIconId = "animated-icon".concat(id);
    var _e = useState(checked), isChecked = _e[0], setIsChecked = _e[1];
    useEffect(function () {
        setIsChecked(checked);
    }, [checked]);
    var handleOnChange = function (e) {
        if (!disabled) {
            setIsChecked(!isChecked);
            onChange && onChange(e);
        }
    };
    var IconContainer = floatingIconButton ? floatingIcon : Fragment$1;
    return (jsx(AnimatedIconContainer, __assign({ defaultIconColor: defaultIconColor, checkedIconColor: checkedIconColor, particleIcon: particleIcon }, { children: jsxs(IconContainer, { children: [jsx("input", { type: "checkbox", id: animatedIconId, name: animatedIconId, onChange: handleOnChange, checked: isChecked, disabled: disabled, ref: ref }), jsx("label", __assign({ htmlFor: animatedIconId }, { children: jsx(SvgContainer$1, __assign({ size: size, noFix: true }, { children: jsxs(Svg, { children: [jsx("use", { className: "default-icon", href: "#dsicon-".concat(defaultIcon) }), jsx("use", { className: "checked-icon", href: "#dsicon-".concat(checkedIcon) }), Boolean(particleIcon) && (jsxs("g", __assign({ className: "particles-container" }, { children: [jsx("use", { className: "particle particle-1", href: "#dsicon-".concat(particleIcon) }), jsx("use", { className: "particle particle-2", href: "#dsicon-".concat(particleIcon) }), jsx("use", { className: "particle particle-3", href: "#dsicon-".concat(particleIcon) }), jsx("use", { className: "particle particle-4", href: "#dsicon-".concat(particleIcon) })] })))] }) })) }))] }) })));
});
AnimatedIcon.displayName = 'AnimatedIcon';

var createMedia = function (minMaxArray) {
    var theArray = minMaxArray
        .map(function (minMax) {
        var condition = [];
        if (minMax.min)
            condition.push("(min-width: ".concat(minMax.min, "px)"));
        if (minMax.max)
            condition.push("(max-width: ".concat(minMax.max, "px)"));
        return condition.join(' and ');
    })
        .join(', ');
    return theArray;
};
var ShowOnMatchStyled = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var minMaxArray = _a.minMaxArray, displayValueOnShow = _a.displayValueOnShow;
    return "\n      display: none;\n\n      ".concat(!(minMaxArray === null || minMaxArray === void 0 ? void 0 : minMaxArray.length)
        ? '' // only add the media if there are minMaxArray
        : "@media ".concat(createMedia(minMaxArray), " {\n        display: ").concat(displayValueOnShow || 'block', ";\n      }"), "\n      \n  ");
});
var templateObject_1;

var ShowOnMediaMatch = function (_a) {
    var className = _a.className, children = _a.children, desktop = _a.desktop, smallDesktop = _a.smallDesktop, tablet = _a.tablet, mobile = _a.mobile, displayValueOnShow = _a.displayValueOnShow;
    var mediaMinMax = getMediaForDevices({ desktop: desktop, smallDesktop: smallDesktop, tablet: tablet, mobile: mobile });
    return (jsx(ShowOnMatchStyled, __assign({ className: className, minMaxArray: mediaMinMax, displayValueOnShow: displayValueOnShow }, { children: children })));
};

export { Accordion, AccordionContainer, AccordionSecondaryContainer, AnimatedIcon, AudienceBoost, AutoGradeLogo, AutocheckLogo, BadgeBase as Badge, Icon as BadgeIcon, BasicCountdown, BlackbookLogo, BlcBox, BlcCarousel, BlcCarouselItem, BlcCircleBadge, BlcColumn, BlcContainer, BlcErrorMessage, BlcInputAmount, BlcInputPrefix, BlcList, BlcListItem, BlcLoader, BlcModal, BlcPagination, Range as BlcRange, BlcRow, BlcSalesCard, BlcSection, BlcSignifier, StyledBlcTabs as BlcTabs, ToastContainer as BlcToastContainer, BlcTooltip, Body, Bubble, Button, CarBravoLogo, Carbravo, CarbravoBanner, Carousel, Checkbox, ClosedMarketplaceBanner, CommercialExclusive, DataGrid, DonutChart, Dot$1 as Dot, Dropdown, DropdownButton, $cb5cc270b50c6fcd$export$f39c2d165cd861fe as DropdownClose, DynamicSearch, EliteDealer, EliteSellerBadge, EliteSellerProgressBar, ExclamationIcon, ExclusiveCountdown, Expandable, ExtendedCountdown, FileDownload, FileUpload, FilterChip, FilterChipToggle, FlexBox, FloatLogo, FormComponentContainer, FormControl, FormError, Go, GoalProgressBar, Group1, Headline, Icon, Image, InputBase as Input, InputFile, InputMask, InputMaskDate, InputSearch, LenderOwned, Line$1 as Line, BidState as MarketplaceBidState, Message, Navigation, Icon as NavigationIcon, OffLeaseExclusive, OpenLaneLogo, PrivateMarketplaceBanner, PrivateSaleNewTermsContent, PrivateSaleOldTermsContent, Radio, Range, RangeSlider, RepoLenderBanner, Select, SelectItem, SellingSoon, SellingToday, SellingTodayCountdown, ShowMore, ShowOnMediaMatch, Slider, Spinner, Stepper, Surface, SvgSprite, TabContent, TabDropdown, SelectItem as TabDropdownItem, TabSection, TabTitle, Tag, TextArea, Toggle, ToggleGroup, Tooltip, TransportLogo, allowedTagParameters, colors, drivetrains, fontFamily, mainMakesList, routes as navigationRoutes, shadow, sortByList, sortChildrenByLabel, theming, toast, transmissions, useMediaDevices, useMediaQuery, userNavigationPermissions, vehicleTypes, zIndexMap };
//# sourceMappingURL=index.modern.js.map
